import * as Is from "react";
import Ct, { createContext as Ha, useState as et, useRef as Me, useCallback as Qe, useEffect as Ee, useMemo as Tr, useContext as zi, forwardRef as xu, cloneElement as Ow, Component as V3, useLayoutEffect as Tp, useReducer as $3, Fragment as Ss, isValidElement as q3, createElement as z3, useImperativeHandle as K3 } from "react";
import { gql as W3, errorExchange as G3, createClient as Y3, dedupExchange as Q3, fetchExchange as J3, Provider as Z3 } from "urql";
import { NavLink as xw, Link as Rw } from "react-router-dom";
var Gt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function X3(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function mW(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      if (this instanceof r) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(e, i);
        return new o();
      }
      return e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var Us = {}, eI = {
  get exports() {
    return Us;
  },
  set exports(t) {
    Us = t;
  }
}, Ho = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Sd, Fm;
function kp() {
  if (Fm)
    return Sd;
  Fm = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(a).map(function(u) {
        return a[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Sd = i() ? Object.assign : function(o, a) {
    for (var s, c = r(o), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        e.call(s, d) && (c[d] = s[d]);
      if (t) {
        l = t(s);
        for (var f = 0; f < l.length; f++)
          n.call(s, l[f]) && (c[l[f]] = s[l[f]]);
      }
    }
    return c;
  }, Sd;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Um;
function tI() {
  if (Um)
    return Ho;
  Um = 1, kp();
  var t = Ct, e = 60103;
  if (Ho.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    e = n("react.element"), Ho.Fragment = n("react.fragment");
  }
  var r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, c, l) {
    var u, d = {}, f = null, h = null;
    l !== void 0 && (f = "" + l), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (h = c.ref);
    for (u in c)
      i.call(c, u) && !o.hasOwnProperty(u) && (d[u] = c[u]);
    if (s && s.defaultProps)
      for (u in c = s.defaultProps, c)
        d[u] === void 0 && (d[u] = c[u]);
    return { $$typeof: e, type: s, key: f, ref: h, props: d, _owner: r.current };
  }
  return Ho.jsx = a, Ho.jsxs = a, Ho;
}
var Td = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hm;
function nI() {
  return Hm || (Hm = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = Ct, n = kp(), r = 60103, i = 60106;
      t.Fragment = 60107;
      var o = 60108, a = 60114, s = 60109, c = 60110, l = 60112, u = 60113, d = 60120, f = 60115, h = 60116, g = 60121, v = 60122, b = 60117, m = 60129, y = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var p = Symbol.for;
        r = p("react.element"), i = p("react.portal"), t.Fragment = p("react.fragment"), o = p("react.strict_mode"), a = p("react.profiler"), s = p("react.provider"), c = p("react.context"), l = p("react.forward_ref"), u = p("react.suspense"), d = p("react.suspense_list"), f = p("react.memo"), h = p("react.lazy"), g = p("react.block"), v = p("react.server.block"), b = p("react.fundamental"), p("react.scope"), p("react.opaque.id"), m = p("react.debug_trace_mode"), p("react.offscreen"), y = p("react.legacy_hidden");
      }
      var w = typeof Symbol == "function" && Symbol.iterator, _ = "@@iterator";
      function E(k) {
        if (k === null || typeof k != "object")
          return null;
        var B = w && k[w] || k[_];
        return typeof B == "function" ? B : null;
      }
      var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function T(k) {
        {
          for (var B = arguments.length, G = new Array(B > 1 ? B - 1 : 0), ve = 1; ve < B; ve++)
            G[ve - 1] = arguments[ve];
          x("error", k, G);
        }
      }
      function x(k, B, G) {
        {
          var ve = S.ReactDebugCurrentFrame, Le = ve.getStackAddendum();
          Le !== "" && (B += "%s", G = G.concat([Le]));
          var ot = G.map(function(Ge) {
            return "" + Ge;
          });
          ot.unshift("Warning: " + B), Function.prototype.apply.call(console[k], console, ot);
        }
      }
      var A = !1;
      function N(k) {
        return !!(typeof k == "string" || typeof k == "function" || k === t.Fragment || k === a || k === m || k === o || k === u || k === d || k === y || A || typeof k == "object" && k !== null && (k.$$typeof === h || k.$$typeof === f || k.$$typeof === s || k.$$typeof === c || k.$$typeof === l || k.$$typeof === b || k.$$typeof === g || k[0] === v));
      }
      function F(k, B, G) {
        var ve = B.displayName || B.name || "";
        return k.displayName || (ve !== "" ? G + "(" + ve + ")" : G);
      }
      function D(k) {
        return k.displayName || "Context";
      }
      function L(k) {
        if (k == null)
          return null;
        if (typeof k.tag == "number" && T("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof k == "function")
          return k.displayName || k.name || null;
        if (typeof k == "string")
          return k;
        switch (k) {
          case t.Fragment:
            return "Fragment";
          case i:
            return "Portal";
          case a:
            return "Profiler";
          case o:
            return "StrictMode";
          case u:
            return "Suspense";
          case d:
            return "SuspenseList";
        }
        if (typeof k == "object")
          switch (k.$$typeof) {
            case c:
              var B = k;
              return D(B) + ".Consumer";
            case s:
              var G = k;
              return D(G._context) + ".Provider";
            case l:
              return F(k, k.render, "ForwardRef");
            case f:
              return L(k.type);
            case g:
              return L(k._render);
            case h: {
              var ve = k, Le = ve._payload, ot = ve._init;
              try {
                return L(ot(Le));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var z = 0, ne, ae, Re, fe, I, J, me;
      function O() {
      }
      O.__reactDisabledLog = !0;
      function ue() {
        {
          if (z === 0) {
            ne = console.log, ae = console.info, Re = console.warn, fe = console.error, I = console.group, J = console.groupCollapsed, me = console.groupEnd;
            var k = {
              configurable: !0,
              enumerable: !0,
              value: O,
              writable: !0
            };
            Object.defineProperties(console, {
              info: k,
              log: k,
              warn: k,
              error: k,
              group: k,
              groupCollapsed: k,
              groupEnd: k
            });
          }
          z++;
        }
      }
      function Ce() {
        {
          if (z--, z === 0) {
            var k = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, k, {
                value: ne
              }),
              info: n({}, k, {
                value: ae
              }),
              warn: n({}, k, {
                value: Re
              }),
              error: n({}, k, {
                value: fe
              }),
              group: n({}, k, {
                value: I
              }),
              groupCollapsed: n({}, k, {
                value: J
              }),
              groupEnd: n({}, k, {
                value: me
              })
            });
          }
          z < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Z = S.ReactCurrentDispatcher, he;
      function Q(k, B, G) {
        {
          if (he === void 0)
            try {
              throw Error();
            } catch (Le) {
              var ve = Le.stack.trim().match(/\n( *(at )?)/);
              he = ve && ve[1] || "";
            }
          return `
` + he + k;
        }
      }
      var $ = !1, q;
      {
        var H = typeof WeakMap == "function" ? WeakMap : Map;
        q = new H();
      }
      function V(k, B) {
        if (!k || $)
          return "";
        {
          var G = q.get(k);
          if (G !== void 0)
            return G;
        }
        var ve;
        $ = !0;
        var Le = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var ot;
        ot = Z.current, Z.current = null, ue();
        try {
          if (B) {
            var Ge = function() {
              throw Error();
            };
            if (Object.defineProperty(Ge.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Ge, []);
              } catch (ir) {
                ve = ir;
              }
              Reflect.construct(k, [], Ge);
            } else {
              try {
                Ge.call();
              } catch (ir) {
                ve = ir;
              }
              k.call(Ge.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (ir) {
              ve = ir;
            }
            k();
          }
        } catch (ir) {
          if (ir && ve && typeof ir.stack == "string") {
            for (var De = ir.stack.split(`
`), At = ve.stack.split(`
`), He = De.length - 1, Ft = At.length - 1; He >= 1 && Ft >= 0 && De[He] !== At[Ft]; )
              Ft--;
            for (; He >= 1 && Ft >= 0; He--, Ft--)
              if (De[He] !== At[Ft]) {
                if (He !== 1 || Ft !== 1)
                  do
                    if (He--, Ft--, Ft < 0 || De[He] !== At[Ft]) {
                      var wr = `
` + De[He].replace(" at new ", " at ");
                      return typeof k == "function" && q.set(k, wr), wr;
                    }
                  while (He >= 1 && Ft >= 0);
                break;
              }
          }
        } finally {
          $ = !1, Z.current = ot, Ce(), Error.prepareStackTrace = Le;
        }
        var Xr = k ? k.displayName || k.name : "", rs = Xr ? Q(Xr) : "";
        return typeof k == "function" && q.set(k, rs), rs;
      }
      function Pe(k, B, G) {
        return V(k, !1);
      }
      function X(k) {
        var B = k.prototype;
        return !!(B && B.isReactComponent);
      }
      function it(k, B, G) {
        if (k == null)
          return "";
        if (typeof k == "function")
          return V(k, X(k));
        if (typeof k == "string")
          return Q(k);
        switch (k) {
          case u:
            return Q("Suspense");
          case d:
            return Q("SuspenseList");
        }
        if (typeof k == "object")
          switch (k.$$typeof) {
            case l:
              return Pe(k.render);
            case f:
              return it(k.type, B, G);
            case g:
              return Pe(k._render);
            case h: {
              var ve = k, Le = ve._payload, ot = ve._init;
              try {
                return it(ot(Le), B, G);
              } catch {
              }
            }
          }
        return "";
      }
      var ht = {}, Ze = S.ReactDebugCurrentFrame;
      function pt(k) {
        if (k) {
          var B = k._owner, G = it(k.type, k._source, B ? B.type : null);
          Ze.setExtraStackFrame(G);
        } else
          Ze.setExtraStackFrame(null);
      }
      function Nt(k, B, G, ve, Le) {
        {
          var ot = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Ge in k)
            if (ot(k, Ge)) {
              var De = void 0;
              try {
                if (typeof k[Ge] != "function") {
                  var At = Error((ve || "React class") + ": " + G + " type `" + Ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof k[Ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw At.name = "Invariant Violation", At;
                }
                De = k[Ge](B, Ge, ve, G, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (He) {
                De = He;
              }
              De && !(De instanceof Error) && (pt(Le), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ve || "React class", G, Ge, typeof De), pt(null)), De instanceof Error && !(De.message in ht) && (ht[De.message] = !0, pt(Le), T("Failed %s type: %s", G, De.message), pt(null));
            }
        }
      }
      var ut = S.ReactCurrentOwner, We = Object.prototype.hasOwnProperty, en = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Jt, gt, Zt;
      Zt = {};
      function Tt(k) {
        if (We.call(k, "ref")) {
          var B = Object.getOwnPropertyDescriptor(k, "ref").get;
          if (B && B.isReactWarning)
            return !1;
        }
        return k.ref !== void 0;
      }
      function U(k) {
        if (We.call(k, "key")) {
          var B = Object.getOwnPropertyDescriptor(k, "key").get;
          if (B && B.isReactWarning)
            return !1;
        }
        return k.key !== void 0;
      }
      function Y(k, B) {
        if (typeof k.ref == "string" && ut.current && B && ut.current.stateNode !== B) {
          var G = L(ut.current.type);
          Zt[G] || (T('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(ut.current.type), k.ref), Zt[G] = !0);
        }
      }
      function we(k, B) {
        {
          var G = function() {
            Jt || (Jt = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", B));
          };
          G.isReactWarning = !0, Object.defineProperty(k, "key", {
            get: G,
            configurable: !0
          });
        }
      }
      function qe(k, B) {
        {
          var G = function() {
            gt || (gt = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", B));
          };
          G.isReactWarning = !0, Object.defineProperty(k, "ref", {
            get: G,
            configurable: !0
          });
        }
      }
      var Ye = function(k, B, G, ve, Le, ot, Ge) {
        var De = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: k,
          key: B,
          ref: G,
          props: Ge,
          // Record the component responsible for creating this element.
          _owner: ot
        };
        return De._store = {}, Object.defineProperty(De._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(De, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ve
        }), Object.defineProperty(De, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Le
        }), Object.freeze && (Object.freeze(De.props), Object.freeze(De)), De;
      };
      function kt(k, B, G, ve, Le) {
        {
          var ot, Ge = {}, De = null, At = null;
          G !== void 0 && (De = "" + G), U(B) && (De = "" + B.key), Tt(B) && (At = B.ref, Y(B, Le));
          for (ot in B)
            We.call(B, ot) && !en.hasOwnProperty(ot) && (Ge[ot] = B[ot]);
          if (k && k.defaultProps) {
            var He = k.defaultProps;
            for (ot in He)
              Ge[ot] === void 0 && (Ge[ot] = He[ot]);
          }
          if (De || At) {
            var Ft = typeof k == "function" ? k.displayName || k.name || "Unknown" : k;
            De && we(Ge, Ft), At && qe(Ge, Ft);
          }
          return Ye(k, De, At, Le, ve, ut.current, Ge);
        }
      }
      var tn = S.ReactCurrentOwner, vn = S.ReactDebugCurrentFrame;
      function jt(k) {
        if (k) {
          var B = k._owner, G = it(k.type, k._source, B ? B.type : null);
          vn.setExtraStackFrame(G);
        } else
          vn.setExtraStackFrame(null);
      }
      var Xt;
      Xt = !1;
      function vt(k) {
        return typeof k == "object" && k !== null && k.$$typeof === r;
      }
      function zn() {
        {
          if (tn.current) {
            var k = L(tn.current.type);
            if (k)
              return `

Check the render method of \`` + k + "`.";
          }
          return "";
        }
      }
      function gn(k) {
        {
          if (k !== void 0) {
            var B = k.fileName.replace(/^.*[\\\/]/, ""), G = k.lineNumber;
            return `

Check your code at ` + B + ":" + G + ".";
          }
          return "";
        }
      }
      var Qr = {};
      function Ji(k) {
        {
          var B = zn();
          if (!B) {
            var G = typeof k == "string" ? k : k.displayName || k.name;
            G && (B = `

Check the top-level render call using <` + G + ">.");
          }
          return B;
        }
      }
      function un(k, B) {
        {
          if (!k._store || k._store.validated || k.key != null)
            return;
          k._store.validated = !0;
          var G = Ji(B);
          if (Qr[G])
            return;
          Qr[G] = !0;
          var ve = "";
          k && k._owner && k._owner !== tn.current && (ve = " It was passed a child from " + L(k._owner.type) + "."), jt(k), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', G, ve), jt(null);
        }
      }
      function kn(k, B) {
        {
          if (typeof k != "object")
            return;
          if (Array.isArray(k))
            for (var G = 0; G < k.length; G++) {
              var ve = k[G];
              vt(ve) && un(ve, B);
            }
          else if (vt(k))
            k._store && (k._store.validated = !0);
          else if (k) {
            var Le = E(k);
            if (typeof Le == "function" && Le !== k.entries)
              for (var ot = Le.call(k), Ge; !(Ge = ot.next()).done; )
                vt(Ge.value) && un(Ge.value, B);
          }
        }
      }
      function Oe(k) {
        {
          var B = k.type;
          if (B == null || typeof B == "string")
            return;
          var G;
          if (typeof B == "function")
            G = B.propTypes;
          else if (typeof B == "object" && (B.$$typeof === l || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          B.$$typeof === f))
            G = B.propTypes;
          else
            return;
          if (G) {
            var ve = L(B);
            Nt(G, k.props, "prop", ve, k);
          } else if (B.PropTypes !== void 0 && !Xt) {
            Xt = !0;
            var Le = L(B);
            T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Le || "Unknown");
          }
          typeof B.getDefaultProps == "function" && !B.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function ft(k) {
        {
          for (var B = Object.keys(k.props), G = 0; G < B.length; G++) {
            var ve = B[G];
            if (ve !== "children" && ve !== "key") {
              jt(k), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ve), jt(null);
              break;
            }
          }
          k.ref !== null && (jt(k), T("Invalid attribute `ref` supplied to `React.Fragment`."), jt(null));
        }
      }
      function Fn(k, B, G, ve, Le, ot) {
        {
          var Ge = N(k);
          if (!Ge) {
            var De = "";
            (k === void 0 || typeof k == "object" && k !== null && Object.keys(k).length === 0) && (De += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var At = gn(Le);
            At ? De += At : De += zn();
            var He;
            k === null ? He = "null" : Array.isArray(k) ? He = "array" : k !== void 0 && k.$$typeof === r ? (He = "<" + (L(k.type) || "Unknown") + " />", De = " Did you accidentally export a JSX literal instead of a component?") : He = typeof k, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", He, De);
          }
          var Ft = kt(k, B, G, Le, ot);
          if (Ft == null)
            return Ft;
          if (Ge) {
            var wr = B.children;
            if (wr !== void 0)
              if (ve)
                if (Array.isArray(wr)) {
                  for (var Xr = 0; Xr < wr.length; Xr++)
                    kn(wr[Xr], k);
                  Object.freeze && Object.freeze(wr);
                } else
                  T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                kn(wr, k);
          }
          return k === t.Fragment ? ft(Ft) : Oe(Ft), Ft;
        }
      }
      function Uo(k, B, G) {
        return Fn(k, B, G, !0);
      }
      function Jr(k, B, G) {
        return Fn(k, B, G, !1);
      }
      var rr = Jr, Zr = Uo;
      t.jsx = rr, t.jsxs = Zr;
    }();
  }(Td)), Td;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = tI() : t.exports = nI();
})(eI);
const cc = Us.Fragment, C = Us.jsx, K = Us.jsxs, Ap = Ha(void 0), rI = ({ children: t, authService: e }) => {
  var _, E, S;
  const [n, r] = et(
    ((_ = e.initialAuthState) == null ? void 0 : _.userId) ?? null
  ), [i, o] = et(
    ((E = e.initialAuthState) == null ? void 0 : E.token) ?? null
  ), [a, s] = et(
    ((S = e.initialAuthState) == null ? void 0 : S.username) ?? null
  ), c = Me(null), l = !!i, u = Qe(
    async ({ email: T, password: x }) => {
      if (e.signUpWithEmailAndPassword)
        await e.signUpWithEmailAndPassword({
          email: T,
          password: x
        });
      else
        throw new Error(
          "signUpWithEmailAndPassword not available for current auth provider"
        );
    },
    [e]
  ), d = Qe(
    async ({ email: T, password: x }) => {
      if (e.loginWithEmailAndPassword)
        await e.loginWithEmailAndPassword({
          email: T,
          password: x
        });
      else
        throw new Error(
          "loginWithEmailAndPassword not available for current auth provider"
        );
    },
    [e]
  ), f = Qe(async () => {
    if (e.loginWithPopup)
      await e.loginWithPopup();
    else
      throw new Error("loginWithPopup not available for current auth provider");
  }, [e]), h = Qe(async () => {
    if (e.loginWithRedirect)
      await e.loginWithRedirect();
    else
      throw new Error(
        "loginWithRedirect not available for current auth provider"
      );
  }, [e]), g = Qe(async () => {
    if (e.changePasswordWithRedirect)
      await e.changePasswordWithRedirect();
    else
      throw new Error(
        "changePasswordWithRedirect not available for current auth provider"
      );
  }, [e]), v = Qe(async () => {
    if (e.handleRedirectResult)
      return await e.handleRedirectResult();
    throw new Error(
      "handleRedirectResult not available for current auth provider"
    );
  }, [e]), b = Qe(
    async (T) => {
      await e.logOut(T);
    },
    [e]
  ), m = Qe(async () => {
    try {
      const T = await e.restoreSession();
      return !!(T != null && T.userId);
    } catch {
      return !1;
    }
  }, [e]), y = Qe(() => c.current, []), p = Qe(() => e.refreshJWT(), [e]);
  Ee(() => e.onAuthStateChange(
    ({ userId: x, token: A, username: N }) => {
      r(x), s(N), c.current = A, o(A);
    }
  ));
  const w = Tr(
    () => ({
      loginWithPopup: f,
      loginWithRedirect: h,
      changePasswordWithRedirect: g,
      handleRedirectResult: v,
      signUpWithEmailAndPassword: u,
      loginWithEmailAndPassword: d,
      logOut: b,
      restoreSession: m,
      loggedIn: l,
      userId: n,
      token: i,
      username: a,
      getToken: y,
      refreshToken: p
    }),
    [
      f,
      h,
      g,
      v,
      u,
      d,
      b,
      m,
      l,
      n,
      i,
      a,
      y,
      p
    ]
  );
  return /* @__PURE__ */ C(Ap.Provider, { value: w, children: t });
}, Ru = () => {
  const t = zi(Ap);
  if (t === void 0)
    throw new Error("useAuth must be used within an AuthContextProvider");
  return t;
}, iI = () => zi(Ap);
var Ff = {}, oI = {
  get exports() {
    return Ff;
  },
  set exports(t) {
    Ff = t;
  }
};
(function(t) {
  var e = Object.prototype.hasOwnProperty, n = "~";
  function r() {
  }
  Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (n = !1));
  function i(c, l, u) {
    this.fn = c, this.context = l, this.once = u || !1;
  }
  function o(c, l, u, d, f) {
    if (typeof u != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(u, d || c, f), g = n ? n + l : l;
    return c._events[g] ? c._events[g].fn ? c._events[g] = [c._events[g], h] : c._events[g].push(h) : (c._events[g] = h, c._eventsCount++), c;
  }
  function a(c, l) {
    --c._eventsCount === 0 ? c._events = new r() : delete c._events[l];
  }
  function s() {
    this._events = new r(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var l = [], u, d;
    if (this._eventsCount === 0)
      return l;
    for (d in u = this._events)
      e.call(u, d) && l.push(n ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? l.concat(Object.getOwnPropertySymbols(u)) : l;
  }, s.prototype.listeners = function(l) {
    var u = n ? n + l : l, d = this._events[u];
    if (!d)
      return [];
    if (d.fn)
      return [d.fn];
    for (var f = 0, h = d.length, g = new Array(h); f < h; f++)
      g[f] = d[f].fn;
    return g;
  }, s.prototype.listenerCount = function(l) {
    var u = n ? n + l : l, d = this._events[u];
    return d ? d.fn ? 1 : d.length : 0;
  }, s.prototype.emit = function(l, u, d, f, h, g) {
    var v = n ? n + l : l;
    if (!this._events[v])
      return !1;
    var b = this._events[v], m = arguments.length, y, p;
    if (b.fn) {
      switch (b.once && this.removeListener(l, b.fn, void 0, !0), m) {
        case 1:
          return b.fn.call(b.context), !0;
        case 2:
          return b.fn.call(b.context, u), !0;
        case 3:
          return b.fn.call(b.context, u, d), !0;
        case 4:
          return b.fn.call(b.context, u, d, f), !0;
        case 5:
          return b.fn.call(b.context, u, d, f, h), !0;
        case 6:
          return b.fn.call(b.context, u, d, f, h, g), !0;
      }
      for (p = 1, y = new Array(m - 1); p < m; p++)
        y[p - 1] = arguments[p];
      b.fn.apply(b.context, y);
    } else {
      var w = b.length, _;
      for (p = 0; p < w; p++)
        switch (b[p].once && this.removeListener(l, b[p].fn, void 0, !0), m) {
          case 1:
            b[p].fn.call(b[p].context);
            break;
          case 2:
            b[p].fn.call(b[p].context, u);
            break;
          case 3:
            b[p].fn.call(b[p].context, u, d);
            break;
          case 4:
            b[p].fn.call(b[p].context, u, d, f);
            break;
          default:
            if (!y)
              for (_ = 1, y = new Array(m - 1); _ < m; _++)
                y[_ - 1] = arguments[_];
            b[p].fn.apply(b[p].context, y);
        }
    }
    return !0;
  }, s.prototype.on = function(l, u, d) {
    return o(this, l, u, d, !1);
  }, s.prototype.once = function(l, u, d) {
    return o(this, l, u, d, !0);
  }, s.prototype.removeListener = function(l, u, d, f) {
    var h = n ? n + l : l;
    if (!this._events[h])
      return this;
    if (!u)
      return a(this, h), this;
    var g = this._events[h];
    if (g.fn)
      g.fn === u && (!f || g.once) && (!d || g.context === d) && a(this, h);
    else {
      for (var v = 0, b = [], m = g.length; v < m; v++)
        (g[v].fn !== u || f && !g[v].once || d && g[v].context !== d) && b.push(g[v]);
      b.length ? this._events[h] = b.length === 1 ? b[0] : b : a(this, h);
    }
    return this;
  }, s.prototype.removeAllListeners = function(l) {
    var u;
    return l ? (u = n ? n + l : l, this._events[u] && a(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, t.exports = s;
})(oI);
const Op = Ff;
var so = 256, cl = [], Hc;
for (; so--; )
  cl[so] = (so + 256).toString(16).substring(1);
function Di() {
  var t = 0, e, n = "";
  if (!Hc || so + 16 > 256) {
    for (Hc = Array(t = 256); t--; )
      Hc[t] = 256 * Math.random() | 0;
    t = so = 0;
  }
  for (; t < 16; t++)
    e = Hc[so + t], t == 6 ? n += cl[e & 15 | 64] : t == 8 ? n += cl[e & 63 | 128] : n += cl[e], t & 1 && t > 1 && t < 11 && (n += "-");
  return so++, n;
}
const Bm = (t) => {
  const e = new Op();
  let n = (t == null ? void 0 : t.currentLogin) ?? {
    userId: null,
    token: null,
    refreshToken: null,
    username: null
  };
  const r = (t == null ? void 0 : t.newLogin) ?? {
    userId: Di(),
    token: Di(),
    refreshToken: Di(),
    username: "test@email.com"
  };
  let i = null;
  return {
    initialAuthState: n,
    loginWithEmailAndPassword: async ({ email: v, password: b }) => (e.emit("authStateChange", r), n = { ...r }, r),
    signUpWithEmailAndPassword: async ({ email: v, password: b }) => (e.emit("authStateChange", r), n = { ...r }, r),
    loginWithPopup: async () => (e.emit("authStateChange", r), n = { ...r }, r),
    loginWithRedirect: async () => {
      i = { ...r };
    },
    handleRedirectResult: async () => i !== null ? (e.emit("authStateChange", i), n = { ...i }, i) : null,
    logOut: async () => {
      e.emit("authStateChange", {
        userId: null,
        token: null,
        refreshToken: null,
        username: null
      }), n = {
        userId: null,
        token: null,
        refreshToken: null,
        username: null
      };
    },
    restoreSession: async () => {
      const v = (t == null ? void 0 : t.sessionLogin) ?? n;
      return e.emit("authStateChange", v), n = v, v;
    },
    refreshJWT: async () => {
    },
    onAuthStateChange: (v) => {
      e.on("authStateChange", v);
      const b = () => e.off("authStateChange", v);
      return () => {
        b();
      };
    },
    unsubscribeAll: () => {
      e.removeAllListeners("authStateChange");
    }
  };
}, vW = ({
  children: t,
  loggedIn: e
}) => {
  const n = e ? Bm({
    currentLogin: {
      userId: "userid",
      token: "token",
      refreshToken: "refreshToken",
      username: "test@email.com"
    }
  }) : Bm();
  return /* @__PURE__ */ C(rI, { authService: n, children: t });
};
/*! @azure/msal-browser v2.28.0 2022-07-18 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Uf = function(t, e) {
  return Uf = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Uf(t, e);
};
function Tn(t, e) {
  Uf(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var Se = function() {
  return Se = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, Se.apply(this, arguments);
};
function re(t, e, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(t, e || [])).next());
  });
}
function ie(t, e) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (o = l[0] & 2 ? i.return : l[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, l[1])).done)
          return o;
        switch (i = 0, o && (l = [l[0] & 2, o.value]), l[0]) {
          case 0:
          case 1:
            o = l;
            break;
          case 4:
            return n.label++, { value: l[1], done: !1 };
          case 5:
            n.label++, i = l[1], l = [0];
            continue;
          case 7:
            l = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              n = 0;
              continue;
            }
            if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
              n.label = l[1];
              break;
            }
            if (l[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = l;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(l);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        l = e.call(t, n);
      } catch (u) {
        l = [6, u], i = 0;
      } finally {
        r = o = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function aI(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n)
    return t;
  var r = n.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
function Nw() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t = t.concat(aI(arguments[e]));
  return t;
}
/*! @azure/msal-common v7.6.0 2022-10-10 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Hf = function(t, e) {
  return Hf = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Hf(t, e);
};
function qn(t, e) {
  Hf(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var nn = function() {
  return nn = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, nn.apply(this, arguments);
};
function je(t, e, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(t, e || [])).next());
  });
}
function Ve(t, e) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; n; )
      try {
        if (r = 1, i && (o = l[0] & 2 ? i.return : l[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, l[1])).done)
          return o;
        switch (i = 0, o && (l = [l[0] & 2, o.value]), l[0]) {
          case 0:
          case 1:
            o = l;
            break;
          case 4:
            return n.label++, { value: l[1], done: !1 };
          case 5:
            n.label++, i = l[1], l = [0];
            continue;
          case 7:
            l = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              n = 0;
              continue;
            }
            if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
              n.label = l[1];
              break;
            }
            if (l[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = l;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(l);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        l = e.call(t, n);
      } catch (u) {
        l = [6, u], i = 0;
      } finally {
        r = o = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function Nu() {
  for (var t = 0, e = 0, n = arguments.length; e < n; e++)
    t += arguments[e].length;
  for (var r = Array(t), i = 0, e = 0; e < n; e++)
    for (var o = arguments[e], a = 0, s = o.length; a < s; a++, i++)
      r[i] = o[a];
  return r;
}
/*! @azure/msal-common v7.6.0 2022-10-10 */
var M = {
  LIBRARY_NAME: "MSAL.JS",
  SKU: "msal.js.common",
  // Prefix for all library cache entries
  CACHE_PREFIX: "msal",
  // default authority
  DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
  DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
  DEFAULT_COMMON_TENANT: "common",
  // ADFS String
  ADFS: "adfs",
  DSTS: "dstsv2",
  // Default AAD Instance Discovery Endpoint
  AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
  // Resource delimiter - used for certain cache entries
  RESOURCE_DELIM: "|",
  // Placeholder for non-existent account ids/objects
  NO_ACCOUNT: "NO_ACCOUNT",
  // Claims
  CLAIMS: "claims",
  // Consumer UTID
  CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
  // Default scopes
  OPENID_SCOPE: "openid",
  PROFILE_SCOPE: "profile",
  OFFLINE_ACCESS_SCOPE: "offline_access",
  EMAIL_SCOPE: "email",
  // Default response type for authorization code flow
  CODE_RESPONSE_TYPE: "code",
  CODE_GRANT_TYPE: "authorization_code",
  RT_GRANT_TYPE: "refresh_token",
  FRAGMENT_RESPONSE_MODE: "fragment",
  S256_CODE_CHALLENGE_METHOD: "S256",
  URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
  AUTHORIZATION_PENDING: "authorization_pending",
  NOT_DEFINED: "not_defined",
  EMPTY_STRING: "",
  FORWARD_SLASH: "/",
  IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
  IMDS_VERSION: "2020-06-01",
  IMDS_TIMEOUT: 2e3,
  AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
  REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
  REGIONAL_AUTH_NON_MSI_QUERY_STRING: "allowestsrnonmsi=true",
  KNOWN_PUBLIC_CLOUDS: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"],
  TOKEN_RESPONSE_TYPE: "token",
  ID_TOKEN_RESPONSE_TYPE: "id_token",
  SHR_NONCE_VALIDITY: 240
}, lc = [
  M.OPENID_SCOPE,
  M.PROFILE_SCOPE,
  M.OFFLINE_ACCESS_SCOPE
], jm = Nu(lc, [
  M.EMAIL_SCOPE
]), Ir;
(function(t) {
  t.CONTENT_TYPE = "Content-Type", t.RETRY_AFTER = "Retry-After", t.CCS_HEADER = "X-AnchorMailbox", t.WWWAuthenticate = "WWW-Authenticate", t.AuthenticationInfo = "Authentication-Info", t.X_MS_REQUEST_ID = "x-ms-request-id";
})(Ir || (Ir = {}));
var mn;
(function(t) {
  t.ID_TOKEN = "idtoken", t.CLIENT_INFO = "client.info", t.ADAL_ID_TOKEN = "adal.idtoken", t.ERROR = "error", t.ERROR_DESC = "error.description", t.ACTIVE_ACCOUNT = "active-account", t.ACTIVE_ACCOUNT_FILTERS = "active-account-filters";
})(mn || (mn = {}));
var xl;
(function(t) {
  t.COMMON = "common", t.ORGANIZATIONS = "organizations", t.CONSUMERS = "consumers";
})(xl || (xl = {}));
var Ke;
(function(t) {
  t.CLIENT_ID = "client_id", t.REDIRECT_URI = "redirect_uri", t.RESPONSE_TYPE = "response_type", t.RESPONSE_MODE = "response_mode", t.GRANT_TYPE = "grant_type", t.CLAIMS = "claims", t.SCOPE = "scope", t.ERROR = "error", t.ERROR_DESCRIPTION = "error_description", t.ACCESS_TOKEN = "access_token", t.ID_TOKEN = "id_token", t.REFRESH_TOKEN = "refresh_token", t.EXPIRES_IN = "expires_in", t.STATE = "state", t.NONCE = "nonce", t.PROMPT = "prompt", t.SESSION_STATE = "session_state", t.CLIENT_INFO = "client_info", t.CODE = "code", t.CODE_CHALLENGE = "code_challenge", t.CODE_CHALLENGE_METHOD = "code_challenge_method", t.CODE_VERIFIER = "code_verifier", t.CLIENT_REQUEST_ID = "client-request-id", t.X_CLIENT_SKU = "x-client-SKU", t.X_CLIENT_VER = "x-client-VER", t.X_CLIENT_OS = "x-client-OS", t.X_CLIENT_CPU = "x-client-CPU", t.X_CLIENT_CURR_TELEM = "x-client-current-telemetry", t.X_CLIENT_LAST_TELEM = "x-client-last-telemetry", t.X_MS_LIB_CAPABILITY = "x-ms-lib-capability", t.X_APP_NAME = "x-app-name", t.X_APP_VER = "x-app-ver", t.POST_LOGOUT_URI = "post_logout_redirect_uri", t.ID_TOKEN_HINT = "id_token_hint", t.DEVICE_CODE = "device_code", t.CLIENT_SECRET = "client_secret", t.CLIENT_ASSERTION = "client_assertion", t.CLIENT_ASSERTION_TYPE = "client_assertion_type", t.TOKEN_TYPE = "token_type", t.REQ_CNF = "req_cnf", t.OBO_ASSERTION = "assertion", t.REQUESTED_TOKEN_USE = "requested_token_use", t.ON_BEHALF_OF = "on_behalf_of", t.FOCI = "foci", t.CCS_HEADER = "X-AnchorMailbox", t.RETURN_SPA_CODE = "return_spa_code", t.NATIVE_BROKER = "nativebroker", t.LOGOUT_HINT = "logout_hint";
})(Ke || (Ke = {}));
var Qo;
(function(t) {
  t.ACCESS_TOKEN = "access_token", t.XMS_CC = "xms_cc";
})(Qo || (Qo = {}));
var Rn = {
  LOGIN: "login",
  SELECT_ACCOUNT: "select_account",
  CONSENT: "consent",
  NONE: "none",
  CREATE: "create",
  NO_SESSION: "no_session"
}, Ts;
(function(t) {
  t.ACCOUNT = "account", t.SID = "sid", t.LOGIN_HINT = "login_hint", t.ID_TOKEN = "id_token", t.DOMAIN_HINT = "domain_hint", t.ORGANIZATIONS = "organizations", t.CONSUMERS = "consumers", t.ACCOUNT_ID = "accountIdentifier", t.HOMEACCOUNT_ID = "homeAccountIdentifier";
})(Ts || (Ts = {}));
var Vm = {
  PLAIN: "plain",
  S256: "S256"
}, Rl;
(function(t) {
  t.QUERY = "query", t.FRAGMENT = "fragment", t.FORM_POST = "form_post";
})(Rl || (Rl = {}));
var Nl;
(function(t) {
  t.IMPLICIT_GRANT = "implicit", t.AUTHORIZATION_CODE_GRANT = "authorization_code", t.CLIENT_CREDENTIALS_GRANT = "client_credentials", t.RESOURCE_OWNER_PASSWORD_GRANT = "password", t.REFRESH_TOKEN_GRANT = "refresh_token", t.DEVICE_CODE_GRANT = "device_code", t.JWT_BEARER = "urn:ietf:params:oauth:grant-type:jwt-bearer";
})(Nl || (Nl = {}));
var ti;
(function(t) {
  t.MSSTS_ACCOUNT_TYPE = "MSSTS", t.ADFS_ACCOUNT_TYPE = "ADFS", t.MSAV1_ACCOUNT_TYPE = "MSA", t.GENERIC_ACCOUNT_TYPE = "Generic";
})(ti || (ti = {}));
var Xn;
(function(t) {
  t.CACHE_KEY_SEPARATOR = "-", t.CLIENT_INFO_SEPARATOR = ".";
})(Xn || (Xn = {}));
var nt;
(function(t) {
  t.ID_TOKEN = "IdToken", t.ACCESS_TOKEN = "AccessToken", t.ACCESS_TOKEN_WITH_AUTH_SCHEME = "AccessToken_With_AuthScheme", t.REFRESH_TOKEN = "RefreshToken";
})(nt || (nt = {}));
var po;
(function(t) {
  t.ACCOUNT = "Account", t.CREDENTIAL = "Credential", t.ID_TOKEN = "IdToken", t.ACCESS_TOKEN = "AccessToken", t.REFRESH_TOKEN = "RefreshToken", t.APP_METADATA = "AppMetadata", t.TEMPORARY = "TempCache", t.TELEMETRY = "Telemetry", t.UNDEFINED = "Undefined", t.THROTTLING = "Throttling";
})(po || (po = {}));
var ri;
(function(t) {
  t[t.ADFS = 1001] = "ADFS", t[t.MSA = 1002] = "MSA", t[t.MSSTS = 1003] = "MSSTS", t[t.GENERIC = 1004] = "GENERIC", t[t.ACCESS_TOKEN = 2001] = "ACCESS_TOKEN", t[t.REFRESH_TOKEN = 2002] = "REFRESH_TOKEN", t[t.ID_TOKEN = 2003] = "ID_TOKEN", t[t.APP_METADATA = 3001] = "APP_METADATA", t[t.UNDEFINED = 9999] = "UNDEFINED";
})(ri || (ri = {}));
var Bf = "appmetadata", sI = "client_info", Ml = "1", ks = {
  CACHE_KEY: "authority-metadata",
  REFRESH_TIME_SECONDS: 3600 * 24
  // 24 Hours
}, cr;
(function(t) {
  t.CONFIG = "config", t.CACHE = "cache", t.NETWORK = "network", t.HARDCODED_VALUES = "hardcoded_values";
})(cr || (cr = {}));
var In = {
  SCHEMA_VERSION: 5,
  MAX_CUR_HEADER_BYTES: 80,
  MAX_LAST_HEADER_BYTES: 330,
  MAX_CACHED_ERRORS: 50,
  CACHE_KEY: "server-telemetry",
  CATEGORY_SEPARATOR: "|",
  VALUE_SEPARATOR: ",",
  OVERFLOW_TRUE: "1",
  OVERFLOW_FALSE: "0",
  UNKNOWN_ERROR: "unknown_error"
}, St;
(function(t) {
  t.BEARER = "Bearer", t.POP = "pop", t.SSH = "ssh-cert";
})(St || (St = {}));
var As = {
  // Default time to throttle RequestThumbprint in seconds
  DEFAULT_THROTTLE_TIME_SECONDS: 60,
  // Default maximum time to throttle in seconds, overrides what the server sends back
  DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
  // Prefix for storing throttling entries
  THROTTLING_PREFIX: "throttling",
  // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
  X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
}, $m = {
  INVALID_GRANT_ERROR: "invalid_grant",
  CLIENT_MISMATCH_ERROR: "client_mismatch"
}, Pl;
(function(t) {
  t.username = "username", t.password = "password";
})(Pl || (Pl = {}));
var Jo;
(function(t) {
  t[t.httpSuccess = 200] = "httpSuccess", t[t.httpBadRequest = 400] = "httpBadRequest";
})(Jo || (Jo = {}));
var Ai;
(function(t) {
  t.FAILED_AUTO_DETECTION = "1", t.INTERNAL_CACHE = "2", t.ENVIRONMENT_VARIABLE = "3", t.IMDS = "4";
})(Ai || (Ai = {}));
var io;
(function(t) {
  t.CONFIGURED_MATCHES_DETECTED = "1", t.CONFIGURED_NO_AUTO_DETECTION = "2", t.CONFIGURED_NOT_DETECTED = "3", t.AUTO_DETECTION_REQUESTED_SUCCESSFUL = "4", t.AUTO_DETECTION_REQUESTED_FAILED = "5";
})(io || (io = {}));
var co;
(function(t) {
  t.NO_CACHE_HIT = "0", t.FORCE_REFRESH = "1", t.NO_CACHED_ACCESS_TOKEN = "2", t.CACHED_ACCESS_TOKEN_EXPIRED = "3", t.REFRESH_CACHED_ACCESS_TOKEN = "4";
})(co || (co = {}));
var jf;
(function(t) {
  t.Jwt = "JWT", t.Jwk = "JWK";
})(jf || (jf = {}));
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Bc = {
  unexpectedError: {
    code: "unexpected_error",
    desc: "Unexpected error in authentication."
  },
  postRequestFailed: {
    code: "post_request_failed",
    desc: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
  }
}, Ie = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n, r, i) {
      var o = this, a = r ? n + ": " + r : n;
      return o = t.call(this, a) || this, Object.setPrototypeOf(o, e.prototype), o.errorCode = n || M.EMPTY_STRING, o.errorMessage = r || M.EMPTY_STRING, o.subError = i || M.EMPTY_STRING, o.name = "AuthError", o;
    }
    return e.prototype.setCorrelationId = function(n) {
      this.correlationId = n;
    }, e.createUnexpectedError = function(n) {
      return new e(Bc.unexpectedError.code, Bc.unexpectedError.desc + ": " + n);
    }, e.createPostRequestFailed = function(n) {
      return new e(Bc.postRequestFailed.code, Bc.postRequestFailed.desc + ": " + n);
    }, e;
  }(Error)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Dl = {
  createNewGuid: function() {
    var t = "Crypto interface - createNewGuid() has not been implemented";
    throw Ie.createUnexpectedError(t);
  },
  base64Decode: function() {
    var t = "Crypto interface - base64Decode() has not been implemented";
    throw Ie.createUnexpectedError(t);
  },
  base64Encode: function() {
    var t = "Crypto interface - base64Encode() has not been implemented";
    throw Ie.createUnexpectedError(t);
  },
  generatePkceCodes: function() {
    return je(this, void 0, void 0, function() {
      var t;
      return Ve(this, function(e) {
        throw t = "Crypto interface - generatePkceCodes() has not been implemented", Ie.createUnexpectedError(t);
      });
    });
  },
  getPublicKeyThumbprint: function() {
    return je(this, void 0, void 0, function() {
      var t;
      return Ve(this, function(e) {
        throw t = "Crypto interface - getPublicKeyThumbprint() has not been implemented", Ie.createUnexpectedError(t);
      });
    });
  },
  removeTokenBindingKey: function() {
    return je(this, void 0, void 0, function() {
      var t;
      return Ve(this, function(e) {
        throw t = "Crypto interface - removeTokenBindingKey() has not been implemented", Ie.createUnexpectedError(t);
      });
    });
  },
  clearKeystore: function() {
    return je(this, void 0, void 0, function() {
      var t;
      return Ve(this, function(e) {
        throw t = "Crypto interface - clearKeystore() has not been implemented", Ie.createUnexpectedError(t);
      });
    });
  },
  signJwt: function() {
    return je(this, void 0, void 0, function() {
      var t;
      return Ve(this, function(e) {
        throw t = "Crypto interface - signJwt() has not been implemented", Ie.createUnexpectedError(t);
      });
    });
  },
  hashString: function() {
    return je(this, void 0, void 0, function() {
      var t;
      return Ve(this, function(e) {
        throw t = "Crypto interface - hashString() has not been implemented", Ie.createUnexpectedError(t);
      });
    });
  }
};
/*! @azure/msal-common v7.6.0 2022-10-10 */
var oe = {
  clientInfoDecodingError: {
    code: "client_info_decoding_error",
    desc: "The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause."
  },
  clientInfoEmptyError: {
    code: "client_info_empty_error",
    desc: "The client info was empty. Please review the trace to determine the root cause."
  },
  tokenParsingError: {
    code: "token_parsing_error",
    desc: "Token cannot be parsed. Please review stack trace to determine root cause."
  },
  nullOrEmptyToken: {
    code: "null_or_empty_token",
    desc: "The token is null or empty. Please review the trace to determine the root cause."
  },
  endpointResolutionError: {
    code: "endpoints_resolution_error",
    desc: "Error: could not resolve endpoints. Please check network and try again."
  },
  networkError: {
    code: "network_error",
    desc: "Network request failed. Please check network trace to determine root cause."
  },
  unableToGetOpenidConfigError: {
    code: "openid_config_error",
    desc: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints."
  },
  hashNotDeserialized: {
    code: "hash_not_deserialized",
    desc: "The hash parameters could not be deserialized. Please review the trace to determine the root cause."
  },
  blankGuidGenerated: {
    code: "blank_guid_generated",
    desc: "The guid generated was blank. Please review the trace to determine the root cause."
  },
  invalidStateError: {
    code: "invalid_state",
    desc: "State was not the expected format. Please check the logs to determine whether the request was sent using ProtocolUtils.setRequestState()."
  },
  stateMismatchError: {
    code: "state_mismatch",
    desc: "State mismatch error. Please check your network. Continued requests may cause cache overflow."
  },
  stateNotFoundError: {
    code: "state_not_found",
    desc: "State not found"
  },
  nonceMismatchError: {
    code: "nonce_mismatch",
    desc: "Nonce mismatch error. This may be caused by a race condition in concurrent requests."
  },
  nonceNotFoundError: {
    code: "nonce_not_found",
    desc: "nonce not found"
  },
  authTimeNotFoundError: {
    code: "auth_time_not_found",
    desc: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information."
  },
  maxAgeTranspiredError: {
    code: "max_age_transpired",
    desc: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication."
  },
  noTokensFoundError: {
    code: "no_tokens_found",
    desc: "No tokens were found for the given scopes, and no authorization code was passed to acquireToken. You must retrieve an authorization code before making a call to acquireToken()."
  },
  multipleMatchingTokens: {
    code: "multiple_matching_tokens",
    desc: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account."
  },
  multipleMatchingAccounts: {
    code: "multiple_matching_accounts",
    desc: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account"
  },
  multipleMatchingAppMetadata: {
    code: "multiple_matching_appMetadata",
    desc: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata"
  },
  tokenRequestCannotBeMade: {
    code: "request_cannot_be_made",
    desc: "Token request cannot be made without authorization code or refresh token."
  },
  appendEmptyScopeError: {
    code: "cannot_append_empty_scope",
    desc: "Cannot append null or empty scope to ScopeSet. Please check the stack trace for more info."
  },
  removeEmptyScopeError: {
    code: "cannot_remove_empty_scope",
    desc: "Cannot remove null or empty scope from ScopeSet. Please check the stack trace for more info."
  },
  appendScopeSetError: {
    code: "cannot_append_scopeset",
    desc: "Cannot append ScopeSet due to error."
  },
  emptyInputScopeSetError: {
    code: "empty_input_scopeset",
    desc: "Empty input ScopeSet cannot be processed."
  },
  DeviceCodePollingCancelled: {
    code: "device_code_polling_cancelled",
    desc: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true."
  },
  DeviceCodeExpired: {
    code: "device_code_expired",
    desc: "Device code is expired."
  },
  DeviceCodeUnknownError: {
    code: "device_code_unknown_error",
    desc: "Device code stopped polling for unknown reasons."
  },
  NoAccountInSilentRequest: {
    code: "no_account_in_silent_request",
    desc: "Please pass an account object, silent flow is not supported without account information"
  },
  invalidCacheRecord: {
    code: "invalid_cache_record",
    desc: "Cache record object was null or undefined."
  },
  invalidCacheEnvironment: {
    code: "invalid_cache_environment",
    desc: "Invalid environment when attempting to create cache entry"
  },
  noAccountFound: {
    code: "no_account_found",
    desc: "No account found in cache for given key."
  },
  CachePluginError: {
    code: "no cache plugin set on CacheManager",
    desc: "ICachePlugin needs to be set before using readFromStorage or writeFromStorage"
  },
  noCryptoObj: {
    code: "no_crypto_object",
    desc: "No crypto object detected. This is required for the following operation: "
  },
  invalidCacheType: {
    code: "invalid_cache_type",
    desc: "Invalid cache type"
  },
  unexpectedAccountType: {
    code: "unexpected_account_type",
    desc: "Unexpected account type."
  },
  unexpectedCredentialType: {
    code: "unexpected_credential_type",
    desc: "Unexpected credential type."
  },
  invalidAssertion: {
    code: "invalid_assertion",
    desc: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515"
  },
  invalidClientCredential: {
    code: "invalid_client_credential",
    desc: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential"
  },
  tokenRefreshRequired: {
    code: "token_refresh_required",
    desc: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired."
  },
  userTimeoutReached: {
    code: "user_timeout_reached",
    desc: "User defined timeout for device code polling reached"
  },
  tokenClaimsRequired: {
    code: "token_claims_cnf_required_for_signedjwt",
    desc: "Cannot generate a POP jwt if the token_claims are not populated"
  },
  noAuthorizationCodeFromServer: {
    code: "authorization_code_missing_from_server_response",
    desc: "Server response does not contain an authorization code to proceed"
  },
  noAzureRegionDetected: {
    code: "no_azure_region_detected",
    desc: "No azure region was detected and no fallback was made available"
  },
  accessTokenEntityNullError: {
    code: "access_token_entity_null",
    desc: "Access token entity is null, please check logs and cache to ensure a valid access token is present."
  },
  bindingKeyNotRemovedError: {
    code: "binding_key_not_removed",
    desc: "Could not remove the credential's binding key from storage."
  },
  logoutNotSupported: {
    code: "end_session_endpoint_not_supported",
    desc: "Provided authority does not support logout."
  },
  keyIdMissing: {
    code: "key_id_missing",
    desc: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key."
  }
}, ge = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n, r) {
      var i = t.call(this, n, r) || this;
      return i.name = "ClientAuthError", Object.setPrototypeOf(i, e.prototype), i;
    }
    return e.createClientInfoDecodingError = function(n) {
      return new e(oe.clientInfoDecodingError.code, oe.clientInfoDecodingError.desc + " Failed with error: " + n);
    }, e.createClientInfoEmptyError = function() {
      return new e(oe.clientInfoEmptyError.code, "" + oe.clientInfoEmptyError.desc);
    }, e.createTokenParsingError = function(n) {
      return new e(oe.tokenParsingError.code, oe.tokenParsingError.desc + " Failed with error: " + n);
    }, e.createTokenNullOrEmptyError = function(n) {
      return new e(oe.nullOrEmptyToken.code, oe.nullOrEmptyToken.desc + " Raw Token Value: " + n);
    }, e.createEndpointDiscoveryIncompleteError = function(n) {
      return new e(oe.endpointResolutionError.code, oe.endpointResolutionError.desc + " Detail: " + n);
    }, e.createNetworkError = function(n, r) {
      return new e(oe.networkError.code, oe.networkError.desc + " | Fetch client threw: " + r + " | Attempted to reach: " + n.split("?")[0]);
    }, e.createUnableToGetOpenidConfigError = function(n) {
      return new e(oe.unableToGetOpenidConfigError.code, oe.unableToGetOpenidConfigError.desc + " Attempted to retrieve endpoints from: " + n);
    }, e.createHashNotDeserializedError = function(n) {
      return new e(oe.hashNotDeserialized.code, oe.hashNotDeserialized.desc + " Given Object: " + n);
    }, e.createInvalidStateError = function(n, r) {
      return new e(oe.invalidStateError.code, oe.invalidStateError.desc + " Invalid State: " + n + ", Root Err: " + r);
    }, e.createStateMismatchError = function() {
      return new e(oe.stateMismatchError.code, oe.stateMismatchError.desc);
    }, e.createStateNotFoundError = function(n) {
      return new e(oe.stateNotFoundError.code, oe.stateNotFoundError.desc + ":  " + n);
    }, e.createNonceMismatchError = function() {
      return new e(oe.nonceMismatchError.code, oe.nonceMismatchError.desc);
    }, e.createAuthTimeNotFoundError = function() {
      return new e(oe.authTimeNotFoundError.code, oe.authTimeNotFoundError.desc);
    }, e.createMaxAgeTranspiredError = function() {
      return new e(oe.maxAgeTranspiredError.code, oe.maxAgeTranspiredError.desc);
    }, e.createNonceNotFoundError = function(n) {
      return new e(oe.nonceNotFoundError.code, oe.nonceNotFoundError.desc + ":  " + n);
    }, e.createMultipleMatchingTokensInCacheError = function() {
      return new e(oe.multipleMatchingTokens.code, oe.multipleMatchingTokens.desc + ".");
    }, e.createMultipleMatchingAccountsInCacheError = function() {
      return new e(oe.multipleMatchingAccounts.code, oe.multipleMatchingAccounts.desc);
    }, e.createMultipleMatchingAppMetadataInCacheError = function() {
      return new e(oe.multipleMatchingAppMetadata.code, oe.multipleMatchingAppMetadata.desc);
    }, e.createTokenRequestCannotBeMadeError = function() {
      return new e(oe.tokenRequestCannotBeMade.code, oe.tokenRequestCannotBeMade.desc);
    }, e.createAppendEmptyScopeToSetError = function(n) {
      return new e(oe.appendEmptyScopeError.code, oe.appendEmptyScopeError.desc + " Given Scope: " + n);
    }, e.createRemoveEmptyScopeFromSetError = function(n) {
      return new e(oe.removeEmptyScopeError.code, oe.removeEmptyScopeError.desc + " Given Scope: " + n);
    }, e.createAppendScopeSetError = function(n) {
      return new e(oe.appendScopeSetError.code, oe.appendScopeSetError.desc + " Detail Error: " + n);
    }, e.createEmptyInputScopeSetError = function() {
      return new e(oe.emptyInputScopeSetError.code, "" + oe.emptyInputScopeSetError.desc);
    }, e.createDeviceCodeCancelledError = function() {
      return new e(oe.DeviceCodePollingCancelled.code, "" + oe.DeviceCodePollingCancelled.desc);
    }, e.createDeviceCodeExpiredError = function() {
      return new e(oe.DeviceCodeExpired.code, "" + oe.DeviceCodeExpired.desc);
    }, e.createDeviceCodeUnknownError = function() {
      return new e(oe.DeviceCodeUnknownError.code, "" + oe.DeviceCodeUnknownError.desc);
    }, e.createNoAccountInSilentRequestError = function() {
      return new e(oe.NoAccountInSilentRequest.code, "" + oe.NoAccountInSilentRequest.desc);
    }, e.createNullOrUndefinedCacheRecord = function() {
      return new e(oe.invalidCacheRecord.code, oe.invalidCacheRecord.desc);
    }, e.createInvalidCacheEnvironmentError = function() {
      return new e(oe.invalidCacheEnvironment.code, oe.invalidCacheEnvironment.desc);
    }, e.createNoAccountFoundError = function() {
      return new e(oe.noAccountFound.code, oe.noAccountFound.desc);
    }, e.createCachePluginError = function() {
      return new e(oe.CachePluginError.code, "" + oe.CachePluginError.desc);
    }, e.createNoCryptoObjectError = function(n) {
      return new e(oe.noCryptoObj.code, "" + oe.noCryptoObj.desc + n);
    }, e.createInvalidCacheTypeError = function() {
      return new e(oe.invalidCacheType.code, "" + oe.invalidCacheType.desc);
    }, e.createUnexpectedAccountTypeError = function() {
      return new e(oe.unexpectedAccountType.code, "" + oe.unexpectedAccountType.desc);
    }, e.createUnexpectedCredentialTypeError = function() {
      return new e(oe.unexpectedCredentialType.code, "" + oe.unexpectedCredentialType.desc);
    }, e.createInvalidAssertionError = function() {
      return new e(oe.invalidAssertion.code, "" + oe.invalidAssertion.desc);
    }, e.createInvalidCredentialError = function() {
      return new e(oe.invalidClientCredential.code, "" + oe.invalidClientCredential.desc);
    }, e.createRefreshRequiredError = function() {
      return new e(oe.tokenRefreshRequired.code, oe.tokenRefreshRequired.desc);
    }, e.createUserTimeoutReachedError = function() {
      return new e(oe.userTimeoutReached.code, oe.userTimeoutReached.desc);
    }, e.createTokenClaimsRequiredError = function() {
      return new e(oe.tokenClaimsRequired.code, oe.tokenClaimsRequired.desc);
    }, e.createNoAuthCodeInServerResponseError = function() {
      return new e(oe.noAuthorizationCodeFromServer.code, oe.noAuthorizationCodeFromServer.desc);
    }, e.createBindingKeyNotRemovedError = function() {
      return new e(oe.bindingKeyNotRemovedError.code, oe.bindingKeyNotRemovedError.desc);
    }, e.createLogoutNotSupportedError = function() {
      return new e(oe.logoutNotSupported.code, oe.logoutNotSupported.desc);
    }, e.createKeyIdMissingError = function() {
      return new e(oe.keyIdMissing.code, oe.keyIdMissing.desc);
    }, e;
  }(Ie)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var ce = (
  /** @class */
  function() {
    function t() {
    }
    return t.decodeAuthToken = function(e) {
      if (t.isEmpty(e))
        throw ge.createTokenNullOrEmptyError(e);
      var n = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/, r = n.exec(e);
      if (!r || r.length < 4)
        throw ge.createTokenParsingError("Given token is malformed: " + JSON.stringify(e));
      var i = {
        header: r[1],
        JWSPayload: r[2],
        JWSSig: r[3]
      };
      return i;
    }, t.isEmpty = function(e) {
      return typeof e > "u" || !e || e.length === 0;
    }, t.isEmptyObj = function(e) {
      if (e && !t.isEmpty(e))
        try {
          var n = JSON.parse(e);
          return Object.keys(n).length === 0;
        } catch {
        }
      return !0;
    }, t.startsWith = function(e, n) {
      return e.indexOf(n) === 0;
    }, t.endsWith = function(e, n) {
      return e.length >= n.length && e.lastIndexOf(n) === e.length - n.length;
    }, t.queryStringToObject = function(e) {
      var n = {}, r = e.split("&"), i = function(o) {
        return decodeURIComponent(o.replace(/\+/g, " "));
      };
      return r.forEach(function(o) {
        if (o.trim()) {
          var a = o.split(/=(.+)/g, 2), s = a[0], c = a[1];
          s && c && (n[i(s)] = i(c));
        }
      }), n;
    }, t.trimArrayEntries = function(e) {
      return e.map(function(n) {
        return n.trim();
      });
    }, t.removeEmptyStringsFromArray = function(e) {
      return e.filter(function(n) {
        return !t.isEmpty(n);
      });
    }, t.jsonParseHelper = function(e) {
      try {
        return JSON.parse(e);
      } catch {
        return null;
      }
    }, t.matchPattern = function(e, n) {
      var r = new RegExp(e.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?"));
      return r.test(n);
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var sn;
(function(t) {
  t[t.Error = 0] = "Error", t[t.Warning = 1] = "Warning", t[t.Info = 2] = "Info", t[t.Verbose = 3] = "Verbose", t[t.Trace = 4] = "Trace";
})(sn || (sn = {}));
var Mw = (
  /** @class */
  function() {
    function t(e, n, r) {
      this.level = sn.Info;
      var i = function() {
      };
      this.localCallback = e.loggerCallback || i, this.piiLoggingEnabled = e.piiLoggingEnabled || !1, this.level = typeof e.logLevel == "number" ? e.logLevel : sn.Info, this.correlationId = e.correlationId || M.EMPTY_STRING, this.packageName = n || M.EMPTY_STRING, this.packageVersion = r || M.EMPTY_STRING;
    }
    return t.prototype.clone = function(e, n, r) {
      return new t({ loggerCallback: this.localCallback, piiLoggingEnabled: this.piiLoggingEnabled, logLevel: this.level, correlationId: r || this.correlationId }, e, n);
    }, t.prototype.logMessage = function(e, n) {
      if (!(n.logLevel > this.level || !this.piiLoggingEnabled && n.containsPii)) {
        var r = (/* @__PURE__ */ new Date()).toUTCString(), i;
        ce.isEmpty(n.correlationId) ? ce.isEmpty(this.correlationId) ? i = "[" + r + "]" : i = "[" + r + "] : [" + this.correlationId + "]" : i = "[" + r + "] : [" + n.correlationId + "]";
        var o = i + " : " + this.packageName + "@" + this.packageVersion + " : " + sn[n.logLevel] + " - " + e;
        this.executeCallback(n.logLevel, o, n.containsPii || !1);
      }
    }, t.prototype.executeCallback = function(e, n, r) {
      this.localCallback && this.localCallback(e, n, r);
    }, t.prototype.error = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Error,
        containsPii: !1,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.errorPii = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Error,
        containsPii: !0,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.warning = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Warning,
        containsPii: !1,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.warningPii = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Warning,
        containsPii: !0,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.info = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Info,
        containsPii: !1,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.infoPii = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Info,
        containsPii: !0,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.verbose = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Verbose,
        containsPii: !1,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.verbosePii = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Verbose,
        containsPii: !0,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.trace = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Trace,
        containsPii: !1,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.tracePii = function(e, n) {
      this.logMessage(e, {
        logLevel: sn.Trace,
        containsPii: !0,
        correlationId: n || M.EMPTY_STRING
      });
    }, t.prototype.isPiiLoggingEnabled = function() {
      return this.piiLoggingEnabled || !1;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var cI = "@azure/msal-common", Pw = "7.6.0";
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Hs;
(function(t) {
  t[t.None = 0] = "None", t.AzurePublic = "https://login.microsoftonline.com", t.AzurePpe = "https://login.windows-ppe.net", t.AzureChina = "https://login.chinacloudapi.cn", t.AzureGermany = "https://login.microsoftonline.de", t.AzureUsGovernment = "https://login.microsoftonline.us";
})(Hs || (Hs = {}));
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Bs = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.generateAccountId = function() {
      return t.generateAccountIdForCacheKey(this.homeAccountId, this.environment);
    }, t.prototype.generateCredentialId = function() {
      return t.generateCredentialIdForCacheKey(this.credentialType, this.clientId, this.realm, this.familyId);
    }, t.prototype.generateTarget = function() {
      return t.generateTargetForCacheKey(this.target);
    }, t.prototype.generateCredentialKey = function() {
      return t.generateCredentialCacheKey(this.homeAccountId, this.environment, this.credentialType, this.clientId, this.realm, this.target, this.familyId, this.tokenType, this.requestedClaimsHash);
    }, t.prototype.generateType = function() {
      switch (this.credentialType) {
        case nt.ID_TOKEN:
          return ri.ID_TOKEN;
        case nt.ACCESS_TOKEN:
        case nt.ACCESS_TOKEN_WITH_AUTH_SCHEME:
          return ri.ACCESS_TOKEN;
        case nt.REFRESH_TOKEN:
          return ri.REFRESH_TOKEN;
        default:
          throw ge.createUnexpectedCredentialTypeError();
      }
    }, t.getCredentialType = function(e) {
      return e.indexOf(nt.ACCESS_TOKEN.toLowerCase()) !== -1 ? e.indexOf(nt.ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) !== -1 ? nt.ACCESS_TOKEN_WITH_AUTH_SCHEME : nt.ACCESS_TOKEN : e.indexOf(nt.ID_TOKEN.toLowerCase()) !== -1 ? nt.ID_TOKEN : e.indexOf(nt.REFRESH_TOKEN.toLowerCase()) !== -1 ? nt.REFRESH_TOKEN : M.NOT_DEFINED;
    }, t.generateCredentialCacheKey = function(e, n, r, i, o, a, s, c, l) {
      var u = [
        this.generateAccountIdForCacheKey(e, n),
        this.generateCredentialIdForCacheKey(r, i, o, s),
        this.generateTargetForCacheKey(a),
        this.generateClaimsHashForCacheKey(l),
        this.generateSchemeForCacheKey(c)
      ];
      return u.join(Xn.CACHE_KEY_SEPARATOR).toLowerCase();
    }, t.generateAccountIdForCacheKey = function(e, n) {
      var r = [e, n];
      return r.join(Xn.CACHE_KEY_SEPARATOR).toLowerCase();
    }, t.generateCredentialIdForCacheKey = function(e, n, r, i) {
      var o = e === nt.REFRESH_TOKEN && i || n, a = [
        e,
        o,
        r || M.EMPTY_STRING
      ];
      return a.join(Xn.CACHE_KEY_SEPARATOR).toLowerCase();
    }, t.generateTargetForCacheKey = function(e) {
      return (e || M.EMPTY_STRING).toLowerCase();
    }, t.generateClaimsHashForCacheKey = function(e) {
      return (e || M.EMPTY_STRING).toLowerCase();
    }, t.generateSchemeForCacheKey = function(e) {
      return e && e.toLowerCase() !== St.BEARER.toLowerCase() ? e.toLowerCase() : M.EMPTY_STRING;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var ze = {
  redirectUriNotSet: {
    code: "redirect_uri_empty",
    desc: "A redirect URI is required for all calls, and none has been set."
  },
  postLogoutUriNotSet: {
    code: "post_logout_uri_empty",
    desc: "A post logout redirect has not been set."
  },
  claimsRequestParsingError: {
    code: "claims_request_parsing_error",
    desc: "Could not parse the given claims request object."
  },
  authorityUriInsecure: {
    code: "authority_uri_insecure",
    desc: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options"
  },
  urlParseError: {
    code: "url_parse_error",
    desc: "URL could not be parsed into appropriate segments."
  },
  urlEmptyError: {
    code: "empty_url_error",
    desc: "URL was empty or null."
  },
  emptyScopesError: {
    code: "empty_input_scopes_error",
    desc: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token."
  },
  nonArrayScopesError: {
    code: "nonarray_input_scopes_error",
    desc: "Scopes cannot be passed as non-array."
  },
  clientIdSingleScopeError: {
    code: "clientid_input_scopes_error",
    desc: "Client ID can only be provided as a single scope."
  },
  invalidPrompt: {
    code: "invalid_prompt_value",
    desc: "Supported prompt values are 'login', 'select_account', 'consent', 'create', 'none' and 'no_session'.  Please see here for valid configuration options: https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_common.html#commonauthorizationurlrequest"
  },
  invalidClaimsRequest: {
    code: "invalid_claims",
    desc: "Given claims parameter must be a stringified JSON object."
  },
  tokenRequestEmptyError: {
    code: "token_request_empty",
    desc: "Token request was empty and not found in cache."
  },
  logoutRequestEmptyError: {
    code: "logout_request_empty",
    desc: "The logout request was null or undefined."
  },
  invalidCodeChallengeMethod: {
    code: "invalid_code_challenge_method",
    desc: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".'
  },
  invalidCodeChallengeParams: {
    code: "pkce_params_missing",
    desc: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request"
  },
  invalidCloudDiscoveryMetadata: {
    code: "invalid_cloud_discovery_metadata",
    desc: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields"
  },
  invalidAuthorityMetadata: {
    code: "invalid_authority_metadata",
    desc: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields."
  },
  untrustedAuthority: {
    code: "untrusted_authority",
    desc: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter."
  },
  invalidAzureCloudInstance: {
    code: "invalid_azure_cloud_instance",
    desc: "Invalid AzureCloudInstance provided. Please refer MSAL JS docs: aks.ms/msaljs/azure_cloud_instance for valid values"
  },
  missingSshJwk: {
    code: "missing_ssh_jwk",
    desc: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme."
  },
  missingSshKid: {
    code: "missing_ssh_kid",
    desc: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme."
  },
  missingNonceAuthenticationHeader: {
    code: "missing_nonce_authentication_header",
    desc: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce."
  },
  invalidAuthenticationHeader: {
    code: "invalid_authentication_header",
    desc: "Invalid authentication header provided"
  }
}, zt = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n, r) {
      var i = t.call(this, n, r) || this;
      return i.name = "ClientConfigurationError", Object.setPrototypeOf(i, e.prototype), i;
    }
    return e.createRedirectUriEmptyError = function() {
      return new e(ze.redirectUriNotSet.code, ze.redirectUriNotSet.desc);
    }, e.createPostLogoutRedirectUriEmptyError = function() {
      return new e(ze.postLogoutUriNotSet.code, ze.postLogoutUriNotSet.desc);
    }, e.createClaimsRequestParsingError = function(n) {
      return new e(ze.claimsRequestParsingError.code, ze.claimsRequestParsingError.desc + " Given value: " + n);
    }, e.createInsecureAuthorityUriError = function(n) {
      return new e(ze.authorityUriInsecure.code, ze.authorityUriInsecure.desc + " Given URI: " + n);
    }, e.createUrlParseError = function(n) {
      return new e(ze.urlParseError.code, ze.urlParseError.desc + " Given Error: " + n);
    }, e.createUrlEmptyError = function() {
      return new e(ze.urlEmptyError.code, ze.urlEmptyError.desc);
    }, e.createEmptyScopesArrayError = function() {
      return new e(ze.emptyScopesError.code, "" + ze.emptyScopesError.desc);
    }, e.createClientIdSingleScopeError = function(n) {
      return new e(ze.clientIdSingleScopeError.code, ze.clientIdSingleScopeError.desc + " Given Scopes: " + n);
    }, e.createInvalidPromptError = function(n) {
      return new e(ze.invalidPrompt.code, ze.invalidPrompt.desc + " Given value: " + n);
    }, e.createInvalidClaimsRequestError = function() {
      return new e(ze.invalidClaimsRequest.code, ze.invalidClaimsRequest.desc);
    }, e.createEmptyLogoutRequestError = function() {
      return new e(ze.logoutRequestEmptyError.code, ze.logoutRequestEmptyError.desc);
    }, e.createEmptyTokenRequestError = function() {
      return new e(ze.tokenRequestEmptyError.code, ze.tokenRequestEmptyError.desc);
    }, e.createInvalidCodeChallengeMethodError = function() {
      return new e(ze.invalidCodeChallengeMethod.code, ze.invalidCodeChallengeMethod.desc);
    }, e.createInvalidCodeChallengeParamsError = function() {
      return new e(ze.invalidCodeChallengeParams.code, ze.invalidCodeChallengeParams.desc);
    }, e.createInvalidCloudDiscoveryMetadataError = function() {
      return new e(ze.invalidCloudDiscoveryMetadata.code, ze.invalidCloudDiscoveryMetadata.desc);
    }, e.createInvalidAuthorityMetadataError = function() {
      return new e(ze.invalidAuthorityMetadata.code, ze.invalidAuthorityMetadata.desc);
    }, e.createUntrustedAuthorityError = function() {
      return new e(ze.untrustedAuthority.code, ze.untrustedAuthority.desc);
    }, e.createInvalidAzureCloudInstanceError = function() {
      return new e(ze.invalidAzureCloudInstance.code, ze.invalidAzureCloudInstance.desc);
    }, e.createMissingSshJwkError = function() {
      return new e(ze.missingSshJwk.code, ze.missingSshJwk.desc);
    }, e.createMissingSshKidError = function() {
      return new e(ze.missingSshKid.code, ze.missingSshKid.desc);
    }, e.createMissingNonceAuthenticationHeadersError = function() {
      return new e(ze.missingNonceAuthenticationHeader.code, ze.missingNonceAuthenticationHeader.desc);
    }, e.createInvalidAuthenticationHeaderError = function(n, r) {
      return new e(ze.invalidAuthenticationHeader.code, ze.invalidAuthenticationHeader.desc + ". Invalid header: " + n + ". Details: " + r);
    }, e;
  }(ge)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Bn = (
  /** @class */
  function() {
    function t(e) {
      var n = this, r = e ? ce.trimArrayEntries(Nu(e)) : [], i = r ? ce.removeEmptyStringsFromArray(r) : [];
      this.validateInputScopes(i), this.scopes = /* @__PURE__ */ new Set(), i.forEach(function(o) {
        return n.scopes.add(o);
      });
    }
    return t.fromString = function(e) {
      var n = e || M.EMPTY_STRING, r = n.split(" ");
      return new t(r);
    }, t.prototype.validateInputScopes = function(e) {
      if (!e || e.length < 1)
        throw zt.createEmptyScopesArrayError();
    }, t.prototype.containsScope = function(e) {
      var n = this.printScopesLowerCase().split(" "), r = new t(n);
      return ce.isEmpty(e) ? !1 : r.scopes.has(e.toLowerCase());
    }, t.prototype.containsScopeSet = function(e) {
      var n = this;
      return !e || e.scopes.size <= 0 ? !1 : this.scopes.size >= e.scopes.size && e.asArray().every(function(r) {
        return n.containsScope(r);
      });
    }, t.prototype.containsOnlyOIDCScopes = function() {
      var e = this, n = 0;
      return jm.forEach(function(r) {
        e.containsScope(r) && (n += 1);
      }), this.scopes.size === n;
    }, t.prototype.appendScope = function(e) {
      ce.isEmpty(e) || this.scopes.add(e.trim());
    }, t.prototype.appendScopes = function(e) {
      var n = this;
      try {
        e.forEach(function(r) {
          return n.appendScope(r);
        });
      } catch (r) {
        throw ge.createAppendScopeSetError(r);
      }
    }, t.prototype.removeScope = function(e) {
      if (ce.isEmpty(e))
        throw ge.createRemoveEmptyScopeFromSetError(e);
      this.scopes.delete(e.trim());
    }, t.prototype.removeOIDCScopes = function() {
      var e = this;
      jm.forEach(function(n) {
        e.scopes.delete(n);
      });
    }, t.prototype.unionScopeSets = function(e) {
      if (!e)
        throw ge.createEmptyInputScopeSetError();
      var n = /* @__PURE__ */ new Set();
      return e.scopes.forEach(function(r) {
        return n.add(r.toLowerCase());
      }), this.scopes.forEach(function(r) {
        return n.add(r.toLowerCase());
      }), n;
    }, t.prototype.intersectingScopeSets = function(e) {
      if (!e)
        throw ge.createEmptyInputScopeSetError();
      e.containsOnlyOIDCScopes() || e.removeOIDCScopes();
      var n = this.unionScopeSets(e), r = e.getScopeCount(), i = this.getScopeCount(), o = n.size;
      return o < i + r;
    }, t.prototype.getScopeCount = function() {
      return this.scopes.size;
    }, t.prototype.asArray = function() {
      var e = [];
      return this.scopes.forEach(function(n) {
        return e.push(n);
      }), e;
    }, t.prototype.printScopes = function() {
      if (this.scopes) {
        var e = this.asArray();
        return e.join(" ");
      }
      return M.EMPTY_STRING;
    }, t.prototype.printScopesLowerCase = function() {
      return this.printScopes().toLowerCase();
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
function Ll(t, e) {
  if (ce.isEmpty(t))
    throw ge.createClientInfoEmptyError();
  try {
    var n = e.base64Decode(t);
    return JSON.parse(n);
  } catch (r) {
    throw ge.createClientInfoDecodingError(r.message);
  }
}
function Zo(t) {
  if (ce.isEmpty(t))
    throw ge.createClientInfoDecodingError("Home account ID was empty.");
  var e = t.split(Xn.CLIENT_INFO_SEPARATOR, 2);
  return {
    uid: e[0],
    utid: e.length < 2 ? M.EMPTY_STRING : e[1]
  };
}
/*! @azure/msal-common v7.6.0 2022-10-10 */
var ur;
(function(t) {
  t[t.Default = 0] = "Default", t[t.Adfs = 1] = "Adfs", t[t.Dsts = 2] = "Dsts";
})(ur || (ur = {}));
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Nn = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.generateAccountId = function() {
      var e = [this.homeAccountId, this.environment];
      return e.join(Xn.CACHE_KEY_SEPARATOR).toLowerCase();
    }, t.prototype.generateAccountKey = function() {
      return t.generateAccountCacheKey({
        homeAccountId: this.homeAccountId,
        environment: this.environment,
        tenantId: this.realm,
        username: this.username,
        localAccountId: this.localAccountId
      });
    }, t.prototype.generateType = function() {
      switch (this.authorityType) {
        case ti.ADFS_ACCOUNT_TYPE:
          return ri.ADFS;
        case ti.MSAV1_ACCOUNT_TYPE:
          return ri.MSA;
        case ti.MSSTS_ACCOUNT_TYPE:
          return ri.MSSTS;
        case ti.GENERIC_ACCOUNT_TYPE:
          return ri.GENERIC;
        default:
          throw ge.createUnexpectedAccountTypeError();
      }
    }, t.prototype.getAccountInfo = function() {
      return {
        homeAccountId: this.homeAccountId,
        environment: this.environment,
        tenantId: this.realm,
        username: this.username,
        localAccountId: this.localAccountId,
        name: this.name,
        idTokenClaims: this.idTokenClaims,
        nativeAccountId: this.nativeAccountId
      };
    }, t.generateAccountCacheKey = function(e) {
      var n = [
        e.homeAccountId,
        e.environment || M.EMPTY_STRING,
        e.tenantId || M.EMPTY_STRING
      ];
      return n.join(Xn.CACHE_KEY_SEPARATOR).toLowerCase();
    }, t.createAccount = function(e, n, r, i, o, a, s, c) {
      var l, u, d, f, h, g, v = new t();
      v.authorityType = ti.MSSTS_ACCOUNT_TYPE, v.clientInfo = e, v.homeAccountId = n, v.nativeAccountId = c;
      var b = s || i && i.getPreferredCache();
      if (!b)
        throw ge.createInvalidCacheEnvironmentError();
      if (v.environment = b, v.realm = ((l = r == null ? void 0 : r.claims) === null || l === void 0 ? void 0 : l.tid) || M.EMPTY_STRING, r) {
        v.idTokenClaims = r.claims, v.localAccountId = ((u = r == null ? void 0 : r.claims) === null || u === void 0 ? void 0 : u.oid) || ((d = r == null ? void 0 : r.claims) === null || d === void 0 ? void 0 : d.sub) || M.EMPTY_STRING;
        var m = (f = r == null ? void 0 : r.claims) === null || f === void 0 ? void 0 : f.preferred_username, y = !((h = r == null ? void 0 : r.claims) === null || h === void 0) && h.emails ? r.claims.emails[0] : null;
        v.username = m || y || M.EMPTY_STRING, v.name = (g = r == null ? void 0 : r.claims) === null || g === void 0 ? void 0 : g.name;
      }
      return v.cloudGraphHostName = o, v.msGraphHost = a, v;
    }, t.createGenericAccount = function(e, n, r, i, o, a) {
      var s, c, l, u, d = new t();
      d.authorityType = r && r.authorityType === ur.Adfs ? ti.ADFS_ACCOUNT_TYPE : ti.GENERIC_ACCOUNT_TYPE, d.homeAccountId = e, d.realm = M.EMPTY_STRING;
      var f = a || r && r.getPreferredCache();
      if (!f)
        throw ge.createInvalidCacheEnvironmentError();
      return n && (d.localAccountId = ((s = n == null ? void 0 : n.claims) === null || s === void 0 ? void 0 : s.oid) || ((c = n == null ? void 0 : n.claims) === null || c === void 0 ? void 0 : c.sub) || M.EMPTY_STRING, d.username = ((l = n == null ? void 0 : n.claims) === null || l === void 0 ? void 0 : l.upn) || M.EMPTY_STRING, d.name = ((u = n == null ? void 0 : n.claims) === null || u === void 0 ? void 0 : u.name) || M.EMPTY_STRING, d.idTokenClaims = n == null ? void 0 : n.claims), d.environment = f, d.cloudGraphHostName = i, d.msGraphHost = o, d;
    }, t.generateHomeAccountId = function(e, n, r, i, o) {
      var a, s = !((a = o == null ? void 0 : o.claims) === null || a === void 0) && a.sub ? o.claims.sub : M.EMPTY_STRING;
      if (n === ur.Adfs || n === ur.Dsts)
        return s;
      if (e)
        try {
          var c = Ll(e, i);
          if (!ce.isEmpty(c.uid) && !ce.isEmpty(c.utid))
            return "" + c.uid + Xn.CLIENT_INFO_SEPARATOR + c.utid;
        } catch {
        }
      return r.verbose("No client info in response"), s;
    }, t.isAccountEntity = function(e) {
      return e ? e.hasOwnProperty("homeAccountId") && e.hasOwnProperty("environment") && e.hasOwnProperty("realm") && e.hasOwnProperty("localAccountId") && e.hasOwnProperty("username") && e.hasOwnProperty("authorityType") : !1;
    }, t.accountInfoIsEqual = function(e, n, r) {
      if (!e || !n)
        return !1;
      var i = !0;
      if (r) {
        var o = e.idTokenClaims || {}, a = n.idTokenClaims || {};
        i = o.iat === a.iat && o.nonce === a.nonce;
      }
      return e.homeAccountId === n.homeAccountId && e.localAccountId === n.localAccountId && e.username === n.username && e.tenantId === n.tenantId && e.environment === n.environment && e.nativeAccountId === n.nativeAccountId && i;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Br = (
  /** @class */
  function() {
    function t(e, n) {
      if (ce.isEmpty(e))
        throw ge.createTokenNullOrEmptyError(e);
      this.rawToken = e, this.claims = t.extractTokenClaims(e, n);
    }
    return t.extractTokenClaims = function(e, n) {
      var r = ce.decodeAuthToken(e);
      try {
        var i = r.JWSPayload, o = n.base64Decode(i);
        return JSON.parse(o);
      } catch (a) {
        throw ge.createTokenParsingError(a);
      }
    }, t.checkMaxAge = function(e, n) {
      var r = 3e5;
      if (n === 0 || Date.now() - r > e + n)
        throw ge.createMaxAgeTranspiredError();
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var _r = (
  /** @class */
  function() {
    function t(e, n) {
      this.clientId = e, this.cryptoImpl = n;
    }
    return t.prototype.getAllAccounts = function() {
      var e = this, n = this.getAccountsFilteredBy(), r = Object.keys(n).map(function(a) {
        return n[a];
      }), i = r.length;
      if (i < 1)
        return [];
      var o = r.map(function(a) {
        var s = t.toObject(new Nn(), a), c = s.getAccountInfo(), l = e.readIdTokenFromCache(e.clientId, c);
        return l && !c.idTokenClaims && (c.idToken = l.secret, c.idTokenClaims = new Br(l.secret, e.cryptoImpl).claims), c;
      });
      return o;
    }, t.prototype.saveCacheRecord = function(e) {
      return je(this, void 0, void 0, function() {
        return Ve(this, function(n) {
          switch (n.label) {
            case 0:
              if (!e)
                throw ge.createNullOrUndefinedCacheRecord();
              return e.account && this.setAccount(e.account), e.idToken && this.setIdTokenCredential(e.idToken), e.accessToken ? [4, this.saveAccessToken(e.accessToken)] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return e.refreshToken && this.setRefreshTokenCredential(e.refreshToken), e.appMetadata && this.setAppMetadata(e.appMetadata), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.saveAccessToken = function(e) {
      return je(this, void 0, void 0, function() {
        var n, r, i, o, a = this;
        return Ve(this, function(s) {
          switch (s.label) {
            case 0:
              return n = this.getCredentialsFilteredBy({
                clientId: e.clientId,
                credentialType: e.credentialType,
                environment: e.environment,
                homeAccountId: e.homeAccountId,
                realm: e.realm,
                tokenType: e.tokenType,
                requestedClaimsHash: e.requestedClaimsHash
              }), r = Bn.fromString(e.target), i = Object.keys(n.accessTokens).map(function(c) {
                return n.accessTokens[c];
              }), i ? (o = [], i.forEach(function(c) {
                var l = Bn.fromString(c.target);
                l.intersectingScopeSets(r) && o.push(a.removeCredential(c));
              }), [4, Promise.all(o)]) : [3, 2];
            case 1:
              s.sent(), s.label = 2;
            case 2:
              return this.setAccessTokenCredential(e), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getAccountsFilteredBy = function(e) {
      return this.getAccountsFilteredByInternal(e ? e.homeAccountId : M.EMPTY_STRING, e ? e.environment : M.EMPTY_STRING, e ? e.realm : M.EMPTY_STRING, e ? e.nativeAccountId : M.EMPTY_STRING);
    }, t.prototype.getAccountsFilteredByInternal = function(e, n, r, i) {
      var o = this, a = this.getKeys(), s = {};
      return a.forEach(function(c) {
        var l = o.getAccount(c);
        l && (e && !o.matchHomeAccountId(l, e) || n && !o.matchEnvironment(l, n) || r && !o.matchRealm(l, r) || i && !o.matchNativeAccountId(l, i) || (s[c] = l));
      }), s;
    }, t.prototype.getCredentialsFilteredBy = function(e) {
      return this.getCredentialsFilteredByInternal(e.homeAccountId, e.environment, e.credentialType, e.clientId, e.familyId, e.realm, e.target, e.userAssertionHash, e.tokenType, e.keyId, e.requestedClaimsHash);
    }, t.prototype.getCredentialsFilteredByInternal = function(e, n, r, i, o, a, s, c, l, u, d) {
      var f = this, h = this.getKeys(), g = {
        idTokens: {},
        accessTokens: {},
        refreshTokens: {}
      };
      return h.forEach(function(v) {
        var b = Bs.getCredentialType(v);
        if (b !== M.NOT_DEFINED) {
          var m = f.getSpecificCredential(v, b);
          if (m && !(c && !f.matchUserAssertionHash(m, c)) && !(typeof e == "string" && !f.matchHomeAccountId(m, e)) && !(n && !f.matchEnvironment(m, n)) && !(a && !f.matchRealm(m, a)) && !(r && !f.matchCredentialType(m, r)) && !(i && !f.matchClientId(m, i)) && !(o && !f.matchFamilyId(m, o)) && !(s && !f.matchTarget(m, s)) && !((d || m.requestedClaimsHash) && m.requestedClaimsHash !== d) && !(r === nt.ACCESS_TOKEN_WITH_AUTH_SCHEME && (l && !f.matchTokenType(m, l) || l === St.SSH && u && !f.matchKeyId(m, u)))) {
            var y = f.updateCredentialCacheKey(v, m);
            switch (b) {
              case nt.ID_TOKEN:
                g.idTokens[y] = m;
                break;
              case nt.ACCESS_TOKEN:
              case nt.ACCESS_TOKEN_WITH_AUTH_SCHEME:
                g.accessTokens[y] = m;
                break;
              case nt.REFRESH_TOKEN:
                g.refreshTokens[y] = m;
                break;
            }
          }
        }
      }), g;
    }, t.prototype.getAppMetadataFilteredBy = function(e) {
      return this.getAppMetadataFilteredByInternal(e.environment, e.clientId);
    }, t.prototype.getAppMetadataFilteredByInternal = function(e, n) {
      var r = this, i = this.getKeys(), o = {};
      return i.forEach(function(a) {
        if (r.isAppMetadata(a)) {
          var s = r.getAppMetadata(a);
          s && (e && !r.matchEnvironment(s, e) || n && !r.matchClientId(s, n) || (o[a] = s));
        }
      }), o;
    }, t.prototype.getAuthorityMetadataByAlias = function(e) {
      var n = this, r = this.getAuthorityMetadataKeys(), i = null;
      return r.forEach(function(o) {
        if (!(!n.isAuthorityMetadata(o) || o.indexOf(n.clientId) === -1)) {
          var a = n.getAuthorityMetadata(o);
          a && a.aliases.indexOf(e) !== -1 && (i = a);
        }
      }), i;
    }, t.prototype.removeAllAccounts = function() {
      return je(this, void 0, void 0, function() {
        var e, n, r = this;
        return Ve(this, function(i) {
          switch (i.label) {
            case 0:
              return e = this.getKeys(), n = [], e.forEach(function(o) {
                var a = r.getAccount(o);
                a && n.push(r.removeAccount(o));
              }), [4, Promise.all(n)];
            case 1:
              return i.sent(), [2, !0];
          }
        });
      });
    }, t.prototype.removeAccount = function(e) {
      return je(this, void 0, void 0, function() {
        var n;
        return Ve(this, function(r) {
          switch (r.label) {
            case 0:
              if (n = this.getAccount(e), !n)
                throw ge.createNoAccountFoundError();
              return [4, this.removeAccountContext(n)];
            case 1:
              return [2, r.sent() && this.removeItem(e, po.ACCOUNT)];
          }
        });
      });
    }, t.prototype.removeAccountContext = function(e) {
      return je(this, void 0, void 0, function() {
        var n, r, i, o = this;
        return Ve(this, function(a) {
          switch (a.label) {
            case 0:
              return n = this.getKeys(), r = e.generateAccountId(), i = [], n.forEach(function(s) {
                var c = Bs.getCredentialType(s);
                if (c !== M.NOT_DEFINED) {
                  var l = o.getSpecificCredential(s, c);
                  l && r === l.generateAccountId() && i.push(o.removeCredential(l));
                }
              }), [4, Promise.all(i)];
            case 1:
              return a.sent(), [2, !0];
          }
        });
      });
    }, t.prototype.removeCredential = function(e) {
      return je(this, void 0, void 0, function() {
        var n, r, i;
        return Ve(this, function(o) {
          switch (o.label) {
            case 0:
              if (n = e.generateCredentialKey(), e.credentialType.toLowerCase() !== nt.ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase())
                return [3, 4];
              if (e.tokenType !== St.POP)
                return [3, 4];
              if (r = e, i = r.keyId, !i)
                return [3, 4];
              o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.cryptoImpl.removeTokenBindingKey(i)];
            case 2:
              return o.sent(), [3, 4];
            case 3:
              throw o.sent(), ge.createBindingKeyNotRemovedError();
            case 4:
              return [2, this.removeItem(n, po.CREDENTIAL)];
          }
        });
      });
    }, t.prototype.removeAppMetadata = function() {
      var e = this, n = this.getKeys();
      return n.forEach(function(r) {
        e.isAppMetadata(r) && e.removeItem(r, po.APP_METADATA);
      }), !0;
    }, t.prototype.readCacheRecord = function(e, n, r, i) {
      var o = this.readAccountFromCache(e), a = this.readIdTokenFromCache(n, e), s = this.readAccessTokenFromCache(n, e, r), c = this.readRefreshTokenFromCache(n, e, !1), l = this.readAppMetadataFromCache(i, n);
      return o && a && (o.idTokenClaims = new Br(a.secret, this.cryptoImpl).claims), {
        account: o,
        idToken: a,
        accessToken: s,
        refreshToken: c,
        appMetadata: l
      };
    }, t.prototype.readAccountFromCache = function(e) {
      var n = Nn.generateAccountCacheKey(e);
      return this.getAccount(n);
    }, t.prototype.readAccountFromCacheWithNativeAccountId = function(e) {
      var n = {
        nativeAccountId: e
      }, r = this.getAccountsFilteredBy(n), i = Object.keys(r).map(function(o) {
        return r[o];
      });
      if (i.length < 1)
        return null;
      if (i.length > 1)
        throw ge.createMultipleMatchingAccountsInCacheError();
      return r[0];
    }, t.prototype.readIdTokenFromCache = function(e, n) {
      var r = {
        homeAccountId: n.homeAccountId,
        environment: n.environment,
        credentialType: nt.ID_TOKEN,
        clientId: e,
        realm: n.tenantId
      }, i = this.getCredentialsFilteredBy(r), o = Object.keys(i.idTokens).map(function(s) {
        return i.idTokens[s];
      }), a = o.length;
      if (a < 1)
        return null;
      if (a > 1)
        throw ge.createMultipleMatchingTokensInCacheError();
      return o[0];
    }, t.prototype.readAccessTokenFromCache = function(e, n, r) {
      var i = new Bn(r.scopes || []), o = r.authenticationScheme || St.BEARER, a = o && o.toLowerCase() !== St.BEARER.toLowerCase() ? nt.ACCESS_TOKEN_WITH_AUTH_SCHEME : nt.ACCESS_TOKEN, s = {
        homeAccountId: n.homeAccountId,
        environment: n.environment,
        credentialType: a,
        clientId: e,
        realm: n.tenantId,
        target: i.printScopesLowerCase(),
        tokenType: o,
        keyId: r.sshKid,
        requestedClaimsHash: r.requestedClaimsHash
      }, c = this.getCredentialsFilteredBy(s), l = Object.keys(c.accessTokens).map(function(d) {
        return c.accessTokens[d];
      }), u = l.length;
      if (u < 1)
        return null;
      if (u > 1)
        throw ge.createMultipleMatchingTokensInCacheError();
      return l[0];
    }, t.prototype.readRefreshTokenFromCache = function(e, n, r) {
      var i = r ? Ml : void 0, o = {
        homeAccountId: n.homeAccountId,
        environment: n.environment,
        credentialType: nt.REFRESH_TOKEN,
        clientId: e,
        familyId: i
      }, a = this.getCredentialsFilteredBy(o), s = Object.keys(a.refreshTokens).map(function(l) {
        return a.refreshTokens[l];
      }), c = s.length;
      return c < 1 ? null : s[0];
    }, t.prototype.readAppMetadataFromCache = function(e, n) {
      var r = {
        environment: e,
        clientId: n
      }, i = this.getAppMetadataFilteredBy(r), o = Object.keys(i).map(function(s) {
        return i[s];
      }), a = o.length;
      if (a < 1)
        return null;
      if (a > 1)
        throw ge.createMultipleMatchingAppMetadataInCacheError();
      return o[0];
    }, t.prototype.isAppMetadataFOCI = function(e, n) {
      var r = this.readAppMetadataFromCache(e, n);
      return !!(r && r.familyId === Ml);
    }, t.prototype.matchHomeAccountId = function(e, n) {
      return typeof e.homeAccountId == "string" && n === e.homeAccountId;
    }, t.prototype.matchUserAssertionHash = function(e, n) {
      return !!(e.userAssertionHash && n === e.userAssertionHash);
    }, t.prototype.matchEnvironment = function(e, n) {
      var r = this.getAuthorityMetadataByAlias(n);
      return !!(r && r.aliases.indexOf(e.environment) > -1);
    }, t.prototype.matchCredentialType = function(e, n) {
      return e.credentialType && n.toLowerCase() === e.credentialType.toLowerCase();
    }, t.prototype.matchClientId = function(e, n) {
      return !!(e.clientId && n === e.clientId);
    }, t.prototype.matchFamilyId = function(e, n) {
      return !!(e.familyId && n === e.familyId);
    }, t.prototype.matchRealm = function(e, n) {
      return !!(e.realm && n === e.realm);
    }, t.prototype.matchNativeAccountId = function(e, n) {
      return !!(e.nativeAccountId && n === e.nativeAccountId);
    }, t.prototype.matchTarget = function(e, n) {
      var r = e.credentialType !== nt.ACCESS_TOKEN && e.credentialType !== nt.ACCESS_TOKEN_WITH_AUTH_SCHEME;
      if (r || !e.target)
        return !1;
      var i = Bn.fromString(e.target), o = Bn.fromString(n);
      return o.containsOnlyOIDCScopes() ? o.removeScope(M.OFFLINE_ACCESS_SCOPE) : o.removeOIDCScopes(), i.containsScopeSet(o);
    }, t.prototype.matchTokenType = function(e, n) {
      return !!(e.tokenType && e.tokenType === n);
    }, t.prototype.matchKeyId = function(e, n) {
      return !!(e.keyId && e.keyId === n);
    }, t.prototype.isAppMetadata = function(e) {
      return e.indexOf(Bf) !== -1;
    }, t.prototype.isAuthorityMetadata = function(e) {
      return e.indexOf(ks.CACHE_KEY) !== -1;
    }, t.prototype.generateAuthorityMetadataCacheKey = function(e) {
      return ks.CACHE_KEY + "-" + this.clientId + "-" + e;
    }, t.prototype.getSpecificCredential = function(e, n) {
      switch (n) {
        case nt.ID_TOKEN:
          return this.getIdTokenCredential(e);
        case nt.ACCESS_TOKEN:
        case nt.ACCESS_TOKEN_WITH_AUTH_SCHEME:
          return this.getAccessTokenCredential(e);
        case nt.REFRESH_TOKEN:
          return this.getRefreshTokenCredential(e);
        default:
          return null;
      }
    }, t.toObject = function(e, n) {
      for (var r in n)
        e[r] = n[r];
      return e;
    }, t;
  }()
), lI = (
  /** @class */
  function(t) {
    qn(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.setAccount = function() {
      var n = "Storage interface - setAccount() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getAccount = function() {
      var n = "Storage interface - getAccount() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.setIdTokenCredential = function() {
      var n = "Storage interface - setIdTokenCredential() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getIdTokenCredential = function() {
      var n = "Storage interface - getIdTokenCredential() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.setAccessTokenCredential = function() {
      var n = "Storage interface - setAccessTokenCredential() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getAccessTokenCredential = function() {
      var n = "Storage interface - getAccessTokenCredential() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.setRefreshTokenCredential = function() {
      var n = "Storage interface - setRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getRefreshTokenCredential = function() {
      var n = "Storage interface - getRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.setAppMetadata = function() {
      var n = "Storage interface - setAppMetadata() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getAppMetadata = function() {
      var n = "Storage interface - getAppMetadata() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.setServerTelemetry = function() {
      var n = "Storage interface - setServerTelemetry() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getServerTelemetry = function() {
      var n = "Storage interface - getServerTelemetry() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.setAuthorityMetadata = function() {
      var n = "Storage interface - setAuthorityMetadata() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getAuthorityMetadata = function() {
      var n = "Storage interface - getAuthorityMetadata() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getAuthorityMetadataKeys = function() {
      var n = "Storage interface - getAuthorityMetadataKeys() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.setThrottlingCache = function() {
      var n = "Storage interface - setThrottlingCache() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getThrottlingCache = function() {
      var n = "Storage interface - getThrottlingCache() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.removeItem = function() {
      var n = "Storage interface - removeItem() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.containsKey = function() {
      var n = "Storage interface - containsKey() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.getKeys = function() {
      var n = "Storage interface - getKeys() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e.prototype.clear = function() {
      return je(this, void 0, void 0, function() {
        var n;
        return Ve(this, function(r) {
          throw n = "Storage interface - clear() has not been implemented for the cacheStorage interface.", Ie.createUnexpectedError(n);
        });
      });
    }, e.prototype.updateCredentialCacheKey = function() {
      var n = "Storage interface - updateCredentialCacheKey() has not been implemented for the cacheStorage interface.";
      throw Ie.createUnexpectedError(n);
    }, e;
  }(_r)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var uI = 300, Dw = {
  tokenRenewalOffsetSeconds: uI,
  preventCorsPreflight: !1,
  proxyUrl: M.EMPTY_STRING
}, dI = {
  loggerCallback: function() {
  },
  piiLoggingEnabled: !1,
  logLevel: sn.Info,
  correlationId: M.EMPTY_STRING
}, fI = {
  sendGetRequestAsync: function() {
    return je(this, void 0, void 0, function() {
      var t;
      return Ve(this, function(e) {
        throw t = "Network interface - sendGetRequestAsync() has not been implemented", Ie.createUnexpectedError(t);
      });
    });
  },
  sendPostRequestAsync: function() {
    return je(this, void 0, void 0, function() {
      var t;
      return Ve(this, function(e) {
        throw t = "Network interface - sendPostRequestAsync() has not been implemented", Ie.createUnexpectedError(t);
      });
    });
  }
}, hI = {
  sku: M.SKU,
  version: Pw,
  cpu: M.EMPTY_STRING,
  os: M.EMPTY_STRING
}, pI = {
  clientSecret: M.EMPTY_STRING,
  clientAssertion: void 0
}, gI = {
  azureCloudInstance: Hs.None,
  tenant: "" + M.DEFAULT_COMMON_TENANT
}, mI = {
  application: {
    appName: "",
    appVersion: ""
  }
};
function vI(t) {
  var e = t.authOptions, n = t.systemOptions, r = t.loggerOptions, i = t.storageInterface, o = t.networkInterface, a = t.cryptoInterface, s = t.clientCredentials, c = t.libraryInfo, l = t.telemetry, u = t.serverTelemetryManager, d = t.persistencePlugin, f = t.serializableCache, h = nn(nn({}, dI), r);
  return {
    authOptions: yI(e),
    systemOptions: nn(nn({}, Dw), n),
    loggerOptions: h,
    storageInterface: i || new lI(e.clientId, Dl),
    networkInterface: o || fI,
    cryptoInterface: a || Dl,
    clientCredentials: s || pI,
    libraryInfo: nn(nn({}, hI), c),
    telemetry: nn(nn({}, mI), l),
    serverTelemetryManager: u || null,
    persistencePlugin: d || null,
    serializableCache: f || null
  };
}
function yI(t) {
  return nn({ clientCapabilities: [], azureCloudOptions: gI, skipAuthorityMetadataCache: !1 }, t);
}
/*! @azure/msal-common v7.6.0 2022-10-10 */
var bo = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n, r, i) {
      var o = t.call(this, n, r, i) || this;
      return o.name = "ServerError", Object.setPrototypeOf(o, e.prototype), o;
    }
    return e;
  }(Ie)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Fl = (
  /** @class */
  function() {
    function t() {
    }
    return t.generateThrottlingStorageKey = function(e) {
      return As.THROTTLING_PREFIX + "." + JSON.stringify(e);
    }, t.preProcess = function(e, n) {
      var r, i = t.generateThrottlingStorageKey(n), o = e.getThrottlingCache(i);
      if (o) {
        if (o.throttleTime < Date.now()) {
          e.removeItem(i, po.THROTTLING);
          return;
        }
        throw new bo(((r = o.errorCodes) === null || r === void 0 ? void 0 : r.join(" ")) || M.EMPTY_STRING, o.errorMessage, o.subError);
      }
    }, t.postProcess = function(e, n, r) {
      if (t.checkResponseStatus(r) || t.checkResponseForRetryAfter(r)) {
        var i = {
          throttleTime: t.calculateThrottleTime(parseInt(r.headers[Ir.RETRY_AFTER])),
          error: r.body.error,
          errorCodes: r.body.error_codes,
          errorMessage: r.body.error_description,
          subError: r.body.suberror
        };
        e.setThrottlingCache(t.generateThrottlingStorageKey(n), i);
      }
    }, t.checkResponseStatus = function(e) {
      return e.status === 429 || e.status >= 500 && e.status < 600;
    }, t.checkResponseForRetryAfter = function(e) {
      return e.headers ? e.headers.hasOwnProperty(Ir.RETRY_AFTER) && (e.status < 200 || e.status >= 300) : !1;
    }, t.calculateThrottleTime = function(e) {
      var n = e <= 0 ? 0 : e, r = Date.now() / 1e3;
      return Math.floor(Math.min(r + (n || As.DEFAULT_THROTTLE_TIME_SECONDS), r + As.DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1e3);
    }, t.removeThrottle = function(e, n, r, i) {
      var o = {
        clientId: n,
        authority: r.authority,
        scopes: r.scopes,
        homeAccountIdentifier: i,
        claims: r.claims,
        authenticationScheme: r.authenticationScheme,
        resourceRequestMethod: r.resourceRequestMethod,
        resourceRequestUri: r.resourceRequestUri,
        shrClaims: r.shrClaims,
        sshKid: r.sshKid
      }, a = this.generateThrottlingStorageKey(o);
      return e.removeItem(a, po.THROTTLING);
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var wI = (
  /** @class */
  function() {
    function t(e, n) {
      this.networkClient = e, this.cacheManager = n;
    }
    return t.prototype.sendPostRequest = function(e, n, r) {
      return je(this, void 0, void 0, function() {
        var i, o;
        return Ve(this, function(a) {
          switch (a.label) {
            case 0:
              Fl.preProcess(this.cacheManager, e), a.label = 1;
            case 1:
              return a.trys.push([1, 3, , 4]), [4, this.networkClient.sendPostRequestAsync(n, r)];
            case 2:
              return i = a.sent(), [3, 4];
            case 3:
              throw o = a.sent(), o instanceof Ie ? o : ge.createNetworkError(n, o);
            case 4:
              return Fl.postProcess(this.cacheManager, e, i), [2, i];
          }
        });
      });
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Zn;
(function(t) {
  t.HOME_ACCOUNT_ID = "home_account_id", t.UPN = "UPN";
})(Zn || (Zn = {}));
/*! @azure/msal-common v7.6.0 2022-10-10 */
var xp = (
  /** @class */
  function() {
    function t(e, n) {
      this.config = vI(e), this.logger = new Mw(this.config.loggerOptions, cI, Pw), this.cryptoUtils = this.config.cryptoInterface, this.cacheManager = this.config.storageInterface, this.networkClient = this.config.networkInterface, this.networkManager = new wI(this.networkClient, this.cacheManager), this.serverTelemetryManager = this.config.serverTelemetryManager, this.authority = this.config.authOptions.authority, this.performanceClient = n;
    }
    return t.prototype.createTokenRequestHeaders = function(e) {
      var n = {};
      if (n[Ir.CONTENT_TYPE] = M.URL_FORM_CONTENT_TYPE, !this.config.systemOptions.preventCorsPreflight && e)
        switch (e.type) {
          case Zn.HOME_ACCOUNT_ID:
            try {
              var r = Zo(e.credential);
              n[Ir.CCS_HEADER] = "Oid:" + r.uid + "@" + r.utid;
            } catch (i) {
              this.logger.verbose("Could not parse home account ID for CCS Header: " + i);
            }
            break;
          case Zn.UPN:
            n[Ir.CCS_HEADER] = "UPN: " + e.credential;
            break;
        }
      return n;
    }, t.prototype.executePostToTokenEndpoint = function(e, n, r, i) {
      return je(this, void 0, void 0, function() {
        var o;
        return Ve(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.networkManager.sendPostRequest(i, e, { body: n, headers: r, proxyUrl: this.config.systemOptions.proxyUrl })];
            case 1:
              return o = a.sent(), this.config.serverTelemetryManager && o.status < 500 && o.status !== 429 && this.config.serverTelemetryManager.clearTelemetryCache(), [2, o];
          }
        });
      });
    }, t.prototype.updateAuthority = function(e) {
      if (!e.discoveryComplete())
        throw ge.createEndpointDiscoveryIncompleteError("Updated authority has not completed endpoint discovery.");
      this.authority = e;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var eo = (
  /** @class */
  function() {
    function t() {
    }
    return t.validateRedirectUri = function(e) {
      if (ce.isEmpty(e))
        throw zt.createRedirectUriEmptyError();
    }, t.validatePrompt = function(e) {
      var n = [];
      for (var r in Rn)
        n.push(Rn[r]);
      if (n.indexOf(e) < 0)
        throw zt.createInvalidPromptError(e);
    }, t.validateClaims = function(e) {
      try {
        JSON.parse(e);
      } catch {
        throw zt.createInvalidClaimsRequestError();
      }
    }, t.validateCodeChallengeParams = function(e, n) {
      if (ce.isEmpty(e) || ce.isEmpty(n))
        throw zt.createInvalidCodeChallengeParamsError();
      this.validateCodeChallengeMethod(n);
    }, t.validateCodeChallengeMethod = function(e) {
      if ([
        Vm.PLAIN,
        Vm.S256
      ].indexOf(e) < 0)
        throw zt.createInvalidCodeChallengeMethodError();
    }, t.sanitizeEQParams = function(e, n) {
      return e ? (n.forEach(function(r, i) {
        e[i] && delete e[i];
      }), e) : {};
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Xo = (
  /** @class */
  function() {
    function t() {
      this.parameters = /* @__PURE__ */ new Map();
    }
    return t.prototype.addResponseTypeCode = function() {
      this.parameters.set(Ke.RESPONSE_TYPE, encodeURIComponent(M.CODE_RESPONSE_TYPE));
    }, t.prototype.addResponseTypeForTokenAndIdToken = function() {
      this.parameters.set(Ke.RESPONSE_TYPE, encodeURIComponent(M.TOKEN_RESPONSE_TYPE + " " + M.ID_TOKEN_RESPONSE_TYPE));
    }, t.prototype.addResponseMode = function(e) {
      this.parameters.set(Ke.RESPONSE_MODE, encodeURIComponent(e || Rl.QUERY));
    }, t.prototype.addNativeBroker = function() {
      this.parameters.set(Ke.NATIVE_BROKER, encodeURIComponent("1"));
    }, t.prototype.addScopes = function(e, n) {
      n === void 0 && (n = !0);
      var r = n ? Nu(e || [], lc) : e || [], i = new Bn(r);
      this.parameters.set(Ke.SCOPE, encodeURIComponent(i.printScopes()));
    }, t.prototype.addClientId = function(e) {
      this.parameters.set(Ke.CLIENT_ID, encodeURIComponent(e));
    }, t.prototype.addRedirectUri = function(e) {
      eo.validateRedirectUri(e), this.parameters.set(Ke.REDIRECT_URI, encodeURIComponent(e));
    }, t.prototype.addPostLogoutRedirectUri = function(e) {
      eo.validateRedirectUri(e), this.parameters.set(Ke.POST_LOGOUT_URI, encodeURIComponent(e));
    }, t.prototype.addIdTokenHint = function(e) {
      this.parameters.set(Ke.ID_TOKEN_HINT, encodeURIComponent(e));
    }, t.prototype.addDomainHint = function(e) {
      this.parameters.set(Ts.DOMAIN_HINT, encodeURIComponent(e));
    }, t.prototype.addLoginHint = function(e) {
      this.parameters.set(Ts.LOGIN_HINT, encodeURIComponent(e));
    }, t.prototype.addCcsUpn = function(e) {
      this.parameters.set(Ir.CCS_HEADER, encodeURIComponent("UPN:" + e));
    }, t.prototype.addCcsOid = function(e) {
      this.parameters.set(Ir.CCS_HEADER, encodeURIComponent("Oid:" + e.uid + "@" + e.utid));
    }, t.prototype.addSid = function(e) {
      this.parameters.set(Ts.SID, encodeURIComponent(e));
    }, t.prototype.addClaims = function(e, n) {
      var r = this.addClientCapabilitiesToClaims(e, n);
      eo.validateClaims(r), this.parameters.set(Ke.CLAIMS, encodeURIComponent(r));
    }, t.prototype.addCorrelationId = function(e) {
      this.parameters.set(Ke.CLIENT_REQUEST_ID, encodeURIComponent(e));
    }, t.prototype.addLibraryInfo = function(e) {
      this.parameters.set(Ke.X_CLIENT_SKU, e.sku), this.parameters.set(Ke.X_CLIENT_VER, e.version), e.os && this.parameters.set(Ke.X_CLIENT_OS, e.os), e.cpu && this.parameters.set(Ke.X_CLIENT_CPU, e.cpu);
    }, t.prototype.addApplicationTelemetry = function(e) {
      e != null && e.appName && this.parameters.set(Ke.X_APP_NAME, e.appName), e != null && e.appVersion && this.parameters.set(Ke.X_APP_VER, e.appVersion);
    }, t.prototype.addPrompt = function(e) {
      eo.validatePrompt(e), this.parameters.set("" + Ke.PROMPT, encodeURIComponent(e));
    }, t.prototype.addState = function(e) {
      ce.isEmpty(e) || this.parameters.set(Ke.STATE, encodeURIComponent(e));
    }, t.prototype.addNonce = function(e) {
      this.parameters.set(Ke.NONCE, encodeURIComponent(e));
    }, t.prototype.addCodeChallengeParams = function(e, n) {
      if (eo.validateCodeChallengeParams(e, n), e && n)
        this.parameters.set(Ke.CODE_CHALLENGE, encodeURIComponent(e)), this.parameters.set(Ke.CODE_CHALLENGE_METHOD, encodeURIComponent(n));
      else
        throw zt.createInvalidCodeChallengeParamsError();
    }, t.prototype.addAuthorizationCode = function(e) {
      this.parameters.set(Ke.CODE, encodeURIComponent(e));
    }, t.prototype.addDeviceCode = function(e) {
      this.parameters.set(Ke.DEVICE_CODE, encodeURIComponent(e));
    }, t.prototype.addRefreshToken = function(e) {
      this.parameters.set(Ke.REFRESH_TOKEN, encodeURIComponent(e));
    }, t.prototype.addCodeVerifier = function(e) {
      this.parameters.set(Ke.CODE_VERIFIER, encodeURIComponent(e));
    }, t.prototype.addClientSecret = function(e) {
      this.parameters.set(Ke.CLIENT_SECRET, encodeURIComponent(e));
    }, t.prototype.addClientAssertion = function(e) {
      ce.isEmpty(e) || this.parameters.set(Ke.CLIENT_ASSERTION, encodeURIComponent(e));
    }, t.prototype.addClientAssertionType = function(e) {
      ce.isEmpty(e) || this.parameters.set(Ke.CLIENT_ASSERTION_TYPE, encodeURIComponent(e));
    }, t.prototype.addOboAssertion = function(e) {
      this.parameters.set(Ke.OBO_ASSERTION, encodeURIComponent(e));
    }, t.prototype.addRequestTokenUse = function(e) {
      this.parameters.set(Ke.REQUESTED_TOKEN_USE, encodeURIComponent(e));
    }, t.prototype.addGrantType = function(e) {
      this.parameters.set(Ke.GRANT_TYPE, encodeURIComponent(e));
    }, t.prototype.addClientInfo = function() {
      this.parameters.set(sI, "1");
    }, t.prototype.addExtraQueryParameters = function(e) {
      var n = this;
      eo.sanitizeEQParams(e, this.parameters), Object.keys(e).forEach(function(r) {
        n.parameters.set(r, e[r]);
      });
    }, t.prototype.addClientCapabilitiesToClaims = function(e, n) {
      var r;
      if (!e)
        r = {};
      else
        try {
          r = JSON.parse(e);
        } catch {
          throw zt.createInvalidClaimsRequestError();
        }
      return n && n.length > 0 && (r.hasOwnProperty(Qo.ACCESS_TOKEN) || (r[Qo.ACCESS_TOKEN] = {}), r[Qo.ACCESS_TOKEN][Qo.XMS_CC] = {
        values: n
      }), JSON.stringify(r);
    }, t.prototype.addUsername = function(e) {
      this.parameters.set(Pl.username, encodeURIComponent(e));
    }, t.prototype.addPassword = function(e) {
      this.parameters.set(Pl.password, encodeURIComponent(e));
    }, t.prototype.addPopToken = function(e) {
      ce.isEmpty(e) || (this.parameters.set(Ke.TOKEN_TYPE, St.POP), this.parameters.set(Ke.REQ_CNF, encodeURIComponent(e)));
    }, t.prototype.addSshJwk = function(e) {
      ce.isEmpty(e) || (this.parameters.set(Ke.TOKEN_TYPE, St.SSH), this.parameters.set(Ke.REQ_CNF, encodeURIComponent(e)));
    }, t.prototype.addServerTelemetry = function(e) {
      this.parameters.set(Ke.X_CLIENT_CURR_TELEM, e.generateCurrentRequestHeaderValue()), this.parameters.set(Ke.X_CLIENT_LAST_TELEM, e.generateLastRequestHeaderValue());
    }, t.prototype.addThrottling = function() {
      this.parameters.set(Ke.X_MS_LIB_CAPABILITY, As.X_MS_LIB_CAPABILITY_VALUE);
    }, t.prototype.addLogoutHint = function(e) {
      this.parameters.set(Ke.LOGOUT_HINT, encodeURIComponent(e));
    }, t.prototype.createQueryString = function() {
      var e = new Array();
      return this.parameters.forEach(function(n, r) {
        e.push(r + "=" + n);
      }), e.join("&");
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var js = (
  /** @class */
  function(t) {
    qn(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.createIdTokenEntity = function(n, r, i, o, a) {
      var s = new e();
      return s.credentialType = nt.ID_TOKEN, s.homeAccountId = n, s.environment = r, s.clientId = o, s.secret = i, s.realm = a, s;
    }, e.isIdTokenEntity = function(n) {
      return n ? n.hasOwnProperty("homeAccountId") && n.hasOwnProperty("environment") && n.hasOwnProperty("credentialType") && n.hasOwnProperty("realm") && n.hasOwnProperty("clientId") && n.hasOwnProperty("secret") && n.credentialType === nt.ID_TOKEN : !1;
    }, e;
  }(Bs)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var fr = (
  /** @class */
  function() {
    function t() {
    }
    return t.nowSeconds = function() {
      return Math.round((/* @__PURE__ */ new Date()).getTime() / 1e3);
    }, t.isTokenExpired = function(e, n) {
      var r = Number(e) || 0, i = t.nowSeconds() + n;
      return i > r;
    }, t.wasClockTurnedBack = function(e) {
      var n = Number(e);
      return n > t.nowSeconds();
    }, t.delay = function(e, n) {
      return new Promise(function(r) {
        return setTimeout(function() {
          return r(n);
        }, e);
      });
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Vs = (
  /** @class */
  function(t) {
    qn(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.createAccessTokenEntity = function(n, r, i, o, a, s, c, l, u, d, f, h, g, v, b) {
      var m, y, p = new e();
      p.homeAccountId = n, p.credentialType = nt.ACCESS_TOKEN, p.secret = i;
      var w = fr.nowSeconds();
      if (p.cachedAt = w.toString(), p.expiresOn = c.toString(), p.extendedExpiresOn = l.toString(), d && (p.refreshOn = d.toString()), p.environment = r, p.clientId = o, p.realm = a, p.target = s, p.userAssertionHash = h, p.tokenType = ce.isEmpty(f) ? St.BEARER : f, v && (p.requestedClaims = v, p.requestedClaimsHash = b), ((m = p.tokenType) === null || m === void 0 ? void 0 : m.toLowerCase()) !== St.BEARER.toLowerCase())
        switch (p.credentialType = nt.ACCESS_TOKEN_WITH_AUTH_SCHEME, p.tokenType) {
          case St.POP:
            var _ = Br.extractTokenClaims(i, u);
            if (!(!((y = _ == null ? void 0 : _.cnf) === null || y === void 0) && y.kid))
              throw ge.createTokenClaimsRequiredError();
            p.keyId = _.cnf.kid;
            break;
          case St.SSH:
            p.keyId = g;
        }
      return p;
    }, e.isAccessTokenEntity = function(n) {
      return n ? n.hasOwnProperty("homeAccountId") && n.hasOwnProperty("environment") && n.hasOwnProperty("credentialType") && n.hasOwnProperty("realm") && n.hasOwnProperty("clientId") && n.hasOwnProperty("secret") && n.hasOwnProperty("target") && (n.credentialType === nt.ACCESS_TOKEN || n.credentialType === nt.ACCESS_TOKEN_WITH_AUTH_SCHEME) : !1;
    }, e;
  }(Bs)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Vf = (
  /** @class */
  function(t) {
    qn(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.createRefreshTokenEntity = function(n, r, i, o, a, s) {
      var c = new e();
      return c.clientId = o, c.credentialType = nt.REFRESH_TOKEN, c.environment = r, c.homeAccountId = n, c.secret = i, c.userAssertionHash = s, a && (c.familyId = a), c;
    }, e.isRefreshTokenEntity = function(n) {
      return n ? n.hasOwnProperty("homeAccountId") && n.hasOwnProperty("environment") && n.hasOwnProperty("credentialType") && n.hasOwnProperty("clientId") && n.hasOwnProperty("secret") && n.credentialType === nt.REFRESH_TOKEN : !1;
    }, e;
  }(Bs)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var qm = [
  "interaction_required",
  "consent_required",
  "login_required"
], bI = [
  "message_only",
  "additional_action",
  "basic_action",
  "user_password_expired",
  "consent_required"
], ms = {
  noTokensFoundError: {
    code: "no_tokens_found",
    desc: "No refresh token found in the cache. Please sign-in."
  },
  native_account_unavailable: {
    code: "native_account_unavailable",
    desc: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API."
  }
}, Cr = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n, r, i) {
      var o = t.call(this, n, r, i) || this;
      return o.name = "InteractionRequiredAuthError", Object.setPrototypeOf(o, e.prototype), o;
    }
    return e.isInteractionRequiredError = function(n, r, i) {
      var o = !!n && qm.indexOf(n) > -1, a = !!i && bI.indexOf(i) > -1, s = !!r && qm.some(function(c) {
        return r.indexOf(c) > -1;
      });
      return o || s || a;
    }, e.createNoTokensFoundError = function() {
      return new e(ms.noTokensFoundError.code, ms.noTokensFoundError.desc);
    }, e.createNativeAccountUnavailableError = function() {
      return new e(ms.native_account_unavailable.code, ms.native_account_unavailable.desc);
    }, e;
  }(Ie)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var _I = (
  /** @class */
  function() {
    function t(e, n, r, i, o) {
      this.account = e || null, this.idToken = n || null, this.accessToken = r || null, this.refreshToken = i || null, this.appMetadata = o || null;
    }
    return t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var ci = (
  /** @class */
  function() {
    function t() {
    }
    return t.setRequestState = function(e, n, r) {
      var i = t.generateLibraryState(e, r);
      return ce.isEmpty(n) ? i : "" + i + M.RESOURCE_DELIM + n;
    }, t.generateLibraryState = function(e, n) {
      if (!e)
        throw ge.createNoCryptoObjectError("generateLibraryState");
      var r = {
        id: e.createNewGuid()
      };
      n && (r.meta = n);
      var i = JSON.stringify(r);
      return e.base64Encode(i);
    }, t.parseRequestState = function(e, n) {
      if (!e)
        throw ge.createNoCryptoObjectError("parseRequestState");
      if (ce.isEmpty(n))
        throw ge.createInvalidStateError(n, "Null, undefined or empty state");
      try {
        var r = n.split(M.RESOURCE_DELIM), i = r[0], o = r.length > 1 ? r.slice(1).join(M.RESOURCE_DELIM) : M.EMPTY_STRING, a = e.base64Decode(i), s = JSON.parse(a);
        return {
          userRequestState: ce.isEmpty(o) ? M.EMPTY_STRING : o,
          libraryState: s
        };
      } catch (c) {
        throw ge.createInvalidStateError(n, c);
      }
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var mt = (
  /** @class */
  function() {
    function t(e) {
      if (this._urlString = e, ce.isEmpty(this._urlString))
        throw zt.createUrlEmptyError();
      ce.isEmpty(this.getHash()) && (this._urlString = t.canonicalizeUri(e));
    }
    return Object.defineProperty(t.prototype, "urlString", {
      get: function() {
        return this._urlString;
      },
      enumerable: !1,
      configurable: !0
    }), t.canonicalizeUri = function(e) {
      if (e) {
        var n = e.toLowerCase();
        return ce.endsWith(n, "?") ? n = n.slice(0, -1) : ce.endsWith(n, "?/") && (n = n.slice(0, -2)), ce.endsWith(n, "/") || (n += "/"), n;
      }
      return e;
    }, t.prototype.validateAsUri = function() {
      var e;
      try {
        e = this.getUrlComponents();
      } catch (n) {
        throw zt.createUrlParseError(n);
      }
      if (!e.HostNameAndPort || !e.PathSegments)
        throw zt.createUrlParseError("Given url string: " + this.urlString);
      if (!e.Protocol || e.Protocol.toLowerCase() !== "https:")
        throw zt.createInsecureAuthorityUriError(this.urlString);
    }, t.appendQueryString = function(e, n) {
      return ce.isEmpty(n) ? e : e.indexOf("?") < 0 ? e + "?" + n : e + "&" + n;
    }, t.removeHashFromUrl = function(e) {
      return t.canonicalizeUri(e.split("#")[0]);
    }, t.prototype.replaceTenantPath = function(e) {
      var n = this.getUrlComponents(), r = n.PathSegments;
      return e && r.length !== 0 && (r[0] === xl.COMMON || r[0] === xl.ORGANIZATIONS) && (r[0] = e), t.constructAuthorityUriFromObject(n);
    }, t.prototype.getHash = function() {
      return t.parseHash(this.urlString);
    }, t.prototype.getUrlComponents = function() {
      var e = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?"), n = this.urlString.match(e);
      if (!n)
        throw zt.createUrlParseError("Given url string: " + this.urlString);
      var r = {
        Protocol: n[1],
        HostNameAndPort: n[4],
        AbsolutePath: n[5],
        QueryString: n[7]
      }, i = r.AbsolutePath.split("/");
      return i = i.filter(function(o) {
        return o && o.length > 0;
      }), r.PathSegments = i, !ce.isEmpty(r.QueryString) && r.QueryString.endsWith("/") && (r.QueryString = r.QueryString.substring(0, r.QueryString.length - 1)), r;
    }, t.getDomainFromUrl = function(e) {
      var n = RegExp("^([^:/?#]+://)?([^/?#]*)"), r = e.match(n);
      if (!r)
        throw zt.createUrlParseError("Given url string: " + e);
      return r[2];
    }, t.getAbsoluteUrl = function(e, n) {
      if (e[0] === M.FORWARD_SLASH) {
        var r = new t(n), i = r.getUrlComponents();
        return i.Protocol + "//" + i.HostNameAndPort + e;
      }
      return e;
    }, t.parseHash = function(e) {
      var n = e.indexOf("#"), r = e.indexOf("#/");
      return r > -1 ? e.substring(r + 2) : n > -1 ? e.substring(n + 1) : M.EMPTY_STRING;
    }, t.parseQueryString = function(e) {
      var n = e.indexOf("?"), r = e.indexOf("/?");
      return r > -1 ? e.substring(r + 2) : n > -1 ? e.substring(n + 1) : M.EMPTY_STRING;
    }, t.constructAuthorityUriFromObject = function(e) {
      return new t(e.Protocol + "//" + e.HostNameAndPort + "/" + e.PathSegments.join("/"));
    }, t.getDeserializedHash = function(e) {
      if (ce.isEmpty(e))
        return {};
      var n = t.parseHash(e), r = ce.queryStringToObject(ce.isEmpty(n) ? e : n);
      if (!r)
        throw ge.createHashNotDeserializedError(JSON.stringify(r));
      return r;
    }, t.getDeserializedQueryString = function(e) {
      if (ce.isEmpty(e))
        return {};
      var n = t.parseQueryString(e), r = ce.queryStringToObject(ce.isEmpty(n) ? e : n);
      if (!r)
        throw ge.createHashNotDeserializedError(JSON.stringify(r));
      return r;
    }, t.hashContainsKnownProperties = function(e) {
      if (ce.isEmpty(e) || e.indexOf("=") < 0)
        return !1;
      var n = t.getDeserializedHash(e);
      return !!(n.code || n.error_description || n.error || n.state);
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var $f;
(function(t) {
  t.SW = "sw", t.UHW = "uhw";
})($f || ($f = {}));
var wa = (
  /** @class */
  function() {
    function t(e) {
      this.cryptoUtils = e;
    }
    return t.prototype.generateCnf = function(e) {
      return je(this, void 0, void 0, function() {
        var n, r, i;
        return Ve(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, this.generateKid(e)];
            case 1:
              return n = o.sent(), r = this.cryptoUtils.base64Encode(JSON.stringify(n)), i = {
                kid: n.kid,
                reqCnfString: r
              }, [4, this.cryptoUtils.hashString(r)];
            case 2:
              return [2, (i.reqCnfHash = o.sent(), i)];
          }
        });
      });
    }, t.prototype.generateKid = function(e) {
      return je(this, void 0, void 0, function() {
        var n;
        return Ve(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.cryptoUtils.getPublicKeyThumbprint(e)];
            case 1:
              return n = r.sent(), [2, {
                kid: n,
                xms_ksl: $f.SW
              }];
          }
        });
      });
    }, t.prototype.signPopToken = function(e, n, r) {
      return je(this, void 0, void 0, function() {
        return Ve(this, function(i) {
          return [2, this.signPayload(e, n, r)];
        });
      });
    }, t.prototype.signPayload = function(e, n, r, i) {
      return je(this, void 0, void 0, function() {
        var o, a, s, c, l, u;
        return Ve(this, function(d) {
          switch (d.label) {
            case 0:
              return o = r.resourceRequestMethod, a = r.resourceRequestUri, s = r.shrClaims, c = r.shrNonce, l = a ? new mt(a) : void 0, u = l == null ? void 0 : l.getUrlComponents(), [4, this.cryptoUtils.signJwt(nn({ at: e, ts: fr.nowSeconds(), m: o == null ? void 0 : o.toUpperCase(), u: u == null ? void 0 : u.HostNameAndPort, nonce: c || this.cryptoUtils.createNewGuid(), p: u == null ? void 0 : u.AbsolutePath, q: u != null && u.QueryString ? [[], u.QueryString] : void 0, client_claims: s || void 0 }, i), n, r.correlationId)];
            case 1:
              return [2, d.sent()];
          }
        });
      });
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var qf = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.generateAppMetadataKey = function() {
      return t.generateAppMetadataCacheKey(this.environment, this.clientId);
    }, t.generateAppMetadataCacheKey = function(e, n) {
      var r = [
        Bf,
        e,
        n
      ];
      return r.join(Xn.CACHE_KEY_SEPARATOR).toLowerCase();
    }, t.createAppMetadataEntity = function(e, n, r) {
      var i = new t();
      return i.clientId = e, i.environment = n, r && (i.familyId = r), i;
    }, t.isAppMetadataEntity = function(e, n) {
      return n ? e.indexOf(Bf) === 0 && n.hasOwnProperty("clientId") && n.hasOwnProperty("environment") : !1;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var EI = (
  /** @class */
  function() {
    function t(e, n) {
      this.cache = e, this.hasChanged = n;
    }
    return Object.defineProperty(t.prototype, "cacheHasChanged", {
      /**
       * boolean which indicates the changes in cache
       */
      get: function() {
        return this.hasChanged;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tokenCache", {
      /**
       * function to retrieve the token cache
       */
      get: function() {
        return this.cache;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Ul = (
  /** @class */
  function() {
    function t(e, n, r, i, o, a) {
      this.clientId = e, this.cacheStorage = n, this.cryptoObj = r, this.logger = i, this.serializableCache = o, this.persistencePlugin = a;
    }
    return t.prototype.validateServerAuthorizationCodeResponse = function(e, n, r) {
      if (!e.state || !n)
        throw e.state ? ge.createStateNotFoundError("Cached State") : ge.createStateNotFoundError("Server State");
      if (decodeURIComponent(e.state) !== decodeURIComponent(n))
        throw ge.createStateMismatchError();
      if (e.error || e.error_description || e.suberror)
        throw Cr.isInteractionRequiredError(e.error, e.error_description, e.suberror) ? new Cr(e.error || M.EMPTY_STRING, e.error_description, e.suberror) : new bo(e.error || M.EMPTY_STRING, e.error_description, e.suberror);
      e.client_info && Ll(e.client_info, r);
    }, t.prototype.validateTokenResponse = function(e) {
      if (e.error || e.error_description || e.suberror) {
        if (Cr.isInteractionRequiredError(e.error, e.error_description, e.suberror))
          throw new Cr(e.error, e.error_description, e.suberror);
        var n = e.error_codes + " - [" + e.timestamp + "]: " + e.error_description + " - Correlation ID: " + e.correlation_id + " - Trace ID: " + e.trace_id;
        throw new bo(e.error, n, e.suberror);
      }
    }, t.prototype.handleServerTokenResponse = function(e, n, r, i, o, a, s, c, l) {
      return je(this, void 0, void 0, function() {
        var u, d, f, h, g, v, b;
        return Ve(this, function(m) {
          switch (m.label) {
            case 0:
              if (e.id_token) {
                if (u = new Br(e.id_token || M.EMPTY_STRING, this.cryptoObj), o && !ce.isEmpty(o.nonce) && u.claims.nonce !== o.nonce)
                  throw ge.createNonceMismatchError();
                if (i.maxAge || i.maxAge === 0) {
                  if (d = u.claims.auth_time, !d)
                    throw ge.createAuthTimeNotFoundError();
                  Br.checkMaxAge(d, i.maxAge);
                }
              }
              this.homeAccountIdentifier = Nn.generateHomeAccountId(e.client_info || M.EMPTY_STRING, n.authorityType, this.logger, this.cryptoObj, u), o && o.state && (f = ci.parseRequestState(this.cryptoObj, o.state)), e.key_id = e.key_id || i.sshKid || void 0, h = this.generateCacheRecord(e, n, r, i, u, a, o), m.label = 1;
            case 1:
              return m.trys.push([1, , 5, 8]), this.persistencePlugin && this.serializableCache ? (this.logger.verbose("Persistence enabled, calling beforeCacheAccess"), g = new EI(this.serializableCache, !0), [4, this.persistencePlugin.beforeCacheAccess(g)]) : [3, 3];
            case 2:
              m.sent(), m.label = 3;
            case 3:
              return s && !c && h.account && (v = h.account.generateAccountKey(), b = this.cacheStorage.getAccount(v), !b) ? (this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache"), [2, t.generateAuthenticationResult(this.cryptoObj, n, h, !1, i, u, f, void 0, l)]) : [4, this.cacheStorage.saveCacheRecord(h)];
            case 4:
              return m.sent(), [3, 8];
            case 5:
              return this.persistencePlugin && this.serializableCache && g ? (this.logger.verbose("Persistence enabled, calling afterCacheAccess"), [4, this.persistencePlugin.afterCacheAccess(g)]) : [3, 7];
            case 6:
              m.sent(), m.label = 7;
            case 7:
              return [
                7
                /*endfinally*/
              ];
            case 8:
              return [2, t.generateAuthenticationResult(this.cryptoObj, n, h, !1, i, u, f, e.spa_code, l)];
          }
        });
      });
    }, t.prototype.generateCacheRecord = function(e, n, r, i, o, a, s) {
      var c = n.getPreferredCache();
      if (ce.isEmpty(c))
        throw ge.createInvalidCacheEnvironmentError();
      var l, u;
      !ce.isEmpty(e.id_token) && o && (l = js.createIdTokenEntity(this.homeAccountIdentifier, c, e.id_token || M.EMPTY_STRING, this.clientId, o.claims.tid || M.EMPTY_STRING), u = this.generateAccountEntity(e, o, n, s));
      var d = null;
      if (!ce.isEmpty(e.access_token)) {
        var f = e.scope ? Bn.fromString(e.scope) : new Bn(i.scopes || []), h = (typeof e.expires_in == "string" ? parseInt(e.expires_in, 10) : e.expires_in) || 0, g = (typeof e.ext_expires_in == "string" ? parseInt(e.ext_expires_in, 10) : e.ext_expires_in) || 0, v = (typeof e.refresh_in == "string" ? parseInt(e.refresh_in, 10) : e.refresh_in) || void 0, b = r + h, m = b + g, y = v && v > 0 ? r + v : void 0;
        d = Vs.createAccessTokenEntity(this.homeAccountIdentifier, c, e.access_token || M.EMPTY_STRING, this.clientId, o ? o.claims.tid || M.EMPTY_STRING : n.tenant, f.printScopes(), b, m, this.cryptoObj, y, e.token_type, a, e.key_id, i.claims, i.requestedClaimsHash);
      }
      var p = null;
      ce.isEmpty(e.refresh_token) || (p = Vf.createRefreshTokenEntity(this.homeAccountIdentifier, c, e.refresh_token || M.EMPTY_STRING, this.clientId, e.foci, a));
      var w = null;
      return ce.isEmpty(e.foci) || (w = qf.createAppMetadataEntity(this.clientId, c, e.foci)), new _I(u, l, d, p, w);
    }, t.prototype.generateAccountEntity = function(e, n, r, i) {
      var o = r.authorityType, a = i ? i.cloud_graph_host_name : M.EMPTY_STRING, s = i ? i.msgraph_host : M.EMPTY_STRING;
      if (o === ur.Adfs)
        return this.logger.verbose("Authority type is ADFS, creating ADFS account"), Nn.createGenericAccount(this.homeAccountIdentifier, n, r, a, s);
      if (ce.isEmpty(e.client_info) && r.protocolMode === "AAD")
        throw ge.createClientInfoEmptyError();
      return e.client_info ? Nn.createAccount(e.client_info, this.homeAccountIdentifier, n, r, a, s) : Nn.createGenericAccount(this.homeAccountIdentifier, n, r, a, s);
    }, t.generateAuthenticationResult = function(e, n, r, i, o, a, s, c, l) {
      var u, d, f;
      return je(this, void 0, void 0, function() {
        var h, g, v, b, m, y, p, w, _, E, S;
        return Ve(this, function(T) {
          switch (T.label) {
            case 0:
              if (h = M.EMPTY_STRING, g = [], v = null, m = M.EMPTY_STRING, !r.accessToken)
                return [3, 4];
              if (r.accessToken.tokenType !== St.POP)
                return [3, 2];
              if (y = new wa(e), p = r.accessToken, w = p.secret, _ = p.keyId, !_)
                throw ge.createKeyIdMissingError();
              return [4, y.signPopToken(w, _, o)];
            case 1:
              return h = T.sent(), [3, 3];
            case 2:
              h = r.accessToken.secret, T.label = 3;
            case 3:
              g = Bn.fromString(r.accessToken.target).asArray(), v = new Date(Number(r.accessToken.expiresOn) * 1e3), b = new Date(Number(r.accessToken.extendedExpiresOn) * 1e3), T.label = 4;
            case 4:
              return r.appMetadata && (m = r.appMetadata.familyId === Ml ? Ml : M.EMPTY_STRING), E = (a == null ? void 0 : a.claims.oid) || (a == null ? void 0 : a.claims.sub) || M.EMPTY_STRING, S = (a == null ? void 0 : a.claims.tid) || M.EMPTY_STRING, [2, {
                authority: n.canonicalAuthority,
                uniqueId: E,
                tenantId: S,
                scopes: g,
                account: r.account ? r.account.getAccountInfo() : null,
                idToken: a ? a.rawToken : M.EMPTY_STRING,
                idTokenClaims: a ? a.claims : {},
                accessToken: h,
                fromCache: i,
                expiresOn: v,
                correlationId: o.correlationId,
                requestId: l || M.EMPTY_STRING,
                extExpiresOn: b,
                familyId: m,
                tokenType: ((u = r.accessToken) === null || u === void 0 ? void 0 : u.tokenType) || M.EMPTY_STRING,
                state: s ? s.userRequestState : M.EMPTY_STRING,
                cloudGraphHostName: ((d = r.account) === null || d === void 0 ? void 0 : d.cloudGraphHostName) || M.EMPTY_STRING,
                msGraphHost: ((f = r.account) === null || f === void 0 ? void 0 : f.msGraphHost) || M.EMPTY_STRING,
                code: c,
                fromNativeBroker: !1
              }];
          }
        });
      });
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Lw = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n) {
      var r = t.call(this, n) || this;
      return r.includeRedirectUri = !0, r;
    }
    return e.prototype.getAuthCodeUrl = function(n) {
      return je(this, void 0, void 0, function() {
        var r;
        return Ve(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.createAuthCodeUrlQueryString(n)];
            case 1:
              return r = i.sent(), [2, mt.appendQueryString(this.authority.authorizationEndpoint, r)];
          }
        });
      });
    }, e.prototype.acquireToken = function(n, r) {
      var i;
      return je(this, void 0, void 0, function() {
        var o, a, s, c;
        return Ve(this, function(l) {
          switch (l.label) {
            case 0:
              if (this.logger.info("in acquireToken call"), !n || ce.isEmpty(n.code))
                throw ge.createTokenRequestCannotBeMadeError();
              return o = fr.nowSeconds(), [4, this.executeTokenRequest(this.authority, n)];
            case 1:
              return a = l.sent(), s = (i = a.headers) === null || i === void 0 ? void 0 : i[Ir.X_MS_REQUEST_ID], c = new Ul(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin), c.validateTokenResponse(a.body), [4, c.handleServerTokenResponse(a.body, this.authority, o, n, r, void 0, void 0, void 0, s)];
            case 2:
              return [2, l.sent()];
          }
        });
      });
    }, e.prototype.handleFragmentResponse = function(n, r) {
      var i = new Ul(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null), o = new mt(n), a = mt.getDeserializedHash(o.getHash());
      if (i.validateServerAuthorizationCodeResponse(a, r, this.cryptoUtils), !a.code)
        throw ge.createNoAuthCodeInServerResponseError();
      return nn(nn({}, a), {
        // Code param is optional in ServerAuthorizationCodeResponse but required in AuthorizationCodePaylod
        code: a.code
      });
    }, e.prototype.getLogoutUri = function(n) {
      if (!n)
        throw zt.createEmptyLogoutRequestError();
      var r = this.createLogoutUrlQueryString(n);
      return mt.appendQueryString(this.authority.endSessionEndpoint, r);
    }, e.prototype.executeTokenRequest = function(n, r) {
      return je(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u;
        return Ve(this, function(d) {
          switch (d.label) {
            case 0:
              return i = {
                clientId: this.config.authOptions.clientId,
                authority: n.canonicalAuthority,
                scopes: r.scopes,
                claims: r.claims,
                authenticationScheme: r.authenticationScheme,
                resourceRequestMethod: r.resourceRequestMethod,
                resourceRequestUri: r.resourceRequestUri,
                shrClaims: r.shrClaims,
                sshKid: r.sshKid
              }, [4, this.createTokenRequestBody(r)];
            case 1:
              if (o = d.sent(), a = this.createTokenQueryParameters(r), s = void 0, r.clientInfo)
                try {
                  c = Ll(r.clientInfo, this.cryptoUtils), s = {
                    credential: "" + c.uid + Xn.CLIENT_INFO_SEPARATOR + c.utid,
                    type: Zn.HOME_ACCOUNT_ID
                  };
                } catch (f) {
                  this.logger.verbose("Could not parse client info for CCS Header: " + f);
                }
              return l = this.createTokenRequestHeaders(s || r.ccsCredential), u = ce.isEmpty(a) ? n.tokenEndpoint : n.tokenEndpoint + "?" + a, [2, this.executePostToTokenEndpoint(u, o, l, i)];
          }
        });
      });
    }, e.prototype.createTokenQueryParameters = function(n) {
      var r = new Xo();
      return n.tokenQueryParameters && r.addExtraQueryParameters(n.tokenQueryParameters), r.createQueryString();
    }, e.prototype.createTokenRequestBody = function(n) {
      return je(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l, l, u;
        return Ve(this, function(d) {
          switch (d.label) {
            case 0:
              return r = new Xo(), r.addClientId(this.config.authOptions.clientId), this.includeRedirectUri ? r.addRedirectUri(n.redirectUri) : eo.validateRedirectUri(n.redirectUri), r.addScopes(n.scopes), r.addAuthorizationCode(n.code), r.addLibraryInfo(this.config.libraryInfo), r.addApplicationTelemetry(this.config.telemetry.application), r.addThrottling(), this.serverTelemetryManager && r.addServerTelemetry(this.serverTelemetryManager), n.codeVerifier && r.addCodeVerifier(n.codeVerifier), this.config.clientCredentials.clientSecret && r.addClientSecret(this.config.clientCredentials.clientSecret), this.config.clientCredentials.clientAssertion && (i = this.config.clientCredentials.clientAssertion, r.addClientAssertion(i.assertion), r.addClientAssertionType(i.assertionType)), r.addGrantType(Nl.AUTHORIZATION_CODE_GRANT), r.addClientInfo(), n.authenticationScheme !== St.POP ? [3, 2] : (o = new wa(this.cryptoUtils), [4, o.generateCnf(n)]);
            case 1:
              return a = d.sent(), r.addPopToken(a.reqCnfString), [3, 3];
            case 2:
              if (n.authenticationScheme === St.SSH)
                if (n.sshJwk)
                  r.addSshJwk(n.sshJwk);
                else
                  throw zt.createMissingSshJwkError();
              d.label = 3;
            case 3:
              if (s = n.correlationId || this.config.cryptoInterface.createNewGuid(), r.addCorrelationId(s), (!ce.isEmptyObj(n.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) && r.addClaims(n.claims, this.config.authOptions.clientCapabilities), c = void 0, n.clientInfo)
                try {
                  l = Ll(n.clientInfo, this.cryptoUtils), c = {
                    credential: "" + l.uid + Xn.CLIENT_INFO_SEPARATOR + l.utid,
                    type: Zn.HOME_ACCOUNT_ID
                  };
                } catch (f) {
                  this.logger.verbose("Could not parse client info for CCS Header: " + f);
                }
              else
                c = n.ccsCredential;
              if (this.config.systemOptions.preventCorsPreflight && c)
                switch (c.type) {
                  case Zn.HOME_ACCOUNT_ID:
                    try {
                      l = Zo(c.credential), r.addCcsOid(l);
                    } catch (f) {
                      this.logger.verbose("Could not parse home account ID for CCS Header: " + f);
                    }
                    break;
                  case Zn.UPN:
                    r.addCcsUpn(c.credential);
                    break;
                }
              return n.tokenBodyParameters && r.addExtraQueryParameters(n.tokenBodyParameters), n.enableSpaAuthorizationCode && (!n.tokenBodyParameters || !n.tokenBodyParameters[Ke.RETURN_SPA_CODE]) && r.addExtraQueryParameters((u = {}, u[Ke.RETURN_SPA_CODE] = "1", u)), [2, r.createQueryString()];
          }
        });
      });
    }, e.prototype.createAuthCodeUrlQueryString = function(n) {
      return je(this, void 0, void 0, function() {
        var r, i, o, a, s, c, c, c, l, u;
        return Ve(this, function(d) {
          switch (d.label) {
            case 0:
              if (r = new Xo(), r.addClientId(this.config.authOptions.clientId), i = Nu(n.scopes || [], n.extraScopesToConsent || []), r.addScopes(i), r.addRedirectUri(n.redirectUri), o = n.correlationId || this.config.cryptoInterface.createNewGuid(), r.addCorrelationId(o), r.addResponseMode(n.responseMode), r.addResponseTypeCode(), r.addLibraryInfo(this.config.libraryInfo), r.addApplicationTelemetry(this.config.telemetry.application), r.addClientInfo(), n.codeChallenge && n.codeChallengeMethod && r.addCodeChallengeParams(n.codeChallenge, n.codeChallengeMethod), n.prompt && r.addPrompt(n.prompt), n.domainHint && r.addDomainHint(n.domainHint), n.prompt !== Rn.SELECT_ACCOUNT)
                if (n.sid && n.prompt === Rn.NONE)
                  this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request"), r.addSid(n.sid);
                else if (n.account) {
                  if (a = this.extractAccountSid(n.account), s = this.extractLoginHint(n.account), s) {
                    this.logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account"), r.addLoginHint(s);
                    try {
                      c = Zo(n.account.homeAccountId), r.addCcsOid(c);
                    } catch {
                      this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                  } else if (a && n.prompt === Rn.NONE) {
                    this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account"), r.addSid(a);
                    try {
                      c = Zo(n.account.homeAccountId), r.addCcsOid(c);
                    } catch {
                      this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                  } else if (n.loginHint)
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request"), r.addLoginHint(n.loginHint), r.addCcsUpn(n.loginHint);
                  else if (n.account.username) {
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account"), r.addLoginHint(n.account.username);
                    try {
                      c = Zo(n.account.homeAccountId), r.addCcsOid(c);
                    } catch {
                      this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                  }
                } else
                  n.loginHint && (this.logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request"), r.addLoginHint(n.loginHint), r.addCcsUpn(n.loginHint));
              else
                this.logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
              return n.nonce && r.addNonce(n.nonce), n.state && r.addState(n.state), (!ce.isEmpty(n.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) && r.addClaims(n.claims, this.config.authOptions.clientCapabilities), n.extraQueryParameters && r.addExtraQueryParameters(n.extraQueryParameters), n.nativeBroker ? (r.addNativeBroker(), n.authenticationScheme !== St.POP ? [3, 2] : (l = new wa(this.cryptoUtils), [4, l.generateCnf(n)])) : [3, 2];
            case 1:
              u = d.sent(), r.addPopToken(u.reqCnfHash), d.label = 2;
            case 2:
              return [2, r.createQueryString()];
          }
        });
      });
    }, e.prototype.createLogoutUrlQueryString = function(n) {
      var r = new Xo();
      return n.postLogoutRedirectUri && r.addPostLogoutRedirectUri(n.postLogoutRedirectUri), n.correlationId && r.addCorrelationId(n.correlationId), n.idTokenHint && r.addIdTokenHint(n.idTokenHint), n.state && r.addState(n.state), n.logoutHint && r.addLogoutHint(n.logoutHint), n.extraQueryParameters && r.addExtraQueryParameters(n.extraQueryParameters), r.createQueryString();
    }, e.prototype.extractAccountSid = function(n) {
      var r;
      return ((r = n.idTokenClaims) === null || r === void 0 ? void 0 : r.sid) || null;
    }, e.prototype.extractLoginHint = function(n) {
      var r;
      return ((r = n.idTokenClaims) === null || r === void 0 ? void 0 : r.login_hint) || null;
    }, e;
  }(xp)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var hn;
(function(t) {
  t.AcquireTokenByCode = "acquireTokenByCode", t.AcquireTokenByRefreshToken = "acquireTokenByRefreshToken", t.AcquireTokenSilent = "acquireTokenSilent", t.AcquireTokenSilentAsync = "acquireTokenSilentAsync", t.AcquireTokenPopup = "acquireTokenPopup", t.CryptoOptsGetPublicKeyThumbprint = "cryptoOptsGetPublicKeyThumbprint", t.CryptoOptsSignJwt = "cryptoOptsSignJwt", t.SilentCacheClientAcquireToken = "silentCacheClientAcquireToken", t.SilentIframeClientAcquireToken = "silentIframeClientAcquireToken", t.SilentRefreshClientAcquireToken = "silentRefreshClientAcquireToken", t.SsoSilent = "ssoSilent", t.StandardInteractionClientGetDiscoveredAuthority = "standardInteractionClientGetDiscoveredAuthority", t.FetchAccountIdWithNativeBroker = "fetchAccountIdWithNativeBroker", t.NativeInteractionClientAcquireToken = "nativeInteractionClientAcquireToken", t.BaseClientCreateTokenRequestHeaders = "baseClientCreateTokenRequestHeaders", t.BrokerHandhshake = "brokerHandshake", t.AcquireTokenByRefreshTokenInBroker = "acquireTokenByRefreshTokenInBroker", t.AcquireTokenByBroker = "acquireTokenByBroker", t.RefreshTokenClientExecuteTokenRequest = "refreshTokenClientExecuteTokenRequest", t.RefreshTokenClientAcquireToken = "refreshTokenClientAcquireToken", t.RefreshTokenClientAcquireTokenWithCachedRefreshToken = "refreshTokenClientAcquireTokenWithCachedRefreshToken";
})(hn || (hn = {}));
var ea;
(function(t) {
  t[t.NotStarted = 0] = "NotStarted", t[t.InProgress = 1] = "InProgress", t[t.Completed = 2] = "Completed";
})(ea || (ea = {}));
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Fw = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n, r) {
      return t.call(this, n, r) || this;
    }
    return e.prototype.acquireToken = function(n) {
      var r, i;
      return je(this, void 0, void 0, function() {
        var o, a, s, c, l, u = this;
        return Ve(this, function(d) {
          switch (d.label) {
            case 0:
              return o = (r = this.performanceClient) === null || r === void 0 ? void 0 : r.startMeasurement(hn.RefreshTokenClientAcquireToken, n.correlationId), this.logger.verbose("RefreshTokenClientAcquireToken called", n.correlationId), a = fr.nowSeconds(), [4, this.executeTokenRequest(n, this.authority)];
            case 1:
              return s = d.sent(), c = (i = s.headers) === null || i === void 0 ? void 0 : i[Ir.X_MS_REQUEST_ID], l = new Ul(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin), l.validateTokenResponse(s.body), [2, l.handleServerTokenResponse(s.body, this.authority, a, n, void 0, void 0, !0, n.forceCache, c).then(function(f) {
                var h;
                return o == null || o.endMeasurement({
                  success: !0,
                  refreshTokenSize: ((h = s.body.refresh_token) === null || h === void 0 ? void 0 : h.length) || 0
                }), f;
              }).catch(function(f) {
                throw u.logger.verbose("Error in fetching refresh token", n.correlationId), o == null || o.endMeasurement({
                  errorCode: f.errorCode,
                  subErrorCode: f.subError,
                  success: !1,
                  refreshTokenSize: void 0
                }), f;
              })];
          }
        });
      });
    }, e.prototype.acquireTokenByRefreshToken = function(n) {
      return je(this, void 0, void 0, function() {
        var r, i, o;
        return Ve(this, function(a) {
          if (!n)
            throw zt.createEmptyTokenRequestError();
          if (!n.account)
            throw ge.createNoAccountInSilentRequestError();
          if (r = this.cacheManager.isAppMetadataFOCI(n.account.environment, this.config.authOptions.clientId), r)
            try {
              return [2, this.acquireTokenWithCachedRefreshToken(n, !0)];
            } catch (s) {
              if (i = s instanceof Cr && s.errorCode === ms.noTokensFoundError.code, o = s instanceof bo && s.errorCode === $m.INVALID_GRANT_ERROR && s.subError === $m.CLIENT_MISMATCH_ERROR, i || o)
                return [2, this.acquireTokenWithCachedRefreshToken(n, !1)];
              throw s;
            }
          return [2, this.acquireTokenWithCachedRefreshToken(n, !1)];
        });
      });
    }, e.prototype.acquireTokenWithCachedRefreshToken = function(n, r) {
      var i;
      return je(this, void 0, void 0, function() {
        var o, a, s;
        return Ve(this, function(c) {
          if (o = (i = this.performanceClient) === null || i === void 0 ? void 0 : i.startMeasurement(hn.RefreshTokenClientAcquireTokenWithCachedRefreshToken, n.correlationId), this.logger.verbose("RefreshTokenClientAcquireTokenWithCachedRefreshToken called", n.correlationId), a = this.cacheManager.readRefreshTokenFromCache(this.config.authOptions.clientId, n.account, r), !a)
            throw o == null || o.discardMeasurement(), Cr.createNoTokensFoundError();
          return o == null || o.endMeasurement({
            success: !0
          }), s = nn(nn({}, n), { refreshToken: a.secret, authenticationScheme: n.authenticationScheme || St.BEARER, ccsCredential: {
            credential: n.account.homeAccountId,
            type: Zn.HOME_ACCOUNT_ID
          } }), [2, this.acquireToken(s)];
        });
      });
    }, e.prototype.executeTokenRequest = function(n, r) {
      var i;
      return je(this, void 0, void 0, function() {
        var o, a, s, c, l, u;
        return Ve(this, function(d) {
          switch (d.label) {
            case 0:
              return o = (i = this.performanceClient) === null || i === void 0 ? void 0 : i.startMeasurement(hn.RefreshTokenClientExecuteTokenRequest, n.correlationId), [4, this.createTokenRequestBody(n)];
            case 1:
              return a = d.sent(), s = this.createTokenQueryParameters(n), c = this.createTokenRequestHeaders(n.ccsCredential), l = {
                clientId: this.config.authOptions.clientId,
                authority: r.canonicalAuthority,
                scopes: n.scopes,
                claims: n.claims,
                authenticationScheme: n.authenticationScheme,
                resourceRequestMethod: n.resourceRequestMethod,
                resourceRequestUri: n.resourceRequestUri,
                shrClaims: n.shrClaims,
                sshKid: n.sshKid
              }, u = mt.appendQueryString(r.tokenEndpoint, s), [2, this.executePostToTokenEndpoint(u, a, c, l).then(function(f) {
                return o == null || o.endMeasurement({
                  success: !0
                }), f;
              }).catch(function(f) {
                throw o == null || o.endMeasurement({
                  success: !1
                }), f;
              })];
          }
        });
      });
    }, e.prototype.createTokenQueryParameters = function(n) {
      var r = new Xo();
      return n.tokenQueryParameters && r.addExtraQueryParameters(n.tokenQueryParameters), r.createQueryString();
    }, e.prototype.createTokenRequestBody = function(n) {
      var r;
      return je(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u;
        return Ve(this, function(d) {
          switch (d.label) {
            case 0:
              return i = n.correlationId, o = (r = this.performanceClient) === null || r === void 0 ? void 0 : r.startMeasurement(hn.BaseClientCreateTokenRequestHeaders, i), a = new Xo(), a.addClientId(this.config.authOptions.clientId), a.addScopes(n.scopes), a.addGrantType(Nl.REFRESH_TOKEN_GRANT), a.addClientInfo(), a.addLibraryInfo(this.config.libraryInfo), a.addApplicationTelemetry(this.config.telemetry.application), a.addThrottling(), this.serverTelemetryManager && a.addServerTelemetry(this.serverTelemetryManager), a.addCorrelationId(i), a.addRefreshToken(n.refreshToken), this.config.clientCredentials.clientSecret && a.addClientSecret(this.config.clientCredentials.clientSecret), this.config.clientCredentials.clientAssertion && (s = this.config.clientCredentials.clientAssertion, a.addClientAssertion(s.assertion), a.addClientAssertionType(s.assertionType)), n.authenticationScheme !== St.POP ? [3, 2] : (c = new wa(this.cryptoUtils), [4, c.generateCnf(n)]);
            case 1:
              return l = d.sent(), a.addPopToken(l.reqCnfString), [3, 3];
            case 2:
              if (n.authenticationScheme === St.SSH)
                if (n.sshJwk)
                  a.addSshJwk(n.sshJwk);
                else
                  throw o == null || o.endMeasurement({
                    success: !1
                  }), zt.createMissingSshJwkError();
              d.label = 3;
            case 3:
              if ((!ce.isEmptyObj(n.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) && a.addClaims(n.claims, this.config.authOptions.clientCapabilities), this.config.systemOptions.preventCorsPreflight && n.ccsCredential)
                switch (n.ccsCredential.type) {
                  case Zn.HOME_ACCOUNT_ID:
                    try {
                      u = Zo(n.ccsCredential.credential), a.addCcsOid(u);
                    } catch (f) {
                      this.logger.verbose("Could not parse home account ID for CCS Header: " + f);
                    }
                    break;
                  case Zn.UPN:
                    a.addCcsUpn(n.ccsCredential.credential);
                    break;
                }
              return o == null || o.endMeasurement({
                success: !0
              }), [2, a.createQueryString()];
          }
        });
      });
    }, e;
  }(xp)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var CI = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n, r) {
      return t.call(this, n, r) || this;
    }
    return e.prototype.acquireToken = function(n) {
      return je(this, void 0, void 0, function() {
        var r, i;
        return Ve(this, function(o) {
          switch (o.label) {
            case 0:
              return o.trys.push([0, 2, , 3]), [4, this.acquireCachedToken(n)];
            case 1:
              return [2, o.sent()];
            case 2:
              if (r = o.sent(), r instanceof ge && r.errorCode === oe.tokenRefreshRequired.code)
                return i = new Fw(this.config, this.performanceClient), [2, i.acquireTokenByRefreshToken(n)];
              throw r;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.acquireCachedToken = function(n) {
      var r, i, o, a;
      return je(this, void 0, void 0, function() {
        var s, c;
        return Ve(this, function(l) {
          switch (l.label) {
            case 0:
              if (!n)
                throw zt.createEmptyTokenRequestError();
              if (n.forceRefresh)
                throw (r = this.serverTelemetryManager) === null || r === void 0 || r.setCacheOutcome(co.FORCE_REFRESH), this.logger.info("SilentFlowClient:acquireCachedToken - Skipping cache because forceRefresh is true."), ge.createRefreshRequiredError();
              if (!n.account)
                throw ge.createNoAccountInSilentRequestError();
              if (s = n.authority || this.authority.getPreferredCache(), c = this.cacheManager.readCacheRecord(n.account, this.config.authOptions.clientId, n, s), c.accessToken) {
                if (fr.wasClockTurnedBack(c.accessToken.cachedAt) || fr.isTokenExpired(c.accessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds))
                  throw (o = this.serverTelemetryManager) === null || o === void 0 || o.setCacheOutcome(co.CACHED_ACCESS_TOKEN_EXPIRED), this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token is expired or will expire within " + this.config.systemOptions.tokenRenewalOffsetSeconds + " seconds."), ge.createRefreshRequiredError();
                if (c.accessToken.refreshOn && fr.isTokenExpired(c.accessToken.refreshOn, 0))
                  throw (a = this.serverTelemetryManager) === null || a === void 0 || a.setCacheOutcome(co.REFRESH_CACHED_ACCESS_TOKEN), this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token's refreshOn property has been exceeded'."), ge.createRefreshRequiredError();
              } else
                throw (i = this.serverTelemetryManager) === null || i === void 0 || i.setCacheOutcome(co.NO_CACHED_ACCESS_TOKEN), this.logger.info("SilentFlowClient:acquireCachedToken - No access token found in cache for the given properties."), ge.createRefreshRequiredError();
              return this.config.serverTelemetryManager && this.config.serverTelemetryManager.incrementCacheHits(), [4, this.generateResultFromCacheRecord(c, n)];
            case 1:
              return [2, l.sent()];
          }
        });
      });
    }, e.prototype.generateResultFromCacheRecord = function(n, r) {
      return je(this, void 0, void 0, function() {
        var i, o;
        return Ve(this, function(a) {
          switch (a.label) {
            case 0:
              if (n.idToken && (i = new Br(n.idToken.secret, this.config.cryptoInterface)), r.maxAge || r.maxAge === 0) {
                if (o = i == null ? void 0 : i.claims.auth_time, !o)
                  throw ge.createAuthTimeNotFoundError();
                Br.checkMaxAge(o, r.maxAge);
              }
              return [4, Ul.generateAuthenticationResult(this.cryptoUtils, this.authority, n, !0, r, i)];
            case 1:
              return [2, a.sent()];
          }
        });
      });
    }, e;
  }(xp)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
function II(t) {
  return t.hasOwnProperty("authorization_endpoint") && t.hasOwnProperty("token_endpoint") && t.hasOwnProperty("issuer") && t.hasOwnProperty("jwks_uri");
}
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Uw = { endpointMetadata: { "https://login.microsoftonline.com/common/": { token_endpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.microsoftonline.com/common/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.microsoftonline.com/{tenantid}/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://graph.microsoft.com/oidc/userinfo", authorization_endpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.microsoftonline.com/common/kerberos", tenant_region_scope: null, cloud_instance_name: "microsoftonline.com", cloud_graph_host_name: "graph.windows.net", msgraph_host: "graph.microsoft.com", rbac_url: "https://pas.windows.net" }, "https://login.chinacloudapi.cn/common/": { token_endpoint: "https://login.chinacloudapi.cn/common/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.chinacloudapi.cn/common/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.partner.microsoftonline.cn/{tenantid}/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo", authorization_endpoint: "https://login.chinacloudapi.cn/common/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.chinacloudapi.cn/common/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.chinacloudapi.cn/common/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.chinacloudapi.cn/common/kerberos", tenant_region_scope: null, cloud_instance_name: "partner.microsoftonline.cn", cloud_graph_host_name: "graph.chinacloudapi.cn", msgraph_host: "microsoftgraph.chinacloudapi.cn", rbac_url: "https://pas.chinacloudapi.cn" }, "https://login.microsoftonline.us/common/": { token_endpoint: "https://login.microsoftonline.us/common/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.microsoftonline.us/common/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.microsoftonline.us/{tenantid}/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://graph.microsoft.com/oidc/userinfo", authorization_endpoint: "https://login.microsoftonline.us/common/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.microsoftonline.us/common/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.microsoftonline.us/common/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.microsoftonline.us/common/kerberos", tenant_region_scope: null, cloud_instance_name: "microsoftonline.us", cloud_graph_host_name: "graph.windows.net", msgraph_host: "graph.microsoft.com", rbac_url: "https://pasff.usgovcloudapi.net" }, "https://login.microsoftonline.com/consumers/": { token_endpoint: "https://login.microsoftonline.com/consumers/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.microsoftonline.com/consumers/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.microsoftonline.com/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://graph.microsoft.com/oidc/userinfo", authorization_endpoint: "https://login.microsoftonline.com/consumers/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.microsoftonline.com/consumers/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.microsoftonline.com/consumers/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.microsoftonline.com/consumers/kerberos", tenant_region_scope: null, cloud_instance_name: "microsoftonline.com", cloud_graph_host_name: "graph.windows.net", msgraph_host: "graph.microsoft.com", rbac_url: "https://pas.windows.net" }, "https://login.chinacloudapi.cn/consumers/": { token_endpoint: "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.chinacloudapi.cn/consumers/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.partner.microsoftonline.cn/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo", authorization_endpoint: "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.chinacloudapi.cn/consumers/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.chinacloudapi.cn/consumers/kerberos", tenant_region_scope: null, cloud_instance_name: "partner.microsoftonline.cn", cloud_graph_host_name: "graph.chinacloudapi.cn", msgraph_host: "microsoftgraph.chinacloudapi.cn", rbac_url: "https://pas.chinacloudapi.cn" }, "https://login.microsoftonline.us/consumers/": { token_endpoint: "https://login.microsoftonline.us/consumers/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.microsoftonline.us/consumers/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.microsoftonline.us/9188040d-6c67-4c5b-b112-36a304b66dad/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://graph.microsoft.com/oidc/userinfo", authorization_endpoint: "https://login.microsoftonline.us/consumers/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.microsoftonline.us/consumers/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.microsoftonline.us/consumers/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.microsoftonline.us/consumers/kerberos", tenant_region_scope: null, cloud_instance_name: "microsoftonline.us", cloud_graph_host_name: "graph.windows.net", msgraph_host: "graph.microsoft.com", rbac_url: "https://pasff.usgovcloudapi.net" }, "https://login.microsoftonline.com/organizations/": { token_endpoint: "https://login.microsoftonline.com/organizations/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.microsoftonline.com/organizations/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.microsoftonline.com/{tenantid}/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://graph.microsoft.com/oidc/userinfo", authorization_endpoint: "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.microsoftonline.com/organizations/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.microsoftonline.com/organizations/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.microsoftonline.com/organizations/kerberos", tenant_region_scope: null, cloud_instance_name: "microsoftonline.com", cloud_graph_host_name: "graph.windows.net", msgraph_host: "graph.microsoft.com", rbac_url: "https://pas.windows.net" }, "https://login.chinacloudapi.cn/organizations/": { token_endpoint: "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.chinacloudapi.cn/organizations/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.partner.microsoftonline.cn/{tenantid}/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://microsoftgraph.chinacloudapi.cn/oidc/userinfo", authorization_endpoint: "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.chinacloudapi.cn/organizations/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.chinacloudapi.cn/organizations/kerberos", tenant_region_scope: null, cloud_instance_name: "partner.microsoftonline.cn", cloud_graph_host_name: "graph.chinacloudapi.cn", msgraph_host: "microsoftgraph.chinacloudapi.cn", rbac_url: "https://pas.chinacloudapi.cn" }, "https://login.microsoftonline.us/organizations/": { token_endpoint: "https://login.microsoftonline.us/organizations/oauth2/v2.0/token", token_endpoint_auth_methods_supported: ["client_secret_post", "private_key_jwt", "client_secret_basic"], jwks_uri: "https://login.microsoftonline.us/organizations/discovery/v2.0/keys", response_modes_supported: ["query", "fragment", "form_post"], subject_types_supported: ["pairwise"], id_token_signing_alg_values_supported: ["RS256"], response_types_supported: ["code", "id_token", "code id_token", "id_token token"], scopes_supported: ["openid", "profile", "email", "offline_access"], issuer: "https://login.microsoftonline.us/{tenantid}/v2.0", request_uri_parameter_supported: !1, userinfo_endpoint: "https://graph.microsoft.com/oidc/userinfo", authorization_endpoint: "https://login.microsoftonline.us/organizations/oauth2/v2.0/authorize", device_authorization_endpoint: "https://login.microsoftonline.us/organizations/oauth2/v2.0/devicecode", http_logout_supported: !0, frontchannel_logout_supported: !0, end_session_endpoint: "https://login.microsoftonline.us/organizations/oauth2/v2.0/logout", claims_supported: ["sub", "iss", "cloud_instance_name", "cloud_instance_host_name", "cloud_graph_host_name", "msgraph_host", "aud", "exp", "iat", "auth_time", "acr", "nonce", "preferred_username", "name", "tid", "ver", "at_hash", "c_hash", "email"], kerberos_endpoint: "https://login.microsoftonline.us/organizations/kerberos", tenant_region_scope: null, cloud_instance_name: "microsoftonline.us", cloud_graph_host_name: "graph.windows.net", msgraph_host: "graph.microsoft.com", rbac_url: "https://pasff.usgovcloudapi.net" } }, instanceDiscoveryMetadata: { "https://login.microsoftonline.com/common/": { tenant_discovery_endpoint: "https://login.microsoftonline.com/common/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] }, "https://login.chinacloudapi.cn/common/": { tenant_discovery_endpoint: "https://login.chinacloudapi.cn/common/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.us/common/": { tenant_discovery_endpoint: "https://login.microsoftonline.us/common/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.com/consumers/": { tenant_discovery_endpoint: "https://login.microsoftonline.com/consumers/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] }, "https://login.chinacloudapi.cn/consumers/": { tenant_discovery_endpoint: "https://login.chinacloudapi.cn/consumers/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.us/consumers/": { tenant_discovery_endpoint: "https://login.microsoftonline.us/consumers/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.com/organizations/": { tenant_discovery_endpoint: "https://login.microsoftonline.com/organizations/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] }, "https://login.chinacloudapi.cn/organizations/": { tenant_discovery_endpoint: "https://login.chinacloudapi.cn/organizations/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] }, "https://login.microsoftonline.us/organizations/": { tenant_discovery_endpoint: "https://login.microsoftonline.us/organizations/v2.0/.well-known/openid-configuration", "api-version": "1.1", metadata: [{ preferred_network: "login.microsoftonline.com", preferred_cache: "login.windows.net", aliases: ["login.microsoftonline.com", "login.windows.net", "login.microsoft.com", "sts.windows.net"] }, { preferred_network: "login.partner.microsoftonline.cn", preferred_cache: "login.partner.microsoftonline.cn", aliases: ["login.partner.microsoftonline.cn", "login.chinacloudapi.cn"] }, { preferred_network: "login.microsoftonline.de", preferred_cache: "login.microsoftonline.de", aliases: ["login.microsoftonline.de"] }, { preferred_network: "login.microsoftonline.us", preferred_cache: "login.microsoftonline.us", aliases: ["login.microsoftonline.us", "login.usgovcloudapi.net"] }, { preferred_network: "login-us.microsoftonline.com", preferred_cache: "login-us.microsoftonline.com", aliases: ["login-us.microsoftonline.com"] }] } } }, zm = Uw.endpointMetadata, Km = Uw.instanceDiscoveryMetadata;
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Hl;
(function(t) {
  t.AAD = "AAD", t.OIDC = "OIDC";
})(Hl || (Hl = {}));
/*! @azure/msal-common v7.6.0 2022-10-10 */
var zf = (
  /** @class */
  function() {
    function t() {
      this.expiresAt = fr.nowSeconds() + ks.REFRESH_TIME_SECONDS;
    }
    return t.prototype.updateCloudDiscoveryMetadata = function(e, n) {
      this.aliases = e.aliases, this.preferred_cache = e.preferred_cache, this.preferred_network = e.preferred_network, this.aliasesFromNetwork = n;
    }, t.prototype.updateEndpointMetadata = function(e, n) {
      this.authorization_endpoint = e.authorization_endpoint, this.token_endpoint = e.token_endpoint, this.end_session_endpoint = e.end_session_endpoint, this.issuer = e.issuer, this.endpointsFromNetwork = n, this.jwks_uri = e.jwks_uri;
    }, t.prototype.updateCanonicalAuthority = function(e) {
      this.canonical_authority = e;
    }, t.prototype.resetExpiresAt = function() {
      this.expiresAt = fr.nowSeconds() + ks.REFRESH_TIME_SECONDS;
    }, t.prototype.isExpired = function() {
      return this.expiresAt <= fr.nowSeconds();
    }, t.isAuthorityMetadataEntity = function(e, n) {
      return n ? e.indexOf(ks.CACHE_KEY) === 0 && n.hasOwnProperty("aliases") && n.hasOwnProperty("preferred_cache") && n.hasOwnProperty("preferred_network") && n.hasOwnProperty("canonical_authority") && n.hasOwnProperty("authorization_endpoint") && n.hasOwnProperty("token_endpoint") && n.hasOwnProperty("issuer") && n.hasOwnProperty("aliasesFromNetwork") && n.hasOwnProperty("endpointsFromNetwork") && n.hasOwnProperty("expiresAt") && n.hasOwnProperty("jwks_uri") : !1;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
function SI(t) {
  return t.hasOwnProperty("tenant_discovery_endpoint") && t.hasOwnProperty("metadata");
}
/*! @azure/msal-common v7.6.0 2022-10-10 */
var TI = (
  /** @class */
  function() {
    function t(e) {
      this.networkInterface = e;
    }
    return t.prototype.detectRegion = function(e, n, r) {
      return je(this, void 0, void 0, function() {
        var i, o, a, s, c;
        return Ve(this, function(l) {
          switch (l.label) {
            case 0:
              if (i = e, i)
                return [3, 8];
              o = t.IMDS_OPTIONS, r && (o.proxyUrl = r), l.label = 1;
            case 1:
              return l.trys.push([1, 6, , 7]), [4, this.getRegionFromIMDS(M.IMDS_VERSION, o)];
            case 2:
              return a = l.sent(), a.status === Jo.httpSuccess && (i = a.body, n.region_source = Ai.IMDS), a.status !== Jo.httpBadRequest ? [3, 5] : [4, this.getCurrentVersion(o)];
            case 3:
              return s = l.sent(), s ? [4, this.getRegionFromIMDS(s, o)] : (n.region_source = Ai.FAILED_AUTO_DETECTION, [2, null]);
            case 4:
              c = l.sent(), c.status === Jo.httpSuccess && (i = c.body, n.region_source = Ai.IMDS), l.label = 5;
            case 5:
              return [3, 7];
            case 6:
              return l.sent(), n.region_source = Ai.FAILED_AUTO_DETECTION, [2, null];
            case 7:
              return [3, 9];
            case 8:
              n.region_source = Ai.ENVIRONMENT_VARIABLE, l.label = 9;
            case 9:
              return i || (n.region_source = Ai.FAILED_AUTO_DETECTION), [2, i || null];
          }
        });
      });
    }, t.prototype.getRegionFromIMDS = function(e, n) {
      return je(this, void 0, void 0, function() {
        return Ve(this, function(r) {
          return [2, this.networkInterface.sendGetRequestAsync(M.IMDS_ENDPOINT + "?api-version=" + e + "&format=text", n, M.IMDS_TIMEOUT)];
        });
      });
    }, t.prototype.getCurrentVersion = function(e) {
      return je(this, void 0, void 0, function() {
        var n;
        return Ve(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, this.networkInterface.sendGetRequestAsync(M.IMDS_ENDPOINT + "?format=json", e)];
            case 1:
              return n = r.sent(), n.status === Jo.httpBadRequest && n.body && n.body["newest-versions"] && n.body["newest-versions"].length > 0 ? [2, n.body["newest-versions"][0]] : [2, null];
            case 2:
              return r.sent(), [2, null];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.IMDS_OPTIONS = {
      headers: {
        Metadata: "true"
      }
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Bl = (
  /** @class */
  function() {
    function t(e, n, r, i, o) {
      this.canonicalAuthority = e, this._canonicalAuthority.validateAsUri(), this.networkInterface = n, this.cacheManager = r, this.authorityOptions = i, this.regionDiscovery = new TI(n), this.regionDiscoveryMetadata = { region_used: void 0, region_source: void 0, region_outcome: void 0 }, this.proxyUrl = o || M.EMPTY_STRING;
    }
    return Object.defineProperty(t.prototype, "authorityType", {
      // See above for AuthorityType
      get: function() {
        var e = this.canonicalAuthorityUrlComponents.PathSegments;
        if (e.length)
          switch (e[0].toLowerCase()) {
            case M.ADFS:
              return ur.Adfs;
            case M.DSTS:
              return ur.Dsts;
          }
        return ur.Default;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "protocolMode", {
      /**
       * ProtocolMode enum representing the way endpoints are constructed.
       */
      get: function() {
        return this.authorityOptions.protocolMode;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "options", {
      /**
       * Returns authorityOptions which can be used to reinstantiate a new authority instance
       */
      get: function() {
        return this.authorityOptions;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "canonicalAuthority", {
      /**
       * A URL that is the authority set by the developer
       */
      get: function() {
        return this._canonicalAuthority.urlString;
      },
      /**
       * Sets canonical authority.
       */
      set: function(e) {
        this._canonicalAuthority = new mt(e), this._canonicalAuthority.validateAsUri(), this._canonicalAuthorityUrlComponents = null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "canonicalAuthorityUrlComponents", {
      /**
       * Get authority components.
       */
      get: function() {
        return this._canonicalAuthorityUrlComponents || (this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents()), this._canonicalAuthorityUrlComponents;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "hostnameAndPort", {
      /**
       * Get hostname and port i.e. login.microsoftonline.com
       */
      get: function() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tenant", {
      /**
       * Get tenant for authority.
       */
      get: function() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "authorizationEndpoint", {
      /**
       * OAuth /authorize endpoint for requests
       */
      get: function() {
        if (this.discoveryComplete()) {
          var e = this.replacePath(this.metadata.authorization_endpoint);
          return this.replaceTenant(e);
        } else
          throw ge.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tokenEndpoint", {
      /**
       * OAuth /token endpoint for requests
       */
      get: function() {
        if (this.discoveryComplete()) {
          var e = this.replacePath(this.metadata.token_endpoint);
          return this.replaceTenant(e);
        } else
          throw ge.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "deviceCodeEndpoint", {
      get: function() {
        if (this.discoveryComplete()) {
          var e = this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
          return this.replaceTenant(e);
        } else
          throw ge.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "endSessionEndpoint", {
      /**
       * OAuth logout endpoint for requests
       */
      get: function() {
        if (this.discoveryComplete()) {
          if (!this.metadata.end_session_endpoint)
            throw ge.createLogoutNotSupportedError();
          var e = this.replacePath(this.metadata.end_session_endpoint);
          return this.replaceTenant(e);
        } else
          throw ge.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "selfSignedJwtAudience", {
      /**
       * OAuth issuer for requests
       */
      get: function() {
        if (this.discoveryComplete()) {
          var e = this.replacePath(this.metadata.issuer);
          return this.replaceTenant(e);
        } else
          throw ge.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "jwksUri", {
      /**
       * Jwks_uri for token signing keys
       */
      get: function() {
        if (this.discoveryComplete()) {
          var e = this.replacePath(this.metadata.jwks_uri);
          return this.replaceTenant(e);
        } else
          throw ge.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.replaceTenant = function(e) {
      return e.replace(/{tenant}|{tenantid}/g, this.tenant);
    }, t.prototype.replacePath = function(e) {
      var n = e, r = new mt(this.metadata.canonical_authority), i = r.getUrlComponents().PathSegments, o = this.canonicalAuthorityUrlComponents.PathSegments;
      return o.forEach(function(a, s) {
        var c = i[s];
        a !== c && (n = n.replace("/" + c + "/", "/" + a + "/"));
      }), n;
    }, Object.defineProperty(t.prototype, "defaultOpenIdConfigurationEndpoint", {
      /**
       * The default open id configuration endpoint for any canonical authority.
       */
      get: function() {
        return this.authorityType === ur.Adfs || this.authorityType === ur.Dsts || this.protocolMode === Hl.OIDC ? this.canonicalAuthority + ".well-known/openid-configuration" : this.canonicalAuthority + "v2.0/.well-known/openid-configuration";
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.discoveryComplete = function() {
      return !!this.metadata;
    }, t.prototype.resolveEndpointsAsync = function() {
      return je(this, void 0, void 0, function() {
        var e, n, r, i;
        return Ve(this, function(o) {
          switch (o.label) {
            case 0:
              return e = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort), e || (e = new zf(), e.updateCanonicalAuthority(this.canonicalAuthority)), [4, this.updateCloudDiscoveryMetadata(e)];
            case 1:
              return n = o.sent(), this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, e.preferred_network), [4, this.updateEndpointMetadata(e)];
            case 2:
              return r = o.sent(), n !== cr.CACHE && r !== cr.CACHE && (e.resetExpiresAt(), e.updateCanonicalAuthority(this.canonicalAuthority)), i = this.cacheManager.generateAuthorityMetadataCacheKey(e.preferred_cache), this.cacheManager.setAuthorityMetadata(i, e), this.metadata = e, [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.updateEndpointMetadata = function(e) {
      var n, r;
      return je(this, void 0, void 0, function() {
        var i, o;
        return Ve(this, function(a) {
          switch (a.label) {
            case 0:
              return i = this.getEndpointMetadataFromConfig(), i ? (e.updateEndpointMetadata(i, !1), [2, cr.CONFIG]) : this.isAuthoritySameType(e) && e.endpointsFromNetwork && !e.isExpired() ? [2, cr.CACHE] : (o = this.getEndpointMetadataFromHardcodedValues(), [4, this.getEndpointMetadataFromNetwork()]);
            case 1:
              return i = a.sent(), i ? !((n = this.authorityOptions.azureRegionConfiguration) === null || n === void 0) && n.azureRegion ? [4, this.updateMetadataWithRegionalInformation(i)] : [3, 3] : [3, 4];
            case 2:
              i = a.sent(), a.label = 3;
            case 3:
              return e.updateEndpointMetadata(i, !0), [2, cr.NETWORK];
            case 4:
              return o && !this.authorityOptions.skipAuthorityMetadataCache ? !((r = this.authorityOptions.azureRegionConfiguration) === null || r === void 0) && r.azureRegion ? [4, this.updateMetadataWithRegionalInformation(o)] : [3, 6] : [3, 7];
            case 5:
              o = a.sent(), a.label = 6;
            case 6:
              return e.updateEndpointMetadata(o, !1), [2, cr.HARDCODED_VALUES];
            case 7:
              throw ge.createUnableToGetOpenidConfigError(this.defaultOpenIdConfigurationEndpoint);
          }
        });
      });
    }, t.prototype.isAuthoritySameType = function(e) {
      var n = new mt(e.canonical_authority), r = n.getUrlComponents().PathSegments;
      return r.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }, t.prototype.getEndpointMetadataFromConfig = function() {
      if (this.authorityOptions.authorityMetadata)
        try {
          return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch {
          throw zt.createInvalidAuthorityMetadataError();
        }
      return null;
    }, t.prototype.getEndpointMetadataFromNetwork = function() {
      return je(this, void 0, void 0, function() {
        var e, n;
        return Ve(this, function(r) {
          switch (r.label) {
            case 0:
              e = {}, this.proxyUrl && (e.proxyUrl = this.proxyUrl), r.label = 1;
            case 1:
              return r.trys.push([1, 3, , 4]), [4, this.networkInterface.sendGetRequestAsync(this.defaultOpenIdConfigurationEndpoint, e)];
            case 2:
              return n = r.sent(), [2, II(n.body) ? n.body : null];
            case 3:
              return r.sent(), [2, null];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getEndpointMetadataFromHardcodedValues = function() {
      return this.canonicalAuthority in zm ? zm[this.canonicalAuthority] : null;
    }, t.prototype.updateMetadataWithRegionalInformation = function(e) {
      var n, r, i, o, a;
      return je(this, void 0, void 0, function() {
        var s, c;
        return Ve(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.regionDiscovery.detectRegion((n = this.authorityOptions.azureRegionConfiguration) === null || n === void 0 ? void 0 : n.environmentRegion, this.regionDiscoveryMetadata, this.proxyUrl)];
            case 1:
              return s = l.sent(), c = ((r = this.authorityOptions.azureRegionConfiguration) === null || r === void 0 ? void 0 : r.azureRegion) === M.AZURE_REGION_AUTO_DISCOVER_FLAG ? s : (i = this.authorityOptions.azureRegionConfiguration) === null || i === void 0 ? void 0 : i.azureRegion, ((o = this.authorityOptions.azureRegionConfiguration) === null || o === void 0 ? void 0 : o.azureRegion) === M.AZURE_REGION_AUTO_DISCOVER_FLAG ? this.regionDiscoveryMetadata.region_outcome = s ? io.AUTO_DETECTION_REQUESTED_SUCCESSFUL : io.AUTO_DETECTION_REQUESTED_FAILED : s ? this.regionDiscoveryMetadata.region_outcome = ((a = this.authorityOptions.azureRegionConfiguration) === null || a === void 0 ? void 0 : a.azureRegion) === s ? io.CONFIGURED_MATCHES_DETECTED : io.CONFIGURED_NOT_DETECTED : this.regionDiscoveryMetadata.region_outcome = io.CONFIGURED_NO_AUTO_DETECTION, c ? (this.regionDiscoveryMetadata.region_used = c, [2, t.replaceWithRegionalInformation(e, c)]) : [2, e];
          }
        });
      });
    }, t.prototype.updateCloudDiscoveryMetadata = function(e) {
      return je(this, void 0, void 0, function() {
        var n, r;
        return Ve(this, function(i) {
          switch (i.label) {
            case 0:
              return n = this.getCloudDiscoveryMetadataFromConfig(), n ? (e.updateCloudDiscoveryMetadata(n, !1), [2, cr.CONFIG]) : this.isAuthoritySameType(e) && e.aliasesFromNetwork && !e.isExpired() ? [2, cr.CACHE] : (r = this.getCloudDiscoveryMetadataFromHarcodedValues(), [4, this.getCloudDiscoveryMetadataFromNetwork()]);
            case 1:
              if (n = i.sent(), n)
                return e.updateCloudDiscoveryMetadata(n, !0), [2, cr.NETWORK];
              if (r && !this.options.skipAuthorityMetadataCache)
                return e.updateCloudDiscoveryMetadata(r, !1), [2, cr.HARDCODED_VALUES];
              throw zt.createUntrustedAuthorityError();
          }
        });
      });
    }, t.prototype.getCloudDiscoveryMetadataFromConfig = function() {
      if (this.authorityOptions.cloudDiscoveryMetadata)
        try {
          var e = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata), n = t.getCloudDiscoveryMetadataFromNetworkResponse(e.metadata, this.hostnameAndPort);
          if (n)
            return n;
        } catch {
          throw zt.createInvalidCloudDiscoveryMetadataError();
        }
      return this.isInKnownAuthorities() ? t.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort) : null;
    }, t.prototype.getCloudDiscoveryMetadataFromNetwork = function() {
      return je(this, void 0, void 0, function() {
        var e, n, r, i, o;
        return Ve(this, function(a) {
          switch (a.label) {
            case 0:
              e = "" + M.AAD_INSTANCE_DISCOVERY_ENDPT + this.canonicalAuthority + "oauth2/v2.0/authorize", n = {}, this.proxyUrl && (n.proxyUrl = this.proxyUrl), r = null, a.label = 1;
            case 1:
              return a.trys.push([1, 3, , 4]), [4, this.networkInterface.sendGetRequestAsync(e, n)];
            case 2:
              return i = a.sent(), o = SI(i.body) ? i.body.metadata : [], o.length === 0 ? [2, null] : (r = t.getCloudDiscoveryMetadataFromNetworkResponse(o, this.hostnameAndPort), [3, 4]);
            case 3:
              return a.sent(), [2, null];
            case 4:
              return r || (r = t.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort)), [2, r];
          }
        });
      });
    }, t.prototype.getCloudDiscoveryMetadataFromHarcodedValues = function() {
      return this.canonicalAuthority in Km ? Km[this.canonicalAuthority] : null;
    }, t.prototype.isInKnownAuthorities = function() {
      var e = this, n = this.authorityOptions.knownAuthorities.filter(function(r) {
        return mt.getDomainFromUrl(r).toLowerCase() === e.hostnameAndPort;
      });
      return n.length > 0;
    }, t.generateAuthority = function(e, n) {
      var r;
      if (n && n.azureCloudInstance !== Hs.None) {
        var i = n.tenant ? n.tenant : M.DEFAULT_COMMON_TENANT;
        r = n.azureCloudInstance + "/" + i + "/";
      }
      return r || e;
    }, t.createCloudDiscoveryMetadataFromHost = function(e) {
      return {
        preferred_network: e,
        preferred_cache: e,
        aliases: [e]
      };
    }, t.getCloudDiscoveryMetadataFromNetworkResponse = function(e, n) {
      for (var r = 0; r < e.length; r++) {
        var i = e[r];
        if (i.aliases.indexOf(n) > -1)
          return i;
      }
      return null;
    }, t.prototype.getPreferredCache = function() {
      if (this.discoveryComplete())
        return this.metadata.preferred_cache;
      throw ge.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
    }, t.prototype.isAlias = function(e) {
      return this.metadata.aliases.indexOf(e) > -1;
    }, t.isPublicCloudAuthority = function(e) {
      return M.KNOWN_PUBLIC_CLOUDS.indexOf(e) >= 0;
    }, t.buildRegionalAuthorityString = function(e, n, r) {
      var i = new mt(e);
      i.validateAsUri();
      var o = i.getUrlComponents(), a = n + "." + o.HostNameAndPort;
      this.isPublicCloudAuthority(o.HostNameAndPort) && (a = n + "." + M.REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX);
      var s = mt.constructAuthorityUriFromObject(nn(nn({}, i.getUrlComponents()), { HostNameAndPort: a })).urlString;
      return r ? s + "?" + r : s;
    }, t.replaceWithRegionalInformation = function(e, n) {
      return e.authorization_endpoint = t.buildRegionalAuthorityString(e.authorization_endpoint, n), e.token_endpoint = t.buildRegionalAuthorityString(e.token_endpoint, n, M.REGIONAL_AUTH_NON_MSI_QUERY_STRING), e.end_session_endpoint && (e.end_session_endpoint = t.buildRegionalAuthorityString(e.end_session_endpoint, n)), e;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var jl = (
  /** @class */
  function() {
    function t() {
    }
    return t.createDiscoveredInstance = function(e, n, r, i, o) {
      return je(this, void 0, void 0, function() {
        var a, s;
        return Ve(this, function(c) {
          switch (c.label) {
            case 0:
              a = t.createInstance(e, n, r, i, o), c.label = 1;
            case 1:
              return c.trys.push([1, 3, , 4]), [4, a.resolveEndpointsAsync()];
            case 2:
              return c.sent(), [2, a];
            case 3:
              throw s = c.sent(), ge.createEndpointDiscoveryIncompleteError(s);
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.createInstance = function(e, n, r, i, o) {
      if (ce.isEmpty(e))
        throw zt.createUrlEmptyError();
      return new Bl(e, n, r, i, o);
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Vl = (
  /** @class */
  function() {
    function t() {
      this.failedRequests = [], this.errors = [], this.cacheHits = 0;
    }
    return t.isServerTelemetryEntity = function(e, n) {
      var r = e.indexOf(In.CACHE_KEY) === 0, i = !0;
      return n && (i = n.hasOwnProperty("failedRequests") && n.hasOwnProperty("errors") && n.hasOwnProperty("cacheHits")), r && i;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Wm = (
  /** @class */
  function() {
    function t() {
    }
    return t.isThrottlingEntity = function(e, n) {
      var r = !1;
      e && (r = e.indexOf(As.THROTTLING_PREFIX) === 0);
      var i = !0;
      return n && (i = n.hasOwnProperty("throttleTime")), r && i;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var kI = {
  sendGetRequestAsync: function() {
    var t = "Network interface - sendGetRequestAsync() has not been implemented for the Network interface.";
    return Promise.reject(Ie.createUnexpectedError(t));
  },
  sendPostRequestAsync: function() {
    var t = "Network interface - sendPostRequestAsync() has not been implemented for the Network interface.";
    return Promise.reject(Ie.createUnexpectedError(t));
  }
};
/*! @azure/msal-common v7.6.0 2022-10-10 */
var jc = {
  missingKidError: {
    code: "missing_kid_error",
    desc: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided."
  },
  missingAlgError: {
    code: "missing_alg_error",
    desc: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
  }
}, Gm = (
  /** @class */
  function(t) {
    qn(e, t);
    function e(n, r) {
      var i = t.call(this, n, r) || this;
      return i.name = "JoseHeaderError", Object.setPrototypeOf(i, e.prototype), i;
    }
    return e.createMissingKidError = function() {
      return new e(jc.missingKidError.code, jc.missingKidError.desc);
    }, e.createMissingAlgError = function() {
      return new e(jc.missingAlgError.code, jc.missingAlgError.desc);
    }, e;
  }(Ie)
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var AI = (
  /** @class */
  function() {
    function t(e) {
      this.typ = e.typ, this.alg = e.alg, this.kid = e.kid;
    }
    return t.getShrHeaderString = function(e) {
      if (!e.kid)
        throw Gm.createMissingKidError();
      if (!e.alg)
        throw Gm.createMissingAlgError();
      var n = new t({
        // Access Token PoP headers must have type JWT, but the type header can be overriden for special cases
        typ: e.typ || jf.Jwt,
        kid: e.kid,
        alg: e.alg
      });
      return JSON.stringify(n);
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var OI = (
  /** @class */
  function() {
    function t(e, n) {
      this.cacheOutcome = co.NO_CACHE_HIT, this.cacheManager = n, this.apiId = e.apiId, this.correlationId = e.correlationId, this.wrapperSKU = e.wrapperSKU || M.EMPTY_STRING, this.wrapperVer = e.wrapperVer || M.EMPTY_STRING, this.telemetryCacheKey = In.CACHE_KEY + Xn.CACHE_KEY_SEPARATOR + e.clientId;
    }
    return t.prototype.generateCurrentRequestHeaderValue = function() {
      var e = "" + this.apiId + In.VALUE_SEPARATOR + this.cacheOutcome, n = [this.wrapperSKU, this.wrapperVer].join(In.VALUE_SEPARATOR), r = this.getRegionDiscoveryFields(), i = [e, r].join(In.VALUE_SEPARATOR);
      return [In.SCHEMA_VERSION, i, n].join(In.CATEGORY_SEPARATOR);
    }, t.prototype.generateLastRequestHeaderValue = function() {
      var e = this.getLastRequests(), n = t.maxErrorsToSend(e), r = e.failedRequests.slice(0, 2 * n).join(In.VALUE_SEPARATOR), i = e.errors.slice(0, n).join(In.VALUE_SEPARATOR), o = e.errors.length, a = n < o ? In.OVERFLOW_TRUE : In.OVERFLOW_FALSE, s = [o, a].join(In.VALUE_SEPARATOR);
      return [In.SCHEMA_VERSION, e.cacheHits, r, i, s].join(In.CATEGORY_SEPARATOR);
    }, t.prototype.cacheFailedRequest = function(e) {
      var n = this.getLastRequests();
      n.errors.length >= In.MAX_CACHED_ERRORS && (n.failedRequests.shift(), n.failedRequests.shift(), n.errors.shift()), n.failedRequests.push(this.apiId, this.correlationId), ce.isEmpty(e.subError) ? ce.isEmpty(e.errorCode) ? e && e.toString() ? n.errors.push(e.toString()) : n.errors.push(In.UNKNOWN_ERROR) : n.errors.push(e.errorCode) : n.errors.push(e.subError), this.cacheManager.setServerTelemetry(this.telemetryCacheKey, n);
    }, t.prototype.incrementCacheHits = function() {
      var e = this.getLastRequests();
      return e.cacheHits += 1, this.cacheManager.setServerTelemetry(this.telemetryCacheKey, e), e.cacheHits;
    }, t.prototype.getLastRequests = function() {
      var e = new Vl(), n = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
      return n || e;
    }, t.prototype.clearTelemetryCache = function() {
      var e = this.getLastRequests(), n = t.maxErrorsToSend(e), r = e.errors.length;
      if (n === r)
        this.cacheManager.removeItem(this.telemetryCacheKey);
      else {
        var i = new Vl();
        i.failedRequests = e.failedRequests.slice(n * 2), i.errors = e.errors.slice(n), this.cacheManager.setServerTelemetry(this.telemetryCacheKey, i);
      }
    }, t.maxErrorsToSend = function(e) {
      var n, r = 0, i = 0, o = e.errors.length;
      for (n = 0; n < o; n++) {
        var a = e.failedRequests[2 * n] || M.EMPTY_STRING, s = e.failedRequests[2 * n + 1] || M.EMPTY_STRING, c = e.errors[n] || M.EMPTY_STRING;
        if (i += a.toString().length + s.toString().length + c.length + 3, i < In.MAX_LAST_HEADER_BYTES)
          r += 1;
        else
          break;
      }
      return r;
    }, t.prototype.getRegionDiscoveryFields = function() {
      var e = [];
      return e.push(this.regionUsed || M.EMPTY_STRING), e.push(this.regionSource || M.EMPTY_STRING), e.push(this.regionOutcome || M.EMPTY_STRING), e.join(",");
    }, t.prototype.updateRegionDiscoveryMetadata = function(e) {
      this.regionUsed = e.region_used, this.regionSource = e.region_source, this.regionOutcome = e.region_outcome;
    }, t.prototype.setCacheOutcome = function(e) {
      this.cacheOutcome = e;
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var Hw = (
  /** @class */
  function() {
    function t(e, n, r, i, o, a) {
      this.authority = n, this.libraryName = i, this.libraryVersion = o, this.applicationTelemetry = a, this.clientId = e, this.logger = r, this.callbacks = /* @__PURE__ */ new Map(), this.eventsByCorrelationId = /* @__PURE__ */ new Map(), this.measurementsById = /* @__PURE__ */ new Map();
    }
    return t.prototype.startMeasurement = function(e, n) {
      var r = this, i, o, a = n || this.generateId();
      n || this.logger.info("PerformanceClient: No correlation id provided for " + e + ", generating", a), this.logger.trace("PerformanceClient: Performance measurement started for " + e, a);
      var s = this.startPerformanceMeasuremeant(e, a);
      s.startMeasurement();
      var c = {
        eventId: this.generateId(),
        status: ea.InProgress,
        authority: this.authority,
        libraryName: this.libraryName,
        libraryVersion: this.libraryVersion,
        appName: (i = this.applicationTelemetry) === null || i === void 0 ? void 0 : i.appName,
        appVersion: (o = this.applicationTelemetry) === null || o === void 0 ? void 0 : o.appVersion,
        clientId: this.clientId,
        name: e,
        startTimeMs: Date.now(),
        correlationId: a
      };
      return this.cacheEventByCorrelationId(c), this.cacheMeasurement(c, s), {
        endMeasurement: function(l) {
          var u = r.endMeasurement(nn(nn({}, c), l));
          return u && r.cacheEventByCorrelationId(u), u;
        },
        flushMeasurement: function() {
          return r.flushMeasurements(c.name, c.correlationId);
        },
        discardMeasurement: function() {
          return r.discardMeasurements(c.correlationId);
        },
        measurement: s,
        event: c
      };
    }, t.prototype.endMeasurement = function(e) {
      var n = this.measurementsById.get(e.eventId);
      if (n) {
        this.measurementsById.delete(e.eventId), n.endMeasurement();
        var r = n.flushMeasurement();
        if (r !== null) {
          this.logger.trace("PerformanceClient: Performance measurement ended for " + e.name + ": " + r + " ms", e.correlationId);
          var i = nn(nn({
            // Allow duration to be overwritten when event ends (e.g. testing), but not status
            durationMs: Math.round(r)
          }, e), { status: ea.Completed });
          return i;
        } else
          this.logger.trace("PerformanceClient: Performance measurement not taken", e.correlationId);
      } else
        this.logger.trace("PerformanceClient: Measurement not found for " + e.eventId, e.correlationId);
      return null;
    }, t.prototype.cacheEventByCorrelationId = function(e) {
      var n = this.eventsByCorrelationId.get(e.correlationId);
      n ? (this.logger.trace("PerformanceClient: Performance measurement for " + e.name + " added/updated", e.correlationId), n.set(e.eventId, e)) : (this.logger.trace("PerformanceClient: Performance measurement for " + e.name + " started", e.correlationId), this.eventsByCorrelationId.set(e.correlationId, (/* @__PURE__ */ new Map()).set(e.eventId, e)));
    }, t.prototype.cacheMeasurement = function(e, n) {
      this.measurementsById.set(e.eventId, n);
    }, t.prototype.flushMeasurements = function(e, n) {
      var r = this;
      this.logger.trace("PerformanceClient: Performance measurements flushed for " + e, n);
      var i = this.eventsByCorrelationId.get(n);
      if (i) {
        this.discardMeasurements(n);
        var o = [];
        i.forEach(function(u) {
          if (u.name !== e && u.status !== ea.Completed) {
            r.logger.trace("PerformanceClient: Incomplete submeasurement " + u.name + " found for " + e, n);
            var d = r.endMeasurement(u);
            d && o.push(d);
          }
          o.push(u);
        });
        var a = o.sort(function(u, d) {
          return u.startTimeMs - d.startTimeMs;
        }), s = a.filter(function(u) {
          return u.name === e && u.status === ea.Completed;
        });
        if (s.length > 0) {
          s.length > 1 && this.logger.verbose("PerformanceClient: Multiple distinct top-level performance events found, using the first", n);
          var c = s[0];
          this.logger.verbose("PerformanceClient: Measurement found for " + e, n);
          var l = a.reduce(function(u, d) {
            if (d.name !== e) {
              r.logger.trace("PerformanceClient: Complete submeasurement found for " + d.name, n);
              var f = d.name + "DurationMs";
              u[f] ? r.logger.verbose("PerformanceClient: Submeasurement for " + e + " already exists for " + d.name + ", ignoring", n) : u[f] = d.durationMs, d.accessTokenSize && (u.accessTokenSize = d.accessTokenSize), d.idTokenSize && (u.idTokenSize = d.idTokenSize), d.refreshTokenSize && (u.refreshTokenSize = d.refreshTokenSize);
            }
            return u;
          }, c);
          this.emitEvents([l], l.correlationId);
        } else
          this.logger.verbose("PerformanceClient: No completed top-level measurements found for " + e, n);
      } else
        this.logger.verbose("PerformanceClient: No measurements found", n);
    }, t.prototype.discardMeasurements = function(e) {
      this.logger.trace("PerformanceClient: Performance measurements discarded", e), this.eventsByCorrelationId.delete(e);
    }, t.prototype.addPerformanceCallback = function(e) {
      var n = this.generateId();
      return this.callbacks.set(n, e), this.logger.verbose("PerformanceClient: Performance callback registered with id: " + n), n;
    }, t.prototype.removePerformanceCallback = function(e) {
      var n = this.callbacks.delete(e);
      return n ? this.logger.verbose("PerformanceClient: Performance callback " + e + " removed.") : this.logger.verbose("PerformanceClient: Performance callback " + e + " not removed."), n;
    }, t.prototype.emitEvents = function(e, n) {
      var r = this;
      this.logger.verbose("PerformanceClient: Emitting performance events", n), this.callbacks.forEach(function(i, o) {
        r.logger.trace("PerformanceClient: Emitting event to callback " + o, n), i.apply(null, [e]);
      });
    }, t;
  }()
);
/*! @azure/msal-common v7.6.0 2022-10-10 */
var xI = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.startMeasurement = function() {
    }, t.prototype.endMeasurement = function() {
    }, t.prototype.flushMeasurement = function() {
      return null;
    }, t;
  }()
), RI = (
  /** @class */
  function(t) {
    qn(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.generateId = function() {
      return "callback-id";
    }, e.prototype.startPerformanceMeasuremeant = function() {
      return new xI();
    }, e;
  }(Hw)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var ee = {
  pkceNotGenerated: {
    code: "pkce_not_created",
    desc: "The PKCE code challenge and verifier could not be generated."
  },
  cryptoDoesNotExist: {
    code: "crypto_nonexistent",
    desc: "The crypto object or function is not available."
  },
  httpMethodNotImplementedError: {
    code: "http_method_not_implemented",
    desc: "The HTTP method given has not been implemented in this library."
  },
  emptyNavigateUriError: {
    code: "empty_navigate_uri",
    desc: "Navigation URI is empty. Please check stack trace for more info."
  },
  hashEmptyError: {
    code: "hash_empty_error",
    desc: "Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. For more visit: aka.ms/msaljs/browser-errors."
  },
  hashDoesNotContainStateError: {
    code: "no_state_in_hash",
    desc: "Hash does not contain state. Please verify that the request originated from msal."
  },
  hashDoesNotContainKnownPropertiesError: {
    code: "hash_does_not_contain_known_properties",
    desc: "Hash does not contain known properites. Please verify that your redirectUri is not changing the hash. For more visit: aka.ms/msaljs/browser-errors."
  },
  unableToParseStateError: {
    code: "unable_to_parse_state",
    desc: "Unable to parse state. Please verify that the request originated from msal."
  },
  stateInteractionTypeMismatchError: {
    code: "state_interaction_type_mismatch",
    desc: "Hash contains state but the interaction type does not match the caller."
  },
  interactionInProgress: {
    code: "interaction_in_progress",
    desc: "Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.  For more visit: aka.ms/msaljs/browser-errors."
  },
  popupWindowError: {
    code: "popup_window_error",
    desc: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."
  },
  emptyWindowError: {
    code: "empty_window_error",
    desc: "window.open returned null or undefined window object."
  },
  userCancelledError: {
    code: "user_cancelled",
    desc: "User cancelled the flow."
  },
  monitorPopupTimeoutError: {
    code: "monitor_window_timeout",
    desc: "Token acquisition in popup failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
  },
  monitorIframeTimeoutError: {
    code: "monitor_window_timeout",
    desc: "Token acquisition in iframe failed due to timeout. For more visit: aka.ms/msaljs/browser-errors."
  },
  redirectInIframeError: {
    code: "redirect_in_iframe",
    desc: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs."
  },
  blockTokenRequestsInHiddenIframeError: {
    code: "block_iframe_reload",
    desc: "Request was blocked inside an iframe because MSAL detected an authentication response. For more visit: aka.ms/msaljs/browser-errors"
  },
  blockAcquireTokenInPopupsError: {
    code: "block_nested_popups",
    desc: "Request was blocked inside a popup because MSAL detected it was running in a popup."
  },
  iframeClosedPrematurelyError: {
    code: "iframe_closed_prematurely",
    desc: "The iframe being monitored was closed prematurely."
  },
  silentLogoutUnsupportedError: {
    code: "silent_logout_unsupported",
    desc: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead."
  },
  noAccountError: {
    code: "no_account_error",
    desc: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request."
  },
  silentPromptValueError: {
    code: "silent_prompt_value_error",
    desc: "The value given for the prompt value is not valid for silent requests - must be set to 'none'."
  },
  noTokenRequestCacheError: {
    code: "no_token_request_cache_error",
    desc: "No token request found in cache."
  },
  unableToParseTokenRequestCacheError: {
    code: "unable_to_parse_token_request_cache_error",
    desc: "The cached token request could not be parsed."
  },
  noCachedAuthorityError: {
    code: "no_cached_authority_error",
    desc: "No cached authority found."
  },
  authRequestNotSet: {
    code: "auth_request_not_set_error",
    desc: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler"
  },
  invalidCacheType: {
    code: "invalid_cache_type",
    desc: "Invalid cache type"
  },
  notInBrowserEnvironment: {
    code: "non_browser_environment",
    desc: "Login and token requests are not supported in non-browser environments."
  },
  databaseNotOpen: {
    code: "database_not_open",
    desc: "Database is not open!"
  },
  noNetworkConnectivity: {
    code: "no_network_connectivity",
    desc: "No network connectivity. Check your internet connection."
  },
  postRequestFailed: {
    code: "post_request_failed",
    desc: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'"
  },
  getRequestFailed: {
    code: "get_request_failed",
    desc: "Network request failed. Please check the network trace to determine root cause."
  },
  failedToParseNetworkResponse: {
    code: "failed_to_parse_response",
    desc: "Failed to parse network response. Check network trace."
  },
  unableToLoadTokenError: {
    code: "unable_to_load_token",
    desc: "Error loading token to cache."
  },
  signingKeyNotFoundInStorage: {
    code: "crypto_key_not_found",
    desc: "Cryptographic Key or Keypair not found in browser storage."
  },
  authCodeRequired: {
    code: "auth_code_required",
    desc: "An authorization code must be provided (as the `code` property on the request) to this flow."
  },
  authCodeOrNativeAccountRequired: {
    code: "auth_code_or_nativeAccountId_required",
    desc: "An authorization code or nativeAccountId must be provided to this flow."
  },
  databaseUnavailable: {
    code: "database_unavailable",
    desc: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts."
  },
  unableToAcquireTokenFromNativePlatform: {
    code: "unable_to_acquire_token_from_native_platform",
    desc: "Unable to acquire token from native platform. For a list of possible reasons visit aka.ms/msaljs/browser-errors."
  },
  nativeHandshakeTimeout: {
    code: "native_handshake_timeout",
    desc: "Timed out while attempting to establish connection to browser extension"
  },
  nativeExtensionNotInstalled: {
    code: "native_extension_not_installed",
    desc: "Native extension is not installed. If you think this is a mistake call the initialize function."
  },
  nativeConnectionNotEstablished: {
    code: "native_connection_not_established",
    desc: "Connection to native platform has not been established. Please install a compatible browser extension and run initialize(). For more please visit aka.ms/msaljs/browser-errors."
  },
  nativeBrokerCalledBeforeInitialize: {
    code: "native_broker_called_before_initialize",
    desc: "You must call and await the initialize function before attempting to call any other MSAL API when native brokering is enabled. For more please visit aka.ms/msaljs/browser-errors."
  },
  nativePromptNotSupported: {
    code: "native_prompt_not_supported",
    desc: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow."
  }
}, se = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r) {
      var i = t.call(this, n, r) || this;
      return Object.setPrototypeOf(i, e.prototype), i.name = "BrowserAuthError", i;
    }
    return e.createPkceNotGeneratedError = function(n) {
      return new e(ee.pkceNotGenerated.code, ee.pkceNotGenerated.desc + " Detail:" + n);
    }, e.createCryptoNotAvailableError = function(n) {
      return new e(ee.cryptoDoesNotExist.code, ee.cryptoDoesNotExist.desc + " Detail:" + n);
    }, e.createHttpMethodNotImplementedError = function(n) {
      return new e(ee.httpMethodNotImplementedError.code, ee.httpMethodNotImplementedError.desc + " Given Method: " + n);
    }, e.createEmptyNavigationUriError = function() {
      return new e(ee.emptyNavigateUriError.code, ee.emptyNavigateUriError.desc);
    }, e.createEmptyHashError = function(n) {
      return new e(ee.hashEmptyError.code, ee.hashEmptyError.desc + " Given Url: " + n);
    }, e.createHashDoesNotContainStateError = function() {
      return new e(ee.hashDoesNotContainStateError.code, ee.hashDoesNotContainStateError.desc);
    }, e.createHashDoesNotContainKnownPropertiesError = function() {
      return new e(ee.hashDoesNotContainKnownPropertiesError.code, ee.hashDoesNotContainKnownPropertiesError.desc);
    }, e.createUnableToParseStateError = function() {
      return new e(ee.unableToParseStateError.code, ee.unableToParseStateError.desc);
    }, e.createStateInteractionTypeMismatchError = function() {
      return new e(ee.stateInteractionTypeMismatchError.code, ee.stateInteractionTypeMismatchError.desc);
    }, e.createInteractionInProgressError = function() {
      return new e(ee.interactionInProgress.code, ee.interactionInProgress.desc);
    }, e.createPopupWindowError = function(n) {
      var r = ee.popupWindowError.desc;
      return r = ce.isEmpty(n) ? r : r + " Details: " + n, new e(ee.popupWindowError.code, r);
    }, e.createEmptyWindowCreatedError = function() {
      return new e(ee.emptyWindowError.code, ee.emptyWindowError.desc);
    }, e.createUserCancelledError = function() {
      return new e(ee.userCancelledError.code, ee.userCancelledError.desc);
    }, e.createMonitorPopupTimeoutError = function() {
      return new e(ee.monitorPopupTimeoutError.code, ee.monitorPopupTimeoutError.desc);
    }, e.createMonitorIframeTimeoutError = function() {
      return new e(ee.monitorIframeTimeoutError.code, ee.monitorIframeTimeoutError.desc);
    }, e.createRedirectInIframeError = function(n) {
      return new e(ee.redirectInIframeError.code, ee.redirectInIframeError.desc + " (window.parent !== window) => " + n);
    }, e.createBlockReloadInHiddenIframeError = function() {
      return new e(ee.blockTokenRequestsInHiddenIframeError.code, ee.blockTokenRequestsInHiddenIframeError.desc);
    }, e.createBlockAcquireTokenInPopupsError = function() {
      return new e(ee.blockAcquireTokenInPopupsError.code, ee.blockAcquireTokenInPopupsError.desc);
    }, e.createIframeClosedPrematurelyError = function() {
      return new e(ee.iframeClosedPrematurelyError.code, ee.iframeClosedPrematurelyError.desc);
    }, e.createSilentLogoutUnsupportedError = function() {
      return new e(ee.silentLogoutUnsupportedError.code, ee.silentLogoutUnsupportedError.desc);
    }, e.createNoAccountError = function() {
      return new e(ee.noAccountError.code, ee.noAccountError.desc);
    }, e.createSilentPromptValueError = function(n) {
      return new e(ee.silentPromptValueError.code, ee.silentPromptValueError.desc + " Given value: " + n);
    }, e.createUnableToParseTokenRequestCacheError = function() {
      return new e(ee.unableToParseTokenRequestCacheError.code, ee.unableToParseTokenRequestCacheError.desc);
    }, e.createNoTokenRequestCacheError = function() {
      return new e(ee.noTokenRequestCacheError.code, ee.noTokenRequestCacheError.desc);
    }, e.createAuthRequestNotSetError = function() {
      return new e(ee.authRequestNotSet.code, ee.authRequestNotSet.desc);
    }, e.createNoCachedAuthorityError = function() {
      return new e(ee.noCachedAuthorityError.code, ee.noCachedAuthorityError.desc);
    }, e.createInvalidCacheTypeError = function() {
      return new e(ee.invalidCacheType.code, "" + ee.invalidCacheType.desc);
    }, e.createNonBrowserEnvironmentError = function() {
      return new e(ee.notInBrowserEnvironment.code, ee.notInBrowserEnvironment.desc);
    }, e.createDatabaseNotOpenError = function() {
      return new e(ee.databaseNotOpen.code, ee.databaseNotOpen.desc);
    }, e.createNoNetworkConnectivityError = function() {
      return new e(ee.noNetworkConnectivity.code, ee.noNetworkConnectivity.desc);
    }, e.createPostRequestFailedError = function(n, r) {
      return new e(ee.postRequestFailed.code, ee.postRequestFailed.desc + " | Network client threw: " + n + " | Attempted to reach: " + r.split("?")[0]);
    }, e.createGetRequestFailedError = function(n, r) {
      return new e(ee.getRequestFailed.code, ee.getRequestFailed.desc + " | Network client threw: " + n + " | Attempted to reach: " + r.split("?")[0]);
    }, e.createFailedToParseNetworkResponseError = function(n) {
      return new e(ee.failedToParseNetworkResponse.code, ee.failedToParseNetworkResponse.desc + " | Attempted to reach: " + n.split("?")[0]);
    }, e.createUnableToLoadTokenError = function(n) {
      return new e(ee.unableToLoadTokenError.code, ee.unableToLoadTokenError.desc + " | " + n);
    }, e.createSigningKeyNotFoundInStorageError = function(n) {
      return new e(ee.signingKeyNotFoundInStorage.code, ee.signingKeyNotFoundInStorage.desc + " | No match found for KeyId: " + n);
    }, e.createAuthCodeRequiredError = function() {
      return new e(ee.authCodeRequired.code, ee.authCodeRequired.desc);
    }, e.createAuthCodeOrNativeAccountIdRequiredError = function() {
      return new e(ee.authCodeOrNativeAccountRequired.code, ee.authCodeOrNativeAccountRequired.desc);
    }, e.createDatabaseUnavailableError = function() {
      return new e(ee.databaseUnavailable.code, ee.databaseUnavailable.desc);
    }, e.createUnableToAcquireTokenFromNativePlatformError = function() {
      return new e(ee.unableToAcquireTokenFromNativePlatform.code, ee.unableToAcquireTokenFromNativePlatform.desc);
    }, e.createNativeHandshakeTimeoutError = function() {
      return new e(ee.nativeHandshakeTimeout.code, ee.nativeHandshakeTimeout.desc);
    }, e.createNativeExtensionNotInstalledError = function() {
      return new e(ee.nativeExtensionNotInstalled.code, ee.nativeExtensionNotInstalled.desc);
    }, e.createNativeConnectionNotEstablishedError = function() {
      return new e(ee.nativeConnectionNotEstablished.code, ee.nativeConnectionNotEstablished.desc);
    }, e.createNativeBrokerCalledBeforeInitialize = function() {
      return new e(ee.nativeBrokerCalledBeforeInitialize.code, ee.nativeBrokerCalledBeforeInitialize.desc);
    }, e.createNativePromptParameterNotSupportedError = function() {
      return new e(ee.nativePromptNotSupported.code, ee.nativePromptNotSupported.desc);
    }, e;
  }(Ie)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Hn = {
  /**
   * Interaction in progress cache value
   */
  INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
  /**
   * Invalid grant error code
   */
  INVALID_GRANT_ERROR: "invalid_grant",
  /**
   * Default popup window width
   */
  POPUP_WIDTH: 483,
  /**
   * Default popup window height
   */
  POPUP_HEIGHT: 600,
  /**
   * Name of the popup window starts with
   */
  POPUP_NAME_PREFIX: "msal",
  /**
   * Default popup monitor poll interval in milliseconds
   */
  POLL_INTERVAL_MS: 50,
  /**
   * Msal-browser SKU
   */
  MSAL_SKU: "msal.js.browser"
}, vs = {
  CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
  PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
  MATS_TELEMETRY: "MATS"
}, ii;
(function(t) {
  t.HandshakeRequest = "Handshake", t.HandshakeResponse = "HandshakeResponse", t.GetToken = "GetToken", t.Response = "Response";
})(ii || (ii = {}));
var xn;
(function(t) {
  t.LocalStorage = "localStorage", t.SessionStorage = "sessionStorage", t.MemoryStorage = "memoryStorage";
})(xn || (xn = {}));
var Pr;
(function(t) {
  t.GET = "GET", t.POST = "POST";
})(Pr || (Pr = {}));
var yt;
(function(t) {
  t.AUTHORITY = "authority", t.ACQUIRE_TOKEN_ACCOUNT = "acquireToken.account", t.SESSION_STATE = "session.state", t.REQUEST_STATE = "request.state", t.NONCE_IDTOKEN = "nonce.id_token", t.ORIGIN_URI = "request.origin", t.RENEW_STATUS = "token.renew.status", t.URL_HASH = "urlHash", t.REQUEST_PARAMS = "request.params", t.SCOPES = "scopes", t.INTERACTION_STATUS_KEY = "interaction.status", t.CCS_CREDENTIAL = "ccs.credential", t.CORRELATION_ID = "request.correlationId", t.NATIVE_REQUEST = "request.native";
})(yt || (yt = {}));
var ta;
(function(t) {
  t.WRAPPER_SKU = "wrapper.sku", t.WRAPPER_VER = "wrapper.version";
})(ta || (ta = {}));
var Bt;
(function(t) {
  t[t.acquireTokenRedirect = 861] = "acquireTokenRedirect", t[t.acquireTokenPopup = 862] = "acquireTokenPopup", t[t.ssoSilent = 863] = "ssoSilent", t[t.acquireTokenSilent_authCode = 864] = "acquireTokenSilent_authCode", t[t.handleRedirectPromise = 865] = "handleRedirectPromise", t[t.acquireTokenByCode = 866] = "acquireTokenByCode", t[t.acquireTokenSilent_silentFlow = 61] = "acquireTokenSilent_silentFlow", t[t.logout = 961] = "logout", t[t.logoutPopup = 962] = "logoutPopup";
})(Bt || (Bt = {}));
var be;
(function(t) {
  t.Redirect = "redirect", t.Popup = "popup", t.Silent = "silent", t.None = "none";
})(be || (be = {}));
var Ym;
(function(t) {
  t.Startup = "startup", t.Login = "login", t.Logout = "logout", t.AcquireToken = "acquireToken", t.SsoSilent = "ssoSilent", t.HandleRedirect = "handleRedirect", t.None = "none";
})(Ym || (Ym = {}));
var Qm = {
  scopes: lc
}, Vc = "jwk", Jm;
(function(t) {
  t.React = "@azure/msal-react", t.Angular = "@azure/msal-angular";
})(Jm || (Jm = {}));
var ll = "msal.db", NI = 1, MI = ll + ".keys";
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var or = {
  redirectUriNotSet: {
    code: "redirect_uri_empty",
    desc: "A redirect URI is required for all calls, and none has been set."
  },
  postLogoutUriNotSet: {
    code: "post_logout_uri_empty",
    desc: "A post logout redirect has not been set."
  },
  storageNotSupportedError: {
    code: "storage_not_supported",
    desc: "Given storage configuration option was not supported."
  },
  noRedirectCallbacksSet: {
    code: "no_redirect_callbacks",
    desc: "No redirect callbacks have been set. Please call setRedirectCallbacks() with the appropriate function arguments before continuing. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
  },
  invalidCallbackObject: {
    code: "invalid_callback_object",
    desc: "The object passed for the callback was invalid. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
  },
  stubPcaInstanceCalled: {
    code: "stubbed_public_client_application_called",
    desc: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors"
  },
  inMemRedirectUnavailable: {
    code: "in_mem_redirect_unavailable",
    desc: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
  }
}, Kf = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r) {
      var i = t.call(this, n, r) || this;
      return i.name = "BrowserConfigurationAuthError", Object.setPrototypeOf(i, e.prototype), i;
    }
    return e.createRedirectUriEmptyError = function() {
      return new e(or.redirectUriNotSet.code, or.redirectUriNotSet.desc);
    }, e.createPostLogoutRedirectUriEmptyError = function() {
      return new e(or.postLogoutUriNotSet.code, or.postLogoutUriNotSet.desc);
    }, e.createStorageNotSupportedError = function(n) {
      return new e(or.storageNotSupportedError.code, or.storageNotSupportedError.desc + " Given Location: " + n);
    }, e.createRedirectCallbacksNotSetError = function() {
      return new e(or.noRedirectCallbacksSet.code, or.noRedirectCallbacksSet.desc);
    }, e.createStubPcaInstanceCalledError = function() {
      return new e(or.stubPcaInstanceCalled.code, or.stubPcaInstanceCalled.desc);
    }, e.createInMemoryRedirectUnavailableError = function() {
      return new e(or.inMemRedirectUnavailable.code, or.inMemRedirectUnavailable.desc);
    }, e;
  }(Ie)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Zm = (
  /** @class */
  function() {
    function t(e) {
      this.validateWindowStorage(e), this.windowStorage = window[e];
    }
    return t.prototype.validateWindowStorage = function(e) {
      if (e !== xn.LocalStorage && e !== xn.SessionStorage)
        throw Kf.createStorageNotSupportedError(e);
      var n = !!window[e];
      if (!n)
        throw Kf.createStorageNotSupportedError(e);
    }, t.prototype.getItem = function(e) {
      return this.windowStorage.getItem(e);
    }, t.prototype.setItem = function(e, n) {
      this.windowStorage.setItem(e, n);
    }, t.prototype.removeItem = function(e) {
      this.windowStorage.removeItem(e);
    }, t.prototype.getKeys = function() {
      return Object.keys(this.windowStorage);
    }, t.prototype.containsKey = function(e) {
      return this.windowStorage.hasOwnProperty(e);
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Wf = (
  /** @class */
  function() {
    function t() {
      this.cache = /* @__PURE__ */ new Map();
    }
    return t.prototype.getItem = function(e) {
      return this.cache.get(e) || null;
    }, t.prototype.setItem = function(e, n) {
      this.cache.set(e, n);
    }, t.prototype.removeItem = function(e) {
      this.cache.delete(e);
    }, t.prototype.getKeys = function() {
      var e = [];
      return this.cache.forEach(function(n, r) {
        e.push(r);
      }), e;
    }, t.prototype.containsKey = function(e) {
      return this.cache.has(e);
    }, t.prototype.clear = function() {
      this.cache.clear();
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Bw = (
  /** @class */
  function() {
    function t() {
    }
    return t.extractBrowserRequestState = function(e, n) {
      if (ce.isEmpty(n))
        return null;
      try {
        var r = ci.parseRequestState(e, n);
        return r.libraryState.meta;
      } catch (i) {
        throw ge.createInvalidStateError(n, i);
      }
    }, t.parseServerResponseFromHash = function(e) {
      if (!e)
        return {};
      var n = new mt(e);
      return mt.getDeserializedHash(n.getHash());
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Gf = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o) {
      var a = t.call(this, n, i) || this;
      return a.COOKIE_LIFE_MULTIPLIER = 24 * 60 * 60 * 1e3, a.cacheConfig = r, a.logger = o, a.internalStorage = new Wf(), a.browserStorage = a.setupBrowserStorage(a.cacheConfig.cacheLocation), a.temporaryCacheStorage = a.setupTemporaryCacheStorage(a.cacheConfig.cacheLocation), a.migrateCacheEntries(), a;
    }
    return e.prototype.setupBrowserStorage = function(n) {
      switch (n) {
        case xn.LocalStorage:
        case xn.SessionStorage:
          try {
            return new Zm(n);
          } catch (r) {
            this.logger.verbose(r);
            break;
          }
      }
      return this.cacheConfig.cacheLocation = xn.MemoryStorage, new Wf();
    }, e.prototype.setupTemporaryCacheStorage = function(n) {
      switch (n) {
        case xn.LocalStorage:
        case xn.SessionStorage:
          try {
            return new Zm(xn.SessionStorage);
          } catch (r) {
            return this.logger.verbose(r), this.internalStorage;
          }
        case xn.MemoryStorage:
        default:
          return this.internalStorage;
      }
    }, e.prototype.migrateCacheEntries = function() {
      var n = this, r = M.CACHE_PREFIX + "." + mn.ID_TOKEN, i = M.CACHE_PREFIX + "." + mn.CLIENT_INFO, o = M.CACHE_PREFIX + "." + mn.ERROR, a = M.CACHE_PREFIX + "." + mn.ERROR_DESC, s = this.browserStorage.getItem(r), c = this.browserStorage.getItem(i), l = this.browserStorage.getItem(o), u = this.browserStorage.getItem(a), d = [s, c, l, u], f = [mn.ID_TOKEN, mn.CLIENT_INFO, mn.ERROR, mn.ERROR_DESC];
      f.forEach(function(h, g) {
        return n.migrateCacheEntry(h, d[g]);
      });
    }, e.prototype.migrateCacheEntry = function(n, r) {
      r && this.setTemporaryCache(n, r, !0);
    }, e.prototype.validateAndParseJson = function(n) {
      try {
        var r = JSON.parse(n);
        return r && typeof r == "object" ? r : null;
      } catch {
        return null;
      }
    }, e.prototype.getItem = function(n) {
      return this.browserStorage.getItem(n);
    }, e.prototype.setItem = function(n, r) {
      this.browserStorage.setItem(n, r);
    }, e.prototype.getAccount = function(n) {
      var r = this.getItem(n);
      if (!r)
        return null;
      var i = this.validateAndParseJson(r);
      return !i || !Nn.isAccountEntity(i) ? null : _r.toObject(new Nn(), i);
    }, e.prototype.setAccount = function(n) {
      this.logger.trace("BrowserCacheManager.setAccount called");
      var r = n.generateAccountKey();
      this.setItem(r, JSON.stringify(n));
    }, e.prototype.getIdTokenCredential = function(n) {
      var r = this.getItem(n);
      if (!r)
        return this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit"), null;
      var i = this.validateAndParseJson(r);
      return !i || !js.isIdTokenEntity(i) ? (this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit"), null) : (this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit"), _r.toObject(new js(), i));
    }, e.prototype.setIdTokenCredential = function(n) {
      this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
      var r = n.generateCredentialKey();
      this.setItem(r, JSON.stringify(n));
    }, e.prototype.getAccessTokenCredential = function(n) {
      var r = this.getItem(n);
      if (!r)
        return this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit"), null;
      var i = this.validateAndParseJson(r);
      return !i || !Vs.isAccessTokenEntity(i) ? (this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit"), null) : (this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit"), _r.toObject(new Vs(), i));
    }, e.prototype.setAccessTokenCredential = function(n) {
      this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
      var r = n.generateCredentialKey();
      this.setItem(r, JSON.stringify(n));
    }, e.prototype.getRefreshTokenCredential = function(n) {
      var r = this.getItem(n);
      if (!r)
        return this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit"), null;
      var i = this.validateAndParseJson(r);
      return !i || !Vf.isRefreshTokenEntity(i) ? (this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit"), null) : (this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit"), _r.toObject(new Vf(), i));
    }, e.prototype.setRefreshTokenCredential = function(n) {
      this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
      var r = n.generateCredentialKey();
      this.setItem(r, JSON.stringify(n));
    }, e.prototype.getAppMetadata = function(n) {
      var r = this.getItem(n);
      if (!r)
        return this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit"), null;
      var i = this.validateAndParseJson(r);
      return !i || !qf.isAppMetadataEntity(n, i) ? (this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit"), null) : (this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit"), _r.toObject(new qf(), i));
    }, e.prototype.setAppMetadata = function(n) {
      this.logger.trace("BrowserCacheManager.setAppMetadata called");
      var r = n.generateAppMetadataKey();
      this.setItem(r, JSON.stringify(n));
    }, e.prototype.getServerTelemetry = function(n) {
      var r = this.getItem(n);
      if (!r)
        return this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit"), null;
      var i = this.validateAndParseJson(r);
      return !i || !Vl.isServerTelemetryEntity(n, i) ? (this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit"), null) : (this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit"), _r.toObject(new Vl(), i));
    }, e.prototype.setServerTelemetry = function(n, r) {
      this.logger.trace("BrowserCacheManager.setServerTelemetry called"), this.setItem(n, JSON.stringify(r));
    }, e.prototype.getAuthorityMetadata = function(n) {
      var r = this.internalStorage.getItem(n);
      if (!r)
        return this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit"), null;
      var i = this.validateAndParseJson(r);
      return i && zf.isAuthorityMetadataEntity(n, i) ? (this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit"), _r.toObject(new zf(), i)) : null;
    }, e.prototype.getAuthorityMetadataKeys = function() {
      var n = this, r = this.internalStorage.getKeys();
      return r.filter(function(i) {
        return n.isAuthorityMetadata(i);
      });
    }, e.prototype.setWrapperMetadata = function(n, r) {
      this.internalStorage.setItem(ta.WRAPPER_SKU, n), this.internalStorage.setItem(ta.WRAPPER_VER, r);
    }, e.prototype.getWrapperMetadata = function() {
      var n = this.internalStorage.getItem(ta.WRAPPER_SKU) || M.EMPTY_STRING, r = this.internalStorage.getItem(ta.WRAPPER_VER) || M.EMPTY_STRING;
      return [n, r];
    }, e.prototype.setAuthorityMetadata = function(n, r) {
      this.logger.trace("BrowserCacheManager.setAuthorityMetadata called"), this.internalStorage.setItem(n, JSON.stringify(r));
    }, e.prototype.getActiveAccount = function() {
      var n = this.generateCacheKey(mn.ACTIVE_ACCOUNT_FILTERS), r = this.getItem(n);
      if (!r) {
        this.logger.trace("No active account filters cache schema found, looking for legacy schema");
        var i = this.generateCacheKey(mn.ACTIVE_ACCOUNT), o = this.getItem(i);
        if (!o)
          return this.logger.trace("No active account found"), null;
        var a = this.getAccountInfoByFilter({ localAccountId: o })[0] || null;
        return a ? (this.logger.trace("Legacy active account cache schema found"), this.logger.trace("Adding active account filters cache schema"), this.setActiveAccount(a), a) : null;
      }
      var s = this.validateAndParseJson(r);
      return s ? (this.logger.trace("Active account filters schema found"), this.getAccountInfoByFilter({
        homeAccountId: s.homeAccountId,
        localAccountId: s.localAccountId
      })[0] || null) : (this.logger.trace("No active account found"), null);
    }, e.prototype.setActiveAccount = function(n) {
      var r = this.generateCacheKey(mn.ACTIVE_ACCOUNT_FILTERS), i = this.generateCacheKey(mn.ACTIVE_ACCOUNT);
      if (n) {
        this.logger.verbose("setActiveAccount: Active account set");
        var o = {
          homeAccountId: n.homeAccountId,
          localAccountId: n.localAccountId
        };
        this.browserStorage.setItem(r, JSON.stringify(o)), this.browserStorage.setItem(i, n.localAccountId);
      } else
        this.logger.verbose("setActiveAccount: No account passed, active account not set"), this.browserStorage.removeItem(r), this.browserStorage.removeItem(i);
    }, e.prototype.getAccountInfoByFilter = function(n) {
      var r = this.getAllAccounts();
      return r.filter(function(i) {
        return !(n.username && n.username.toLowerCase() !== i.username.toLowerCase() || n.homeAccountId && n.homeAccountId !== i.homeAccountId || n.localAccountId && n.localAccountId !== i.localAccountId || n.tenantId && n.tenantId !== i.tenantId || n.environment && n.environment !== i.environment);
      });
    }, e.prototype.getAccountInfoByHints = function(n, r) {
      var i = this.getAllAccounts().filter(function(o) {
        if (r) {
          var a = o.idTokenClaims && o.idTokenClaims.sid;
          return r === a;
        }
        return n ? n === o.username : !1;
      });
      if (i.length === 1)
        return i[0];
      if (i.length > 1)
        throw ge.createMultipleMatchingAccountsInCacheError();
      return null;
    }, e.prototype.getThrottlingCache = function(n) {
      var r = this.getItem(n);
      if (!r)
        return this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit"), null;
      var i = this.validateAndParseJson(r);
      return !i || !Wm.isThrottlingEntity(n, i) ? (this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit"), null) : (this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit"), _r.toObject(new Wm(), i));
    }, e.prototype.setThrottlingCache = function(n, r) {
      this.logger.trace("BrowserCacheManager.setThrottlingCache called"), this.setItem(n, JSON.stringify(r));
    }, e.prototype.getTemporaryCache = function(n, r) {
      var i = r ? this.generateCacheKey(n) : n;
      if (this.cacheConfig.storeAuthStateInCookie) {
        var o = this.getItemCookie(i);
        if (o)
          return this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies"), o;
      }
      var a = this.temporaryCacheStorage.getItem(i);
      if (!a) {
        if (this.cacheConfig.cacheLocation === xn.LocalStorage) {
          var s = this.browserStorage.getItem(i);
          if (s)
            return this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage"), s;
        }
        return this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage"), null;
      }
      return this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned"), a;
    }, e.prototype.setTemporaryCache = function(n, r, i) {
      var o = i ? this.generateCacheKey(n) : n;
      this.temporaryCacheStorage.setItem(o, r), this.cacheConfig.storeAuthStateInCookie && (this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie"), this.setItemCookie(o, r));
    }, e.prototype.removeItem = function(n) {
      return this.browserStorage.removeItem(n), this.temporaryCacheStorage.removeItem(n), this.cacheConfig.storeAuthStateInCookie && (this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie"), this.clearItemCookie(n)), !0;
    }, e.prototype.containsKey = function(n) {
      return this.browserStorage.containsKey(n) || this.temporaryCacheStorage.containsKey(n);
    }, e.prototype.getKeys = function() {
      return Nw(this.browserStorage.getKeys(), this.temporaryCacheStorage.getKeys());
    }, e.prototype.clear = function() {
      return re(this, void 0, void 0, function() {
        var n = this;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.removeAllAccounts()];
            case 1:
              return r.sent(), this.removeAppMetadata(), this.getKeys().forEach(function(i) {
                (n.browserStorage.containsKey(i) || n.temporaryCacheStorage.containsKey(i)) && (i.indexOf(M.CACHE_PREFIX) !== -1 || i.indexOf(n.clientId) !== -1) && n.removeItem(i);
              }), this.internalStorage.clear(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.setItemCookie = function(n, r, i) {
      var o = encodeURIComponent(n) + "=" + encodeURIComponent(r) + ";path=/;SameSite=Lax;";
      if (i) {
        var a = this.getCookieExpirationTime(i);
        o += "expires=" + a + ";";
      }
      this.cacheConfig.secureCookies && (o += "Secure;"), document.cookie = o;
    }, e.prototype.getItemCookie = function(n) {
      for (var r = encodeURIComponent(n) + "=", i = document.cookie.split(";"), o = 0; o < i.length; o++) {
        for (var a = i[o]; a.charAt(0) === " "; )
          a = a.substring(1);
        if (a.indexOf(r) === 0)
          return decodeURIComponent(a.substring(r.length, a.length));
      }
      return M.EMPTY_STRING;
    }, e.prototype.clearMsalCookies = function() {
      var n = this, r = M.CACHE_PREFIX + "." + this.clientId, i = document.cookie.split(";");
      i.forEach(function(o) {
        for (; o.charAt(0) === " "; )
          o = o.substring(1);
        if (o.indexOf(r) === 0) {
          var a = o.split("=")[0];
          n.clearItemCookie(a);
        }
      });
    }, e.prototype.clearItemCookie = function(n) {
      this.setItemCookie(n, M.EMPTY_STRING, -1);
    }, e.prototype.getCookieExpirationTime = function(n) {
      var r = /* @__PURE__ */ new Date(), i = new Date(r.getTime() + n * this.COOKIE_LIFE_MULTIPLIER);
      return i.toUTCString();
    }, e.prototype.getCache = function() {
      return this.browserStorage;
    }, e.prototype.setCache = function() {
    }, e.prototype.generateCacheKey = function(n) {
      var r = this.validateAndParseJson(n);
      return r ? JSON.stringify(n) : ce.startsWith(n, M.CACHE_PREFIX) || ce.startsWith(n, mn.ADAL_ID_TOKEN) ? n : M.CACHE_PREFIX + "." + this.clientId + "." + n;
    }, e.prototype.generateAuthorityKey = function(n) {
      var r = ci.parseRequestState(this.cryptoImpl, n).libraryState.id;
      return this.generateCacheKey(yt.AUTHORITY + "." + r);
    }, e.prototype.generateNonceKey = function(n) {
      var r = ci.parseRequestState(this.cryptoImpl, n).libraryState.id;
      return this.generateCacheKey(yt.NONCE_IDTOKEN + "." + r);
    }, e.prototype.generateStateKey = function(n) {
      var r = ci.parseRequestState(this.cryptoImpl, n).libraryState.id;
      return this.generateCacheKey(yt.REQUEST_STATE + "." + r);
    }, e.prototype.getCachedAuthority = function(n) {
      var r = this.generateStateKey(n), i = this.getTemporaryCache(r);
      if (!i)
        return null;
      var o = this.generateAuthorityKey(i);
      return this.getTemporaryCache(o);
    }, e.prototype.updateCacheEntries = function(n, r, i, o, a) {
      this.logger.trace("BrowserCacheManager.updateCacheEntries called");
      var s = this.generateStateKey(n);
      this.setTemporaryCache(s, n, !1);
      var c = this.generateNonceKey(n);
      this.setTemporaryCache(c, r, !1);
      var l = this.generateAuthorityKey(n);
      if (this.setTemporaryCache(l, i, !1), a) {
        var u = {
          credential: a.homeAccountId,
          type: Zn.HOME_ACCOUNT_ID
        };
        this.setTemporaryCache(yt.CCS_CREDENTIAL, JSON.stringify(u), !0);
      } else if (!ce.isEmpty(o)) {
        var u = {
          credential: o,
          type: Zn.UPN
        };
        this.setTemporaryCache(yt.CCS_CREDENTIAL, JSON.stringify(u), !0);
      }
    }, e.prototype.resetRequestCache = function(n) {
      var r = this;
      this.logger.trace("BrowserCacheManager.resetRequestCache called"), ce.isEmpty(n) || this.getKeys().forEach(function(i) {
        i.indexOf(n) !== -1 && r.removeItem(i);
      }), n && (this.removeItem(this.generateStateKey(n)), this.removeItem(this.generateNonceKey(n)), this.removeItem(this.generateAuthorityKey(n))), this.removeItem(this.generateCacheKey(yt.REQUEST_PARAMS)), this.removeItem(this.generateCacheKey(yt.ORIGIN_URI)), this.removeItem(this.generateCacheKey(yt.URL_HASH)), this.removeItem(this.generateCacheKey(yt.CORRELATION_ID)), this.removeItem(this.generateCacheKey(yt.CCS_CREDENTIAL)), this.removeItem(this.generateCacheKey(yt.NATIVE_REQUEST)), this.setInteractionInProgress(!1);
    }, e.prototype.cleanRequestByState = function(n) {
      if (this.logger.trace("BrowserCacheManager.cleanRequestByState called"), n) {
        var r = this.generateStateKey(n), i = this.temporaryCacheStorage.getItem(r);
        this.logger.infoPii("BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: " + i), this.resetRequestCache(i || M.EMPTY_STRING);
      }
      this.clearMsalCookies();
    }, e.prototype.cleanRequestByInteractionType = function(n) {
      var r = this;
      this.logger.trace("BrowserCacheManager.cleanRequestByInteractionType called"), this.getKeys().forEach(function(i) {
        if (i.indexOf(yt.REQUEST_STATE) !== -1) {
          var o = r.temporaryCacheStorage.getItem(i);
          if (o) {
            var a = Bw.extractBrowserRequestState(r.cryptoImpl, o);
            a && a.interactionType === n && (r.logger.infoPii("BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: " + o), r.resetRequestCache(o));
          }
        }
      }), this.clearMsalCookies(), this.setInteractionInProgress(!1);
    }, e.prototype.cacheCodeRequest = function(n, r) {
      this.logger.trace("BrowserCacheManager.cacheCodeRequest called");
      var i = r.base64Encode(JSON.stringify(n));
      this.setTemporaryCache(yt.REQUEST_PARAMS, i, !0);
    }, e.prototype.getCachedRequest = function(n, r) {
      this.logger.trace("BrowserCacheManager.getCachedRequest called");
      var i = this.getTemporaryCache(yt.REQUEST_PARAMS, !0);
      if (!i)
        throw se.createNoTokenRequestCacheError();
      var o = this.validateAndParseJson(r.base64Decode(i));
      if (!o)
        throw se.createUnableToParseTokenRequestCacheError();
      if (this.removeItem(this.generateCacheKey(yt.REQUEST_PARAMS)), ce.isEmpty(o.authority)) {
        var a = this.generateAuthorityKey(n), s = this.getTemporaryCache(a);
        if (!s)
          throw se.createNoCachedAuthorityError();
        o.authority = s;
      }
      return o;
    }, e.prototype.getCachedNativeRequest = function() {
      this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
      var n = this.getTemporaryCache(yt.NATIVE_REQUEST, !0);
      if (!n)
        return this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found"), null;
      var r = this.validateAndParseJson(n);
      return r || (this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request"), null);
    }, e.prototype.isInteractionInProgress = function(n) {
      var r = this.getInteractionInProgress();
      return n ? r === this.clientId : !!r;
    }, e.prototype.getInteractionInProgress = function() {
      var n = M.CACHE_PREFIX + "." + yt.INTERACTION_STATUS_KEY;
      return this.getTemporaryCache(n, !1);
    }, e.prototype.setInteractionInProgress = function(n) {
      var r = M.CACHE_PREFIX + "." + yt.INTERACTION_STATUS_KEY;
      if (n) {
        if (this.getInteractionInProgress())
          throw se.createInteractionInProgressError();
        this.setTemporaryCache(r, this.clientId, !1);
      } else
        !n && this.getInteractionInProgress() === this.clientId && this.removeItem(r);
    }, e.prototype.getLegacyLoginHint = function() {
      var n = this.getTemporaryCache(mn.ADAL_ID_TOKEN);
      n && (this.browserStorage.removeItem(mn.ADAL_ID_TOKEN), this.logger.verbose("Cached ADAL id token retrieved."));
      var r = this.getTemporaryCache(mn.ID_TOKEN, !0);
      r && (this.removeItem(this.generateCacheKey(mn.ID_TOKEN)), this.logger.verbose("Cached MSAL.js v1 id token retrieved"));
      var i = r || n;
      if (i) {
        var o = new Br(i, this.cryptoImpl);
        if (o.claims && o.claims.preferred_username)
          return this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 preferred_username as loginHint"), o.claims.preferred_username;
        if (o.claims && o.claims.upn)
          return this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 upn as loginHint"), o.claims.upn;
        this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, however, no account hint claim found. Enable preferred_username or upn id token claim to get SSO.");
      }
      return null;
    }, e.prototype.updateCredentialCacheKey = function(n, r) {
      var i = r.generateCredentialKey();
      if (n !== i) {
        var o = this.getItem(n);
        if (o)
          return this.removeItem(n), this.setItem(i, o), this.logger.verbose("Updated an outdated " + r.credentialType + " cache key"), i;
        this.logger.error("Attempted to update an outdated " + r.credentialType + " cache key but no item matching the outdated key was found in storage");
      }
      return n;
    }, e;
  }(_r)
), PI = function(t, e) {
  var n = {
    cacheLocation: xn.MemoryStorage,
    storeAuthStateInCookie: !1,
    secureCookies: !1
  };
  return new Gf(t, n, Dl, e);
};
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var kd = "@azure/msal-browser", Os = "2.28.0";
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var DI = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.sendGetRequestAsync = function(e, n) {
      return re(this, void 0, void 0, function() {
        var r, i, o;
        return ie(this, function(a) {
          switch (a.label) {
            case 0:
              return a.trys.push([0, 2, , 3]), [4, fetch(e, {
                method: Pr.GET,
                headers: this.getFetchHeaders(n)
              })];
            case 1:
              return r = a.sent(), [3, 3];
            case 2:
              throw i = a.sent(), window.navigator.onLine ? se.createGetRequestFailedError(i, e) : se.createNoNetworkConnectivityError();
            case 3:
              return a.trys.push([3, 5, , 6]), o = {
                headers: this.getHeaderDict(r.headers)
              }, [4, r.json()];
            case 4:
              return [2, (o.body = a.sent(), o.status = r.status, o)];
            case 5:
              throw a.sent(), se.createFailedToParseNetworkResponseError(e);
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.sendPostRequestAsync = function(e, n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a;
        return ie(this, function(s) {
          switch (s.label) {
            case 0:
              r = n && n.body || M.EMPTY_STRING, s.label = 1;
            case 1:
              return s.trys.push([1, 3, , 4]), [4, fetch(e, {
                method: Pr.POST,
                headers: this.getFetchHeaders(n),
                body: r
              })];
            case 2:
              return i = s.sent(), [3, 4];
            case 3:
              throw o = s.sent(), window.navigator.onLine ? se.createPostRequestFailedError(o, e) : se.createNoNetworkConnectivityError();
            case 4:
              return s.trys.push([4, 6, , 7]), a = {
                headers: this.getHeaderDict(i.headers)
              }, [4, i.json()];
            case 5:
              return [2, (a.body = s.sent(), a.status = i.status, a)];
            case 6:
              throw s.sent(), se.createFailedToParseNetworkResponseError(e);
            case 7:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getFetchHeaders = function(e) {
      var n = new Headers();
      if (!(e && e.headers))
        return n;
      var r = e.headers;
      return Object.keys(r).forEach(function(i) {
        n.append(i, r[i]);
      }), n;
    }, t.prototype.getHeaderDict = function(e) {
      var n = {};
      return e.forEach(function(r, i) {
        n[i] = r;
      }), n;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var LI = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.sendGetRequestAsync = function(e, n) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(r) {
          return [2, this.sendRequestAsync(e, Pr.GET, n)];
        });
      });
    }, t.prototype.sendPostRequestAsync = function(e, n) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(r) {
          return [2, this.sendRequestAsync(e, Pr.POST, n)];
        });
      });
    }, t.prototype.sendRequestAsync = function(e, n, r) {
      var i = this;
      return new Promise(function(o, a) {
        var s = new XMLHttpRequest();
        if (s.open(
          n,
          e,
          /* async: */
          !0
        ), i.setXhrHeaders(s, r), s.onload = function() {
          (s.status < 200 || s.status >= 300) && (n === Pr.POST ? a(se.createPostRequestFailedError("Failed with status " + s.status, e)) : a(se.createGetRequestFailedError("Failed with status " + s.status, e)));
          try {
            var c = JSON.parse(s.responseText), l = {
              headers: i.getHeaderDict(s),
              body: c,
              status: s.status
            };
            o(l);
          } catch {
            a(se.createFailedToParseNetworkResponseError(e));
          }
        }, s.onerror = function() {
          window.navigator.onLine ? n === Pr.POST ? a(se.createPostRequestFailedError("Failed with status " + s.status, e)) : a(se.createGetRequestFailedError("Failed with status " + s.status, e)) : a(se.createNoNetworkConnectivityError());
        }, n === Pr.POST && r && r.body)
          s.send(r.body);
        else if (n === Pr.GET)
          s.send();
        else
          throw se.createHttpMethodNotImplementedError(n);
      });
    }, t.prototype.setXhrHeaders = function(e, n) {
      if (n && n.headers) {
        var r = n.headers;
        Object.keys(r).forEach(function(i) {
          e.setRequestHeader(i, r[i]);
        });
      }
    }, t.prototype.getHeaderDict = function(e) {
      var n = e.getAllResponseHeaders(), r = n.trim().split(/[\r\n]+/), i = {};
      return r.forEach(function(o) {
        var a = o.split(": "), s = a.shift(), c = a.join(": ");
        s && c && (i[s] = c);
      }), i;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var rn = (
  /** @class */
  function() {
    function t() {
    }
    return t.clearHash = function(e) {
      e.location.hash = M.EMPTY_STRING, typeof e.history.replaceState == "function" && e.history.replaceState(null, M.EMPTY_STRING, "" + e.location.origin + e.location.pathname + e.location.search);
    }, t.replaceHash = function(e) {
      var n = e.split("#");
      n.shift(), window.location.hash = n.length > 0 ? n.join("#") : M.EMPTY_STRING;
    }, t.isInIframe = function() {
      return window.parent !== window;
    }, t.isInPopup = function() {
      return typeof window < "u" && !!window.opener && window.opener !== window && typeof window.name == "string" && window.name.indexOf(Hn.POPUP_NAME_PREFIX + ".") === 0;
    }, t.getCurrentUri = function() {
      return window.location.href.split("?")[0].split("#")[0];
    }, t.getHomepage = function() {
      var e = new mt(window.location.href), n = e.getUrlComponents();
      return n.Protocol + "//" + n.HostNameAndPort + "/";
    }, t.getBrowserNetworkClient = function() {
      return window.fetch && window.Headers ? new DI() : new LI();
    }, t.blockReloadInHiddenIframes = function() {
      var e = mt.hashContainsKnownProperties(window.location.hash);
      if (e && t.isInIframe())
        throw se.createBlockReloadInHiddenIframeError();
    }, t.blockRedirectInIframe = function(e, n) {
      var r = t.isInIframe();
      if (e === be.Redirect && r && !n)
        throw se.createRedirectInIframeError(r);
    }, t.blockAcquireTokenInPopups = function() {
      if (t.isInPopup())
        throw se.createBlockAcquireTokenInPopupsError();
    }, t.blockNonBrowserEnvironment = function(e) {
      if (!e)
        throw se.createNonBrowserEnvironmentError();
    }, t.blockNativeBrokerCalledBeforeInitialized = function(e, n) {
      if (e && !n)
        throw se.createNativeBrokerCalledBeforeInitialize();
    }, t.detectIEOrEdge = function() {
      var e = window.navigator.userAgent, n = e.indexOf("MSIE "), r = e.indexOf("Trident/"), i = e.indexOf("Edge/"), o = n > 0 || r > 0, a = i > 0;
      return o || a;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var jw = (
  /** @class */
  function() {
    function t(e, n, r, i, o, a, s, c, l) {
      this.config = e, this.browserStorage = n, this.browserCrypto = r, this.networkClient = this.config.system.networkClient, this.eventHandler = o, this.navigationClient = a, this.nativeMessageHandler = c, this.correlationId = l || this.browserCrypto.createNewGuid(), this.logger = i.clone(Hn.MSAL_SKU, Os, this.correlationId), this.performanceClient = s;
    }
    return t.prototype.clearCacheOnLogout = function(e) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(n) {
          switch (n.label) {
            case 0:
              if (!e)
                return [3, 5];
              Nn.accountInfoIsEqual(e, this.browserStorage.getActiveAccount(), !1) && (this.logger.verbose("Setting active account to null"), this.browserStorage.setActiveAccount(null)), n.label = 1;
            case 1:
              return n.trys.push([1, 3, , 4]), [4, this.browserStorage.removeAccount(Nn.generateAccountCacheKey(e))];
            case 2:
              return n.sent(), this.logger.verbose("Cleared cache items belonging to the account provided in the logout request."), [3, 4];
            case 3:
              return n.sent(), this.logger.error("Account provided in logout request was not found. Local cache unchanged."), [3, 4];
            case 4:
              return [3, 9];
            case 5:
              return n.trys.push([5, 8, , 9]), this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId), [4, this.browserStorage.clear()];
            case 6:
              return n.sent(), [4, this.browserCrypto.clearKeystore()];
            case 7:
              return n.sent(), [3, 9];
            case 8:
              return n.sent(), this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged."), [3, 9];
            case 9:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.initializeBaseRequest = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r, i, o;
        return ie(this, function(a) {
          switch (a.label) {
            case 0:
              if (this.logger.verbose("Initializing BaseAuthRequest"), n = e.authority || this.config.auth.authority, r = Nw(e && e.scopes || []), i = Se(Se({}, e), {
                correlationId: this.correlationId,
                authority: n,
                scopes: r
              }), !i.authenticationScheme)
                i.authenticationScheme = St.BEARER, this.logger.verbose(`Authentication Scheme wasn't explicitly set in request, defaulting to "Bearer" request`);
              else {
                if (i.authenticationScheme === St.SSH) {
                  if (!e.sshJwk)
                    throw zt.createMissingSshJwkError();
                  if (!e.sshKid)
                    throw zt.createMissingSshKidError();
                }
                this.logger.verbose('Authentication Scheme set to "' + i.authenticationScheme + '" as configured in Auth request');
              }
              return e.claims && !ce.isEmpty(e.claims) ? (o = i, [4, this.browserCrypto.hashString(e.claims)]) : [3, 2];
            case 1:
              o.requestedClaimsHash = a.sent(), a.label = 2;
            case 2:
              return [2, i];
          }
        });
      });
    }, t.prototype.getRedirectUri = function(e) {
      this.logger.verbose("getRedirectUri called");
      var n = e || this.config.auth.redirectUri || rn.getCurrentUri();
      return mt.getAbsoluteUrl(n, rn.getCurrentUri());
    }, t.prototype.initializeServerTelemetryManager = function(e, n) {
      this.logger.verbose("initializeServerTelemetryManager called");
      var r = {
        clientId: this.config.auth.clientId,
        correlationId: this.correlationId,
        apiId: e,
        forceRefresh: n || !1,
        wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
        wrapperVer: this.browserStorage.getWrapperMetadata()[1]
      };
      return new OI(r, this.browserStorage);
    }, t.prototype.getDiscoveredAuthority = function(e) {
      return re(this, void 0, void 0, function() {
        var n;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              return this.logger.verbose("getDiscoveredAuthority called"), n = {
                protocolMode: this.config.auth.protocolMode,
                knownAuthorities: this.config.auth.knownAuthorities,
                cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                authorityMetadata: this.config.auth.authorityMetadata
              }, e ? (this.logger.verbose("Creating discovered authority with request authority"), [4, jl.createDiscoveredInstance(e, this.config.system.networkClient, this.browserStorage, n)]) : [3, 2];
            case 1:
              return [2, r.sent()];
            case 2:
              return this.logger.verbose("Creating discovered authority with configured authority"), [4, jl.createDiscoveredInstance(this.config.auth.authority, this.config.system.networkClient, this.browserStorage, n)];
            case 3:
              return [2, r.sent()];
          }
        });
      });
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Ba = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.initializeAuthorizationCodeRequest = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i;
        return ie(this, function(o) {
          switch (o.label) {
            case 0:
              return this.logger.verbose("initializeAuthorizationRequest called", n.correlationId), [4, this.browserCrypto.generatePkceCodes()];
            case 1:
              return r = o.sent(), i = Se(Se({}, n), { redirectUri: n.redirectUri, code: M.EMPTY_STRING, codeVerifier: r.verifier }), n.codeChallenge = r.challenge, n.codeChallengeMethod = M.S256_CODE_CHALLENGE_METHOD, [2, i];
          }
        });
      });
    }, e.prototype.initializeLogoutRequest = function(n) {
      this.logger.verbose("initializeLogoutRequest called", n == null ? void 0 : n.correlationId);
      var r = Se({ correlationId: this.correlationId || this.browserCrypto.createNewGuid() }, n);
      if (n)
        if (n.logoutHint)
          this.logger.verbose("logoutHint has already been set in logoutRequest");
        else if (n.account) {
          var i = this.getLogoutHintFromIdTokenClaims(n.account);
          i && (this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided"), r.logoutHint = i);
        } else
          this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
      else
        this.logger.verbose("logoutHint will not be set since no logout request was configured");
      return !n || n.postLogoutRedirectUri !== null ? n && n.postLogoutRedirectUri ? (this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", r.correlationId), r.postLogoutRedirectUri = mt.getAbsoluteUrl(n.postLogoutRedirectUri, rn.getCurrentUri())) : this.config.auth.postLogoutRedirectUri === null ? this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", r.correlationId) : this.config.auth.postLogoutRedirectUri ? (this.logger.verbose("Setting postLogoutRedirectUri to configured uri", r.correlationId), r.postLogoutRedirectUri = mt.getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, rn.getCurrentUri())) : (this.logger.verbose("Setting postLogoutRedirectUri to current page", r.correlationId), r.postLogoutRedirectUri = mt.getAbsoluteUrl(rn.getCurrentUri(), rn.getCurrentUri())) : this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", r.correlationId), r;
    }, e.prototype.getLogoutHintFromIdTokenClaims = function(n) {
      var r = n.idTokenClaims;
      if (r) {
        if (r.login_hint)
          return r.login_hint;
        this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
      } else
        this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
      return null;
    }, e.prototype.createAuthCodeClient = function(n, r, i) {
      return re(this, void 0, void 0, function() {
        var o;
        return ie(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.getClientConfiguration(n, r, i)];
            case 1:
              return o = a.sent(), [2, new Lw(o)];
          }
        });
      });
    }, e.prototype.getClientConfiguration = function(n, r, i) {
      return re(this, void 0, void 0, function() {
        var o;
        return ie(this, function(a) {
          switch (a.label) {
            case 0:
              return this.logger.verbose("getClientConfiguration called", this.correlationId), [4, this.getDiscoveredAuthority(r, i)];
            case 1:
              return o = a.sent(), [2, {
                authOptions: {
                  clientId: this.config.auth.clientId,
                  authority: o,
                  clientCapabilities: this.config.auth.clientCapabilities
                },
                systemOptions: {
                  tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                  preventCorsPreflight: !0
                },
                loggerOptions: {
                  loggerCallback: this.config.system.loggerOptions.loggerCallback,
                  piiLoggingEnabled: this.config.system.loggerOptions.piiLoggingEnabled,
                  logLevel: this.config.system.loggerOptions.logLevel,
                  correlationId: this.correlationId
                },
                cryptoInterface: this.browserCrypto,
                networkInterface: this.networkClient,
                storageInterface: this.browserStorage,
                serverTelemetryManager: n,
                libraryInfo: {
                  sku: Hn.MSAL_SKU,
                  version: Os,
                  cpu: M.EMPTY_STRING,
                  os: M.EMPTY_STRING
                },
                telemetry: this.config.telemetry
              }];
          }
        });
      });
    }, e.prototype.validateAndExtractStateFromHash = function(n, r, i) {
      if (this.logger.verbose("validateAndExtractStateFromHash called", i), !n.state)
        throw se.createHashDoesNotContainStateError();
      var o = Bw.extractBrowserRequestState(this.browserCrypto, n.state);
      if (!o)
        throw se.createUnableToParseStateError();
      if (o.interactionType !== r)
        throw se.createStateInteractionTypeMismatchError();
      return this.logger.verbose("Returning state from hash", i), n.state;
    }, e.prototype.getDiscoveredAuthority = function(n, r) {
      return re(this, void 0, void 0, function() {
        var i, o, a, s;
        return ie(this, function(c) {
          switch (c.label) {
            case 0:
              return this.logger.verbose("getDiscoveredAuthority called", this.correlationId), i = this.performanceClient.startMeasurement(hn.StandardInteractionClientGetDiscoveredAuthority, this.correlationId), o = {
                protocolMode: this.config.auth.protocolMode,
                knownAuthorities: this.config.auth.knownAuthorities,
                cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
                authorityMetadata: this.config.auth.authorityMetadata,
                skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
              }, a = n || this.config.auth.authority, s = Bl.generateAuthority(a, r || this.config.auth.azureCloudOptions), this.logger.verbose("Creating discovered authority with configured authority", this.correlationId), [4, jl.createDiscoveredInstance(s, this.config.system.networkClient, this.browserStorage, o).then(function(l) {
                return i.endMeasurement({
                  success: !0
                }), l;
              }).catch(function(l) {
                throw i.endMeasurement({
                  errorCode: l.errorCode,
                  subErrorCode: l.subError,
                  success: !1
                }), l;
              })];
            case 1:
              return [2, c.sent()];
          }
        });
      });
    }, e.prototype.initializeAuthorizationRequest = function(n, r) {
      return re(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u;
        return ie(this, function(d) {
          switch (d.label) {
            case 0:
              return this.logger.verbose("initializeAuthorizationRequest called", this.correlationId), i = this.getRedirectUri(n.redirectUri), o = {
                interactionType: r
              }, a = ci.setRequestState(this.browserCrypto, n && n.state || M.EMPTY_STRING, o), c = [{}], [4, this.initializeBaseRequest(n)];
            case 1:
              return s = Se.apply(void 0, [Se.apply(void 0, c.concat([d.sent()])), { redirectUri: i, state: a, nonce: n.nonce || this.browserCrypto.createNewGuid(), responseMode: Rl.FRAGMENT }]), l = n.account || this.browserStorage.getActiveAccount(), l && (this.logger.verbose("Setting validated request account", this.correlationId), this.logger.verbosePii("Setting validated request account: " + l.homeAccountId, this.correlationId), s.account = l), ce.isEmpty(s.loginHint) && !l && (u = this.browserStorage.getLegacyLoginHint(), u && (s.loginHint = u)), [2, s];
          }
        });
      });
    }, e;
  }(jw)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Rp = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      this.authModule = e, this.browserStorage = n, this.authCodeRequest = r, this.logger = i;
    }
    return t.prototype.handleCodeResponseFromHash = function(e, n, r, i) {
      return re(this, void 0, void 0, function() {
        var o, a, s;
        return ie(this, function(c) {
          if (this.logger.verbose("InteractionHandler.handleCodeResponse called"), ce.isEmpty(e))
            throw se.createEmptyHashError(e);
          if (o = this.browserStorage.generateStateKey(n), a = this.browserStorage.getTemporaryCache(o), !a)
            throw ge.createStateNotFoundError("Cached State");
          try {
            s = this.authModule.handleFragmentResponse(e, a);
          } catch (l) {
            throw l instanceof bo && l.subError === ee.userCancelledError.code ? se.createUserCancelledError() : l;
          }
          return [2, this.handleCodeResponseFromServer(s, n, r, i)];
        });
      });
    }, t.prototype.handleCodeResponseFromServer = function(e, n, r, i, o) {
      return o === void 0 && (o = !0), re(this, void 0, void 0, function() {
        var a, s, c, l, u, d;
        return ie(this, function(f) {
          switch (f.label) {
            case 0:
              if (this.logger.trace("InteractionHandler.handleCodeResponseFromServer called"), a = this.browserStorage.generateStateKey(n), s = this.browserStorage.getTemporaryCache(a), !s)
                throw ge.createStateNotFoundError("Cached State");
              return c = this.browserStorage.generateNonceKey(s), l = this.browserStorage.getTemporaryCache(c), this.authCodeRequest.code = e.code, e.cloud_instance_host_name ? [4, this.updateTokenEndpointAuthority(e.cloud_instance_host_name, r, i)] : [3, 2];
            case 1:
              f.sent(), f.label = 2;
            case 2:
              return o && (e.nonce = l || void 0), e.state = s, e.client_info ? this.authCodeRequest.clientInfo = e.client_info : (u = this.checkCcsCredentials(), u && (this.authCodeRequest.ccsCredential = u)), [4, this.authModule.acquireToken(this.authCodeRequest, e)];
            case 3:
              return d = f.sent(), this.browserStorage.cleanRequestByState(n), [2, d];
          }
        });
      });
    }, t.prototype.updateTokenEndpointAuthority = function(e, n, r) {
      return re(this, void 0, void 0, function() {
        var i, o;
        return ie(this, function(a) {
          switch (a.label) {
            case 0:
              return i = "https://" + e + "/" + n.tenant + "/", [4, jl.createDiscoveredInstance(i, r, this.browserStorage, n.options)];
            case 1:
              return o = a.sent(), this.authModule.updateAuthority(o), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.checkCcsCredentials = function() {
      var e = this.browserStorage.getTemporaryCache(yt.CCS_CREDENTIAL, !0);
      if (e)
        try {
          return JSON.parse(e);
        } catch {
          this.authModule.logger.error("Cache credential could not be parsed"), this.authModule.logger.errorPii("Cache credential could not be parsed: " + e);
        }
      return null;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Xm = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o, a) {
      var s = t.call(this, n, r, i, o) || this;
      return s.browserCrypto = a, s;
    }
    return e.prototype.initiateAuthRequest = function(n, r) {
      return re(this, void 0, void 0, function() {
        var i, o;
        return ie(this, function(a) {
          switch (a.label) {
            case 0:
              return this.logger.verbose("RedirectHandler.initiateAuthRequest called"), ce.isEmpty(n) ? [3, 7] : (r.redirectStartPage && (this.logger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set, caching start page"), this.browserStorage.setTemporaryCache(yt.ORIGIN_URI, r.redirectStartPage, !0)), this.browserStorage.setTemporaryCache(yt.CORRELATION_ID, this.authCodeRequest.correlationId, !0), this.browserStorage.cacheCodeRequest(this.authCodeRequest, this.browserCrypto), this.logger.infoPii("RedirectHandler.initiateAuthRequest: Navigate to: " + n), i = {
                apiId: Bt.acquireTokenRedirect,
                timeout: r.redirectTimeout,
                noHistory: !1
              }, typeof r.onRedirectNavigate != "function" ? [3, 4] : (this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback"), o = r.onRedirectNavigate(n), o === !1 ? [3, 2] : (this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating"), [4, r.navigationClient.navigateExternal(n, i)])));
            case 1:
              return a.sent(), [
                2
                /*return*/
              ];
            case 2:
              return this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation"), [
                2
                /*return*/
              ];
            case 3:
              return [3, 6];
            case 4:
              return this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url"), [4, r.navigationClient.navigateExternal(n, i)];
            case 5:
              return a.sent(), [
                2
                /*return*/
              ];
            case 6:
              return [3, 8];
            case 7:
              throw this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty"), se.createEmptyNavigationUriError();
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.handleCodeResponseFromHash = function(n, r, i, o) {
      return re(this, void 0, void 0, function() {
        var a, s, c, l, u, d, f;
        return ie(this, function(h) {
          switch (h.label) {
            case 0:
              if (this.logger.verbose("RedirectHandler.handleCodeResponse called"), ce.isEmpty(n))
                throw se.createEmptyHashError(n);
              if (this.browserStorage.setInteractionInProgress(!1), a = this.browserStorage.generateStateKey(r), s = this.browserStorage.getTemporaryCache(a), !s)
                throw ge.createStateNotFoundError("Cached State");
              try {
                c = this.authModule.handleFragmentResponse(n, s);
              } catch (g) {
                throw g instanceof bo && g.subError === ee.userCancelledError.code ? se.createUserCancelledError() : g;
              }
              return l = this.browserStorage.generateNonceKey(s), u = this.browserStorage.getTemporaryCache(l), this.authCodeRequest.code = c.code, c.cloud_instance_host_name ? [4, this.updateTokenEndpointAuthority(c.cloud_instance_host_name, i, o)] : [3, 2];
            case 1:
              h.sent(), h.label = 2;
            case 2:
              return c.nonce = u || void 0, c.state = s, c.client_info ? this.authCodeRequest.clientInfo = c.client_info : (d = this.checkCcsCredentials(), d && (this.authCodeRequest.ccsCredential = d)), [4, this.authModule.acquireToken(this.authCodeRequest, c)];
            case 3:
              return f = h.sent(), this.browserStorage.cleanRequestByState(r), [2, f];
          }
        });
      });
    }, e;
  }(Rp)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Be;
(function(t) {
  t.INITIALIZE_START = "msal:initializeStart", t.INITIALIZE_END = "msal:initializeEnd", t.ACCOUNT_ADDED = "msal:accountAdded", t.ACCOUNT_REMOVED = "msal:accountRemoved", t.LOGIN_START = "msal:loginStart", t.LOGIN_SUCCESS = "msal:loginSuccess", t.LOGIN_FAILURE = "msal:loginFailure", t.ACQUIRE_TOKEN_START = "msal:acquireTokenStart", t.ACQUIRE_TOKEN_SUCCESS = "msal:acquireTokenSuccess", t.ACQUIRE_TOKEN_FAILURE = "msal:acquireTokenFailure", t.ACQUIRE_TOKEN_NETWORK_START = "msal:acquireTokenFromNetworkStart", t.SSO_SILENT_START = "msal:ssoSilentStart", t.SSO_SILENT_SUCCESS = "msal:ssoSilentSuccess", t.SSO_SILENT_FAILURE = "msal:ssoSilentFailure", t.ACQUIRE_TOKEN_BY_CODE_START = "msal:acquireTokenByCodeStart", t.ACQUIRE_TOKEN_BY_CODE_SUCCESS = "msal:acquireTokenByCodeSuccess", t.ACQUIRE_TOKEN_BY_CODE_FAILURE = "msal:acquireTokenByCodeFailure", t.HANDLE_REDIRECT_START = "msal:handleRedirectStart", t.HANDLE_REDIRECT_END = "msal:handleRedirectEnd", t.POPUP_OPENED = "msal:popupOpened", t.LOGOUT_START = "msal:logoutStart", t.LOGOUT_SUCCESS = "msal:logoutSuccess", t.LOGOUT_FAILURE = "msal:logoutFailure", t.LOGOUT_END = "msal:logoutEnd";
})(Be || (Be = {}));
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Oi;
(function(t) {
  t.USER_INTERACTION_REQUIRED = "USER_INTERACTION_REQUIRED", t.USER_CANCEL = "USER_CANCEL", t.NO_NETWORK = "NO_NETWORK", t.TRANSIENT_ERROR = "TRANSIENT_ERROR", t.PERSISTENT_ERROR = "PERSISTENT_ERROR", t.DISABLED = "DISABLED", t.ACCOUNT_UNAVAILABLE = "ACCOUNT_UNAVAILABLE";
})(Oi || (Oi = {}));
var os = {
  extensionError: {
    code: "ContentError"
  },
  userSwitch: {
    code: "user_switch",
    desc: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
  },
  tokensNotFoundInCache: {
    code: "tokens_not_found_in_internal_memory_cache",
    desc: "Tokens not cached in MSAL JS internal memory, please make the WAM request"
  }
}, Lr = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i) {
      var o = t.call(this, n, r) || this;
      return Object.setPrototypeOf(o, e.prototype), o.name = "NativeAuthError", o.ext = i, o;
    }
    return e.prototype.isFatal = function() {
      if (this.ext && this.ext.status && (this.ext.status === Oi.PERSISTENT_ERROR || this.ext.status === Oi.DISABLED))
        return !0;
      switch (this.errorCode) {
        case os.extensionError.code:
          return !0;
        default:
          return !1;
      }
    }, e.createError = function(n, r, i) {
      if (i && i.status)
        switch (i.status) {
          case Oi.ACCOUNT_UNAVAILABLE:
            return Cr.createNativeAccountUnavailableError();
          case Oi.USER_INTERACTION_REQUIRED:
            return new Cr(n, r);
          case Oi.USER_CANCEL:
            return se.createUserCancelledError();
          case Oi.NO_NETWORK:
            return se.createNoNetworkConnectivityError();
        }
      return new e(n, r, i);
    }, e.createUserSwitchError = function() {
      return new e(os.userSwitch.code, os.userSwitch.desc);
    }, e.createTokensNotFoundInCacheError = function() {
      return new e(os.tokensNotFoundInCache.code, os.tokensNotFoundInCache.desc);
    }, e;
  }(Ie)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var Vw = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.acquireToken = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s;
        return ie(this, function(c) {
          switch (c.label) {
            case 0:
              return r = this.performanceClient.startMeasurement(hn.SilentCacheClientAcquireToken, n.correlationId), i = this.initializeServerTelemetryManager(Bt.acquireTokenSilent_silentFlow), [4, this.createSilentFlowClient(i, n.authority, n.azureCloudOptions)];
            case 1:
              o = c.sent(), this.logger.verbose("Silent auth client created"), c.label = 2;
            case 2:
              return c.trys.push([2, 4, , 5]), [4, o.acquireCachedToken(n)];
            case 3:
              return a = c.sent(), r.endMeasurement({
                success: !0,
                fromCache: !0
              }), [2, a];
            case 4:
              throw s = c.sent(), s instanceof se && s.errorCode === ee.signingKeyNotFoundInStorage.code && this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair."), r.endMeasurement({
                errorCode: s instanceof Ie && s.errorCode || void 0,
                subErrorCode: s instanceof Ie && s.subError || void 0,
                success: !1
              }), s;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.logout = function() {
      return Promise.reject(se.createSilentLogoutUnsupportedError());
    }, e.prototype.createSilentFlowClient = function(n, r, i) {
      return re(this, void 0, void 0, function() {
        var o;
        return ie(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.getClientConfiguration(n, r, i)];
            case 1:
              return o = a.sent(), [2, new CI(o)];
          }
        });
      });
    }, e.prototype.initializeSilentRequest = function(n, r) {
      return re(this, void 0, void 0, function() {
        var i;
        return ie(this, function(o) {
          switch (o.label) {
            case 0:
              return i = [Se({}, n)], [4, this.initializeBaseRequest(n)];
            case 1:
              return [2, Se.apply(void 0, [Se.apply(void 0, i.concat([o.sent()])), { account: r, forceRefresh: n.forceRefresh || !1 }])];
          }
        });
      });
    }, e;
  }(Ba)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var aa = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o, a, s, c, l, u, d, f, h) {
      var g = t.call(this, n, r, i, o, a, s, l, u, h) || this;
      return g.apiId = c, g.accountId = d, g.nativeMessageHandler = u, g.nativeStorageManager = f, g.silentCacheClient = new Vw(n, g.nativeStorageManager, i, o, a, s, l, u, h), g;
    }
    return e.prototype.acquireToken = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l;
        return ie(this, function(u) {
          switch (u.label) {
            case 0:
              return this.logger.trace("NativeInteractionClient - acquireToken called."), r = this.performanceClient.startMeasurement(hn.NativeInteractionClientAcquireToken, n.correlationId), i = fr.nowSeconds(), [4, this.initializeNativeRequest(n)];
            case 1:
              o = u.sent(), u.label = 2;
            case 2:
              return u.trys.push([2, 4, , 5]), [4, this.acquireTokensFromCache(this.accountId, o)];
            case 3:
              return a = u.sent(), r.endMeasurement({
                success: !0,
                isNativeBroker: !0,
                fromCache: !0
              }), [2, a];
            case 4:
              return u.sent(), this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call"), [3, 5];
            case 5:
              return s = {
                method: ii.GetToken,
                request: o
              }, [4, this.nativeMessageHandler.sendMessage(s)];
            case 6:
              return c = u.sent(), l = this.validateNativeResponse(c), [2, this.handleNativeResponse(l, o, i).then(function(d) {
                return r.endMeasurement({
                  success: !0,
                  isNativeBroker: !0
                }), d;
              }).catch(function(d) {
                throw r.endMeasurement({
                  success: !1,
                  errorCode: d.errorCode,
                  subErrorCode: d.subError,
                  isNativeBroker: !0
                }), d;
              })];
          }
        });
      });
    }, e.prototype.createSilentCacheRequest = function(n, r) {
      return {
        authority: n.authority,
        correlationId: this.correlationId,
        scopes: Bn.fromString(n.scopes).asArray(),
        account: r,
        forceRefresh: !1
      };
    }, e.prototype.acquireTokensFromCache = function(n, r) {
      return re(this, void 0, void 0, function() {
        var i, o, a, s, c;
        return ie(this, function(l) {
          switch (l.label) {
            case 0:
              if (i = this.browserStorage.readAccountFromCacheWithNativeAccountId(n), !i)
                throw ge.createNoAccountFoundError();
              o = i.getAccountInfo(), l.label = 1;
            case 1:
              return l.trys.push([1, 3, , 4]), a = this.createSilentCacheRequest(r, o), [4, this.silentCacheClient.acquireToken(a)];
            case 2:
              return s = l.sent(), [2, s];
            case 3:
              throw c = l.sent(), c;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.acquireTokenRedirect = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c;
        return ie(this, function(l) {
          switch (l.label) {
            case 0:
              return this.logger.trace("NativeInteractionClient - acquireTokenRedirect called."), [4, this.initializeNativeRequest(n)];
            case 1:
              r = l.sent(), i = {
                method: ii.GetToken,
                request: r
              }, l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, this.nativeMessageHandler.sendMessage(i)];
            case 3:
              return o = l.sent(), this.validateNativeResponse(o), [3, 5];
            case 4:
              if (a = l.sent(), a instanceof Lr && a.isFatal())
                throw a;
              return [3, 5];
            case 5:
              return this.browserStorage.setTemporaryCache(yt.NATIVE_REQUEST, JSON.stringify(r), !0), s = {
                apiId: Bt.acquireTokenRedirect,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: !1
              }, c = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(n.redirectUri), [4, this.navigationClient.navigateExternal(c, s)];
            case 6:
              return l.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.handleRedirectPromise = function() {
      return re(this, void 0, void 0, function() {
        var n, r, i, o, a, s;
        return ie(this, function(c) {
          switch (c.label) {
            case 0:
              if (this.logger.trace("NativeInteractionClient - handleRedirectPromise called."), !this.browserStorage.isInteractionInProgress(!0))
                return this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null."), [2, null];
              if (n = this.browserStorage.getCachedNativeRequest(), !n)
                return this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null."), [2, null];
              this.browserStorage.removeItem(this.browserStorage.generateCacheKey(yt.NATIVE_REQUEST)), r = {
                method: ii.GetToken,
                request: n
              }, i = fr.nowSeconds(), c.label = 1;
            case 1:
              return c.trys.push([1, 3, , 4]), this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker."), [4, this.nativeMessageHandler.sendMessage(r)];
            case 2:
              return o = c.sent(), this.validateNativeResponse(o), a = this.handleNativeResponse(o, n, i), this.browserStorage.setInteractionInProgress(!1), [2, a];
            case 3:
              throw s = c.sent(), this.browserStorage.setInteractionInProgress(!1), s;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.logout = function() {
      return this.logger.trace("NativeInteractionClient - logout called."), Promise.reject("Logout not implemented yet");
    }, e.prototype.handleNativeResponse = function(n, r, i) {
      return re(this, void 0, void 0, function() {
        var o, a, s, c, l, u, d, f, h, g, v, b, m, y, p, w, _, E, S, T, x = this;
        return ie(this, function(A) {
          switch (A.label) {
            case 0:
              if (this.logger.trace("NativeInteractionClient - handleNativeResponse called."), n.account.id !== r.accountId)
                throw Lr.createUserSwitchError();
              return o = new Br(n.id_token || M.EMPTY_STRING, this.browserCrypto), [4, this.getDiscoveredAuthority(r.authority)];
            case 1:
              switch (a = A.sent(), s = a.getPreferredCache(), c = Nn.generateHomeAccountId(n.client_info || M.EMPTY_STRING, ur.Default, this.logger, this.browserCrypto, o), l = Nn.createAccount(n.client_info, c, o, void 0, void 0, void 0, s, n.account.id), this.browserStorage.setAccount(l), u = n.scopes ? Bn.fromString(n.scopes) : Bn.fromString(r.scopes), d = n.account.properties || {}, f = d.UID || o.claims.oid || o.claims.sub || M.EMPTY_STRING, h = d.TenantId || o.claims.tid || M.EMPTY_STRING, v = St.BEARER, b = r.tokenType, b) {
                case St.POP:
                  return [3, 2];
              }
              return [3, 4];
            case 2:
              if (v = St.POP, n.shr)
                return this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer"), g = n.shr, [3, 5];
              if (m = new wa(this.browserCrypto), y = {
                resourceRequestMethod: r.resourceRequestMethod,
                resourceRequestUri: r.resourceRequestUri,
                shrClaims: r.shrClaims,
                shrNonce: r.shrNonce
              }, !r.keyId)
                throw ge.createKeyIdMissingError();
              return [4, m.signPopToken(n.access_token, r.keyId, y)];
            case 3:
              return g = A.sent(), [3, 5];
            case 4:
              g = n.access_token, A.label = 5;
            case 5:
              return p = this.getMATSFromResponse(n), w = {
                authority: a.canonicalAuthority,
                uniqueId: f,
                tenantId: h,
                scopes: u.asArray(),
                account: l.getAccountInfo(),
                idToken: n.id_token,
                idTokenClaims: o.claims,
                accessToken: g,
                fromCache: p ? this.isResponseFromCache(p) : !1,
                expiresOn: new Date(Number(i + n.expires_in) * 1e3),
                tokenType: v,
                correlationId: this.correlationId,
                state: n.state,
                fromNativeBroker: !0
              }, _ = js.createIdTokenEntity(c, r.authority, n.id_token || M.EMPTY_STRING, r.clientId, o.claims.tid || M.EMPTY_STRING), this.nativeStorageManager.setIdTokenCredential(_), E = v === St.POP ? M.SHR_NONCE_VALIDITY : (typeof n.expires_in == "string" ? parseInt(n.expires_in, 10) : n.expires_in) || 0, S = i + E, T = Vs.createAccessTokenEntity(c, r.authority, g, r.clientId, h, u.printScopes(), S, 0, this.browserCrypto), this.nativeStorageManager.setAccessTokenCredential(T), this.browserStorage.removeAccountContext(l).catch(function(N) {
                x.logger.error("Error occurred while removing account context from browser storage. " + N);
              }), [2, w];
          }
        });
      });
    }, e.prototype.validateNativeResponse = function(n) {
      if (n.hasOwnProperty("access_token") && n.hasOwnProperty("id_token") && n.hasOwnProperty("client_info") && n.hasOwnProperty("account") && n.hasOwnProperty("scopes") && n.hasOwnProperty("expires_in"))
        return n;
      throw Lr.createUnexpectedError("Response missing expected properties.");
    }, e.prototype.getMATSFromResponse = function(n) {
      if (n.properties.MATS)
        try {
          return JSON.parse(n.properties.MATS);
        } catch {
          this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
      return null;
    }, e.prototype.isResponseFromCache = function(n) {
      return typeof n.is_cached > "u" ? (this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false."), !1) : !!n.is_cached;
    }, e.prototype.initializeNativeRequest = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l, u, d, f = this;
        return ie(this, function(h) {
          switch (h.label) {
            case 0:
              return this.logger.trace("NativeInteractionClient - initializeNativeRequest called"), r = n.authority || this.config.auth.authority, i = new mt(r), i.validateAsUri(), o = n && n.scopes || [], a = new Bn(o), a.appendScopes(lc), s = function() {
                switch (f.apiId) {
                  case Bt.ssoSilent:
                  case Bt.acquireTokenSilent_silentFlow:
                    return f.logger.trace("initializeNativeRequest: silent request sets prompt to none"), Rn.NONE;
                }
                if (!n.prompt) {
                  f.logger.trace("initializeNativeRequest: prompt was not provided");
                  return;
                }
                switch (n.prompt) {
                  case Rn.NONE:
                  case Rn.CONSENT:
                  case Rn.LOGIN:
                    return f.logger.trace("initializeNativeRequest: prompt is compatible with native flow"), n.prompt;
                  default:
                    throw f.logger.trace("initializeNativeRequest: prompt = " + n.prompt + " is not compatible with native flow"), se.createNativePromptParameterNotSupportedError();
                }
              }, c = Se(Se({}, n), {
                accountId: this.accountId,
                clientId: this.config.auth.clientId,
                authority: i.urlString,
                scopes: a.printScopes(),
                redirectUri: this.getRedirectUri(n.redirectUri),
                prompt: s(),
                correlationId: this.correlationId,
                tokenType: n.authenticationScheme,
                windowTitleSubstring: document.title,
                extraParameters: Se(Se(Se({}, n.extraQueryParameters), n.tokenQueryParameters), { telemetry: vs.MATS_TELEMETRY }),
                extendedExpiryToken: !1
                // Make this configurable?
              }), n.authenticationScheme !== St.POP ? [3, 2] : (l = {
                resourceRequestUri: n.resourceRequestUri,
                resourceRequestMethod: n.resourceRequestMethod,
                shrClaims: n.shrClaims,
                shrNonce: n.shrNonce
              }, u = new wa(this.browserCrypto), [4, u.generateCnf(l)]);
            case 1:
              d = h.sent(), c.reqCnf = d.reqCnfHash, c.keyId = d.kid, h.label = 2;
            case 2:
              return [2, c];
          }
        });
      });
    }, e;
  }(jw)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var go = (
  /** @class */
  function() {
    function t(e, n, r) {
      this.logger = e, this.handshakeTimeoutMs = n, this.extensionId = r, this.resolvers = /* @__PURE__ */ new Map(), this.handshakeResolvers = /* @__PURE__ */ new Map(), this.responseId = 0, this.messageChannel = new MessageChannel(), this.windowListener = this.onWindowMessage.bind(this);
    }
    return t.prototype.sendMessage = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r = this;
        return ie(this, function(i) {
          return this.logger.trace("NativeMessageHandler - sendMessage called."), n = {
            channel: vs.CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: this.responseId++,
            body: e
          }, this.logger.trace("NativeMessageHandler - Sending request to browser extension"), this.logger.tracePii("NativeMessageHandler - Sending request to browser extension: " + JSON.stringify(n)), this.messageChannel.port1.postMessage(n), [2, new Promise(function(o, a) {
            r.resolvers.set(n.responseId, { resolve: o, reject: a });
          })];
        });
      });
    }, t.createProvider = function(e, n) {
      return re(this, void 0, void 0, function() {
        var r, i;
        return ie(this, function(o) {
          switch (o.label) {
            case 0:
              e.trace("NativeMessageHandler - createProvider called."), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 5]), r = new t(e, n, vs.PREFERRED_EXTENSION_ID), [4, r.sendHandshakeRequest()];
            case 2:
              return o.sent(), [2, r];
            case 3:
              return o.sent(), i = new t(e, n), [4, i.sendHandshakeRequest()];
            case 4:
              return o.sent(), [2, i];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.sendHandshakeRequest = function() {
      return re(this, void 0, void 0, function() {
        var e, n = this;
        return ie(this, function(r) {
          return this.logger.trace("NativeMessageHandler - sendHandshakeRequest called."), window.addEventListener("message", this.windowListener, !1), e = {
            channel: vs.CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: this.responseId++,
            body: {
              method: ii.HandshakeRequest
            }
          }, this.messageChannel.port1.onmessage = function(i) {
            n.onChannelMessage(i);
          }, window.postMessage(e, window.origin, [this.messageChannel.port2]), [2, new Promise(function(i, o) {
            n.handshakeResolvers.set(e.responseId, { resolve: i, reject: o }), n.timeoutId = window.setTimeout(function() {
              window.removeEventListener("message", n.windowListener, !1), n.messageChannel.port1.close(), n.messageChannel.port2.close(), o(se.createNativeHandshakeTimeoutError()), n.handshakeResolvers.delete(e.responseId);
            }, n.handshakeTimeoutMs);
          })];
        });
      });
    }, t.prototype.onWindowMessage = function(e) {
      if (this.logger.trace("NativeMessageHandler - onWindowMessage called"), e.source === window) {
        var n = e.data;
        if (!(!n.channel || n.channel !== vs.CHANNEL_ID) && !(n.extensionId && n.extensionId !== this.extensionId) && n.body.method === ii.HandshakeRequest) {
          this.logger.verbose(n.extensionId ? "Extension with id: " + n.extensionId + " not installed" : "No extension installed"), clearTimeout(this.timeoutId), this.messageChannel.port1.close(), this.messageChannel.port2.close(), window.removeEventListener("message", this.windowListener, !1);
          var r = this.handshakeResolvers.get(n.responseId);
          r && r.reject(se.createNativeExtensionNotInstalledError());
        }
      }
    }, t.prototype.onChannelMessage = function(e) {
      this.logger.trace("NativeMessageHandler - onChannelMessage called.");
      var n = e.data, r = this.resolvers.get(n.responseId), i = this.handshakeResolvers.get(n.responseId);
      try {
        var o = n.body.method;
        if (o === ii.Response) {
          if (!r)
            return;
          var a = n.body.response;
          if (this.logger.trace("NativeMessageHandler - Received response from browser extension"), this.logger.tracePii("NativeMessageHandler - Received response from browser extension: " + JSON.stringify(a)), a.status !== "Success")
            r.reject(Lr.createError(a.code, a.description, a.ext));
          else if (a.result)
            a.result.code && a.result.description ? r.reject(Lr.createError(a.result.code, a.result.description, a.result.ext)) : r.resolve(a.result);
          else
            throw Ie.createUnexpectedError("Event does not contain result.");
          this.resolvers.delete(n.responseId);
        } else if (o === ii.HandshakeResponse) {
          if (!i)
            return;
          clearTimeout(this.timeoutId), window.removeEventListener("message", this.windowListener, !1), this.extensionId = n.extensionId, this.logger.verbose("NativeMessageHandler - Received HandshakeResponse from extension: " + this.extensionId), i.resolve(), this.handshakeResolvers.delete(n.responseId);
        }
      } catch (s) {
        this.logger.error("Error parsing response from WAM Extension"), this.logger.errorPii("Error parsing response from WAM Extension: " + s.toString()), this.logger.errorPii("Unable to parse " + e), r ? r.reject(s) : i && i.reject(s);
      }
    }, t.isNativeAvailable = function(e, n, r, i) {
      if (n.trace("isNativeAvailable called"), !e.system.allowNativeBroker)
        return n.trace("isNativeAvailable: allowNativeBroker is not enabled, returning false"), !1;
      if (!r)
        return n.trace("isNativeAvailable: WAM extension provider is not initialized, returning false"), !1;
      if (i)
        switch (i) {
          case St.BEARER:
          case St.POP:
            return n.trace("isNativeAvailable: authenticationScheme is supported, returning true"), !0;
          default:
            return n.trace("isNativeAvailable: authenticationScheme is not supported, returning false"), !1;
        }
      return !0;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var FI = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o, a, s, c, l, u, d) {
      var f = t.call(this, n, r, i, o, a, s, c, u, d) || this;
      return f.nativeStorage = l, f;
    }
    return e.prototype.acquireToken = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l, u, d, f = this;
        return ie(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, this.initializeAuthorizationRequest(n, be.Redirect)];
            case 1:
              r = h.sent(), this.browserStorage.updateCacheEntries(r.state, r.nonce, r.authority, r.loginHint || M.EMPTY_STRING, r.account || null), i = this.initializeServerTelemetryManager(Bt.acquireTokenRedirect), o = function(g) {
                g.persisted && (f.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache."), f.browserStorage.cleanRequestByState(r.state));
              }, h.label = 2;
            case 2:
              return h.trys.push([2, 7, , 8]), [4, this.initializeAuthorizationCodeRequest(r)];
            case 3:
              return a = h.sent(), [4, this.createAuthCodeClient(i, r.authority, r.azureCloudOptions)];
            case 4:
              return s = h.sent(), this.logger.verbose("Auth code client created"), c = new Xm(s, this.browserStorage, a, this.logger, this.browserCrypto), [4, s.getAuthCodeUrl(Se(Se({}, r), { nativeBroker: go.isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, n.authenticationScheme) }))];
            case 5:
              return l = h.sent(), u = this.getRedirectStartPage(n.redirectStartPage), this.logger.verbosePii("Redirect start page: " + u), window.addEventListener("pageshow", o), [4, c.initiateAuthRequest(l, {
                navigationClient: this.navigationClient,
                redirectTimeout: this.config.system.redirectNavigationTimeout,
                redirectStartPage: u,
                onRedirectNavigate: n.onRedirectNavigate
              })];
            case 6:
              return [2, h.sent()];
            case 7:
              throw d = h.sent(), d instanceof Ie && d.setCorrelationId(this.correlationId), window.removeEventListener("pageshow", o), i.cacheFailedRequest(d), this.browserStorage.cleanRequestByState(r.state), d;
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.handleRedirectPromise = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l, u, d, f, h, g;
        return ie(this, function(v) {
          switch (v.label) {
            case 0:
              r = this.initializeServerTelemetryManager(Bt.handleRedirectPromise), v.label = 1;
            case 1:
              if (v.trys.push([1, 10, , 11]), !this.browserStorage.isInteractionInProgress(!0))
                return this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null."), [2, null];
              if (i = this.getRedirectResponseHash(n || window.location.hash), !i)
                return this.logger.info("handleRedirectPromise did not detect a response hash as a result of a redirect. Cleaning temporary cache."), this.browserStorage.cleanRequestByInteractionType(be.Redirect), [2, null];
              o = void 0;
              try {
                a = mt.getDeserializedHash(i), o = this.validateAndExtractStateFromHash(a, be.Redirect), this.logger.verbose("State extracted from hash");
              } catch (b) {
                return this.logger.info("handleRedirectPromise was unable to extract state due to: " + b), this.browserStorage.cleanRequestByInteractionType(be.Redirect), [2, null];
              }
              return s = this.browserStorage.getTemporaryCache(yt.ORIGIN_URI, !0) || M.EMPTY_STRING, c = mt.removeHashFromUrl(s), l = mt.removeHashFromUrl(window.location.href), c === l && this.config.auth.navigateToLoginRequestUrl ? (this.logger.verbose("Current page is loginRequestUrl, handling hash"), [4, this.handleHash(i, o, r)]) : [3, 3];
            case 2:
              return u = v.sent(), s.indexOf("#") > -1 && rn.replaceHash(s), [2, u];
            case 3:
              return this.config.auth.navigateToLoginRequestUrl ? [3, 4] : (this.logger.verbose("NavigateToLoginRequestUrl set to false, handling hash"), [2, this.handleHash(i, o, r)]);
            case 4:
              return !rn.isInIframe() || this.config.system.allowRedirectInIframe ? (this.browserStorage.setTemporaryCache(yt.URL_HASH, i, !0), d = {
                apiId: Bt.handleRedirectPromise,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: !0
              }, f = !0, !s || s === "null" ? (h = rn.getHomepage(), this.browserStorage.setTemporaryCache(yt.ORIGIN_URI, h, !0), this.logger.warning("Unable to get valid login request url from cache, redirecting to home page"), [4, this.navigationClient.navigateInternal(h, d)]) : [3, 6]) : [3, 9];
            case 5:
              return f = v.sent(), [3, 8];
            case 6:
              return this.logger.verbose("Navigating to loginRequestUrl: " + s), [4, this.navigationClient.navigateInternal(s, d)];
            case 7:
              f = v.sent(), v.label = 8;
            case 8:
              if (!f)
                return [2, this.handleHash(i, o, r)];
              v.label = 9;
            case 9:
              return [2, null];
            case 10:
              throw g = v.sent(), g instanceof Ie && g.setCorrelationId(this.correlationId), r.cacheFailedRequest(g), this.browserStorage.cleanRequestByInteractionType(be.Redirect), g;
            case 11:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getRedirectResponseHash = function(n) {
      this.logger.verbose("getRedirectResponseHash called");
      var r = mt.hashContainsKnownProperties(n);
      if (r)
        return rn.clearHash(window), this.logger.verbose("Hash contains known properties, returning response hash"), n;
      var i = this.browserStorage.getTemporaryCache(yt.URL_HASH, !0);
      return this.browserStorage.removeItem(this.browserStorage.generateCacheKey(yt.URL_HASH)), this.logger.verbose("Hash does not contain known properties, returning cached hash"), i;
    }, e.prototype.handleHash = function(n, r, i) {
      return re(this, void 0, void 0, function() {
        var o, a, s, c, l, u, d, f = this;
        return ie(this, function(h) {
          switch (h.label) {
            case 0:
              if (o = this.browserStorage.getCachedRequest(r, this.browserCrypto), this.logger.verbose("handleHash called, retrieved cached request"), a = mt.getDeserializedHash(n), a.accountId) {
                if (this.logger.verbose("Account id found in hash, calling WAM for token"), !this.nativeMessageHandler)
                  throw se.createNativeConnectionNotEstablishedError();
                return s = new aa(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, Bt.acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, a.accountId, this.browserStorage, o.correlationId), c = ci.parseRequestState(this.browserCrypto, r).userRequestState, [2, s.acquireToken(Se(Se({}, o), {
                  state: c,
                  prompt: void 0
                  // Server should handle the prompt, ideally native broker can do this part silently
                })).finally(function() {
                  f.browserStorage.cleanRequestByState(r);
                })];
              }
              if (l = this.browserStorage.getCachedAuthority(r), !l)
                throw se.createNoCachedAuthorityError();
              return [4, this.createAuthCodeClient(i, l)];
            case 1:
              return u = h.sent(), this.logger.verbose("Auth code client created"), Fl.removeThrottle(this.browserStorage, this.config.auth.clientId, o), d = new Xm(u, this.browserStorage, o, this.logger, this.browserCrypto), [4, d.handleCodeResponseFromHash(n, r, u.authority, this.networkClient)];
            case 2:
              return [2, h.sent()];
          }
        });
      });
    }, e.prototype.logout = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l;
        return ie(this, function(u) {
          switch (u.label) {
            case 0:
              this.logger.verbose("logoutRedirect called"), r = this.initializeLogoutRequest(n), i = this.initializeServerTelemetryManager(Bt.logout), u.label = 1;
            case 1:
              return u.trys.push([1, 10, , 11]), this.eventHandler.emitEvent(Be.LOGOUT_START, be.Redirect, n), [4, this.clearCacheOnLogout(r.account)];
            case 2:
              return u.sent(), o = {
                apiId: Bt.logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: !1
              }, [4, this.createAuthCodeClient(i, n && n.authority)];
            case 3:
              return a = u.sent(), this.logger.verbose("Auth code client created"), s = a.getLogoutUri(r), this.eventHandler.emitEvent(Be.LOGOUT_SUCCESS, be.Redirect, r), n && typeof n.onRedirectNavigate == "function" ? (c = n.onRedirectNavigate(s), c === !1 ? [3, 5] : (this.logger.verbose("Logout onRedirectNavigate did not return false, navigating"), this.browserStorage.getInteractionInProgress() || this.browserStorage.setInteractionInProgress(!0), [4, this.navigationClient.navigateExternal(s, o)])) : [3, 7];
            case 4:
              return u.sent(), [
                2
                /*return*/
              ];
            case 5:
              this.browserStorage.setInteractionInProgress(!1), this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation"), u.label = 6;
            case 6:
              return [3, 9];
            case 7:
              return this.browserStorage.getInteractionInProgress() || this.browserStorage.setInteractionInProgress(!0), [4, this.navigationClient.navigateExternal(s, o)];
            case 8:
              return u.sent(), [
                2
                /*return*/
              ];
            case 9:
              return [3, 11];
            case 10:
              throw l = u.sent(), l instanceof Ie && l.setCorrelationId(this.correlationId), i.cacheFailedRequest(l), this.eventHandler.emitEvent(Be.LOGOUT_FAILURE, be.Redirect, null, l), this.eventHandler.emitEvent(Be.LOGOUT_END, be.Redirect), l;
            case 11:
              return this.eventHandler.emitEvent(Be.LOGOUT_END, be.Redirect), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.getRedirectStartPage = function(n) {
      var r = n || window.location.href;
      return mt.getAbsoluteUrl(r, rn.getCurrentUri());
    }, e;
  }(Ba)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var UI = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o, a, s, c, l, u, d) {
      var f = t.call(this, n, r, i, o, a, s, c, u, d) || this;
      return f.unloadWindow = f.unloadWindow.bind(f), f.nativeStorage = l, f;
    }
    return e.prototype.acquireToken = function(n) {
      try {
        var r = this.generatePopupName(n.scopes || lc, n.authority || this.config.auth.authority), i = n.popupWindowAttributes || {};
        if (this.config.system.asyncPopups)
          return this.logger.verbose("asyncPopups set to true, acquiring token"), this.acquireTokenPopupAsync(n, r, i);
        this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
        var o = this.openSizedPopup("about:blank", r, i);
        return this.acquireTokenPopupAsync(n, r, i, o);
      } catch (a) {
        return Promise.reject(a);
      }
    }, e.prototype.logout = function(n) {
      try {
        this.logger.verbose("logoutPopup called");
        var r = this.initializeLogoutRequest(n), i = this.generateLogoutPopupName(r), o = n && n.authority, a = n && n.mainWindowRedirectUri, s = (n == null ? void 0 : n.popupWindowAttributes) || {};
        if (this.config.system.asyncPopups)
          return this.logger.verbose("asyncPopups set to true"), this.logoutPopupAsync(r, i, s, o, void 0, a);
        this.logger.verbose("asyncPopup set to false, opening popup");
        var c = this.openSizedPopup("about:blank", i, s);
        return this.logoutPopupAsync(r, i, s, o, c, a);
      } catch (l) {
        return Promise.reject(l);
      }
    }, e.prototype.acquireTokenPopupAsync = function(n, r, i, o) {
      return re(this, void 0, void 0, function() {
        var a, s, c, l, u, d, f, h, g, v, b, m, y, p, w, _, E, S = this;
        return ie(this, function(T) {
          switch (T.label) {
            case 0:
              return this.logger.verbose("acquireTokenPopupAsync called"), a = this.initializeServerTelemetryManager(Bt.acquireTokenPopup), [4, this.initializeAuthorizationRequest(n, be.Popup)];
            case 1:
              s = T.sent(), this.browserStorage.updateCacheEntries(s.state, s.nonce, s.authority, s.loginHint || M.EMPTY_STRING, s.account || null), T.label = 2;
            case 2:
              return T.trys.push([2, 8, , 9]), [4, this.initializeAuthorizationCodeRequest(s)];
            case 3:
              return c = T.sent(), [4, this.createAuthCodeClient(a, s.authority, s.azureCloudOptions)];
            case 4:
              return l = T.sent(), this.logger.verbose("Auth code client created"), u = go.isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, n.authenticationScheme), d = void 0, u && (d = this.performanceClient.startMeasurement(hn.FetchAccountIdWithNativeBroker, n.correlationId)), [4, l.getAuthCodeUrl(Se(Se({}, s), { nativeBroker: u }))];
            case 5:
              return f = T.sent(), h = new Rp(l, this.browserStorage, c, this.logger), g = {
                popup: o,
                popupName: r,
                popupWindowAttributes: i
              }, v = this.initiateAuthRequest(f, g), this.eventHandler.emitEvent(Be.POPUP_OPENED, be.Popup, { popupWindow: v }, null), [4, this.monitorPopupForHash(v)];
            case 6:
              if (b = T.sent(), m = mt.getDeserializedHash(b), y = this.validateAndExtractStateFromHash(m, be.Popup, s.correlationId), Fl.removeThrottle(this.browserStorage, this.config.auth.clientId, c), m.accountId) {
                if (this.logger.verbose("Account id found in hash, calling WAM for token"), d && d.endMeasurement({
                  success: !0,
                  isNativeBroker: !0
                }), !this.nativeMessageHandler)
                  throw se.createNativeConnectionNotEstablishedError();
                return p = new aa(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, Bt.acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, m.accountId, this.nativeStorage, s.correlationId), w = ci.parseRequestState(this.browserCrypto, y).userRequestState, [2, p.acquireToken(Se(Se({}, s), {
                  state: w,
                  prompt: void 0
                  // Server should handle the prompt, ideally native broker can do this part silently
                })).finally(function() {
                  S.browserStorage.cleanRequestByState(y);
                })];
              }
              return [4, h.handleCodeResponseFromHash(b, y, l.authority, this.networkClient)];
            case 7:
              return _ = T.sent(), [2, _];
            case 8:
              throw E = T.sent(), o && o.close(), E instanceof Ie && E.setCorrelationId(this.correlationId), a.cacheFailedRequest(E), this.browserStorage.cleanRequestByState(s.state), E;
            case 9:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.logoutPopupAsync = function(n, r, i, o, a, s) {
      return re(this, void 0, void 0, function() {
        var c, l, u, d, f, h, g;
        return ie(this, function(v) {
          switch (v.label) {
            case 0:
              this.logger.verbose("logoutPopupAsync called"), this.eventHandler.emitEvent(Be.LOGOUT_START, be.Popup, n), c = this.initializeServerTelemetryManager(Bt.logoutPopup), v.label = 1;
            case 1:
              return v.trys.push([1, 5, , 6]), [4, this.clearCacheOnLogout(n.account)];
            case 2:
              return v.sent(), [4, this.createAuthCodeClient(c, o)];
            case 3:
              return l = v.sent(), this.logger.verbose("Auth code client created"), u = l.getLogoutUri(n), this.eventHandler.emitEvent(Be.LOGOUT_SUCCESS, be.Popup, n), d = this.openPopup(u, { popupName: r, popupWindowAttributes: i, popup: a }), this.eventHandler.emitEvent(Be.POPUP_OPENED, be.Popup, { popupWindow: d }, null), [4, this.waitForLogoutPopup(d)];
            case 4:
              return v.sent(), s ? (f = {
                apiId: Bt.logoutPopup,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: !1
              }, h = mt.getAbsoluteUrl(s, rn.getCurrentUri()), this.logger.verbose("Redirecting main window to url specified in the request"), this.logger.verbosePii("Redirecting main window to: " + h), this.navigationClient.navigateInternal(h, f)) : this.logger.verbose("No main window navigation requested"), [3, 6];
            case 5:
              throw g = v.sent(), a && a.close(), g instanceof Ie && g.setCorrelationId(this.correlationId), this.browserStorage.setInteractionInProgress(!1), this.eventHandler.emitEvent(Be.LOGOUT_FAILURE, be.Popup, null, g), this.eventHandler.emitEvent(Be.LOGOUT_END, be.Popup), c.cacheFailedRequest(g), g;
            case 6:
              return this.eventHandler.emitEvent(Be.LOGOUT_END, be.Popup), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.initiateAuthRequest = function(n, r) {
      if (ce.isEmpty(n))
        throw this.logger.error("Navigate url is empty"), se.createEmptyNavigationUriError();
      return this.logger.infoPii("Navigate to: " + n), this.openPopup(n, r);
    }, e.prototype.monitorPopupForHash = function(n) {
      var r = this;
      return new Promise(function(i, o) {
        var a = r.config.system.windowHashTimeout / Hn.POLL_INTERVAL_MS, s = 0;
        r.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
        var c = setInterval(function() {
          if (n.closed) {
            r.logger.error("PopupHandler.monitorPopupForHash - window closed"), r.cleanPopup(), clearInterval(c), o(se.createUserCancelledError());
            return;
          }
          var l = M.EMPTY_STRING, u = M.EMPTY_STRING;
          try {
            l = n.location.href, u = n.location.hash;
          } catch {
          }
          ce.isEmpty(l) || l === "about:blank" || (r.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller"), s++, u ? (r.logger.verbose("PopupHandler.monitorPopupForHash - found hash in url"), clearInterval(c), r.cleanPopup(n), mt.hashContainsKnownProperties(u) ? (r.logger.verbose("PopupHandler.monitorPopupForHash - hash contains known properties, returning."), i(u)) : (r.logger.error("PopupHandler.monitorPopupForHash - found hash in url but it does not contain known properties. Check that your router is not changing the hash prematurely."), r.logger.errorPii("PopupHandler.monitorPopupForHash - hash found: " + u), o(se.createHashDoesNotContainKnownPropertiesError()))) : s > a && (r.logger.error("PopupHandler.monitorPopupForHash - unable to find hash in url, timing out"), clearInterval(c), o(se.createMonitorPopupTimeoutError())));
        }, Hn.POLL_INTERVAL_MS);
      });
    }, e.prototype.waitForLogoutPopup = function(n) {
      var r = this;
      return new Promise(function(i) {
        r.logger.verbose("PopupHandler.waitForLogoutPopup - polling started");
        var o = setInterval(function() {
          n.closed && (r.logger.error("PopupHandler.waitForLogoutPopup - window closed"), r.cleanPopup(), clearInterval(o), i());
          var a = M.EMPTY_STRING;
          try {
            a = n.location.href;
          } catch {
          }
          ce.isEmpty(a) || a === "about:blank" || (r.logger.verbose("PopupHandler.waitForLogoutPopup - popup window is on same origin as caller, closing."), clearInterval(o), r.cleanPopup(n), i());
        }, Hn.POLL_INTERVAL_MS);
      });
    }, e.prototype.openPopup = function(n, r) {
      try {
        var i = void 0;
        if (r.popup ? (i = r.popup, this.logger.verbosePii("Navigating popup window to: " + n), i.location.assign(n)) : typeof r.popup > "u" && (this.logger.verbosePii("Opening popup window to: " + n), i = this.openSizedPopup(n, r.popupName, r.popupWindowAttributes)), !i)
          throw se.createEmptyWindowCreatedError();
        return i.focus && i.focus(), this.currentWindow = i, window.addEventListener("beforeunload", this.unloadWindow), i;
      } catch (o) {
        throw this.logger.error("error opening popup " + o.message), this.browserStorage.setInteractionInProgress(!1), se.createPopupWindowError(o.toString());
      }
    }, e.prototype.openSizedPopup = function(n, r, i) {
      var o, a, s, c, l = window.screenLeft ? window.screenLeft : window.screenX, u = window.screenTop ? window.screenTop : window.screenY, d = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, f = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight, h = (o = i.popupSize) === null || o === void 0 ? void 0 : o.width, g = (a = i.popupSize) === null || a === void 0 ? void 0 : a.height, v = (s = i.popupPosition) === null || s === void 0 ? void 0 : s.top, b = (c = i.popupPosition) === null || c === void 0 ? void 0 : c.left;
      return (!h || h < 0 || h > d) && (this.logger.verbose("Default popup window width used. Window width not configured or invalid."), h = Hn.POPUP_WIDTH), (!g || g < 0 || g > f) && (this.logger.verbose("Default popup window height used. Window height not configured or invalid."), g = Hn.POPUP_HEIGHT), (!v || v < 0 || v > f) && (this.logger.verbose("Default popup window top position used. Window top not configured or invalid."), v = Math.max(0, f / 2 - Hn.POPUP_HEIGHT / 2 + u)), (!b || b < 0 || b > d) && (this.logger.verbose("Default popup window left position used. Window left not configured or invalid."), b = Math.max(0, d / 2 - Hn.POPUP_WIDTH / 2 + l)), window.open(n, r, "width=" + h + ", height=" + g + ", top=" + v + ", left=" + b + ", scrollbars=yes");
    }, e.prototype.unloadWindow = function(n) {
      this.browserStorage.cleanRequestByInteractionType(be.Popup), this.currentWindow && this.currentWindow.close(), n.preventDefault();
    }, e.prototype.cleanPopup = function(n) {
      n && n.close(), window.removeEventListener("beforeunload", this.unloadWindow), this.browserStorage.setInteractionInProgress(!1);
    }, e.prototype.generatePopupName = function(n, r) {
      return Hn.POPUP_NAME_PREFIX + "." + this.config.auth.clientId + "." + n.join("-") + "." + r + "." + this.correlationId;
    }, e.prototype.generateLogoutPopupName = function(n) {
      var r = n.account && n.account.homeAccountId;
      return Hn.POPUP_NAME_PREFIX + "." + this.config.auth.clientId + "." + r + "." + this.correlationId;
    }, e;
  }(Ba)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var HI = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.navigateInternal = function(e, n) {
      return t.defaultNavigateWindow(e, n);
    }, t.prototype.navigateExternal = function(e, n) {
      return t.defaultNavigateWindow(e, n);
    }, t.defaultNavigateWindow = function(e, n) {
      return n.noHistory ? window.location.replace(e) : window.location.assign(e), new Promise(function(r) {
        setTimeout(function() {
          r(!0);
        }, n.timeout);
      });
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var BI = 6e4, Yf = 6e3, jI = 3e4, VI = 2e3;
function $I(t, e) {
  var n = t.auth, r = t.cache, i = t.system, o = t.telemetry, a = {
    clientId: M.EMPTY_STRING,
    authority: "" + M.DEFAULT_AUTHORITY,
    knownAuthorities: [],
    cloudDiscoveryMetadata: M.EMPTY_STRING,
    authorityMetadata: M.EMPTY_STRING,
    redirectUri: M.EMPTY_STRING,
    postLogoutRedirectUri: M.EMPTY_STRING,
    navigateToLoginRequestUrl: !0,
    clientCapabilities: [],
    protocolMode: Hl.AAD,
    azureCloudOptions: {
      azureCloudInstance: Hs.None,
      tenant: M.EMPTY_STRING
    },
    skipAuthorityMetadataCache: !1
  }, s = {
    cacheLocation: xn.SessionStorage,
    storeAuthStateInCookie: !1,
    secureCookies: !1
  }, c = {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    loggerCallback: function() {
    },
    logLevel: sn.Info,
    piiLoggingEnabled: !1
  }, l = Se(Se({}, Dw), {
    loggerOptions: c,
    networkClient: e ? rn.getBrowserNetworkClient() : kI,
    navigationClient: new HI(),
    loadFrameTimeout: 0,
    // If loadFrameTimeout is provided, use that as default.
    windowHashTimeout: (i == null ? void 0 : i.loadFrameTimeout) || BI,
    iframeHashTimeout: (i == null ? void 0 : i.loadFrameTimeout) || Yf,
    navigateFrameWait: e && rn.detectIEOrEdge() ? 500 : 0,
    redirectNavigationTimeout: jI,
    asyncPopups: !1,
    allowRedirectInIframe: !1,
    allowNativeBroker: !1,
    nativeBrokerHandshakeTimeout: (i == null ? void 0 : i.nativeBrokerHandshakeTimeout) || VI
  }), u = {
    application: {
      appName: M.EMPTY_STRING,
      appVersion: M.EMPTY_STRING
    }
  }, d = {
    auth: Se(Se({}, a), n),
    cache: Se(Se({}, s), r),
    system: Se(Se({}, l), i),
    telemetry: Se(Se({}, u), o)
  };
  return d;
}
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var $w = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o, a) {
      var s = t.call(this, n, r, i, o) || this;
      return s.navigateFrameWait = a, s;
    }
    return e.prototype.initiateAuthRequest = function(n) {
      return re(this, void 0, void 0, function() {
        var r;
        return ie(this, function(i) {
          switch (i.label) {
            case 0:
              if (ce.isEmpty(n))
                throw this.logger.info("Navigate url is empty"), se.createEmptyNavigationUriError();
              return this.navigateFrameWait ? [4, this.loadFrame(n)] : [3, 2];
            case 1:
              return r = i.sent(), [3, 3];
            case 2:
              r = this.loadFrameSync(n), i.label = 3;
            case 3:
              return [2, r];
          }
        });
      });
    }, e.prototype.monitorIframeForHash = function(n, r) {
      var i = this;
      return new Promise(function(o, a) {
        r < Yf && i.logger.warning("system.loadFrameTimeout or system.iframeHashTimeout set to lower (" + r + "ms) than the default (" + Yf + "ms). This may result in timeouts.");
        var s = window.performance.now(), c = s + r, l = setInterval(function() {
          if (window.performance.now() > c) {
            i.removeHiddenIframe(n), clearInterval(l), a(se.createMonitorIframeTimeoutError());
            return;
          }
          var u = M.EMPTY_STRING, d = n.contentWindow;
          try {
            u = d ? d.location.href : M.EMPTY_STRING;
          } catch {
          }
          if (!ce.isEmpty(u)) {
            var f = d ? d.location.hash : M.EMPTY_STRING;
            if (mt.hashContainsKnownProperties(f)) {
              i.removeHiddenIframe(n), clearInterval(l), o(f);
              return;
            }
          }
        }, Hn.POLL_INTERVAL_MS);
      });
    }, e.prototype.loadFrame = function(n) {
      var r = this;
      return new Promise(function(i, o) {
        var a = r.createHiddenIframe();
        setTimeout(function() {
          if (!a) {
            o("Unable to load iframe");
            return;
          }
          a.src = n, i(a);
        }, r.navigateFrameWait);
      });
    }, e.prototype.loadFrameSync = function(n) {
      var r = this.createHiddenIframe();
      return r.src = n, r;
    }, e.prototype.createHiddenIframe = function() {
      var n = document.createElement("iframe");
      return n.style.visibility = "hidden", n.style.position = "absolute", n.style.width = n.style.height = "0", n.style.border = "0", n.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms"), document.getElementsByTagName("body")[0].appendChild(n), n;
    }, e.prototype.removeHiddenIframe = function(n) {
      document.body === n.parentNode && document.body.removeChild(n);
    }, e;
  }(Rp)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var qI = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o, a, s, c, l, u, d, f) {
      var h = t.call(this, n, r, i, o, a, s, l, d, f) || this;
      return h.apiId = c, h.nativeStorage = u, h;
    }
    return e.prototype.acquireToken = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s;
        return ie(this, function(c) {
          switch (c.label) {
            case 0:
              if (this.logger.verbose("acquireTokenByIframe called"), r = this.performanceClient.startMeasurement(hn.SilentIframeClientAcquireToken, n.correlationId), ce.isEmpty(n.loginHint) && ce.isEmpty(n.sid) && (!n.account || ce.isEmpty(n.account.username)) && this.logger.warning("No user hint provided. The authorization server may need more information to complete this request."), n.prompt && n.prompt !== Rn.NONE)
                throw r.endMeasurement({
                  success: !1
                }), se.createSilentPromptValueError(n.prompt);
              return [4, this.initializeAuthorizationRequest(Se(Se({}, n), { prompt: Rn.NONE }), be.Silent)];
            case 1:
              i = c.sent(), this.browserStorage.updateCacheEntries(i.state, i.nonce, i.authority, i.loginHint || M.EMPTY_STRING, i.account || null), o = this.initializeServerTelemetryManager(this.apiId), c.label = 2;
            case 2:
              return c.trys.push([2, 5, , 6]), [4, this.createAuthCodeClient(o, i.authority, i.azureCloudOptions)];
            case 3:
              return a = c.sent(), this.logger.verbose("Auth code client created"), [4, this.silentTokenHelper(a, i).then(function(l) {
                return r.endMeasurement({
                  success: !0,
                  fromCache: !1
                }), l;
              })];
            case 4:
              return [2, c.sent()];
            case 5:
              throw s = c.sent(), s instanceof Ie && s.setCorrelationId(this.correlationId), o.cacheFailedRequest(s), this.browserStorage.cleanRequestByState(i.state), r.endMeasurement({
                errorCode: s instanceof Ie && s.errorCode || void 0,
                subErrorCode: s instanceof Ie && s.subError || void 0,
                success: !1
              }), s;
            case 6:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.logout = function() {
      return Promise.reject(se.createSilentLogoutUnsupportedError());
    }, e.prototype.silentTokenHelper = function(n, r) {
      return re(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u, d, f, h = this;
        return ie(this, function(g) {
          switch (g.label) {
            case 0:
              return [4, this.initializeAuthorizationCodeRequest(r)];
            case 1:
              return i = g.sent(), [4, n.getAuthCodeUrl(Se(Se({}, r), { nativeBroker: go.isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, r.authenticationScheme) }))];
            case 2:
              return o = g.sent(), a = new $w(n, this.browserStorage, i, this.logger, this.config.system.navigateFrameWait), [4, a.initiateAuthRequest(o)];
            case 3:
              return s = g.sent(), [4, a.monitorIframeForHash(s, this.config.system.iframeHashTimeout)];
            case 4:
              if (c = g.sent(), l = mt.getDeserializedHash(c), u = this.validateAndExtractStateFromHash(l, be.Silent, i.correlationId), l.accountId) {
                if (this.logger.verbose("Account id found in hash, calling WAM for token"), !this.nativeMessageHandler)
                  throw se.createNativeConnectionNotEstablishedError();
                return d = new aa(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.apiId, this.performanceClient, this.nativeMessageHandler, l.accountId, this.browserStorage, this.correlationId), f = ci.parseRequestState(this.browserCrypto, u).userRequestState, [2, d.acquireToken(Se(Se({}, r), { state: f, prompt: Rn.NONE })).finally(function() {
                  h.browserStorage.cleanRequestByState(u);
                })];
              }
              return [2, a.handleCodeResponseFromHash(c, u, n.authority, this.networkClient)];
          }
        });
      });
    }, e;
  }(Ba)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var zI = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.acquireToken = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c = this;
        return ie(this, function(l) {
          switch (l.label) {
            case 0:
              return i = [Se({}, n)], [4, this.initializeBaseRequest(n)];
            case 1:
              return r = Se.apply(void 0, i.concat([l.sent()])), o = this.performanceClient.startMeasurement(hn.SilentRefreshClientAcquireToken, r.correlationId), a = this.initializeServerTelemetryManager(Bt.acquireTokenSilent_silentFlow), [4, this.createRefreshTokenClient(a, r.authority, r.azureCloudOptions)];
            case 2:
              return s = l.sent(), this.logger.verbose("Refresh token client created"), [2, s.acquireTokenByRefreshToken(r).then(function(u) {
                return o.endMeasurement({
                  success: !0,
                  fromCache: u.fromCache
                }), u;
              }).catch(function(u) {
                throw u instanceof Ie && u.setCorrelationId(c.correlationId), a.cacheFailedRequest(u), o.endMeasurement({
                  errorCode: u.errorCode,
                  subErrorCode: u.subError,
                  success: !1
                }), u;
              })];
          }
        });
      });
    }, e.prototype.logout = function() {
      return Promise.reject(se.createSilentLogoutUnsupportedError());
    }, e.prototype.createRefreshTokenClient = function(n, r, i) {
      return re(this, void 0, void 0, function() {
        var o;
        return ie(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.getClientConfiguration(n, r, i)];
            case 1:
              return o = a.sent(), [2, new Fw(o)];
          }
        });
      });
    }, e;
  }(Ba)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var KI = (
  /** @class */
  function() {
    function t(e, n) {
      this.eventCallbacks = /* @__PURE__ */ new Map(), this.logger = e, this.browserCrypto = n, this.listeningToStorageEvents = !1, this.handleAccountCacheChange = this.handleAccountCacheChange.bind(this);
    }
    return t.prototype.addEventCallback = function(e) {
      if (typeof window < "u") {
        var n = this.browserCrypto.createNewGuid();
        return this.eventCallbacks.set(n, e), this.logger.verbose("Event callback registered with id: " + n), n;
      }
      return null;
    }, t.prototype.removeEventCallback = function(e) {
      this.eventCallbacks.delete(e), this.logger.verbose("Event callback " + e + " removed.");
    }, t.prototype.enableAccountStorageEvents = function() {
      typeof window > "u" || (this.listeningToStorageEvents ? this.logger.verbose("Account storage listener already registered.") : (this.logger.verbose("Adding account storage listener."), this.listeningToStorageEvents = !0, window.addEventListener("storage", this.handleAccountCacheChange)));
    }, t.prototype.disableAccountStorageEvents = function() {
      typeof window > "u" || (this.listeningToStorageEvents ? (this.logger.verbose("Removing account storage listener."), window.removeEventListener("storage", this.handleAccountCacheChange), this.listeningToStorageEvents = !1) : this.logger.verbose("No account storage listener registered."));
    }, t.prototype.emitEvent = function(e, n, r, i) {
      var o = this;
      if (typeof window < "u") {
        var a = {
          eventType: e,
          interactionType: n || null,
          payload: r || null,
          error: i || null,
          timestamp: Date.now()
        };
        this.logger.info("Emitting event: " + e), this.eventCallbacks.forEach(function(s, c) {
          o.logger.verbose("Emitting event to callback " + c + ": " + e), s.apply(null, [a]);
        });
      }
    }, t.prototype.handleAccountCacheChange = function(e) {
      try {
        var n = e.newValue || e.oldValue;
        if (!n)
          return;
        var r = JSON.parse(n);
        if (typeof r != "object" || !Nn.isAccountEntity(r))
          return;
        var i = _r.toObject(new Nn(), r), o = i.getAccountInfo();
        !e.oldValue && e.newValue ? (this.logger.info("Account was added to cache in a different window"), this.emitEvent(Be.ACCOUNT_ADDED, void 0, o)) : !e.newValue && e.oldValue && (this.logger.info("Account was removed from cache in a different window"), this.emitEvent(Be.ACCOUNT_REMOVED, void 0, o));
      } catch {
        return;
      }
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var An = (
  /** @class */
  function() {
    function t() {
    }
    return t.decimalToHex = function(e) {
      for (var n = e.toString(16); n.length < 2; )
        n = "0" + n;
      return n;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var qw = (
  /** @class */
  function() {
    function t(e) {
      this.cryptoObj = e;
    }
    return t.prototype.generateGuid = function() {
      try {
        var e = new Uint8Array(16);
        return this.cryptoObj.getRandomValues(e), e[6] |= 64, e[6] &= 79, e[8] |= 128, e[8] &= 191, An.decimalToHex(e[0]) + An.decimalToHex(e[1]) + An.decimalToHex(e[2]) + An.decimalToHex(e[3]) + "-" + An.decimalToHex(e[4]) + An.decimalToHex(e[5]) + "-" + An.decimalToHex(e[6]) + An.decimalToHex(e[7]) + "-" + An.decimalToHex(e[8]) + An.decimalToHex(e[9]) + "-" + An.decimalToHex(e[10]) + An.decimalToHex(e[11]) + An.decimalToHex(e[12]) + An.decimalToHex(e[13]) + An.decimalToHex(e[14]) + An.decimalToHex(e[15]);
      } catch {
        for (var n = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx", r = "0123456789abcdef", i = 0, o = M.EMPTY_STRING, a = 0; a < 36; a++)
          n[a] !== "-" && n[a] !== "4" && (i = Math.random() * 16 | 0), n[a] === "x" ? o += r[i] : n[a] === "y" ? (i &= 3, i |= 8, o += r[i]) : o += n[a];
        return o;
      }
    }, t.prototype.isGuid = function(e) {
      var n = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return n.test(e);
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var sa = (
  /** @class */
  function() {
    function t() {
    }
    return t.stringToUtf8Arr = function(e) {
      for (var n, r = 0, i = e.length, o = 0; o < i; o++)
        n = e.charCodeAt(o), r += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : n < 2097152 ? 4 : n < 67108864 ? 5 : 6;
      for (var a = new Uint8Array(r), s = 0, c = 0; s < r; c++)
        n = e.charCodeAt(c), n < 128 ? a[s++] = n : n < 2048 ? (a[s++] = 192 + (n >>> 6), a[s++] = 128 + (n & 63)) : n < 65536 ? (a[s++] = 224 + (n >>> 12), a[s++] = 128 + (n >>> 6 & 63), a[s++] = 128 + (n & 63)) : n < 2097152 ? (a[s++] = 240 + (n >>> 18), a[s++] = 128 + (n >>> 12 & 63), a[s++] = 128 + (n >>> 6 & 63), a[s++] = 128 + (n & 63)) : n < 67108864 ? (a[s++] = 248 + (n >>> 24), a[s++] = 128 + (n >>> 18 & 63), a[s++] = 128 + (n >>> 12 & 63), a[s++] = 128 + (n >>> 6 & 63), a[s++] = 128 + (n & 63)) : (a[s++] = 252 + (n >>> 30), a[s++] = 128 + (n >>> 24 & 63), a[s++] = 128 + (n >>> 18 & 63), a[s++] = 128 + (n >>> 12 & 63), a[s++] = 128 + (n >>> 6 & 63), a[s++] = 128 + (n & 63));
      return a;
    }, t.stringToArrayBuffer = function(e) {
      for (var n = new ArrayBuffer(e.length), r = new Uint8Array(n), i = 0; i < e.length; i++)
        r[i] = e.charCodeAt(i);
      return n;
    }, t.utf8ArrToString = function(e) {
      for (var n = M.EMPTY_STRING, r = void 0, i = e.length, o = 0; o < i; o++)
        r = e[o], n += String.fromCharCode(r > 251 && r < 254 && o + 5 < i ? (
          /* six bytes */
          /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */
          (r - 252) * 1073741824 + (e[++o] - 128 << 24) + (e[++o] - 128 << 18) + (e[++o] - 128 << 12) + (e[++o] - 128 << 6) + e[++o] - 128
        ) : r > 247 && r < 252 && o + 4 < i ? (
          /* five bytes */
          (r - 248 << 24) + (e[++o] - 128 << 18) + (e[++o] - 128 << 12) + (e[++o] - 128 << 6) + e[++o] - 128
        ) : r > 239 && r < 248 && o + 3 < i ? (
          /* four bytes */
          (r - 240 << 18) + (e[++o] - 128 << 12) + (e[++o] - 128 << 6) + e[++o] - 128
        ) : r > 223 && r < 240 && o + 2 < i ? (
          /* three bytes */
          (r - 224 << 12) + (e[++o] - 128 << 6) + e[++o] - 128
        ) : r > 191 && r < 224 && o + 1 < i ? (
          /* two bytes */
          (r - 192 << 6) + e[++o] - 128
        ) : (
          /* nPart < 127 ? */
          /* one byte */
          r
        ));
      return n;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var zw = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.urlEncode = function(e) {
      return encodeURIComponent(this.encode(e).replace(/=/g, M.EMPTY_STRING).replace(/\+/g, "-").replace(/\//g, "_"));
    }, t.prototype.urlEncodeArr = function(e) {
      return this.base64EncArr(e).replace(/=/g, M.EMPTY_STRING).replace(/\+/g, "-").replace(/\//g, "_");
    }, t.prototype.encode = function(e) {
      var n = sa.stringToUtf8Arr(e);
      return this.base64EncArr(n);
    }, t.prototype.base64EncArr = function(e) {
      for (var n = (3 - e.length % 3) % 3, r = M.EMPTY_STRING, i = void 0, o = e.length, a = 0, s = 0; s < o; s++)
        i = s % 3, a |= e[s] << (16 >>> i & 24), (i === 2 || e.length - s === 1) && (r += String.fromCharCode(this.uint6ToB64(a >>> 18 & 63), this.uint6ToB64(a >>> 12 & 63), this.uint6ToB64(a >>> 6 & 63), this.uint6ToB64(a & 63)), a = 0);
      return n === 0 ? r : r.substring(0, r.length - n) + (n === 1 ? "=" : "==");
    }, t.prototype.uint6ToB64 = function(e) {
      return e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e === 62 ? 43 : e === 63 ? 47 : 65;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var WI = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decode = function(e) {
      var n = e.replace(/-/g, "+").replace(/_/g, "/");
      switch (n.length % 4) {
        case 0:
          break;
        case 2:
          n += "==";
          break;
        case 3:
          n += "=";
          break;
        default:
          throw new Error("Invalid base64 string");
      }
      var r = this.base64DecToArr(n);
      return sa.utf8ArrToString(r);
    }, t.prototype.base64DecToArr = function(e, n) {
      for (var r = e.replace(/[^A-Za-z0-9\+\/]/g, M.EMPTY_STRING), i = r.length, o = n ? Math.ceil((i * 3 + 1 >>> 2) / n) * n : i * 3 + 1 >>> 2, a = new Uint8Array(o), s = void 0, c = void 0, l = 0, u = 0, d = 0; d < i; d++)
        if (c = d & 3, l |= this.b64ToUint6(r.charCodeAt(d)) << 18 - 6 * c, c === 3 || i - d === 1) {
          for (s = 0; s < 3 && u < o; s++, u++)
            a[u] = l >>> (16 >>> s & 24) & 255;
          l = 0;
        }
      return a;
    }, t.prototype.b64ToUint6 = function(e) {
      return e > 64 && e < 91 ? e - 65 : e > 96 && e < 123 ? e - 71 : e > 47 && e < 58 ? e + 4 : e === 43 ? 62 : e === 47 ? 63 : 0;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var GI = 32, YI = (
  /** @class */
  function() {
    function t(e) {
      this.base64Encode = new zw(), this.cryptoObj = e;
    }
    return t.prototype.generateCodes = function() {
      return re(this, void 0, void 0, function() {
        var e, n;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              return e = this.generateCodeVerifier(), [4, this.generateCodeChallengeFromVerifier(e)];
            case 1:
              return n = r.sent(), [2, {
                verifier: e,
                challenge: n
              }];
          }
        });
      });
    }, t.prototype.generateCodeVerifier = function() {
      try {
        var e = new Uint8Array(GI);
        this.cryptoObj.getRandomValues(e);
        var n = this.base64Encode.urlEncodeArr(e);
        return n;
      } catch (r) {
        throw se.createPkceNotGeneratedError(r);
      }
    }, t.prototype.generateCodeChallengeFromVerifier = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r;
        return ie(this, function(i) {
          switch (i.label) {
            case 0:
              return i.trys.push([0, 2, , 3]), [4, this.cryptoObj.sha256Digest(e)];
            case 1:
              return n = i.sent(), [2, this.base64Encode.urlEncodeArr(new Uint8Array(n))];
            case 2:
              throw r = i.sent(), se.createPkceNotGeneratedError(r);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var QI = "RSASSA-PKCS1-v1_5", Ad = "SHA-256", JI = 2048, ZI = new Uint8Array([1, 0, 1]), ul = (
  /** @class */
  function() {
    function t(e) {
      if (this.logger = e, !this.hasCryptoAPI())
        throw se.createCryptoNotAvailableError("Browser crypto or msCrypto object not available.");
      this._keygenAlgorithmOptions = {
        name: QI,
        hash: Ad,
        modulusLength: JI,
        publicExponent: ZI
      };
    }
    return t.prototype.sha256Digest = function(e) {
      return re(this, void 0, void 0, function() {
        var n;
        return ie(this, function(r) {
          return n = sa.stringToUtf8Arr(e), [2, this.hasIECrypto() ? this.getMSCryptoDigest(Ad, n) : this.getSubtleCryptoDigest(Ad, n)];
        });
      });
    }, t.prototype.getRandomValues = function(e) {
      var n = window.msCrypto || window.crypto;
      if (!n.getRandomValues)
        throw se.createCryptoNotAvailableError("getRandomValues does not exist.");
      n.getRandomValues(e);
    }, t.prototype.generateKeyPair = function(e, n) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(r) {
          return [2, this.hasIECrypto() ? this.msCryptoGenerateKey(e, n) : window.crypto.subtle.generateKey(this._keygenAlgorithmOptions, e, n)];
        });
      });
    }, t.prototype.exportJwk = function(e) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(n) {
          return [2, this.hasIECrypto() ? this.msCryptoExportJwk(e) : window.crypto.subtle.exportKey(Vc, e)];
        });
      });
    }, t.prototype.importJwk = function(e, n, r) {
      return re(this, void 0, void 0, function() {
        var i, o;
        return ie(this, function(a) {
          return i = t.getJwkString(e), o = sa.stringToArrayBuffer(i), [2, this.hasIECrypto() ? this.msCryptoImportKey(o, n, r) : window.crypto.subtle.importKey(Vc, e, this._keygenAlgorithmOptions, n, r)];
        });
      });
    }, t.prototype.sign = function(e, n) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(r) {
          return [2, this.hasIECrypto() ? this.msCryptoSign(e, n) : window.crypto.subtle.sign(this._keygenAlgorithmOptions, e, n)];
        });
      });
    }, t.prototype.hasCryptoAPI = function() {
      return this.hasIECrypto() || this.hasBrowserCrypto();
    }, t.prototype.hasIECrypto = function() {
      return "msCrypto" in window;
    }, t.prototype.hasBrowserCrypto = function() {
      return "crypto" in window;
    }, t.prototype.getSubtleCryptoDigest = function(e, n) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(r) {
          return [2, window.crypto.subtle.digest(e, n)];
        });
      });
    }, t.prototype.getMSCryptoDigest = function(e, n) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(r) {
          return [2, new Promise(function(i, o) {
            var a = window.msCrypto.subtle.digest(e, n.buffer);
            a.addEventListener("complete", function(s) {
              i(s.target.result);
            }), a.addEventListener("error", function(s) {
              o(s);
            });
          })];
        });
      });
    }, t.prototype.msCryptoGenerateKey = function(e, n) {
      return re(this, void 0, void 0, function() {
        var r = this;
        return ie(this, function(i) {
          return [2, new Promise(function(o, a) {
            var s = window.msCrypto.subtle.generateKey(r._keygenAlgorithmOptions, e, n);
            s.addEventListener("complete", function(c) {
              o(c.target.result);
            }), s.addEventListener("error", function(c) {
              a(c);
            });
          })];
        });
      });
    }, t.prototype.msCryptoExportJwk = function(e) {
      return re(this, void 0, void 0, function() {
        return ie(this, function(n) {
          return [2, new Promise(function(r, i) {
            var o = window.msCrypto.subtle.exportKey(Vc, e);
            o.addEventListener("complete", function(a) {
              var s = a.target.result, c = sa.utf8ArrToString(new Uint8Array(s)).replace(/\r/g, M.EMPTY_STRING).replace(/\n/g, M.EMPTY_STRING).replace(/\t/g, M.EMPTY_STRING).split(" ").join(M.EMPTY_STRING).replace("\0", M.EMPTY_STRING);
              try {
                r(JSON.parse(c));
              } catch (l) {
                i(l);
              }
            }), o.addEventListener("error", function(a) {
              i(a);
            });
          })];
        });
      });
    }, t.prototype.msCryptoImportKey = function(e, n, r) {
      return re(this, void 0, void 0, function() {
        var i = this;
        return ie(this, function(o) {
          return [2, new Promise(function(a, s) {
            var c = window.msCrypto.subtle.importKey(Vc, e, i._keygenAlgorithmOptions, n, r);
            c.addEventListener("complete", function(l) {
              a(l.target.result);
            }), c.addEventListener("error", function(l) {
              s(l);
            });
          })];
        });
      });
    }, t.prototype.msCryptoSign = function(e, n) {
      return re(this, void 0, void 0, function() {
        var r = this;
        return ie(this, function(i) {
          return [2, new Promise(function(o, a) {
            var s = window.msCrypto.subtle.sign(r._keygenAlgorithmOptions, e, n);
            s.addEventListener("complete", function(c) {
              o(c.target.result);
            }), s.addEventListener("error", function(c) {
              a(c);
            });
          })];
        });
      });
    }, t.getJwkString = function(e) {
      return JSON.stringify(e, Object.keys(e).sort());
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var XI = (
  /** @class */
  function() {
    function t() {
      this.dbName = ll, this.version = NI, this.tableName = MI, this.dbOpen = !1;
    }
    return t.prototype.open = function() {
      return re(this, void 0, void 0, function() {
        var e = this;
        return ie(this, function(n) {
          return [2, new Promise(function(r, i) {
            var o = window.indexedDB.open(e.dbName, e.version);
            o.addEventListener("upgradeneeded", function(a) {
              var s = a;
              s.target.result.createObjectStore(e.tableName);
            }), o.addEventListener("success", function(a) {
              var s = a;
              e.db = s.target.result, e.dbOpen = !0, r();
            }), o.addEventListener("error", function() {
              return i(se.createDatabaseUnavailableError());
            });
          })];
        });
      });
    }, t.prototype.closeConnection = function() {
      var e = this.db;
      e && this.dbOpen && (e.close(), this.dbOpen = !1);
    }, t.prototype.validateDbIsOpen = function() {
      return re(this, void 0, void 0, function() {
        return ie(this, function(e) {
          switch (e.label) {
            case 0:
              return this.dbOpen ? [3, 2] : [4, this.open()];
            case 1:
              return [2, e.sent()];
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getItem = function(e) {
      return re(this, void 0, void 0, function() {
        var n = this;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.validateDbIsOpen()];
            case 1:
              return r.sent(), [2, new Promise(function(i, o) {
                if (!n.db)
                  return o(se.createDatabaseNotOpenError());
                var a = n.db.transaction([n.tableName], "readonly"), s = a.objectStore(n.tableName), c = s.get(e);
                c.addEventListener("success", function(l) {
                  var u = l;
                  n.closeConnection(), i(u.target.result);
                }), c.addEventListener("error", function(l) {
                  n.closeConnection(), o(l);
                });
              })];
          }
        });
      });
    }, t.prototype.setItem = function(e, n) {
      return re(this, void 0, void 0, function() {
        var r = this;
        return ie(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.validateDbIsOpen()];
            case 1:
              return i.sent(), [2, new Promise(function(o, a) {
                if (!r.db)
                  return a(se.createDatabaseNotOpenError());
                var s = r.db.transaction([r.tableName], "readwrite"), c = s.objectStore(r.tableName), l = c.put(n, e);
                l.addEventListener("success", function() {
                  r.closeConnection(), o();
                }), l.addEventListener("error", function(u) {
                  r.closeConnection(), a(u);
                });
              })];
          }
        });
      });
    }, t.prototype.removeItem = function(e) {
      return re(this, void 0, void 0, function() {
        var n = this;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.validateDbIsOpen()];
            case 1:
              return r.sent(), [2, new Promise(function(i, o) {
                if (!n.db)
                  return o(se.createDatabaseNotOpenError());
                var a = n.db.transaction([n.tableName], "readwrite"), s = a.objectStore(n.tableName), c = s.delete(e);
                c.addEventListener("success", function() {
                  n.closeConnection(), i();
                }), c.addEventListener("error", function(l) {
                  n.closeConnection(), o(l);
                });
              })];
          }
        });
      });
    }, t.prototype.getKeys = function() {
      return re(this, void 0, void 0, function() {
        var e = this;
        return ie(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.validateDbIsOpen()];
            case 1:
              return n.sent(), [2, new Promise(function(r, i) {
                if (!e.db)
                  return i(se.createDatabaseNotOpenError());
                var o = e.db.transaction([e.tableName], "readonly"), a = o.objectStore(e.tableName), s = a.getAllKeys();
                s.addEventListener("success", function(c) {
                  var l = c;
                  e.closeConnection(), r(l.target.result);
                }), s.addEventListener("error", function(c) {
                  e.closeConnection(), i(c);
                });
              })];
          }
        });
      });
    }, t.prototype.containsKey = function(e) {
      return re(this, void 0, void 0, function() {
        var n = this;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.validateDbIsOpen()];
            case 1:
              return r.sent(), [2, new Promise(function(i, o) {
                if (!n.db)
                  return o(se.createDatabaseNotOpenError());
                var a = n.db.transaction([n.tableName], "readonly"), s = a.objectStore(n.tableName), c = s.count(e);
                c.addEventListener("success", function(l) {
                  var u = l;
                  n.closeConnection(), i(u.target.result === 1);
                }), c.addEventListener("error", function(l) {
                  n.closeConnection(), o(l);
                });
              })];
          }
        });
      });
    }, t.prototype.deleteDatabase = function() {
      return re(this, void 0, void 0, function() {
        var e, n;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              return this.db && this.dbOpen && this.closeConnection(), [4, window.indexedDB.databases()];
            case 1:
              return e = r.sent(), n = e.find(function(i) {
                return i.name === ll;
              }), n ? [2, new Promise(function(i, o) {
                var a = window.indexedDB.deleteDatabase(ll);
                a.addEventListener("success", function() {
                  return i(!0);
                }), a.addEventListener("error", function() {
                  return o(!1);
                });
              })] : [2, !0];
          }
        });
      });
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var ev = (
  /** @class */
  function() {
    function t(e, n) {
      this.inMemoryCache = new Wf(), this.indexedDBCache = new XI(), this.logger = e, this.storeName = n;
    }
    return t.prototype.handleDatabaseAccessError = function(e) {
      if (e instanceof se && e.errorCode === ee.databaseUnavailable.code)
        this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
      else
        throw e;
    }, t.prototype.getItem = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r;
        return ie(this, function(i) {
          switch (i.label) {
            case 0:
              if (n = this.inMemoryCache.getItem(e), n)
                return [3, 4];
              i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage."), [4, this.indexedDBCache.getItem(e)];
            case 2:
              return [2, i.sent()];
            case 3:
              return r = i.sent(), this.handleDatabaseAccessError(r), [3, 4];
            case 4:
              return [2, n];
          }
        });
      });
    }, t.prototype.setItem = function(e, n) {
      return re(this, void 0, void 0, function() {
        var r;
        return ie(this, function(i) {
          switch (i.label) {
            case 0:
              this.inMemoryCache.setItem(e, n), i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), [4, this.indexedDBCache.setItem(e, n)];
            case 2:
              return i.sent(), [3, 4];
            case 3:
              return r = i.sent(), this.handleDatabaseAccessError(r), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.removeItem = function(e) {
      return re(this, void 0, void 0, function() {
        var n;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              this.inMemoryCache.removeItem(e), r.label = 1;
            case 1:
              return r.trys.push([1, 3, , 4]), [4, this.indexedDBCache.removeItem(e)];
            case 2:
              return r.sent(), [3, 4];
            case 3:
              return n = r.sent(), this.handleDatabaseAccessError(n), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getKeys = function() {
      return re(this, void 0, void 0, function() {
        var e, n;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              if (e = this.inMemoryCache.getKeys(), e.length !== 0)
                return [3, 4];
              r.label = 1;
            case 1:
              return r.trys.push([1, 3, , 4]), this.logger.verbose("In-memory cache is empty, now querying persistent storage."), [4, this.indexedDBCache.getKeys()];
            case 2:
              return [2, r.sent()];
            case 3:
              return n = r.sent(), this.handleDatabaseAccessError(n), [3, 4];
            case 4:
              return [2, e];
          }
        });
      });
    }, t.prototype.containsKey = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r;
        return ie(this, function(i) {
          switch (i.label) {
            case 0:
              if (n = this.inMemoryCache.containsKey(e), n)
                return [3, 4];
              i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), this.logger.verbose("Key not found in in-memory cache, now querying persistent storage."), [4, this.indexedDBCache.containsKey(e)];
            case 2:
              return [2, i.sent()];
            case 3:
              return r = i.sent(), this.handleDatabaseAccessError(r), [3, 4];
            case 4:
              return [2, n];
          }
        });
      });
    }, t.prototype.clear = function() {
      return re(this, void 0, void 0, function() {
        var e, n;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              this.logger.verbose("Deleting in-memory keystore " + this.storeName), this.inMemoryCache.clear(), this.logger.verbose("In-memory keystore " + this.storeName + " deleted"), this.logger.verbose("Deleting persistent keystore " + this.storeName), r.label = 1;
            case 1:
              return r.trys.push([1, 3, , 4]), [4, this.indexedDBCache.deleteDatabase()];
            case 2:
              return e = r.sent(), e && this.logger.verbose("Persistent keystore " + this.storeName + " deleted"), [2, e];
            case 3:
              return n = r.sent(), this.handleDatabaseAccessError(n), [2, !1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var $l;
(function(t) {
  t.asymmetricKeys = "asymmetricKeys", t.symmetricKeys = "symmetricKeys";
})($l || ($l = {}));
var eS = (
  /** @class */
  function() {
    function t(e, n) {
      this.logger = e, this.browserCrypto = new ul(this.logger), this.b64Encode = new zw(), this.b64Decode = new WI(), this.guidGenerator = new qw(this.browserCrypto), this.pkceGenerator = new YI(this.browserCrypto), this.cache = {
        asymmetricKeys: new ev(this.logger, $l.asymmetricKeys),
        symmetricKeys: new ev(this.logger, $l.symmetricKeys)
      }, this.performanceClient = n;
    }
    return t.prototype.createNewGuid = function() {
      return this.guidGenerator.generateGuid();
    }, t.prototype.base64Encode = function(e) {
      return this.b64Encode.encode(e);
    }, t.prototype.base64Decode = function(e) {
      return this.b64Decode.decode(e);
    }, t.prototype.generatePkceCodes = function() {
      return re(this, void 0, void 0, function() {
        return ie(this, function(e) {
          return [2, this.pkceGenerator.generateCodes()];
        });
      });
    }, t.prototype.getPublicKeyThumbprint = function(e) {
      var n;
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l, u;
        return ie(this, function(d) {
          switch (d.label) {
            case 0:
              return r = (n = this.performanceClient) === null || n === void 0 ? void 0 : n.startMeasurement(hn.CryptoOptsGetPublicKeyThumbprint, e.correlationId), [4, this.browserCrypto.generateKeyPair(t.EXTRACTABLE, t.POP_KEY_USAGES)];
            case 1:
              return i = d.sent(), [4, this.browserCrypto.exportJwk(i.publicKey)];
            case 2:
              return o = d.sent(), a = {
                e: o.e,
                kty: o.kty,
                n: o.n
              }, s = ul.getJwkString(a), [4, this.hashString(s)];
            case 3:
              return c = d.sent(), [4, this.browserCrypto.exportJwk(i.privateKey)];
            case 4:
              return l = d.sent(), [4, this.browserCrypto.importJwk(l, !1, ["sign"])];
            case 5:
              return u = d.sent(), [4, this.cache.asymmetricKeys.setItem(c, {
                privateKey: u,
                publicKey: i.publicKey,
                requestMethod: e.resourceRequestMethod,
                requestUri: e.resourceRequestUri
              })];
            case 6:
              return d.sent(), r && r.endMeasurement({
                success: !0
              }), [2, c];
          }
        });
      });
    }, t.prototype.removeTokenBindingKey = function(e) {
      return re(this, void 0, void 0, function() {
        var n;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.cache.asymmetricKeys.removeItem(e)];
            case 1:
              return r.sent(), [4, this.cache.asymmetricKeys.containsKey(e)];
            case 2:
              return n = r.sent(), [2, !n];
          }
        });
      });
    }, t.prototype.clearKeystore = function() {
      return re(this, void 0, void 0, function() {
        var e;
        return ie(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 3, , 4]), this.logger.verbose("Deleting in-memory and persistent asymmetric key stores"), [4, this.cache.asymmetricKeys.clear()];
            case 1:
              return n.sent(), this.logger.verbose("Successfully deleted asymmetric key stores"), this.logger.verbose("Deleting in-memory and persistent symmetric key stores"), [4, this.cache.symmetricKeys.clear()];
            case 2:
              return n.sent(), this.logger.verbose("Successfully deleted symmetric key stores"), [2, !0];
            case 3:
              return e = n.sent(), e instanceof Error ? this.logger.error("Clearing keystore failed with error: " + e.message) : this.logger.error("Clearing keystore failed with unknown error"), [2, !1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.signJwt = function(e, n, r) {
      var i;
      return re(this, void 0, void 0, function() {
        var o, a, s, c, l, u, d, f, h, g, v, b, m;
        return ie(this, function(y) {
          switch (y.label) {
            case 0:
              return o = (i = this.performanceClient) === null || i === void 0 ? void 0 : i.startMeasurement(hn.CryptoOptsSignJwt, r), [4, this.cache.asymmetricKeys.getItem(n)];
            case 1:
              if (a = y.sent(), !a)
                throw se.createSigningKeyNotFoundInStorageError(n);
              return [4, this.browserCrypto.exportJwk(a.publicKey)];
            case 2:
              return s = y.sent(), c = ul.getJwkString(s), l = this.b64Encode.urlEncode(JSON.stringify({ kid: n })), u = AI.getShrHeaderString({ kid: l, alg: s.alg }), d = this.b64Encode.urlEncode(u), e.cnf = {
                jwk: JSON.parse(c)
              }, f = this.b64Encode.urlEncode(JSON.stringify(e)), h = d + "." + f, g = sa.stringToArrayBuffer(h), [4, this.browserCrypto.sign(a.privateKey, g)];
            case 3:
              return v = y.sent(), b = this.b64Encode.urlEncodeArr(new Uint8Array(v)), m = h + "." + b, o && o.endMeasurement({
                success: !0
              }), [2, m];
          }
        });
      });
    }, t.prototype.hashString = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r;
        return ie(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.browserCrypto.sha256Digest(e)];
            case 1:
              return n = i.sent(), r = new Uint8Array(n), [2, this.b64Encode.urlEncodeArr(r)];
          }
        });
      });
    }, t.POP_KEY_USAGES = ["sign", "verify"], t.EXTRACTABLE = !0, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var tS = (
  /** @class */
  function() {
    function t(e, n, r, i) {
      this.isBrowserEnvironment = typeof window < "u", this.config = e, this.storage = n, this.logger = r, this.cryptoObj = i;
    }
    return t.prototype.loadExternalTokens = function(e, n, r) {
      if (this.logger.info("TokenCache - loadExternalTokens called"), !n.id_token)
        throw se.createUnableToLoadTokenError("Please ensure server response includes id token.");
      if (e.account)
        this.loadIdToken(n.id_token, e.account.homeAccountId, e.account.environment, e.account.tenantId, r), this.loadAccessToken(e, n, e.account.homeAccountId, e.account.environment, e.account.tenantId, r);
      else if (e.authority) {
        var i = Bl.generateAuthority(e.authority, e.azureCloudOptions), o = {
          protocolMode: this.config.auth.protocolMode,
          knownAuthorities: this.config.auth.knownAuthorities,
          cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
          authorityMetadata: this.config.auth.authorityMetadata,
          skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        }, a = new Bl(i, this.config.system.networkClient, this.storage, o);
        if (r.clientInfo)
          this.logger.trace("TokenCache - homeAccountId from options"), this.loadIdToken(n.id_token, r.clientInfo, a.hostnameAndPort, a.tenant, r), this.loadAccessToken(e, n, r.clientInfo, a.hostnameAndPort, a.tenant, r);
        else if (n.client_info)
          this.logger.trace("TokenCache - homeAccountId from response"), this.loadIdToken(n.id_token, n.client_info, a.hostnameAndPort, a.tenant, r), this.loadAccessToken(e, n, n.client_info, a.hostnameAndPort, a.tenant, r);
        else
          throw se.createUnableToLoadTokenError("Please provide clientInfo in the response or options.");
      } else
        throw se.createUnableToLoadTokenError("Please provide a request with an account or a request with authority.");
    }, t.prototype.loadIdToken = function(e, n, r, i, o) {
      var a = js.createIdTokenEntity(n, r, e, this.config.auth.clientId, i), s = new Br(e, this.cryptoObj), c = o.clientInfo ? Nn.createAccount(o.clientInfo, n, s, void 0, void 0, void 0, r) : Nn.createGenericAccount(n, s, void 0, void 0, void 0, r);
      if (this.isBrowserEnvironment)
        this.logger.verbose("TokenCache - loading id token"), this.storage.setAccount(c), this.storage.setIdTokenCredential(a);
      else
        throw se.createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    }, t.prototype.loadAccessToken = function(e, n, r, i, o, a) {
      if (!n.access_token) {
        this.logger.verbose("TokenCache - No access token provided for caching");
        return;
      }
      if (!n.expires_in)
        throw se.createUnableToLoadTokenError("Please ensure server response includes expires_in value.");
      if (!a.extendedExpiresOn)
        throw se.createUnableToLoadTokenError("Please provide an extendedExpiresOn value in the options.");
      var s = new Bn(e.scopes).printScopes(), c = a.expiresOn || n.expires_in + (/* @__PURE__ */ new Date()).getTime() / 1e3, l = a.extendedExpiresOn, u = Vs.createAccessTokenEntity(r, i, n.access_token, this.config.auth.clientId, o, s, c, l, this.cryptoObj);
      if (this.isBrowserEnvironment)
        this.logger.verbose("TokenCache - loading access token"), this.storage.setAccessTokenCredential(u);
      else
        throw se.createUnableToLoadTokenError("loadExternalTokens is designed to work in browser environments only.");
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var nS = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n) {
      var r = t.call(this, n) || this;
      return r.includeRedirectUri = !1, r;
    }
    return e;
  }(Lw)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var rS = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o, a, s, c, l, u, d) {
      var f = t.call(this, n, r, i, o, a, s, l, u, d) || this;
      return f.apiId = c, f;
    }
    return e.prototype.acquireToken = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l;
        return ie(this, function(u) {
          switch (u.label) {
            case 0:
              if (this.logger.trace("SilentAuthCodeClient.acquireToken called"), !n.code)
                throw se.createAuthCodeRequiredError();
              return [4, this.initializeAuthorizationRequest(n, be.Silent)];
            case 1:
              r = u.sent(), this.browserStorage.updateCacheEntries(r.state, r.nonce, r.authority, r.loginHint || M.EMPTY_STRING, r.account || null), i = this.initializeServerTelemetryManager(this.apiId), u.label = 2;
            case 2:
              return u.trys.push([2, 4, , 5]), o = Se(Se({}, r), { code: n.code }), [4, this.getClientConfiguration(i, r.authority)];
            case 3:
              return a = u.sent(), s = new nS(a), this.logger.verbose("Auth code client created"), c = new $w(s, this.browserStorage, o, this.logger, this.config.system.navigateFrameWait), [2, c.handleCodeResponseFromServer({
                code: n.code,
                msgraph_host: n.msGraphHost,
                cloud_graph_host_name: n.cloudGraphHostName,
                cloud_instance_host_name: n.cloudInstanceHostName
              }, r.state, s.authority, this.networkClient, !1)];
            case 4:
              throw l = u.sent(), l instanceof Ie && l.setCorrelationId(this.correlationId), i.cacheFailedRequest(l), this.browserStorage.cleanRequestByState(r.state), l;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.logout = function() {
      return Promise.reject(se.createSilentLogoutUnsupportedError());
    }, e;
  }(Ba)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var iS = (
  /** @class */
  function() {
    function t(e, n) {
      this.correlationId = n, this.measureName = "msal.measure." + e + "." + this.correlationId, this.startMark = "msal.start." + e + "." + this.correlationId, this.endMark = "msal.end." + e + "." + this.correlationId;
    }
    return t.supportsBrowserPerformance = function() {
      return typeof window < "u" && typeof window.performance < "u" && typeof window.performance.mark == "function" && typeof window.performance.measure == "function" && typeof window.performance.clearMarks == "function" && typeof window.performance.clearMeasures == "function" && typeof window.performance.getEntriesByName == "function";
    }, t.prototype.startMeasurement = function() {
      if (t.supportsBrowserPerformance())
        try {
          window.performance.mark(this.startMark);
        } catch {
        }
    }, t.prototype.endMeasurement = function() {
      if (t.supportsBrowserPerformance())
        try {
          window.performance.mark(this.endMark), window.performance.measure(this.measureName, this.startMark, this.endMark);
        } catch {
        }
    }, t.prototype.flushMeasurement = function() {
      if (t.supportsBrowserPerformance())
        try {
          var e = window.performance.getEntriesByName(this.measureName, "measure");
          if (e.length > 0) {
            var n = e[0].duration;
            return window.performance.clearMeasures(this.measureName), window.performance.clearMarks(this.startMark), window.performance.clearMarks(this.endMark), n;
          }
        } catch {
        }
      return null;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var oS = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n, r, i, o, a, s) {
      var c = t.call(this, n, r, i, o, a, s) || this;
      return c.browserCrypto = new ul(c.logger), c.guidGenerator = new qw(c.browserCrypto), c;
    }
    return e.prototype.startPerformanceMeasuremeant = function(n, r) {
      return new iS(n, r);
    }, e.prototype.generateId = function() {
      return this.guidGenerator.generateGuid();
    }, e.prototype.getPageVisibility = function() {
      var n;
      return ((n = document.visibilityState) === null || n === void 0 ? void 0 : n.toString()) || null;
    }, e.prototype.startMeasurement = function(n, r) {
      var i = this, o = this.getPageVisibility(), a = t.prototype.startMeasurement.call(this, n, r);
      return Se(Se({}, a), { endMeasurement: function(s) {
        return a.endMeasurement(Se({ startPageVisibility: o, endPageVisibility: i.getPageVisibility() }, s));
      } });
    }, e;
  }(Hw)
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var aS = (
  /** @class */
  function() {
    function t(e) {
      this.isBrowserEnvironment = typeof window < "u", this.config = $I(e, this.isBrowserEnvironment), this.initialized = !1, this.logger = new Mw(this.config.system.loggerOptions, kd, Os), this.networkClient = this.config.system.networkClient, this.navigationClient = this.config.system.navigationClient, this.redirectResponse = /* @__PURE__ */ new Map(), this.hybridAuthCodeResponses = /* @__PURE__ */ new Map(), this.performanceClient = this.isBrowserEnvironment ? new oS(this.config.auth.clientId, this.config.auth.authority, this.logger, kd, Os, this.config.telemetry.application) : new RI(this.config.auth.clientId, this.config.auth.authority, this.logger, kd, Os, this.config.telemetry.application), this.browserCrypto = this.isBrowserEnvironment ? new eS(this.logger, this.performanceClient) : Dl, this.eventHandler = new KI(this.logger, this.browserCrypto), this.browserStorage = this.isBrowserEnvironment ? new Gf(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger) : PI(this.config.auth.clientId, this.logger);
      var n = {
        cacheLocation: xn.MemoryStorage,
        storeAuthStateInCookie: !1,
        secureCookies: !1
      };
      this.nativeInternalStorage = new Gf(this.config.auth.clientId, n, this.browserCrypto, this.logger), this.tokenCache = new tS(this.config, this.browserStorage, this.logger, this.browserCrypto);
    }
    return t.prototype.initialize = function() {
      return re(this, void 0, void 0, function() {
        var e, n;
        return ie(this, function(r) {
          switch (r.label) {
            case 0:
              if (this.logger.trace("initialize called"), this.initialized)
                return this.logger.info("initialize has already been called, exiting early."), [
                  2
                  /*return*/
                ];
              if (this.eventHandler.emitEvent(Be.INITIALIZE_START), !this.config.system.allowNativeBroker)
                return [3, 4];
              r.label = 1;
            case 1:
              return r.trys.push([1, 3, , 4]), e = this, [4, go.createProvider(this.logger, this.config.system.nativeBrokerHandshakeTimeout)];
            case 2:
              return e.nativeExtensionProvider = r.sent(), [3, 4];
            case 3:
              return n = r.sent(), this.logger.verbose(n), [3, 4];
            case 4:
              return this.initialized = !0, this.eventHandler.emitEvent(Be.INITIALIZE_END), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.handleRedirectPromise = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r, i, o, a, s, c, l, u = this;
        return ie(this, function(d) {
          return this.logger.verbose("handleRedirectPromise called"), rn.blockNativeBrokerCalledBeforeInitialized(this.config.system.allowNativeBroker, this.initialized), n = this.getAllAccounts(), this.isBrowserEnvironment ? (r = e || M.EMPTY_STRING, i = this.redirectResponse.get(r), typeof i > "u" ? (this.eventHandler.emitEvent(Be.HANDLE_REDIRECT_START, be.Redirect), this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise"), o = this.browserStorage.getCachedNativeRequest(), a = void 0, o && go.isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider) && this.nativeExtensionProvider && !e ? (this.logger.trace("handleRedirectPromise - acquiring token from native platform"), s = new aa(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, Bt.handleRedirectPromise, this.performanceClient, this.nativeExtensionProvider, o.accountId, this.nativeInternalStorage, o.correlationId), a = s.handleRedirectPromise()) : (this.logger.trace("handleRedirectPromise - acquiring token from web flow"), c = this.browserStorage.getTemporaryCache(yt.CORRELATION_ID, !0) || M.EMPTY_STRING, l = this.createRedirectClient(c), a = l.handleRedirectPromise(e)), i = a.then(function(f) {
            if (f) {
              var h = n.length < u.getAllAccounts().length;
              h ? (u.eventHandler.emitEvent(Be.LOGIN_SUCCESS, be.Redirect, f), u.logger.verbose("handleRedirectResponse returned result, login success")) : (u.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_SUCCESS, be.Redirect, f), u.logger.verbose("handleRedirectResponse returned result, acquire token success"));
            }
            return u.eventHandler.emitEvent(Be.HANDLE_REDIRECT_END, be.Redirect), f;
          }).catch(function(f) {
            throw n.length > 0 ? u.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_FAILURE, be.Redirect, null, f) : u.eventHandler.emitEvent(Be.LOGIN_FAILURE, be.Redirect, null, f), u.eventHandler.emitEvent(Be.HANDLE_REDIRECT_END, be.Redirect), f;
          }), this.redirectResponse.set(r, i)) : this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call"), [2, i]) : (this.logger.verbose("handleRedirectPromise returns null, not browser environment"), [2, null]);
        });
      });
    }, t.prototype.acquireTokenRedirect = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r, i, o, a, s = this;
        return ie(this, function(c) {
          return n = this.getRequestCorrelationId(e), this.logger.verbose("acquireTokenRedirect called", n), this.preflightBrowserEnvironmentCheck(be.Redirect), r = this.getAllAccounts().length > 0, r ? this.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_START, be.Redirect, e) : this.eventHandler.emitEvent(Be.LOGIN_START, be.Redirect, e), this.nativeExtensionProvider && this.canUseNative(e) ? (o = new aa(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, Bt.acquireTokenRedirect, this.performanceClient, this.nativeExtensionProvider, this.getNativeAccountId(e), this.nativeInternalStorage, e.correlationId), i = o.acquireTokenRedirect(e).catch(function(l) {
            if (l instanceof Lr && l.isFatal()) {
              s.nativeExtensionProvider = void 0;
              var u = s.createRedirectClient(e.correlationId);
              return u.acquireToken(e);
            } else if (l instanceof Cr) {
              s.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
              var u = s.createRedirectClient(e.correlationId);
              return u.acquireToken(e);
            }
            throw s.browserStorage.setInteractionInProgress(!1), l;
          })) : (a = this.createRedirectClient(e.correlationId), i = a.acquireToken(e)), [2, i.catch(function(l) {
            throw r ? s.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_FAILURE, be.Redirect, null, l) : s.eventHandler.emitEvent(Be.LOGIN_FAILURE, be.Redirect, null, l), l;
          })];
        });
      });
    }, t.prototype.acquireTokenPopup = function(e) {
      var n = this, r = this.getRequestCorrelationId(e), i = this.performanceClient.startMeasurement(hn.AcquireTokenPopup, r);
      try {
        this.logger.verbose("acquireTokenPopup called", r), this.preflightBrowserEnvironmentCheck(be.Popup);
      } catch (c) {
        return Promise.reject(c);
      }
      var o = this.getAllAccounts();
      o.length > 0 ? this.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_START, be.Popup, e) : this.eventHandler.emitEvent(Be.LOGIN_START, be.Popup, e);
      var a;
      if (this.canUseNative(e))
        a = this.acquireTokenNative(e, Bt.acquireTokenPopup).then(function(c) {
          return n.browserStorage.setInteractionInProgress(!1), i.endMeasurement({
            success: !0,
            isNativeBroker: !0,
            accessTokenSize: c.accessToken.length,
            idTokenSize: c.idToken.length
          }), i.flushMeasurement(), c;
        }).catch(function(c) {
          if (c instanceof Lr && c.isFatal()) {
            n.nativeExtensionProvider = void 0;
            var l = n.createPopupClient(e.correlationId);
            return l.acquireToken(e);
          } else if (c instanceof Cr) {
            n.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
            var l = n.createPopupClient(e.correlationId);
            return l.acquireToken(e);
          }
          throw n.browserStorage.setInteractionInProgress(!1), c;
        });
      else {
        var s = this.createPopupClient(e.correlationId);
        a = s.acquireToken(e);
      }
      return a.then(function(c) {
        var l = o.length < n.getAllAccounts().length;
        return l ? n.eventHandler.emitEvent(Be.LOGIN_SUCCESS, be.Popup, c) : n.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_SUCCESS, be.Popup, c), i.endMeasurement({
          success: !0,
          accessTokenSize: c.accessToken.length,
          idTokenSize: c.idToken.length
        }), i.flushMeasurement(), c;
      }).catch(function(c) {
        return o.length > 0 ? n.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_FAILURE, be.Popup, null, c) : n.eventHandler.emitEvent(Be.LOGIN_FAILURE, be.Popup, null, c), i.endMeasurement({
          errorCode: c.errorCode,
          subErrorCode: c.subError,
          success: !1
        }), i.flushMeasurement(), Promise.reject(c);
      });
    }, t.prototype.ssoSilent = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r, i, o, a, s = this;
        return ie(this, function(c) {
          return n = this.getRequestCorrelationId(e), r = Se(Se({}, e), { prompt: Rn.NONE, correlationId: n }), this.preflightBrowserEnvironmentCheck(be.Silent), i = this.performanceClient.startMeasurement(hn.SsoSilent, n), this.logger.verbose("ssoSilent called", n), this.eventHandler.emitEvent(Be.SSO_SILENT_START, be.Silent, r), this.canUseNative(r) ? o = this.acquireTokenNative(r, Bt.ssoSilent).catch(function(l) {
            if (l instanceof Lr && l.isFatal()) {
              s.nativeExtensionProvider = void 0;
              var u = s.createSilentIframeClient(r.correlationId);
              return u.acquireToken(r);
            }
            throw l;
          }) : (a = this.createSilentIframeClient(r.correlationId), o = a.acquireToken(r)), [2, o.then(function(l) {
            return s.eventHandler.emitEvent(Be.SSO_SILENT_SUCCESS, be.Silent, l), i.endMeasurement({
              success: !0,
              isNativeBroker: l.fromNativeBroker,
              accessTokenSize: l.accessToken.length,
              idTokenSize: l.idToken.length
            }), i.flushMeasurement(), l;
          }).catch(function(l) {
            throw s.eventHandler.emitEvent(Be.SSO_SILENT_FAILURE, be.Silent, null, l), i.endMeasurement({
              errorCode: l.errorCode,
              subErrorCode: l.subError,
              success: !1
            }), i.flushMeasurement(), l;
          })];
        });
      });
    }, t.prototype.acquireTokenByCode = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r, i, o, a = this;
        return ie(this, function(s) {
          n = this.getRequestCorrelationId(e), this.preflightBrowserEnvironmentCheck(be.Silent), this.logger.trace("acquireTokenByCode called", n), this.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_BY_CODE_START, be.Silent, e), r = this.performanceClient.startMeasurement(hn.AcquireTokenByCode, e.correlationId);
          try {
            if (e.code)
              return i = e.code, o = this.hybridAuthCodeResponses.get(i), o ? (this.logger.verbose("Existing acquireTokenByCode request found", e.correlationId), r.endMeasurement({
                success: !0
              }), r.discardMeasurement()) : (this.logger.verbose("Initiating new acquireTokenByCode request", n), o = this.acquireTokenByCodeAsync(Se(Se({}, e), { correlationId: n })).then(function(c) {
                return a.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_BY_CODE_SUCCESS, be.Silent, c), a.hybridAuthCodeResponses.delete(i), r.endMeasurement({
                  success: !0,
                  accessTokenSize: c.accessToken.length,
                  idTokenSize: c.idToken.length,
                  isNativeBroker: c.fromNativeBroker
                }), r.flushMeasurement(), c;
              }).catch(function(c) {
                throw a.hybridAuthCodeResponses.delete(i), a.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_BY_CODE_FAILURE, be.Silent, null, c), r.endMeasurement({
                  errorCode: c.errorCode,
                  subErrorCode: c.subError,
                  success: !1
                }), r.flushMeasurement(), c;
              }), this.hybridAuthCodeResponses.set(i, o)), [2, o];
            if (e.nativeAccountId) {
              if (this.canUseNative(e, e.nativeAccountId))
                return [2, this.acquireTokenNative(e, Bt.acquireTokenByCode, e.nativeAccountId).catch(function(c) {
                  throw c instanceof Lr && c.isFatal() && (a.nativeExtensionProvider = void 0), c;
                })];
              throw se.createUnableToAcquireTokenFromNativePlatformError();
            } else
              throw se.createAuthCodeOrNativeAccountIdRequiredError();
          } catch (c) {
            throw this.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_BY_CODE_FAILURE, be.Silent, null, c), r.endMeasurement({
              errorCode: c instanceof Ie && c.errorCode || void 0,
              subErrorCode: c instanceof Ie && c.subError || void 0,
              success: !1
            }), c;
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.acquireTokenByCodeAsync = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r;
        return ie(this, function(i) {
          switch (i.label) {
            case 0:
              return this.logger.trace("acquireTokenByCodeAsync called", e.correlationId), n = this.createSilentAuthCodeClient(e.correlationId), [4, n.acquireToken(e)];
            case 1:
              return r = i.sent(), [2, r];
          }
        });
      });
    }, t.prototype.acquireTokenByRefreshToken = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r, i = this;
        return ie(this, function(o) {
          return rn.blockReloadInHiddenIframes(), n = this.performanceClient.startMeasurement(hn.AcquireTokenByRefreshToken, e.correlationId), this.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_NETWORK_START, be.Silent, e), r = this.createSilentRefreshClient(e.correlationId), [2, r.acquireToken(e).then(function(a) {
            return n.endMeasurement({
              success: !0,
              fromCache: a.fromCache,
              accessTokenSize: a.accessToken.length,
              idTokenSize: a.idToken.length
            }), a;
          }).catch(function(a) {
            var s = a instanceof bo, c = a instanceof Cr, l = a.errorCode === Hn.INVALID_GRANT_ERROR;
            if (s && l && !c) {
              i.logger.verbose("Refresh token expired or invalid, attempting acquire token by iframe", e.correlationId);
              var u = i.createSilentIframeClient(e.correlationId);
              return u.acquireToken(e).then(function(d) {
                return n.endMeasurement({
                  success: !0,
                  fromCache: d.fromCache,
                  accessTokenSize: d.accessToken.length,
                  idTokenSize: d.idToken.length
                }), d;
              }).catch(function(d) {
                throw n.endMeasurement({
                  errorCode: d.errorCode,
                  subErrorCode: d.subError,
                  success: !1
                }), d;
              });
            }
            throw n.endMeasurement({
              success: !1
            }), a;
          })];
        });
      });
    }, t.prototype.logout = function(e) {
      return re(this, void 0, void 0, function() {
        var n;
        return ie(this, function(r) {
          return n = this.getRequestCorrelationId(e), this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", n), [2, this.logoutRedirect(Se({ correlationId: n }, e))];
        });
      });
    }, t.prototype.logoutRedirect = function(e) {
      return re(this, void 0, void 0, function() {
        var n, r;
        return ie(this, function(i) {
          return n = this.getRequestCorrelationId(e), this.preflightBrowserEnvironmentCheck(be.Redirect), r = this.createRedirectClient(n), [2, r.logout(e)];
        });
      });
    }, t.prototype.logoutPopup = function(e) {
      try {
        var n = this.getRequestCorrelationId(e);
        this.preflightBrowserEnvironmentCheck(be.Popup);
        var r = this.createPopupClient(n);
        return r.logout(e);
      } catch (i) {
        return Promise.reject(i);
      }
    }, t.prototype.getAllAccounts = function() {
      return this.logger.verbose("getAllAccounts called"), this.isBrowserEnvironment ? this.browserStorage.getAllAccounts() : [];
    }, t.prototype.getAccountByUsername = function(e) {
      var n = this.getAllAccounts();
      return !ce.isEmpty(e) && n && n.length ? (this.logger.verbose("Account matching username found, returning"), this.logger.verbosePii("Returning signed-in accounts matching username: " + e), n.filter(function(r) {
        return r.username.toLowerCase() === e.toLowerCase();
      })[0] || null) : (this.logger.verbose("getAccountByUsername: No matching account found, returning null"), null);
    }, t.prototype.getAccountByHomeId = function(e) {
      var n = this.getAllAccounts();
      return !ce.isEmpty(e) && n && n.length ? (this.logger.verbose("Account matching homeAccountId found, returning"), this.logger.verbosePii("Returning signed-in accounts matching homeAccountId: " + e), n.filter(function(r) {
        return r.homeAccountId === e;
      })[0] || null) : (this.logger.verbose("getAccountByHomeId: No matching account found, returning null"), null);
    }, t.prototype.getAccountByLocalId = function(e) {
      var n = this.getAllAccounts();
      return !ce.isEmpty(e) && n && n.length ? (this.logger.verbose("Account matching localAccountId found, returning"), this.logger.verbosePii("Returning signed-in accounts matching localAccountId: " + e), n.filter(function(r) {
        return r.localAccountId === e;
      })[0] || null) : (this.logger.verbose("getAccountByLocalId: No matching account found, returning null"), null);
    }, t.prototype.setActiveAccount = function(e) {
      this.browserStorage.setActiveAccount(e);
    }, t.prototype.getActiveAccount = function() {
      return this.browserStorage.getActiveAccount();
    }, t.prototype.preflightBrowserEnvironmentCheck = function(e, n) {
      if (n === void 0 && (n = !0), this.logger.verbose("preflightBrowserEnvironmentCheck started"), rn.blockNonBrowserEnvironment(this.isBrowserEnvironment), rn.blockRedirectInIframe(e, this.config.system.allowRedirectInIframe), rn.blockReloadInHiddenIframes(), rn.blockAcquireTokenInPopups(), rn.blockNativeBrokerCalledBeforeInitialized(this.config.system.allowNativeBroker, this.initialized), e === be.Redirect && this.config.cache.cacheLocation === xn.MemoryStorage && !this.config.cache.storeAuthStateInCookie)
        throw Kf.createInMemoryRedirectUnavailableError();
      (e === be.Redirect || e === be.Popup) && this.preflightInteractiveRequest(n);
    }, t.prototype.preflightInteractiveRequest = function(e) {
      this.logger.verbose("preflightInteractiveRequest called, validating app environment"), rn.blockReloadInHiddenIframes(), e && this.browserStorage.setInteractionInProgress(!0);
    }, t.prototype.acquireTokenNative = function(e, n, r) {
      return re(this, void 0, void 0, function() {
        var i;
        return ie(this, function(o) {
          if (this.logger.trace("acquireTokenNative called"), !this.nativeExtensionProvider)
            throw se.createNativeConnectionNotEstablishedError();
          return i = new aa(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, n, this.performanceClient, this.nativeExtensionProvider, r || this.getNativeAccountId(e), this.nativeInternalStorage, e.correlationId), [2, i.acquireToken(e)];
        });
      });
    }, t.prototype.canUseNative = function(e, n) {
      if (this.logger.trace("canUseNative called"), !go.isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, e.authenticationScheme))
        return this.logger.trace("canUseNative: isNativeAvailable returned false, returning false"), !1;
      if (e.prompt)
        switch (e.prompt) {
          case Rn.NONE:
          case Rn.CONSENT:
          case Rn.LOGIN:
            this.logger.trace("canUseNative: prompt is compatible with native flow");
            break;
          default:
            return this.logger.trace("canUseNative: prompt = " + e.prompt + " is not compatible with native flow, returning false"), !1;
        }
      return !n && !this.getNativeAccountId(e) ? (this.logger.trace("canUseNative: nativeAccountId is not available, returning false"), !1) : !0;
    }, t.prototype.getNativeAccountId = function(e) {
      var n = e.account || this.browserStorage.getAccountInfoByHints(e.loginHint, e.sid) || this.getActiveAccount();
      return n && n.nativeAccountId || "";
    }, t.prototype.createPopupClient = function(e) {
      return new UI(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, e);
    }, t.prototype.createRedirectClient = function(e) {
      return new FI(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, e);
    }, t.prototype.createSilentIframeClient = function(e) {
      return new qI(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, Bt.ssoSilent, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, e);
    }, t.prototype.createSilentCacheClient = function(e) {
      return new Vw(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, e);
    }, t.prototype.createSilentRefreshClient = function(e) {
      return new zI(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, e);
    }, t.prototype.createSilentAuthCodeClient = function(e) {
      return new rS(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, Bt.acquireTokenByCode, this.performanceClient, this.nativeExtensionProvider, e);
    }, t.prototype.addEventCallback = function(e) {
      return this.eventHandler.addEventCallback(e);
    }, t.prototype.removeEventCallback = function(e) {
      this.eventHandler.removeEventCallback(e);
    }, t.prototype.addPerformanceCallback = function(e) {
      return this.performanceClient.addPerformanceCallback(e);
    }, t.prototype.removePerformanceCallback = function(e) {
      return this.performanceClient.removePerformanceCallback(e);
    }, t.prototype.enableAccountStorageEvents = function() {
      this.eventHandler.enableAccountStorageEvents();
    }, t.prototype.disableAccountStorageEvents = function() {
      this.eventHandler.disableAccountStorageEvents();
    }, t.prototype.getTokenCache = function() {
      return this.tokenCache;
    }, t.prototype.getLogger = function() {
      return this.logger;
    }, t.prototype.setLogger = function(e) {
      this.logger = e;
    }, t.prototype.initializeWrapperLibrary = function(e, n) {
      this.browserStorage.setWrapperMetadata(e, n);
    }, t.prototype.setNavigationClient = function(e) {
      this.navigationClient = e;
    }, t.prototype.getConfiguration = function() {
      return this.config;
    }, t.prototype.getRequestCorrelationId = function(e) {
      return e != null && e.correlationId ? e.correlationId : this.isBrowserEnvironment ? this.browserCrypto.createNewGuid() : M.EMPTY_STRING;
    }, t;
  }()
);
/*! @azure/msal-browser v2.28.0 2022-07-18 */
var sS = (
  /** @class */
  function(t) {
    Tn(e, t);
    function e(n) {
      var r = t.call(this, n) || this;
      return r.activeSilentTokenRequests = /* @__PURE__ */ new Map(), r;
    }
    return e.prototype.loginRedirect = function(n) {
      return re(this, void 0, void 0, function() {
        var r;
        return ie(this, function(i) {
          return r = this.getRequestCorrelationId(n), this.logger.verbose("loginRedirect called", r), [2, this.acquireTokenRedirect(Se({ correlationId: r }, n || Qm))];
        });
      });
    }, e.prototype.loginPopup = function(n) {
      var r = this.getRequestCorrelationId(n);
      return this.logger.verbose("loginPopup called", r), this.acquireTokenPopup(Se({ correlationId: r }, n || Qm));
    }, e.prototype.acquireTokenSilent = function(n) {
      return re(this, void 0, void 0, function() {
        var r, i, o, a, s, c, l, u = this;
        return ie(this, function(d) {
          if (r = this.getRequestCorrelationId(n), i = this.performanceClient.startMeasurement(hn.AcquireTokenSilent, r), this.preflightBrowserEnvironmentCheck(be.Silent), this.logger.verbose("acquireTokenSilent called", r), o = n.account || this.getActiveAccount(), !o)
            throw se.createNoAccountError();
          return a = {
            clientId: this.config.auth.clientId,
            authority: n.authority || M.EMPTY_STRING,
            scopes: n.scopes,
            homeAccountIdentifier: o.homeAccountId,
            claims: n.claims,
            authenticationScheme: n.authenticationScheme,
            resourceRequestMethod: n.resourceRequestMethod,
            resourceRequestUri: n.resourceRequestUri,
            shrClaims: n.shrClaims,
            sshKid: n.sshKid
          }, s = JSON.stringify(a), c = this.activeSilentTokenRequests.get(s), typeof c > "u" ? (this.logger.verbose("acquireTokenSilent called for the first time, storing active request", r), l = this.acquireTokenSilentAsync(Se(Se({}, n), { correlationId: r }), o).then(function(f) {
            return u.activeSilentTokenRequests.delete(s), i.endMeasurement({
              success: !0,
              fromCache: f.fromCache,
              accessTokenSize: f.accessToken.length,
              idTokenSize: f.idToken.length,
              isNativeBroker: f.fromNativeBroker
            }), i.flushMeasurement(), f;
          }).catch(function(f) {
            throw u.activeSilentTokenRequests.delete(s), i.endMeasurement({
              success: !1
            }), i.flushMeasurement(), f;
          }), this.activeSilentTokenRequests.set(s, l), [2, l]) : (this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", r), i.endMeasurement({
            success: !0
          }), i.discardMeasurement(), [2, c]);
        });
      });
    }, e.prototype.acquireTokenSilentAsync = function(n, r) {
      return re(this, void 0, void 0, function() {
        var i, o, a, s, c, l = this;
        return ie(this, function(u) {
          switch (u.label) {
            case 0:
              return this.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_START, be.Silent, n), i = this.performanceClient.startMeasurement(hn.AcquireTokenSilentAsync, n.correlationId), go.isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, n.authenticationScheme) && r.nativeAccountId ? (this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform"), a = Se(Se({}, n), { account: r }), o = this.acquireTokenNative(a, Bt.acquireTokenSilent_silentFlow).catch(function(d) {
                return re(l, void 0, void 0, function() {
                  var f;
                  return ie(this, function(h) {
                    if (d instanceof Lr && d.isFatal())
                      return this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow"), this.nativeExtensionProvider = void 0, f = this.createSilentIframeClient(n.correlationId), [2, f.acquireToken(n)];
                    throw d;
                  });
                });
              }), [3, 3]) : [3, 1];
            case 1:
              return this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow"), s = this.createSilentCacheClient(n.correlationId), [4, s.initializeSilentRequest(n, r)];
            case 2:
              c = u.sent(), o = s.acquireToken(c).catch(function() {
                return re(l, void 0, void 0, function() {
                  return ie(this, function(d) {
                    return [2, this.acquireTokenByRefreshToken(c)];
                  });
                });
              }), u.label = 3;
            case 3:
              return [2, o.then(function(d) {
                return l.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_SUCCESS, be.Silent, d), i.endMeasurement({
                  success: !0,
                  fromCache: d.fromCache,
                  accessTokenSize: d.accessToken.length,
                  idTokenSize: d.idToken.length,
                  isNativeBroker: d.fromNativeBroker
                }), d;
              }).catch(function(d) {
                throw l.eventHandler.emitEvent(Be.ACQUIRE_TOKEN_FAILURE, be.Silent, null, d), i.endMeasurement({
                  errorCode: d.errorCode,
                  subErrorCode: d.subError,
                  success: !1
                }), d;
              })];
          }
        });
      });
    }, e;
  }(aS)
);
function Mu(t, e) {
  return t !== void 0 && typeof t == "object" && t !== null && t.hasOwnProperty(e);
}
function cS(t) {
  return typeof t == "object" && Mu(t, "disabled") && typeof t.disabled == "boolean" ? t.disabled : !1;
}
function Kw(t) {
  if (!t)
    return "";
  if (typeof t == "string")
    return t;
  if (typeof t == "object" && Mu(t, "value"))
    return JSON.stringify(t.value);
  throw new Error(`Could not convert item to key: ${JSON.stringify(t)}`);
}
function Np(t) {
  if (!t)
    return "";
  if (typeof t == "string")
    return t;
  if (typeof t == "number")
    return t.toString();
  if (typeof t == "object" && Mu(t, "label") && typeof t.label == "string")
    return t.label;
  throw new Error(`Could not convert item to string: ${JSON.stringify(t)}`);
}
const yW = (t) => {
  if (!t)
    return null;
  const e = Np(t).split("-");
  return `**/${e[1]}/${e[0]}`;
}, lS = (t, e, n) => {
  if (!n)
    switch (t) {
      case sn.Error:
        console.error(e);
        return;
      case sn.Info:
        console.info(e);
        return;
      case sn.Verbose:
        console.debug(e);
        return;
      case sn.Warning:
        console.warn(e);
        return;
    }
}, wW = ({
  clientId: t,
  baseAuthority: e,
  defaultAuthority: n,
  signInAuthority: r,
  passwordResetAuthority: i,
  captureException: o = () => {
  }
}) => {
  const a = {
    auth: {
      clientId: t,
      authority: e,
      knownAuthorities: [n, i]
    },
    system: {
      loggerOptions: {
        loggerCallback: lS
      }
    }
  }, s = new sS(a), c = new Op(), l = async () => {
    const y = await s.loginPopup({
      authority: n,
      redirectUri: `${window.location.origin}/blank.html`,
      scopes: []
    }), p = {
      userId: y == null ? void 0 : y.uniqueId,
      token: y == null ? void 0 : y.idToken,
      refreshToken: null,
      username: (y == null ? void 0 : y.idTokenClaims).email ?? null
    };
    return c.emit("authStateChange", p), p;
  }, u = async () => {
    try {
      await s.loginRedirect({
        redirectUri: window.location.origin,
        scopes: [],
        authority: n,
        state: JSON.stringify({
          postLoginRedirectUri: window.location.href
        })
      });
    } catch (y) {
      if (y instanceof se && y.errorCode === "interaction_in_progress" && (f && await f(), u))
        return u();
      throw y;
    }
  }, d = async () => {
    await s.loginRedirect({
      redirectUri: window.location.origin,
      authority: i,
      scopes: []
    });
  }, f = async () => {
    let y = null;
    try {
      y = await s.handleRedirectPromise();
    } catch (p) {
      if (p instanceof Ie)
        p != null && p.errorMessage.includes("AADB2C90118") ? await s.loginRedirect({
          redirectUri: window.location.origin,
          scopes: [],
          authority: i
        }) : p != null && p.errorMessage.includes("AADB2C90091") ? await s.loginRedirect({
          redirectUri: window.location.origin,
          scopes: [],
          authority: r
        }) : (o(p), await h());
      else
        throw p;
    }
    if (y !== null) {
      let p = null;
      try {
        const _ = JSON.parse((y == null ? void 0 : y.state) ?? "{}");
        Mu(_, "postLoginRedirectUri") && typeof (_ == null ? void 0 : _.postLoginRedirectUri) == "string" && (p = _ == null ? void 0 : _.postLoginRedirectUri);
      } catch (_) {
        o(_);
      }
      const w = {
        userId: y == null ? void 0 : y.uniqueId,
        token: y == null ? void 0 : y.idToken,
        refreshToken: null,
        username: (y == null ? void 0 : y.idTokenClaims).email ?? null,
        postLoginRedirectUri: p
      };
      return c.emit("authStateChange", w), w;
    }
    return null;
  }, h = async (y) => {
    await s.logoutRedirect({
      authority: n,
      postLogoutRedirectUri: y ?? window.location.origin
    });
    const p = {
      userId: null,
      token: null,
      refreshToken: null,
      username: null
    };
    c.emit("authStateChange", p);
  }, g = async () => {
    try {
      await m();
    } catch (y) {
      console.error("Error refreshing JWT", y);
    }
  }, v = (y) => {
    c.on("authStateChange", y);
    const p = () => c.off("authStateChange", y);
    return () => {
      p();
    };
  }, b = () => {
    c.removeAllListeners("authStateChange");
  }, m = async () => {
    const y = s.getAllAccounts();
    if (y.length > 0)
      try {
        const p = await s.acquireTokenSilent({
          authority: n,
          account: y[0],
          scopes: []
        }), w = {
          userId: p == null ? void 0 : p.uniqueId,
          token: p == null ? void 0 : p.idToken,
          refreshToken: null,
          username: (p == null ? void 0 : p.idTokenClaims).email ?? null
        };
        return c.emit("authStateChange", w), w;
      } catch (p) {
        if (p instanceof Ie && p.errorMessage.includes("AADB2C90080"))
          return await h(), {
            userId: null,
            token: null,
            refreshToken: null,
            username: null
          };
        o(p);
      }
    return {
      userId: null,
      token: null,
      refreshToken: null,
      username: null
    };
  };
  return {
    loginWithPopup: l,
    loginWithRedirect: u,
    changePasswordWithRedirect: d,
    handleRedirectResult: f,
    logOut: h,
    restoreSession: m,
    refreshJWT: g,
    onAuthStateChange: v,
    unsubscribeAll: b
  };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ww = function(t) {
  const e = [];
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    let i = t.charCodeAt(r);
    i < 128 ? e[n++] = i : i < 2048 ? (e[n++] = i >> 6 | 192, e[n++] = i & 63 | 128) : (i & 64512) === 55296 && r + 1 < t.length && (t.charCodeAt(r + 1) & 64512) === 56320 ? (i = 65536 + ((i & 1023) << 10) + (t.charCodeAt(++r) & 1023), e[n++] = i >> 18 | 240, e[n++] = i >> 12 & 63 | 128, e[n++] = i >> 6 & 63 | 128, e[n++] = i & 63 | 128) : (e[n++] = i >> 12 | 224, e[n++] = i >> 6 & 63 | 128, e[n++] = i & 63 | 128);
  }
  return e;
}, uS = function(t) {
  const e = [];
  let n = 0, r = 0;
  for (; n < t.length; ) {
    const i = t[n++];
    if (i < 128)
      e[r++] = String.fromCharCode(i);
    else if (i > 191 && i < 224) {
      const o = t[n++];
      e[r++] = String.fromCharCode((i & 31) << 6 | o & 63);
    } else if (i > 239 && i < 365) {
      const o = t[n++], a = t[n++], s = t[n++], c = ((i & 7) << 18 | (o & 63) << 12 | (a & 63) << 6 | s & 63) - 65536;
      e[r++] = String.fromCharCode(55296 + (c >> 10)), e[r++] = String.fromCharCode(56320 + (c & 1023));
    } else {
      const o = t[n++], a = t[n++];
      e[r++] = String.fromCharCode((i & 15) << 12 | (o & 63) << 6 | a & 63);
    }
  }
  return e.join("");
}, Gw = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(t, e) {
    if (!Array.isArray(t))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = e ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
    for (let i = 0; i < t.length; i += 3) {
      const o = t[i], a = i + 1 < t.length, s = a ? t[i + 1] : 0, c = i + 2 < t.length, l = c ? t[i + 2] : 0, u = o >> 2, d = (o & 3) << 4 | s >> 4;
      let f = (s & 15) << 2 | l >> 6, h = l & 63;
      c || (h = 64, a || (f = 64)), r.push(n[u], n[d], n[f], n[h]);
    }
    return r.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? btoa(t) : this.encodeByteArray(Ww(t), e);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(t, e) {
    return this.HAS_NATIVE_SUPPORT && !e ? atob(t) : uS(this.decodeStringToByteArray(t, e));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(t, e) {
    this.init_();
    const n = e ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
    for (let i = 0; i < t.length; ) {
      const o = n[t.charAt(i++)], s = i < t.length ? n[t.charAt(i)] : 0;
      ++i;
      const l = i < t.length ? n[t.charAt(i)] : 64;
      ++i;
      const d = i < t.length ? n[t.charAt(i)] : 64;
      if (++i, o == null || s == null || l == null || d == null)
        throw Error();
      const f = o << 2 | s >> 4;
      if (r.push(f), l !== 64) {
        const h = s << 4 & 240 | l >> 2;
        if (r.push(h), d !== 64) {
          const g = l << 6 & 192 | d;
          r.push(g);
        }
      }
    }
    return r;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let t = 0; t < this.ENCODED_VALS.length; t++)
        this.byteToCharMap_[t] = this.ENCODED_VALS.charAt(t), this.charToByteMap_[this.byteToCharMap_[t]] = t, this.byteToCharMapWebSafe_[t] = this.ENCODED_VALS_WEBSAFE.charAt(t), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[t]] = t, t >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(t)] = t, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(t)] = t);
    }
  }
}, dS = function(t) {
  const e = Ww(t);
  return Gw.encodeByteArray(e, !0);
}, Yw = function(t) {
  return dS(t).replace(/\./g, "");
}, Qw = function(t) {
  try {
    return Gw.decodeString(t, !0);
  } catch (e) {
    console.error("base64Decode failed: ", e);
  }
  return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Pn() {
  return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function fS() {
  return typeof window < "u" && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(Pn());
}
function hS() {
  const t = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof t == "object" && t.id !== void 0;
}
function pS() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}
function gS() {
  const t = Pn();
  return t.indexOf("MSIE ") >= 0 || t.indexOf("Trident/") >= 0;
}
function mS() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function vS() {
  return new Promise((t, e) => {
    try {
      let n = !0;
      const r = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(r);
      i.onsuccess = () => {
        i.result.close(), n || self.indexedDB.deleteDatabase(r), t(!0);
      }, i.onupgradeneeded = () => {
        n = !1;
      }, i.onerror = () => {
        var o;
        e(((o = i.error) === null || o === void 0 ? void 0 : o.message) || "");
      };
    } catch (n) {
      e(n);
    }
  });
}
function yS() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const wS = () => yS().__FIREBASE_DEFAULTS__, bS = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const t = process.env.__FIREBASE_DEFAULTS__;
  if (t)
    return JSON.parse(t);
}, _S = () => {
  if (typeof document > "u")
    return;
  let t;
  try {
    t = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const e = t && Qw(t[1]);
  return e && JSON.parse(e);
}, Mp = () => {
  try {
    return wS() || bS() || _S();
  } catch (t) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${t}`);
    return;
  }
}, ES = (t) => {
  var e, n;
  return (n = (e = Mp()) === null || e === void 0 ? void 0 : e.emulatorHosts) === null || n === void 0 ? void 0 : n[t];
}, CS = () => {
  var t;
  return (t = Mp()) === null || t === void 0 ? void 0 : t.config;
}, Jw = (t) => {
  var e;
  return (e = Mp()) === null || e === void 0 ? void 0 : e[`_${t}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class IS {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((e, n) => {
      this.resolve = e, this.reject = n;
    });
  }
  /**
   * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(e) {
    return (n, r) => {
      n ? this.reject(n) : this.resolve(r), typeof e == "function" && (this.promise.catch(() => {
      }), e.length === 1 ? e(n) : e(n, r));
    };
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const SS = "FirebaseError";
class Ki extends Error {
  constructor(e, n, r) {
    super(n), this.code = e, this.customData = r, this.name = SS, Object.setPrototypeOf(this, Ki.prototype), Error.captureStackTrace && Error.captureStackTrace(this, uc.prototype.create);
  }
}
class uc {
  constructor(e, n, r) {
    this.service = e, this.serviceName = n, this.errors = r;
  }
  create(e, ...n) {
    const r = n[0] || {}, i = `${this.service}/${e}`, o = this.errors[e], a = o ? TS(o, r) : "Error", s = `${this.serviceName}: ${a} (${i}).`;
    return new Ki(i, s, r);
  }
}
function TS(t, e) {
  return t.replace(kS, (n, r) => {
    const i = e[r];
    return i != null ? String(i) : `<${r}?>`;
  });
}
const kS = /\{\$([^}]+)}/g;
function AS(t) {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e))
      return !1;
  return !0;
}
function ql(t, e) {
  if (t === e)
    return !0;
  const n = Object.keys(t), r = Object.keys(e);
  for (const i of n) {
    if (!r.includes(i))
      return !1;
    const o = t[i], a = e[i];
    if (tv(o) && tv(a)) {
      if (!ql(o, a))
        return !1;
    } else if (o !== a)
      return !1;
  }
  for (const i of r)
    if (!n.includes(i))
      return !1;
  return !0;
}
function tv(t) {
  return t !== null && typeof t == "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function dc(t) {
  const e = [];
  for (const [n, r] of Object.entries(t))
    Array.isArray(r) ? r.forEach((i) => {
      e.push(encodeURIComponent(n) + "=" + encodeURIComponent(i));
    }) : e.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
  return e.length ? "&" + e.join("&") : "";
}
function ys(t) {
  const e = {};
  return t.replace(/^\?/, "").split("&").forEach((r) => {
    if (r) {
      const [i, o] = r.split("=");
      e[decodeURIComponent(i)] = decodeURIComponent(o);
    }
  }), e;
}
function ws(t) {
  const e = t.indexOf("?");
  if (!e)
    return "";
  const n = t.indexOf("#", e);
  return t.substring(e, n > 0 ? n : void 0);
}
function OS(t, e) {
  const n = new xS(t, e);
  return n.subscribe.bind(n);
}
class xS {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(e, n) {
    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = n, this.task.then(() => {
      e(this);
    }).catch((r) => {
      this.error(r);
    });
  }
  next(e) {
    this.forEachObserver((n) => {
      n.next(e);
    });
  }
  error(e) {
    this.forEachObserver((n) => {
      n.error(e);
    }), this.close(e);
  }
  complete() {
    this.forEachObserver((e) => {
      e.complete();
    }), this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber sychronously to their
   *   call to subscribe().
   */
  subscribe(e, n, r) {
    let i;
    if (e === void 0 && n === void 0 && r === void 0)
      throw new Error("Missing Observer.");
    RS(e, [
      "next",
      "error",
      "complete"
    ]) ? i = e : i = {
      next: e,
      error: n,
      complete: r
    }, i.next === void 0 && (i.next = Od), i.error === void 0 && (i.error = Od), i.complete === void 0 && (i.complete = Od);
    const o = this.unsubscribeOne.bind(this, this.observers.length);
    return this.finalized && this.task.then(() => {
      try {
        this.finalError ? i.error(this.finalError) : i.complete();
      } catch {
      }
    }), this.observers.push(i), o;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(e) {
    this.observers === void 0 || this.observers[e] === void 0 || (delete this.observers[e], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
  }
  forEachObserver(e) {
    if (!this.finalized)
      for (let n = 0; n < this.observers.length; n++)
        this.sendOne(n, e);
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(e, n) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[e] !== void 0)
        try {
          n(this.observers[e]);
        } catch (r) {
          typeof console < "u" && console.error && console.error(r);
        }
    });
  }
  close(e) {
    this.finalized || (this.finalized = !0, e !== void 0 && (this.finalError = e), this.task.then(() => {
      this.observers = void 0, this.onNoObservers = void 0;
    }));
  }
}
function RS(t, e) {
  if (typeof t != "object" || t === null)
    return !1;
  for (const n of e)
    if (n in t && typeof t[n] == "function")
      return !0;
  return !1;
}
function Od() {
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function yi(t) {
  return t && t._delegate ? t._delegate : t;
}
class ba {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(e, n, r) {
    this.name = e, this.instanceFactory = n, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(e) {
    return this.instantiationMode = e, this;
  }
  setMultipleInstances(e) {
    return this.multipleInstances = e, this;
  }
  setServiceProps(e) {
    return this.serviceProps = e, this;
  }
  setInstanceCreatedCallback(e) {
    return this.onInstanceCreated = e, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const to = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class NS {
  constructor(e, n) {
    this.name = e, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide mulitple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(e) {
    const n = this.normalizeInstanceIdentifier(e);
    if (!this.instancesDeferred.has(n)) {
      const r = new IS();
      if (this.instancesDeferred.set(n, r), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const i = this.getOrInitializeService({
            instanceIdentifier: n
          });
          i && r.resolve(i);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(e) {
    var n;
    const r = this.normalizeInstanceIdentifier(e == null ? void 0 : e.identifier), i = (n = e == null ? void 0 : e.optional) !== null && n !== void 0 ? n : !1;
    if (this.isInitialized(r) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: r
        });
      } catch (o) {
        if (i)
          return null;
        throw o;
      }
    else {
      if (i)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(e) {
    if (e.name !== this.name)
      throw Error(`Mismatching Component ${e.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = e, !!this.shouldAutoInitialize()) {
      if (PS(e))
        try {
          this.getOrInitializeService({ instanceIdentifier: to });
        } catch {
        }
      for (const [n, r] of this.instancesDeferred.entries()) {
        const i = this.normalizeInstanceIdentifier(n);
        try {
          const o = this.getOrInitializeService({
            instanceIdentifier: i
          });
          r.resolve(o);
        } catch {
        }
      }
    }
  }
  clearInstance(e = to) {
    this.instancesDeferred.delete(e), this.instancesOptions.delete(e), this.instances.delete(e);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const e = Array.from(this.instances.values());
    await Promise.all([
      ...e.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...e.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(e = to) {
    return this.instances.has(e);
  }
  getOptions(e = to) {
    return this.instancesOptions.get(e) || {};
  }
  initialize(e = {}) {
    const { options: n = {} } = e, r = this.normalizeInstanceIdentifier(e.instanceIdentifier);
    if (this.isInitialized(r))
      throw Error(`${this.name}(${r}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const i = this.getOrInitializeService({
      instanceIdentifier: r,
      options: n
    });
    for (const [o, a] of this.instancesDeferred.entries()) {
      const s = this.normalizeInstanceIdentifier(o);
      r === s && a.resolve(i);
    }
    return i;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(e, n) {
    var r;
    const i = this.normalizeInstanceIdentifier(n), o = (r = this.onInitCallbacks.get(i)) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set();
    o.add(e), this.onInitCallbacks.set(i, o);
    const a = this.instances.get(i);
    return a && e(a, i), () => {
      o.delete(e);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(e, n) {
    const r = this.onInitCallbacks.get(n);
    if (r)
      for (const i of r)
        try {
          i(e, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: e, options: n = {} }) {
    let r = this.instances.get(e);
    if (!r && this.component && (r = this.component.instanceFactory(this.container, {
      instanceIdentifier: MS(e),
      options: n
    }), this.instances.set(e, r), this.instancesOptions.set(e, n), this.invokeOnInitCallbacks(r, e), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, e, r);
      } catch {
      }
    return r || null;
  }
  normalizeInstanceIdentifier(e = to) {
    return this.component ? this.component.multipleInstances ? e : to : e;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function MS(t) {
  return t === to ? void 0 : t;
}
function PS(t) {
  return t.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class DS {
  constructor(e) {
    this.name = e, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(e) {
    const n = this.getProvider(e.name);
    if (n.isComponentSet())
      throw new Error(`Component ${e.name} has already been registered with ${this.name}`);
    n.setComponent(e);
  }
  addOrOverwriteComponent(e) {
    this.getProvider(e.name).isComponentSet() && this.providers.delete(e.name), this.addComponent(e);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(e) {
    if (this.providers.has(e))
      return this.providers.get(e);
    const n = new NS(e, this);
    return this.providers.set(e, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Ht;
(function(t) {
  t[t.DEBUG = 0] = "DEBUG", t[t.VERBOSE = 1] = "VERBOSE", t[t.INFO = 2] = "INFO", t[t.WARN = 3] = "WARN", t[t.ERROR = 4] = "ERROR", t[t.SILENT = 5] = "SILENT";
})(Ht || (Ht = {}));
const LS = {
  debug: Ht.DEBUG,
  verbose: Ht.VERBOSE,
  info: Ht.INFO,
  warn: Ht.WARN,
  error: Ht.ERROR,
  silent: Ht.SILENT
}, FS = Ht.INFO, US = {
  [Ht.DEBUG]: "log",
  [Ht.VERBOSE]: "log",
  [Ht.INFO]: "info",
  [Ht.WARN]: "warn",
  [Ht.ERROR]: "error"
}, HS = (t, e, ...n) => {
  if (e < t.logLevel)
    return;
  const r = (/* @__PURE__ */ new Date()).toISOString(), i = US[e];
  if (i)
    console[i](`[${r}]  ${t.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${e})`);
};
let Zw = class {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(e) {
    this.name = e, this._logLevel = FS, this._logHandler = HS, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(e) {
    if (!(e in Ht))
      throw new TypeError(`Invalid value "${e}" assigned to \`logLevel\``);
    this._logLevel = e;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(e) {
    this._logLevel = typeof e == "string" ? LS[e] : e;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(e) {
    if (typeof e != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = e;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(e) {
    this._userLogHandler = e;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...e) {
    this._userLogHandler && this._userLogHandler(this, Ht.DEBUG, ...e), this._logHandler(this, Ht.DEBUG, ...e);
  }
  log(...e) {
    this._userLogHandler && this._userLogHandler(this, Ht.VERBOSE, ...e), this._logHandler(this, Ht.VERBOSE, ...e);
  }
  info(...e) {
    this._userLogHandler && this._userLogHandler(this, Ht.INFO, ...e), this._logHandler(this, Ht.INFO, ...e);
  }
  warn(...e) {
    this._userLogHandler && this._userLogHandler(this, Ht.WARN, ...e), this._logHandler(this, Ht.WARN, ...e);
  }
  error(...e) {
    this._userLogHandler && this._userLogHandler(this, Ht.ERROR, ...e), this._logHandler(this, Ht.ERROR, ...e);
  }
};
const BS = (t, e) => e.some((n) => t instanceof n);
let nv, rv;
function jS() {
  return nv || (nv = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function VS() {
  return rv || (rv = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const Xw = /* @__PURE__ */ new WeakMap(), Qf = /* @__PURE__ */ new WeakMap(), eb = /* @__PURE__ */ new WeakMap(), xd = /* @__PURE__ */ new WeakMap(), Pp = /* @__PURE__ */ new WeakMap();
function $S(t) {
  const e = new Promise((n, r) => {
    const i = () => {
      t.removeEventListener("success", o), t.removeEventListener("error", a);
    }, o = () => {
      n(Li(t.result)), i();
    }, a = () => {
      r(t.error), i();
    };
    t.addEventListener("success", o), t.addEventListener("error", a);
  });
  return e.then((n) => {
    n instanceof IDBCursor && Xw.set(n, t);
  }).catch(() => {
  }), Pp.set(e, t), e;
}
function qS(t) {
  if (Qf.has(t))
    return;
  const e = new Promise((n, r) => {
    const i = () => {
      t.removeEventListener("complete", o), t.removeEventListener("error", a), t.removeEventListener("abort", a);
    }, o = () => {
      n(), i();
    }, a = () => {
      r(t.error || new DOMException("AbortError", "AbortError")), i();
    };
    t.addEventListener("complete", o), t.addEventListener("error", a), t.addEventListener("abort", a);
  });
  Qf.set(t, e);
}
let Jf = {
  get(t, e, n) {
    if (t instanceof IDBTransaction) {
      if (e === "done")
        return Qf.get(t);
      if (e === "objectStoreNames")
        return t.objectStoreNames || eb.get(t);
      if (e === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return Li(t[e]);
  },
  set(t, e, n) {
    return t[e] = n, !0;
  },
  has(t, e) {
    return t instanceof IDBTransaction && (e === "done" || e === "store") ? !0 : e in t;
  }
};
function zS(t) {
  Jf = t(Jf);
}
function KS(t) {
  return t === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(e, ...n) {
    const r = t.call(Rd(this), e, ...n);
    return eb.set(r, e.sort ? e.sort() : [e]), Li(r);
  } : VS().includes(t) ? function(...e) {
    return t.apply(Rd(this), e), Li(Xw.get(this));
  } : function(...e) {
    return Li(t.apply(Rd(this), e));
  };
}
function WS(t) {
  return typeof t == "function" ? KS(t) : (t instanceof IDBTransaction && qS(t), BS(t, jS()) ? new Proxy(t, Jf) : t);
}
function Li(t) {
  if (t instanceof IDBRequest)
    return $S(t);
  if (xd.has(t))
    return xd.get(t);
  const e = WS(t);
  return e !== t && (xd.set(t, e), Pp.set(e, t)), e;
}
const Rd = (t) => Pp.get(t);
function GS(t, e, { blocked: n, upgrade: r, blocking: i, terminated: o } = {}) {
  const a = indexedDB.open(t, e), s = Li(a);
  return r && a.addEventListener("upgradeneeded", (c) => {
    r(Li(a.result), c.oldVersion, c.newVersion, Li(a.transaction));
  }), n && a.addEventListener("blocked", () => n()), s.then((c) => {
    o && c.addEventListener("close", () => o()), i && c.addEventListener("versionchange", () => i());
  }).catch(() => {
  }), s;
}
const YS = ["get", "getKey", "getAll", "getAllKeys", "count"], QS = ["put", "add", "delete", "clear"], Nd = /* @__PURE__ */ new Map();
function iv(t, e) {
  if (!(t instanceof IDBDatabase && !(e in t) && typeof e == "string"))
    return;
  if (Nd.get(e))
    return Nd.get(e);
  const n = e.replace(/FromIndex$/, ""), r = e !== n, i = QS.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || YS.includes(n))
  )
    return;
  const o = async function(a, ...s) {
    const c = this.transaction(a, i ? "readwrite" : "readonly");
    let l = c.store;
    return r && (l = l.index(s.shift())), (await Promise.all([
      l[n](...s),
      i && c.done
    ]))[0];
  };
  return Nd.set(e, o), o;
}
zS((t) => ({
  ...t,
  get: (e, n, r) => iv(e, n) || t.get(e, n, r),
  has: (e, n) => !!iv(e, n) || t.has(e, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class JS {
  constructor(e) {
    this.container = e;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (ZS(n)) {
        const r = n.getImmediate();
        return `${r.library}/${r.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function ZS(t) {
  const e = t.getComponent();
  return (e == null ? void 0 : e.type) === "VERSION";
}
const Zf = "@firebase/app", ov = "0.9.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const _o = new Zw("@firebase/app"), XS = "@firebase/app-compat", eT = "@firebase/analytics-compat", tT = "@firebase/analytics", nT = "@firebase/app-check-compat", rT = "@firebase/app-check", iT = "@firebase/auth", oT = "@firebase/auth-compat", aT = "@firebase/database", sT = "@firebase/database-compat", cT = "@firebase/functions", lT = "@firebase/functions-compat", uT = "@firebase/installations", dT = "@firebase/installations-compat", fT = "@firebase/messaging", hT = "@firebase/messaging-compat", pT = "@firebase/performance", gT = "@firebase/performance-compat", mT = "@firebase/remote-config", vT = "@firebase/remote-config-compat", yT = "@firebase/storage", wT = "@firebase/storage-compat", bT = "@firebase/firestore", _T = "@firebase/firestore-compat", ET = "firebase", CT = "9.15.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Xf = "[DEFAULT]", IT = {
  [Zf]: "fire-core",
  [XS]: "fire-core-compat",
  [tT]: "fire-analytics",
  [eT]: "fire-analytics-compat",
  [rT]: "fire-app-check",
  [nT]: "fire-app-check-compat",
  [iT]: "fire-auth",
  [oT]: "fire-auth-compat",
  [aT]: "fire-rtdb",
  [sT]: "fire-rtdb-compat",
  [cT]: "fire-fn",
  [lT]: "fire-fn-compat",
  [uT]: "fire-iid",
  [dT]: "fire-iid-compat",
  [fT]: "fire-fcm",
  [hT]: "fire-fcm-compat",
  [pT]: "fire-perf",
  [gT]: "fire-perf-compat",
  [mT]: "fire-rc",
  [vT]: "fire-rc-compat",
  [yT]: "fire-gcs",
  [wT]: "fire-gcs-compat",
  [bT]: "fire-fst",
  [_T]: "fire-fst-compat",
  "fire-js": "fire-js",
  [ET]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const zl = /* @__PURE__ */ new Map(), eh = /* @__PURE__ */ new Map();
function ST(t, e) {
  try {
    t.container.addComponent(e);
  } catch (n) {
    _o.debug(`Component ${e.name} failed to register with FirebaseApp ${t.name}`, n);
  }
}
function $s(t) {
  const e = t.name;
  if (eh.has(e))
    return _o.debug(`There were multiple attempts to register component ${e}.`), !1;
  eh.set(e, t);
  for (const n of zl.values())
    ST(n, t);
  return !0;
}
function tb(t, e) {
  const n = t.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return n && n.triggerHeartbeat(), t.container.getProvider(e);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const TT = {
  [
    "no-app"
    /* AppError.NO_APP */
  ]: "No Firebase App '{$appName}' has been created - call Firebase App.initializeApp()",
  [
    "bad-app-name"
    /* AppError.BAD_APP_NAME */
  ]: "Illegal App name: '{$appName}",
  [
    "duplicate-app"
    /* AppError.DUPLICATE_APP */
  ]: "Firebase App named '{$appName}' already exists with different options or config",
  [
    "app-deleted"
    /* AppError.APP_DELETED */
  ]: "Firebase App named '{$appName}' already deleted",
  [
    "no-options"
    /* AppError.NO_OPTIONS */
  ]: "Need to provide options, when not being deployed to hosting via source.",
  [
    "invalid-app-argument"
    /* AppError.INVALID_APP_ARGUMENT */
  ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  [
    "invalid-log-argument"
    /* AppError.INVALID_LOG_ARGUMENT */
  ]: "First argument to `onLog` must be null or a function.",
  [
    "idb-open"
    /* AppError.IDB_OPEN */
  ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  [
    "idb-get"
    /* AppError.IDB_GET */
  ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  [
    "idb-set"
    /* AppError.IDB_WRITE */
  ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  [
    "idb-delete"
    /* AppError.IDB_DELETE */
  ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
}, Fi = new uc("app", "Firebase", TT);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kT {
  constructor(e, n, r) {
    this._isDeleted = !1, this._options = Object.assign({}, e), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new ba(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(e) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = e;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(e) {
    this._isDeleted = e;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw Fi.create("app-deleted", { appName: this._name });
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Pu = CT;
function nb(t, e = {}) {
  let n = t;
  typeof e != "object" && (e = { name: e });
  const r = Object.assign({ name: Xf, automaticDataCollectionEnabled: !1 }, e), i = r.name;
  if (typeof i != "string" || !i)
    throw Fi.create("bad-app-name", {
      appName: String(i)
    });
  if (n || (n = CS()), !n)
    throw Fi.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const o = zl.get(i);
  if (o) {
    if (ql(n, o.options) && ql(r, o.config))
      return o;
    throw Fi.create("duplicate-app", { appName: i });
  }
  const a = new DS(i);
  for (const c of eh.values())
    a.addComponent(c);
  const s = new kT(n, r, a);
  return zl.set(i, s), s;
}
function AT(t = Xf) {
  const e = zl.get(t);
  if (!e && t === Xf)
    return nb();
  if (!e)
    throw Fi.create("no-app", { appName: t });
  return e;
}
function ca(t, e, n) {
  var r;
  let i = (r = IT[t]) !== null && r !== void 0 ? r : t;
  n && (i += `-${n}`);
  const o = i.match(/\s|\//), a = e.match(/\s|\//);
  if (o || a) {
    const s = [
      `Unable to register library "${i}" with version "${e}":`
    ];
    o && s.push(`library name "${i}" contains illegal characters (whitespace or "/")`), o && a && s.push("and"), a && s.push(`version name "${e}" contains illegal characters (whitespace or "/")`), _o.warn(s.join(" "));
    return;
  }
  $s(new ba(
    `${i}-version`,
    () => ({ library: i, version: e }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const OT = "firebase-heartbeat-database", xT = 1, qs = "firebase-heartbeat-store";
let Md = null;
function rb() {
  return Md || (Md = GS(OT, xT, {
    upgrade: (t, e) => {
      switch (e) {
        case 0:
          t.createObjectStore(qs);
      }
    }
  }).catch((t) => {
    throw Fi.create("idb-open", {
      originalErrorMessage: t.message
    });
  })), Md;
}
async function RT(t) {
  try {
    return (await rb()).transaction(qs).objectStore(qs).get(ib(t));
  } catch (e) {
    if (e instanceof Ki)
      _o.warn(e.message);
    else {
      const n = Fi.create("idb-get", {
        originalErrorMessage: e == null ? void 0 : e.message
      });
      _o.warn(n.message);
    }
  }
}
async function av(t, e) {
  try {
    const r = (await rb()).transaction(qs, "readwrite");
    return await r.objectStore(qs).put(e, ib(t)), r.done;
  } catch (n) {
    if (n instanceof Ki)
      _o.warn(n.message);
    else {
      const r = Fi.create("idb-set", {
        originalErrorMessage: n == null ? void 0 : n.message
      });
      _o.warn(r.message);
    }
  }
}
function ib(t) {
  return `${t.name}!${t.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const NT = 1024, MT = 30 * 24 * 60 * 60 * 1e3;
class PT {
  constructor(e) {
    this.container = e, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new LT(n), this._heartbeatsCachePromise = this._storage.read().then((r) => (this._heartbeatsCache = r, r));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    const n = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), r = sv();
    if (this._heartbeatsCache === null && (this._heartbeatsCache = await this._heartbeatsCachePromise), !(this._heartbeatsCache.lastSentHeartbeatDate === r || this._heartbeatsCache.heartbeats.some((i) => i.date === r)))
      return this._heartbeatsCache.heartbeats.push({ date: r, agent: n }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((i) => {
        const o = new Date(i.date).valueOf();
        return Date.now() - o <= MT;
      }), this._storage.overwrite(this._heartbeatsCache);
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0)
      return "";
    const e = sv(), { heartbeatsToSend: n, unsentEntries: r } = DT(this._heartbeatsCache.heartbeats), i = Yw(JSON.stringify({ version: 2, heartbeats: n }));
    return this._heartbeatsCache.lastSentHeartbeatDate = e, r.length > 0 ? (this._heartbeatsCache.heartbeats = r, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), i;
  }
}
function sv() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function DT(t, e = NT) {
  const n = [];
  let r = t.slice();
  for (const i of t) {
    const o = n.find((a) => a.agent === i.agent);
    if (o) {
      if (o.dates.push(i.date), cv(n) > e) {
        o.dates.pop();
        break;
      }
    } else if (n.push({
      agent: i.agent,
      dates: [i.date]
    }), cv(n) > e) {
      n.pop();
      break;
    }
    r = r.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: r
  };
}
class LT {
  constructor(e) {
    this.app = e, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return mS() ? vS().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    return await this._canUseIndexedDBPromise ? await RT(this.app) || { heartbeats: [] } : { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(e) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return av(this.app, {
        lastSentHeartbeatDate: (n = e.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: e.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(e) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return av(this.app, {
        lastSentHeartbeatDate: (n = e.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: [
          ...i.heartbeats,
          ...e.heartbeats
        ]
      });
    } else
      return;
  }
}
function cv(t) {
  return Yw(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: t })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function FT(t) {
  $s(new ba(
    "platform-logger",
    (e) => new JS(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), $s(new ba(
    "heartbeat",
    (e) => new PT(e),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), ca(Zf, ov, t), ca(Zf, ov, "esm2017"), ca("fire-js", "");
}
FT("");
var UT = "firebase", HT = "9.15.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
ca(UT, HT, "app");
var th = function(t, e) {
  return th = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, th(t, e);
};
function an(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  th(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var R = function() {
  return R = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, R.apply(this, arguments);
};
function jr(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function ke(t, e, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function l(u) {
      u.done ? o(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(t, e || [])).next());
  });
}
function Ae(t, e) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, l[0] && (n = 0)), n; )
      try {
        if (r = 1, i && (o = l[0] & 2 ? i.return : l[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, l[1])).done)
          return o;
        switch (i = 0, o && (l = [l[0] & 2, o.value]), l[0]) {
          case 0:
          case 1:
            o = l;
            break;
          case 4:
            return n.label++, { value: l[1], done: !1 };
          case 5:
            n.label++, i = l[1], l = [0];
            continue;
          case 7:
            l = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (l[0] === 6 || l[0] === 2)) {
              n = 0;
              continue;
            }
            if (l[0] === 3 && (!o || l[1] > o[0] && l[1] < o[3])) {
              n.label = l[1];
              break;
            }
            if (l[0] === 6 && n.label < o[1]) {
              n.label = o[1], o = l;
              break;
            }
            if (o && n.label < o[2]) {
              n.label = o[2], n.ops.push(l);
              break;
            }
            o[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        l = e.call(t, n);
      } catch (u) {
        l = [6, u], i = 0;
      } finally {
        r = o = 0;
      }
    if (l[0] & 5)
      throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function ln(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = e.length, o; r < i; r++)
      (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
function ob() {
  return {
    [
      "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
    ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
  };
}
const BT = ob, ab = new uc("auth", "Firebase", ob());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const lv = new Zw("@firebase/auth");
function dl(t, ...e) {
  lv.logLevel <= Ht.ERROR && lv.error(`Auth (${Pu}): ${t}`, ...e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function pr(t, ...e) {
  throw Dp(t, ...e);
}
function Fr(t, ...e) {
  return Dp(t, ...e);
}
function sb(t, e, n) {
  const r = Object.assign(Object.assign({}, BT()), { [e]: n });
  return new uc("auth", "Firebase", r).create(e, {
    appName: t.name
  });
}
function cb(t, e, n) {
  const r = n;
  if (!(e instanceof r))
    throw r.name !== e.constructor.name && pr(
      t,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), sb(t, "argument-error", `Type of ${e.constructor.name} does not match expected instance.Did you pass a reference from a different Auth SDK?`);
}
function Dp(t, ...e) {
  if (typeof t != "string") {
    const n = e[0], r = [...e.slice(1)];
    return r[0] && (r[0].appName = t.name), t._errorFactory.create(n, ...r);
  }
  return ab.create(t, ...e);
}
function Fe(t, e, ...n) {
  if (!t)
    throw Dp(e, ...n);
}
function oi(t) {
  const e = "INTERNAL ASSERTION FAILED: " + t;
  throw dl(e), new Error(e);
}
function fi(t, e) {
  t || oi(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const uv = /* @__PURE__ */ new Map();
function ai(t) {
  fi(t instanceof Function, "Expected a class definition");
  let e = uv.get(t);
  return e ? (fi(e instanceof t, "Instance stored in cache mismatched with class"), e) : (e = new t(), uv.set(t, e), e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function jT(t, e) {
  const n = tb(t, "auth");
  if (n.isInitialized()) {
    const i = n.getImmediate(), o = n.getOptions();
    if (ql(o, e ?? {}))
      return i;
    pr(
      i,
      "already-initialized"
      /* AuthErrorCode.ALREADY_INITIALIZED */
    );
  }
  return n.initialize({ options: e });
}
function VT(t, e) {
  const n = (e == null ? void 0 : e.persistence) || [], r = (Array.isArray(n) ? n : [n]).map(ai);
  e != null && e.errorMap && t._updateErrorMap(e.errorMap), t._initializeWithPersistence(r, e == null ? void 0 : e.popupRedirectResolver);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function nh() {
  var t;
  return typeof self < "u" && ((t = self.location) === null || t === void 0 ? void 0 : t.href) || "";
}
function $T() {
  return dv() === "http:" || dv() === "https:";
}
function dv() {
  var t;
  return typeof self < "u" && ((t = self.location) === null || t === void 0 ? void 0 : t.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function qT() {
  return typeof navigator < "u" && navigator && "onLine" in navigator && typeof navigator.onLine == "boolean" && // Apply only for traditional web apps and Chrome extensions.
  // This is especially true for Cordova apps which have unreliable
  // navigator.onLine behavior unless cordova-plugin-network-information is
  // installed which overwrites the native navigator.onLine value and
  // defines navigator.connection.
  ($T() || hS() || "connection" in navigator) ? navigator.onLine : !0;
}
function zT() {
  if (typeof navigator > "u")
    return null;
  const t = navigator;
  return (
    // Most reliable, but only supported in Chrome/Firefox.
    t.languages && t.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    t.language || // Couldn't determine language.
    null
  );
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class fc {
  constructor(e, n) {
    this.shortDelay = e, this.longDelay = n, fi(n > e, "Short delay should be less than long delay!"), this.isMobile = fS() || pS();
  }
  get() {
    return qT() ? this.isMobile ? this.longDelay : this.shortDelay : Math.min(5e3, this.shortDelay);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Lp(t, e) {
  fi(t.emulator, "Emulator should always be set here");
  const { url: n } = t.emulator;
  return e ? `${n}${e.startsWith("/") ? e.slice(1) : e}` : n;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class lb {
  static initialize(e, n, r) {
    this.fetchImpl = e, n && (this.headersImpl = n), r && (this.responseImpl = r);
  }
  static fetch() {
    if (this.fetchImpl)
      return this.fetchImpl;
    if (typeof self < "u" && "fetch" in self)
      return self.fetch;
    oi("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static headers() {
    if (this.headersImpl)
      return this.headersImpl;
    if (typeof self < "u" && "Headers" in self)
      return self.Headers;
    oi("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
  static response() {
    if (this.responseImpl)
      return this.responseImpl;
    if (typeof self < "u" && "Response" in self)
      return self.Response;
    oi("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const KT = {
  // Custom token errors.
  CREDENTIAL_MISMATCH: "custom-token-mismatch",
  // This can only happen if the SDK sends a bad request.
  MISSING_CUSTOM_TOKEN: "internal-error",
  // Create Auth URI errors.
  INVALID_IDENTIFIER: "invalid-email",
  // This can only happen if the SDK sends a bad request.
  MISSING_CONTINUE_URI: "internal-error",
  // Sign in with email and password errors (some apply to sign up too).
  INVALID_PASSWORD: "wrong-password",
  // This can only happen if the SDK sends a bad request.
  MISSING_PASSWORD: "internal-error",
  // Sign up with email and password errors.
  EMAIL_EXISTS: "email-already-in-use",
  PASSWORD_LOGIN_DISABLED: "operation-not-allowed",
  // Verify assertion for sign in with credential errors:
  INVALID_IDP_RESPONSE: "invalid-credential",
  INVALID_PENDING_TOKEN: "invalid-credential",
  FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use",
  // This can only happen if the SDK sends a bad request.
  MISSING_REQ_TYPE: "internal-error",
  // Send Password reset email errors:
  EMAIL_NOT_FOUND: "user-not-found",
  RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
  EXPIRED_OOB_CODE: "expired-action-code",
  INVALID_OOB_CODE: "invalid-action-code",
  // This can only happen if the SDK sends a bad request.
  MISSING_OOB_CODE: "internal-error",
  // Operations that require ID token in request:
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login",
  INVALID_ID_TOKEN: "invalid-user-token",
  TOKEN_EXPIRED: "user-token-expired",
  USER_NOT_FOUND: "user-token-expired",
  // Other errors.
  TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests",
  // Phone Auth related errors.
  INVALID_CODE: "invalid-verification-code",
  INVALID_SESSION_INFO: "invalid-verification-id",
  INVALID_TEMPORARY_PROOF: "invalid-credential",
  MISSING_SESSION_INFO: "missing-verification-id",
  SESSION_EXPIRED: "code-expired",
  // Other action code errors when additional settings passed.
  // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
  // This is OK as this error will be caught by client side validation.
  MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name",
  UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri",
  // getProjectConfig errors when clientId is passed.
  INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id",
  // User actions (sign-up or deletion) disabled errors.
  ADMIN_ONLY_OPERATION: "admin-restricted-operation",
  // Multi factor related errors.
  INVALID_MFA_PENDING_CREDENTIAL: "invalid-multi-factor-session",
  MFA_ENROLLMENT_NOT_FOUND: "multi-factor-info-not-found",
  MISSING_MFA_ENROLLMENT_ID: "missing-multi-factor-info",
  MISSING_MFA_PENDING_CREDENTIAL: "missing-multi-factor-session",
  SECOND_FACTOR_EXISTS: "second-factor-already-in-use",
  SECOND_FACTOR_LIMIT_EXCEEDED: "maximum-second-factor-count-exceeded",
  // Blocking functions related errors.
  BLOCKING_FUNCTION_ERROR_RESPONSE: "internal-error"
  /* AuthErrorCode.INTERNAL_ERROR */
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const WT = new fc(3e4, 6e4);
function hc(t, e) {
  return t.tenantId && !e.tenantId ? Object.assign(Object.assign({}, e), { tenantId: t.tenantId }) : e;
}
async function pc(t, e, n, r, i = {}) {
  return ub(t, i, async () => {
    let o = {}, a = {};
    r && (e === "GET" ? a = r : o = {
      body: JSON.stringify(r)
    });
    const s = dc(Object.assign({ key: t.config.apiKey }, a)).slice(1), c = await t._getAdditionalHeaders();
    return c[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/json", t.languageCode && (c[
      "X-Firebase-Locale"
      /* HttpHeader.X_FIREBASE_LOCALE */
    ] = t.languageCode), lb.fetch()(db(t, t.config.apiHost, n, s), Object.assign({
      method: e,
      headers: c,
      referrerPolicy: "no-referrer"
    }, o));
  });
}
async function ub(t, e, n) {
  t._canInitEmulator = !1;
  const r = Object.assign(Object.assign({}, KT), e);
  try {
    const i = new GT(t), o = await Promise.race([
      n(),
      i.promise
    ]);
    i.clearNetworkTimeout();
    const a = await o.json();
    if ("needConfirmation" in a)
      throw $c(t, "account-exists-with-different-credential", a);
    if (o.ok && !("errorMessage" in a))
      return a;
    {
      const s = o.ok ? a.errorMessage : a.error.message, [c, l] = s.split(" : ");
      if (c === "FEDERATED_USER_ID_ALREADY_LINKED")
        throw $c(t, "credential-already-in-use", a);
      if (c === "EMAIL_EXISTS")
        throw $c(t, "email-already-in-use", a);
      if (c === "USER_DISABLED")
        throw $c(t, "user-disabled", a);
      const u = r[c] || c.toLowerCase().replace(/[_\s]+/g, "-");
      if (l)
        throw sb(t, u, l);
      pr(t, u);
    }
  } catch (i) {
    if (i instanceof Ki)
      throw i;
    pr(
      t,
      "network-request-failed"
      /* AuthErrorCode.NETWORK_REQUEST_FAILED */
    );
  }
}
async function gc(t, e, n, r, i = {}) {
  const o = await pc(t, e, n, r, i);
  return "mfaPendingCredential" in o && pr(t, "multi-factor-auth-required", {
    _serverResponse: o
  }), o;
}
function db(t, e, n, r) {
  const i = `${e}${n}?${r}`;
  return t.config.emulator ? Lp(t.config, i) : `${t.config.apiScheme}://${i}`;
}
class GT {
  constructor(e) {
    this.auth = e, this.timer = null, this.promise = new Promise((n, r) => {
      this.timer = setTimeout(() => r(Fr(
        this.auth,
        "network-request-failed"
        /* AuthErrorCode.NETWORK_REQUEST_FAILED */
      )), WT.get());
    });
  }
  clearNetworkTimeout() {
    clearTimeout(this.timer);
  }
}
function $c(t, e, n) {
  const r = {
    appName: t.name
  };
  n.email && (r.email = n.email), n.phoneNumber && (r.phoneNumber = n.phoneNumber);
  const i = Fr(t, e, r);
  return i.customData._tokenResponse = n, i;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function YT(t, e) {
  return pc(t, "POST", "/v1/accounts:delete", e);
}
async function QT(t, e) {
  return pc(t, "POST", "/v1/accounts:lookup", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function xs(t) {
  if (t)
    try {
      const e = new Date(Number(t));
      if (!isNaN(e.getTime()))
        return e.toUTCString();
    } catch {
    }
}
async function JT(t, e = !1) {
  const n = yi(t), r = await n.getIdToken(e), i = Fp(r);
  Fe(
    i && i.exp && i.auth_time && i.iat,
    n.auth,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const o = typeof i.firebase == "object" ? i.firebase : void 0, a = o == null ? void 0 : o.sign_in_provider;
  return {
    claims: i,
    token: r,
    authTime: xs(Pd(i.auth_time)),
    issuedAtTime: xs(Pd(i.iat)),
    expirationTime: xs(Pd(i.exp)),
    signInProvider: a || null,
    signInSecondFactor: (o == null ? void 0 : o.sign_in_second_factor) || null
  };
}
function Pd(t) {
  return Number(t) * 1e3;
}
function Fp(t) {
  const [e, n, r] = t.split(".");
  if (e === void 0 || n === void 0 || r === void 0)
    return dl("JWT malformed, contained fewer than 3 sections"), null;
  try {
    const i = Qw(n);
    return i ? JSON.parse(i) : (dl("Failed to decode base64 JWT payload"), null);
  } catch (i) {
    return dl("Caught error parsing JWT payload as JSON", i == null ? void 0 : i.toString()), null;
  }
}
function ZT(t) {
  const e = Fp(t);
  return Fe(
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Fe(
    typeof e.exp < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Fe(
    typeof e.iat < "u",
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Number(e.exp) - Number(e.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function zs(t, e, n = !1) {
  if (n)
    return e;
  try {
    return await e;
  } catch (r) {
    throw r instanceof Ki && XT(r) && t.auth.currentUser === t && await t.auth.signOut(), r;
  }
}
function XT({ code: t }) {
  return t === "auth/user-disabled" || t === "auth/user-token-expired";
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ek {
  constructor(e) {
    this.user = e, this.isRunning = !1, this.timerId = null, this.errorBackoff = 3e4;
  }
  _start() {
    this.isRunning || (this.isRunning = !0, this.schedule());
  }
  _stop() {
    this.isRunning && (this.isRunning = !1, this.timerId !== null && clearTimeout(this.timerId));
  }
  getInterval(e) {
    var n;
    if (e) {
      const r = this.errorBackoff;
      return this.errorBackoff = Math.min(
        this.errorBackoff * 2,
        96e4
        /* Duration.RETRY_BACKOFF_MAX */
      ), r;
    } else {
      this.errorBackoff = 3e4;
      const i = ((n = this.user.stsTokenManager.expirationTime) !== null && n !== void 0 ? n : 0) - Date.now() - 3e5;
      return Math.max(0, i);
    }
  }
  schedule(e = !1) {
    if (!this.isRunning)
      return;
    const n = this.getInterval(e);
    this.timerId = setTimeout(async () => {
      await this.iteration();
    }, n);
  }
  async iteration() {
    try {
      await this.user.getIdToken(!0);
    } catch (e) {
      (e == null ? void 0 : e.code) === "auth/network-request-failed" && this.schedule(
        /* wasError */
        !0
      );
      return;
    }
    this.schedule();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class fb {
  constructor(e, n) {
    this.createdAt = e, this.lastLoginAt = n, this._initializeTime();
  }
  _initializeTime() {
    this.lastSignInTime = xs(this.lastLoginAt), this.creationTime = xs(this.createdAt);
  }
  _copy(e) {
    this.createdAt = e.createdAt, this.lastLoginAt = e.lastLoginAt, this._initializeTime();
  }
  toJSON() {
    return {
      createdAt: this.createdAt,
      lastLoginAt: this.lastLoginAt
    };
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Kl(t) {
  var e;
  const n = t.auth, r = await t.getIdToken(), i = await zs(t, QT(n, { idToken: r }));
  Fe(
    i == null ? void 0 : i.users.length,
    n,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  );
  const o = i.users[0];
  t._notifyReloadListener(o);
  const a = !((e = o.providerUserInfo) === null || e === void 0) && e.length ? rk(o.providerUserInfo) : [], s = nk(t.providerData, a), c = t.isAnonymous, l = !(t.email && o.passwordHash) && !(s != null && s.length), u = c ? l : !1, d = {
    uid: o.localId,
    displayName: o.displayName || null,
    photoURL: o.photoUrl || null,
    email: o.email || null,
    emailVerified: o.emailVerified || !1,
    phoneNumber: o.phoneNumber || null,
    tenantId: o.tenantId || null,
    providerData: s,
    metadata: new fb(o.createdAt, o.lastLoginAt),
    isAnonymous: u
  };
  Object.assign(t, d);
}
async function tk(t) {
  const e = yi(t);
  await Kl(e), await e.auth._persistUserIfCurrent(e), e.auth._notifyListenersIfCurrent(e);
}
function nk(t, e) {
  return [...t.filter((r) => !e.some((i) => i.providerId === r.providerId)), ...e];
}
function rk(t) {
  return t.map((e) => {
    var { providerId: n } = e, r = jr(e, ["providerId"]);
    return {
      providerId: n,
      uid: r.rawId || "",
      displayName: r.displayName || null,
      email: r.email || null,
      phoneNumber: r.phoneNumber || null,
      photoURL: r.photoUrl || null
    };
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ik(t, e) {
  const n = await ub(t, {}, async () => {
    const r = dc({
      grant_type: "refresh_token",
      refresh_token: e
    }).slice(1), { tokenApiHost: i, apiKey: o } = t.config, a = db(t, i, "/v1/token", `key=${o}`), s = await t._getAdditionalHeaders();
    return s[
      "Content-Type"
      /* HttpHeader.CONTENT_TYPE */
    ] = "application/x-www-form-urlencoded", lb.fetch()(a, {
      method: "POST",
      headers: s,
      body: r
    });
  });
  return {
    accessToken: n.access_token,
    expiresIn: n.expires_in,
    refreshToken: n.refresh_token
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ks {
  constructor() {
    this.refreshToken = null, this.accessToken = null, this.expirationTime = null;
  }
  get isExpired() {
    return !this.expirationTime || Date.now() > this.expirationTime - 3e4;
  }
  updateFromServerResponse(e) {
    Fe(
      e.idToken,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Fe(
      typeof e.idToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Fe(
      typeof e.refreshToken < "u",
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const n = "expiresIn" in e && typeof e.expiresIn < "u" ? Number(e.expiresIn) : ZT(e.idToken);
    this.updateTokensAndExpiration(e.idToken, e.refreshToken, n);
  }
  async getToken(e, n = !1) {
    return Fe(
      !this.accessToken || this.refreshToken,
      e,
      "user-token-expired"
      /* AuthErrorCode.TOKEN_EXPIRED */
    ), !n && this.accessToken && !this.isExpired ? this.accessToken : this.refreshToken ? (await this.refresh(e, this.refreshToken), this.accessToken) : null;
  }
  clearRefreshToken() {
    this.refreshToken = null;
  }
  async refresh(e, n) {
    const { accessToken: r, refreshToken: i, expiresIn: o } = await ik(e, n);
    this.updateTokensAndExpiration(r, i, Number(o));
  }
  updateTokensAndExpiration(e, n, r) {
    this.refreshToken = n || null, this.accessToken = e || null, this.expirationTime = Date.now() + r * 1e3;
  }
  static fromJSON(e, n) {
    const { refreshToken: r, accessToken: i, expirationTime: o } = n, a = new Ks();
    return r && (Fe(typeof r == "string", "internal-error", {
      appName: e
    }), a.refreshToken = r), i && (Fe(typeof i == "string", "internal-error", {
      appName: e
    }), a.accessToken = i), o && (Fe(typeof o == "number", "internal-error", {
      appName: e
    }), a.expirationTime = o), a;
  }
  toJSON() {
    return {
      refreshToken: this.refreshToken,
      accessToken: this.accessToken,
      expirationTime: this.expirationTime
    };
  }
  _assign(e) {
    this.accessToken = e.accessToken, this.refreshToken = e.refreshToken, this.expirationTime = e.expirationTime;
  }
  _clone() {
    return Object.assign(new Ks(), this.toJSON());
  }
  _performRefresh() {
    return oi("not implemented");
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _i(t, e) {
  Fe(typeof t == "string" || typeof t > "u", "internal-error", { appName: e });
}
class mo {
  constructor(e) {
    var { uid: n, auth: r, stsTokenManager: i } = e, o = jr(e, ["uid", "auth", "stsTokenManager"]);
    this.providerId = "firebase", this.proactiveRefresh = new ek(this), this.reloadUserInfo = null, this.reloadListener = null, this.uid = n, this.auth = r, this.stsTokenManager = i, this.accessToken = i.accessToken, this.displayName = o.displayName || null, this.email = o.email || null, this.emailVerified = o.emailVerified || !1, this.phoneNumber = o.phoneNumber || null, this.photoURL = o.photoURL || null, this.isAnonymous = o.isAnonymous || !1, this.tenantId = o.tenantId || null, this.providerData = o.providerData ? [...o.providerData] : [], this.metadata = new fb(o.createdAt || void 0, o.lastLoginAt || void 0);
  }
  async getIdToken(e) {
    const n = await zs(this, this.stsTokenManager.getToken(this.auth, e));
    return Fe(
      n,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.accessToken !== n && (this.accessToken = n, await this.auth._persistUserIfCurrent(this), this.auth._notifyListenersIfCurrent(this)), n;
  }
  getIdTokenResult(e) {
    return JT(this, e);
  }
  reload() {
    return tk(this);
  }
  _assign(e) {
    this !== e && (Fe(
      this.uid === e.uid,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.displayName = e.displayName, this.photoURL = e.photoURL, this.email = e.email, this.emailVerified = e.emailVerified, this.phoneNumber = e.phoneNumber, this.isAnonymous = e.isAnonymous, this.tenantId = e.tenantId, this.providerData = e.providerData.map((n) => Object.assign({}, n)), this.metadata._copy(e.metadata), this.stsTokenManager._assign(e.stsTokenManager));
  }
  _clone(e) {
    return new mo(Object.assign(Object.assign({}, this), { auth: e, stsTokenManager: this.stsTokenManager._clone() }));
  }
  _onReload(e) {
    Fe(
      !this.reloadListener,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.reloadListener = e, this.reloadUserInfo && (this._notifyReloadListener(this.reloadUserInfo), this.reloadUserInfo = null);
  }
  _notifyReloadListener(e) {
    this.reloadListener ? this.reloadListener(e) : this.reloadUserInfo = e;
  }
  _startProactiveRefresh() {
    this.proactiveRefresh._start();
  }
  _stopProactiveRefresh() {
    this.proactiveRefresh._stop();
  }
  async _updateTokensIfNecessary(e, n = !1) {
    let r = !1;
    e.idToken && e.idToken !== this.stsTokenManager.accessToken && (this.stsTokenManager.updateFromServerResponse(e), r = !0), n && await Kl(this), await this.auth._persistUserIfCurrent(this), r && this.auth._notifyListenersIfCurrent(this);
  }
  async delete() {
    const e = await this.getIdToken();
    return await zs(this, YT(this.auth, { idToken: e })), this.stsTokenManager.clearRefreshToken(), this.auth.signOut();
  }
  toJSON() {
    return Object.assign(Object.assign({
      uid: this.uid,
      email: this.email || void 0,
      emailVerified: this.emailVerified,
      displayName: this.displayName || void 0,
      isAnonymous: this.isAnonymous,
      photoURL: this.photoURL || void 0,
      phoneNumber: this.phoneNumber || void 0,
      tenantId: this.tenantId || void 0,
      providerData: this.providerData.map((e) => Object.assign({}, e)),
      stsTokenManager: this.stsTokenManager.toJSON(),
      // Redirect event ID must be maintained in case there is a pending
      // redirect event.
      _redirectEventId: this._redirectEventId
    }, this.metadata.toJSON()), {
      // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
      apiKey: this.auth.config.apiKey,
      appName: this.auth.name
    });
  }
  get refreshToken() {
    return this.stsTokenManager.refreshToken || "";
  }
  static _fromJSON(e, n) {
    var r, i, o, a, s, c, l, u;
    const d = (r = n.displayName) !== null && r !== void 0 ? r : void 0, f = (i = n.email) !== null && i !== void 0 ? i : void 0, h = (o = n.phoneNumber) !== null && o !== void 0 ? o : void 0, g = (a = n.photoURL) !== null && a !== void 0 ? a : void 0, v = (s = n.tenantId) !== null && s !== void 0 ? s : void 0, b = (c = n._redirectEventId) !== null && c !== void 0 ? c : void 0, m = (l = n.createdAt) !== null && l !== void 0 ? l : void 0, y = (u = n.lastLoginAt) !== null && u !== void 0 ? u : void 0, { uid: p, emailVerified: w, isAnonymous: _, providerData: E, stsTokenManager: S } = n;
    Fe(
      p && S,
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const T = Ks.fromJSON(this.name, S);
    Fe(
      typeof p == "string",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), _i(d, e.name), _i(f, e.name), Fe(
      typeof w == "boolean",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), Fe(
      typeof _ == "boolean",
      e,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), _i(h, e.name), _i(g, e.name), _i(v, e.name), _i(b, e.name), _i(m, e.name), _i(y, e.name);
    const x = new mo({
      uid: p,
      auth: e,
      email: f,
      emailVerified: w,
      displayName: d,
      isAnonymous: _,
      photoURL: g,
      phoneNumber: h,
      tenantId: v,
      stsTokenManager: T,
      createdAt: m,
      lastLoginAt: y
    });
    return E && Array.isArray(E) && (x.providerData = E.map((A) => Object.assign({}, A))), b && (x._redirectEventId = b), x;
  }
  /**
   * Initialize a User from an idToken server response
   * @param auth
   * @param idTokenResponse
   */
  static async _fromIdTokenResponse(e, n, r = !1) {
    const i = new Ks();
    i.updateFromServerResponse(n);
    const o = new mo({
      uid: n.localId,
      auth: e,
      stsTokenManager: i,
      isAnonymous: r
    });
    return await Kl(o), o;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class hb {
  constructor() {
    this.type = "NONE", this.storage = {};
  }
  async _isAvailable() {
    return !0;
  }
  async _set(e, n) {
    this.storage[e] = n;
  }
  async _get(e) {
    const n = this.storage[e];
    return n === void 0 ? null : n;
  }
  async _remove(e) {
    delete this.storage[e];
  }
  _addListener(e, n) {
  }
  _removeListener(e, n) {
  }
}
hb.type = "NONE";
const fv = hb;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function fl(t, e, n) {
  return `firebase:${t}:${e}:${n}`;
}
class la {
  constructor(e, n, r) {
    this.persistence = e, this.auth = n, this.userKey = r;
    const { config: i, name: o } = this.auth;
    this.fullUserKey = fl(this.userKey, i.apiKey, o), this.fullPersistenceKey = fl("persistence", i.apiKey, o), this.boundEventHandler = n._onStorageEvent.bind(n), this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
  }
  setCurrentUser(e) {
    return this.persistence._set(this.fullUserKey, e.toJSON());
  }
  async getCurrentUser() {
    const e = await this.persistence._get(this.fullUserKey);
    return e ? mo._fromJSON(this.auth, e) : null;
  }
  removeCurrentUser() {
    return this.persistence._remove(this.fullUserKey);
  }
  savePersistenceForRedirect() {
    return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
  }
  async setPersistence(e) {
    if (this.persistence === e)
      return;
    const n = await this.getCurrentUser();
    if (await this.removeCurrentUser(), this.persistence = e, n)
      return this.setCurrentUser(n);
  }
  delete() {
    this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
  }
  static async create(e, n, r = "authUser") {
    if (!n.length)
      return new la(ai(fv), e, r);
    const i = (await Promise.all(n.map(async (l) => {
      if (await l._isAvailable())
        return l;
    }))).filter((l) => l);
    let o = i[0] || ai(fv);
    const a = fl(r, e.config.apiKey, e.name);
    let s = null;
    for (const l of n)
      try {
        const u = await l._get(a);
        if (u) {
          const d = mo._fromJSON(e, u);
          l !== o && (s = d), o = l;
          break;
        }
      } catch {
      }
    const c = i.filter((l) => l._shouldAllowMigration);
    return !o._shouldAllowMigration || !c.length ? new la(o, e, r) : (o = c[0], s && await o._set(a, s.toJSON()), await Promise.all(n.map(async (l) => {
      if (l !== o)
        try {
          await l._remove(a);
        } catch {
        }
    })), new la(o, e, r));
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function hv(t) {
  const e = t.toLowerCase();
  if (e.includes("opera/") || e.includes("opr/") || e.includes("opios/"))
    return "Opera";
  if (mb(e))
    return "IEMobile";
  if (e.includes("msie") || e.includes("trident/"))
    return "IE";
  if (e.includes("edge/"))
    return "Edge";
  if (pb(e))
    return "Firefox";
  if (e.includes("silk/"))
    return "Silk";
  if (yb(e))
    return "Blackberry";
  if (wb(e))
    return "Webos";
  if (Up(e))
    return "Safari";
  if ((e.includes("chrome/") || gb(e)) && !e.includes("edge/"))
    return "Chrome";
  if (vb(e))
    return "Android";
  {
    const n = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/, r = t.match(n);
    if ((r == null ? void 0 : r.length) === 2)
      return r[1];
  }
  return "Other";
}
function pb(t = Pn()) {
  return /firefox\//i.test(t);
}
function Up(t = Pn()) {
  const e = t.toLowerCase();
  return e.includes("safari/") && !e.includes("chrome/") && !e.includes("crios/") && !e.includes("android");
}
function gb(t = Pn()) {
  return /crios\//i.test(t);
}
function mb(t = Pn()) {
  return /iemobile/i.test(t);
}
function vb(t = Pn()) {
  return /android/i.test(t);
}
function yb(t = Pn()) {
  return /blackberry/i.test(t);
}
function wb(t = Pn()) {
  return /webos/i.test(t);
}
function Du(t = Pn()) {
  return /iphone|ipad|ipod/i.test(t) || /macintosh/i.test(t) && /mobile/i.test(t);
}
function ok(t = Pn()) {
  var e;
  return Du(t) && !!(!((e = window.navigator) === null || e === void 0) && e.standalone);
}
function ak() {
  return gS() && document.documentMode === 10;
}
function bb(t = Pn()) {
  return Du(t) || vb(t) || wb(t) || yb(t) || /windows phone/i.test(t) || mb(t);
}
function sk() {
  try {
    return !!(window && window !== window.top);
  } catch {
    return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _b(t, e = []) {
  let n;
  switch (t) {
    case "Browser":
      n = hv(Pn());
      break;
    case "Worker":
      n = `${hv(Pn())}-${t}`;
      break;
    default:
      n = t;
  }
  const r = e.length ? e.join(",") : "FirebaseCore-web";
  return `${n}/JsCore/${Pu}/${r}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ck {
  constructor(e) {
    this.auth = e, this.queue = [];
  }
  pushCallback(e, n) {
    const r = (o) => new Promise((a, s) => {
      try {
        const c = e(o);
        a(c);
      } catch (c) {
        s(c);
      }
    });
    r.onAbort = n, this.queue.push(r);
    const i = this.queue.length - 1;
    return () => {
      this.queue[i] = () => Promise.resolve();
    };
  }
  async runMiddleware(e) {
    if (this.auth.currentUser === e)
      return;
    const n = [];
    try {
      for (const r of this.queue)
        await r(e), r.onAbort && n.push(r.onAbort);
    } catch (r) {
      n.reverse();
      for (const i of n)
        try {
          i();
        } catch {
        }
      throw this.auth._errorFactory.create("login-blocked", {
        originalMessage: r == null ? void 0 : r.message
      });
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class lk {
  constructor(e, n, r) {
    this.app = e, this.heartbeatServiceProvider = n, this.config = r, this.currentUser = null, this.emulatorConfig = null, this.operations = Promise.resolve(), this.authStateSubscription = new pv(this), this.idTokenSubscription = new pv(this), this.beforeStateQueue = new ck(this), this.redirectUser = null, this.isProactiveRefreshEnabled = !1, this._canInitEmulator = !0, this._isInitialized = !1, this._deleted = !1, this._initializationPromise = null, this._popupRedirectResolver = null, this._errorFactory = ab, this.lastNotifiedUid = void 0, this.languageCode = null, this.tenantId = null, this.settings = { appVerificationDisabledForTesting: !1 }, this.frameworks = [], this.name = e.name, this.clientVersion = r.sdkClientVersion;
  }
  _initializeWithPersistence(e, n) {
    return n && (this._popupRedirectResolver = ai(n)), this._initializationPromise = this.queue(async () => {
      var r, i;
      if (!this._deleted && (this.persistenceManager = await la.create(this, e), !this._deleted)) {
        if (!((r = this._popupRedirectResolver) === null || r === void 0) && r._shouldInitProactively)
          try {
            await this._popupRedirectResolver._initialize(this);
          } catch {
          }
        await this.initializeCurrentUser(n), this.lastNotifiedUid = ((i = this.currentUser) === null || i === void 0 ? void 0 : i.uid) || null, !this._deleted && (this._isInitialized = !0);
      }
    }), this._initializationPromise;
  }
  /**
   * If the persistence is changed in another window, the user manager will let us know
   */
  async _onStorageEvent() {
    if (this._deleted)
      return;
    const e = await this.assertedPersistence.getCurrentUser();
    if (!(!this.currentUser && !e)) {
      if (this.currentUser && e && this.currentUser.uid === e.uid) {
        this._currentUser._assign(e), await this.currentUser.getIdToken();
        return;
      }
      await this._updateCurrentUser(
        e,
        /* skipBeforeStateCallbacks */
        !0
      );
    }
  }
  async initializeCurrentUser(e) {
    var n;
    const r = await this.assertedPersistence.getCurrentUser();
    let i = r, o = !1;
    if (e && this.config.authDomain) {
      await this.getOrInitRedirectPersistenceManager();
      const a = (n = this.redirectUser) === null || n === void 0 ? void 0 : n._redirectEventId, s = i == null ? void 0 : i._redirectEventId, c = await this.tryRedirectSignIn(e);
      (!a || a === s) && (c != null && c.user) && (i = c.user, o = !0);
    }
    if (!i)
      return this.directlySetCurrentUser(null);
    if (!i._redirectEventId) {
      if (o)
        try {
          await this.beforeStateQueue.runMiddleware(i);
        } catch (a) {
          i = r, this._popupRedirectResolver._overrideRedirectResult(this, () => Promise.reject(a));
        }
      return i ? this.reloadAndSetCurrentUserOrClear(i) : this.directlySetCurrentUser(null);
    }
    return Fe(
      this._popupRedirectResolver,
      this,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), await this.getOrInitRedirectPersistenceManager(), this.redirectUser && this.redirectUser._redirectEventId === i._redirectEventId ? this.directlySetCurrentUser(i) : this.reloadAndSetCurrentUserOrClear(i);
  }
  async tryRedirectSignIn(e) {
    let n = null;
    try {
      n = await this._popupRedirectResolver._completeRedirectFn(this, e, !0);
    } catch {
      await this._setRedirectUser(null);
    }
    return n;
  }
  async reloadAndSetCurrentUserOrClear(e) {
    try {
      await Kl(e);
    } catch (n) {
      if ((n == null ? void 0 : n.code) !== "auth/network-request-failed")
        return this.directlySetCurrentUser(null);
    }
    return this.directlySetCurrentUser(e);
  }
  useDeviceLanguage() {
    this.languageCode = zT();
  }
  async _delete() {
    this._deleted = !0;
  }
  async updateCurrentUser(e) {
    const n = e ? yi(e) : null;
    return n && Fe(
      n.auth.config.apiKey === this.config.apiKey,
      this,
      "invalid-user-token"
      /* AuthErrorCode.INVALID_AUTH */
    ), this._updateCurrentUser(n && n._clone(this));
  }
  async _updateCurrentUser(e, n = !1) {
    if (!this._deleted)
      return e && Fe(
        this.tenantId === e.tenantId,
        this,
        "tenant-id-mismatch"
        /* AuthErrorCode.TENANT_ID_MISMATCH */
      ), n || await this.beforeStateQueue.runMiddleware(e), this.queue(async () => {
        await this.directlySetCurrentUser(e), this.notifyAuthListeners();
      });
  }
  async signOut() {
    return await this.beforeStateQueue.runMiddleware(null), (this.redirectPersistenceManager || this._popupRedirectResolver) && await this._setRedirectUser(null), this._updateCurrentUser(
      null,
      /* skipBeforeStateCallbacks */
      !0
    );
  }
  setPersistence(e) {
    return this.queue(async () => {
      await this.assertedPersistence.setPersistence(ai(e));
    });
  }
  _getPersistence() {
    return this.assertedPersistence.persistence.type;
  }
  _updateErrorMap(e) {
    this._errorFactory = new uc("auth", "Firebase", e());
  }
  onAuthStateChanged(e, n, r) {
    return this.registerStateListener(this.authStateSubscription, e, n, r);
  }
  beforeAuthStateChanged(e, n) {
    return this.beforeStateQueue.pushCallback(e, n);
  }
  onIdTokenChanged(e, n, r) {
    return this.registerStateListener(this.idTokenSubscription, e, n, r);
  }
  toJSON() {
    var e;
    return {
      apiKey: this.config.apiKey,
      authDomain: this.config.authDomain,
      appName: this.name,
      currentUser: (e = this._currentUser) === null || e === void 0 ? void 0 : e.toJSON()
    };
  }
  async _setRedirectUser(e, n) {
    const r = await this.getOrInitRedirectPersistenceManager(n);
    return e === null ? r.removeCurrentUser() : r.setCurrentUser(e);
  }
  async getOrInitRedirectPersistenceManager(e) {
    if (!this.redirectPersistenceManager) {
      const n = e && ai(e) || this._popupRedirectResolver;
      Fe(
        n,
        this,
        "argument-error"
        /* AuthErrorCode.ARGUMENT_ERROR */
      ), this.redirectPersistenceManager = await la.create(
        this,
        [ai(n._redirectPersistence)],
        "redirectUser"
        /* KeyName.REDIRECT_USER */
      ), this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
    }
    return this.redirectPersistenceManager;
  }
  async _redirectUserForId(e) {
    var n, r;
    return this._isInitialized && await this.queue(async () => {
    }), ((n = this._currentUser) === null || n === void 0 ? void 0 : n._redirectEventId) === e ? this._currentUser : ((r = this.redirectUser) === null || r === void 0 ? void 0 : r._redirectEventId) === e ? this.redirectUser : null;
  }
  async _persistUserIfCurrent(e) {
    if (e === this.currentUser)
      return this.queue(async () => this.directlySetCurrentUser(e));
  }
  /** Notifies listeners only if the user is current */
  _notifyListenersIfCurrent(e) {
    e === this.currentUser && this.notifyAuthListeners();
  }
  _key() {
    return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
  }
  _startProactiveRefresh() {
    this.isProactiveRefreshEnabled = !0, this.currentUser && this._currentUser._startProactiveRefresh();
  }
  _stopProactiveRefresh() {
    this.isProactiveRefreshEnabled = !1, this.currentUser && this._currentUser._stopProactiveRefresh();
  }
  /** Returns the current user cast as the internal type */
  get _currentUser() {
    return this.currentUser;
  }
  notifyAuthListeners() {
    var e, n;
    if (!this._isInitialized)
      return;
    this.idTokenSubscription.next(this.currentUser);
    const r = (n = (e = this.currentUser) === null || e === void 0 ? void 0 : e.uid) !== null && n !== void 0 ? n : null;
    this.lastNotifiedUid !== r && (this.lastNotifiedUid = r, this.authStateSubscription.next(this.currentUser));
  }
  registerStateListener(e, n, r, i) {
    if (this._deleted)
      return () => {
      };
    const o = typeof n == "function" ? n : n.next.bind(n), a = this._isInitialized ? Promise.resolve() : this._initializationPromise;
    return Fe(
      a,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), a.then(() => o(this.currentUser)), typeof n == "function" ? e.addObserver(n, r, i) : e.addObserver(n);
  }
  /**
   * Unprotected (from race conditions) method to set the current user. This
   * should only be called from within a queued callback. This is necessary
   * because the queue shouldn't rely on another queued callback.
   */
  async directlySetCurrentUser(e) {
    this.currentUser && this.currentUser !== e && this._currentUser._stopProactiveRefresh(), e && this.isProactiveRefreshEnabled && e._startProactiveRefresh(), this.currentUser = e, e ? await this.assertedPersistence.setCurrentUser(e) : await this.assertedPersistence.removeCurrentUser();
  }
  queue(e) {
    return this.operations = this.operations.then(e, e), this.operations;
  }
  get assertedPersistence() {
    return Fe(
      this.persistenceManager,
      this,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.persistenceManager;
  }
  _logFramework(e) {
    !e || this.frameworks.includes(e) || (this.frameworks.push(e), this.frameworks.sort(), this.clientVersion = _b(this.config.clientPlatform, this._getFrameworks()));
  }
  _getFrameworks() {
    return this.frameworks;
  }
  async _getAdditionalHeaders() {
    var e;
    const n = {
      [
        "X-Client-Version"
        /* HttpHeader.X_CLIENT_VERSION */
      ]: this.clientVersion
    };
    this.app.options.appId && (n[
      "X-Firebase-gmpid"
      /* HttpHeader.X_FIREBASE_GMPID */
    ] = this.app.options.appId);
    const r = await ((e = this.heartbeatServiceProvider.getImmediate({
      optional: !0
    })) === null || e === void 0 ? void 0 : e.getHeartbeatsHeader());
    return r && (n[
      "X-Firebase-Client"
      /* HttpHeader.X_FIREBASE_CLIENT */
    ] = r), n;
  }
}
function Wi(t) {
  return yi(t);
}
let pv = class {
  constructor(e) {
    this.auth = e, this.observer = null, this.addObserver = OS((n) => this.observer = n);
  }
  get next() {
    return Fe(
      this.observer,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), this.observer.next.bind(this.observer);
  }
};
function uk(t, e, n) {
  const r = Wi(t);
  Fe(
    r._canInitEmulator,
    r,
    "emulator-config-failed"
    /* AuthErrorCode.EMULATOR_CONFIG_FAILED */
  ), Fe(
    /^https?:\/\//.test(e),
    r,
    "invalid-emulator-scheme"
    /* AuthErrorCode.INVALID_EMULATOR_SCHEME */
  );
  const i = !!(n != null && n.disableWarnings), o = Eb(e), { host: a, port: s } = dk(e), c = s === null ? "" : `:${s}`;
  r.config.emulator = { url: `${o}//${a}${c}/` }, r.settings.appVerificationDisabledForTesting = !0, r.emulatorConfig = Object.freeze({
    host: a,
    port: s,
    protocol: o.replace(":", ""),
    options: Object.freeze({ disableWarnings: i })
  }), i || fk();
}
function Eb(t) {
  const e = t.indexOf(":");
  return e < 0 ? "" : t.substr(0, e + 1);
}
function dk(t) {
  const e = Eb(t), n = /(\/\/)?([^?#/]+)/.exec(t.substr(e.length));
  if (!n)
    return { host: "", port: null };
  const r = n[2].split("@").pop() || "", i = /^(\[[^\]]+\])(:|$)/.exec(r);
  if (i) {
    const o = i[1];
    return { host: o, port: gv(r.substr(o.length + 1)) };
  } else {
    const [o, a] = r.split(":");
    return { host: o, port: gv(a) };
  }
}
function gv(t) {
  if (!t)
    return null;
  const e = Number(t);
  return isNaN(e) ? null : e;
}
function fk() {
  function t() {
    const e = document.createElement("p"), n = e.style;
    e.innerText = "Running in emulator mode. Do not use with production credentials.", n.position = "fixed", n.width = "100%", n.backgroundColor = "#ffffff", n.border = ".1em solid #000000", n.color = "#b50000", n.bottom = "0px", n.left = "0px", n.margin = "0px", n.zIndex = "10000", n.textAlign = "center", e.classList.add("firebase-emulator-warning"), document.body.appendChild(e);
  }
  typeof console < "u" && typeof console.info == "function" && console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials."), typeof window < "u" && typeof document < "u" && (document.readyState === "loading" ? window.addEventListener("DOMContentLoaded", t) : t());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Hp {
  /** @internal */
  constructor(e, n) {
    this.providerId = e, this.signInMethod = n;
  }
  /**
   * Returns a JSON-serializable representation of this object.
   *
   * @returns a JSON-serializable representation of this object.
   */
  toJSON() {
    return oi("not implemented");
  }
  /** @internal */
  _getIdTokenResponse(e) {
    return oi("not implemented");
  }
  /** @internal */
  _linkToIdToken(e, n) {
    return oi("not implemented");
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    return oi("not implemented");
  }
}
async function hk(t, e) {
  return pc(t, "POST", "/v1/accounts:update", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function pk(t, e) {
  return gc(t, "POST", "/v1/accounts:signInWithPassword", hc(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function gk(t, e) {
  return gc(t, "POST", "/v1/accounts:signInWithEmailLink", hc(t, e));
}
async function mk(t, e) {
  return gc(t, "POST", "/v1/accounts:signInWithEmailLink", hc(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ws extends Hp {
  /** @internal */
  constructor(e, n, r, i = null) {
    super("password", r), this._email = e, this._password = n, this._tenantId = i;
  }
  /** @internal */
  static _fromEmailAndPassword(e, n) {
    return new Ws(
      e,
      n,
      "password"
      /* SignInMethod.EMAIL_PASSWORD */
    );
  }
  /** @internal */
  static _fromEmailAndCode(e, n, r = null) {
    return new Ws(e, n, "emailLink", r);
  }
  /** {@inheritdoc AuthCredential.toJSON} */
  toJSON() {
    return {
      email: this._email,
      password: this._password,
      signInMethod: this.signInMethod,
      tenantId: this._tenantId
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
   *
   * @param json - Either `object` or the stringified representation of the object. When string is
   * provided, `JSON.parse` would be called first.
   *
   * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
   */
  static fromJSON(e) {
    const n = typeof e == "string" ? JSON.parse(e) : e;
    if (n != null && n.email && (n != null && n.password)) {
      if (n.signInMethod === "password")
        return this._fromEmailAndPassword(n.email, n.password);
      if (n.signInMethod === "emailLink")
        return this._fromEmailAndCode(n.email, n.password, n.tenantId);
    }
    return null;
  }
  /** @internal */
  async _getIdTokenResponse(e) {
    switch (this.signInMethod) {
      case "password":
        return pk(e, {
          returnSecureToken: !0,
          email: this._email,
          password: this._password
        });
      case "emailLink":
        return gk(e, {
          email: this._email,
          oobCode: this._password
        });
      default:
        pr(
          e,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  async _linkToIdToken(e, n) {
    switch (this.signInMethod) {
      case "password":
        return hk(e, {
          idToken: n,
          returnSecureToken: !0,
          email: this._email,
          password: this._password
        });
      case "emailLink":
        return mk(e, {
          idToken: n,
          email: this._email,
          oobCode: this._password
        });
      default:
        pr(
          e,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    return this._getIdTokenResponse(e);
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function ua(t, e) {
  return gc(t, "POST", "/v1/accounts:signInWithIdp", hc(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const vk = "http://localhost";
class Eo extends Hp {
  constructor() {
    super(...arguments), this.pendingToken = null;
  }
  /** @internal */
  static _fromParams(e) {
    const n = new Eo(e.providerId, e.signInMethod);
    return e.idToken || e.accessToken ? (e.idToken && (n.idToken = e.idToken), e.accessToken && (n.accessToken = e.accessToken), e.nonce && !e.pendingToken && (n.nonce = e.nonce), e.pendingToken && (n.pendingToken = e.pendingToken)) : e.oauthToken && e.oauthTokenSecret ? (n.accessToken = e.oauthToken, n.secret = e.oauthTokenSecret) : pr(
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), n;
  }
  /** {@inheritdoc AuthCredential.toJSON}  */
  toJSON() {
    return {
      idToken: this.idToken,
      accessToken: this.accessToken,
      secret: this.secret,
      nonce: this.nonce,
      pendingToken: this.pendingToken,
      providerId: this.providerId,
      signInMethod: this.signInMethod
    };
  }
  /**
   * Static method to deserialize a JSON representation of an object into an
   * {@link  AuthCredential}.
   *
   * @param json - Input can be either Object or the stringified representation of the object.
   * When string is provided, JSON.parse would be called first.
   *
   * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
   */
  static fromJSON(e) {
    const n = typeof e == "string" ? JSON.parse(e) : e, { providerId: r, signInMethod: i } = n, o = jr(n, ["providerId", "signInMethod"]);
    if (!r || !i)
      return null;
    const a = new Eo(r, i);
    return a.idToken = o.idToken || void 0, a.accessToken = o.accessToken || void 0, a.secret = o.secret, a.nonce = o.nonce, a.pendingToken = o.pendingToken || null, a;
  }
  /** @internal */
  _getIdTokenResponse(e) {
    const n = this.buildRequest();
    return ua(e, n);
  }
  /** @internal */
  _linkToIdToken(e, n) {
    const r = this.buildRequest();
    return r.idToken = n, ua(e, r);
  }
  /** @internal */
  _getReauthenticationResolver(e) {
    const n = this.buildRequest();
    return n.autoCreate = !1, ua(e, n);
  }
  buildRequest() {
    const e = {
      requestUri: vk,
      returnSecureToken: !0
    };
    if (this.pendingToken)
      e.pendingToken = this.pendingToken;
    else {
      const n = {};
      this.idToken && (n.id_token = this.idToken), this.accessToken && (n.access_token = this.accessToken), this.secret && (n.oauth_token_secret = this.secret), n.providerId = this.providerId, this.nonce && !this.pendingToken && (n.nonce = this.nonce), e.postBody = dc(n);
    }
    return e;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function yk(t) {
  switch (t) {
    case "recoverEmail":
      return "RECOVER_EMAIL";
    case "resetPassword":
      return "PASSWORD_RESET";
    case "signIn":
      return "EMAIL_SIGNIN";
    case "verifyEmail":
      return "VERIFY_EMAIL";
    case "verifyAndChangeEmail":
      return "VERIFY_AND_CHANGE_EMAIL";
    case "revertSecondFactorAddition":
      return "REVERT_SECOND_FACTOR_ADDITION";
    default:
      return null;
  }
}
function wk(t) {
  const e = ys(ws(t)).link, n = e ? ys(ws(e)).deep_link_id : null, r = ys(ws(t)).deep_link_id;
  return (r ? ys(ws(r)).link : null) || r || n || e || t;
}
class Bp {
  /**
   * @param actionLink - The link from which to extract the URL.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @internal
   */
  constructor(e) {
    var n, r, i, o, a, s;
    const c = ys(ws(e)), l = (n = c.apiKey) !== null && n !== void 0 ? n : null, u = (r = c.oobCode) !== null && r !== void 0 ? r : null, d = yk((i = c.mode) !== null && i !== void 0 ? i : null);
    Fe(
      l && u && d,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), this.apiKey = l, this.operation = d, this.code = u, this.continueUrl = (o = c.continueUrl) !== null && o !== void 0 ? o : null, this.languageCode = (a = c.languageCode) !== null && a !== void 0 ? a : null, this.tenantId = (s = c.tenantId) !== null && s !== void 0 ? s : null;
  }
  /**
   * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
   * otherwise returns null.
   *
   * @param link  - The email action link string.
   * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
   *
   * @public
   */
  static parseLink(e) {
    const n = wk(e);
    try {
      return new Bp(n);
    } catch {
      return null;
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Po {
  constructor() {
    this.providerId = Po.PROVIDER_ID;
  }
  /**
   * Initialize an {@link AuthCredential} using an email and password.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credential(email, password);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * const userCredential = await signInWithEmailAndPassword(auth, email, password);
   * ```
   *
   * @param email - Email address.
   * @param password - User account password.
   * @returns The auth provider credential.
   */
  static credential(e, n) {
    return Ws._fromEmailAndPassword(e, n);
  }
  /**
   * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
   * email link operation.
   *
   * @example
   * ```javascript
   * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
   * const userCredential = await signInWithCredential(auth, authCredential);
   * ```
   *
   * @example
   * ```javascript
   * await sendSignInLinkToEmail(auth, email);
   * // Obtain emailLink from user.
   * const userCredential = await signInWithEmailLink(auth, email, emailLink);
   * ```
   *
   * @param auth - The {@link Auth} instance used to verify the link.
   * @param email - Email address.
   * @param emailLink - Sign-in email link.
   * @returns - The auth provider credential.
   */
  static credentialWithLink(e, n) {
    const r = Bp.parseLink(n);
    return Fe(
      r,
      "argument-error"
      /* AuthErrorCode.ARGUMENT_ERROR */
    ), Ws._fromEmailAndCode(e, r.code, r.tenantId);
  }
}
Po.PROVIDER_ID = "password";
Po.EMAIL_PASSWORD_SIGN_IN_METHOD = "password";
Po.EMAIL_LINK_SIGN_IN_METHOD = "emailLink";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Lu {
  /**
   * Constructor for generic OAuth providers.
   *
   * @param providerId - Provider for which credentials should be generated.
   */
  constructor(e) {
    this.providerId = e, this.defaultLanguageCode = null, this.customParameters = {};
  }
  /**
   * Set the language gode.
   *
   * @param languageCode - language code
   */
  setDefaultLanguage(e) {
    this.defaultLanguageCode = e;
  }
  /**
   * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
   * operations.
   *
   * @remarks
   * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
   * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
   *
   * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
   */
  setCustomParameters(e) {
    return this.customParameters = e, this;
  }
  /**
   * Retrieve the current list of {@link CustomParameters}.
   */
  getCustomParameters() {
    return this.customParameters;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class mc extends Lu {
  constructor() {
    super(...arguments), this.scopes = [];
  }
  /**
   * Add an OAuth scope to the credential.
   *
   * @param scope - Provider OAuth scope to add.
   */
  addScope(e) {
    return this.scopes.includes(e) || this.scopes.push(e), this;
  }
  /**
   * Retrieve the current list of OAuth scopes.
   */
  getScopes() {
    return [...this.scopes];
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ri extends mc {
  constructor() {
    super(
      "facebook.com"
      /* ProviderId.FACEBOOK */
    );
  }
  /**
   * Creates a credential for Facebook.
   *
   * @example
   * ```javascript
   * // `event` from the Facebook auth.authResponseChange callback.
   * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param accessToken - Facebook access token.
   */
  static credential(e) {
    return Eo._fromParams({
      providerId: Ri.PROVIDER_ID,
      signInMethod: Ri.FACEBOOK_SIGN_IN_METHOD,
      accessToken: e
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return Ri.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return Ri.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e || !("oauthAccessToken" in e) || !e.oauthAccessToken)
      return null;
    try {
      return Ri.credential(e.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
Ri.FACEBOOK_SIGN_IN_METHOD = "facebook.com";
Ri.PROVIDER_ID = "facebook.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Ni extends mc {
  constructor() {
    super(
      "google.com"
      /* ProviderId.GOOGLE */
    ), this.addScope("profile");
  }
  /**
   * Creates a credential for Google. At least one of ID token and access token is required.
   *
   * @example
   * ```javascript
   * // \`googleUser\` from the onsuccess Google Sign In callback.
   * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
   * const result = await signInWithCredential(credential);
   * ```
   *
   * @param idToken - Google ID token.
   * @param accessToken - Google access token.
   */
  static credential(e, n) {
    return Eo._fromParams({
      providerId: Ni.PROVIDER_ID,
      signInMethod: Ni.GOOGLE_SIGN_IN_METHOD,
      idToken: e,
      accessToken: n
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return Ni.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return Ni.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e)
      return null;
    const { oauthIdToken: n, oauthAccessToken: r } = e;
    if (!n && !r)
      return null;
    try {
      return Ni.credential(n, r);
    } catch {
      return null;
    }
  }
}
Ni.GOOGLE_SIGN_IN_METHOD = "google.com";
Ni.PROVIDER_ID = "google.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Mi extends mc {
  constructor() {
    super(
      "github.com"
      /* ProviderId.GITHUB */
    );
  }
  /**
   * Creates a credential for Github.
   *
   * @param accessToken - Github access token.
   */
  static credential(e) {
    return Eo._fromParams({
      providerId: Mi.PROVIDER_ID,
      signInMethod: Mi.GITHUB_SIGN_IN_METHOD,
      accessToken: e
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return Mi.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return Mi.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e || !("oauthAccessToken" in e) || !e.oauthAccessToken)
      return null;
    try {
      return Mi.credential(e.oauthAccessToken);
    } catch {
      return null;
    }
  }
}
Mi.GITHUB_SIGN_IN_METHOD = "github.com";
Mi.PROVIDER_ID = "github.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Pi extends mc {
  constructor() {
    super(
      "twitter.com"
      /* ProviderId.TWITTER */
    );
  }
  /**
   * Creates a credential for Twitter.
   *
   * @param token - Twitter access token.
   * @param secret - Twitter secret.
   */
  static credential(e, n) {
    return Eo._fromParams({
      providerId: Pi.PROVIDER_ID,
      signInMethod: Pi.TWITTER_SIGN_IN_METHOD,
      oauthToken: e,
      oauthTokenSecret: n
    });
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromResult(e) {
    return Pi.credentialFromTaggedObject(e);
  }
  /**
   * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
   * thrown during a sign-in, link, or reauthenticate operation.
   *
   * @param userCredential - The user credential.
   */
  static credentialFromError(e) {
    return Pi.credentialFromTaggedObject(e.customData || {});
  }
  static credentialFromTaggedObject({ _tokenResponse: e }) {
    if (!e)
      return null;
    const { oauthAccessToken: n, oauthTokenSecret: r } = e;
    if (!n || !r)
      return null;
    try {
      return Pi.credential(n, r);
    } catch {
      return null;
    }
  }
}
Pi.TWITTER_SIGN_IN_METHOD = "twitter.com";
Pi.PROVIDER_ID = "twitter.com";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function bk(t, e) {
  return gc(t, "POST", "/v1/accounts:signUp", hc(t, e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Co {
  constructor(e) {
    this.user = e.user, this.providerId = e.providerId, this._tokenResponse = e._tokenResponse, this.operationType = e.operationType;
  }
  static async _fromIdTokenResponse(e, n, r, i = !1) {
    const o = await mo._fromIdTokenResponse(e, r, i), a = mv(r);
    return new Co({
      user: o,
      providerId: a,
      _tokenResponse: r,
      operationType: n
    });
  }
  static async _forOperation(e, n, r) {
    await e._updateTokensIfNecessary(
      r,
      /* reload */
      !0
    );
    const i = mv(r);
    return new Co({
      user: e,
      providerId: i,
      _tokenResponse: r,
      operationType: n
    });
  }
}
function mv(t) {
  return t.providerId ? t.providerId : "phoneNumber" in t ? "phone" : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Wl extends Ki {
  constructor(e, n, r, i) {
    var o;
    super(n.code, n.message), this.operationType = r, this.user = i, Object.setPrototypeOf(this, Wl.prototype), this.customData = {
      appName: e.name,
      tenantId: (o = e.tenantId) !== null && o !== void 0 ? o : void 0,
      _serverResponse: n.customData._serverResponse,
      operationType: r
    };
  }
  static _fromErrorAndOperation(e, n, r, i) {
    return new Wl(e, n, r, i);
  }
}
function Cb(t, e, n, r) {
  return (e === "reauthenticate" ? n._getReauthenticationResolver(t) : n._getIdTokenResponse(t)).catch((o) => {
    throw o.code === "auth/multi-factor-auth-required" ? Wl._fromErrorAndOperation(t, o, e, r) : o;
  });
}
async function _k(t, e, n = !1) {
  const r = await zs(t, e._linkToIdToken(t.auth, await t.getIdToken()), n);
  return Co._forOperation(t, "link", r);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Ek(t, e, n = !1) {
  const { auth: r } = t, i = "reauthenticate";
  try {
    const o = await zs(t, Cb(r, i, e, t), n);
    Fe(
      o.idToken,
      r,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const a = Fp(o.idToken);
    Fe(
      a,
      r,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    );
    const { sub: s } = a;
    return Fe(
      t.uid === s,
      r,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), Co._forOperation(t, i, o);
  } catch (o) {
    throw (o == null ? void 0 : o.code) === "auth/user-not-found" && pr(
      r,
      "user-mismatch"
      /* AuthErrorCode.USER_MISMATCH */
    ), o;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function Ib(t, e, n = !1) {
  const r = "signIn", i = await Cb(t, r, e), o = await Co._fromIdTokenResponse(t, r, i);
  return n || await t._updateCurrentUser(o.user), o;
}
async function Ck(t, e) {
  return Ib(Wi(t), e);
}
async function Ik(t, e, n) {
  const r = Wi(t), i = await bk(r, {
    returnSecureToken: !0,
    email: e,
    password: n
  }), o = await Co._fromIdTokenResponse(r, "signIn", i);
  return await r._updateCurrentUser(o.user), o;
}
function Sk(t, e, n) {
  return Ck(yi(t), Po.credential(e, n));
}
function Tk(t, e, n, r) {
  return yi(t).onIdTokenChanged(e, n, r);
}
function kk(t, e, n) {
  return yi(t).beforeAuthStateChanged(e, n);
}
function Ak(t, e, n, r) {
  return yi(t).onAuthStateChanged(e, n, r);
}
function Ok(t) {
  return yi(t).signOut();
}
const Gl = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Sb {
  constructor(e, n) {
    this.storageRetriever = e, this.type = n;
  }
  _isAvailable() {
    try {
      return this.storage ? (this.storage.setItem(Gl, "1"), this.storage.removeItem(Gl), Promise.resolve(!0)) : Promise.resolve(!1);
    } catch {
      return Promise.resolve(!1);
    }
  }
  _set(e, n) {
    return this.storage.setItem(e, JSON.stringify(n)), Promise.resolve();
  }
  _get(e) {
    const n = this.storage.getItem(e);
    return Promise.resolve(n ? JSON.parse(n) : null);
  }
  _remove(e) {
    return this.storage.removeItem(e), Promise.resolve();
  }
  get storage() {
    return this.storageRetriever();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function xk() {
  const t = Pn();
  return Up(t) || Du(t);
}
const Rk = 1e3, Nk = 10;
class Tb extends Sb {
  constructor() {
    super(
      () => window.localStorage,
      "LOCAL"
      /* PersistenceType.LOCAL */
    ), this.boundEventHandler = (e, n) => this.onStorageEvent(e, n), this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.safariLocalStorageNotSynced = xk() && sk(), this.fallbackToPolling = bb(), this._shouldAllowMigration = !0;
  }
  forAllChangedKeys(e) {
    for (const n of Object.keys(this.listeners)) {
      const r = this.storage.getItem(n), i = this.localCache[n];
      r !== i && e(n, i, r);
    }
  }
  onStorageEvent(e, n = !1) {
    if (!e.key) {
      this.forAllChangedKeys((a, s, c) => {
        this.notifyListeners(a, c);
      });
      return;
    }
    const r = e.key;
    if (n ? this.detachListener() : this.stopPolling(), this.safariLocalStorageNotSynced) {
      const a = this.storage.getItem(r);
      if (e.newValue !== a)
        e.newValue !== null ? this.storage.setItem(r, e.newValue) : this.storage.removeItem(r);
      else if (this.localCache[r] === e.newValue && !n)
        return;
    }
    const i = () => {
      const a = this.storage.getItem(r);
      !n && this.localCache[r] === a || this.notifyListeners(r, a);
    }, o = this.storage.getItem(r);
    ak() && o !== e.newValue && e.newValue !== e.oldValue ? setTimeout(i, Nk) : i();
  }
  notifyListeners(e, n) {
    this.localCache[e] = n;
    const r = this.listeners[e];
    if (r)
      for (const i of Array.from(r))
        i(n && JSON.parse(n));
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(() => {
      this.forAllChangedKeys((e, n, r) => {
        this.onStorageEvent(
          new StorageEvent("storage", {
            key: e,
            oldValue: n,
            newValue: r
          }),
          /* poll */
          !0
        );
      });
    }, Rk);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  attachListener() {
    window.addEventListener("storage", this.boundEventHandler);
  }
  detachListener() {
    window.removeEventListener("storage", this.boundEventHandler);
  }
  _addListener(e, n) {
    Object.keys(this.listeners).length === 0 && (this.fallbackToPolling ? this.startPolling() : this.attachListener()), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this.localCache[e] = this.storage.getItem(e)), this.listeners[e].add(n);
  }
  _removeListener(e, n) {
    this.listeners[e] && (this.listeners[e].delete(n), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && (this.detachListener(), this.stopPolling());
  }
  // Update local cache on base operations:
  async _set(e, n) {
    await super._set(e, n), this.localCache[e] = JSON.stringify(n);
  }
  async _get(e) {
    const n = await super._get(e);
    return this.localCache[e] = JSON.stringify(n), n;
  }
  async _remove(e) {
    await super._remove(e), delete this.localCache[e];
  }
}
Tb.type = "LOCAL";
const Mk = Tb;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class kb extends Sb {
  constructor() {
    super(
      () => window.sessionStorage,
      "SESSION"
      /* PersistenceType.SESSION */
    );
  }
  _addListener(e, n) {
  }
  _removeListener(e, n) {
  }
}
kb.type = "SESSION";
const Ab = kb;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Pk(t) {
  return Promise.all(t.map(async (e) => {
    try {
      return {
        fulfilled: !0,
        value: await e
      };
    } catch (n) {
      return {
        fulfilled: !1,
        reason: n
      };
    }
  }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Fu {
  constructor(e) {
    this.eventTarget = e, this.handlersMap = {}, this.boundEventHandler = this.handleEvent.bind(this);
  }
  /**
   * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
   *
   * @param eventTarget - An event target (such as window or self) through which the underlying
   * messages will be received.
   */
  static _getInstance(e) {
    const n = this.receivers.find((i) => i.isListeningto(e));
    if (n)
      return n;
    const r = new Fu(e);
    return this.receivers.push(r), r;
  }
  isListeningto(e) {
    return this.eventTarget === e;
  }
  /**
   * Fans out a MessageEvent to the appropriate listeners.
   *
   * @remarks
   * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
   * finished processing.
   *
   * @param event - The MessageEvent.
   *
   */
  async handleEvent(e) {
    const n = e, { eventId: r, eventType: i, data: o } = n.data, a = this.handlersMap[i];
    if (!(a != null && a.size))
      return;
    n.ports[0].postMessage({
      status: "ack",
      eventId: r,
      eventType: i
    });
    const s = Array.from(a).map(async (l) => l(n.origin, o)), c = await Pk(s);
    n.ports[0].postMessage({
      status: "done",
      eventId: r,
      eventType: i,
      response: c
    });
  }
  /**
   * Subscribe an event handler for a particular event.
   *
   * @param eventType - Event name to subscribe to.
   * @param eventHandler - The event handler which should receive the events.
   *
   */
  _subscribe(e, n) {
    Object.keys(this.handlersMap).length === 0 && this.eventTarget.addEventListener("message", this.boundEventHandler), this.handlersMap[e] || (this.handlersMap[e] = /* @__PURE__ */ new Set()), this.handlersMap[e].add(n);
  }
  /**
   * Unsubscribe an event handler from a particular event.
   *
   * @param eventType - Event name to unsubscribe from.
   * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
   *
   */
  _unsubscribe(e, n) {
    this.handlersMap[e] && n && this.handlersMap[e].delete(n), (!n || this.handlersMap[e].size === 0) && delete this.handlersMap[e], Object.keys(this.handlersMap).length === 0 && this.eventTarget.removeEventListener("message", this.boundEventHandler);
  }
}
Fu.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function jp(t = "", e = 10) {
  let n = "";
  for (let r = 0; r < e; r++)
    n += Math.floor(Math.random() * 10);
  return t + n;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Dk {
  constructor(e) {
    this.target = e, this.handlers = /* @__PURE__ */ new Set();
  }
  /**
   * Unsubscribe the handler and remove it from our tracking Set.
   *
   * @param handler - The handler to unsubscribe.
   */
  removeMessageHandler(e) {
    e.messageChannel && (e.messageChannel.port1.removeEventListener("message", e.onMessage), e.messageChannel.port1.close()), this.handlers.delete(e);
  }
  /**
   * Send a message to the Receiver located at {@link target}.
   *
   * @remarks
   * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
   * receiver has had a chance to fully process the event.
   *
   * @param eventType - Type of event to send.
   * @param data - The payload of the event.
   * @param timeout - Timeout for waiting on an ACK from the receiver.
   *
   * @returns An array of settled promises from all the handlers that were listening on the receiver.
   */
  async _send(e, n, r = 50) {
    const i = typeof MessageChannel < "u" ? new MessageChannel() : null;
    if (!i)
      throw new Error(
        "connection_unavailable"
        /* _MessageError.CONNECTION_UNAVAILABLE */
      );
    let o, a;
    return new Promise((s, c) => {
      const l = jp("", 20);
      i.port1.start();
      const u = setTimeout(() => {
        c(new Error(
          "unsupported_event"
          /* _MessageError.UNSUPPORTED_EVENT */
        ));
      }, r);
      a = {
        messageChannel: i,
        onMessage(d) {
          const f = d;
          if (f.data.eventId === l)
            switch (f.data.status) {
              case "ack":
                clearTimeout(u), o = setTimeout(
                  () => {
                    c(new Error(
                      "timeout"
                      /* _MessageError.TIMEOUT */
                    ));
                  },
                  3e3
                  /* _TimeoutDuration.COMPLETION */
                );
                break;
              case "done":
                clearTimeout(o), s(f.data.response);
                break;
              default:
                clearTimeout(u), clearTimeout(o), c(new Error(
                  "invalid_response"
                  /* _MessageError.INVALID_RESPONSE */
                ));
                break;
            }
        }
      }, this.handlers.add(a), i.port1.addEventListener("message", a.onMessage), this.target.postMessage({
        eventType: e,
        eventId: l,
        data: n
      }, [i.port2]);
    }).finally(() => {
      a && this.removeMessageHandler(a);
    });
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ur() {
  return window;
}
function Lk(t) {
  Ur().location.href = t;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Ob() {
  return typeof Ur().WorkerGlobalScope < "u" && typeof Ur().importScripts == "function";
}
async function Fk() {
  if (!(navigator != null && navigator.serviceWorker))
    return null;
  try {
    return (await navigator.serviceWorker.ready).active;
  } catch {
    return null;
  }
}
function Uk() {
  var t;
  return ((t = navigator == null ? void 0 : navigator.serviceWorker) === null || t === void 0 ? void 0 : t.controller) || null;
}
function Hk() {
  return Ob() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const xb = "firebaseLocalStorageDb", Bk = 1, Yl = "firebaseLocalStorage", Rb = "fbase_key";
class vc {
  constructor(e) {
    this.request = e;
  }
  toPromise() {
    return new Promise((e, n) => {
      this.request.addEventListener("success", () => {
        e(this.request.result);
      }), this.request.addEventListener("error", () => {
        n(this.request.error);
      });
    });
  }
}
function Uu(t, e) {
  return t.transaction([Yl], e ? "readwrite" : "readonly").objectStore(Yl);
}
function jk() {
  const t = indexedDB.deleteDatabase(xb);
  return new vc(t).toPromise();
}
function rh() {
  const t = indexedDB.open(xb, Bk);
  return new Promise((e, n) => {
    t.addEventListener("error", () => {
      n(t.error);
    }), t.addEventListener("upgradeneeded", () => {
      const r = t.result;
      try {
        r.createObjectStore(Yl, { keyPath: Rb });
      } catch (i) {
        n(i);
      }
    }), t.addEventListener("success", async () => {
      const r = t.result;
      r.objectStoreNames.contains(Yl) ? e(r) : (r.close(), await jk(), e(await rh()));
    });
  });
}
async function vv(t, e, n) {
  const r = Uu(t, !0).put({
    [Rb]: e,
    value: n
  });
  return new vc(r).toPromise();
}
async function Vk(t, e) {
  const n = Uu(t, !1).get(e), r = await new vc(n).toPromise();
  return r === void 0 ? null : r.value;
}
function yv(t, e) {
  const n = Uu(t, !0).delete(e);
  return new vc(n).toPromise();
}
const $k = 800, qk = 3;
class Nb {
  constructor() {
    this.type = "LOCAL", this._shouldAllowMigration = !0, this.listeners = {}, this.localCache = {}, this.pollTimer = null, this.pendingWrites = 0, this.receiver = null, this.sender = null, this.serviceWorkerReceiverAvailable = !1, this.activeServiceWorker = null, this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(() => {
    }, () => {
    });
  }
  async _openDb() {
    return this.db ? this.db : (this.db = await rh(), this.db);
  }
  async _withRetries(e) {
    let n = 0;
    for (; ; )
      try {
        const r = await this._openDb();
        return await e(r);
      } catch (r) {
        if (n++ > qk)
          throw r;
        this.db && (this.db.close(), this.db = void 0);
      }
  }
  /**
   * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
   * postMessage interface to send these events to the worker ourselves.
   */
  async initializeServiceWorkerMessaging() {
    return Ob() ? this.initializeReceiver() : this.initializeSender();
  }
  /**
   * As the worker we should listen to events from the main window.
   */
  async initializeReceiver() {
    this.receiver = Fu._getInstance(Hk()), this.receiver._subscribe("keyChanged", async (e, n) => ({
      keyProcessed: (await this._poll()).includes(n.key)
    })), this.receiver._subscribe("ping", async (e, n) => [
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ]);
  }
  /**
   * As the main window, we should let the worker know when keys change (set and remove).
   *
   * @remarks
   * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
   * may not resolve.
   */
  async initializeSender() {
    var e, n;
    if (this.activeServiceWorker = await Fk(), !this.activeServiceWorker)
      return;
    this.sender = new Dk(this.activeServiceWorker);
    const r = await this.sender._send(
      "ping",
      {},
      800
      /* _TimeoutDuration.LONG_ACK */
    );
    r && !((e = r[0]) === null || e === void 0) && e.fulfilled && !((n = r[0]) === null || n === void 0) && n.value.includes(
      "keyChanged"
      /* _EventType.KEY_CHANGED */
    ) && (this.serviceWorkerReceiverAvailable = !0);
  }
  /**
   * Let the worker know about a changed key, the exact key doesn't technically matter since the
   * worker will just trigger a full sync anyway.
   *
   * @remarks
   * For now, we only support one service worker per page.
   *
   * @param key - Storage key which changed.
   */
  async notifyServiceWorker(e) {
    if (!(!this.sender || !this.activeServiceWorker || Uk() !== this.activeServiceWorker))
      try {
        await this.sender._send(
          "keyChanged",
          { key: e },
          // Use long timeout if receiver has previously responded to a ping from us.
          this.serviceWorkerReceiverAvailable ? 800 : 50
          /* _TimeoutDuration.ACK */
        );
      } catch {
      }
  }
  async _isAvailable() {
    try {
      if (!indexedDB)
        return !1;
      const e = await rh();
      return await vv(e, Gl, "1"), await yv(e, Gl), !0;
    } catch {
    }
    return !1;
  }
  async _withPendingWrite(e) {
    this.pendingWrites++;
    try {
      await e();
    } finally {
      this.pendingWrites--;
    }
  }
  async _set(e, n) {
    return this._withPendingWrite(async () => (await this._withRetries((r) => vv(r, e, n)), this.localCache[e] = n, this.notifyServiceWorker(e)));
  }
  async _get(e) {
    const n = await this._withRetries((r) => Vk(r, e));
    return this.localCache[e] = n, n;
  }
  async _remove(e) {
    return this._withPendingWrite(async () => (await this._withRetries((n) => yv(n, e)), delete this.localCache[e], this.notifyServiceWorker(e)));
  }
  async _poll() {
    const e = await this._withRetries((i) => {
      const o = Uu(i, !1).getAll();
      return new vc(o).toPromise();
    });
    if (!e)
      return [];
    if (this.pendingWrites !== 0)
      return [];
    const n = [], r = /* @__PURE__ */ new Set();
    for (const { fbase_key: i, value: o } of e)
      r.add(i), JSON.stringify(this.localCache[i]) !== JSON.stringify(o) && (this.notifyListeners(i, o), n.push(i));
    for (const i of Object.keys(this.localCache))
      this.localCache[i] && !r.has(i) && (this.notifyListeners(i, null), n.push(i));
    return n;
  }
  notifyListeners(e, n) {
    this.localCache[e] = n;
    const r = this.listeners[e];
    if (r)
      for (const i of Array.from(r))
        i(n);
  }
  startPolling() {
    this.stopPolling(), this.pollTimer = setInterval(async () => this._poll(), $k);
  }
  stopPolling() {
    this.pollTimer && (clearInterval(this.pollTimer), this.pollTimer = null);
  }
  _addListener(e, n) {
    Object.keys(this.listeners).length === 0 && this.startPolling(), this.listeners[e] || (this.listeners[e] = /* @__PURE__ */ new Set(), this._get(e)), this.listeners[e].add(n);
  }
  _removeListener(e, n) {
    this.listeners[e] && (this.listeners[e].delete(n), this.listeners[e].size === 0 && delete this.listeners[e]), Object.keys(this.listeners).length === 0 && this.stopPolling();
  }
}
Nb.type = "LOCAL";
const zk = Nb;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Kk() {
  var t, e;
  return (e = (t = document.getElementsByTagName("head")) === null || t === void 0 ? void 0 : t[0]) !== null && e !== void 0 ? e : document;
}
function Wk(t) {
  return new Promise((e, n) => {
    const r = document.createElement("script");
    r.setAttribute("src", t), r.onload = e, r.onerror = (i) => {
      const o = Fr(
        "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
      );
      o.customData = i, n(o);
    }, r.type = "text/javascript", r.charset = "UTF-8", Kk().appendChild(r);
  });
}
function Gk(t) {
  return `__${t}${Math.floor(Math.random() * 1e6)}`;
}
new fc(3e4, 6e4);
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Vp(t, e) {
  return e ? ai(e) : (Fe(
    t._popupRedirectResolver,
    t,
    "argument-error"
    /* AuthErrorCode.ARGUMENT_ERROR */
  ), t._popupRedirectResolver);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class $p extends Hp {
  constructor(e) {
    super(
      "custom",
      "custom"
      /* ProviderId.CUSTOM */
    ), this.params = e;
  }
  _getIdTokenResponse(e) {
    return ua(e, this._buildIdpRequest());
  }
  _linkToIdToken(e, n) {
    return ua(e, this._buildIdpRequest(n));
  }
  _getReauthenticationResolver(e) {
    return ua(e, this._buildIdpRequest());
  }
  _buildIdpRequest(e) {
    const n = {
      requestUri: this.params.requestUri,
      sessionId: this.params.sessionId,
      postBody: this.params.postBody,
      tenantId: this.params.tenantId,
      pendingToken: this.params.pendingToken,
      returnSecureToken: !0,
      returnIdpCredential: !0
    };
    return e && (n.idToken = e), n;
  }
}
function Yk(t) {
  return Ib(t.auth, new $p(t), t.bypassAuthState);
}
function Qk(t) {
  const { auth: e, user: n } = t;
  return Fe(
    n,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), Ek(n, new $p(t), t.bypassAuthState);
}
async function Jk(t) {
  const { auth: e, user: n } = t;
  return Fe(
    n,
    e,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), _k(n, new $p(t), t.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Mb {
  constructor(e, n, r, i, o = !1) {
    this.auth = e, this.resolver = r, this.user = i, this.bypassAuthState = o, this.pendingPromise = null, this.eventManager = null, this.filter = Array.isArray(n) ? n : [n];
  }
  execute() {
    return new Promise(async (e, n) => {
      this.pendingPromise = { resolve: e, reject: n };
      try {
        this.eventManager = await this.resolver._initialize(this.auth), await this.onExecution(), this.eventManager.registerConsumer(this);
      } catch (r) {
        this.reject(r);
      }
    });
  }
  async onAuthEvent(e) {
    const { urlResponse: n, sessionId: r, postBody: i, tenantId: o, error: a, type: s } = e;
    if (a) {
      this.reject(a);
      return;
    }
    const c = {
      auth: this.auth,
      requestUri: n,
      sessionId: r,
      tenantId: o || void 0,
      postBody: i || void 0,
      user: this.user,
      bypassAuthState: this.bypassAuthState
    };
    try {
      this.resolve(await this.getIdpTask(s)(c));
    } catch (l) {
      this.reject(l);
    }
  }
  onError(e) {
    this.reject(e);
  }
  getIdpTask(e) {
    switch (e) {
      case "signInViaPopup":
      case "signInViaRedirect":
        return Yk;
      case "linkViaPopup":
      case "linkViaRedirect":
        return Jk;
      case "reauthViaPopup":
      case "reauthViaRedirect":
        return Qk;
      default:
        pr(
          this.auth,
          "internal-error"
          /* AuthErrorCode.INTERNAL_ERROR */
        );
    }
  }
  resolve(e) {
    fi(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.resolve(e), this.unregisterAndCleanUp();
  }
  reject(e) {
    fi(this.pendingPromise, "Pending promise was never set"), this.pendingPromise.reject(e), this.unregisterAndCleanUp();
  }
  unregisterAndCleanUp() {
    this.eventManager && this.eventManager.unregisterConsumer(this), this.pendingPromise = null, this.cleanUp();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Zk = new fc(2e3, 1e4);
async function Xk(t, e, n) {
  const r = Wi(t);
  cb(t, e, Lu);
  const i = Vp(r, n);
  return new lo(r, "signInViaPopup", e, i).executeNotNull();
}
class lo extends Mb {
  constructor(e, n, r, i, o) {
    super(e, n, i, o), this.provider = r, this.authWindow = null, this.pollId = null, lo.currentPopupAction && lo.currentPopupAction.cancel(), lo.currentPopupAction = this;
  }
  async executeNotNull() {
    const e = await this.execute();
    return Fe(
      e,
      this.auth,
      "internal-error"
      /* AuthErrorCode.INTERNAL_ERROR */
    ), e;
  }
  async onExecution() {
    fi(this.filter.length === 1, "Popup operations only handle one event");
    const e = jp();
    this.authWindow = await this.resolver._openPopup(
      this.auth,
      this.provider,
      this.filter[0],
      // There's always one, see constructor
      e
    ), this.authWindow.associatedEvent = e, this.resolver._originValidation(this.auth).catch((n) => {
      this.reject(n);
    }), this.resolver._isIframeWebStorageSupported(this.auth, (n) => {
      n || this.reject(Fr(
        this.auth,
        "web-storage-unsupported"
        /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */
      ));
    }), this.pollUserCancellation();
  }
  get eventId() {
    var e;
    return ((e = this.authWindow) === null || e === void 0 ? void 0 : e.associatedEvent) || null;
  }
  cancel() {
    this.reject(Fr(
      this.auth,
      "cancelled-popup-request"
      /* AuthErrorCode.EXPIRED_POPUP_REQUEST */
    ));
  }
  cleanUp() {
    this.authWindow && this.authWindow.close(), this.pollId && window.clearTimeout(this.pollId), this.authWindow = null, this.pollId = null, lo.currentPopupAction = null;
  }
  pollUserCancellation() {
    const e = () => {
      var n, r;
      if (!((r = (n = this.authWindow) === null || n === void 0 ? void 0 : n.window) === null || r === void 0) && r.closed) {
        this.pollId = window.setTimeout(
          () => {
            this.pollId = null, this.reject(Fr(
              this.auth,
              "popup-closed-by-user"
              /* AuthErrorCode.POPUP_CLOSED_BY_USER */
            ));
          },
          2e3
          /* _Timeout.AUTH_EVENT */
        );
        return;
      }
      this.pollId = window.setTimeout(e, Zk.get());
    };
    e();
  }
}
lo.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const e4 = "pendingRedirect", hl = /* @__PURE__ */ new Map();
class t4 extends Mb {
  constructor(e, n, r = !1) {
    super(e, [
      "signInViaRedirect",
      "linkViaRedirect",
      "reauthViaRedirect",
      "unknown"
      /* AuthEventType.UNKNOWN */
    ], n, void 0, r), this.eventId = null;
  }
  /**
   * Override the execute function; if we already have a redirect result, then
   * just return it.
   */
  async execute() {
    let e = hl.get(this.auth._key());
    if (!e) {
      try {
        const r = await n4(this.resolver, this.auth) ? await super.execute() : null;
        e = () => Promise.resolve(r);
      } catch (n) {
        e = () => Promise.reject(n);
      }
      hl.set(this.auth._key(), e);
    }
    return this.bypassAuthState || hl.set(this.auth._key(), () => Promise.resolve(null)), e();
  }
  async onAuthEvent(e) {
    if (e.type === "signInViaRedirect")
      return super.onAuthEvent(e);
    if (e.type === "unknown") {
      this.resolve(null);
      return;
    }
    if (e.eventId) {
      const n = await this.auth._redirectUserForId(e.eventId);
      if (n)
        return this.user = n, super.onAuthEvent(e);
      this.resolve(null);
    }
  }
  async onExecution() {
  }
  cleanUp() {
  }
}
async function n4(t, e) {
  const n = Db(e), r = Pb(t);
  if (!await r._isAvailable())
    return !1;
  const i = await r._get(n) === "true";
  return await r._remove(n), i;
}
async function r4(t, e) {
  return Pb(t)._set(Db(e), "true");
}
function i4(t, e) {
  hl.set(t._key(), e);
}
function Pb(t) {
  return ai(t._redirectPersistence);
}
function Db(t) {
  return fl(e4, t.config.apiKey, t.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function o4(t, e, n) {
  return a4(t, e, n);
}
async function a4(t, e, n) {
  const r = Wi(t);
  cb(t, e, Lu);
  const i = Vp(r, n);
  return await r4(i, r), i._openRedirect(
    r,
    e,
    "signInViaRedirect"
    /* AuthEventType.SIGN_IN_VIA_REDIRECT */
  );
}
async function wv(t, e) {
  return await Wi(t)._initializationPromise, Lb(t, e, !1);
}
async function Lb(t, e, n = !1) {
  const r = Wi(t), i = Vp(r, e), a = await new t4(r, i, n).execute();
  return a && !n && (delete a.user._redirectEventId, await r._persistUserIfCurrent(a.user), await r._setRedirectUser(null, e)), a;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const s4 = 10 * 60 * 1e3;
class c4 {
  constructor(e) {
    this.auth = e, this.cachedEventUids = /* @__PURE__ */ new Set(), this.consumers = /* @__PURE__ */ new Set(), this.queuedRedirectEvent = null, this.hasHandledPotentialRedirect = !1, this.lastProcessedEventTime = Date.now();
  }
  registerConsumer(e) {
    this.consumers.add(e), this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, e) && (this.sendToConsumer(this.queuedRedirectEvent, e), this.saveEventToCache(this.queuedRedirectEvent), this.queuedRedirectEvent = null);
  }
  unregisterConsumer(e) {
    this.consumers.delete(e);
  }
  onEvent(e) {
    if (this.hasEventBeenHandled(e))
      return !1;
    let n = !1;
    return this.consumers.forEach((r) => {
      this.isEventForConsumer(e, r) && (n = !0, this.sendToConsumer(e, r), this.saveEventToCache(e));
    }), this.hasHandledPotentialRedirect || !l4(e) || (this.hasHandledPotentialRedirect = !0, n || (this.queuedRedirectEvent = e, n = !0)), n;
  }
  sendToConsumer(e, n) {
    var r;
    if (e.error && !Fb(e)) {
      const i = ((r = e.error.code) === null || r === void 0 ? void 0 : r.split("auth/")[1]) || "internal-error";
      n.onError(Fr(this.auth, i));
    } else
      n.onAuthEvent(e);
  }
  isEventForConsumer(e, n) {
    const r = n.eventId === null || !!e.eventId && e.eventId === n.eventId;
    return n.filter.includes(e.type) && r;
  }
  hasEventBeenHandled(e) {
    return Date.now() - this.lastProcessedEventTime >= s4 && this.cachedEventUids.clear(), this.cachedEventUids.has(bv(e));
  }
  saveEventToCache(e) {
    this.cachedEventUids.add(bv(e)), this.lastProcessedEventTime = Date.now();
  }
}
function bv(t) {
  return [t.type, t.eventId, t.sessionId, t.tenantId].filter((e) => e).join("-");
}
function Fb({ type: t, error: e }) {
  return t === "unknown" && (e == null ? void 0 : e.code) === "auth/no-auth-event";
}
function l4(t) {
  switch (t.type) {
    case "signInViaRedirect":
    case "linkViaRedirect":
    case "reauthViaRedirect":
      return !0;
    case "unknown":
      return Fb(t);
    default:
      return !1;
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
async function u4(t, e = {}) {
  return pc(t, "GET", "/v1/projects", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const d4 = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/, f4 = /^https?/;
async function h4(t) {
  if (t.config.emulator)
    return;
  const { authorizedDomains: e } = await u4(t);
  for (const n of e)
    try {
      if (p4(n))
        return;
    } catch {
    }
  pr(
    t,
    "unauthorized-domain"
    /* AuthErrorCode.INVALID_ORIGIN */
  );
}
function p4(t) {
  const e = nh(), { protocol: n, hostname: r } = new URL(e);
  if (t.startsWith("chrome-extension://")) {
    const a = new URL(t);
    return a.hostname === "" && r === "" ? n === "chrome-extension:" && t.replace("chrome-extension://", "") === e.replace("chrome-extension://", "") : n === "chrome-extension:" && a.hostname === r;
  }
  if (!f4.test(n))
    return !1;
  if (d4.test(t))
    return r === t;
  const i = t.replace(/\./g, "\\.");
  return new RegExp("^(.+\\." + i + "|" + i + ")$", "i").test(r);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const g4 = new fc(3e4, 6e4);
function _v() {
  const t = Ur().___jsl;
  if (t != null && t.H) {
    for (const e of Object.keys(t.H))
      if (t.H[e].r = t.H[e].r || [], t.H[e].L = t.H[e].L || [], t.H[e].r = [...t.H[e].L], t.CP)
        for (let n = 0; n < t.CP.length; n++)
          t.CP[n] = null;
  }
}
function m4(t) {
  return new Promise((e, n) => {
    var r, i, o;
    function a() {
      _v(), gapi.load("gapi.iframes", {
        callback: () => {
          e(gapi.iframes.getContext());
        },
        ontimeout: () => {
          _v(), n(Fr(
            t,
            "network-request-failed"
            /* AuthErrorCode.NETWORK_REQUEST_FAILED */
          ));
        },
        timeout: g4.get()
      });
    }
    if (!((i = (r = Ur().gapi) === null || r === void 0 ? void 0 : r.iframes) === null || i === void 0) && i.Iframe)
      e(gapi.iframes.getContext());
    else if (!((o = Ur().gapi) === null || o === void 0) && o.load)
      a();
    else {
      const s = Gk("iframefcb");
      return Ur()[s] = () => {
        gapi.load ? a() : n(Fr(
          t,
          "network-request-failed"
          /* AuthErrorCode.NETWORK_REQUEST_FAILED */
        ));
      }, Wk(`https://apis.google.com/js/api.js?onload=${s}`).catch((c) => n(c));
    }
  }).catch((e) => {
    throw pl = null, e;
  });
}
let pl = null;
function v4(t) {
  return pl = pl || m4(t), pl;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const y4 = new fc(5e3, 15e3), w4 = "__/auth/iframe", b4 = "emulator/auth/iframe", _4 = {
  style: {
    position: "absolute",
    top: "-100px",
    width: "1px",
    height: "1px"
  },
  "aria-hidden": "true",
  tabindex: "-1"
}, E4 = /* @__PURE__ */ new Map([
  ["identitytoolkit.googleapis.com", "p"],
  ["staging-identitytoolkit.sandbox.googleapis.com", "s"],
  ["test-identitytoolkit.sandbox.googleapis.com", "t"]
  // test
]);
function C4(t) {
  const e = t.config;
  Fe(
    e.authDomain,
    t,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  );
  const n = e.emulator ? Lp(e, b4) : `https://${t.config.authDomain}/${w4}`, r = {
    apiKey: e.apiKey,
    appName: t.name,
    v: Pu
  }, i = E4.get(t.config.apiHost);
  i && (r.eid = i);
  const o = t._getFrameworks();
  return o.length && (r.fw = o.join(",")), `${n}?${dc(r).slice(1)}`;
}
async function I4(t) {
  const e = await v4(t), n = Ur().gapi;
  return Fe(
    n,
    t,
    "internal-error"
    /* AuthErrorCode.INTERNAL_ERROR */
  ), e.open({
    where: document.body,
    url: C4(t),
    messageHandlersFilter: n.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
    attributes: _4,
    dontclear: !0
  }, (r) => new Promise(async (i, o) => {
    await r.restyle({
      // Prevent iframe from closing on mouse out.
      setHideOnLeave: !1
    });
    const a = Fr(
      t,
      "network-request-failed"
      /* AuthErrorCode.NETWORK_REQUEST_FAILED */
    ), s = Ur().setTimeout(() => {
      o(a);
    }, y4.get());
    function c() {
      Ur().clearTimeout(s), i(r);
    }
    r.ping(c).then(c, () => {
      o(a);
    });
  }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const S4 = {
  location: "yes",
  resizable: "yes",
  statusbar: "yes",
  toolbar: "no"
}, T4 = 500, k4 = 600, A4 = "_blank", O4 = "http://localhost";
class Ev {
  constructor(e) {
    this.window = e, this.associatedEvent = null;
  }
  close() {
    if (this.window)
      try {
        this.window.close();
      } catch {
      }
  }
}
function x4(t, e, n, r = T4, i = k4) {
  const o = Math.max((window.screen.availHeight - i) / 2, 0).toString(), a = Math.max((window.screen.availWidth - r) / 2, 0).toString();
  let s = "";
  const c = Object.assign(Object.assign({}, S4), {
    width: r.toString(),
    height: i.toString(),
    top: o,
    left: a
  }), l = Pn().toLowerCase();
  n && (s = gb(l) ? A4 : n), pb(l) && (e = e || O4, c.scrollbars = "yes");
  const u = Object.entries(c).reduce((f, [h, g]) => `${f}${h}=${g},`, "");
  if (ok(l) && s !== "_self")
    return R4(e || "", s), new Ev(null);
  const d = window.open(e || "", s, u);
  Fe(
    d,
    t,
    "popup-blocked"
    /* AuthErrorCode.POPUP_BLOCKED */
  );
  try {
    d.focus();
  } catch {
  }
  return new Ev(d);
}
function R4(t, e) {
  const n = document.createElement("a");
  n.href = t, n.target = e;
  const r = document.createEvent("MouseEvent");
  r.initMouseEvent("click", !0, !0, window, 1, 0, 0, 0, 0, !1, !1, !1, !1, 1, null), n.dispatchEvent(r);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const N4 = "__/auth/handler", M4 = "emulator/auth/handler";
function Cv(t, e, n, r, i, o) {
  Fe(
    t.config.authDomain,
    t,
    "auth-domain-config-required"
    /* AuthErrorCode.MISSING_AUTH_DOMAIN */
  ), Fe(
    t.config.apiKey,
    t,
    "invalid-api-key"
    /* AuthErrorCode.INVALID_API_KEY */
  );
  const a = {
    apiKey: t.config.apiKey,
    appName: t.name,
    authType: n,
    redirectUrl: r,
    v: Pu,
    eventId: i
  };
  if (e instanceof Lu) {
    e.setDefaultLanguage(t.languageCode), a.providerId = e.providerId || "", AS(e.getCustomParameters()) || (a.customParameters = JSON.stringify(e.getCustomParameters()));
    for (const [c, l] of Object.entries(o || {}))
      a[c] = l;
  }
  if (e instanceof mc) {
    const c = e.getScopes().filter((l) => l !== "");
    c.length > 0 && (a.scopes = c.join(","));
  }
  t.tenantId && (a.tid = t.tenantId);
  const s = a;
  for (const c of Object.keys(s))
    s[c] === void 0 && delete s[c];
  return `${P4(t)}?${dc(s).slice(1)}`;
}
function P4({ config: t }) {
  return t.emulator ? Lp(t, M4) : `https://${t.authDomain}/${N4}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Dd = "webStorageSupport";
class D4 {
  constructor() {
    this.eventManagers = {}, this.iframes = {}, this.originValidationPromises = {}, this._redirectPersistence = Ab, this._completeRedirectFn = Lb, this._overrideRedirectResult = i4;
  }
  // Wrapping in async even though we don't await anywhere in order
  // to make sure errors are raised as promise rejections
  async _openPopup(e, n, r, i) {
    var o;
    fi((o = this.eventManagers[e._key()]) === null || o === void 0 ? void 0 : o.manager, "_initialize() not called before _openPopup()");
    const a = Cv(e, n, r, nh(), i);
    return x4(e, a, jp());
  }
  async _openRedirect(e, n, r, i) {
    return await this._originValidation(e), Lk(Cv(e, n, r, nh(), i)), new Promise(() => {
    });
  }
  _initialize(e) {
    const n = e._key();
    if (this.eventManagers[n]) {
      const { manager: i, promise: o } = this.eventManagers[n];
      return i ? Promise.resolve(i) : (fi(o, "If manager is not set, promise should be"), o);
    }
    const r = this.initAndGetManager(e);
    return this.eventManagers[n] = { promise: r }, r.catch(() => {
      delete this.eventManagers[n];
    }), r;
  }
  async initAndGetManager(e) {
    const n = await I4(e), r = new c4(e);
    return n.register("authEvent", (i) => (Fe(
      i == null ? void 0 : i.authEvent,
      e,
      "invalid-auth-event"
      /* AuthErrorCode.INVALID_AUTH_EVENT */
    ), {
      status: r.onEvent(i.authEvent) ? "ACK" : "ERROR"
      /* GapiOutcome.ERROR */
    }), gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER), this.eventManagers[e._key()] = { manager: r }, this.iframes[e._key()] = n, r;
  }
  _isIframeWebStorageSupported(e, n) {
    this.iframes[e._key()].send(Dd, { type: Dd }, (i) => {
      var o;
      const a = (o = i == null ? void 0 : i[0]) === null || o === void 0 ? void 0 : o[Dd];
      a !== void 0 && n(!!a), pr(
        e,
        "internal-error"
        /* AuthErrorCode.INTERNAL_ERROR */
      );
    }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
  }
  _originValidation(e) {
    const n = e._key();
    return this.originValidationPromises[n] || (this.originValidationPromises[n] = h4(e)), this.originValidationPromises[n];
  }
  get _shouldInitProactively() {
    return bb() || Up() || Du();
  }
}
const L4 = D4;
var Iv = "@firebase/auth", Sv = "0.21.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class F4 {
  constructor(e) {
    this.auth = e, this.internalListeners = /* @__PURE__ */ new Map();
  }
  getUid() {
    var e;
    return this.assertAuthConfigured(), ((e = this.auth.currentUser) === null || e === void 0 ? void 0 : e.uid) || null;
  }
  async getToken(e) {
    return this.assertAuthConfigured(), await this.auth._initializationPromise, this.auth.currentUser ? { accessToken: await this.auth.currentUser.getIdToken(e) } : null;
  }
  addAuthTokenListener(e) {
    if (this.assertAuthConfigured(), this.internalListeners.has(e))
      return;
    const n = this.auth.onIdTokenChanged((r) => {
      e((r == null ? void 0 : r.stsTokenManager.accessToken) || null);
    });
    this.internalListeners.set(e, n), this.updateProactiveRefresh();
  }
  removeAuthTokenListener(e) {
    this.assertAuthConfigured();
    const n = this.internalListeners.get(e);
    n && (this.internalListeners.delete(e), n(), this.updateProactiveRefresh());
  }
  assertAuthConfigured() {
    Fe(
      this.auth._initializationPromise,
      "dependent-sdk-initialized-before-auth"
      /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */
    );
  }
  updateProactiveRefresh() {
    this.internalListeners.size > 0 ? this.auth._startProactiveRefresh() : this.auth._stopProactiveRefresh();
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function U4(t) {
  switch (t) {
    case "Node":
      return "node";
    case "ReactNative":
      return "rn";
    case "Worker":
      return "webworker";
    case "Cordova":
      return "cordova";
    default:
      return;
  }
}
function H4(t) {
  $s(new ba(
    "auth",
    (e, { options: n }) => {
      const r = e.getProvider("app").getImmediate(), i = e.getProvider("heartbeat"), { apiKey: o, authDomain: a } = r.options;
      return ((s, c) => {
        Fe(o && !o.includes(":"), "invalid-api-key", { appName: s.name }), Fe(!(a != null && a.includes(":")), "argument-error", {
          appName: s.name
        });
        const l = {
          apiKey: o,
          authDomain: a,
          clientPlatform: t,
          apiHost: "identitytoolkit.googleapis.com",
          tokenApiHost: "securetoken.googleapis.com",
          apiScheme: "https",
          sdkClientVersion: _b(t)
        }, u = new lk(s, c, l);
        return VT(u, n), u;
      })(r, i);
    },
    "PUBLIC"
    /* ComponentType.PUBLIC */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  ).setInstanceCreatedCallback((e, n, r) => {
    e.getProvider(
      "auth-internal"
      /* _ComponentName.AUTH_INTERNAL */
    ).initialize();
  })), $s(new ba(
    "auth-internal",
    (e) => {
      const n = Wi(e.getProvider(
        "auth"
        /* _ComponentName.AUTH */
      ).getImmediate());
      return ((r) => new F4(r))(n);
    },
    "PRIVATE"
    /* ComponentType.PRIVATE */
  ).setInstantiationMode(
    "EXPLICIT"
    /* InstantiationMode.EXPLICIT */
  )), ca(Iv, Sv, U4(t)), ca(Iv, Sv, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const B4 = 5 * 60, j4 = Jw("authIdTokenMaxAge") || B4;
let Tv = null;
const V4 = (t) => async (e) => {
  const n = e && await e.getIdTokenResult(), r = n && ((/* @__PURE__ */ new Date()).getTime() - Date.parse(n.issuedAtTime)) / 1e3;
  if (r && r > j4)
    return;
  const i = n == null ? void 0 : n.token;
  Tv !== i && (Tv = i, await fetch(t, {
    method: i ? "POST" : "DELETE",
    headers: i ? {
      Authorization: `Bearer ${i}`
    } : {}
  }));
};
function $4(t = AT()) {
  const e = tb(t, "auth");
  if (e.isInitialized())
    return e.getImmediate();
  const n = jT(t, {
    popupRedirectResolver: L4,
    persistence: [
      zk,
      Mk,
      Ab
    ]
  }), r = Jw("authTokenSyncURL");
  if (r) {
    const o = V4(r);
    kk(n, o, () => o(n.currentUser)), Tk(n, (a) => o(a));
  }
  const i = ES("auth");
  return i && uk(n, `http://${i}`), n;
}
H4(
  "Browser"
  /* ClientPlatform.BROWSER */
);
const EW = (t) => {
  const e = {
    apiKey: t.clientId,
    authDomain: t.authDomain
  }, n = nb(e), r = $4(n);
  t.tenantId && (r.tenantId = t.tenantId);
  const i = new Po(), o = new Op(), a = async (p) => {
    const w = (p == null ? void 0 : p.uid) ?? null, _ = await (p == null ? void 0 : p.getIdToken()) ?? null, E = (p == null ? void 0 : p.refreshToken) ?? null, S = (p == null ? void 0 : p.email) ?? null;
    return {
      userId: w,
      token: _,
      refreshToken: E,
      username: S
    };
  }, s = async () => {
    const p = await Xk(r, i);
    return a(p.user);
  }, c = async () => {
    await o4(r, i);
  }, l = async () => {
  }, u = async ({ email: p, password: w }) => {
    const _ = await Sk(r, p, w);
    return a(_.user);
  }, d = async ({ email: p, password: w }) => {
    const _ = await Ik(
      r,
      p,
      w
    );
    return a(_.user);
  }, f = async () => {
    const p = await wv(r), w = (p == null ? void 0 : p.user) ?? null;
    return await a(w);
  }, h = async () => {
    await Ok(r);
  }, g = async () => {
    var p;
    await ((p = r.currentUser) == null ? void 0 : p.getIdToken());
  }, v = Ak(r, async (p) => {
    const w = await a(p);
    o.emit("authStateChange", w);
  });
  return {
    loginWithPopup: s,
    loginWithRedirect: c,
    changePasswordWithRedirect: l,
    handleRedirectResult: f,
    logOut: h,
    restoreSession: async () => {
      const p = await wv(r), w = (p == null ? void 0 : p.user) ?? null;
      return await a(w);
    },
    refreshJWT: g,
    onAuthStateChange: (p) => {
      o.on("authStateChange", p);
      const w = () => o.off("authStateChange", p);
      return () => {
        w();
      };
    },
    unsubscribeAll: () => {
      v(), o.removeAllListeners("authStateChange");
    },
    loginWithEmailAndPassword: u,
    signUpWithEmailAndPassword: d
  };
}, CW = ({ children: t }) => {
  const { loggedIn: e } = Ru();
  return e ? /* @__PURE__ */ C(cc, { children: t }) : null;
}, IW = ({
  children: t
}) => {
  const { loggedIn: e } = Ru();
  return e ? null : /* @__PURE__ */ C(cc, { children: t });
};
var Ld = "Invariant Violation", kv = Object.setPrototypeOf, q4 = kv === void 0 ? function(t, e) {
  return t.__proto__ = e, t;
} : kv, Mt = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n) {
      n === void 0 && (n = Ld);
      var r = t.call(this, typeof n == "number" ? Ld + ": " + n + " (see https://github.com/apollographql/invariant-packages)" : n) || this;
      return r.framesToPop = 1, r.name = Ld, q4(r, e.prototype), r;
    }
    return e;
  }(Error)
);
function le(t, e) {
  if (!t)
    throw new Mt(e);
}
var Ub = ["debug", "log", "warn", "error", "silent"], z4 = Ub.indexOf("log");
function qc(t) {
  return function() {
    if (Ub.indexOf(t) >= z4) {
      var e = console[t] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(t) {
  t.debug = qc("debug"), t.log = qc("log"), t.warn = qc("warn"), t.error = qc("error");
})(le || (le = {}));
function ni(t) {
  try {
    return t();
  } catch {
  }
}
const Av = ni(function() {
  return globalThis;
}) || ni(function() {
  return window;
}) || ni(function() {
  return self;
}) || ni(function() {
  return global;
}) || ni(function() {
  return ni.constructor("return this")();
});
var Ov = "__", xv = [Ov, Ov].join("DEV");
function K4() {
  try {
    return !!__DEV__;
  } catch {
    return Object.defineProperty(Av, xv, {
      value: ni(function() {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), Av[xv];
  }
}
const Fd = K4();
function xi(t) {
  try {
    return t();
  } catch {
  }
}
var ih = xi(function() {
  return globalThis;
}) || xi(function() {
  return window;
}) || xi(function() {
  return self;
}) || xi(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
xi(function() {
  return xi.constructor("return this")();
}), oh = !1;
function W4() {
  ih && !xi(function() {
    return process.env.NODE_ENV;
  }) && !xi(function() {
    return process;
  }) && (Object.defineProperty(ih, "process", {
    value: {
      env: {
        // This default needs to be "production" instead of "development", to
        // avoid the problem https://github.com/graphql/graphql-js/pull/2894
        // will eventually solve, once merged and released.
        NODE_ENV: "production"
      }
    },
    // Let anyone else change global.process as they see fit, but hide it from
    // Object.keys(global) enumeration.
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), oh = !0);
}
W4();
function Rv() {
  oh && (delete ih.process, oh = !1);
}
function gl(t, e) {
  if (!!!t)
    throw new Error(e);
}
function G4(t) {
  return typeof t == "object" && t !== null;
}
function Y4(t, e) {
  if (!!!t)
    throw new Error(
      e ?? "Unexpected invariant triggered."
    );
}
const Q4 = /\r\n|[\n\r]/g;
function ah(t, e) {
  let n = 0, r = 1;
  for (const i of t.body.matchAll(Q4)) {
    if (typeof i.index == "number" || Y4(!1), i.index >= e)
      break;
    n = i.index + i[0].length, r += 1;
  }
  return {
    line: r,
    column: e + 1 - n
  };
}
function J4(t) {
  return Hb(
    t.source,
    ah(t.source, t.start)
  );
}
function Hb(t, e) {
  const n = t.locationOffset.column - 1, r = "".padStart(n) + t.body, i = e.line - 1, o = t.locationOffset.line - 1, a = e.line + o, s = e.line === 1 ? n : 0, c = e.column + s, l = `${t.name}:${a}:${c}
`, u = r.split(/\r\n|[\n\r]/g), d = u[i];
  if (d.length > 120) {
    const f = Math.floor(c / 80), h = c % 80, g = [];
    for (let v = 0; v < d.length; v += 80)
      g.push(d.slice(v, v + 80));
    return l + Nv([
      [`${a} |`, g[0]],
      ...g.slice(1, f + 1).map((v) => ["|", v]),
      ["|", "^".padStart(h)],
      ["|", g[f + 1]]
    ]);
  }
  return l + Nv([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, u[i - 1]],
    [`${a} |`, d],
    ["|", "^".padStart(c)],
    [`${a + 1} |`, u[i + 1]]
  ]);
}
function Nv(t) {
  const e = t.filter(([r, i]) => i !== void 0), n = Math.max(...e.map(([r]) => r.length));
  return e.map(([r, i]) => r.padStart(n) + (i ? " " + i : "")).join(`
`);
}
function Z4(t) {
  const e = t[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: t[1],
    positions: t[2],
    path: t[3],
    originalError: t[4],
    extensions: t[5]
  } : e;
}
let X4 = class Bb extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorArgs` constructor overload instead.
   */
  constructor(e, ...n) {
    var r, i, o;
    const { nodes: a, source: s, positions: c, path: l, originalError: u, extensions: d } = Z4(n);
    super(e), this.name = "GraphQLError", this.path = l ?? void 0, this.originalError = u ?? void 0, this.nodes = Mv(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const f = Mv(
      (r = this.nodes) === null || r === void 0 ? void 0 : r.map((g) => g.loc).filter((g) => g != null)
    );
    this.source = s ?? (f == null || (i = f[0]) === null || i === void 0 ? void 0 : i.source), this.positions = c ?? (f == null ? void 0 : f.map((g) => g.start)), this.locations = c && s ? c.map((g) => ah(s, g)) : f == null ? void 0 : f.map((g) => ah(g.source, g.start));
    const h = G4(
      u == null ? void 0 : u.extensions
    ) ? u == null ? void 0 : u.extensions : void 0;
    this.extensions = (o = d ?? h) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), u != null && u.stack ? Object.defineProperty(this, "stack", {
      value: u.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Bb) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const n of this.nodes)
        n.loc && (e += `

` + J4(n.loc));
    else if (this.source && this.locations)
      for (const n of this.locations)
        e += `

` + Hb(this.source, n);
    return e;
  }
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
};
function Mv(t) {
  return t === void 0 || t.length === 0 ? void 0 : t;
}
function Sn(t, e, n) {
  return new X4(`Syntax Error: ${n}`, {
    source: t,
    positions: [e]
  });
}
class e6 {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(e, n, r) {
    this.start = e.start, this.end = n.end, this.startToken = e, this.endToken = n, this.source = r;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class jb {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(e, n, r, i, o, a) {
    this.kind = e, this.start = n, this.end = r, this.line = i, this.column = o, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const Vb = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, t6 = new Set(Object.keys(Vb));
function Pv(t) {
  const e = t == null ? void 0 : t.kind;
  return typeof e == "string" && t6.has(e);
}
let na;
(function(t) {
  t.QUERY = "query", t.MUTATION = "mutation", t.SUBSCRIPTION = "subscription";
})(na || (na = {}));
let sh;
(function(t) {
  t.QUERY = "QUERY", t.MUTATION = "MUTATION", t.SUBSCRIPTION = "SUBSCRIPTION", t.FIELD = "FIELD", t.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", t.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", t.INLINE_FRAGMENT = "INLINE_FRAGMENT", t.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", t.SCHEMA = "SCHEMA", t.SCALAR = "SCALAR", t.OBJECT = "OBJECT", t.FIELD_DEFINITION = "FIELD_DEFINITION", t.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", t.INTERFACE = "INTERFACE", t.UNION = "UNION", t.ENUM = "ENUM", t.ENUM_VALUE = "ENUM_VALUE", t.INPUT_OBJECT = "INPUT_OBJECT", t.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(sh || (sh = {}));
let ye;
(function(t) {
  t.NAME = "Name", t.DOCUMENT = "Document", t.OPERATION_DEFINITION = "OperationDefinition", t.VARIABLE_DEFINITION = "VariableDefinition", t.SELECTION_SET = "SelectionSet", t.FIELD = "Field", t.ARGUMENT = "Argument", t.FRAGMENT_SPREAD = "FragmentSpread", t.INLINE_FRAGMENT = "InlineFragment", t.FRAGMENT_DEFINITION = "FragmentDefinition", t.VARIABLE = "Variable", t.INT = "IntValue", t.FLOAT = "FloatValue", t.STRING = "StringValue", t.BOOLEAN = "BooleanValue", t.NULL = "NullValue", t.ENUM = "EnumValue", t.LIST = "ListValue", t.OBJECT = "ObjectValue", t.OBJECT_FIELD = "ObjectField", t.DIRECTIVE = "Directive", t.NAMED_TYPE = "NamedType", t.LIST_TYPE = "ListType", t.NON_NULL_TYPE = "NonNullType", t.SCHEMA_DEFINITION = "SchemaDefinition", t.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", t.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", t.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", t.FIELD_DEFINITION = "FieldDefinition", t.INPUT_VALUE_DEFINITION = "InputValueDefinition", t.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", t.UNION_TYPE_DEFINITION = "UnionTypeDefinition", t.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", t.ENUM_VALUE_DEFINITION = "EnumValueDefinition", t.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", t.DIRECTIVE_DEFINITION = "DirectiveDefinition", t.SCHEMA_EXTENSION = "SchemaExtension", t.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", t.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", t.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", t.UNION_TYPE_EXTENSION = "UnionTypeExtension", t.ENUM_TYPE_EXTENSION = "EnumTypeExtension", t.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(ye || (ye = {}));
function ch(t) {
  return t === 9 || t === 32;
}
function Gs(t) {
  return t >= 48 && t <= 57;
}
function $b(t) {
  return t >= 97 && t <= 122 || // A-Z
  t >= 65 && t <= 90;
}
function qb(t) {
  return $b(t) || t === 95;
}
function n6(t) {
  return $b(t) || Gs(t) || t === 95;
}
function r6(t) {
  var e;
  let n = Number.MAX_SAFE_INTEGER, r = null, i = -1;
  for (let a = 0; a < t.length; ++a) {
    var o;
    const s = t[a], c = i6(s);
    c !== s.length && (r = (o = r) !== null && o !== void 0 ? o : a, i = a, a !== 0 && c < n && (n = c));
  }
  return t.map((a, s) => s === 0 ? a : a.slice(n)).slice(
    (e = r) !== null && e !== void 0 ? e : 0,
    i + 1
  );
}
function i6(t) {
  let e = 0;
  for (; e < t.length && ch(t.charCodeAt(e)); )
    ++e;
  return e;
}
function o6(t, e) {
  const n = t.replace(/"""/g, '\\"""'), r = n.split(/\r\n|[\n\r]/g), i = r.length === 1, o = r.length > 1 && r.slice(1).every((h) => h.length === 0 || ch(h.charCodeAt(0))), a = n.endsWith('\\"""'), s = t.endsWith('"') && !a, c = t.endsWith("\\"), l = s || c, u = !(e != null && e.minimize) && // add leading and trailing new lines only if it improves readability
  (!i || t.length > 70 || l || o || a);
  let d = "";
  const f = i && ch(t.charCodeAt(0));
  return (u && !f || o) && (d += `
`), d += n, (u || l) && (d += `
`), '"""' + d + '"""';
}
let W;
(function(t) {
  t.SOF = "<SOF>", t.EOF = "<EOF>", t.BANG = "!", t.DOLLAR = "$", t.AMP = "&", t.PAREN_L = "(", t.PAREN_R = ")", t.SPREAD = "...", t.COLON = ":", t.EQUALS = "=", t.AT = "@", t.BRACKET_L = "[", t.BRACKET_R = "]", t.BRACE_L = "{", t.PIPE = "|", t.BRACE_R = "}", t.NAME = "Name", t.INT = "Int", t.FLOAT = "Float", t.STRING = "String", t.BLOCK_STRING = "BlockString", t.COMMENT = "Comment";
})(W || (W = {}));
class a6 {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(e) {
    const n = new jb(W.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = n, this.token = n, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== W.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const n = c6(this, e.end);
          e.next = n, n.prev = e, e = n;
        }
      while (e.kind === W.COMMENT);
    return e;
  }
}
function s6(t) {
  return t === W.BANG || t === W.DOLLAR || t === W.AMP || t === W.PAREN_L || t === W.PAREN_R || t === W.SPREAD || t === W.COLON || t === W.EQUALS || t === W.AT || t === W.BRACKET_L || t === W.BRACKET_R || t === W.BRACE_L || t === W.PIPE || t === W.BRACE_R;
}
function ja(t) {
  return t >= 0 && t <= 55295 || t >= 57344 && t <= 1114111;
}
function Hu(t, e) {
  return zb(t.charCodeAt(e)) && Kb(t.charCodeAt(e + 1));
}
function zb(t) {
  return t >= 55296 && t <= 56319;
}
function Kb(t) {
  return t >= 56320 && t <= 57343;
}
function Io(t, e) {
  const n = t.source.body.codePointAt(e);
  if (n === void 0)
    return W.EOF;
  if (n >= 32 && n <= 126) {
    const r = String.fromCodePoint(n);
    return r === '"' ? `'"'` : `"${r}"`;
  }
  return "U+" + n.toString(16).toUpperCase().padStart(4, "0");
}
function dn(t, e, n, r, i) {
  const o = t.line, a = 1 + n - t.lineStart;
  return new jb(e, n, r, o, a, i);
}
function c6(t, e) {
  const n = t.source.body, r = n.length;
  let i = e;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++t.line, t.lineStart = i;
        continue;
      case 13:
        n.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++t.line, t.lineStart = i;
        continue;
      case 35:
        return l6(t, i);
      case 33:
        return dn(t, W.BANG, i, i + 1);
      case 36:
        return dn(t, W.DOLLAR, i, i + 1);
      case 38:
        return dn(t, W.AMP, i, i + 1);
      case 40:
        return dn(t, W.PAREN_L, i, i + 1);
      case 41:
        return dn(t, W.PAREN_R, i, i + 1);
      case 46:
        if (n.charCodeAt(i + 1) === 46 && n.charCodeAt(i + 2) === 46)
          return dn(t, W.SPREAD, i, i + 3);
        break;
      case 58:
        return dn(t, W.COLON, i, i + 1);
      case 61:
        return dn(t, W.EQUALS, i, i + 1);
      case 64:
        return dn(t, W.AT, i, i + 1);
      case 91:
        return dn(t, W.BRACKET_L, i, i + 1);
      case 93:
        return dn(t, W.BRACKET_R, i, i + 1);
      case 123:
        return dn(t, W.BRACE_L, i, i + 1);
      case 124:
        return dn(t, W.PIPE, i, i + 1);
      case 125:
        return dn(t, W.BRACE_R, i, i + 1);
      case 34:
        return n.charCodeAt(i + 1) === 34 && n.charCodeAt(i + 2) === 34 ? g6(t, i) : d6(t, i);
    }
    if (Gs(o) || o === 45)
      return u6(t, i, o);
    if (qb(o))
      return m6(t, i);
    throw Sn(
      t.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : ja(o) || Hu(n, i) ? `Unexpected character: ${Io(t, i)}.` : `Invalid character: ${Io(t, i)}.`
    );
  }
  return dn(t, W.EOF, r, r);
}
function l6(t, e) {
  const n = t.source.body, r = n.length;
  let i = e + 1;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (ja(o))
      ++i;
    else if (Hu(n, i))
      i += 2;
    else
      break;
  }
  return dn(
    t,
    W.COMMENT,
    e,
    i,
    n.slice(e + 1, i)
  );
}
function u6(t, e, n) {
  const r = t.source.body;
  let i = e, o = n, a = !1;
  if (o === 45 && (o = r.charCodeAt(++i)), o === 48) {
    if (o = r.charCodeAt(++i), Gs(o))
      throw Sn(
        t.source,
        i,
        `Invalid number, unexpected digit after 0: ${Io(
          t,
          i
        )}.`
      );
  } else
    i = Ud(t, i, o), o = r.charCodeAt(i);
  if (o === 46 && (a = !0, o = r.charCodeAt(++i), i = Ud(t, i, o), o = r.charCodeAt(i)), (o === 69 || o === 101) && (a = !0, o = r.charCodeAt(++i), (o === 43 || o === 45) && (o = r.charCodeAt(++i)), i = Ud(t, i, o), o = r.charCodeAt(i)), o === 46 || qb(o))
    throw Sn(
      t.source,
      i,
      `Invalid number, expected digit but got: ${Io(
        t,
        i
      )}.`
    );
  return dn(
    t,
    a ? W.FLOAT : W.INT,
    e,
    i,
    r.slice(e, i)
  );
}
function Ud(t, e, n) {
  if (!Gs(n))
    throw Sn(
      t.source,
      e,
      `Invalid number, expected digit but got: ${Io(
        t,
        e
      )}.`
    );
  const r = t.source.body;
  let i = e + 1;
  for (; Gs(r.charCodeAt(i)); )
    ++i;
  return i;
}
function d6(t, e) {
  const n = t.source.body, r = n.length;
  let i = e + 1, o = i, a = "";
  for (; i < r; ) {
    const s = n.charCodeAt(i);
    if (s === 34)
      return a += n.slice(o, i), dn(t, W.STRING, e, i + 1, a);
    if (s === 92) {
      a += n.slice(o, i);
      const c = n.charCodeAt(i + 1) === 117 ? n.charCodeAt(i + 2) === 123 ? f6(t, i) : h6(t, i) : p6(t, i);
      a += c.value, i += c.size, o = i;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (ja(s))
      ++i;
    else if (Hu(n, i))
      i += 2;
    else
      throw Sn(
        t.source,
        i,
        `Invalid character within String: ${Io(
          t,
          i
        )}.`
      );
  }
  throw Sn(t.source, i, "Unterminated string.");
}
function f6(t, e) {
  const n = t.source.body;
  let r = 0, i = 3;
  for (; i < 12; ) {
    const o = n.charCodeAt(e + i++);
    if (o === 125) {
      if (i < 5 || !ja(r))
        break;
      return {
        value: String.fromCodePoint(r),
        size: i
      };
    }
    if (r = r << 4 | bs(o), r < 0)
      break;
  }
  throw Sn(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${n.slice(
      e,
      e + i
    )}".`
  );
}
function h6(t, e) {
  const n = t.source.body, r = Dv(n, e + 2);
  if (ja(r))
    return {
      value: String.fromCodePoint(r),
      size: 6
    };
  if (zb(r) && n.charCodeAt(e + 6) === 92 && n.charCodeAt(e + 7) === 117) {
    const i = Dv(n, e + 8);
    if (Kb(i))
      return {
        value: String.fromCodePoint(r, i),
        size: 12
      };
  }
  throw Sn(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${n.slice(e, e + 6)}".`
  );
}
function Dv(t, e) {
  return bs(t.charCodeAt(e)) << 12 | bs(t.charCodeAt(e + 1)) << 8 | bs(t.charCodeAt(e + 2)) << 4 | bs(t.charCodeAt(e + 3));
}
function bs(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 65 && t <= 70 ? t - 55 : t >= 97 && t <= 102 ? t - 87 : -1;
}
function p6(t, e) {
  const n = t.source.body;
  switch (n.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw Sn(
    t.source,
    e,
    `Invalid character escape sequence: "${n.slice(
      e,
      e + 2
    )}".`
  );
}
function g6(t, e) {
  const n = t.source.body, r = n.length;
  let i = t.lineStart, o = e + 3, a = o, s = "";
  const c = [];
  for (; o < r; ) {
    const l = n.charCodeAt(o);
    if (l === 34 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34) {
      s += n.slice(a, o), c.push(s);
      const u = dn(
        t,
        W.BLOCK_STRING,
        e,
        o + 3,
        // Return a string of the lines joined with U+000A.
        r6(c).join(`
`)
      );
      return t.line += c.length - 1, t.lineStart = i, u;
    }
    if (l === 92 && n.charCodeAt(o + 1) === 34 && n.charCodeAt(o + 2) === 34 && n.charCodeAt(o + 3) === 34) {
      s += n.slice(a, o), a = o + 1, o += 4;
      continue;
    }
    if (l === 10 || l === 13) {
      s += n.slice(a, o), c.push(s), l === 13 && n.charCodeAt(o + 1) === 10 ? o += 2 : ++o, s = "", a = o, i = o;
      continue;
    }
    if (ja(l))
      ++o;
    else if (Hu(n, o))
      o += 2;
    else
      throw Sn(
        t.source,
        o,
        `Invalid character within String: ${Io(
          t,
          o
        )}.`
      );
  }
  throw Sn(t.source, o, "Unterminated string.");
}
function m6(t, e) {
  const n = t.source.body, r = n.length;
  let i = e + 1;
  for (; i < r; ) {
    const o = n.charCodeAt(i);
    if (n6(o))
      ++i;
    else
      break;
  }
  return dn(
    t,
    W.NAME,
    e,
    i,
    n.slice(e, i)
  );
}
const v6 = 10, Wb = 2;
function qp(t) {
  return Bu(t, []);
}
function Bu(t, e) {
  switch (typeof t) {
    case "string":
      return JSON.stringify(t);
    case "function":
      return t.name ? `[function ${t.name}]` : "[function]";
    case "object":
      return y6(t, e);
    default:
      return String(t);
  }
}
function y6(t, e) {
  if (t === null)
    return "null";
  if (e.includes(t))
    return "[Circular]";
  const n = [...e, t];
  if (w6(t)) {
    const r = t.toJSON();
    if (r !== t)
      return typeof r == "string" ? r : Bu(r, n);
  } else if (Array.isArray(t))
    return _6(t, n);
  return b6(t, n);
}
function w6(t) {
  return typeof t.toJSON == "function";
}
function b6(t, e) {
  const n = Object.entries(t);
  return n.length === 0 ? "{}" : e.length > Wb ? "[" + E6(t) + "]" : "{ " + n.map(
    ([i, o]) => i + ": " + Bu(o, e)
  ).join(", ") + " }";
}
function _6(t, e) {
  if (t.length === 0)
    return "[]";
  if (e.length > Wb)
    return "[Array]";
  const n = Math.min(v6, t.length), r = t.length - n, i = [];
  for (let o = 0; o < n; ++o)
    i.push(Bu(t[o], e));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push(`... ${r} more items`), "[" + i.join(", ") + "]";
}
function E6(t) {
  const e = Object.prototype.toString.call(t).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof t.constructor == "function") {
    const n = t.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return e;
}
const C6 = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  // eslint-disable-next-line no-undef
  process.env.NODE_ENV === "production" ? function(e, n) {
    return e instanceof n;
  } : function(e, n) {
    if (e instanceof n)
      return !0;
    if (typeof e == "object" && e !== null) {
      var r;
      const i = n.prototype[Symbol.toStringTag], o = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (r = e.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (i === o) {
        const a = qp(e);
        throw new Error(`Cannot use ${i} "${a}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class zp {
  constructor(e, n = "GraphQL request", r = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || gl(!1, `Body must be a string. Received: ${qp(e)}.`), this.body = e, this.name = n, this.locationOffset = r, this.locationOffset.line > 0 || gl(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || gl(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function I6(t) {
  return C6(t, zp);
}
function S6(t, e) {
  return new T6(t, e).parseDocument();
}
class T6 {
  constructor(e, n) {
    const r = I6(e) ? e : new zp(e);
    this._lexer = new a6(r), this._options = n;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const e = this.expectToken(W.NAME);
    return this.node(e, {
      kind: ye.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: ye.DOCUMENT,
      definitions: this.many(
        W.SOF,
        this.parseDefinition,
        W.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(W.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), n = e ? this._lexer.lookahead() : this._lexer.token;
    if (n.kind === W.NAME) {
      switch (n.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (e)
        throw Sn(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (n.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(n);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(W.BRACE_L))
      return this.node(e, {
        kind: ye.OPERATION_DEFINITION,
        operation: na.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const n = this.parseOperationType();
    let r;
    return this.peek(W.NAME) && (r = this.parseName()), this.node(e, {
      kind: ye.OPERATION_DEFINITION,
      operation: n,
      name: r,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const e = this.expectToken(W.NAME);
    switch (e.value) {
      case "query":
        return na.QUERY;
      case "mutation":
        return na.MUTATION;
      case "subscription":
        return na.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      W.PAREN_L,
      this.parseVariableDefinition,
      W.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: ye.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(W.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(W.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(W.DOLLAR), this.node(e, {
      kind: ye.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: ye.SELECTION_SET,
      selections: this.many(
        W.BRACE_L,
        this.parseSelection,
        W.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(W.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const e = this._lexer.token, n = this.parseName();
    let r, i;
    return this.expectOptionalToken(W.COLON) ? (r = n, i = this.parseName()) : i = n, this.node(e, {
      kind: ye.FIELD,
      alias: r,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(W.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(e) {
    const n = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(W.PAREN_L, n, W.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(e = !1) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(W.COLON), this.node(n, {
      kind: ye.ARGUMENT,
      name: r,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(W.SPREAD);
    const n = this.expectOptionalKeyword("on");
    return !n && this.peek(W.NAME) ? this.node(e, {
      kind: ye.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: ye.INLINE_FRAGMENT,
      typeCondition: n ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    var e;
    const n = this._lexer.token;
    return this.expectKeyword("fragment"), ((e = this._options) === null || e === void 0 ? void 0 : e.allowLegacyFragmentVariables) === !0 ? this.node(n, {
      kind: ye.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(n, {
      kind: ye.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(e) {
    const n = this._lexer.token;
    switch (n.kind) {
      case W.BRACKET_L:
        return this.parseList(e);
      case W.BRACE_L:
        return this.parseObject(e);
      case W.INT:
        return this._lexer.advance(), this.node(n, {
          kind: ye.INT,
          value: n.value
        });
      case W.FLOAT:
        return this._lexer.advance(), this.node(n, {
          kind: ye.FLOAT,
          value: n.value
        });
      case W.STRING:
      case W.BLOCK_STRING:
        return this.parseStringLiteral();
      case W.NAME:
        switch (this._lexer.advance(), n.value) {
          case "true":
            return this.node(n, {
              kind: ye.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(n, {
              kind: ye.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(n, {
              kind: ye.NULL
            });
          default:
            return this.node(n, {
              kind: ye.ENUM,
              value: n.value
            });
        }
      case W.DOLLAR:
        if (e)
          if (this.expectToken(W.DOLLAR), this._lexer.token.kind === W.NAME) {
            const r = this._lexer.token.value;
            throw Sn(
              this._lexer.source,
              n.start,
              `Unexpected variable "$${r}" in constant value.`
            );
          } else
            throw this.unexpected(n);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this._lexer.advance(), this.node(e, {
      kind: ye.STRING,
      value: e.value,
      block: e.kind === W.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(e) {
    const n = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: ye.LIST,
      values: this.any(W.BRACKET_L, n, W.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(e) {
    const n = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: ye.OBJECT,
      fields: this.any(W.BRACE_L, n, W.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(e) {
    const n = this._lexer.token, r = this.parseName();
    return this.expectToken(W.COLON), this.node(n, {
      kind: ye.OBJECT_FIELD,
      name: r,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(e) {
    const n = [];
    for (; this.peek(W.AT); )
      n.push(this.parseDirective(e));
    return n;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(e) {
    const n = this._lexer.token;
    return this.expectToken(W.AT), this.node(n, {
      kind: ye.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let n;
    if (this.expectOptionalToken(W.BRACKET_L)) {
      const r = this.parseTypeReference();
      this.expectToken(W.BRACKET_R), n = this.node(e, {
        kind: ye.LIST_TYPE,
        type: r
      });
    } else
      n = this.parseNamedType();
    return this.expectOptionalToken(W.BANG) ? this.node(e, {
      kind: ye.NON_NULL_TYPE,
      type: n
    }) : n;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: ye.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(W.STRING) || this.peek(W.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("schema");
    const r = this.parseConstDirectives(), i = this.many(
      W.BRACE_L,
      this.parseOperationTypeDefinition,
      W.BRACE_R
    );
    return this.node(e, {
      kind: ye.SCHEMA_DEFINITION,
      description: n,
      directives: r,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, n = this.parseOperationType();
    this.expectToken(W.COLON);
    const r = this.parseNamedType();
    return this.node(e, {
      kind: ye.OPERATION_TYPE_DEFINITION,
      operation: n,
      type: r
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("scalar");
    const r = this.parseName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: ye.SCALAR_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("type");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(e, {
      kind: ye.OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(W.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      W.BRACE_L,
      this.parseFieldDefinition,
      W.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const e = this._lexer.token, n = this.parseDescription(), r = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(W.COLON);
    const o = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(e, {
      kind: ye.FIELD_DEFINITION,
      description: n,
      name: r,
      arguments: i,
      type: o,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      W.PAREN_L,
      this.parseInputValueDef,
      W.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const e = this._lexer.token, n = this.parseDescription(), r = this.parseName();
    this.expectToken(W.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(W.EQUALS) && (o = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(e, {
      kind: ye.INPUT_VALUE_DEFINITION,
      description: n,
      name: r,
      type: i,
      defaultValue: o,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("interface");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(e, {
      kind: ye.INTERFACE_TYPE_DEFINITION,
      description: n,
      name: r,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("union");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: ye.UNION_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(W.EQUALS) ? this.delimitedMany(W.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("enum");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: ye.ENUM_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      W.BRACE_L,
      this.parseEnumValueDefinition,
      W.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, n = this.parseDescription(), r = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(e, {
      kind: ye.ENUM_VALUE_DEFINITION,
      description: n,
      name: r,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw Sn(
        this._lexer.source,
        this._lexer.token.start,
        `${zc(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("input");
    const r = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: ye.INPUT_OBJECT_TYPE_DEFINITION,
      description: n,
      name: r,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      W.BRACE_L,
      this.parseInputValueDef,
      W.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === W.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const n = this.parseConstDirectives(), r = this.optionalMany(
      W.BRACE_L,
      this.parseOperationTypeDefinition,
      W.BRACE_R
    );
    if (n.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: ye.SCHEMA_EXTENSION,
      directives: n,
      operationTypes: r
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const n = this.parseName(), r = this.parseConstDirectives();
    if (r.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: ye.SCALAR_TYPE_EXTENSION,
      name: n,
      directives: r
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (r.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: ye.OBJECT_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const n = this.parseName(), r = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (r.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: ye.INTERFACE_TYPE_EXTENSION,
      name: n,
      interfaces: r,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: ye.UNION_TYPE_EXTENSION,
      name: n,
      directives: r,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: ye.ENUM_TYPE_EXTENSION,
      name: n,
      directives: r,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const n = this.parseName(), r = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: ye.INPUT_OBJECT_TYPE_EXTENSION,
      name: n,
      directives: r,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, n = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(W.AT);
    const r = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(e, {
      kind: ye.DIRECTIVE_DEFINITION,
      description: n,
      name: r,
      arguments: i,
      repeatable: o,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(W.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, n = this.parseName();
    if (Object.prototype.hasOwnProperty.call(sh, n.value))
      return n;
    throw this.unexpected(e);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(e, n) {
    var r;
    return ((r = this._options) === null || r === void 0 ? void 0 : r.noLocation) !== !0 && (n.loc = new e6(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), n;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(e) {
    const n = this._lexer.token;
    if (n.kind === e)
      return this._lexer.advance(), n;
    throw Sn(
      this._lexer.source,
      n.start,
      `Expected ${Gb(e)}, found ${zc(n)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this._lexer.advance(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(e) {
    const n = this._lexer.token;
    if (n.kind === W.NAME && n.value === e)
      this._lexer.advance();
    else
      throw Sn(
        this._lexer.source,
        n.start,
        `Expected "${e}", found ${zc(n)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(e) {
    const n = this._lexer.token;
    return n.kind === W.NAME && n.value === e ? (this._lexer.advance(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(e) {
    const n = e ?? this._lexer.token;
    return Sn(
      this._lexer.source,
      n.start,
      `Unexpected ${zc(n)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(e, n, r) {
    this.expectToken(e);
    const i = [];
    for (; !this.expectOptionalToken(r); )
      i.push(n.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(e, n, r) {
    if (this.expectOptionalToken(e)) {
      const i = [];
      do
        i.push(n.call(this));
      while (!this.expectOptionalToken(r));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(e, n, r) {
    this.expectToken(e);
    const i = [];
    do
      i.push(n.call(this));
    while (!this.expectOptionalToken(r));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(e, n) {
    this.expectOptionalToken(e);
    const r = [];
    do
      r.push(n.call(this));
    while (this.expectOptionalToken(e));
    return r;
  }
}
function zc(t) {
  const e = t.value;
  return Gb(t.kind) + (e != null ? ` "${e}"` : "");
}
function Gb(t) {
  return s6(t) ? `"${t}"` : t;
}
function k6(t, e, n) {
  const r = /* @__PURE__ */ Object.create(null);
  for (const i of t)
    r[e(i)] = n(i);
  return r;
}
function A6(t) {
  return `"${t.replace(O6, x6)}"`;
}
const O6 = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function x6(t) {
  return R6[t.charCodeAt(0)];
}
const R6 = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Yb = Object.freeze({});
function qr(t, e, n = Vb) {
  const r = /* @__PURE__ */ new Map();
  for (const m of Object.values(ye))
    r.set(m, N6(e, m));
  let i, o = Array.isArray(t), a = [t], s = -1, c = [], l = t, u, d;
  const f = [], h = [];
  do {
    s++;
    const m = s === a.length, y = m && c.length !== 0;
    if (m) {
      if (u = h.length === 0 ? void 0 : f[f.length - 1], l = d, d = h.pop(), y)
        if (o) {
          l = l.slice();
          let w = 0;
          for (const [_, E] of c) {
            const S = _ - w;
            E === null ? (l.splice(S, 1), w++) : l[S] = E;
          }
        } else {
          l = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(l)
          );
          for (const [w, _] of c)
            l[w] = _;
        }
      s = i.index, a = i.keys, c = i.edits, o = i.inArray, i = i.prev;
    } else if (d) {
      if (u = o ? s : a[s], l = d[u], l == null)
        continue;
      f.push(u);
    }
    let p;
    if (!Array.isArray(l)) {
      var g, v;
      Pv(l) || gl(!1, `Invalid AST Node: ${qp(l)}.`);
      const w = m ? (g = r.get(l.kind)) === null || g === void 0 ? void 0 : g.leave : (v = r.get(l.kind)) === null || v === void 0 ? void 0 : v.enter;
      if (p = w == null ? void 0 : w.call(e, l, u, d, f, h), p === Yb)
        break;
      if (p === !1) {
        if (!m) {
          f.pop();
          continue;
        }
      } else if (p !== void 0 && (c.push([u, p]), !m))
        if (Pv(p))
          l = p;
        else {
          f.pop();
          continue;
        }
    }
    if (p === void 0 && y && c.push([u, l]), m)
      f.pop();
    else {
      var b;
      i = {
        inArray: o,
        index: s,
        keys: a,
        edits: c,
        prev: i
      }, o = Array.isArray(l), a = o ? l : (b = n[l.kind]) !== null && b !== void 0 ? b : [], s = -1, c = [], d && h.push(d), d = l;
    }
  } while (i !== void 0);
  return c.length !== 0 ? c[c.length - 1][1] : t;
}
function N6(t, e) {
  const n = t[e];
  return typeof n == "object" ? n : typeof n == "function" ? {
    enter: n,
    leave: void 0
  } : {
    enter: t.enter,
    leave: t.leave
  };
}
function M6(t) {
  return qr(t, D6);
}
const P6 = 80, D6 = {
  Name: {
    leave: (t) => t.value
  },
  Variable: {
    leave: (t) => "$" + t.name
  },
  // Document
  Document: {
    leave: (t) => _e(t.definitions, `

`)
  },
  OperationDefinition: {
    leave(t) {
      const e = lt("(", _e(t.variableDefinitions, ", "), ")"), n = _e(
        [
          t.operation,
          _e([t.name, e]),
          _e(t.directives, " ")
        ],
        " "
      );
      return (n === "query" ? "" : n + " ") + t.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: t, type: e, defaultValue: n, directives: r }) => t + ": " + e + lt(" = ", n) + lt(" ", _e(r, " "))
  },
  SelectionSet: {
    leave: ({ selections: t }) => br(t)
  },
  Field: {
    leave({ alias: t, name: e, arguments: n, directives: r, selectionSet: i }) {
      const o = lt("", t, ": ") + e;
      let a = o + lt("(", _e(n, ", "), ")");
      return a.length > P6 && (a = o + lt(`(
`, ml(_e(n, `
`)), `
)`)), _e([a, _e(r, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: t, value: e }) => t + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: t, directives: e }) => "..." + t + lt(" ", _e(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: t, directives: e, selectionSet: n }) => _e(
      [
        "...",
        lt("on ", t),
        _e(e, " "),
        n
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: t, typeCondition: e, variableDefinitions: n, directives: r, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${t}${lt("(", _e(n, ", "), ")")} on ${e} ${lt("", _e(r, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: t }) => t
  },
  FloatValue: {
    leave: ({ value: t }) => t
  },
  StringValue: {
    leave: ({ value: t, block: e }) => e ? o6(t) : A6(t)
  },
  BooleanValue: {
    leave: ({ value: t }) => t ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: t }) => t
  },
  ListValue: {
    leave: ({ values: t }) => "[" + _e(t, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: t }) => "{" + _e(t, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: t, value: e }) => t + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: t, arguments: e }) => "@" + t + lt("(", _e(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: t }) => t
  },
  ListType: {
    leave: ({ type: t }) => "[" + t + "]"
  },
  NonNullType: {
    leave: ({ type: t }) => t + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: t, directives: e, operationTypes: n }) => lt("", t, `
`) + _e(["schema", _e(e, " "), br(n)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: t, type: e }) => t + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: t, name: e, directives: n }) => lt("", t, `
`) + _e(["scalar", e, _e(n, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: t, name: e, interfaces: n, directives: r, fields: i }) => lt("", t, `
`) + _e(
      [
        "type",
        e,
        lt("implements ", _e(n, " & ")),
        _e(r, " "),
        br(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: t, name: e, arguments: n, type: r, directives: i }) => lt("", t, `
`) + e + (Lv(n) ? lt(`(
`, ml(_e(n, `
`)), `
)`) : lt("(", _e(n, ", "), ")")) + ": " + r + lt(" ", _e(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: t, name: e, type: n, defaultValue: r, directives: i }) => lt("", t, `
`) + _e(
      [e + ": " + n, lt("= ", r), _e(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: t, name: e, interfaces: n, directives: r, fields: i }) => lt("", t, `
`) + _e(
      [
        "interface",
        e,
        lt("implements ", _e(n, " & ")),
        _e(r, " "),
        br(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, types: r }) => lt("", t, `
`) + _e(
      ["union", e, _e(n, " "), lt("= ", _e(r, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, values: r }) => lt("", t, `
`) + _e(["enum", e, _e(n, " "), br(r)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: t, name: e, directives: n }) => lt("", t, `
`) + _e([e, _e(n, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: t, name: e, directives: n, fields: r }) => lt("", t, `
`) + _e(["input", e, _e(n, " "), br(r)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: t, name: e, arguments: n, repeatable: r, locations: i }) => lt("", t, `
`) + "directive @" + e + (Lv(n) ? lt(`(
`, ml(_e(n, `
`)), `
)`) : lt("(", _e(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + _e(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: t, operationTypes: e }) => _e(
      ["extend schema", _e(t, " "), br(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: t, directives: e }) => _e(["extend scalar", t, _e(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: t, interfaces: e, directives: n, fields: r }) => _e(
      [
        "extend type",
        t,
        lt("implements ", _e(e, " & ")),
        _e(n, " "),
        br(r)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: t, interfaces: e, directives: n, fields: r }) => _e(
      [
        "extend interface",
        t,
        lt("implements ", _e(e, " & ")),
        _e(n, " "),
        br(r)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: t, directives: e, types: n }) => _e(
      [
        "extend union",
        t,
        _e(e, " "),
        lt("= ", _e(n, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: t, directives: e, values: n }) => _e(["extend enum", t, _e(e, " "), br(n)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: t, directives: e, fields: n }) => _e(["extend input", t, _e(e, " "), br(n)], " ")
  }
};
function _e(t, e = "") {
  var n;
  return (n = t == null ? void 0 : t.filter((r) => r).join(e)) !== null && n !== void 0 ? n : "";
}
function br(t) {
  return lt(`{
`, ml(_e(t, `
`)), `
}`);
}
function lt(t, e, n = "") {
  return e != null && e !== "" ? t + e + n : "";
}
function ml(t) {
  return lt("  ", t.replace(/\n/g, `
  `));
}
function Lv(t) {
  var e;
  return (e = t == null ? void 0 : t.some((n) => n.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
function _a(t, e) {
  switch (t.kind) {
    case ye.NULL:
      return null;
    case ye.INT:
      return parseInt(t.value, 10);
    case ye.FLOAT:
      return parseFloat(t.value);
    case ye.STRING:
    case ye.ENUM:
    case ye.BOOLEAN:
      return t.value;
    case ye.LIST:
      return t.values.map(
        (n) => _a(n, e)
      );
    case ye.OBJECT:
      return k6(
        t.fields,
        (n) => n.name.value,
        (n) => _a(n.value, e)
      );
    case ye.VARIABLE:
      return e == null ? void 0 : e[t.name.value];
  }
}
function L6() {
  return Rv();
}
function F6() {
  __DEV__ ? le(typeof Fd == "boolean", Fd) : le(typeof Fd == "boolean", 36);
}
L6();
F6();
function ju(t, e) {
  var n = t.directives;
  return !n || !n.length ? !0 : j6(n).every(function(r) {
    var i = r.directive, o = r.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = e && e[o.value.name.value], __DEV__ ? le(a !== void 0, "Invalid variable referenced in @".concat(i.name.value, " directive.")) : le(a !== void 0, 37)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function U6(t) {
  var e = [];
  return qr(t, {
    Directive: function(n) {
      e.push(n.name.value);
    }
  }), e;
}
function lh(t, e) {
  return U6(e).some(function(n) {
    return t.indexOf(n) > -1;
  });
}
function H6(t) {
  return t && lh(["client"], t) && lh(["export"], t);
}
function B6(t) {
  var e = t.name.value;
  return e === "skip" || e === "include";
}
function j6(t) {
  var e = [];
  return t && t.length && t.forEach(function(n) {
    if (B6(n)) {
      var r = n.arguments, i = n.name.value;
      __DEV__ ? le(r && r.length === 1, "Incorrect number of arguments for the @".concat(i, " directive.")) : le(r && r.length === 1, 38);
      var o = r[0];
      __DEV__ ? le(o.name && o.name.value === "if", "Invalid argument for the @".concat(i, " directive.")) : le(o.name && o.name.value === "if", 39);
      var a = o.value;
      __DEV__ ? le(a && (a.kind === "Variable" || a.kind === "BooleanValue"), "Argument for the @".concat(i, " directive must be a variable or a boolean value.")) : le(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 40), e.push({ directive: n, ifArgument: o });
    }
  }), e;
}
function V6(t, e) {
  var n = e, r = [];
  t.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw __DEV__ ? new Mt("Found a ".concat(o.operation, " operation").concat(o.name ? " named '".concat(o.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new Mt(41);
    o.kind === "FragmentDefinition" && r.push(o);
  }), typeof n > "u" && (__DEV__ ? le(r.length === 1, "Found ".concat(r.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : le(r.length === 1, 42), n = r[0].name.value);
  var i = R(R({}, t), { definitions: ln([
    {
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: n
            }
          }
        ]
      }
    }
  ], t.definitions, !0) });
  return i;
}
function Vu(t) {
  t === void 0 && (t = []);
  var e = {};
  return t.forEach(function(n) {
    e[n.name.value] = n;
  }), e;
}
function Kp(t, e) {
  switch (t.kind) {
    case "InlineFragment":
      return t;
    case "FragmentSpread": {
      var n = e && e[t.name.value];
      return __DEV__ ? le(n, "No fragment named ".concat(t.name.value, ".")) : le(n, 43), n;
    }
    default:
      return null;
  }
}
function on(t) {
  return t !== null && typeof t == "object";
}
function da(t) {
  return { __ref: String(t) };
}
function It(t) {
  return !!(t && typeof t == "object" && typeof t.__ref == "string");
}
function $6(t) {
  return on(t) && t.kind === "Document" && Array.isArray(t.definitions);
}
function q6(t) {
  return t.kind === "StringValue";
}
function z6(t) {
  return t.kind === "BooleanValue";
}
function K6(t) {
  return t.kind === "IntValue";
}
function W6(t) {
  return t.kind === "FloatValue";
}
function G6(t) {
  return t.kind === "Variable";
}
function Y6(t) {
  return t.kind === "ObjectValue";
}
function Q6(t) {
  return t.kind === "ListValue";
}
function J6(t) {
  return t.kind === "EnumValue";
}
function Z6(t) {
  return t.kind === "NullValue";
}
function Ea(t, e, n, r) {
  if (K6(n) || W6(n))
    t[e.value] = Number(n.value);
  else if (z6(n) || q6(n))
    t[e.value] = n.value;
  else if (Y6(n)) {
    var i = {};
    n.fields.map(function(a) {
      return Ea(i, a.name, a.value, r);
    }), t[e.value] = i;
  } else if (G6(n)) {
    var o = (r || {})[n.name.value];
    t[e.value] = o;
  } else if (Q6(n))
    t[e.value] = n.values.map(function(a) {
      var s = {};
      return Ea(s, e, a, r), s[e.value];
    });
  else if (J6(n))
    t[e.value] = n.value;
  else if (Z6(n))
    t[e.value] = null;
  else
    throw __DEV__ ? new Mt('The inline argument "'.concat(e.value, '" of kind "').concat(n.kind, '"') + "is not supported. Use variables instead of inline arguments to overcome this limitation.") : new Mt(52);
}
function X6(t, e) {
  var n = null;
  t.directives && (n = {}, t.directives.forEach(function(i) {
    n[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return Ea(n[i.name.value], a, s, e);
    });
  }));
  var r = null;
  return t.arguments && t.arguments.length && (r = {}, t.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return Ea(r, o, a, e);
  })), Wp(t.name.value, r, n);
}
var e5 = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export"
], Wp = Object.assign(function(t, e, n) {
  if (e && n && n.connection && n.connection.key)
    if (n.connection.filter && n.connection.filter.length > 0) {
      var r = n.connection.filter ? n.connection.filter : [];
      r.sort();
      var i = {};
      return r.forEach(function(s) {
        i[s] = e[s];
      }), "".concat(n.connection.key, "(").concat(as(i), ")");
    } else
      return n.connection.key;
  var o = t;
  if (e) {
    var a = as(e);
    o += "(".concat(a, ")");
  }
  return n && Object.keys(n).forEach(function(s) {
    e5.indexOf(s) === -1 && (n[s] && Object.keys(n[s]).length ? o += "@".concat(s, "(").concat(as(n[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(t) {
    var e = as;
    return as = t, e;
  }
}), as = function(e) {
  return JSON.stringify(e, t5);
};
function t5(t, e) {
  return on(e) && !Array.isArray(e) && (e = Object.keys(e).sort().reduce(function(n, r) {
    return n[r] = e[r], n;
  }, {})), e;
}
function $u(t, e) {
  if (t.arguments && t.arguments.length) {
    var n = {};
    return t.arguments.forEach(function(r) {
      var i = r.name, o = r.value;
      return Ea(n, i, o, e);
    }), n;
  }
  return null;
}
function So(t) {
  return t.alias ? t.alias.value : t.name.value;
}
function uh(t, e, n) {
  if (typeof t.__typename == "string")
    return t.__typename;
  for (var r = 0, i = e.selections; r < i.length; r++) {
    var o = i[r];
    if (hi(o)) {
      if (o.name.value === "__typename")
        return t[So(o)];
    } else {
      var a = uh(t, Kp(o, n).selectionSet, n);
      if (typeof a == "string")
        return a;
    }
  }
}
function hi(t) {
  return t.kind === "Field";
}
function Qb(t) {
  return t.kind === "InlineFragment";
}
function yc(t) {
  __DEV__ ? le(t && t.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : le(t && t.kind === "Document", 44);
  var e = t.definitions.filter(function(n) {
    return n.kind !== "FragmentDefinition";
  }).map(function(n) {
    if (n.kind !== "OperationDefinition")
      throw __DEV__ ? new Mt('Schema type definitions not allowed in queries. Found: "'.concat(n.kind, '"')) : new Mt(45);
    return n;
  });
  return __DEV__ ? le(e.length <= 1, "Ambiguous GraphQL document: contains ".concat(e.length, " operations")) : le(e.length <= 1, 46), t;
}
function wc(t) {
  return yc(t), t.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function dh(t) {
  return t.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function qu(t) {
  return t.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function Jb(t) {
  var e = wc(t);
  return __DEV__ ? le(e && e.operation === "query", "Must contain a query definition.") : le(e && e.operation === "query", 47), e;
}
function n5(t) {
  __DEV__ ? le(t.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : le(t.kind === "Document", 48), __DEV__ ? le(t.definitions.length <= 1, "Fragment must have exactly one definition.") : le(t.definitions.length <= 1, 49);
  var e = t.definitions[0];
  return __DEV__ ? le(e.kind === "FragmentDefinition", "Must be a fragment definition.") : le(e.kind === "FragmentDefinition", 50), e;
}
function Gp(t) {
  yc(t);
  for (var e, n = 0, r = t.definitions; n < r.length; n++) {
    var i = r[n];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !e && (e = i);
  }
  if (e)
    return e;
  throw __DEV__ ? new Mt("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new Mt(51);
}
function Yp(t) {
  var e = /* @__PURE__ */ Object.create(null), n = t && t.variableDefinitions;
  return n && n.length && n.forEach(function(r) {
    r.defaultValue && Ea(e, r.variable.name, r.defaultValue);
  }), e;
}
function Fv(t, e, n) {
  var r = 0;
  return t.forEach(function(i, o) {
    e.call(this, i, o, t) && (t[r++] = i);
  }, n), t.length = r, t;
}
var Uv = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
};
function Zb(t, e) {
  return t.selectionSet.selections.every(function(n) {
    return n.kind === "FragmentSpread" && Zb(e[n.name.value], e);
  });
}
function Qp(t) {
  return Zb(wc(t) || n5(t), Vu(qu(t))) ? null : t;
}
function Hv(t) {
  return function(n) {
    return t.some(function(r) {
      return r.name && r.name === n.name.value || r.test && r.test(n);
    });
  };
}
function Xb(t, e) {
  var n = /* @__PURE__ */ Object.create(null), r = [], i = /* @__PURE__ */ Object.create(null), o = [], a = Qp(qr(e, {
    Variable: {
      enter: function(s, c, l) {
        l.kind !== "VariableDefinition" && (n[s.name.value] = !0);
      }
    },
    Field: {
      enter: function(s) {
        if (t && s.directives) {
          var c = t.some(function(l) {
            return l.remove;
          });
          if (c && s.directives && s.directives.some(Hv(t)))
            return s.arguments && s.arguments.forEach(function(l) {
              l.value.kind === "Variable" && r.push({
                name: l.value.name.value
              });
            }), s.selectionSet && e2(s.selectionSet).forEach(function(l) {
              o.push({
                name: l.name.value
              });
            }), null;
        }
      }
    },
    FragmentSpread: {
      enter: function(s) {
        i[s.name.value] = !0;
      }
    },
    Directive: {
      enter: function(s) {
        if (Hv(t)(s))
          return null;
      }
    }
  }));
  return a && Fv(r, function(s) {
    return !!s.name && !n[s.name];
  }).length && (a = a5(r, a)), a && Fv(o, function(s) {
    return !!s.name && !i[s.name];
  }).length && (a = s5(o, a)), a;
}
var Jp = Object.assign(function(t) {
  return qr(yc(t), {
    SelectionSet: {
      enter: function(e, n, r) {
        if (!(r && r.kind === "OperationDefinition")) {
          var i = e.selections;
          if (i) {
            var o = i.some(function(s) {
              return hi(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = r;
              if (!(hi(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return R(R({}, e), { selections: ln(ln([], i, !0), [Uv], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(t) {
    return t === Uv;
  }
}), r5 = {
  test: function(t) {
    var e = t.name.value === "connection";
    return e && (!t.arguments || !t.arguments.some(function(n) {
      return n.name.value === "key";
    })) && __DEV__ && le.warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key."), e;
  }
};
function i5(t) {
  return Xb([r5], yc(t));
}
function o5(t) {
  return function(n) {
    return t.some(function(r) {
      return n.value && n.value.kind === "Variable" && n.value.name && (r.name === n.value.name.value || r.test && r.test(n));
    });
  };
}
function a5(t, e) {
  var n = o5(t);
  return Qp(qr(e, {
    OperationDefinition: {
      enter: function(r) {
        return R(R({}, r), { variableDefinitions: r.variableDefinitions ? r.variableDefinitions.filter(function(i) {
          return !t.some(function(o) {
            return o.name === i.variable.name.value;
          });
        }) : [] });
      }
    },
    Field: {
      enter: function(r) {
        var i = t.some(function(a) {
          return a.remove;
        });
        if (i) {
          var o = 0;
          if (r.arguments && r.arguments.forEach(function(a) {
            n(a) && (o += 1);
          }), o === 1)
            return null;
        }
      }
    },
    Argument: {
      enter: function(r) {
        if (n(r))
          return null;
      }
    }
  }));
}
function s5(t, e) {
  function n(r) {
    if (t.some(function(i) {
      return i.name === r.name.value;
    }))
      return null;
  }
  return Qp(qr(e, {
    FragmentSpread: { enter: n },
    FragmentDefinition: { enter: n }
  }));
}
function e2(t) {
  var e = [];
  return t.selections.forEach(function(n) {
    (hi(n) || Qb(n)) && n.selectionSet ? e2(n.selectionSet).forEach(function(r) {
      return e.push(r);
    }) : n.kind === "FragmentSpread" && e.push(n);
  }), e;
}
function c5(t) {
  var e = Gp(t), n = e.operation;
  if (n === "query")
    return t;
  var r = qr(t, {
    OperationDefinition: {
      enter: function(i) {
        return R(R({}, i), { operation: "query" });
      }
    }
  });
  return r;
}
function l5(t) {
  yc(t);
  var e = Xb([
    {
      test: function(n) {
        return n.name.value === "client";
      },
      remove: !0
    }
  ], t);
  return e && (e = qr(e, {
    FragmentDefinition: {
      enter: function(n) {
        if (n.selectionSet) {
          var r = n.selectionSet.selections.every(function(i) {
            return hi(i) && i.name.value === "__typename";
          });
          if (r)
            return null;
        }
      }
    }
  })), e;
}
var u5 = Object.prototype.hasOwnProperty;
function Bv() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return t2(t);
}
function t2(t) {
  var e = t[0] || {}, n = t.length;
  if (n > 1)
    for (var r = new bc(), i = 1; i < n; ++i)
      e = r.merge(e, t[i]);
  return e;
}
var d5 = function(t, e, n) {
  return this.merge(t[n], e[n]);
}, bc = function() {
  function t(e) {
    e === void 0 && (e = d5), this.reconciler = e, this.isObject = on, this.pastCopies = /* @__PURE__ */ new Set();
  }
  return t.prototype.merge = function(e, n) {
    for (var r = this, i = [], o = 2; o < arguments.length; o++)
      i[o - 2] = arguments[o];
    return on(n) && on(e) ? (Object.keys(n).forEach(function(a) {
      if (u5.call(e, a)) {
        var s = e[a];
        if (n[a] !== s) {
          var c = r.reconciler.apply(r, ln([e, n, a], i, !1));
          c !== s && (e = r.shallowCopyForMerge(e), e[a] = c);
        }
      } else
        e = r.shallowCopyForMerge(e), e[a] = n[a];
    }), e) : n;
  }, t.prototype.shallowCopyForMerge = function(e) {
    if (on(e)) {
      if (this.pastCopies.has(e)) {
        if (!Object.isFrozen(e))
          return e;
        this.pastCopies.delete(e);
      }
      Array.isArray(e) ? e = e.slice(0) : e = R({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e);
    }
    return e;
  }, t;
}();
function f5(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n)
    return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = h5(t)) || e && t && typeof t.length == "number") {
    n && (t = n);
    var r = 0;
    return function() {
      return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h5(t, e) {
  if (t) {
    if (typeof t == "string")
      return jv(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return jv(t, e);
  }
}
function jv(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function Vv(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Zp(t, e, n) {
  return e && Vv(t.prototype, e), n && Vv(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var Xp = function() {
  return typeof Symbol == "function";
}, eg = function(t) {
  return Xp() && !!Symbol[t];
}, tg = function(t) {
  return eg(t) ? Symbol[t] : "@@" + t;
};
Xp() && !eg("observable") && (Symbol.observable = Symbol("observable"));
var p5 = tg("iterator"), fh = tg("observable"), n2 = tg("species");
function Ql(t, e) {
  var n = t[e];
  if (n != null) {
    if (typeof n != "function")
      throw new TypeError(n + " is not a function");
    return n;
  }
}
function ss(t) {
  var e = t.constructor;
  return e !== void 0 && (e = e[n2], e === null && (e = void 0)), e !== void 0 ? e : Rt;
}
function g5(t) {
  return t instanceof Rt;
}
function Ca(t) {
  Ca.log ? Ca.log(t) : setTimeout(function() {
    throw t;
  });
}
function vl(t) {
  Promise.resolve().then(function() {
    try {
      t();
    } catch (e) {
      Ca(e);
    }
  });
}
function r2(t) {
  var e = t._cleanup;
  if (e !== void 0 && (t._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var n = Ql(e, "unsubscribe");
        n && n.call(e);
      }
    } catch (r) {
      Ca(r);
    }
}
function hh(t) {
  t._observer = void 0, t._queue = void 0, t._state = "closed";
}
function m5(t) {
  var e = t._queue;
  if (e) {
    t._queue = void 0, t._state = "ready";
    for (var n = 0; n < e.length && (i2(t, e[n].type, e[n].value), t._state !== "closed"); ++n)
      ;
  }
}
function i2(t, e, n) {
  t._state = "running";
  var r = t._observer;
  try {
    var i = Ql(r, e);
    switch (e) {
      case "next":
        i && i.call(r, n);
        break;
      case "error":
        if (hh(t), i)
          i.call(r, n);
        else
          throw n;
        break;
      case "complete":
        hh(t), i && i.call(r);
        break;
    }
  } catch (o) {
    Ca(o);
  }
  t._state === "closed" ? r2(t) : t._state === "running" && (t._state = "ready");
}
function Hd(t, e, n) {
  if (t._state !== "closed") {
    if (t._state === "buffering") {
      t._queue.push({
        type: e,
        value: n
      });
      return;
    }
    if (t._state !== "ready") {
      t._state = "buffering", t._queue = [{
        type: e,
        value: n
      }], vl(function() {
        return m5(t);
      });
      return;
    }
    i2(t, e, n);
  }
}
var v5 = /* @__PURE__ */ function() {
  function t(n, r) {
    this._cleanup = void 0, this._observer = n, this._queue = void 0, this._state = "initializing";
    var i = new y5(this);
    try {
      this._cleanup = r.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = t.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (hh(this), r2(this));
  }, Zp(t, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), t;
}(), y5 = /* @__PURE__ */ function() {
  function t(n) {
    this._subscription = n;
  }
  var e = t.prototype;
  return e.next = function(r) {
    Hd(this._subscription, "next", r);
  }, e.error = function(r) {
    Hd(this._subscription, "error", r);
  }, e.complete = function() {
    Hd(this._subscription, "complete");
  }, Zp(t, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), t;
}(), Rt = /* @__PURE__ */ function() {
  function t(n) {
    if (!(this instanceof t))
      throw new TypeError("Observable cannot be called as a function");
    if (typeof n != "function")
      throw new TypeError("Observable initializer must be a function");
    this._subscriber = n;
  }
  var e = t.prototype;
  return e.subscribe = function(r) {
    return (typeof r != "object" || r === null) && (r = {
      next: r,
      error: arguments[1],
      complete: arguments[2]
    }), new v5(r, this._subscriber);
  }, e.forEach = function(r) {
    var i = this;
    return new Promise(function(o, a) {
      if (typeof r != "function") {
        a(new TypeError(r + " is not a function"));
        return;
      }
      function s() {
        c.unsubscribe(), o();
      }
      var c = i.subscribe({
        next: function(l) {
          try {
            r(l, s);
          } catch (u) {
            a(u), c.unsubscribe();
          }
        },
        error: a,
        complete: o
      });
    });
  }, e.map = function(r) {
    var i = this;
    if (typeof r != "function")
      throw new TypeError(r + " is not a function");
    var o = ss(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            s = r(s);
          } catch (c) {
            return a.error(c);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, e.filter = function(r) {
    var i = this;
    if (typeof r != "function")
      throw new TypeError(r + " is not a function");
    var o = ss(this);
    return new o(function(a) {
      return i.subscribe({
        next: function(s) {
          try {
            if (!r(s))
              return;
          } catch (c) {
            return a.error(c);
          }
          a.next(s);
        },
        error: function(s) {
          a.error(s);
        },
        complete: function() {
          a.complete();
        }
      });
    });
  }, e.reduce = function(r) {
    var i = this;
    if (typeof r != "function")
      throw new TypeError(r + " is not a function");
    var o = ss(this), a = arguments.length > 1, s = !1, c = arguments[1], l = c;
    return new o(function(u) {
      return i.subscribe({
        next: function(d) {
          var f = !s;
          if (s = !0, !f || a)
            try {
              l = r(l, d);
            } catch (h) {
              return u.error(h);
            }
          else
            l = d;
        },
        error: function(d) {
          u.error(d);
        },
        complete: function() {
          if (!s && !a)
            return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(l), u.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var r = this, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    var s = ss(this);
    return new s(function(c) {
      var l, u = 0;
      function d(f) {
        l = f.subscribe({
          next: function(h) {
            c.next(h);
          },
          error: function(h) {
            c.error(h);
          },
          complete: function() {
            u === o.length ? (l = void 0, c.complete()) : d(s.from(o[u++]));
          }
        });
      }
      return d(r), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, e.flatMap = function(r) {
    var i = this;
    if (typeof r != "function")
      throw new TypeError(r + " is not a function");
    var o = ss(this);
    return new o(function(a) {
      var s = [], c = i.subscribe({
        next: function(u) {
          if (r)
            try {
              u = r(u);
            } catch (f) {
              return a.error(f);
            }
          var d = o.from(u).subscribe({
            next: function(f) {
              a.next(f);
            },
            error: function(f) {
              a.error(f);
            },
            complete: function() {
              var f = s.indexOf(d);
              f >= 0 && s.splice(f, 1), l();
            }
          });
          s.push(d);
        },
        error: function(u) {
          a.error(u);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        c.closed && s.length === 0 && a.complete();
      }
      return function() {
        s.forEach(function(u) {
          return u.unsubscribe();
        }), c.unsubscribe();
      };
    });
  }, e[fh] = function() {
    return this;
  }, t.from = function(r) {
    var i = typeof this == "function" ? this : t;
    if (r == null)
      throw new TypeError(r + " is not an object");
    var o = Ql(r, fh);
    if (o) {
      var a = o.call(r);
      if (Object(a) !== a)
        throw new TypeError(a + " is not an object");
      return g5(a) && a.constructor === i ? a : new i(function(s) {
        return a.subscribe(s);
      });
    }
    if (eg("iterator") && (o = Ql(r, p5), o))
      return new i(function(s) {
        vl(function() {
          if (!s.closed) {
            for (var c = f5(o.call(r)), l; !(l = c()).done; ) {
              var u = l.value;
              if (s.next(u), s.closed)
                return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(r))
      return new i(function(s) {
        vl(function() {
          if (!s.closed) {
            for (var c = 0; c < r.length; ++c)
              if (s.next(r[c]), s.closed)
                return;
            s.complete();
          }
        });
      });
    throw new TypeError(r + " is not observable");
  }, t.of = function() {
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = typeof this == "function" ? this : t;
    return new a(function(s) {
      vl(function() {
        if (!s.closed) {
          for (var c = 0; c < i.length; ++c)
            if (s.next(i[c]), s.closed)
              return;
          s.complete();
        }
      });
    });
  }, Zp(t, null, [{
    key: n2,
    get: function() {
      return this;
    }
  }]), t;
}();
Xp() && Object.defineProperty(Rt, Symbol("extensions"), {
  value: {
    symbol: fh,
    hostReportError: Ca
  },
  configurable: !0
});
function w5(t) {
  var e, n = t.Symbol;
  if (typeof n == "function")
    if (n.observable)
      e = n.observable;
    else {
      typeof n.for == "function" ? e = n.for("https://github.com/benlesh/symbol-observable") : e = n("https://github.com/benlesh/symbol-observable");
      try {
        n.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var Ko;
typeof self < "u" ? Ko = self : typeof window < "u" ? Ko = window : typeof global < "u" ? Ko = global : typeof module < "u" ? Ko = module : Ko = Function("return this")();
w5(Ko);
var $v = Rt.prototype, qv = "@@observable";
$v[qv] || ($v[qv] = function() {
  return this;
});
var b5 = Object.prototype.toString;
function o2(t) {
  return ph(t);
}
function ph(t, e) {
  switch (b5.call(t)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(t))
        return e.get(t);
      var n = t.slice(0);
      return e.set(t, n), n.forEach(function(i, o) {
        n[o] = ph(i, e);
      }), n;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(t))
        return e.get(t);
      var r = Object.create(Object.getPrototypeOf(t));
      return e.set(t, r), Object.keys(t).forEach(function(i) {
        r[i] = ph(t[i], e);
      }), r;
    }
    default:
      return t;
  }
}
function _5(t) {
  var e = /* @__PURE__ */ new Set([t]);
  return e.forEach(function(n) {
    on(n) && E5(n) === n && Object.getOwnPropertyNames(n).forEach(function(r) {
      on(n[r]) && e.add(n[r]);
    });
  }), t;
}
function E5(t) {
  if (__DEV__ && !Object.isFrozen(t))
    try {
      Object.freeze(t);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return t;
}
function gh(t) {
  return __DEV__ && _5(t), t;
}
function Rs(t, e, n) {
  var r = [];
  t.forEach(function(i) {
    return i[e] && r.push(i);
  }), r.forEach(function(i) {
    return i[e](n);
  });
}
function Bd(t, e, n) {
  return new Rt(function(r) {
    var i = r.next, o = r.error, a = r.complete, s = 0, c = !1, l = {
      then: function(h) {
        return new Promise(function(g) {
          return g(h());
        });
      }
    };
    function u(h, g) {
      return h ? function(v) {
        ++s;
        var b = function() {
          return h(v);
        };
        l = l.then(b, b).then(function(m) {
          --s, i && i.call(r, m), c && d.complete();
        }, function(m) {
          throw --s, m;
        }).catch(function(m) {
          o && o.call(r, m);
        });
      } : function(v) {
        return g && g.call(r, v);
      };
    }
    var d = {
      next: u(e, i),
      error: u(n, o),
      complete: function() {
        c = !0, s || a && a.call(r);
      }
    }, f = t.subscribe(d);
    return function() {
      return f.unsubscribe();
    };
  });
}
var Do = typeof WeakMap == "function" && !(typeof navigator == "object" && navigator.product === "ReactNative"), C5 = typeof WeakSet == "function", a2 = typeof Symbol == "function" && typeof Symbol.for == "function";
function s2(t) {
  function e(n) {
    Object.defineProperty(t, n, { value: Rt });
  }
  return a2 && Symbol.species && e(Symbol.species), e("@@species"), t;
}
function zv(t) {
  return t && typeof t.then == "function";
}
var _s = function(t) {
  an(e, t);
  function e(n) {
    var r = t.call(this, function(i) {
      return r.addObserver(i), function() {
        return r.removeObserver(i);
      };
    }) || this;
    return r.observers = /* @__PURE__ */ new Set(), r.addCount = 0, r.promise = new Promise(function(i, o) {
      r.resolve = i, r.reject = o;
    }), r.handlers = {
      next: function(i) {
        r.sub !== null && (r.latest = ["next", i], Rs(r.observers, "next", i));
      },
      error: function(i) {
        var o = r.sub;
        o !== null && (o && setTimeout(function() {
          return o.unsubscribe();
        }), r.sub = null, r.latest = ["error", i], r.reject(i), Rs(r.observers, "error", i));
      },
      complete: function() {
        if (r.sub !== null) {
          var i = r.sources.shift();
          i ? zv(i) ? i.then(function(o) {
            return r.sub = o.subscribe(r.handlers);
          }) : r.sub = i.subscribe(r.handlers) : (r.sub = null, r.latest && r.latest[0] === "next" ? r.resolve(r.latest[1]) : r.resolve(), Rs(r.observers, "complete"));
        }
      }
    }, r.cancel = function(i) {
      r.reject(i), r.sources = [], r.handlers.complete();
    }, r.promise.catch(function(i) {
    }), typeof n == "function" && (n = [new Rt(n)]), zv(n) ? n.then(function(i) {
      return r.start(i);
    }, r.handlers.error) : r.start(n), r;
  }
  return e.prototype.start = function(n) {
    this.sub === void 0 && (this.sources = Array.from(n), this.handlers.complete());
  }, e.prototype.deliverLastMessage = function(n) {
    if (this.latest) {
      var r = this.latest[0], i = n[r];
      i && i.call(n, this.latest[1]), this.sub === null && r === "next" && n.complete && n.complete();
    }
  }, e.prototype.addObserver = function(n) {
    this.observers.has(n) || (this.deliverLastMessage(n), this.observers.add(n), ++this.addCount);
  }, e.prototype.removeObserver = function(n, r) {
    this.observers.delete(n) && --this.addCount < 1 && !r && this.handlers.error(new Error("Observable cancelled prematurely"));
  }, e.prototype.cleanup = function(n) {
    var r = this, i = !1, o = function() {
      i || (i = !0, r.observers.delete(a), n());
    }, a = {
      next: o,
      error: o,
      complete: o
    }, s = this.addCount;
    this.addObserver(a), this.addCount = s;
  }, e;
}(Rt);
s2(_s);
function To(t) {
  return Array.isArray(t) && t.length > 0;
}
function yl(t) {
  return t.errors && t.errors.length > 0 || !1;
}
function Ys() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var n = /* @__PURE__ */ Object.create(null);
  return t.forEach(function(r) {
    r && Object.keys(r).forEach(function(i) {
      var o = r[i];
      o !== void 0 && (n[i] = o);
    });
  }), n;
}
var Kv = /* @__PURE__ */ new Map();
function mh(t) {
  var e = Kv.get(t) || 1;
  return Kv.set(t, e + 1), "".concat(t, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function I5(t) {
  var e = mh("stringifyForDisplay");
  return JSON.stringify(t, function(n, r) {
    return r === void 0 ? e : r;
  }).split(JSON.stringify(e)).join("<undefined>");
}
function Wv(t) {
  return new Rt(function(e) {
    e.error(t);
  });
}
function S5(t) {
  return new Rt(function(e) {
    t.then(function(n) {
      e.next(n), e.complete();
    }).catch(e.error.bind(e));
  });
}
var Gv = function(t, e, n) {
  var r = new Error(n);
  throw r.name = "ServerError", r.response = t, r.statusCode = t.status, r.result = e, r;
};
function T5(t) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], n = 0, r = Object.keys(t); n < r.length; n++) {
    var i = r[n];
    if (e.indexOf(i) < 0)
      throw __DEV__ ? new Mt("illegal argument: ".concat(i)) : new Mt(24);
  }
  return t;
}
function k5(t, e) {
  var n = R({}, t), r = function(o) {
    typeof o == "function" ? n = R(R({}, n), o(n)) : n = R(R({}, n), o);
  }, i = function() {
    return R({}, n);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: r
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: i
  }), e;
}
function A5(t) {
  var e = {
    variables: t.variables || {},
    extensions: t.extensions || {},
    operationName: t.operationName,
    query: t.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? dh(e.query) || void 0 : ""), e;
}
function Yv(t, e) {
  return e ? e(t) : Rt.of();
}
function cs(t) {
  return typeof t == "function" ? new zr(t) : t;
}
function Kc(t) {
  return t.request.length <= 1;
}
var O5 = function(t) {
  an(e, t);
  function e(n, r) {
    var i = t.call(this, n) || this;
    return i.link = r, i;
  }
  return e;
}(Error), zr = function() {
  function t(e) {
    e && (this.request = e);
  }
  return t.empty = function() {
    return new t(function() {
      return Rt.of();
    });
  }, t.from = function(e) {
    return e.length === 0 ? t.empty() : e.map(cs).reduce(function(n, r) {
      return n.concat(r);
    });
  }, t.split = function(e, n, r) {
    var i = cs(n), o = cs(r || new t(Yv));
    return Kc(i) && Kc(o) ? new t(function(a) {
      return e(a) ? i.request(a) || Rt.of() : o.request(a) || Rt.of();
    }) : new t(function(a, s) {
      return e(a) ? i.request(a, s) || Rt.of() : o.request(a, s) || Rt.of();
    });
  }, t.execute = function(e, n) {
    return e.request(k5(n.context, A5(T5(n)))) || Rt.of();
  }, t.concat = function(e, n) {
    var r = cs(e);
    if (Kc(r))
      return __DEV__ && le.warn(new O5("You are calling concat on a terminating link, which will have no effect", r)), r;
    var i = cs(n);
    return Kc(i) ? new t(function(o) {
      return r.request(o, function(a) {
        return i.request(a) || Rt.of();
      }) || Rt.of();
    }) : new t(function(o, a) {
      return r.request(o, function(s) {
        return i.request(s, a) || Rt.of();
      }) || Rt.of();
    });
  }, t.prototype.split = function(e, n, r) {
    return this.concat(t.split(e, n, r || new t(Yv)));
  }, t.prototype.concat = function(e) {
    return t.concat(this, e);
  }, t.prototype.request = function(e, n) {
    throw __DEV__ ? new Mt("request is not implemented") : new Mt(19);
  }, t.prototype.onError = function(e, n) {
    if (n && n.error)
      return n.error(e), !1;
    throw e;
  }, t.prototype.setOnError = function(e) {
    return this.onError = e, this;
  }, t;
}(), x5 = zr.from, vh = zr.execute, R5 = "3.5.6", Qv = Object.prototype.hasOwnProperty;
function N5(t) {
  return function(e) {
    return e.text().then(function(n) {
      try {
        return JSON.parse(n);
      } catch (i) {
        var r = i;
        throw r.name = "ServerParseError", r.response = e, r.statusCode = e.status, r.bodyText = n, r;
      }
    }).then(function(n) {
      return e.status >= 300 && Gv(e, n, "Response not successful: Received status code ".concat(e.status)), !Array.isArray(n) && !Qv.call(n, "data") && !Qv.call(n, "errors") && Gv(e, n, "Server response was missing for query '".concat(Array.isArray(t) ? t.map(function(r) {
        return r.operationName;
      }) : t.operationName, "'.")), n;
    });
  };
}
var yh = function(t, e) {
  var n;
  try {
    n = JSON.stringify(t);
  } catch (i) {
    var r = __DEV__ ? new Mt("Network request failed. ".concat(e, " is not serializable: ").concat(i.message)) : new Mt(21);
    throw r.parseError = i, r;
  }
  return n;
}, M5 = {
  includeQuery: !0,
  includeExtensions: !1
}, P5 = {
  accept: "*/*",
  "content-type": "application/json"
}, D5 = {
  method: "POST"
}, L5 = {
  http: M5,
  headers: P5,
  options: D5
}, F5 = function(t, e) {
  return e(t);
};
function U5(t, e) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var i = {}, o = {};
  n.forEach(function(d) {
    i = R(R(R({}, i), d.options), { headers: R(R({}, i.headers), H5(d.headers)) }), d.credentials && (i.credentials = d.credentials), o = R(R({}, o), d.http);
  });
  var a = t.operationName, s = t.extensions, c = t.variables, l = t.query, u = { operationName: a, variables: c };
  return o.includeExtensions && (u.extensions = s), o.includeQuery && (u.query = e(l, M6)), {
    options: i,
    body: u
  };
}
function H5(t) {
  if (t) {
    var e = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(t)).forEach(function(n) {
      e[n.toLowerCase()] = t[n];
    }), e;
  }
  return t;
}
var B5 = function(t) {
  if (!t && typeof fetch > "u")
    throw __DEV__ ? new Mt(`
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `) : new Mt(20);
}, j5 = function() {
  if (typeof AbortController > "u")
    return { controller: !1, signal: !1 };
  var t = new AbortController(), e = t.signal;
  return { controller: t, signal: e };
}, V5 = function(t, e) {
  var n = t.getContext(), r = n.uri;
  return r || (typeof e == "function" ? e(t) : e || "/graphql");
};
function $5(t, e) {
  var n = [], r = function(d, f) {
    n.push("".concat(d, "=").concat(encodeURIComponent(f)));
  };
  if ("query" in e && r("query", e.query), e.operationName && r("operationName", e.operationName), e.variables) {
    var i = void 0;
    try {
      i = yh(e.variables, "Variables map");
    } catch (d) {
      return { parseError: d };
    }
    r("variables", i);
  }
  if (e.extensions) {
    var o = void 0;
    try {
      o = yh(e.extensions, "Extensions map");
    } catch (d) {
      return { parseError: d };
    }
    r("extensions", o);
  }
  var a = "", s = t, c = t.indexOf("#");
  c !== -1 && (a = t.substr(c), s = t.substr(0, c));
  var l = s.indexOf("?") === -1 ? "?" : "&", u = s + l + n.join("&") + a;
  return { newURI: u };
}
var Jv = ni(function() {
  return fetch;
}), q5 = function(t) {
  t === void 0 && (t = {});
  var e = t.uri, n = e === void 0 ? "/graphql" : e, r = t.fetch, i = t.print, o = i === void 0 ? F5 : i, a = t.includeExtensions, s = t.useGETForQueries, c = t.includeUnusedVariables, l = c === void 0 ? !1 : c, u = jr(t, ["uri", "fetch", "print", "includeExtensions", "useGETForQueries", "includeUnusedVariables"]);
  __DEV__ && B5(r || Jv);
  var d = {
    http: { includeExtensions: a },
    options: u.fetchOptions,
    credentials: u.credentials,
    headers: u.headers
  };
  return new zr(function(f) {
    var h = V5(f, n), g = f.getContext(), v = {};
    if (g.clientAwareness) {
      var b = g.clientAwareness, m = b.name, y = b.version;
      m && (v["apollographql-client-name"] = m), y && (v["apollographql-client-version"] = y);
    }
    var p = R(R({}, v), g.headers), w = {
      http: g.http,
      options: g.fetchOptions,
      credentials: g.credentials,
      headers: p
    }, _ = U5(f, o, L5, d, w), E = _.options, S = _.body;
    if (S.variables && !l) {
      var T = new Set(Object.keys(S.variables));
      qr(f.query, {
        Variable: function(ae, Re, fe) {
          fe && fe.kind !== "VariableDefinition" && T.delete(ae.name.value);
        }
      }), T.size && (S.variables = R({}, S.variables), T.forEach(function(ae) {
        delete S.variables[ae];
      }));
    }
    var x;
    if (!E.signal) {
      var A = j5(), N = A.controller, F = A.signal;
      x = N, x && (E.signal = F);
    }
    var D = function(ae) {
      return ae.kind === "OperationDefinition" && ae.operation === "mutation";
    };
    if (s && !f.query.definitions.some(D) && (E.method = "GET"), E.method === "GET") {
      var L = $5(h, S), z = L.newURI, ne = L.parseError;
      if (ne)
        return Wv(ne);
      h = z;
    } else
      try {
        E.body = yh(S, "Payload");
      } catch (ae) {
        return Wv(ae);
      }
    return new Rt(function(ae) {
      var Re = r || ni(function() {
        return fetch;
      }) || Jv;
      return Re(h, E).then(function(fe) {
        return f.setContext({ response: fe }), fe;
      }).then(N5(f)).then(function(fe) {
        return ae.next(fe), ae.complete(), fe;
      }).catch(function(fe) {
        fe.name !== "AbortError" && (fe.result && fe.result.errors && fe.result.data && ae.next(fe.result), ae.error(fe));
      }), function() {
        x && x.abort();
      };
    });
  });
}, c2 = function(t) {
  an(e, t);
  function e(n) {
    n === void 0 && (n = {});
    var r = t.call(this, q5(n).request) || this;
    return r.options = n, r;
  }
  return e;
}(zr);
const { toString: Zv, hasOwnProperty: z5 } = Object.prototype, Xv = Function.prototype.toString, wh = /* @__PURE__ */ new Map();
function wn(t, e) {
  try {
    return bh(t, e);
  } finally {
    wh.clear();
  }
}
function bh(t, e) {
  if (t === e)
    return !0;
  const n = Zv.call(t), r = Zv.call(e);
  if (n !== r)
    return !1;
  switch (n) {
    case "[object Array]":
      if (t.length !== e.length)
        return !1;
    case "[object Object]": {
      if (t0(t, e))
        return !0;
      const i = e0(t), o = e0(e), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!z5.call(e, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const c = i[s];
        if (!bh(t[c], e[c]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return t.name === e.name && t.message === e.message;
    case "[object Number]":
      if (t !== t)
        return e !== e;
    case "[object Boolean]":
    case "[object Date]":
      return +t == +e;
    case "[object RegExp]":
    case "[object String]":
      return t == `${e}`;
    case "[object Map]":
    case "[object Set]": {
      if (t.size !== e.size)
        return !1;
      if (t0(t, e))
        return !0;
      const i = t.entries(), o = n === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, c] = a.value;
        if (!e.has(s) || o && !bh(c, e.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      t = new Uint8Array(t), e = new Uint8Array(e);
    case "[object DataView]": {
      let i = t.byteLength;
      if (i === e.byteLength)
        for (; i-- && t[i] === e[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = Xv.call(t);
      return i !== Xv.call(e) ? !1 : !G5(i, W5);
    }
  }
  return !1;
}
function e0(t) {
  return Object.keys(t).filter(K5, t);
}
function K5(t) {
  return this[t] !== void 0;
}
const W5 = "{ [native code] }";
function G5(t, e) {
  const n = t.length - e.length;
  return n >= 0 && t.indexOf(e, n) === n;
}
function t0(t, e) {
  let n = wh.get(t);
  if (n) {
    if (n.has(e))
      return !0;
  } else
    wh.set(t, n = /* @__PURE__ */ new Set());
  return n.add(e), !1;
}
var Y5 = function() {
  return /* @__PURE__ */ Object.create(null);
}, l2 = Array.prototype, Q5 = l2.forEach, J5 = l2.slice, _c = (
  /** @class */
  function() {
    function t(e, n) {
      e === void 0 && (e = !0), n === void 0 && (n = Y5), this.weakness = e, this.makeData = n;
    }
    return t.prototype.lookup = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      return this.lookupArray(e);
    }, t.prototype.lookupArray = function(e) {
      var n = this;
      return Q5.call(e, function(r) {
        return n = n.getChildTrie(r);
      }), n.data || (n.data = this.makeData(J5.call(e)));
    }, t.prototype.getChildTrie = function(e) {
      var n = this.weakness && Z5(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map()), r = n.get(e);
      return r || n.set(e, r = new t(this.weakness, this.makeData)), r;
    }, t;
  }()
);
function Z5(t) {
  switch (typeof t) {
    case "object":
      if (t === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
let En = null;
const n0 = {};
let X5 = 1;
const eA = () => class {
  constructor() {
    this.id = [
      "slot",
      X5++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = En; e; e = e.parent)
      if (this.id in e.slots) {
        const n = e.slots[this.id];
        if (n === n0)
          break;
        return e !== En && (En.slots[this.id] = n), !0;
      }
    return En && (En.slots[this.id] = n0), !1;
  }
  getValue() {
    if (this.hasValue())
      return En.slots[this.id];
  }
  withValue(e, n, r, i) {
    const o = {
      __proto__: null,
      [this.id]: e
    }, a = En;
    En = { parent: a, slots: o };
    try {
      return n.apply(i, r);
    } finally {
      En = a;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const n = En;
    return function() {
      const r = En;
      try {
        return En = n, e.apply(this, arguments);
      } finally {
        En = r;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, n, r) {
    if (En) {
      const i = En;
      try {
        return En = null, e.apply(r, n);
      } finally {
        En = i;
      }
    } else
      return e.apply(r, n);
  }
};
function r0(t) {
  try {
    return t();
  } catch {
  }
}
const jd = "@wry/context:Slot", tA = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  r0(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  r0(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), i0 = tA, nA = i0[jd] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[jd] || function(t) {
  try {
    Object.defineProperty(i0, jd, {
      value: t,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return t;
  }
}(eA());
function rA() {
}
var iA = (
  /** @class */
  function() {
    function t(e, n) {
      e === void 0 && (e = 1 / 0), n === void 0 && (n = rA), this.max = e, this.dispose = n, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
    }
    return t.prototype.has = function(e) {
      return this.map.has(e);
    }, t.prototype.get = function(e) {
      var n = this.getNode(e);
      return n && n.value;
    }, t.prototype.getNode = function(e) {
      var n = this.map.get(e);
      if (n && n !== this.newest) {
        var r = n.older, i = n.newer;
        i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
      }
      return n;
    }, t.prototype.set = function(e, n) {
      var r = this.getNode(e);
      return r ? r.value = n : (r = {
        key: e,
        value: n,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(e, r), r.value);
    }, t.prototype.clean = function() {
      for (; this.oldest && this.map.size > this.max; )
        this.delete(this.oldest.key);
    }, t.prototype.delete = function(e) {
      var n = this.map.get(e);
      return n ? (n === this.newest && (this.newest = n.older), n === this.oldest && (this.oldest = n.newer), n.newer && (n.newer.older = n.older), n.older && (n.older.newer = n.newer), this.map.delete(e), this.dispose(n.value, e), !0) : !1;
    }, t;
  }()
), zu = new nA(), Vd, oA = Object.prototype.hasOwnProperty, ng = (Vd = Array.from, Vd === void 0 ? function(t) {
  var e = [];
  return t.forEach(function(n) {
    return e.push(n);
  }), e;
} : Vd);
function Jl(t) {
  var e = t.unsubscribe;
  typeof e == "function" && (t.unsubscribe = void 0, e());
}
var Qs = [], aA = 100;
function Ia(t, e) {
  if (!t)
    throw new Error(e || "assertion failure");
}
function sA(t, e) {
  var n = t.length;
  return (
    // Unknown values are not equal to each other.
    n > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    n === e.length && // The underlying value or exception must be the same.
    t[n - 1] === e[n - 1]
  );
}
function u2(t) {
  switch (t.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return t[0];
    case 2:
      throw t[1];
  }
}
function cA(t) {
  return t.slice(0);
}
var lA = (
  /** @class */
  function() {
    function t(e) {
      this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++t.count;
    }
    return t.prototype.peek = function() {
      if (this.value.length === 1 && !Bi(this))
        return o0(this), this.value[0];
    }, t.prototype.recompute = function(e) {
      return Ia(!this.recomputing, "already recomputing"), o0(this), Bi(this) ? uA(this, e) : u2(this.value);
    }, t.prototype.setDirty = function() {
      this.dirty || (this.dirty = !0, this.value.length = 0, d2(this), Jl(this));
    }, t.prototype.dispose = function() {
      var e = this;
      this.setDirty(), m2(this), rg(this, function(n, r) {
        n.setDirty(), v2(n, e);
      });
    }, t.prototype.forget = function() {
      this.dispose();
    }, t.prototype.dependOn = function(e) {
      e.add(this), this.deps || (this.deps = Qs.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
    }, t.prototype.forgetDeps = function() {
      var e = this;
      this.deps && (ng(this.deps).forEach(function(n) {
        return n.delete(e);
      }), this.deps.clear(), Qs.push(this.deps), this.deps = null);
    }, t.count = 0, t;
  }()
);
function o0(t) {
  var e = zu.getValue();
  if (e)
    return t.parents.add(e), e.childValues.has(t) || e.childValues.set(t, []), Bi(t) ? h2(e, t) : p2(e, t), e;
}
function uA(t, e) {
  return m2(t), zu.withValue(t, dA, [t, e]), hA(t, e) && fA(t), u2(t.value);
}
function dA(t, e) {
  t.recomputing = !0, t.value.length = 0;
  try {
    t.value[0] = t.fn.apply(null, e);
  } catch (n) {
    t.value[1] = n;
  }
  t.recomputing = !1;
}
function Bi(t) {
  return t.dirty || !!(t.dirtyChildren && t.dirtyChildren.size);
}
function fA(t) {
  t.dirty = !1, !Bi(t) && f2(t);
}
function d2(t) {
  rg(t, h2);
}
function f2(t) {
  rg(t, p2);
}
function rg(t, e) {
  var n = t.parents.size;
  if (n)
    for (var r = ng(t.parents), i = 0; i < n; ++i)
      e(r[i], t);
}
function h2(t, e) {
  Ia(t.childValues.has(e)), Ia(Bi(e));
  var n = !Bi(t);
  if (!t.dirtyChildren)
    t.dirtyChildren = Qs.pop() || /* @__PURE__ */ new Set();
  else if (t.dirtyChildren.has(e))
    return;
  t.dirtyChildren.add(e), n && d2(t);
}
function p2(t, e) {
  Ia(t.childValues.has(e)), Ia(!Bi(e));
  var n = t.childValues.get(e);
  n.length === 0 ? t.childValues.set(e, cA(e.value)) : sA(n, e.value) || t.setDirty(), g2(t, e), !Bi(t) && f2(t);
}
function g2(t, e) {
  var n = t.dirtyChildren;
  n && (n.delete(e), n.size === 0 && (Qs.length < aA && Qs.push(n), t.dirtyChildren = null));
}
function m2(t) {
  t.childValues.size > 0 && t.childValues.forEach(function(e, n) {
    v2(t, n);
  }), t.forgetDeps(), Ia(t.dirtyChildren === null);
}
function v2(t, e) {
  e.parents.delete(t), t.childValues.delete(e), g2(t, e);
}
function hA(t, e) {
  if (typeof t.subscribe == "function")
    try {
      Jl(t), t.unsubscribe = t.subscribe.apply(null, e);
    } catch {
      return t.setDirty(), !1;
    }
  return !0;
}
var pA = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function y2(t) {
  var e = /* @__PURE__ */ new Map(), n = t && t.subscribe;
  function r(i) {
    var o = zu.getValue();
    if (o) {
      var a = e.get(i);
      a || e.set(i, a = /* @__PURE__ */ new Set()), o.dependOn(a), typeof n == "function" && (Jl(a), a.unsubscribe = n(i));
    }
  }
  return r.dirty = function(o, a) {
    var s = e.get(o);
    if (s) {
      var c = a && oA.call(pA, a) ? a : "setDirty";
      ng(s).forEach(function(l) {
        return l[c]();
      }), e.delete(o), Jl(s);
    }
  }, r;
}
function w2() {
  var t = new _c(typeof WeakMap == "function");
  return function() {
    return t.lookupArray(arguments);
  };
}
w2();
var $d = /* @__PURE__ */ new Set();
function Zl(t, e) {
  e === void 0 && (e = /* @__PURE__ */ Object.create(null));
  var n = new iA(e.max || Math.pow(2, 16), function(l) {
    return l.dispose();
  }), r = e.keyArgs, i = e.makeCacheKey || w2(), o = function() {
    var l = i.apply(null, r ? r.apply(null, arguments) : arguments);
    if (l === void 0)
      return t.apply(null, arguments);
    var u = n.get(l);
    u || (n.set(l, u = new lA(t)), u.subscribe = e.subscribe, u.forget = function() {
      return n.delete(l);
    });
    var d = u.recompute(Array.prototype.slice.call(arguments));
    return n.set(l, u), $d.add(n), zu.hasValue() || ($d.forEach(function(f) {
      return f.clean();
    }), $d.clear()), d;
  };
  Object.defineProperty(o, "size", {
    get: function() {
      return n.map.size;
    },
    configurable: !1,
    enumerable: !1
  });
  function a(l) {
    var u = n.get(l);
    u && u.setDirty();
  }
  o.dirtyKey = a, o.dirty = function() {
    a(i.apply(null, arguments));
  };
  function s(l) {
    var u = n.get(l);
    if (u)
      return u.peek();
  }
  o.peekKey = s, o.peek = function() {
    return s(i.apply(null, arguments));
  };
  function c(l) {
    return n.delete(l);
  }
  return o.forgetKey = c, o.forget = function() {
    return c(i.apply(null, arguments));
  }, o.makeCacheKey = i, o.getKey = r ? function() {
    return i.apply(null, r.apply(null, arguments));
  } : i, Object.freeze(o);
}
var gA = function() {
  function t() {
    this.getFragmentDoc = Zl(V6);
  }
  return t.prototype.batch = function(e) {
    var n = this, r = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, i;
    return this.performTransaction(function() {
      return i = e.update(n);
    }, r), i;
  }, t.prototype.recordOptimisticTransaction = function(e, n) {
    this.performTransaction(e, n);
  }, t.prototype.transformDocument = function(e) {
    return e;
  }, t.prototype.identify = function(e) {
  }, t.prototype.gc = function() {
    return [];
  }, t.prototype.modify = function(e) {
    return !1;
  }, t.prototype.transformForLink = function(e) {
    return e;
  }, t.prototype.readQuery = function(e, n) {
    return n === void 0 && (n = !!e.optimistic), this.read(R(R({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: n }));
  }, t.prototype.readFragment = function(e, n) {
    return n === void 0 && (n = !!e.optimistic), this.read(R(R({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: n }));
  }, t.prototype.writeQuery = function(e) {
    var n = e.id, r = e.data, i = jr(e, ["id", "data"]);
    return this.write(Object.assign(i, {
      dataId: n || "ROOT_QUERY",
      result: r
    }));
  }, t.prototype.writeFragment = function(e) {
    var n = e.id, r = e.data, i = e.fragment, o = e.fragmentName, a = jr(e, ["id", "data", "fragment", "fragmentName"]);
    return this.write(Object.assign(a, {
      query: this.getFragmentDoc(i, o),
      dataId: n,
      result: r
    }));
  }, t.prototype.updateQuery = function(e, n) {
    return this.batch({
      update: function(r) {
        var i = r.readQuery(e), o = n(i);
        return o == null ? i : (r.writeQuery(R(R({}, e), { data: o })), o);
      }
    });
  }, t.prototype.updateFragment = function(e, n) {
    return this.batch({
      update: function(r) {
        var i = r.readFragment(e), o = n(i);
        return o == null ? i : (r.writeFragment(R(R({}, e), { data: o })), o);
      }
    });
  }, t;
}(), b2 = function() {
  function t(e, n, r, i) {
    this.message = e, this.path = n, this.query = r, this.variables = i;
  }
  return t;
}(), yn = Object.prototype.hasOwnProperty;
function _2(t, e) {
  var n = t.__typename, r = t.id, i = t._id;
  if (typeof n == "string" && (e && (e.keyObject = r !== void 0 ? { id: r } : i !== void 0 ? { _id: i } : void 0), r === void 0 && (r = i), r !== void 0))
    return "".concat(n, ":").concat(typeof r == "number" || typeof r == "string" ? r : JSON.stringify(r));
}
var E2 = {
  dataIdFromObject: _2,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function mA(t) {
  return Ys(E2, t);
}
function C2(t) {
  var e = t.canonizeResults;
  return e === void 0 ? E2.canonizeResults : e;
}
function vA(t, e) {
  return It(e) ? t.get(e.__ref, "__typename") : e && e.__typename;
}
var I2 = /^[_a-z][_0-9a-z]*/i;
function ji(t) {
  var e = t.match(I2);
  return e ? e[0] : t;
}
function _h(t, e, n) {
  return on(e) ? Array.isArray(e) ? e.every(function(r) {
    return _h(t, r, n);
  }) : t.selections.every(function(r) {
    if (hi(r) && ju(r, n)) {
      var i = So(r);
      return yn.call(e, i) && (!r.selectionSet || _h(r.selectionSet, e[i], n));
    }
    return !0;
  }) : !1;
}
function ra(t) {
  return on(t) && !It(t) && !Array.isArray(t);
}
function yA() {
  return new bc();
}
var wl = /* @__PURE__ */ Object.create(null), qd = function() {
  return wl;
}, a0 = /* @__PURE__ */ Object.create(null), Js = function() {
  function t(e, n) {
    var r = this;
    this.policies = e, this.group = n, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
      return gh(It(i) ? r.get(i.__ref, o) : i && i[o]);
    }, this.canRead = function(i) {
      return It(i) ? r.has(i.__ref) : typeof i == "object";
    }, this.toReference = function(i, o) {
      if (typeof i == "string")
        return da(i);
      if (It(i))
        return i;
      var a = r.policies.identify(i)[0];
      if (a) {
        var s = da(a);
        return o && r.merge(a, i), s;
      }
    };
  }
  return t.prototype.toObject = function() {
    return R({}, this.data);
  }, t.prototype.has = function(e) {
    return this.lookup(e, !0) !== void 0;
  }, t.prototype.get = function(e, n) {
    if (this.group.depend(e, n), yn.call(this.data, e)) {
      var r = this.data[e];
      if (r && yn.call(r, n))
        return r[n];
    }
    if (n === "__typename" && yn.call(this.policies.rootTypenamesById, e))
      return this.policies.rootTypenamesById[e];
    if (this instanceof Si)
      return this.parent.get(e, n);
  }, t.prototype.lookup = function(e, n) {
    if (n && this.group.depend(e, "__exists"), yn.call(this.data, e))
      return this.data[e];
    if (this instanceof Si)
      return this.parent.lookup(e, n);
    if (this.policies.rootTypenamesById[e])
      return /* @__PURE__ */ Object.create(null);
  }, t.prototype.merge = function(e, n) {
    var r = this, i;
    It(e) && (e = e.__ref), It(n) && (n = n.__ref);
    var o = typeof e == "string" ? this.lookup(i = e) : e, a = typeof n == "string" ? this.lookup(i = n) : n;
    if (a) {
      __DEV__ ? le(typeof i == "string", "store.merge expects a string ID") : le(typeof i == "string", 1);
      var s = new bc(bA).merge(o, a);
      if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
        var c = /* @__PURE__ */ Object.create(null);
        o || (c.__exists = 1), Object.keys(a).forEach(function(l) {
          if (!o || o[l] !== s[l]) {
            c[l] = 1;
            var u = ji(l);
            u !== l && !r.policies.hasKeyArgs(s.__typename, u) && (c[u] = 1), s[l] === void 0 && !(r instanceof Si) && delete s[l];
          }
        }), c.__typename && !(o && o.__typename) && this.policies.rootTypenamesById[i] === s.__typename && delete c.__typename, Object.keys(c).forEach(function(l) {
          return r.group.dirty(i, l);
        });
      }
    }
  }, t.prototype.modify = function(e, n) {
    var r = this, i = this.lookup(e);
    if (i) {
      var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, c = {
        DELETE: wl,
        INVALIDATE: a0,
        isReference: It,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function(l, u) {
          return r.policies.readField(typeof l == "string" ? {
            fieldName: l,
            from: u || da(e)
          } : l, { store: r });
        }
      };
      if (Object.keys(i).forEach(function(l) {
        var u = ji(l), d = i[l];
        if (d !== void 0) {
          var f = typeof n == "function" ? n : n[l] || n[u];
          if (f) {
            var h = f === qd ? wl : f(gh(d), R(R({}, c), { fieldName: u, storeFieldName: l, storage: r.getStorage(e, l) }));
            h === a0 ? r.group.dirty(e, l) : (h === wl && (h = void 0), h !== d && (o[l] = h, a = !0, d = h));
          }
          d !== void 0 && (s = !1);
        }
      }), a)
        return this.merge(e, o), s && (this instanceof Si ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
    }
    return !1;
  }, t.prototype.delete = function(e, n, r) {
    var i, o = this.lookup(e);
    if (o) {
      var a = this.getFieldValue(o, "__typename"), s = n && r ? this.policies.getStoreFieldName({ typename: a, fieldName: n, args: r }) : n;
      return this.modify(e, s ? (i = {}, i[s] = qd, i) : qd);
    }
    return !1;
  }, t.prototype.evict = function(e, n) {
    var r = !1;
    return e.id && (yn.call(this.data, e.id) && (r = this.delete(e.id, e.fieldName, e.args)), this instanceof Si && this !== n && (r = this.parent.evict(e, n) || r), (e.fieldName || r) && this.group.dirty(e.id, e.fieldName || "__exists")), r;
  }, t.prototype.clear = function() {
    this.replace(null);
  }, t.prototype.extract = function() {
    var e = this, n = this.toObject(), r = [];
    return this.getRootIdSet().forEach(function(i) {
      yn.call(e.policies.rootTypenamesById, i) || r.push(i);
    }), r.length && (n.__META = { extraRootIds: r.sort() }), n;
  }, t.prototype.replace = function(e) {
    var n = this;
    if (Object.keys(this.data).forEach(function(o) {
      e && yn.call(e, o) || n.delete(o);
    }), e) {
      var r = e.__META, i = jr(e, ["__META"]);
      Object.keys(i).forEach(function(o) {
        n.merge(o, i[o]);
      }), r && r.extraRootIds.forEach(this.retain, this);
    }
  }, t.prototype.retain = function(e) {
    return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
  }, t.prototype.release = function(e) {
    if (this.rootIds[e] > 0) {
      var n = --this.rootIds[e];
      return n || delete this.rootIds[e], n;
    }
    return 0;
  }, t.prototype.getRootIdSet = function(e) {
    return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof Si ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
  }, t.prototype.gc = function() {
    var e = this, n = this.getRootIdSet(), r = this.toObject();
    n.forEach(function(a) {
      yn.call(r, a) && (Object.keys(e.findChildRefIds(a)).forEach(n.add, n), delete r[a]);
    });
    var i = Object.keys(r);
    if (i.length) {
      for (var o = this; o instanceof Si; )
        o = o.parent;
      i.forEach(function(a) {
        return o.delete(a);
      });
    }
    return i;
  }, t.prototype.findChildRefIds = function(e) {
    if (!yn.call(this.refs, e)) {
      var n = this.refs[e] = /* @__PURE__ */ Object.create(null), r = this.data[e];
      if (!r)
        return n;
      var i = /* @__PURE__ */ new Set([r]);
      i.forEach(function(o) {
        It(o) && (n[o.__ref] = !0), on(o) && Object.keys(o).forEach(function(a) {
          var s = o[a];
          on(s) && i.add(s);
        });
      });
    }
    return this.refs[e];
  }, t.prototype.makeCacheKey = function() {
    return this.group.keyMaker.lookupArray(arguments);
  }, t;
}(), S2 = function() {
  function t(e, n) {
    n === void 0 && (n = null), this.caching = e, this.parent = n, this.d = null, this.resetCaching();
  }
  return t.prototype.resetCaching = function() {
    this.d = this.caching ? y2() : null, this.keyMaker = new _c(Do);
  }, t.prototype.depend = function(e, n) {
    if (this.d) {
      this.d(zd(e, n));
      var r = ji(n);
      r !== n && this.d(zd(e, r)), this.parent && this.parent.depend(e, n);
    }
  }, t.prototype.dirty = function(e, n) {
    this.d && this.d.dirty(zd(e, n), n === "__exists" ? "forget" : "setDirty");
  }, t;
}();
function zd(t, e) {
  return e + "#" + t;
}
function s0(t, e) {
  Ns(t) && t.group.depend(e, "__exists");
}
(function(t) {
  var e = function(n) {
    an(r, n);
    function r(i) {
      var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, c = i.seed, l = n.call(this, o, new S2(s)) || this;
      return l.stump = new wA(l), l.storageTrie = new _c(Do), c && l.replace(c), l;
    }
    return r.prototype.addLayer = function(i, o) {
      return this.stump.addLayer(i, o);
    }, r.prototype.removeLayer = function() {
      return this;
    }, r.prototype.getStorage = function() {
      return this.storageTrie.lookupArray(arguments);
    }, r;
  }(t);
  t.Root = e;
})(Js || (Js = {}));
var Si = function(t) {
  an(e, t);
  function e(n, r, i, o) {
    var a = t.call(this, r.policies, o) || this;
    return a.id = n, a.parent = r, a.replay = i, a.group = o, i(a), a;
  }
  return e.prototype.addLayer = function(n, r) {
    return new e(n, this, r, this.group);
  }, e.prototype.removeLayer = function(n) {
    var r = this, i = this.parent.removeLayer(n);
    return n === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
      var a = r.data[o], s = i.lookup(o);
      s ? a ? a !== s && Object.keys(a).forEach(function(c) {
        wn(a[c], s[c]) || r.group.dirty(o, c);
      }) : (r.group.dirty(o, "__exists"), Object.keys(s).forEach(function(c) {
        r.group.dirty(o, c);
      })) : r.delete(o);
    }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
  }, e.prototype.toObject = function() {
    return R(R({}, this.parent.toObject()), this.data);
  }, e.prototype.findChildRefIds = function(n) {
    var r = this.parent.findChildRefIds(n);
    return yn.call(this.data, n) ? R(R({}, r), t.prototype.findChildRefIds.call(this, n)) : r;
  }, e.prototype.getStorage = function() {
    for (var n = this.parent; n.parent; )
      n = n.parent;
    return n.getStorage.apply(n, arguments);
  }, e;
}(Js), wA = function(t) {
  an(e, t);
  function e(n) {
    return t.call(this, "EntityStore.Stump", n, function() {
    }, new S2(n.group.caching, n.group)) || this;
  }
  return e.prototype.removeLayer = function() {
    return this;
  }, e.prototype.merge = function() {
    return this.parent.merge.apply(this.parent, arguments);
  }, e;
}(Si);
function bA(t, e, n) {
  var r = t[n], i = e[n];
  return wn(r, i) ? r : i;
}
function Ns(t) {
  return !!(t instanceof Js && t.group.caching);
}
function _A(t) {
  return on(t) ? Array.isArray(t) ? t.slice(0) : R({ __proto__: Object.getPrototypeOf(t) }, t) : t;
}
var Eh = function() {
  function t() {
    this.known = new (C5 ? WeakSet : Set)(), this.pool = new _c(Do), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
  }
  return t.prototype.isKnown = function(e) {
    return on(e) && this.known.has(e);
  }, t.prototype.pass = function(e) {
    if (on(e)) {
      var n = _A(e);
      return this.passes.set(n, e), n;
    }
    return e;
  }, t.prototype.admit = function(e) {
    var n = this;
    if (on(e)) {
      var r = this.passes.get(e);
      if (r)
        return r;
      var i = Object.getPrototypeOf(e);
      switch (i) {
        case Array.prototype: {
          if (this.known.has(e))
            return e;
          var o = e.map(this.admit, this), a = this.pool.lookupArray(o);
          return a.array || (this.known.add(a.array = o), __DEV__ && Object.freeze(o)), a.array;
        }
        case null:
        case Object.prototype: {
          if (this.known.has(e))
            return e;
          var s = Object.getPrototypeOf(e), c = [s], l = this.sortedKeys(e);
          c.push(l.json);
          var u = c.length;
          l.sorted.forEach(function(h) {
            c.push(n.admit(e[h]));
          });
          var a = this.pool.lookupArray(c);
          if (!a.object) {
            var d = a.object = Object.create(s);
            this.known.add(d), l.sorted.forEach(function(h, g) {
              d[h] = c[u + g];
            }), __DEV__ && Object.freeze(d);
          }
          return a.object;
        }
      }
    }
    return e;
  }, t.prototype.sortedKeys = function(e) {
    var n = Object.keys(e), r = this.pool.lookupArray(n);
    if (!r.keys) {
      n.sort();
      var i = JSON.stringify(n);
      (r.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, r.keys = { sorted: n, json: i });
    }
    return r.keys;
  }, t;
}(), vo = Object.assign(function(t) {
  if (on(t)) {
    Ch === void 0 && c0();
    var e = Ch.admit(t), n = Ih.get(e);
    return n === void 0 && Ih.set(e, n = JSON.stringify(e)), n;
  }
  return JSON.stringify(t);
}, {
  reset: c0
}), Ch, Ih;
function c0() {
  Ch = new Eh(), Ih = new (Do ? WeakMap : Map)();
}
function l0(t) {
  return [
    t.selectionSet,
    t.objectOrReference,
    t.context,
    t.context.canonizeResults
  ];
}
var EA = function() {
  function t(e) {
    var n = this;
    this.knownResults = new (Do ? WeakMap : Map)(), this.config = Ys(e, {
      addTypename: e.addTypename !== !1,
      canonizeResults: C2(e)
    }), this.canon = e.canon || new Eh(), this.executeSelectionSet = Zl(function(r) {
      var i, o = r.context.canonizeResults, a = l0(r);
      a[3] = !o;
      var s = (i = n.executeSelectionSet).peek.apply(i, a);
      return s ? o ? R(R({}, s), { result: n.canon.admit(s.result) }) : s : (s0(r.context.store, r.enclosingRef.__ref), n.execSelectionSetImpl(r));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: l0,
      makeCacheKey: function(r, i, o, a) {
        if (Ns(o.store))
          return o.store.makeCacheKey(r, It(i) ? i.__ref : i, o.varString, a);
      }
    }), this.executeSubSelectedArray = Zl(function(r) {
      return s0(r.context.store, r.enclosingRef.__ref), n.execSubSelectedArrayImpl(r);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(r) {
        var i = r.field, o = r.array, a = r.context;
        if (Ns(a.store))
          return a.store.makeCacheKey(i, o, a.varString);
      }
    });
  }
  return t.prototype.resetCanon = function() {
    this.canon = new Eh();
  }, t.prototype.diffQueryAgainstStore = function(e) {
    var n = e.store, r = e.query, i = e.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = e.variables, s = e.returnPartialData, c = s === void 0 ? !0 : s, l = e.canonizeResults, u = l === void 0 ? this.config.canonizeResults : l, d = this.config.cache.policies;
    a = R(R({}, Yp(Jb(r))), a);
    var f = da(o), h = new bc(), g = this.executeSelectionSet({
      selectionSet: Gp(r).selectionSet,
      objectOrReference: f,
      enclosingRef: f,
      context: {
        store: n,
        query: r,
        policies: d,
        variables: a,
        varString: vo(a),
        canonizeResults: u,
        fragmentMap: Vu(qu(r)),
        merge: function(b, m) {
          return h.merge(b, m);
        }
      }
    }), v;
    if (g.missing && (v = [new b2(CA(g.missing), g.missing, r, a)], !c))
      throw v[0];
    return {
      result: g.result,
      complete: !v,
      missing: v
    };
  }, t.prototype.isFresh = function(e, n, r, i) {
    if (Ns(i.store) && this.knownResults.get(e) === r) {
      var o = this.executeSelectionSet.peek(r, n, i, this.canon.isKnown(e));
      if (o && e === o.result)
        return !0;
    }
    return !1;
  }, t.prototype.execSelectionSetImpl = function(e) {
    var n = this, r = e.selectionSet, i = e.objectOrReference, o = e.enclosingRef, a = e.context;
    if (It(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(i.__ref, " object")
      };
    var s = a.variables, c = a.policies, l = a.store, u = l.getFieldValue(i, "__typename"), d = {}, f;
    this.config.addTypename && typeof u == "string" && !c.rootIdsByTypename[u] && (d = { __typename: u });
    function h(m, y) {
      var p;
      return m.missing && (f = a.merge(f, (p = {}, p[y] = m.missing, p))), m.result;
    }
    var g = new Set(r.selections);
    g.forEach(function(m) {
      var y, p;
      if (ju(m, s))
        if (hi(m)) {
          var w = c.readField({
            fieldName: m.name.value,
            field: m,
            variables: a.variables,
            from: i
          }, a), _ = So(m);
          w === void 0 ? Jp.added(m) || (f = a.merge(f, (y = {}, y[_] = "Can't find field '".concat(m.name.value, "' on ").concat(It(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), y))) : Array.isArray(w) ? w = h(n.executeSubSelectedArray({
            field: m,
            array: w,
            enclosingRef: o,
            context: a
          }), _) : m.selectionSet ? w != null && (w = h(n.executeSelectionSet({
            selectionSet: m.selectionSet,
            objectOrReference: w,
            enclosingRef: It(w) ? w : o,
            context: a
          }), _)) : a.canonizeResults && (w = n.canon.pass(w)), w !== void 0 && (d = a.merge(d, (p = {}, p[_] = w, p)));
        } else {
          var E = Kp(m, a.fragmentMap);
          E && c.fragmentMatches(E, u) && E.selectionSet.selections.forEach(g.add, g);
        }
    });
    var v = { result: d, missing: f }, b = a.canonizeResults ? this.canon.admit(v) : gh(v);
    return b.result && this.knownResults.set(b.result, r), b;
  }, t.prototype.execSubSelectedArrayImpl = function(e) {
    var n = this, r = e.field, i = e.array, o = e.enclosingRef, a = e.context, s;
    function c(l, u) {
      var d;
      return l.missing && (s = a.merge(s, (d = {}, d[u] = l.missing, d))), l.result;
    }
    return r.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(l, u) {
      return l === null ? null : Array.isArray(l) ? c(n.executeSubSelectedArray({
        field: r,
        array: l,
        enclosingRef: o,
        context: a
      }), u) : r.selectionSet ? c(n.executeSelectionSet({
        selectionSet: r.selectionSet,
        objectOrReference: l,
        enclosingRef: It(l) ? l : o,
        context: a
      }), u) : (__DEV__ && IA(a.store, r, l), l);
    }), {
      result: a.canonizeResults ? this.canon.admit(i) : i,
      missing: s
    };
  }, t;
}();
function CA(t) {
  try {
    JSON.stringify(t, function(e, n) {
      if (typeof n == "string")
        throw n;
      return n;
    });
  } catch (e) {
    return e;
  }
}
function IA(t, e, n) {
  if (!e.selectionSet) {
    var r = /* @__PURE__ */ new Set([n]);
    r.forEach(function(i) {
      on(i) && (__DEV__ ? le(!It(i), "Missing selection set for object of type ".concat(vA(t, i), " returned for query field ").concat(e.name.value)) : le(!It(i), 5), Object.values(i).forEach(r.add, r));
    });
  }
}
var Cn = null, u0 = {}, SA = 1, TA = function() {
  return (
    /** @class */
    function() {
      function t() {
        this.id = [
          "slot",
          SA++,
          Date.now(),
          Math.random().toString(36).slice(2)
        ].join(":");
      }
      return t.prototype.hasValue = function() {
        for (var e = Cn; e; e = e.parent)
          if (this.id in e.slots) {
            var n = e.slots[this.id];
            if (n === u0)
              break;
            return e !== Cn && (Cn.slots[this.id] = n), !0;
          }
        return Cn && (Cn.slots[this.id] = u0), !1;
      }, t.prototype.getValue = function() {
        if (this.hasValue())
          return Cn.slots[this.id];
      }, t.prototype.withValue = function(e, n, r, i) {
        var o, a = (o = {
          __proto__: null
        }, o[this.id] = e, o), s = Cn;
        Cn = { parent: s, slots: a };
        try {
          return n.apply(i, r);
        } finally {
          Cn = s;
        }
      }, t.bind = function(e) {
        var n = Cn;
        return function() {
          var r = Cn;
          try {
            return Cn = n, e.apply(this, arguments);
          } finally {
            Cn = r;
          }
        };
      }, t.noContext = function(e, n, r) {
        if (Cn) {
          var i = Cn;
          try {
            return Cn = null, e.apply(r, n);
          } finally {
            Cn = i;
          }
        } else
          return e.apply(r, n);
      }, t;
    }()
  );
}, Kd = "@wry/context:Slot", Wd = Array, ig = Wd[Kd] || function() {
  var t = TA();
  try {
    Object.defineProperty(Wd, Kd, {
      value: Wd[Kd] = t,
      enumerable: !1,
      writable: !1,
      configurable: !1
    });
  } finally {
    return t;
  }
}();
ig.bind;
ig.noContext;
var og = new ig(), d0 = /* @__PURE__ */ new WeakMap();
function Ms(t) {
  var e = d0.get(t);
  return e || d0.set(t, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: y2()
  }), e;
}
function f0(t) {
  Ms(t).vars.forEach(function(e) {
    return e.forgetCache(t);
  });
}
function kA(t) {
  Ms(t).vars.forEach(function(e) {
    return e.attachCache(t);
  });
}
function AA(t) {
  var e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = function(o) {
    if (arguments.length > 0) {
      if (t !== o) {
        t = o, e.forEach(function(c) {
          Ms(c).dep.dirty(r), OA(c);
        });
        var a = Array.from(n);
        n.clear(), a.forEach(function(c) {
          return c(t);
        });
      }
    } else {
      var s = og.getValue();
      s && (i(s), Ms(s).dep(r));
    }
    return t;
  };
  r.onNextChange = function(o) {
    return n.add(o), function() {
      n.delete(o);
    };
  };
  var i = r.attachCache = function(o) {
    return e.add(o), Ms(o).vars.add(r), r;
  };
  return r.forgetCache = function(o) {
    return e.delete(o);
  }, r;
}
function OA(t) {
  t.broadcastWatches && t.broadcastWatches();
}
var h0 = /* @__PURE__ */ Object.create(null);
function ag(t) {
  var e = JSON.stringify(t);
  return h0[e] || (h0[e] = /* @__PURE__ */ Object.create(null));
}
function p0(t) {
  var e = ag(t);
  return e.keyFieldsFn || (e.keyFieldsFn = function(n, r) {
    var i = function(a, s) {
      return r.readField(s, a);
    }, o = r.keyObject = sg(t, function(a) {
      var s = fa(r.storeObject, a, i);
      return s === void 0 && n !== r.storeObject && yn.call(n, a[0]) && (s = fa(n, a, k2)), __DEV__ ? le(s !== void 0, "Missing field '".concat(a.join("."), "' while extracting keyFields from ").concat(JSON.stringify(n))) : le(s !== void 0, 2), s;
    });
    return "".concat(r.typename, ":").concat(JSON.stringify(o));
  });
}
function g0(t) {
  var e = ag(t);
  return e.keyArgsFn || (e.keyArgsFn = function(n, r) {
    var i = r.field, o = r.variables, a = r.fieldName, s = sg(t, function(l) {
      var u = l[0], d = u.charAt(0);
      if (d === "@") {
        if (i && To(i.directives)) {
          var f = u.slice(1), h = i.directives.find(function(m) {
            return m.name.value === f;
          }), g = h && $u(h, o);
          return g && fa(g, l.slice(1));
        }
        return;
      }
      if (d === "$") {
        var v = u.slice(1);
        if (o && yn.call(o, v)) {
          var b = l.slice(0);
          return b[0] = v, fa(o, b);
        }
        return;
      }
      if (n)
        return fa(n, l);
    }), c = JSON.stringify(s);
    return (n || c !== "{}") && (a += ":" + c), a;
  });
}
function sg(t, e) {
  var n = new bc();
  return T2(t).reduce(function(r, i) {
    var o, a = e(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      r = n.merge(r, a);
    }
    return r;
  }, /* @__PURE__ */ Object.create(null));
}
function T2(t) {
  var e = ag(t);
  if (!e.paths) {
    var n = e.paths = [], r = [];
    t.forEach(function(i, o) {
      Array.isArray(i) ? (T2(i).forEach(function(a) {
        return n.push(r.concat(a));
      }), r.length = 0) : (r.push(i), Array.isArray(t[o + 1]) || (n.push(r.slice(0)), r.length = 0));
    });
  }
  return e.paths;
}
function k2(t, e) {
  return t[e];
}
function fa(t, e, n) {
  return n = n || k2, A2(e.reduce(function r(i, o) {
    return Array.isArray(i) ? i.map(function(a) {
      return r(a, o);
    }) : i && n(i, o);
  }, t));
}
function A2(t) {
  return on(t) ? Array.isArray(t) ? t.map(A2) : sg(Object.keys(t).sort(), function(e) {
    return fa(t, e);
  }) : t;
}
Wp.setStringify(vo);
function Sh(t) {
  return t.args !== void 0 ? t.args : t.field ? $u(t.field, t.variables) : null;
}
var xA = function() {
}, m0 = function(t, e) {
  return e.fieldName;
}, v0 = function(t, e, n) {
  var r = n.mergeObjects;
  return r(t, e);
}, y0 = function(t, e) {
  return e;
}, RA = function() {
  function t(e) {
    this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = R({ dataIdFromObject: _2 }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
  }
  return t.prototype.identify = function(e, n) {
    var r, i = this, o = n && (n.typename || ((r = n.storeObject) === null || r === void 0 ? void 0 : r.__typename)) || e.__typename;
    if (o === this.rootTypenamesById.ROOT_QUERY)
      return ["ROOT_QUERY"];
    for (var a = n && n.storeObject || e, s = R(R({}, n), { typename: o, storeObject: a, readField: n && n.readField || function() {
      var f = cg(arguments, a);
      return i.readField(f, {
        store: i.cache.data,
        variables: f.variables
      });
    } }), c, l = o && this.getTypePolicy(o), u = l && l.keyFn || this.config.dataIdFromObject; u; ) {
      var d = u(e, s);
      if (Array.isArray(d))
        u = p0(d);
      else {
        c = d;
        break;
      }
    }
    return c = c ? String(c) : void 0, s.keyObject ? [c, s.keyObject] : [c];
  }, t.prototype.addTypePolicies = function(e) {
    var n = this;
    Object.keys(e).forEach(function(r) {
      var i = e[r], o = i.queryType, a = i.mutationType, s = i.subscriptionType, c = jr(i, ["queryType", "mutationType", "subscriptionType"]);
      o && n.setRootTypename("Query", r), a && n.setRootTypename("Mutation", r), s && n.setRootTypename("Subscription", r), yn.call(n.toBeAdded, r) ? n.toBeAdded[r].push(c) : n.toBeAdded[r] = [c];
    });
  }, t.prototype.updateTypePolicy = function(e, n) {
    var r = this, i = this.getTypePolicy(e), o = n.keyFields, a = n.fields;
    function s(c, l) {
      c.merge = typeof l == "function" ? l : l === !0 ? v0 : l === !1 ? y0 : c.merge;
    }
    s(i, n.merge), i.keyFn = o === !1 ? xA : Array.isArray(o) ? p0(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(c) {
      var l = r.getFieldPolicy(e, c, !0), u = a[c];
      if (typeof u == "function")
        l.read = u;
      else {
        var d = u.keyArgs, f = u.read, h = u.merge;
        l.keyFn = d === !1 ? m0 : Array.isArray(d) ? g0(d) : typeof d == "function" ? d : l.keyFn, typeof f == "function" && (l.read = f), s(l, h);
      }
      l.read && l.merge && (l.keyFn = l.keyFn || m0);
    });
  }, t.prototype.setRootTypename = function(e, n) {
    n === void 0 && (n = e);
    var r = "ROOT_" + e.toUpperCase(), i = this.rootTypenamesById[r];
    n !== i && (__DEV__ ? le(!i || i === e, "Cannot change root ".concat(e, " __typename more than once")) : le(!i || i === e, 3), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[n] = r, this.rootTypenamesById[r] = n);
  }, t.prototype.addPossibleTypes = function(e) {
    var n = this;
    this.usingPossibleTypes = !0, Object.keys(e).forEach(function(r) {
      n.getSupertypeSet(r, !0), e[r].forEach(function(i) {
        n.getSupertypeSet(i, !0).add(r);
        var o = i.match(I2);
        (!o || o[0] !== i) && n.fuzzySubtypes.set(i, new RegExp(i));
      });
    });
  }, t.prototype.getTypePolicy = function(e) {
    var n = this;
    if (!yn.call(this.typePolicies, e)) {
      var r = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
      r.fields = /* @__PURE__ */ Object.create(null);
      var i = this.supertypeMap.get(e);
      i && i.size && i.forEach(function(a) {
        var s = n.getTypePolicy(a), c = s.fields, l = jr(s, ["fields"]);
        Object.assign(r, l), Object.assign(r.fields, c);
      });
    }
    var o = this.toBeAdded[e];
    return o && o.length && o.splice(0).forEach(function(a) {
      n.updateTypePolicy(e, a);
    }), this.typePolicies[e];
  }, t.prototype.getFieldPolicy = function(e, n, r) {
    if (e) {
      var i = this.getTypePolicy(e).fields;
      return i[n] || r && (i[n] = /* @__PURE__ */ Object.create(null));
    }
  }, t.prototype.getSupertypeSet = function(e, n) {
    var r = this.supertypeMap.get(e);
    return !r && n && this.supertypeMap.set(e, r = /* @__PURE__ */ new Set()), r;
  }, t.prototype.fragmentMatches = function(e, n, r, i) {
    var o = this;
    if (!e.typeCondition)
      return !0;
    if (!n)
      return !1;
    var a = e.typeCondition.name.value;
    if (n === a)
      return !0;
    if (this.usingPossibleTypes && this.supertypeMap.has(a))
      for (var s = this.getSupertypeSet(n, !0), c = [s], l = function(g) {
        var v = o.getSupertypeSet(g, !1);
        v && v.size && c.indexOf(v) < 0 && c.push(v);
      }, u = !!(r && this.fuzzySubtypes.size), d = !1, f = 0; f < c.length; ++f) {
        var h = c[f];
        if (h.has(a))
          return s.has(a) || (d && __DEV__ && le.warn("Inferring subtype ".concat(n, " of supertype ").concat(a)), s.add(a)), !0;
        h.forEach(l), u && f === c.length - 1 && _h(e.selectionSet, r, i) && (u = !1, d = !0, this.fuzzySubtypes.forEach(function(g, v) {
          var b = n.match(g);
          b && b[0] === n && l(v);
        }));
      }
    return !1;
  }, t.prototype.hasKeyArgs = function(e, n) {
    var r = this.getFieldPolicy(e, n, !1);
    return !!(r && r.keyFn);
  }, t.prototype.getStoreFieldName = function(e) {
    var n = e.typename, r = e.fieldName, i = this.getFieldPolicy(n, r, !1), o, a = i && i.keyFn;
    if (a && n)
      for (var s = {
        typename: n,
        fieldName: r,
        field: e.field || null,
        variables: e.variables
      }, c = Sh(e); a; ) {
        var l = a(c, s);
        if (Array.isArray(l))
          a = g0(l);
        else {
          o = l || r;
          break;
        }
      }
    return o === void 0 && (o = e.field ? X6(e.field, e.variables) : Wp(r, Sh(e))), o === !1 ? r : r === ji(o) ? o : r + ":" + o;
  }, t.prototype.readField = function(e, n) {
    var r = e.from;
    if (r) {
      var i = e.field || e.fieldName;
      if (i) {
        if (e.typename === void 0) {
          var o = n.store.getFieldValue(r, "__typename");
          o && (e.typename = o);
        }
        var a = this.getStoreFieldName(e), s = ji(a), c = n.store.getFieldValue(r, a), l = this.getFieldPolicy(e.typename, s, !1), u = l && l.read;
        if (u) {
          var d = w0(this, r, e, n, n.store.getStorage(It(r) ? r.__ref : r, a));
          return og.withValue(this.cache, u, [c, d]);
        }
        return c;
      }
    }
  }, t.prototype.getReadFunction = function(e, n) {
    var r = this.getFieldPolicy(e, n, !1);
    return r && r.read;
  }, t.prototype.getMergeFunction = function(e, n, r) {
    var i = this.getFieldPolicy(e, n, !1), o = i && i.merge;
    return !o && r && (i = this.getTypePolicy(r), o = i && i.merge), o;
  }, t.prototype.runMergeFunction = function(e, n, r, i, o) {
    var a = r.field, s = r.typename, c = r.merge;
    return c === v0 ? O2(i.store)(e, n) : c === y0 ? n : (i.overwrite && (e = void 0), c(e, n, w0(this, void 0, { typename: s, fieldName: a.name.value, field: a, variables: i.variables }, i, o || /* @__PURE__ */ Object.create(null))));
  }, t;
}();
function w0(t, e, n, r, i) {
  var o = t.getStoreFieldName(n), a = ji(o), s = n.variables || r.variables, c = r.store, l = c.toReference, u = c.canRead;
  return {
    args: Sh(n),
    field: n.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: It,
    toReference: l,
    storage: i,
    cache: t.cache,
    canRead: u,
    readField: function() {
      return t.readField(cg(arguments, e, r), r);
    },
    mergeObjects: O2(r.store)
  };
}
function cg(t, e, n) {
  var r = t[0], i = t[1], o = t.length, a;
  return typeof r == "string" ? a = {
    fieldName: r,
    from: o > 1 ? i : e
  } : (a = R({}, r), yn.call(a, "from") || (a.from = e)), __DEV__ && a.from === void 0 && __DEV__ && le.warn("Undefined 'from' passed to readField with arguments ".concat(I5(Array.from(t)))), a.variables === void 0 && (a.variables = n), a;
}
function O2(t) {
  return function(n, r) {
    if (Array.isArray(n) || Array.isArray(r))
      throw __DEV__ ? new Mt("Cannot automatically merge arrays") : new Mt(4);
    if (on(n) && on(r)) {
      var i = t.getFieldValue(n, "__typename"), o = t.getFieldValue(r, "__typename"), a = i && o && i !== o;
      if (a)
        return r;
      if (It(n) && ra(r))
        return t.merge(n.__ref, r), n;
      if (ra(n) && It(r))
        return t.merge(n, r.__ref), r;
      if (ra(n) && ra(r))
        return R(R({}, n), r);
    }
    return r;
  };
}
function Gd(t, e, n) {
  var r = "".concat(e).concat(n), i = t.flavors.get(r);
  return i || t.flavors.set(r, i = t.clientOnly === e && t.deferred === n ? t : R(R({}, t), { clientOnly: e, deferred: n })), i;
}
var NA = function() {
  function t(e, n) {
    this.cache = e, this.reader = n;
  }
  return t.prototype.writeToStore = function(e, n) {
    var r = this, i = n.query, o = n.result, a = n.dataId, s = n.variables, c = n.overwrite, l = wc(i), u = yA();
    s = R(R({}, Yp(l)), s);
    var d = {
      store: e,
      written: /* @__PURE__ */ Object.create(null),
      merge: function(h, g) {
        return u.merge(h, g);
      },
      variables: s,
      varString: vo(s),
      fragmentMap: Vu(qu(i)),
      overwrite: !!c,
      incomingById: /* @__PURE__ */ new Map(),
      clientOnly: !1,
      deferred: !1,
      flavors: /* @__PURE__ */ new Map()
    }, f = this.processSelectionSet({
      result: o || /* @__PURE__ */ Object.create(null),
      dataId: a,
      selectionSet: l.selectionSet,
      mergeTree: { map: /* @__PURE__ */ new Map() },
      context: d
    });
    if (!It(f))
      throw __DEV__ ? new Mt("Could not identify object ".concat(JSON.stringify(o))) : new Mt(6);
    return d.incomingById.forEach(function(h, g) {
      var v = h.storeObject, b = h.mergeTree, m = h.fieldNodeSet, y = da(g);
      if (b && b.map.size) {
        var p = r.applyMerges(b, y, v, d);
        if (It(p))
          return;
        v = p;
      }
      if (__DEV__ && !d.overwrite) {
        var w = /* @__PURE__ */ Object.create(null);
        m.forEach(function(S) {
          S.selectionSet && (w[S.name.value] = !0);
        });
        var _ = function(S) {
          return w[ji(S)] === !0;
        }, E = function(S) {
          var T = b && b.map.get(S);
          return !!(T && T.info && T.info.merge);
        };
        Object.keys(v).forEach(function(S) {
          _(S) && !E(S) && MA(y, v, S, d.store);
        });
      }
      e.merge(g, v);
    }), e.retain(f.__ref), f;
  }, t.prototype.processSelectionSet = function(e) {
    var n = this, r = e.dataId, i = e.result, o = e.selectionSet, a = e.context, s = e.mergeTree, c = this.cache.policies, l = /* @__PURE__ */ Object.create(null), u = r && c.rootTypenamesById[r] || uh(i, o, a.fragmentMap) || r && a.store.get(r, "__typename");
    typeof u == "string" && (l.__typename = u);
    var d = function() {
      var p = cg(arguments, l, a.variables);
      if (It(p.from)) {
        var w = a.incomingById.get(p.from.__ref);
        if (w) {
          var _ = c.readField(R(R({}, p), { from: w.storeObject }), a);
          if (_ !== void 0)
            return _;
        }
      }
      return c.readField(p, a);
    }, f = /* @__PURE__ */ new Set();
    this.flattenFields(o, i, a, u).forEach(function(p, w) {
      var _, E = So(w), S = i[E];
      if (f.add(w), S !== void 0) {
        var T = c.getStoreFieldName({
          typename: u,
          fieldName: w.name.value,
          field: w,
          variables: p.variables
        }), x = b0(s, T), A = n.processFieldValue(S, w, w.selectionSet ? Gd(p, !1, !1) : p, x), N = void 0;
        w.selectionSet && (It(A) || ra(A)) && (N = d("__typename", A));
        var F = c.getMergeFunction(u, w.name.value, N);
        F ? x.info = {
          field: w,
          typename: u,
          merge: F
        } : _0(s, T), l = p.merge(l, (_ = {}, _[T] = A, _));
      } else
        __DEV__ && !p.clientOnly && !p.deferred && !Jp.added(w) && !c.getReadFunction(u, w.name.value) && __DEV__ && le.error("Missing field '".concat(So(w), "' while writing result ").concat(JSON.stringify(i, null, 2)).substring(0, 1e3));
    });
    try {
      var h = c.identify(i, {
        typename: u,
        selectionSet: o,
        fragmentMap: a.fragmentMap,
        storeObject: l,
        readField: d
      }), g = h[0], v = h[1];
      r = r || g, v && (l = a.merge(l, v));
    } catch (p) {
      if (!r)
        throw p;
    }
    if (typeof r == "string") {
      var b = da(r), m = a.written[r] || (a.written[r] = []);
      if (m.indexOf(o) >= 0 || (m.push(o), this.reader && this.reader.isFresh(i, b, o, a)))
        return b;
      var y = a.incomingById.get(r);
      return y ? (y.storeObject = a.merge(y.storeObject, l), y.mergeTree = Th(y.mergeTree, s), f.forEach(function(p) {
        return y.fieldNodeSet.add(p);
      })) : a.incomingById.set(r, {
        storeObject: l,
        mergeTree: Xl(s) ? void 0 : s,
        fieldNodeSet: f
      }), b;
    }
    return l;
  }, t.prototype.processFieldValue = function(e, n, r, i) {
    var o = this;
    return !n.selectionSet || e === null ? __DEV__ ? o2(e) : e : Array.isArray(e) ? e.map(function(a, s) {
      var c = o.processFieldValue(a, n, r, b0(i, s));
      return _0(i, s), c;
    }) : this.processSelectionSet({
      result: e,
      selectionSet: n.selectionSet,
      context: r,
      mergeTree: i
    });
  }, t.prototype.flattenFields = function(e, n, r, i) {
    i === void 0 && (i = uh(n, e, r.fragmentMap));
    var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new _c(!1);
    return function c(l, u) {
      var d = s.lookup(l, u.clientOnly, u.deferred);
      d.visited || (d.visited = !0, l.selections.forEach(function(f) {
        if (ju(f, r.variables)) {
          var h = u.clientOnly, g = u.deferred;
          if (!(h && g) && To(f.directives) && f.directives.forEach(function(m) {
            var y = m.name.value;
            if (y === "client" && (h = !0), y === "defer") {
              var p = $u(m, r.variables);
              (!p || p.if !== !1) && (g = !0);
            }
          }), hi(f)) {
            var v = o.get(f);
            v && (h = h && v.clientOnly, g = g && v.deferred), o.set(f, Gd(r, h, g));
          } else {
            var b = Kp(f, r.fragmentMap);
            b && a.fragmentMatches(b, i, n, r.variables) && c(b.selectionSet, Gd(r, h, g));
          }
        }
      }));
    }(e, r), o;
  }, t.prototype.applyMerges = function(e, n, r, i, o) {
    var a, s = this;
    if (e.map.size && !It(r)) {
      var c = !Array.isArray(r) && (It(n) || ra(n)) ? n : void 0, l = r;
      c && !o && (o = [It(c) ? c.__ref : c]);
      var u, d = function(f, h) {
        return Array.isArray(f) ? typeof h == "number" ? f[h] : void 0 : i.store.getFieldValue(f, String(h));
      };
      e.map.forEach(function(f, h) {
        var g = d(c, h), v = d(l, h);
        if (v !== void 0) {
          o && o.push(h);
          var b = s.applyMerges(f, g, v, i, o);
          b !== v && (u = u || /* @__PURE__ */ new Map(), u.set(h, b)), o && le(o.pop() === h);
        }
      }), u && (r = Array.isArray(l) ? l.slice(0) : R({}, l), u.forEach(function(f, h) {
        r[h] = f;
      }));
    }
    return e.info ? this.cache.policies.runMergeFunction(n, r, e.info, i, o && (a = i.store).getStorage.apply(a, o)) : r;
  }, t;
}(), x2 = [];
function b0(t, e) {
  var n = t.map;
  return n.has(e) || n.set(e, x2.pop() || { map: /* @__PURE__ */ new Map() }), n.get(e);
}
function Th(t, e) {
  if (t === e || !e || Xl(e))
    return t;
  if (!t || Xl(t))
    return e;
  var n = t.info && e.info ? R(R({}, t.info), e.info) : t.info || e.info, r = t.map.size && e.map.size, i = r ? /* @__PURE__ */ new Map() : t.map.size ? t.map : e.map, o = { info: n, map: i };
  if (r) {
    var a = new Set(e.map.keys());
    t.map.forEach(function(s, c) {
      o.map.set(c, Th(s, e.map.get(c))), a.delete(c);
    }), a.forEach(function(s) {
      o.map.set(s, Th(e.map.get(s), t.map.get(s)));
    });
  }
  return o;
}
function Xl(t) {
  return !t || !(t.info || t.map.size);
}
function _0(t, e) {
  var n = t.map, r = n.get(e);
  r && Xl(r) && (x2.push(r), n.delete(e));
}
var E0 = /* @__PURE__ */ new Set();
function MA(t, e, n, r) {
  var i = function(d) {
    var f = r.getFieldValue(d, n);
    return typeof f == "object" && f;
  }, o = i(t);
  if (o) {
    var a = i(e);
    if (a && !It(o) && !wn(o, a) && !Object.keys(o).every(function(d) {
      return r.getFieldValue(a, d) !== void 0;
    })) {
      var s = r.getFieldValue(t, "__typename") || r.getFieldValue(e, "__typename"), c = ji(n), l = "".concat(s, ".").concat(c);
      if (!E0.has(l)) {
        E0.add(l);
        var u = [];
        !Array.isArray(o) && !Array.isArray(a) && [o, a].forEach(function(d) {
          var f = r.getFieldValue(d, "__typename");
          typeof f == "string" && !u.includes(f) && u.push(f);
        }), __DEV__ && le.warn("Cache data may be lost when replacing the ".concat(c, " field of a ").concat(s, ` object.

To address this problem (which is not a bug in Apollo Client), `).concat(u.length ? "either ensure all objects of type " + u.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(l, ` field, so InMemoryCache can safely merge these objects:

  existing: `).concat(JSON.stringify(o).slice(0, 1e3), `
  incoming: `).concat(JSON.stringify(a).slice(0, 1e3), `

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`));
      }
    }
  }
}
var PA = function(t) {
  an(e, t);
  function e(n) {
    n === void 0 && (n = {});
    var r = t.call(this) || this;
    return r.watches = /* @__PURE__ */ new Set(), r.typenameDocumentCache = /* @__PURE__ */ new Map(), r.makeVar = AA, r.txCount = 0, r.config = mA(n), r.addTypename = !!r.config.addTypename, r.policies = new RA({
      cache: r,
      dataIdFromObject: r.config.dataIdFromObject,
      possibleTypes: r.config.possibleTypes,
      typePolicies: r.config.typePolicies
    }), r.init(), r;
  }
  return e.prototype.init = function() {
    var n = this.data = new Js.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = n.stump, this.resetResultCache();
  }, e.prototype.resetResultCache = function(n) {
    var r = this, i = this.storeReader;
    this.storeWriter = new NA(this, this.storeReader = new EA({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: C2(this.config),
      canon: n ? void 0 : i && i.canon
    })), this.maybeBroadcastWatch = Zl(function(o, a) {
      return r.broadcastWatch(o, a);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function(o) {
        var a = o.optimistic ? r.optimisticData : r.data;
        if (Ns(a)) {
          var s = o.optimistic, c = o.rootId, l = o.variables;
          return a.makeCacheKey(o.query, o.callback, vo({ optimistic: s, rootId: c, variables: l }));
        }
      }
    }), (/* @__PURE__ */ new Set([
      this.data.group,
      this.optimisticData.group
    ])).forEach(function(o) {
      return o.resetCaching();
    });
  }, e.prototype.restore = function(n) {
    return this.init(), n && this.data.replace(n), this;
  }, e.prototype.extract = function(n) {
    return n === void 0 && (n = !1), (n ? this.optimisticData : this.data).extract();
  }, e.prototype.read = function(n) {
    var r = n.returnPartialData, i = r === void 0 ? !1 : r;
    try {
      return this.storeReader.diffQueryAgainstStore(R(R({}, n), { store: n.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
    } catch (o) {
      if (o instanceof b2)
        return null;
      throw o;
    }
  }, e.prototype.write = function(n) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, n);
    } finally {
      !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.modify = function(n) {
    if (yn.call(n, "id") && !n.id)
      return !1;
    var r = n.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, r.modify(n.id || "ROOT_QUERY", n.fields);
    } finally {
      !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.diff = function(n) {
    return this.storeReader.diffQueryAgainstStore(R(R({}, n), { store: n.optimistic ? this.optimisticData : this.data, rootId: n.id || "ROOT_QUERY", config: this.config }));
  }, e.prototype.watch = function(n) {
    var r = this;
    return this.watches.size || kA(this), this.watches.add(n), n.immediate && this.maybeBroadcastWatch(n), function() {
      r.watches.delete(n) && !r.watches.size && f0(r), r.maybeBroadcastWatch.forget(n);
    };
  }, e.prototype.gc = function(n) {
    vo.reset();
    var r = this.optimisticData.gc();
    return n && !this.txCount && (n.resetResultCache ? this.resetResultCache(n.resetResultIdentities) : n.resetResultIdentities && this.storeReader.resetCanon()), r;
  }, e.prototype.retain = function(n, r) {
    return (r ? this.optimisticData : this.data).retain(n);
  }, e.prototype.release = function(n, r) {
    return (r ? this.optimisticData : this.data).release(n);
  }, e.prototype.identify = function(n) {
    if (It(n))
      return n.__ref;
    try {
      return this.policies.identify(n)[0];
    } catch (r) {
      __DEV__ && le.warn(r);
    }
  }, e.prototype.evict = function(n) {
    if (!n.id) {
      if (yn.call(n, "id"))
        return !1;
      n = R(R({}, n), { id: "ROOT_QUERY" });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(n, this.data);
    } finally {
      !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
    }
  }, e.prototype.reset = function(n) {
    var r = this;
    return this.init(), vo.reset(), n && n.discardWatches ? (this.watches.forEach(function(i) {
      return r.maybeBroadcastWatch.forget(i);
    }), this.watches.clear(), f0(this)) : this.broadcastWatches(), Promise.resolve();
  }, e.prototype.removeOptimistic = function(n) {
    var r = this.optimisticData.removeLayer(n);
    r !== this.optimisticData && (this.optimisticData = r, this.broadcastWatches());
  }, e.prototype.batch = function(n) {
    var r = this, i = n.update, o = n.optimistic, a = o === void 0 ? !0 : o, s = n.removeOptimistic, c = n.onWatchUpdated, l, u = function(f) {
      var h = r, g = h.data, v = h.optimisticData;
      ++r.txCount, f && (r.data = r.optimisticData = f);
      try {
        return l = i(r);
      } finally {
        --r.txCount, r.data = g, r.optimisticData = v;
      }
    }, d = /* @__PURE__ */ new Set();
    return c && !this.txCount && this.broadcastWatches(R(R({}, n), { onWatchUpdated: function(f) {
      return d.add(f), !1;
    } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, u) : a === !1 ? u(this.data) : u(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), c && d.size ? (this.broadcastWatches(R(R({}, n), { onWatchUpdated: function(f, h) {
      var g = c.call(this, f, h);
      return g !== !1 && d.delete(f), g;
    } })), d.size && d.forEach(function(f) {
      return r.maybeBroadcastWatch.dirty(f);
    })) : this.broadcastWatches(n), l;
  }, e.prototype.performTransaction = function(n, r) {
    return this.batch({
      update: n,
      optimistic: r || r !== null
    });
  }, e.prototype.transformDocument = function(n) {
    if (this.addTypename) {
      var r = this.typenameDocumentCache.get(n);
      return r || (r = Jp(n), this.typenameDocumentCache.set(n, r), this.typenameDocumentCache.set(r, r)), r;
    }
    return n;
  }, e.prototype.broadcastWatches = function(n) {
    var r = this;
    this.txCount || this.watches.forEach(function(i) {
      return r.maybeBroadcastWatch(i, n);
    });
  }, e.prototype.broadcastWatch = function(n, r) {
    var i = n.lastDiff, o = this.diff(n);
    r && (n.optimistic && typeof r.optimistic == "string" && (o.fromOptimisticTransaction = !0), r.onWatchUpdated && r.onWatchUpdated.call(this, n, o, i) === !1) || (!i || !wn(i.result, o.result)) && n.callback(n.lastDiff = o, i);
  }, e;
}(gA);
function DA(t) {
  return t.hasOwnProperty("graphQLErrors");
}
var LA = function(t) {
  var e = "";
  if (To(t.graphQLErrors) || To(t.clientErrors)) {
    var n = (t.graphQLErrors || []).concat(t.clientErrors || []);
    n.forEach(function(r) {
      var i = r ? r.message : "Error message not found.";
      e += "".concat(i, `
`);
    });
  }
  return t.networkError && (e += "".concat(t.networkError.message, `
`)), e = e.replace(/\n$/, ""), e;
}, Bo = function(t) {
  an(e, t);
  function e(n) {
    var r = n.graphQLErrors, i = n.clientErrors, o = n.networkError, a = n.errorMessage, s = n.extraInfo, c = t.call(this, a) || this;
    return c.graphQLErrors = r || [], c.clientErrors = i || [], c.networkError = o || null, c.message = a || LA(c), c.extraInfo = s, c.__proto__ = e.prototype, c;
  }
  return e;
}(Error), qt;
(function(t) {
  t[t.loading = 1] = "loading", t[t.setVariables = 2] = "setVariables", t[t.fetchMore = 3] = "fetchMore", t[t.refetch = 4] = "refetch", t[t.poll = 6] = "poll", t[t.ready = 7] = "ready", t[t.error = 8] = "error";
})(qt || (qt = {}));
function Zs(t) {
  return t ? t < 7 : !1;
}
var FA = Object.assign, UA = Object.hasOwnProperty, C0 = !1, kh = function(t) {
  an(e, t);
  function e(n) {
    var r = n.queryManager, i = n.queryInfo, o = n.options, a = t.call(this, function(c) {
      try {
        var l = c._subscription._observer;
        l && !l.error && (l.error = HA);
      } catch {
      }
      var u = !a.observers.size;
      a.observers.add(c);
      var d = a.last;
      return d && d.error ? c.error && c.error(d.error) : d && d.result && c.next && c.next(d.result), u && a.reobserve().catch(function() {
      }), function() {
        a.observers.delete(c) && !a.observers.size && a.tearDownQuery();
      };
    }) || this;
    a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.isTornDown = !1, a.options = o, a.queryId = i.queryId || r.generateQueryId();
    var s = wc(o.query);
    return a.queryName = s && s.name && s.name.value, a.initialFetchPolicy = o.fetchPolicy || "cache-first", a.queryManager = r, a.queryInfo = i, a;
  }
  return Object.defineProperty(e.prototype, "variables", {
    get: function() {
      return this.options.variables;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.result = function() {
    var n = this;
    return new Promise(function(r, i) {
      var o = {
        next: function(s) {
          r(s), n.observers.delete(o), n.observers.size || n.queryManager.removeQuery(n.queryId), setTimeout(function() {
            a.unsubscribe();
          }, 0);
        },
        error: i
      }, a = n.subscribe(o);
    });
  }, e.prototype.getCurrentResult = function(n) {
    n === void 0 && (n = !0);
    var r = this.getLastResult(!0), i = this.queryInfo.networkStatus || r && r.networkStatus || qt.ready, o = R(R({}, r), { loading: Zs(i), networkStatus: i }), a = this.options.fetchPolicy, s = a === void 0 ? "cache-first" : a;
    if (!(s === "network-only" || s === "no-cache" || s === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers)) {
      var c = this.queryInfo.getDiff();
      (c.complete || this.options.returnPartialData) && (o.data = c.result), wn(o.data, {}) && (o.data = void 0), c.complete ? (delete o.partial, c.complete && o.networkStatus === qt.loading && (s === "cache-first" || s === "cache-only") && (o.networkStatus = qt.ready, o.loading = !1)) : o.partial = !0, __DEV__ && !c.complete && !this.options.partialRefetch && !o.loading && !o.data && !o.error && R2(c.missing);
    }
    return n && this.updateLastResult(o), o;
  }, e.prototype.isDifferentFromLastResult = function(n) {
    return !this.last || !wn(this.last.result, n);
  }, e.prototype.getLast = function(n, r) {
    var i = this.last;
    if (i && i[n] && (!r || wn(i.variables, this.variables)))
      return i[n];
  }, e.prototype.getLastResult = function(n) {
    return this.getLast("result", n);
  }, e.prototype.getLastError = function(n) {
    return this.getLast("error", n);
  }, e.prototype.resetLastResults = function() {
    delete this.last, this.isTornDown = !1;
  }, e.prototype.resetQueryStoreErrors = function() {
    this.queryManager.resetErrors(this.queryId);
  }, e.prototype.refetch = function(n) {
    var r, i = {
      pollInterval: 0
    }, o = this.options.fetchPolicy;
    if (o === "standby" || o === "cache-and-network" ? i.fetchPolicy = o : o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", __DEV__ && n && UA.call(n, "variables")) {
      var a = Jb(this.options.query), s = a.variableDefinitions;
      (!s || !s.some(function(c) {
        return c.variable.name.value === "variables";
      })) && __DEV__ && le.warn("Called refetch(".concat(JSON.stringify(n), ") for query ").concat(((r = a.name) === null || r === void 0 ? void 0 : r.value) || JSON.stringify(a), `, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`));
    }
    return n && !wn(this.options.variables, n) && (i.variables = this.options.variables = R(R({}, this.options.variables), n)), this.queryInfo.resetLastWrite(), this.reobserve(i, qt.refetch);
  }, e.prototype.fetchMore = function(n) {
    var r = this, i = R(R({}, n.query ? n : R(R(R({}, this.options), n), { variables: R(R({}, this.options.variables), n.variables) })), { fetchPolicy: "no-cache" }), o = this.queryManager.generateQueryId();
    return i.notifyOnNetworkStatusChange && (this.queryInfo.networkStatus = qt.fetchMore, this.observe()), this.queryManager.fetchQuery(o, i, qt.fetchMore).then(function(a) {
      var s = a.data, c = n.updateQuery;
      return c ? (__DEV__ && !C0 && (__DEV__ && le.warn(`The updateQuery callback for fetchMore is deprecated, and will be removed
in the next major version of Apollo Client.

Please convert updateQuery functions to field policies with appropriate
read and merge functions, or use/adapt a helper function (such as
concatPagination, offsetLimitPagination, or relayStylePagination) from
@apollo/client/utilities.

The field policy system handles pagination more effectively than a
hand-written updateQuery function, and you only need to define the policy
once, rather than every time you call fetchMore.`), C0 = !0), r.updateQuery(function(l) {
        return c(l, {
          fetchMoreResult: s,
          variables: i.variables
        });
      })) : r.queryManager.cache.writeQuery({
        query: i.query,
        variables: i.variables,
        data: s
      }), a;
    }).finally(function() {
      r.queryManager.stopQuery(o), r.reobserve();
    });
  }, e.prototype.subscribeToMore = function(n) {
    var r = this, i = this.queryManager.startGraphQLSubscription({
      query: n.document,
      variables: n.variables,
      context: n.context
    }).subscribe({
      next: function(o) {
        var a = n.updateQuery;
        a && r.updateQuery(function(s, c) {
          var l = c.variables;
          return a(s, {
            subscriptionData: o,
            variables: l
          });
        });
      },
      error: function(o) {
        if (n.onError) {
          n.onError(o);
          return;
        }
        __DEV__ && le.error("Unhandled GraphQL subscription error", o);
      }
    });
    return this.subscriptions.add(i), function() {
      r.subscriptions.delete(i) && i.unsubscribe();
    };
  }, e.prototype.setOptions = function(n) {
    return this.reobserve(n);
  }, e.prototype.setVariables = function(n) {
    return wn(this.variables, n) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = n, this.observers.size ? this.reobserve({
      fetchPolicy: this.initialFetchPolicy,
      variables: n
    }, qt.setVariables) : Promise.resolve());
  }, e.prototype.updateQuery = function(n) {
    var r = this.queryManager, i = r.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: !0,
      optimistic: !1
    }).result, o = n(i, {
      variables: this.variables
    });
    o && (r.cache.writeQuery({
      query: this.options.query,
      data: o,
      variables: this.variables
    }), r.broadcastQueries());
  }, e.prototype.startPolling = function(n) {
    this.options.pollInterval = n, this.updatePolling();
  }, e.prototype.stopPolling = function() {
    this.options.pollInterval = 0, this.updatePolling();
  }, e.prototype.fetch = function(n, r) {
    return this.queryManager.setObservableQuery(this), this.queryManager.fetchQueryObservable(this.queryId, n, r);
  }, e.prototype.updatePolling = function() {
    var n = this;
    if (!this.queryManager.ssrMode) {
      var r = this, i = r.pollingInfo, o = r.options.pollInterval;
      if (!o) {
        i && (clearTimeout(i.timeout), delete this.pollingInfo);
        return;
      }
      if (!(i && i.interval === o)) {
        __DEV__ ? le(o, "Attempted to start a polling query without a polling interval.") : le(o, 10);
        var a = i || (this.pollingInfo = {});
        a.interval = o;
        var s = function() {
          n.pollingInfo && (Zs(n.queryInfo.networkStatus) ? c() : n.reobserve({
            fetchPolicy: "network-only"
          }, qt.poll).then(c, c));
        }, c = function() {
          var l = n.pollingInfo;
          l && (clearTimeout(l.timeout), l.timeout = setTimeout(s, l.interval));
        };
        c();
      }
    }
  }, e.prototype.updateLastResult = function(n, r) {
    return r === void 0 && (r = this.variables), this.last = R(R({}, this.last), { result: this.queryManager.assumeImmutableResults ? n : o2(n), variables: r }), To(n.errors) || delete this.last.error, this.last;
  }, e.prototype.reobserve = function(n, r) {
    var i = this;
    this.isTornDown = !1;
    var o = r === qt.refetch || r === qt.fetchMore || r === qt.poll, a = this.options.variables, s = o ? Ys(this.options, n) : FA(this.options, Ys(n));
    o || (this.updatePolling(), n && n.variables && !n.fetchPolicy && !wn(n.variables, a) && (s.fetchPolicy = this.initialFetchPolicy, r === void 0 && (r = qt.setVariables)));
    var c = s.variables && R({}, s.variables), l = this.fetch(s, r), u = {
      next: function(d) {
        i.reportResult(d, c);
      },
      error: function(d) {
        i.reportError(d, c);
      }
    };
    return o || (this.concast && this.observer && this.concast.removeObserver(this.observer, !0), this.concast = l, this.observer = u), l.addObserver(u), l.promise;
  }, e.prototype.observe = function() {
    this.reportResult(this.getCurrentResult(!1), this.variables);
  }, e.prototype.reportResult = function(n, r) {
    (this.getLastError() || this.isDifferentFromLastResult(n)) && (this.updateLastResult(n, r), Rs(this.observers, "next", n));
  }, e.prototype.reportError = function(n, r) {
    var i = R(R({}, this.getLastResult()), { error: n, errors: n.graphQLErrors, networkStatus: qt.error, loading: !1 });
    this.updateLastResult(i, r), Rs(this.observers, "error", this.last.error = n);
  }, e.prototype.hasObservers = function() {
    return this.observers.size > 0;
  }, e.prototype.tearDownQuery = function() {
    this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(n) {
      return n.unsubscribe();
    }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
  }, e;
}(Rt);
s2(kh);
function HA(t) {
  __DEV__ && le.error("Unhandled error", t.message, t.stack);
}
function R2(t) {
  __DEV__ && t && __DEV__ && le.debug("Missing cache result fields: ".concat(JSON.stringify(t)), t);
}
function BA(t) {
  var e = t.fetchPolicy, n = e === void 0 ? "cache-first" : e, r = t.nextFetchPolicy;
  r && (t.fetchPolicy = typeof r == "function" ? r.call(t, n) : r);
}
var N2 = function() {
  function t(e) {
    var n = e.cache, r = e.client, i = e.resolvers, o = e.fragmentMatcher;
    this.cache = n, r && (this.client = r), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
  }
  return t.prototype.addResolvers = function(e) {
    var n = this;
    this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(r) {
      n.resolvers = Bv(n.resolvers, r);
    }) : this.resolvers = Bv(this.resolvers, e);
  }, t.prototype.setResolvers = function(e) {
    this.resolvers = {}, this.addResolvers(e);
  }, t.prototype.getResolvers = function() {
    return this.resolvers || {};
  }, t.prototype.runResolvers = function(e) {
    var n = e.document, r = e.remoteResult, i = e.context, o = e.variables, a = e.onlyRunForcedResolvers, s = a === void 0 ? !1 : a;
    return ke(this, void 0, void 0, function() {
      return Ae(this, function(c) {
        return n ? [2, this.resolveDocument(n, r.data, i, o, this.fragmentMatcher, s).then(function(l) {
          return R(R({}, r), { data: l.result });
        })] : [2, r];
      });
    });
  }, t.prototype.setFragmentMatcher = function(e) {
    this.fragmentMatcher = e;
  }, t.prototype.getFragmentMatcher = function() {
    return this.fragmentMatcher;
  }, t.prototype.clientQuery = function(e) {
    return lh(["client"], e) && this.resolvers ? e : null;
  }, t.prototype.serverQuery = function(e) {
    return l5(e);
  }, t.prototype.prepareContext = function(e) {
    var n = this.cache;
    return R(R({}, e), { cache: n, getCacheKey: function(r) {
      return n.identify(r);
    } });
  }, t.prototype.addExportedVariables = function(e, n, r) {
    return n === void 0 && (n = {}), r === void 0 && (r = {}), ke(this, void 0, void 0, function() {
      return Ae(this, function(i) {
        return e ? [2, this.resolveDocument(e, this.buildRootValueFromCache(e, n) || {}, this.prepareContext(r), n).then(function(o) {
          return R(R({}, n), o.exportedVariables);
        })] : [2, R({}, n)];
      });
    });
  }, t.prototype.shouldForceResolvers = function(e) {
    var n = !1;
    return qr(e, {
      Directive: {
        enter: function(r) {
          if (r.name.value === "client" && r.arguments && (n = r.arguments.some(function(i) {
            return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
          }), n))
            return Yb;
        }
      }
    }), n;
  }, t.prototype.buildRootValueFromCache = function(e, n) {
    return this.cache.diff({
      query: c5(e),
      variables: n,
      returnPartialData: !0,
      optimistic: !1
    }).result;
  }, t.prototype.resolveDocument = function(e, n, r, i, o, a) {
    return r === void 0 && (r = {}), i === void 0 && (i = {}), o === void 0 && (o = function() {
      return !0;
    }), a === void 0 && (a = !1), ke(this, void 0, void 0, function() {
      var s, c, l, u, d, f, h, g, v;
      return Ae(this, function(b) {
        return s = Gp(e), c = qu(e), l = Vu(c), u = s.operation, d = u ? u.charAt(0).toUpperCase() + u.slice(1) : "Query", f = this, h = f.cache, g = f.client, v = {
          fragmentMap: l,
          context: R(R({}, r), { cache: h, client: g }),
          variables: i,
          fragmentMatcher: o,
          defaultOperationType: d,
          exportedVariables: {},
          onlyRunForcedResolvers: a
        }, [2, this.resolveSelectionSet(s.selectionSet, n, v).then(function(m) {
          return {
            result: m,
            exportedVariables: v.exportedVariables
          };
        })];
      });
    });
  }, t.prototype.resolveSelectionSet = function(e, n, r) {
    return ke(this, void 0, void 0, function() {
      var i, o, a, s, c, l = this;
      return Ae(this, function(u) {
        return i = r.fragmentMap, o = r.context, a = r.variables, s = [n], c = function(d) {
          return ke(l, void 0, void 0, function() {
            var f, h;
            return Ae(this, function(g) {
              return ju(d, a) ? hi(d) ? [2, this.resolveField(d, n, r).then(function(v) {
                var b;
                typeof v < "u" && s.push((b = {}, b[So(d)] = v, b));
              })] : (Qb(d) ? f = d : (f = i[d.name.value], __DEV__ ? le(f, "No fragment named ".concat(d.name.value)) : le(f, 9)), f && f.typeCondition && (h = f.typeCondition.name.value, r.fragmentMatcher(n, h, o)) ? [2, this.resolveSelectionSet(f.selectionSet, n, r).then(function(v) {
                s.push(v);
              })] : [2]) : [2];
            });
          });
        }, [2, Promise.all(e.selections.map(c)).then(function() {
          return t2(s);
        })];
      });
    });
  }, t.prototype.resolveField = function(e, n, r) {
    return ke(this, void 0, void 0, function() {
      var i, o, a, s, c, l, u, d, f, h = this;
      return Ae(this, function(g) {
        return i = r.variables, o = e.name.value, a = So(e), s = o !== a, c = n[a] || n[o], l = Promise.resolve(c), (!r.onlyRunForcedResolvers || this.shouldForceResolvers(e)) && (u = n.__typename || r.defaultOperationType, d = this.resolvers && this.resolvers[u], d && (f = d[s ? o : a], f && (l = Promise.resolve(og.withValue(this.cache, f, [
          n,
          $u(e, i),
          r.context,
          { field: e, fragmentMap: r.fragmentMap }
        ]))))), [2, l.then(function(v) {
          if (v === void 0 && (v = c), e.directives && e.directives.forEach(function(b) {
            b.name.value === "export" && b.arguments && b.arguments.forEach(function(m) {
              m.name.value === "as" && m.value.kind === "StringValue" && (r.exportedVariables[m.value.value] = v);
            });
          }), !e.selectionSet || v == null)
            return v;
          if (Array.isArray(v))
            return h.resolveSubSelectedArray(e, v, r);
          if (e.selectionSet)
            return h.resolveSelectionSet(e.selectionSet, v, r);
        })];
      });
    });
  }, t.prototype.resolveSubSelectedArray = function(e, n, r) {
    var i = this;
    return Promise.all(n.map(function(o) {
      if (o === null)
        return null;
      if (Array.isArray(o))
        return i.resolveSubSelectedArray(e, o, r);
      if (e.selectionSet)
        return i.resolveSelectionSet(e.selectionSet, o, r);
    }));
  }, t;
}(), ia = new (Do ? WeakMap : Map)();
function Yd(t, e) {
  var n = t[e];
  typeof n == "function" && (t[e] = function() {
    return ia.set(t, (ia.get(t) + 1) % 1e15), n.apply(this, arguments);
  });
}
function I0(t) {
  t.notifyTimeout && (clearTimeout(t.notifyTimeout), t.notifyTimeout = void 0);
}
var Qd = function() {
  function t(e, n) {
    n === void 0 && (n = e.generateQueryId()), this.queryId = n, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.subscriptions = /* @__PURE__ */ new Set(), this.stopped = !1, this.dirty = !1, this.observableQuery = null;
    var r = this.cache = e.cache;
    ia.has(r) || (ia.set(r, 0), Yd(r, "evict"), Yd(r, "modify"), Yd(r, "reset"));
  }
  return t.prototype.init = function(e) {
    var n = e.networkStatus || qt.loading;
    return this.variables && this.networkStatus !== qt.loading && !wn(this.variables, e.variables) && (n = qt.setVariables), wn(e.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
      document: e.document,
      variables: e.variables,
      networkError: null,
      graphQLErrors: this.graphQLErrors || [],
      networkStatus: n
    }), e.observableQuery && this.setObservableQuery(e.observableQuery), e.lastRequestId && (this.lastRequestId = e.lastRequestId), this;
  }, t.prototype.reset = function() {
    I0(this), this.lastDiff = void 0, this.dirty = !1;
  }, t.prototype.getDiff = function(e) {
    e === void 0 && (e = this.variables);
    var n = this.getDiffOptions(e);
    if (this.lastDiff && wn(n, this.lastDiff.options))
      return this.lastDiff.diff;
    this.updateWatch(this.variables = e);
    var r = this.observableQuery;
    if (r && r.options.fetchPolicy === "no-cache")
      return { complete: !1 };
    var i = this.cache.diff(n);
    return this.updateLastDiff(i, n), i;
  }, t.prototype.updateLastDiff = function(e, n) {
    this.lastDiff = e ? {
      diff: e,
      options: n || this.getDiffOptions()
    } : void 0;
  }, t.prototype.getDiffOptions = function(e) {
    var n;
    return e === void 0 && (e = this.variables), {
      query: this.document,
      variables: e,
      returnPartialData: !0,
      optimistic: !0,
      canonizeResults: (n = this.observableQuery) === null || n === void 0 ? void 0 : n.options.canonizeResults
    };
  }, t.prototype.setDiff = function(e) {
    var n = this, r = this.lastDiff && this.lastDiff.diff;
    this.updateLastDiff(e), !this.dirty && !wn(r && r.result, e && e.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
      return n.notify();
    }, 0)));
  }, t.prototype.setObservableQuery = function(e) {
    var n = this;
    e !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = e, e ? (e.queryInfo = this, this.listeners.add(this.oqListener = function() {
      n.getDiff().fromOptimisticTransaction ? e.observe() : e.reobserve();
    })) : delete this.oqListener);
  }, t.prototype.notify = function() {
    var e = this;
    I0(this), this.shouldNotify() && this.listeners.forEach(function(n) {
      return n(e);
    }), this.dirty = !1;
  }, t.prototype.shouldNotify = function() {
    if (!this.dirty || !this.listeners.size)
      return !1;
    if (Zs(this.networkStatus) && this.observableQuery) {
      var e = this.observableQuery.options.fetchPolicy;
      if (e !== "cache-only" && e !== "cache-and-network")
        return !1;
    }
    return !0;
  }, t.prototype.stop = function() {
    if (!this.stopped) {
      this.stopped = !0, this.reset(), this.cancel(), this.cancel = t.prototype.cancel, this.subscriptions.forEach(function(n) {
        return n.unsubscribe();
      });
      var e = this.observableQuery;
      e && e.stopPolling();
    }
  }, t.prototype.cancel = function() {
  }, t.prototype.updateWatch = function(e) {
    var n = this;
    e === void 0 && (e = this.variables);
    var r = this.observableQuery;
    if (!(r && r.options.fetchPolicy === "no-cache")) {
      var i = R(R({}, this.getDiffOptions(e)), { watcher: this, callback: function(o) {
        return n.setDiff(o);
      } });
      (!this.lastWatch || !wn(i, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = i));
    }
  }, t.prototype.resetLastWrite = function() {
    this.lastWrite = void 0;
  }, t.prototype.shouldWrite = function(e, n) {
    var r = this.lastWrite;
    return !(r && r.dmCount === ia.get(this.cache) && wn(n, r.variables) && wn(e.data, r.result.data));
  }, t.prototype.markResult = function(e, n, r) {
    var i = this;
    this.graphQLErrors = To(e.errors) ? e.errors : [], this.reset(), n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: e.data, complete: !0 }, this.getDiffOptions(n.variables)) : r !== 0 && (Ah(e, n.errorPolicy) ? this.cache.performTransaction(function(o) {
      if (i.shouldWrite(e, n.variables))
        o.writeQuery({
          query: i.document,
          data: e.data,
          variables: n.variables,
          overwrite: r === 1
        }), i.lastWrite = {
          result: e,
          variables: n.variables,
          dmCount: ia.get(i.cache)
        };
      else if (i.lastDiff && i.lastDiff.diff.complete) {
        e.data = i.lastDiff.diff.result;
        return;
      }
      var a = i.getDiffOptions(n.variables), s = o.diff(a);
      i.stopped || i.updateWatch(n.variables), i.updateLastDiff(s, a), s.complete && (e.data = s.result);
    }) : this.lastWrite = void 0);
  }, t.prototype.markReady = function() {
    return this.networkError = null, this.networkStatus = qt.ready;
  }, t.prototype.markError = function(e) {
    return this.networkStatus = qt.error, this.lastWrite = void 0, this.reset(), e.graphQLErrors && (this.graphQLErrors = e.graphQLErrors), e.networkError && (this.networkError = e.networkError), e;
  }, t;
}();
function Ah(t, e) {
  e === void 0 && (e = "none");
  var n = e === "ignore" || e === "all", r = !yl(t);
  return !r && n && t.data && (r = !0), r;
}
var jA = Object.prototype.hasOwnProperty, VA = function() {
  function t(e) {
    var n = e.cache, r = e.link, i = e.queryDeduplication, o = i === void 0 ? !1 : i, a = e.onBroadcast, s = e.ssrMode, c = s === void 0 ? !1 : s, l = e.clientAwareness, u = l === void 0 ? {} : l, d = e.localState, f = e.assumeImmutableResults;
    this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new (Do ? WeakMap : Map)(), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = /* @__PURE__ */ new Map(), this.cache = n, this.link = r, this.queryDeduplication = o, this.clientAwareness = u, this.localState = d || new N2({ cache: n }), this.ssrMode = c, this.assumeImmutableResults = !!f, (this.onBroadcast = a) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
  }
  return t.prototype.stop = function() {
    var e = this;
    this.queries.forEach(function(n, r) {
      e.stopQueryNoBroadcast(r);
    }), this.cancelPendingFetches(__DEV__ ? new Mt("QueryManager stopped while query was in flight") : new Mt(11));
  }, t.prototype.cancelPendingFetches = function(e) {
    this.fetchCancelFns.forEach(function(n) {
      return n(e);
    }), this.fetchCancelFns.clear();
  }, t.prototype.mutate = function(e) {
    var n = e.mutation, r = e.variables, i = e.optimisticResponse, o = e.updateQueries, a = e.refetchQueries, s = a === void 0 ? [] : a, c = e.awaitRefetchQueries, l = c === void 0 ? !1 : c, u = e.update, d = e.onQueryUpdated, f = e.errorPolicy, h = f === void 0 ? "none" : f, g = e.fetchPolicy, v = g === void 0 ? "network-only" : g, b = e.keepRootFields, m = e.context;
    return ke(this, void 0, void 0, function() {
      var y, p, w;
      return Ae(this, function(_) {
        switch (_.label) {
          case 0:
            return __DEV__ ? le(n, "mutation option is required. You must specify your GraphQL document in the mutation option.") : le(n, 12), __DEV__ ? le(v === "network-only" || v === "no-cache", "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : le(v === "network-only" || v === "no-cache", 13), y = this.generateMutationId(), n = this.transform(n).document, r = this.getVariables(n, r), this.transform(n).hasClientExports ? [4, this.localState.addExportedVariables(n, r, m)] : [3, 2];
          case 1:
            r = _.sent(), _.label = 2;
          case 2:
            return p = this.mutationStore && (this.mutationStore[y] = {
              mutation: n,
              variables: r,
              loading: !0,
              error: null
            }), i && this.markMutationOptimistic(i, {
              mutationId: y,
              document: n,
              variables: r,
              fetchPolicy: v,
              errorPolicy: h,
              context: m,
              updateQueries: o,
              update: u,
              keepRootFields: b
            }), this.broadcastQueries(), w = this, [2, new Promise(function(E, S) {
              return Bd(w.getObservableFromLink(n, R(R({}, m), { optimisticResponse: i }), r, !1), function(T) {
                if (yl(T) && h === "none")
                  throw new Bo({
                    graphQLErrors: T.errors
                  });
                p && (p.loading = !1, p.error = null);
                var x = R({}, T);
                return typeof s == "function" && (s = s(x)), h === "ignore" && yl(x) && delete x.errors, w.markMutationResult({
                  mutationId: y,
                  result: x,
                  document: n,
                  variables: r,
                  fetchPolicy: v,
                  errorPolicy: h,
                  context: m,
                  update: u,
                  updateQueries: o,
                  awaitRefetchQueries: l,
                  refetchQueries: s,
                  removeOptimistic: i ? y : void 0,
                  onQueryUpdated: d,
                  keepRootFields: b
                });
              }).subscribe({
                next: function(T) {
                  w.broadcastQueries(), E(T);
                },
                error: function(T) {
                  p && (p.loading = !1, p.error = T), i && w.cache.removeOptimistic(y), w.broadcastQueries(), S(T instanceof Bo ? T : new Bo({
                    networkError: T
                  }));
                }
              });
            })];
        }
      });
    });
  }, t.prototype.markMutationResult = function(e, n) {
    var r = this;
    n === void 0 && (n = this.cache);
    var i = e.result, o = [], a = e.fetchPolicy === "no-cache";
    if (!a && Ah(i, e.errorPolicy)) {
      o.push({
        result: i.data,
        dataId: "ROOT_MUTATION",
        query: e.document,
        variables: e.variables
      });
      var s = e.updateQueries;
      s && this.queries.forEach(function(l, u) {
        var d = l.observableQuery, f = d && d.queryName;
        if (!(!f || !jA.call(s, f))) {
          var h = s[f], g = r.queries.get(u), v = g.document, b = g.variables, m = n.diff({
            query: v,
            variables: b,
            returnPartialData: !0,
            optimistic: !1
          }), y = m.result, p = m.complete;
          if (p && y) {
            var w = h(y, {
              mutationResult: i,
              queryName: v && dh(v) || void 0,
              queryVariables: b
            });
            w && o.push({
              result: w,
              dataId: "ROOT_QUERY",
              query: v,
              variables: b
            });
          }
        }
      });
    }
    if (o.length > 0 || e.refetchQueries || e.update || e.onQueryUpdated || e.removeOptimistic) {
      var c = [];
      if (this.refetchQueries({
        updateCache: function(l) {
          a || o.forEach(function(f) {
            return l.write(f);
          });
          var u = e.update;
          if (u) {
            if (!a) {
              var d = l.diff({
                id: "ROOT_MUTATION",
                query: r.transform(e.document).asQuery,
                variables: e.variables,
                optimistic: !1,
                returnPartialData: !0
              });
              d.complete && (i = R(R({}, i), { data: d.result }));
            }
            u(l, i, {
              context: e.context,
              variables: e.variables
            });
          }
          !a && !e.keepRootFields && l.modify({
            id: "ROOT_MUTATION",
            fields: function(f, h) {
              var g = h.fieldName, v = h.DELETE;
              return g === "__typename" ? f : v;
            }
          });
        },
        include: e.refetchQueries,
        optimistic: !1,
        removeOptimistic: e.removeOptimistic,
        onQueryUpdated: e.onQueryUpdated || null
      }).forEach(function(l) {
        return c.push(l);
      }), e.awaitRefetchQueries || e.onQueryUpdated)
        return Promise.all(c).then(function() {
          return i;
        });
    }
    return Promise.resolve(i);
  }, t.prototype.markMutationOptimistic = function(e, n) {
    var r = this, i = typeof e == "function" ? e(n.variables) : e;
    return this.cache.recordOptimisticTransaction(function(o) {
      try {
        r.markMutationResult(R(R({}, n), { result: { data: i } }), o);
      } catch (a) {
        __DEV__ && le.error(a);
      }
    }, n.mutationId);
  }, t.prototype.fetchQuery = function(e, n, r) {
    return this.fetchQueryObservable(e, n, r).promise;
  }, t.prototype.getQueryStore = function() {
    var e = /* @__PURE__ */ Object.create(null);
    return this.queries.forEach(function(n, r) {
      e[r] = {
        variables: n.variables,
        networkStatus: n.networkStatus,
        networkError: n.networkError,
        graphQLErrors: n.graphQLErrors
      };
    }), e;
  }, t.prototype.resetErrors = function(e) {
    var n = this.queries.get(e);
    n && (n.networkError = void 0, n.graphQLErrors = []);
  }, t.prototype.transform = function(e) {
    var n = this.transformCache;
    if (!n.has(e)) {
      var r = this.cache.transformDocument(e), i = i5(this.cache.transformForLink(r)), o = this.localState.clientQuery(r), a = i && this.localState.serverQuery(i), s = {
        document: r,
        hasClientExports: H6(r),
        hasForcedResolvers: this.localState.shouldForceResolvers(r),
        clientQuery: o,
        serverQuery: a,
        defaultVars: Yp(wc(r)),
        asQuery: R(R({}, r), { definitions: r.definitions.map(function(l) {
          return l.kind === "OperationDefinition" && l.operation !== "query" ? R(R({}, l), { operation: "query" }) : l;
        }) })
      }, c = function(l) {
        l && !n.has(l) && n.set(l, s);
      };
      c(e), c(r), c(o), c(a);
    }
    return n.get(e);
  }, t.prototype.getVariables = function(e, n) {
    return R(R({}, this.transform(e).defaultVars), n);
  }, t.prototype.watchQuery = function(e) {
    e = R(R({}, e), { variables: this.getVariables(e.query, e.variables) }), typeof e.notifyOnNetworkStatusChange > "u" && (e.notifyOnNetworkStatusChange = !1);
    var n = new Qd(this), r = new kh({
      queryManager: this,
      queryInfo: n,
      options: e
    });
    return this.queries.set(r.queryId, n), n.init({
      document: e.query,
      observableQuery: r,
      variables: e.variables
    }), r;
  }, t.prototype.query = function(e, n) {
    var r = this;
    return n === void 0 && (n = this.generateQueryId()), __DEV__ ? le(e.query, "query option is required. You must specify your GraphQL document in the query option.") : le(e.query, 14), __DEV__ ? le(e.query.kind === "Document", 'You must wrap the query string in a "gql" tag.') : le(e.query.kind === "Document", 15), __DEV__ ? le(!e.returnPartialData, "returnPartialData option only supported on watchQuery.") : le(!e.returnPartialData, 16), __DEV__ ? le(!e.pollInterval, "pollInterval option only supported on watchQuery.") : le(!e.pollInterval, 17), this.fetchQuery(n, e).finally(function() {
      return r.stopQuery(n);
    });
  }, t.prototype.generateQueryId = function() {
    return String(this.queryIdCounter++);
  }, t.prototype.generateRequestId = function() {
    return this.requestIdCounter++;
  }, t.prototype.generateMutationId = function() {
    return String(this.mutationIdCounter++);
  }, t.prototype.stopQueryInStore = function(e) {
    this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
  }, t.prototype.stopQueryInStoreNoBroadcast = function(e) {
    var n = this.queries.get(e);
    n && n.stop();
  }, t.prototype.clearStore = function(e) {
    return e === void 0 && (e = {
      discardWatches: !0
    }), this.cancelPendingFetches(__DEV__ ? new Mt("Store reset while query was in flight (not completed in link chain)") : new Mt(18)), this.queries.forEach(function(n) {
      n.observableQuery ? n.networkStatus = qt.loading : n.stop();
    }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(e);
  }, t.prototype.getObservableQueries = function(e) {
    var n = this;
    e === void 0 && (e = "active");
    var r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set();
    return Array.isArray(e) && e.forEach(function(a) {
      typeof a == "string" ? i.set(a, !1) : $6(a) ? i.set(n.transform(a).document, !1) : on(a) && a.query && o.add(a);
    }), this.queries.forEach(function(a, s) {
      var c = a.observableQuery, l = a.document;
      if (c) {
        if (e === "all") {
          r.set(s, c);
          return;
        }
        var u = c.queryName, d = c.options.fetchPolicy;
        if (d === "standby" || e === "active" && !c.hasObservers())
          return;
        (e === "active" || u && i.has(u) || l && i.has(l)) && (r.set(s, c), u && i.set(u, !0), l && i.set(l, !0));
      }
    }), o.size && o.forEach(function(a) {
      var s = mh("legacyOneTimeQuery"), c = n.getQuery(s).init({
        document: a.query,
        variables: a.variables
      }), l = new kh({
        queryManager: n,
        queryInfo: c,
        options: R(R({}, a), { fetchPolicy: "network-only" })
      });
      le(l.queryId === s), c.setObservableQuery(l), r.set(s, l);
    }), __DEV__ && i.size && i.forEach(function(a, s) {
      a || __DEV__ && le.warn("Unknown query ".concat(typeof s == "string" ? "named " : "").concat(JSON.stringify(s, null, 2), " requested in refetchQueries options.include array"));
    }), r;
  }, t.prototype.reFetchObservableQueries = function(e) {
    var n = this;
    e === void 0 && (e = !1);
    var r = [];
    return this.getObservableQueries(e ? "all" : "active").forEach(function(i, o) {
      var a = i.options.fetchPolicy;
      i.resetLastResults(), (e || a !== "standby" && a !== "cache-only") && r.push(i.refetch()), n.getQuery(o).setDiff(null);
    }), this.broadcastQueries(), Promise.all(r);
  }, t.prototype.setObservableQuery = function(e) {
    this.getQuery(e.queryId).setObservableQuery(e);
  }, t.prototype.startGraphQLSubscription = function(e) {
    var n = this, r = e.query, i = e.fetchPolicy, o = e.errorPolicy, a = e.variables, s = e.context, c = s === void 0 ? {} : s;
    r = this.transform(r).document, a = this.getVariables(r, a);
    var l = function(d) {
      return n.getObservableFromLink(r, c, d).map(function(f) {
        if (i !== "no-cache" && (Ah(f, o) && n.cache.write({
          query: r,
          result: f.data,
          dataId: "ROOT_SUBSCRIPTION",
          variables: d
        }), n.broadcastQueries()), yl(f))
          throw new Bo({
            graphQLErrors: f.errors
          });
        return f;
      });
    };
    if (this.transform(r).hasClientExports) {
      var u = this.localState.addExportedVariables(r, a, c).then(l);
      return new Rt(function(d) {
        var f = null;
        return u.then(function(h) {
          return f = h.subscribe(d);
        }, d.error), function() {
          return f && f.unsubscribe();
        };
      });
    }
    return l(a);
  }, t.prototype.stopQuery = function(e) {
    this.stopQueryNoBroadcast(e), this.broadcastQueries();
  }, t.prototype.stopQueryNoBroadcast = function(e) {
    this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
  }, t.prototype.removeQuery = function(e) {
    this.fetchCancelFns.delete(e), this.getQuery(e).stop(), this.queries.delete(e);
  }, t.prototype.broadcastQueries = function() {
    this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(e) {
      return e.notify();
    });
  }, t.prototype.getLocalState = function() {
    return this.localState;
  }, t.prototype.getObservableFromLink = function(e, n, r, i) {
    var o = this, a;
    i === void 0 && (i = (a = n == null ? void 0 : n.queryDeduplication) !== null && a !== void 0 ? a : this.queryDeduplication);
    var s, c = this.transform(e).serverQuery;
    if (c) {
      var l = this, u = l.inFlightLinkObservables, d = l.link, f = {
        query: c,
        variables: r,
        operationName: dh(c) || void 0,
        context: this.prepareContext(R(R({}, n), { forceFetch: !i }))
      };
      if (n = f.context, i) {
        var h = u.get(c) || /* @__PURE__ */ new Map();
        u.set(c, h);
        var g = vo(r);
        if (s = h.get(g), !s) {
          var v = new _s([
            vh(d, f)
          ]);
          h.set(g, s = v), v.cleanup(function() {
            h.delete(g) && h.size < 1 && u.delete(c);
          });
        }
      } else
        s = new _s([
          vh(d, f)
        ]);
    } else
      s = new _s([
        Rt.of({ data: {} })
      ]), n = this.prepareContext(n);
    var b = this.transform(e).clientQuery;
    return b && (s = Bd(s, function(m) {
      return o.localState.runResolvers({
        document: b,
        remoteResult: m,
        context: n,
        variables: r
      });
    })), s;
  }, t.prototype.getResultsFromLink = function(e, n, r) {
    var i = e.lastRequestId = this.generateRequestId();
    return Bd(this.getObservableFromLink(e.document, r.context, r.variables), function(o) {
      var a = To(o.errors);
      if (i >= e.lastRequestId) {
        if (a && r.errorPolicy === "none")
          throw e.markError(new Bo({
            graphQLErrors: o.errors
          }));
        e.markResult(o, r, n), e.markReady();
      }
      var s = {
        data: o.data,
        loading: !1,
        networkStatus: e.networkStatus || qt.ready
      };
      return a && r.errorPolicy !== "ignore" && (s.errors = o.errors), s;
    }, function(o) {
      var a = DA(o) ? o : new Bo({ networkError: o });
      throw i >= e.lastRequestId && e.markError(a), a;
    });
  }, t.prototype.fetchQueryObservable = function(e, n, r) {
    var i = this;
    r === void 0 && (r = qt.loading);
    var o = this.transform(n.query).document, a = this.getVariables(o, n.variables), s = this.getQuery(e), c = n.fetchPolicy, l = c === void 0 ? "cache-first" : c, u = n.errorPolicy, d = u === void 0 ? "none" : u, f = n.returnPartialData, h = f === void 0 ? !1 : f, g = n.notifyOnNetworkStatusChange, v = g === void 0 ? !1 : g, b = n.context, m = b === void 0 ? {} : b, y = Object.assign({}, n, {
      query: o,
      variables: a,
      fetchPolicy: l,
      errorPolicy: d,
      returnPartialData: h,
      notifyOnNetworkStatusChange: v,
      context: m
    }), p = function(_) {
      return y.variables = _, i.fetchQueryByPolicy(s, y, r);
    };
    this.fetchCancelFns.set(e, function(_) {
      setTimeout(function() {
        return w.cancel(_);
      });
    });
    var w = new _s(this.transform(y.query).hasClientExports ? this.localState.addExportedVariables(y.query, y.variables, y.context).then(p) : p(y.variables));
    return w.cleanup(function() {
      i.fetchCancelFns.delete(e), BA(n);
    }), w;
  }, t.prototype.refetchQueries = function(e) {
    var n = this, r = e.updateCache, i = e.include, o = e.optimistic, a = o === void 0 ? !1 : o, s = e.removeOptimistic, c = s === void 0 ? a ? mh("refetchQueries") : void 0 : s, l = e.onQueryUpdated, u = /* @__PURE__ */ new Map();
    i && this.getObservableQueries(i).forEach(function(f, h) {
      u.set(h, {
        oq: f,
        lastDiff: n.getQuery(h).getDiff()
      });
    });
    var d = /* @__PURE__ */ new Map();
    return r && this.cache.batch({
      update: r,
      optimistic: a && c || !1,
      removeOptimistic: c,
      onWatchUpdated: function(f, h, g) {
        var v = f.watcher instanceof Qd && f.watcher.observableQuery;
        if (v) {
          if (l) {
            u.delete(v.queryId);
            var b = l(v, h, g);
            return b === !0 && (b = v.refetch()), b !== !1 && d.set(v, b), b;
          }
          l !== null && u.set(v.queryId, { oq: v, lastDiff: g, diff: h });
        }
      }
    }), u.size && u.forEach(function(f, h) {
      var g = f.oq, v = f.lastDiff, b = f.diff, m;
      if (l) {
        if (!b) {
          var y = g.queryInfo;
          y.reset(), b = y.getDiff();
        }
        m = l(g, b, v);
      }
      (!l || m === !0) && (m = g.refetch()), m !== !1 && d.set(g, m), h.indexOf("legacyOneTimeQuery") >= 0 && n.stopQueryNoBroadcast(h);
    }), c && this.cache.removeOptimistic(c), d;
  }, t.prototype.fetchQueryByPolicy = function(e, n, r) {
    var i = this, o = n.query, a = n.variables, s = n.fetchPolicy, c = n.refetchWritePolicy, l = n.errorPolicy, u = n.returnPartialData, d = n.context, f = n.notifyOnNetworkStatusChange, h = e.networkStatus;
    e.init({
      document: o,
      variables: a,
      networkStatus: r
    });
    var g = function() {
      return e.getDiff(a);
    }, v = function(w, _) {
      _ === void 0 && (_ = e.networkStatus || qt.loading);
      var E = w.result;
      __DEV__ && !u && !wn(E, {}) && R2(w.missing);
      var S = function(T) {
        return Rt.of(R({ data: T, loading: Zs(_), networkStatus: _ }, w.complete ? null : { partial: !0 }));
      };
      return E && i.transform(o).hasForcedResolvers ? i.localState.runResolvers({
        document: o,
        remoteResult: { data: E },
        context: d,
        variables: a,
        onlyRunForcedResolvers: !0
      }).then(function(T) {
        return S(T.data || void 0);
      }) : S(E);
    }, b = s === "no-cache" ? 0 : r === qt.refetch && c !== "merge" ? 1 : 2, m = function() {
      return i.getResultsFromLink(e, b, {
        variables: a,
        context: d,
        fetchPolicy: s,
        errorPolicy: l
      });
    }, y = f && typeof h == "number" && h !== r && Zs(r);
    switch (s) {
      default:
      case "cache-first": {
        var p = g();
        return p.complete ? [
          v(p, e.markReady())
        ] : u || y ? [
          v(p),
          m()
        ] : [
          m()
        ];
      }
      case "cache-and-network": {
        var p = g();
        return p.complete || u || y ? [
          v(p),
          m()
        ] : [
          m()
        ];
      }
      case "cache-only":
        return [
          v(g(), e.markReady())
        ];
      case "network-only":
        return y ? [
          v(g()),
          m()
        ] : [m()];
      case "no-cache":
        return y ? [
          v(e.getDiff()),
          m()
        ] : [m()];
      case "standby":
        return [];
    }
  }, t.prototype.getQuery = function(e) {
    return e && !this.queries.has(e) && this.queries.set(e, new Qd(this, e)), this.queries.get(e);
  }, t.prototype.prepareContext = function(e) {
    e === void 0 && (e = {});
    var n = this.localState.prepareContext(e);
    return R(R({}, n), { clientAwareness: this.clientAwareness });
  }, t;
}(), S0 = !1;
function Jd(t, e) {
  return Ys(t, e, e.variables && {
    variables: R(R({}, t.variables), e.variables)
  });
}
var $A = function() {
  function t(e) {
    var n = this;
    this.defaultOptions = {}, this.resetStoreCallbacks = [], this.clearStoreCallbacks = [];
    var r = e.uri, i = e.credentials, o = e.headers, a = e.cache, s = e.ssrMode, c = s === void 0 ? !1 : s, l = e.ssrForceFetchDelay, u = l === void 0 ? 0 : l, d = e.connectToDevTools, f = d === void 0 ? typeof window == "object" && !window.__APOLLO_CLIENT__ && __DEV__ : d, h = e.queryDeduplication, g = h === void 0 ? !0 : h, v = e.defaultOptions, b = e.assumeImmutableResults, m = b === void 0 ? !1 : b, y = e.resolvers, p = e.typeDefs, w = e.fragmentMatcher, _ = e.name, E = e.version, S = e.link;
    if (S || (S = r ? new c2({ uri: r, credentials: i, headers: o }) : zr.empty()), !a)
      throw __DEV__ ? new Mt(`To initialize Apollo Client, you must specify a 'cache' property in the options object. 
For more information, please visit: https://go.apollo.dev/c/docs`) : new Mt(7);
    if (this.link = S, this.cache = a, this.disableNetworkFetches = c || u > 0, this.queryDeduplication = g, this.defaultOptions = v || {}, this.typeDefs = p, u && setTimeout(function() {
      return n.disableNetworkFetches = !1;
    }, u), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), f && typeof window == "object" && (window.__APOLLO_CLIENT__ = this), !S0 && __DEV__ && (S0 = !0, typeof window < "u" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__)) {
      var T = window.navigator, x = T && T.userAgent, A = void 0;
      typeof x == "string" && (x.indexOf("Chrome/") > -1 ? A = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : x.indexOf("Firefox/") > -1 && (A = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), A && __DEV__ && le.log("Download the Apollo DevTools for a better development experience: " + A);
    }
    this.version = R5, this.localState = new N2({
      cache: a,
      client: this,
      resolvers: y,
      fragmentMatcher: w
    }), this.queryManager = new VA({
      cache: this.cache,
      link: this.link,
      queryDeduplication: g,
      ssrMode: c,
      clientAwareness: {
        name: _,
        version: E
      },
      localState: this.localState,
      assumeImmutableResults: m,
      onBroadcast: f ? function() {
        n.devToolsHookCb && n.devToolsHookCb({
          action: {},
          state: {
            queries: n.queryManager.getQueryStore(),
            mutations: n.queryManager.mutationStore || {}
          },
          dataWithOptimisticResults: n.cache.extract(!0)
        });
      } : void 0
    });
  }
  return t.prototype.stop = function() {
    this.queryManager.stop();
  }, t.prototype.watchQuery = function(e) {
    return this.defaultOptions.watchQuery && (e = Jd(this.defaultOptions.watchQuery, e)), this.disableNetworkFetches && (e.fetchPolicy === "network-only" || e.fetchPolicy === "cache-and-network") && (e = R(R({}, e), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(e);
  }, t.prototype.query = function(e) {
    return this.defaultOptions.query && (e = Jd(this.defaultOptions.query, e)), __DEV__ ? le(e.fetchPolicy !== "cache-and-network", "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.") : le(e.fetchPolicy !== "cache-and-network", 8), this.disableNetworkFetches && e.fetchPolicy === "network-only" && (e = R(R({}, e), { fetchPolicy: "cache-first" })), this.queryManager.query(e);
  }, t.prototype.mutate = function(e) {
    return this.defaultOptions.mutate && (e = Jd(this.defaultOptions.mutate, e)), this.queryManager.mutate(e);
  }, t.prototype.subscribe = function(e) {
    return this.queryManager.startGraphQLSubscription(e);
  }, t.prototype.readQuery = function(e, n) {
    return n === void 0 && (n = !1), this.cache.readQuery(e, n);
  }, t.prototype.readFragment = function(e, n) {
    return n === void 0 && (n = !1), this.cache.readFragment(e, n);
  }, t.prototype.writeQuery = function(e) {
    this.cache.writeQuery(e), this.queryManager.broadcastQueries();
  }, t.prototype.writeFragment = function(e) {
    this.cache.writeFragment(e), this.queryManager.broadcastQueries();
  }, t.prototype.__actionHookForDevTools = function(e) {
    this.devToolsHookCb = e;
  }, t.prototype.__requestRaw = function(e) {
    return vh(this.link, e);
  }, t.prototype.resetStore = function() {
    var e = this;
    return Promise.resolve().then(function() {
      return e.queryManager.clearStore({
        discardWatches: !1
      });
    }).then(function() {
      return Promise.all(e.resetStoreCallbacks.map(function(n) {
        return n();
      }));
    }).then(function() {
      return e.reFetchObservableQueries();
    });
  }, t.prototype.clearStore = function() {
    var e = this;
    return Promise.resolve().then(function() {
      return e.queryManager.clearStore({
        discardWatches: !0
      });
    }).then(function() {
      return Promise.all(e.clearStoreCallbacks.map(function(n) {
        return n();
      }));
    });
  }, t.prototype.onResetStore = function(e) {
    var n = this;
    return this.resetStoreCallbacks.push(e), function() {
      n.resetStoreCallbacks = n.resetStoreCallbacks.filter(function(r) {
        return r !== e;
      });
    };
  }, t.prototype.onClearStore = function(e) {
    var n = this;
    return this.clearStoreCallbacks.push(e), function() {
      n.clearStoreCallbacks = n.clearStoreCallbacks.filter(function(r) {
        return r !== e;
      });
    };
  }, t.prototype.reFetchObservableQueries = function(e) {
    return this.queryManager.reFetchObservableQueries(e);
  }, t.prototype.refetchQueries = function(e) {
    var n = this.queryManager.refetchQueries(e), r = [], i = [];
    n.forEach(function(a, s) {
      r.push(s), i.push(a);
    });
    var o = Promise.all(i);
    return o.queries = r, o.results = i, o.catch(function(a) {
      __DEV__ && le.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(a));
    }), o;
  }, t.prototype.getObservableQueries = function(e) {
    return e === void 0 && (e = "active"), this.queryManager.getObservableQueries(e);
  }, t.prototype.extract = function(e) {
    return this.cache.extract(e);
  }, t.prototype.restore = function(e) {
    return this.cache.restore(e);
  }, t.prototype.addResolvers = function(e) {
    this.localState.addResolvers(e);
  }, t.prototype.setResolvers = function(e) {
    this.localState.setResolvers(e);
  }, t.prototype.getResolvers = function() {
    return this.localState.getResolvers();
  }, t.prototype.setLocalStateFragmentMatcher = function(e) {
    this.localState.setFragmentMatcher(e);
  }, t.prototype.setLink = function(e) {
    this.link = this.queryManager.link = e;
  }, t;
}(), T0 = a2 ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function qA() {
  var t = Is.createContext[T0];
  return t || (Object.defineProperty(Is.createContext, T0, {
    value: t = Is.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), t.displayName = "ApolloContext"), t;
}
var zA = function(t) {
  var e = t.client, n = t.children, r = qA();
  return Is.createElement(r.Consumer, null, function(i) {
    return i === void 0 && (i = {}), e && i.client !== e && (i = Object.assign({}, i, { client: e })), __DEV__ ? le(i.client, 'ApolloProvider was not passed a client instance. Make sure you pass in your client via the "client" prop.') : le(i.client, 26), Is.createElement(r.Provider, { value: i }, n);
  });
};
function KA(t) {
  var e = t || {}, n = e.initial, r = n === void 0 ? 300 : n, i = e.jitter, o = i === void 0 ? !0 : i, a = e.max, s = a === void 0 ? 1 / 0 : a, c = o ? r : r / 2;
  return function(u) {
    var d = Math.min(s, c * Math.pow(2, u));
    return o && (d = Math.random() * d), d;
  };
}
function WA(t) {
  var e = t || {}, n = e.retryIf, r = e.max, i = r === void 0 ? 5 : r;
  return function(a, s, c) {
    return a >= i ? !1 : n ? n(c, s) : !!c;
  };
}
var GA = function() {
  function t(e, n, r, i) {
    var o = this;
    this.operation = e, this.nextLink = n, this.delayFor = r, this.retryIf = i, this.retryCount = 0, this.values = [], this.complete = !1, this.canceled = !1, this.observers = [], this.currentSubscription = null, this.onNext = function(a) {
      o.values.push(a);
      for (var s = 0, c = o.observers; s < c.length; s++) {
        var l = c[s];
        l && l.next(a);
      }
    }, this.onComplete = function() {
      o.complete = !0;
      for (var a = 0, s = o.observers; a < s.length; a++) {
        var c = s[a];
        c && c.complete();
      }
    }, this.onError = function(a) {
      return ke(o, void 0, void 0, function() {
        var s, c, l, u;
        return Ae(this, function(d) {
          switch (d.label) {
            case 0:
              return this.retryCount += 1, [4, this.retryIf(this.retryCount, this.operation, a)];
            case 1:
              if (s = d.sent(), s)
                return this.scheduleRetry(this.delayFor(this.retryCount, this.operation, a)), [2];
              for (this.error = a, c = 0, l = this.observers; c < l.length; c++)
                u = l[c], u && u.error(a);
              return [2];
          }
        });
      });
    };
  }
  return t.prototype.subscribe = function(e) {
    if (this.canceled)
      throw new Error("Subscribing to a retryable link that was canceled is not supported");
    this.observers.push(e);
    for (var n = 0, r = this.values; n < r.length; n++) {
      var i = r[n];
      e.next(i);
    }
    this.complete ? e.complete() : this.error && e.error(this.error);
  }, t.prototype.unsubscribe = function(e) {
    var n = this.observers.indexOf(e);
    if (n < 0)
      throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
    this.observers[n] = null, this.observers.every(function(r) {
      return r === null;
    }) && this.cancel();
  }, t.prototype.start = function() {
    this.currentSubscription || this.try();
  }, t.prototype.cancel = function() {
    this.currentSubscription && this.currentSubscription.unsubscribe(), clearTimeout(this.timerId), this.timerId = void 0, this.currentSubscription = null, this.canceled = !0;
  }, t.prototype.try = function() {
    this.currentSubscription = this.nextLink(this.operation).subscribe({
      next: this.onNext,
      error: this.onError,
      complete: this.onComplete
    });
  }, t.prototype.scheduleRetry = function(e) {
    var n = this;
    if (this.timerId)
      throw new Error("RetryLink BUG! Encountered overlapping retries");
    this.timerId = setTimeout(function() {
      n.timerId = void 0, n.try();
    }, e);
  }, t;
}(), YA = function(t) {
  an(e, t);
  function e(n) {
    var r = t.call(this) || this, i = n || {}, o = i.attempts, a = i.delay;
    return r.delayFor = typeof a == "function" ? a : KA(a), r.retryIf = typeof o == "function" ? o : WA(o), r;
  }
  return e.prototype.request = function(n, r) {
    var i = new GA(n, r, this.delayFor, this.retryIf);
    return i.start(), new Rt(function(o) {
      return i.subscribe(o), function() {
        i.unsubscribe(o);
      };
    });
  }, e;
}(zr);
function M2(t) {
  return new zr(function(e, n) {
    return new Rt(function(r) {
      var i, o, a;
      try {
        i = n(e).subscribe({
          next: function(s) {
            if (s.errors && (a = t({
              graphQLErrors: s.errors,
              response: s,
              operation: e,
              forward: n
            }), a)) {
              o = a.subscribe({
                next: r.next.bind(r),
                error: r.error.bind(r),
                complete: r.complete.bind(r)
              });
              return;
            }
            r.next(s);
          },
          error: function(s) {
            if (a = t({
              operation: e,
              networkError: s,
              graphQLErrors: s && s.result && s.result.errors,
              forward: n
            }), a) {
              o = a.subscribe({
                next: r.next.bind(r),
                error: r.error.bind(r),
                complete: r.complete.bind(r)
              });
              return;
            }
            r.error(s);
          },
          complete: function() {
            a || r.complete.bind(r)();
          }
        });
      } catch (s) {
        t({ networkError: s, operation: e, forward: n }), r.error(s);
      }
      return function() {
        i && i.unsubscribe(), o && i.unsubscribe();
      };
    });
  });
}
(function(t) {
  an(e, t);
  function e(n) {
    var r = t.call(this) || this;
    return r.link = M2(n), r;
  }
  return e.prototype.request = function(n, r) {
    return this.link.request(n, r);
  }, e;
})(zr);
const QA = ({
  endpoint: t,
  getToken: e,
  refreshToken: n
}) => {
  const r = new zr((s, c) => {
    const l = e();
    return l && s.setContext(({ headers: u = {} }) => ({
      headers: {
        ...u,
        // ...metaHeaders,
        "auth-token": l
      }
    })), c(s);
  }), i = M2(
    ({ networkError: s, graphQLErrors: c = [], operation: l, forward: u }) => {
      var g, v;
      const d = () => S5(n()).flatMap(() => u(l)), f = ((g = s == null ? void 0 : s.result) == null ? void 0 : g.errors) ?? [];
      if (((v = s == null ? void 0 : s.result) == null ? void 0 : v.message) === "Token Error" || f.find((b) => b.message === "Token Error") || c.find((b) => b.message === "Token Error"))
        return d();
    }
  ), o = new c2({
    uri: t
  }), a = new YA();
  return new $A({
    cache: new PA(),
    link: x5([a, i, r, o])
  });
}, TW = ({
  endpoint: t,
  children: e
}) => {
  const { getToken: n, loggedIn: r, refreshToken: i } = Ru(), o = Me(
    QA({ endpoint: t, getToken: n, refreshToken: i })
  ).current;
  return Ee(() => {
    r || o.resetStore();
  }, [r, o]), /* @__PURE__ */ C(zA, { client: o, children: e });
};
var P2 = () => {
}, Vi = P2;
function Rr(t) {
  return {
    tag: 0,
    0: t
  };
}
function Ec(t) {
  return {
    tag: 1,
    0: t
  };
}
var k0 = () => typeof Symbol == "function" && Symbol.asyncIterator || "@@asyncIterator", JA = (t) => t;
function Qn(t) {
  return (e) => (n) => {
    var r = Vi;
    e((i) => {
      i === 0 ? n(0) : i.tag === 0 ? (r = i[0], n(i)) : t(i[0]) ? n(i) : r(0);
    });
  };
}
function Wo(t) {
  return (e) => (n) => e((r) => {
    r === 0 || r.tag === 0 ? n(r) : n(Ec(t(r[0])));
  });
}
function lg(t) {
  return (e) => (n) => {
    var r = [], i = Vi, o = !1, a = !1;
    e((s) => {
      a || (s === 0 ? (a = !0, r.length || n(0)) : s.tag === 0 ? i = s[0] : (o = !1, function(l) {
        var u = Vi;
        l((d) => {
          if (d === 0) {
            if (r.length) {
              var f = r.indexOf(u);
              f > -1 && (r = r.slice()).splice(f, 1), r.length || (a ? n(0) : o || (o = !0, i(0)));
            }
          } else
            d.tag === 0 ? (r.push(u = d[0]), u(0)) : r.length && (n(d), u(0));
        });
      }(t(s[0])), o || (o = !0, i(0))));
    }), n(Rr((s) => {
      if (s === 1) {
        a || (a = !0, i(1));
        for (var c = 0, l = r, u = r.length; c < u; c++)
          l[c](1);
        r.length = 0;
      } else {
        !a && !o ? (o = !0, i(0)) : o = !1;
        for (var d = 0, f = r, h = r.length; d < h; d++)
          f[d](0);
      }
    }));
  };
}
function ZA(t) {
  return lg(JA)(t);
}
function Xs(t) {
  return ZA(L2(t));
}
function Oh(t) {
  return (e) => (n) => {
    var r = !1;
    e((i) => {
      if (!r)
        if (i === 0)
          r = !0, n(0);
        else if (i.tag === 0) {
          var o = i[0];
          n(Rr((a) => {
            a === 1 && (r = !0), o(a);
          }));
        } else
          t(i[0]), n(i);
    });
  };
}
function XA(t) {
  return (e) => (n) => e((r) => {
    r === 0 ? n(0) : r.tag === 0 ? (n(r), t()) : n(r);
  });
}
function Ui(t) {
  var e = [], n = Vi, r = !1;
  return (i) => {
    e.push(i), e.length === 1 && t((o) => {
      if (o === 0) {
        for (var a = 0, s = e, c = e.length; a < c; a++)
          s[a](0);
        e.length = 0;
      } else if (o.tag === 0)
        n = o[0];
      else {
        r = !1;
        for (var l = 0, u = e, d = e.length; l < d; l++)
          u[l](o);
      }
    }), i(Rr((o) => {
      if (o === 1) {
        var a = e.indexOf(i);
        a > -1 && (e = e.slice()).splice(a, 1), e.length || n(1);
      } else
        r || (r = !0, n(0));
    }));
  };
}
function D2(t) {
  return (e) => (n) => {
    var r = Vi, i = !1, o = 0;
    e((a) => {
      i || (a === 0 ? (i = !0, n(0)) : a.tag === 0 ? t <= 0 ? (i = !0, n(0), a[0](1)) : r = a[0] : o++ < t ? (n(a), !i && o >= t && (i = !0, n(0), r(1))) : n(a));
    }), n(Rr((a) => {
      a === 1 && !i ? (i = !0, r(1)) : a === 0 && !i && o < t && r(0);
    }));
  };
}
function eO(t) {
  return (e) => (n) => {
    var r = Vi, i = Vi, o = !1;
    e((a) => {
      o || (a === 0 ? (o = !0, i(1), n(0)) : a.tag === 0 ? (r = a[0], t((s) => {
        s === 0 || (s.tag === 0 ? (i = s[0])(0) : (o = !0, i(1), r(1), n(0)));
      })) : n(a));
    }), n(Rr((a) => {
      a === 1 && !o ? (o = !0, r(1), i(1)) : o || r(0);
    }));
  };
}
function tO(t) {
  return (e) => (n) => {
    var r, i = !1, o = !1;
    e((a) => {
      if (!o)
        if (a === 0)
          o = !0, r ? i = !0 : n(0);
        else if (a.tag === 0) {
          var s = a[0];
          n(Rr((c) => {
            c === 1 && !o ? (o = !0, i = !1, r && clearTimeout(r), s(1)) : o || s(0);
          }));
        } else
          r && clearTimeout(r), r = setTimeout(() => {
            r = void 0, n(a), i && n(0);
          }, t(a[0]));
    });
  };
}
function nO(t) {
  return (e) => {
    var n = t[k0()] && t[k0()]() || t, r = !1, i = !1, o = !1, a;
    e(Rr(async (s) => {
      if (s === 1)
        r = !0, n.return && n.return();
      else if (i)
        o = !0;
      else {
        for (o = i = !0; o && !r; )
          if ((a = await n.next()).done)
            r = !0, n.return && await n.return(), e(0);
          else
            try {
              o = !1, e(Ec(a.value));
            } catch (c) {
              if (n.throw)
                (r = !!(await n.throw(c)).done) && e(0);
              else
                throw c;
            }
        i = !1;
      }
    }));
  };
}
function rO(t) {
  return t[Symbol.asyncIterator] ? nO(t) : (e) => {
    var n = t[Symbol.iterator](), r = !1, i = !1, o = !1, a;
    e(Rr((s) => {
      if (s === 1)
        r = !0, n.return && n.return();
      else if (i)
        o = !0;
      else {
        for (o = i = !0; o && !r; )
          if ((a = n.next()).done)
            r = !0, n.return && n.return(), e(0);
          else
            try {
              o = !1, e(Ec(a.value));
            } catch (c) {
              if (n.throw)
                (r = !!n.throw(c).done) && e(0);
              else
                throw c;
            }
        i = !1;
      }
    }));
  };
}
var L2 = rO;
function iO(t) {
  return (e) => {
    var n = !1;
    e(Rr((r) => {
      r === 1 ? n = !0 : n || (n = !0, e(Ec(t)), e(0));
    }));
  };
}
function oO(t) {
  return (e) => {
    var n = !1, r = t({
      next(i) {
        n || e(Ec(i));
      },
      complete() {
        n || (n = !0, e(0));
      }
    });
    e(Rr((i) => {
      i === 1 && !n && (n = !0, r());
    }));
  };
}
function F2() {
  var t, e;
  return {
    source: Ui(oO((n) => (t = n.next, e = n.complete, P2))),
    next(n) {
      t && t(n);
    },
    complete() {
      e && e();
    }
  };
}
var aO = (t) => {
  var e = !1;
  t(Rr((n) => {
    n === 1 ? e = !0 : e || (e = !0, t(0));
  }));
};
function U2(t) {
  return new Promise((e) => {
    var n = Vi, r;
    t((i) => {
      i === 0 ? Promise.resolve(r).then(e) : i.tag === 0 ? (n = i[0])(0) : (r = i[0], n(0));
    });
  });
}
var Ku = (...t) => {
  for (var e = t[0], n = 1, r = t.length; n < r; n++)
    e = t[n](e);
  return e;
}, Es = {
  NAME: "Name",
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  DIRECTIVE: "Directive",
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType"
};
class sO extends Error {
  constructor(e, n, r, i, o, a, s) {
    super(e), this.name = "GraphQLError", this.message = e, o && (this.path = o), n && (this.nodes = Array.isArray(n) ? n : [n]), r && (this.source = r), i && (this.positions = i), a && (this.originalError = a);
    var c = s;
    if (!c && a) {
      var l = a.extensions;
      l && typeof l == "object" && (c = l);
    }
    this.extensions = c || {};
  }
  toJSON() {
    return {
      ...this,
      message: this.message
    };
  }
  toString() {
    return this.message;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
}
var Kt, tt;
function pn(t) {
  return new sO(`Syntax Error: Unexpected token at ${tt} in ${t}`);
}
function Wn(t) {
  if (t.lastIndex = tt, t.test(Kt))
    return Kt.slice(tt, tt = t.lastIndex);
}
var Wc = / +(?=[^\s])/y;
function cO(t) {
  for (var e = t.split(`
`), n = "", r = 0, i = 0, o = e.length - 1, a = 0; a < e.length; a++)
    Wc.lastIndex = 0, Wc.test(e[a]) && (a && (!r || Wc.lastIndex < r) && (r = Wc.lastIndex), i = i || a, o = a);
  for (var s = i; s <= o; s++)
    s !== i && (n += `
`), n += e[s].slice(r).replace(/\\"""/g, '"""');
  return n;
}
function st() {
  for (var t = 0 | Kt.charCodeAt(tt++); t === 9 || t === 10 || t === 13 || t === 32 || t === 35 || t === 44 || t === 65279; t = 0 | Kt.charCodeAt(tt++))
    if (t === 35)
      for (; (t = Kt.charCodeAt(tt++)) !== 10 && t !== 13; )
        ;
  tt--;
}
var H2 = /[_A-Za-z]\w*/y;
function Vr() {
  var t;
  if (t = Wn(H2))
    return {
      kind: "Name",
      value: t
    };
}
var lO = /(?:null|true|false)/y, B2 = /\$[_A-Za-z]\w*/y, uO = /-?\d+/y, dO = /(?:\.\d+)?[eE][+-]?\d+|\.\d+/y, fO = /\\/g, hO = /"""(?:"""|(?:[\s\S]*?[^\\])""")/y, pO = /"(?:"|[^\r\n]*?[^\\]")/y;
function eu(t) {
  var e, n;
  if (n = Wn(lO))
    e = n === "null" ? {
      kind: "NullValue"
    } : {
      kind: "BooleanValue",
      value: n === "true"
    };
  else if (!t && (n = Wn(B2)))
    e = {
      kind: "Variable",
      name: {
        kind: "Name",
        value: n.slice(1)
      }
    };
  else if (n = Wn(uO)) {
    var r = n;
    (n = Wn(dO)) ? e = {
      kind: "FloatValue",
      value: r + n
    } : e = {
      kind: "IntValue",
      value: r
    };
  } else if (n = Wn(H2))
    e = {
      kind: "EnumValue",
      value: n
    };
  else if (n = Wn(hO))
    e = {
      kind: "StringValue",
      value: cO(n.slice(3, -3)),
      block: !0
    };
  else if (n = Wn(pO))
    e = {
      kind: "StringValue",
      value: fO.test(n) ? JSON.parse(n) : n.slice(1, -1),
      block: !1
    };
  else if (e = function(o) {
    var a;
    if (Kt.charCodeAt(tt) === 91) {
      tt++, st();
      for (var s = []; a = eu(o); )
        s.push(a);
      if (Kt.charCodeAt(tt++) !== 93)
        throw pn("ListValue");
      return st(), {
        kind: "ListValue",
        values: s
      };
    }
  }(t) || function(o) {
    if (Kt.charCodeAt(tt) === 123) {
      tt++, st();
      for (var a = [], s; s = Vr(); ) {
        if (st(), Kt.charCodeAt(tt++) !== 58)
          throw pn("ObjectField");
        st();
        var c = eu(o);
        if (!c)
          throw pn("ObjectField");
        a.push({
          kind: "ObjectField",
          name: s,
          value: c
        });
      }
      if (Kt.charCodeAt(tt++) !== 125)
        throw pn("ObjectValue");
      return st(), {
        kind: "ObjectValue",
        fields: a
      };
    }
  }(t))
    return e;
  return st(), e;
}
function j2(t) {
  var e = [];
  if (st(), Kt.charCodeAt(tt) === 40) {
    tt++, st();
    for (var n; n = Vr(); ) {
      if (st(), Kt.charCodeAt(tt++) !== 58)
        throw pn("Argument");
      st();
      var r = eu(t);
      if (!r)
        throw pn("Argument");
      e.push({
        kind: "Argument",
        name: n,
        value: r
      });
    }
    if (!e.length || Kt.charCodeAt(tt++) !== 41)
      throw pn("Argument");
    st();
  }
  return e;
}
function Sa(t) {
  var e = [];
  for (st(); Kt.charCodeAt(tt) === 64; ) {
    tt++;
    var n = Vr();
    if (!n)
      throw pn("Directive");
    st(), e.push({
      kind: "Directive",
      name: n,
      arguments: j2(t)
    });
  }
  return e;
}
function gO() {
  var t = Vr();
  if (t) {
    st();
    var e;
    if (Kt.charCodeAt(tt) === 58) {
      if (tt++, st(), e = t, !(t = Vr()))
        throw pn("Field");
      st();
    }
    return {
      kind: "Field",
      alias: e,
      name: t,
      arguments: j2(!1),
      directives: Sa(!1),
      selectionSet: Wu()
    };
  }
}
function V2() {
  var t;
  if (st(), Kt.charCodeAt(tt) === 91) {
    tt++, st();
    var e = V2();
    if (!e || Kt.charCodeAt(tt++) !== 93)
      throw pn("ListType");
    t = {
      kind: "ListType",
      type: e
    };
  } else if (t = Vr())
    t = {
      kind: "NamedType",
      name: t
    };
  else
    throw pn("NamedType");
  return st(), Kt.charCodeAt(tt) === 33 ? (tt++, st(), {
    kind: "NonNullType",
    type: t
  }) : t;
}
var mO = /on/y;
function $2() {
  if (Wn(mO)) {
    st();
    var t = Vr();
    if (!t)
      throw pn("NamedType");
    return st(), {
      kind: "NamedType",
      name: t
    };
  }
}
var vO = /\.\.\./y;
function yO() {
  if (Wn(vO)) {
    st();
    var t = tt, e;
    if ((e = Vr()) && e.value !== "on")
      return {
        kind: "FragmentSpread",
        name: e,
        directives: Sa(!1)
      };
    tt = t;
    var n = $2(), r = Sa(!1), i = Wu();
    if (!i)
      throw pn("InlineFragment");
    return {
      kind: "InlineFragment",
      typeCondition: n,
      directives: r,
      selectionSet: i
    };
  }
}
function Wu() {
  var t;
  if (st(), Kt.charCodeAt(tt) === 123) {
    tt++, st();
    for (var e = []; t = yO() || gO(); )
      e.push(t);
    if (!e.length || Kt.charCodeAt(tt++) !== 125)
      throw pn("SelectionSet");
    return st(), {
      kind: "SelectionSet",
      selections: e
    };
  }
}
var wO = /fragment/y;
function bO() {
  if (Wn(wO)) {
    st();
    var t = Vr();
    if (!t)
      throw pn("FragmentDefinition");
    st();
    var e = $2();
    if (!e)
      throw pn("FragmentDefinition");
    var n = Sa(!1), r = Wu();
    if (!r)
      throw pn("FragmentDefinition");
    return {
      kind: "FragmentDefinition",
      name: t,
      typeCondition: e,
      directives: n,
      selectionSet: r
    };
  }
}
var _O = /(?:query|mutation|subscription)/y;
function EO() {
  var t, e, n = [], r = [];
  (t = Wn(_O)) && (st(), e = Vr(), n = function() {
    var a, s = [];
    if (st(), Kt.charCodeAt(tt) === 40) {
      for (tt++, st(); a = Wn(B2); ) {
        if (st(), Kt.charCodeAt(tt++) !== 58)
          throw pn("VariableDefinition");
        var c = V2(), l = void 0;
        if (Kt.charCodeAt(tt) === 61 && (tt++, st(), !(l = eu(!0))))
          throw pn("VariableDefinition");
        st(), s.push({
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: a.slice(1)
            }
          },
          type: c,
          defaultValue: l,
          directives: Sa(!0)
        });
      }
      if (Kt.charCodeAt(tt++) !== 41)
        throw pn("VariableDefinition");
      st();
    }
    return s;
  }(), r = Sa(!1));
  var i = Wu();
  if (i)
    return {
      kind: "OperationDefinition",
      operation: t || "query",
      name: e,
      variableDefinitions: n,
      directives: r,
      selectionSet: i
    };
}
function CO(t, e) {
  return Kt = typeof t.body == "string" ? t.body : t, tt = 0, function() {
    var r;
    st();
    for (var i = []; r = bO() || EO(); )
      i.push(r);
    return {
      kind: "Document",
      definitions: i
    };
  }();
}
function IO(t) {
  return JSON.stringify(t);
}
function SO(t) {
  return `"""
` + t.replace(/"""/g, '\\"""') + `
"""`;
}
var ar = (t) => !(!t || !t.length), On = {
  OperationDefinition(t) {
    if (t.operation === "query" && !t.name && !ar(t.variableDefinitions) && !ar(t.directives))
      return On.SelectionSet(t.selectionSet);
    var e = t.operation;
    return t.name && (e += " " + t.name.value), ar(t.variableDefinitions) && (t.name || (e += " "), e += "(" + t.variableDefinitions.map(On.VariableDefinition).join(", ") + ")"), ar(t.directives) && (e += " " + t.directives.map(On.Directive).join(" ")), e + " " + On.SelectionSet(t.selectionSet);
  },
  VariableDefinition(t) {
    var e = On.Variable(t.variable) + ": " + sr(t.type);
    return t.defaultValue && (e += " = " + sr(t.defaultValue)), ar(t.directives) && (e += " " + t.directives.map(On.Directive).join(" ")), e;
  },
  Field(t) {
    var e = (t.alias ? t.alias.value + ": " : "") + t.name.value;
    if (ar(t.arguments)) {
      var n = t.arguments.map(On.Argument), r = e + "(" + n.join(", ") + ")";
      e = r.length > 80 ? e + `(
  ` + n.join(`
`).replace(/\n/g, `
  `) + `
)` : r;
    }
    return ar(t.directives) && (e += " " + t.directives.map(On.Directive).join(" ")), t.selectionSet ? e + " " + On.SelectionSet(t.selectionSet) : e;
  },
  StringValue: (t) => t.block ? SO(t.value) : IO(t.value),
  BooleanValue: (t) => "" + t.value,
  NullValue: (t) => "null",
  IntValue: (t) => t.value,
  FloatValue: (t) => t.value,
  EnumValue: (t) => t.value,
  Name: (t) => t.value,
  Variable: (t) => "$" + t.name.value,
  ListValue: (t) => "[" + t.values.map(sr).join(", ") + "]",
  ObjectValue: (t) => "{" + t.fields.map(On.ObjectField).join(", ") + "}",
  ObjectField: (t) => t.name.value + ": " + sr(t.value),
  Document: (t) => ar(t.definitions) ? t.definitions.map(sr).join(`

`) : "",
  SelectionSet: (t) => `{
  ` + t.selections.map(sr).join(`
`).replace(/\n/g, `
  `) + `
}`,
  Argument: (t) => t.name.value + ": " + sr(t.value),
  FragmentSpread(t) {
    var e = "..." + t.name.value;
    return ar(t.directives) && (e += " " + t.directives.map(On.Directive).join(" ")), e;
  },
  InlineFragment(t) {
    var e = "...";
    return t.typeCondition && (e += " on " + t.typeCondition.name.value), ar(t.directives) && (e += " " + t.directives.map(On.Directive).join(" ")), e + " " + sr(t.selectionSet);
  },
  FragmentDefinition(t) {
    var e = "fragment " + t.name.value;
    return e += " on " + t.typeCondition.name.value, ar(t.directives) && (e += " " + t.directives.map(On.Directive).join(" ")), e + " " + sr(t.selectionSet);
  },
  Directive(t) {
    var e = "@" + t.name.value;
    return ar(t.arguments) && (e += "(" + t.arguments.map(On.Argument).join(", ") + ")"), e;
  },
  NamedType: (t) => t.name.value,
  ListType: (t) => "[" + sr(t.type) + "]",
  NonNullType: (t) => sr(t.type) + "!"
};
function sr(t) {
  return On[t.kind] ? On[t.kind](t) : "";
}
var xh = (t, e) => {
  for (var n = 0 | (e || 5381), r = 0, i = 0 | t.length; r < i; r++)
    n = (n << 5) + n + t.charCodeAt(r);
  return n;
}, bl = /* @__PURE__ */ new Set(), A0 = /* @__PURE__ */ new WeakMap(), Go = (t) => {
  if (t === null || bl.has(t))
    return "null";
  if (typeof t != "object")
    return JSON.stringify(t) || "";
  if (t.toJSON)
    return Go(t.toJSON());
  if (Array.isArray(t)) {
    var e = "[";
    for (var n of t)
      e.length > 1 && (e += ","), e += Go(n) || "null";
    return e += "]";
  } else if (O0 !== nu && t instanceof O0 || x0 !== nu && t instanceof x0)
    return "null";
  var r = Object.keys(t).sort();
  if (!r.length && t.constructor && t.constructor !== Object) {
    var i = A0.get(t) || Math.random().toString(36).slice(2);
    return A0.set(t, i), Go({
      __key: i
    });
  }
  bl.add(t);
  var o = "{";
  for (var a of r) {
    var s = Go(t[a]);
    s && (o.length > 1 && (o += ","), o += Go(a) + ":" + s);
  }
  return bl.delete(t), o += "}";
}, tu = (t) => (bl.clear(), Go(t));
class nu {
}
var O0 = typeof File < "u" ? File : nu, x0 = typeof Blob < "u" ? Blob : nu, TO = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g, kO = /(?:#[^\n\r]+)?(?:[\r\n]+|$)/g, AO = (t, e) => e % 2 == 0 ? t.replace(kO, `
`) : t, R0 = (t) => t.split(TO).map(AO).join("").trim(), N0 = /* @__PURE__ */ new Map(), _l = /* @__PURE__ */ new Map(), q2 = (t) => {
  var e;
  return typeof t == "string" ? e = R0(t) : t.loc && _l.get(t.__key) === t ? e = t.loc.source.body : (e = N0.get(t) || R0(sr(t)), N0.set(t, e)), typeof t != "string" && !t.loc && (t.loc = {
    start: 0,
    end: e.length,
    source: {
      body: e,
      name: "gql",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }), e;
}, M0 = (t) => {
  var e = xh(q2(t));
  if (t.definitions) {
    var n = OO(t);
    n && (e = xh(`
# ${n}`, e));
  }
  return e;
}, z2 = (t) => {
  var e, n;
  return typeof t == "string" ? (e = M0(t), n = _l.get(e) || CO(t)) : (e = t.__key || M0(t), n = _l.get(e) || t), n.loc || q2(n), n.__key = e, _l.set(e, n), n;
}, Rh = (t, e, n) => {
  var r = e || {}, i = z2(t), o = tu(r), a = i.__key;
  return o !== "{}" && (a = xh(o, a)), {
    key: a,
    query: i,
    variables: r,
    extensions: n
  };
}, OO = (t) => {
  for (var e of t.definitions)
    if (e.kind === Es.OPERATION_DEFINITION)
      return e.name ? e.name.value : void 0;
};
typeof TextDecoder < "u" && new TextDecoder();
var Nh = (t) => {
  if ("definitions" in t) {
    var e = [];
    for (var n of t.definitions) {
      var r = Nh(n);
      e.push(r);
    }
    return {
      ...t,
      definitions: e
    };
  }
  if ("directives" in t && t.directives && t.directives.length) {
    var i = [], o = {};
    for (var a of t.directives) {
      var s = a.name.value;
      s[0] !== "_" ? i.push(a) : s = s.slice(1), o[s] = a;
    }
    t = {
      ...t,
      directives: i,
      _directives: o
    };
  }
  if ("selectionSet" in t) {
    var c = [], l = t.kind === Es.OPERATION_DEFINITION;
    if (t.selectionSet) {
      for (var u of t.selectionSet.selections || []) {
        l = l || u.kind === Es.FIELD && u.name.value === "__typename" && !u.alias;
        var d = Nh(u);
        c.push(d);
      }
      return l || c.push({
        kind: Es.FIELD,
        name: {
          kind: Es.NAME,
          value: "__typename"
        },
        _generated: !0
      }), {
        ...t,
        selectionSet: {
          ...t.selectionSet,
          selections: c
        }
      };
    }
  }
  return t;
}, P0 = /* @__PURE__ */ new Map(), Cs = (t) => {
  var e = z2(t), n = P0.get(e.__key);
  return n || (P0.set(e.__key, n = Nh(e)), Object.defineProperty(n, "__key", {
    value: e.__key,
    enumerable: !1
  })), n;
};
function ko(t, e, n) {
  return {
    ...e,
    kind: t,
    context: e.context ? {
      ...e.context,
      ...n
    } : n || e.context
  };
}
const xO = ({ initialDelayMs: t, maxDelayMs: e, randomDelay: n, maxNumberAttempts: r, retryIf: i, retryWith: o }) => {
  const a = t || 1e3, s = e || 15e3, c = r || 2, l = n !== void 0 ? !!n : !0;
  return ({ forward: u, dispatchDebug: d }) => (f) => {
    const h = Ui(f), { source: g, next: v } = F2(), b = lg((m) => {
      const { key: y, context: p } = m, w = (p.retryCount || 0) + 1;
      let _ = p.retryDelay || a;
      const E = Math.random() + 1.5;
      l && _ * E < s && (_ *= E);
      const S = Qn((T) => (T.kind === "query" || T.kind === "teardown") && T.key === y)(h);
      return process.env.NODE_ENV !== "production" && d({
        type: "retryAttempt",
        message: `The operation has failed and a retry has been triggered (${w} / ${c})`,
        operation: m,
        data: {
          retryCount: w
        },
        source: "retryExchange"
      }), eO(S)(tO(() => _)(iO(ko(m.kind, m, {
        ...m.context,
        retryDelay: _,
        retryCount: w
      }))));
    })(g);
    return Qn((m) => {
      if (!(m.error && (i ? i(m.error, m.operation) : o || m.error.networkError)))
        return !0;
      if (!((m.operation.context.retryCount || 0) >= c - 1)) {
        const y = o ? o(m.error, m.operation) : m.operation;
        return y ? (v(y), !1) : !0;
      }
      return process.env.NODE_ENV !== "production" && d({
        type: "retryExhausted",
        message: "Maximum number of retries has been reached. No further retries will be performed.",
        operation: m.operation,
        source: "retryExchange"
      }), !0;
    })(Ui(u(Xs([h, b]))));
  };
};
var Zd = (t, e) => ko(t.kind, t, {
  ...t.context,
  authAttempt: e
});
function RO(t) {
  return ({ client: e, forward: n }) => {
    var r = /* @__PURE__ */ new WeakSet(), i = F2(), o = /* @__PURE__ */ new Map();
    function a(l) {
      l && (c = l), s = void 0;
      var u = o;
      o = /* @__PURE__ */ new Map(), u.forEach(i.next);
    }
    var s, c = null;
    return (l) => {
      s = Promise.resolve().then(() => t({
        mutate(m, y, p) {
          var w = e.createRequestOperation("mutation", Rh(m, y), p);
          return U2(D2(1)(Qn((_) => _.operation.key === w.key)(XA(() => {
            var _ = d(w);
            r.add(_), i.next(_);
          })(b))));
        },
        appendHeaders(m, y) {
          var p = typeof m.context.fetchOptions == "function" ? m.context.fetchOptions() : m.context.fetchOptions || {};
          return ko(m.kind, m, {
            ...m.context,
            fetchOptions: {
              ...p,
              headers: {
                ...p.headers,
                ...y
              }
            }
          });
        }
      })).then(a);
      function u(m) {
        o.set(m.key, Zd(m, !0)), c && !s && (s = c.refreshAuth().finally(a));
      }
      function d(m) {
        return c ? c.addAuthToOperation(m) : m;
      }
      var f = Ui(l), h = Qn((m) => m.kind === "teardown")(f), g = Qn((m) => m.kind !== "teardown")(f), v = Qn(Boolean)(Wo((m) => r.has(m) ? m : s ? (o.has(m.key) || o.set(m.key, Zd(m, !1)), null) : function(p) {
        return !p.context.authAttempt && c && c.willAuthError && c.willAuthError(p);
      }(m) ? (u(m), null) : d(Zd(m, !1)))(Xs([i.source, g]))), b = Ui(n(Xs([v, h])));
      return Qn((m) => m.error && function(p) {
        return c && c.didAuthError && c.didAuthError(p.error, p.operation);
      }(m) && !m.operation.context.authAttempt ? (u(m.operation), !1) : !0)(b);
    };
  };
}
const NO = ({
  getToken: t,
  refreshToken: e,
  logOut: n
}) => RO(async (r) => ({
  addAuthToOperation(i) {
    const o = t();
    return o ? r.appendHeaders(i, {
      "auth-token": o
    }) : i;
  },
  willAuthError(i) {
    return !t();
  },
  didAuthError: (i) => !!i.message.includes("Token Error"),
  async refreshAuth() {
    try {
      await e();
    } catch {
      await n();
    }
  }
}));
var gr = (t) => t.name.value, K2 = (t) => t.typeCondition.name.value, ug = (t) => t.alias ? t.alias.value : t.name.value, MO = [], hr = (t) => t.selectionSet ? t.selectionSet.selections : MO, W2 = (t) => t.typeCondition ? t.typeCondition.name.value : null, G2 = (t) => t.kind === ye.FIELD, PO = (t) => t.kind === ye.INLINE_FRAGMENT, dg = (t, e) => {
  var n = null;
  if (t.arguments)
    for (var r = 0, i = t.arguments.length; r < i; r++) {
      var o = t.arguments[r], a = _a(o.value, e);
      a != null && (n || (n = {}), n[gr(o)] = a);
    }
  return n;
}, DO = (t, e) => {
  if (!(!e || !t.variableDefinitions)) {
    for (var n = {}, r = 0, i = t.variableDefinitions.length; r < i; r++) {
      var o = gr(t.variableDefinitions[r].variable);
      n[o] = e[o];
    }
    return n;
  }
}, Y2 = (t, e) => {
  var n = {};
  if (!e)
    return n;
  if (t.variableDefinitions)
    for (var r = 0, i = t.variableDefinitions.length; r < i; r++) {
      var o = t.variableDefinitions[r], a = gr(o.variable);
      n[a] = e[a] === void 0 && o.defaultValue ? _a(o.defaultValue, e) : e[a];
    }
  for (var s in e)
    s in n || (n[s] = e[s]);
  return n;
}, Q2 = `
https://bit.ly/2XbVrpR#`, D0 = /* @__PURE__ */ new Set(), Ta = [], Cc = () => Ta.pop(), Ic = (t, e) => {
  var n = "";
  e.kind === ye.INLINE_FRAGMENT ? n = t ? `Inline Fragment on "${t}"` : "Inline Fragment" : e.kind === ye.OPERATION_DEFINITION ? n = `${e.name ? `"${e.name.value}"` : "Unnamed"} ${e.operation}` : e.kind === ye.FRAGMENT_DEFINITION && (n = `"${e.name.value}" Fragment`), n && Ta.push(n);
}, J2 = () => Ta.length ? `
(Caused At: ` + Ta.join(", ") + ")" : "";
function Gi(t, e, n) {
  if (!t) {
    var r = e || "Minfied Error #" + n + `
`;
    process.env.NODE_ENV !== "production" && (r += J2());
    var i = new Error(r + Q2 + n);
    throw i.name = "Graphcache Error", i;
  }
}
function cn(t, e) {
  D0.has(t) || (console.warn(t + J2() + Q2 + e), D0.add(t));
}
var ru = (t) => {
  for (var e = 0; e < t.definitions.length; e++)
    if (t.definitions[e].kind === ye.OPERATION_DEFINITION)
      return t.definitions[e];
  Gi(!1, process.env.NODE_ENV !== "production" ? "Invalid GraphQL document: All GraphQL documents must contain an OperationDefinitionnode for a query, subscription, or mutation." : "", 1);
}, Gu = (t) => {
  for (var e = {}, n = 0; n < t.definitions.length; n++) {
    var r = t.definitions[n];
    r.kind === ye.FRAGMENT_DEFINITION && (e[gr(r)] = r);
  }
  return e;
}, LO = (t, e) => {
  for (var n = 0; t.directives && n < t.directives.length; n++) {
    var r = t.directives[n], i = gr(r);
    if ((i === "include" || i === "skip") && r.arguments && r.arguments[0] && gr(r.arguments[0]) === "if") {
      var o = _a(r.arguments[0].value, e);
      return i === "include" ? !!o : !o;
    }
  }
  return !0;
}, FO = (t, e) => {
  for (var n = 0; t.directives && n < t.directives.length; n++) {
    var r = t.directives[n];
    if (gr(r) === "defer") {
      for (var i = 0; r.arguments && i < r.arguments.length; i++) {
        var o = r.arguments[n];
        if (gr(o) === "if")
          return !!_a(o.value, e);
      }
      return !0;
    }
  }
  return !1;
}, L0 = (t, e, n) => {
  var r = fg(t, e, n);
  return !!r && r.type.kind !== "NON_NULL";
}, Z2 = (t, e, n) => {
  var r = fg(t, e, n);
  if (!r)
    return !1;
  var i = r.type.kind === "NON_NULL" ? r.type.ofType : r.type;
  return i.kind === "LIST" && i.ofType.kind !== "NON_NULL";
}, X2 = (t, e, n) => n.indexOf("__") === 0 || e.indexOf("__") === 0 || !!fg(t, e, n), UO = (t, e, n) => {
  if (!n)
    return !1;
  var r = W2(e);
  return !r || n === r ? !0 : t.types.has(r) && t.types.get(r).kind === "OBJECT" ? r === n : (function(o, a) {
    Gi(o.types.has(a) && (o.types.get(a).kind === "INTERFACE" || o.types.get(a).kind === "UNION"), process.env.NODE_ENV !== "production" ? "Invalid Abstract type: The type `" + a + "` is not an Interface or Union type in the defined schema, but a fragment in the GraphQL document is using it as a type condition." : "", 5);
  }(t, r), e_(t, n), t.isSubType(r, n));
}, fg = (t, e, n) => {
  if (!(n.indexOf("__") === 0 || e.indexOf("__") === 0)) {
    e_(t, e);
    var r = t.types.get(e).fields()[n];
    return process.env.NODE_ENV !== "production" && (r || cn("Invalid field: The field `" + n + "` does not exist on `" + e + "`, but the GraphQL document expects it to exist.\nTraversal will continue, however this may lead to undefined behavior!", 4)), r;
  }
};
function e_(t, e) {
  Gi(t.types.has(e) && t.types.get(e).kind === "OBJECT", process.env.NODE_ENV !== "production" ? "Invalid Object type: The type `" + e + "` is not an object in the defined schema, but the GraphQL document is traversing it." : "", 3);
}
function Gc(t) {
  process.env.NODE_ENV !== "production" && cn(`Invalid resolver: \`${t}\` is not in the defined schema, but the \`resolvers\` option is referencing it.`, 23);
}
var uo = (t, e) => e ? `${t}(${tu(e)})` : t, ka = (t, e) => `${t}.${e}`, HO = (t) => {
  var e = t.indexOf("(");
  return e > -1 ? {
    fieldKey: t,
    fieldName: t.slice(0, e),
    arguments: JSON.parse(t.slice(e + 1, -1))
  } : {
    fieldKey: t,
    fieldName: t,
    arguments: null
  };
}, t_ = (t) => {
  var e = t.indexOf(".");
  return {
    entityKey: t.slice(0, e).replace(/%2e/g, "."),
    fieldKey: t.slice(e + 1)
  };
}, n_ = () => /* @__PURE__ */ Object.create(null), ec = null, iu = null, kr = null, rt = null, li = null, Ln = null, Ao = !1, Va = (t) => {
  var e;
  if (t) {
    if (ec.has(t))
      return t;
    e = iu.get(t) || {
      ...t
    }, iu.set(t, e);
  } else
    e = {};
  return ec.add(e), e;
}, Xd = (t) => !!t && ec.has(t), Aa = (t, e, n, r) => {
  ec = /* @__PURE__ */ new WeakSet(), iu = /* @__PURE__ */ new WeakMap(), kr = t, rt = e, li = /* @__PURE__ */ new Set(), Ao = !!r, process.env.NODE_ENV !== "production" && (Ta.length = 0), n ? kr === "read" ? Ln = n : r || e.optimisticOrder.length > 1 ? (!r && !e.commutativeKeys.has(n) ? El(e, n) : r && (e.optimisticOrder.indexOf(n) !== -1 && !e.commutativeKeys.has(n) && e.optimisticOrder.splice(e.optimisticOrder.indexOf(n), 1), e.commutativeKeys.delete(n)), Ln = n, VO(e, n)) : (Ln = null, s_(e, n)) : Ln = null;
}, Oa = () => {
  process.env.NODE_ENV !== "production" && hg();
  var t = rt, e = Ln;
  if (Ao = !1, Ln = null, e && t.optimisticOrder.indexOf(e) > -1)
    for (var n = t.optimisticOrder.length; --n >= 0 && t.dirtyKeys.has(t.optimisticOrder[n]) && t.commutativeKeys.has(t.optimisticOrder[n]); )
      $O(t.optimisticOrder[n]);
  ec = null, iu = null, kr = null, rt = null, li = null, process.env.NODE_ENV !== "production" && (Ta.length = 0), process.env.NODE_ENV !== "test" && !t.defer && (t.storage || !t.optimisticOrder.length) && (t.defer = !0, setTimeout(() => {
    Aa("read", t, null), jO(), qO(), Oa(), t.defer = !1;
  }));
}, F0 = (t, e, n) => {
  e && !n && t.deferredKeys.delete(e), Aa("write", t, e, n), Oa();
}, BO = () => (Gi(kr !== null, process.env.NODE_ENV !== "production" ? "Invalid Cache call: The cache may only be accessed or mutated duringoperations like write or query, or as part of its resolvers, updaters, or optimistic configs." : "", 2), kr), hg = () => (Gi(li !== null, process.env.NODE_ENV !== "production" ? "Invalid Cache call: The cache may only be accessed or mutated duringoperations like write or query, or as part of its resolvers, updaters, or optimistic configs." : "", 2), li), r_ = (t, e, n, r) => {
  process.env.NODE_ENV !== "production" && Gi(kr !== "read", process.env.NODE_ENV !== "production" ? "Invalid Cache write: You may not write to the cache during cache reads.  Accesses to `cache.writeFragment`, `cache.updateQuery`, and `cache.link` may  not be made inside `resolvers` for instance." : "", 27);
  var i = Ln ? t.optimistic.get(Ln) : t.base, o = i.get(e);
  o === void 0 && i.set(e, o = n_()), r === void 0 && !Ln ? delete o[n] : o[n] = r;
}, i_ = (t, e, n) => {
  for (var r, i = !Ao && kr === "read" && Ln && rt.commutativeKeys.has(Ln), o = 0, a = rt.optimisticOrder.length; o < a; o++) {
    var s = rt.optimisticOrder[o], c = t.optimistic.get(s);
    if (i = i && s !== Ln, c && (!i || !rt.commutativeKeys.has(s)) && (!Ao || kr === "write" || rt.commutativeKeys.has(s)) && (r = c.get(e)) !== void 0 && n in r)
      return r[n];
  }
  return (r = t.base.get(e)) !== void 0 ? r[n] : void 0;
}, ou = (t, e) => {
  if (Array.isArray(t))
    for (var n = 0, r = t.length; n < r; n++)
      ou(t[n], e);
  else
    typeof t == "string" && ((i, o) => {
      var a = rt.refCount.get(i) || 0, s = a + o > 0 ? a + o : 0;
      rt.refCount.set(i, s), s ? !a && s && rt.gc.delete(i) : rt.gc.add(i);
    })(t, e);
}, U0 = (t, e, n) => {
  if (n !== void 0)
    for (var r in n)
      e.has(r) || (t.push(HO(r)), e.add(r));
}, H0 = (t, e, n, r) => {
  U0(t, e, r.base.get(n));
  for (var i = 0, o = rt.optimisticOrder.length; i < o; i++) {
    var a = r.optimistic.get(rt.optimisticOrder[i]);
    a !== void 0 && U0(t, e, a.get(n));
  }
}, jO = () => {
  if (!rt.optimisticOrder.length) {
    for (var t of rt.gc.keys())
      if (rt.gc.delete(t), !((rt.refCount.get(t) || 0) > 0)) {
        rt.refCount.delete(t), rt.records.base.delete(t);
        var e = rt.links.base.get(t);
        if (e) {
          rt.links.base.delete(t);
          for (var n in e)
            ou(e[n], -1);
        }
      }
  }
}, Sc = (t, e) => {
  e !== "__typename" && (t !== rt.queryRootKey ? li.add(t) : e !== void 0 && li.add(ka(t, e)));
}, o_ = (t, e) => {
  !Ao && rt.storage && rt.persist.add(((n, r) => `${n.replace(/\./g, "%2e")}.${r}`)(t, e));
}, xa = (t, e) => (Sc(t, e), i_(rt.records, t, e)), Ra = (t, e) => (Sc(t, e), i_(rt.links, t, e)), tc = (t, e, n) => {
  Sc(t, e), o_(t, e), r_(rt.records, t, e, n);
}, nc = (t, e, n) => {
  var r = Ln ? rt.links.optimistic.get(Ln) : rt.links.base;
  Ln || (ou(function(o) {
    for (var a = void 0, s = o[0], c = 1; c < o.length; ) {
      var l = o[c], u = o[c + 1];
      if (c += 2, (l === "optionalAccess" || l === "optionalCall") && s == null)
        return;
      l === "access" || l === "optionalAccess" ? (a = s, s = u(s)) : (l === "call" || l === "optionalCall") && (s = u((...d) => s.call(a, ...d)), a = void 0);
    }
    return s;
  }([r, "optionalAccess", (i) => i.get, "call", (i) => i(t), "optionalAccess", (i) => i[e]]), -1), ou(n, 1)), Sc(t, e), o_(t, e), r_(rt.links, t, e, n);
}, El = (t, e, n) => {
  var r = t.optimisticOrder.indexOf(e);
  if (r > -1 && t.optimisticOrder.splice(r, 1), n)
    for (t.deferredKeys.add(e), r = r > -1 ? r : 0; r < t.optimisticOrder.length && !t.deferredKeys.has(t.optimisticOrder[r]) && (!t.dirtyKeys.has(t.optimisticOrder[r]) || !t.commutativeKeys.has(t.optimisticOrder[r])); r++)
      ;
  else
    t.deferredKeys.delete(e), r > -1 && !t.commutativeKeys.has(e) && a_(t, e), r = 0;
  t.optimisticOrder.splice(r, 0, e), t.commutativeKeys.add(e);
}, VO = (t, e) => {
  t.optimisticOrder.indexOf(e) === -1 && t.optimisticOrder.unshift(e), t.dirtyKeys.has(e) || (t.dirtyKeys.add(e), t.links.optimistic.set(e, /* @__PURE__ */ new Map()), t.records.optimistic.set(e, /* @__PURE__ */ new Map()));
}, a_ = (t, e) => {
  t.dirtyKeys.has(e) && (t.dirtyKeys.delete(e), t.records.optimistic.delete(e), t.links.optimistic.delete(e), t.deferredKeys.delete(e));
}, s_ = (t, e) => {
  var n = t.optimisticOrder.indexOf(e);
  n > -1 && (t.optimisticOrder.splice(n, 1), t.commutativeKeys.delete(e)), a_(t, e);
}, $O = (t) => {
  var e = li;
  li = /* @__PURE__ */ new Set(), kr = "write";
  var n = rt.links.optimistic.get(t);
  if (n)
    for (var r of n.entries()) {
      var i = r[0], o = r[1];
      for (var a in o)
        nc(i, a, o[a]);
    }
  var s = rt.records.optimistic.get(t);
  if (s)
    for (var c of s.entries()) {
      var l = c[0], u = c[1];
      for (var d in u)
        tc(l, d, u[d]);
    }
  li = e, s_(rt, t);
}, B0 = (t) => {
  var { links: e, records: n } = rt, r = [], i = /* @__PURE__ */ new Set();
  return Sc(t), H0(r, i, t, e), H0(r, i, t, n), r;
}, qO = () => {
  if (rt.storage) {
    Ao = !0, kr = "read";
    var t = n_();
    for (var e of rt.persist.keys()) {
      var { entityKey: n, fieldKey: r } = t_(e), i = void 0;
      (i = Ra(n, r)) !== void 0 ? t[e] = `:${tu(i)}` : (i = xa(n, r)) !== void 0 ? t[e] = tu(i) : t[e] = void 0;
    }
    Ao = !1, rt.storage.writeData(t), rt.persist.clear();
  }
}, Cl = {
  current: null
}, fo = {
  current: !1
}, Yu = (t) => t.__internal.path.length > 0 && t.__internal.errorMap ? t.__internal.errorMap[t.__internal.path.join(".")] : void 0, Qu = (t, e, n, r, i, o, a) => {
  var s = {
    store: t,
    variables: e,
    fragments: n,
    parent: {
      __typename: r
    },
    parentTypeName: r,
    parentKey: i,
    parentFieldKey: "",
    fieldName: "",
    error: void 0,
    partial: !1,
    optimistic: !!o,
    __internal: {
      path: [],
      errorMap: void 0
    }
  };
  if (a && a.graphQLErrors)
    for (var c = 0; c < a.graphQLErrors.length; c++) {
      var l = a.graphQLErrors[c];
      l.path && l.path.length && (s.__internal.errorMap || (s.__internal.errorMap = /* @__PURE__ */ Object.create(null)), s.__internal.errorMap[l.path.join(".")] = l);
    }
  return s;
}, Mh = (t, e, n, r, i, o) => {
  Cl.current = t, t.parent = e, t.parentTypeName = n, t.parentKey = r, t.parentFieldKey = i, t.fieldName = o, t.error = Yu(t);
}, zO = (t, e, n, r) => {
  if (!e)
    return !1;
  var i = W2(t);
  return !i || e === i ? !0 : (process.env.NODE_ENV !== "production" && cn("Heuristic Fragment Matching: A fragment is trying to match against the `" + e + "` type, but the type condition is `" + i + "`. Since GraphQL allows for interfaces `" + i + "` may be an interface.\nA schema needs to be defined for this match to be deterministic, otherwise the fragment will be matched heuristically!", 16), kr === "write" || !hr(t).some((o) => {
    if (!G2(o))
      return !1;
    var a = uo(gr(o), dg(o, r));
    return !((s, c) => xa(s, c) !== void 0 || Ra(s, c) !== void 0)(n, a);
  }));
}, Ju = (t, e, n, r) => {
  var i = !1, o, a = 0;
  return function() {
    if (!fo.current && i && (fo.current = i), o) {
      var c = o();
      if (c != null)
        return c;
      o = void 0, i = !1, process.env.NODE_ENV !== "production" && Cc();
    }
    for (; a < n.length; ) {
      var l = n[a++];
      if (LO(l, r.variables)) {
        if (G2(l))
          return l;
        var u = PO(l) ? l : r.fragments[gr(l)];
        if (u !== void 0 && (r.store.schema ? UO(r.store.schema, u, t) : zO(u, t, e, r.variables)))
          return process.env.NODE_ENV !== "production" && Ic(t, u), i = !!FO(l, r.variables), !fo.current && i && (fo.current = i), (o = Ju(t, e, hr(u), r))();
      } else
        continue;
    }
  };
}, Il = (t) => t ?? null, Ph = (t, e) => {
  if (e == null)
    return e;
  if (Array.isArray(e)) {
    for (var n = new Array(e.length), r = 0, i = n.length; r < i; r++)
      n[r] = Ph(t, e[r]);
    return n;
  }
  var o = t.keyOfEntity(e);
  return process.env.NODE_ENV !== "production" && !o && e && typeof e == "object" && cn("Can't generate a key for link(...) item.\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + e.__typename + "`.", 12), o;
}, KO = (t, e, n, r, i) => {
  Aa("write", t.data, i || null);
  var o = pg(t, e, n, r);
  return Oa(), o;
}, pg = (t, e, n, r, i) => {
  var o = ru(e.query), a = {
    data: n,
    dependencies: hg()
  }, s = t.rootFields[o.operation], c = Qu(t, Y2(o, e.variables), Gu(e.query), s, s, !!i, r);
  return process.env.NODE_ENV !== "production" && Ic(s, o), gg(c, s, hr(o), n), process.env.NODE_ENV !== "production" && Cc(), a;
}, gg = (t, e, n, r) => {
  var i = t.store.rootNames[e] || "query", o = !!t.store.rootNames[e], a = o ? e : r.__typename;
  if (a)
    !o && e && tc(e, "__typename", a);
  else {
    process.env.NODE_ENV !== "production" && cn("Couldn't find __typename when writing.\nIf you're writing to the cache manually have to pass a `__typename` property on each entity in your data.", 14);
    return;
  }
  for (var s = t.store.updates[a], c = Ju(a, e || a, n, t), l; l = c(); ) {
    var u = gr(l), d = dg(l, t.variables), f = uo(u, d), h = ug(l), g = r[t.optimistic ? u : h];
    if (process.env.NODE_ENV !== "production")
      if (i === "query" && g === void 0 && !fo.current && !t.optimistic) {
        process.env.NODE_ENV !== "production" && cn("Invalid undefined: The field at `" + f + "` is `undefined`, but the GraphQL query expects a " + (l.selectionSet === void 0 ? "scalar (number, boolean, etc)" : "selection set") + " for this field.", 13);
        continue;
      } else
        t.store.schema && a && u !== "__typename" && X2(t.store.schema, a, u);
    if (!(u === "__typename" || g === void 0 && (fo.current || t.optimistic && i === "query"))) {
      t.__internal.path.push(h);
      var v = void 0;
      if (t.optimistic && i === "mutation") {
        if (!(v = t.store.optimisticMutations[u]))
          continue;
      } else
        t.optimistic && typeof g == "function" && (v = g);
      if (v && (Mh(t, r, a, a, f, u), g = Il(v(d || {}, t.store, t))), l.selectionSet)
        if (e && i === "query") {
          var b = ka(e, f), m = Dh(t, hr(l), Il(g), b);
          nc(e || a, f, m);
        } else
          Dh(t, hr(l), Il(g));
      else
        e && i === "query" && tc(e || a, f, g !== null || !Yu(t) ? g : void 0);
      var y = s && s[u];
      y && (Mh(t, r, a, a, ka(a, f), u), r[u] = g, y(r, d || {}, t.store, t)), t.__internal.path.pop();
    }
  }
}, WO = /^__|PageInfo|(Connection|Edge)$/, Dh = (t, e, n, r) => {
  if (Array.isArray(n)) {
    for (var i = new Array(n.length), o = 0, a = n.length; o < a; o++) {
      t.__internal.path.push(o);
      var s = r ? ka(r, `${o}`) : void 0, c = Dh(t, e, n[o], s);
      i[o] = c, t.__internal.path.pop();
    }
    return i;
  } else if (n === null)
    return Yu(t) ? void 0 : null;
  var l = t.store.keyOfEntity(n), u = n.__typename;
  process.env.NODE_ENV !== "production" && r && !t.store.keys[n.__typename] && l === null && typeof u == "string" && !WO.test(u) && cn("Invalid key: The GraphQL query at the field at `" + r + "` has a selection set, but no key could be generated for the data at this field.\nYou have to request `id` or `_id` fields for all selection sets or create a custom `keys` config for `" + u + "`.\nEntities without keys will be embedded directly on the parent entity. If this is intentional, create a `keys` config for `" + u + "` that always returns null.", 15);
  var d = l || r;
  return gg(t, d, e, n), d || null;
};
let GO = class Lh {
  constructor(e) {
    Lh.prototype.__init.call(this), Lh.prototype.__init2.call(this), e || (e = {}), this.resolvers = e.resolvers || {}, this.optimisticMutations = e.optimistic || {}, this.keys = e.keys || {};
    var n = "Query", r = "Mutation", i = "Subscription";
    if (e.schema) {
      var o = (({ __schema: s }) => {
        var c = /* @__PURE__ */ new Map(), l = (v) => {
          var b;
          return () => {
            if (!b) {
              b = {};
              for (var m = 0; m < v.length; m++)
                b[v[m].name] = v[m];
            }
            return b;
          };
        }, u = (v) => {
          switch (v.kind) {
            case "OBJECT":
            case "INTERFACE":
              return {
                name: v.name,
                kind: v.kind,
                interfaces: l(v.interfaces || []),
                fields: l(v.fields.map((b) => ({
                  name: b.name,
                  type: b.type,
                  args: l(b.args)
                })))
              };
            case "UNION":
              return {
                name: v.name,
                kind: v.kind,
                types: l(v.possibleTypes || [])
              };
          }
        }, d = {
          query: s.queryType ? s.queryType.name : null,
          mutation: s.mutationType ? s.mutationType.name : null,
          subscription: s.subscriptionType ? s.subscriptionType.name : null,
          types: void 0,
          isSubType(v, b) {
            var m = c.get(v), y = c.get(b);
            return !m || !y ? !1 : m.kind === "UNION" ? !!m.types()[b] : m.kind !== "OBJECT" && y.kind === "OBJECT" ? !!y.interfaces()[v] : v === b;
          }
        };
        if (s.types) {
          d.types = c;
          for (var f = 0; f < s.types.length; f++) {
            var h = s.types[f];
            if (h && h.name) {
              var g = u(h);
              g && c.set(h.name, g);
            }
          }
        }
        return d;
      })(e.schema);
      n = o.query || n, r = o.mutation || r, i = o.subscription || i, o.types && (this.schema = o);
    }
    this.updates = e.updates || {}, this.rootFields = {
      query: n,
      mutation: r,
      subscription: i
    }, this.rootNames = {
      [n]: "query",
      [r]: "mutation",
      [i]: "subscription"
    }, this.data = (a = n, {
      defer: !1,
      gc: /* @__PURE__ */ new Set(),
      persist: /* @__PURE__ */ new Set(),
      queryRootKey: a,
      refCount: /* @__PURE__ */ new Map(),
      links: {
        optimistic: /* @__PURE__ */ new Map(),
        base: /* @__PURE__ */ new Map()
      },
      records: {
        optimistic: /* @__PURE__ */ new Map(),
        base: /* @__PURE__ */ new Map()
      },
      deferredKeys: /* @__PURE__ */ new Set(),
      commutativeKeys: /* @__PURE__ */ new Set(),
      dirtyKeys: /* @__PURE__ */ new Set(),
      optimisticOrder: [],
      storage: null
    });
    var a;
    this.schema && process.env.NODE_ENV !== "production" && (function(c, l) {
      if (process.env.NODE_ENV !== "production")
        for (var u in l)
          process.env.NODE_ENV !== "production" && (c.types.has(u) || cn("Invalid Object type: The type `" + u + "` is not an object in the defined schema, but the `keys` option is referencing it.", 20));
    }(this.schema, this.keys), function(c, l) {
      if (process.env.NODE_ENV !== "production")
        for (var u in l) {
          if (l[u]) {
            if (!c.types.has(u)) {
              var d = "";
              return u === "Mutation" && c.mutation && c.mutation !== "Mutation" ? d += "\nMaybe your config should reference `" + c.mutation + "`?" : u === "Subscription" && c.subscription && c.subscription !== "Subscription" && (d += "\nMaybe your config should reference `" + c.subscription + "`?"), process.env.NODE_ENV !== "production" ? cn("Invalid updates type: The type `" + u + "` is not an object in the defined schema, but the `updates` config is referencing it." + d, 21) : void 0;
            }
          } else
            continue;
          var f = c.types.get(u).fields();
          for (var h in l[u])
            process.env.NODE_ENV !== "production" && (f[h] || cn("Invalid updates field: `" + h + "` on `" + u + "` is not in the defined schema, but the `updates` config is referencing it.", 22));
        }
    }(this.schema, this.updates), function(c, l) {
      if (process.env.NODE_ENV !== "production") {
        for (var u in l)
          if (u === "Query")
            if (c.query) {
              var d = c.types.get(c.query).fields();
              for (var f in l.Query || {})
                d[f] || Gc("Query." + f);
            } else
              Gc("Query");
          else if (!c.types.has(u))
            Gc(u);
          else if (c.types.get(u).kind === "INTERFACE" || c.types.get(u).kind === "UNION")
            v = u, b = c.types.get(u).kind, process.env.NODE_ENV !== "production" && cn(`Invalid resolver: \`${v}\` does not match to a concrete type in the schema, but the \`resolvers\` option is referencing it. Implement the resolver for the types that ${b === "UNION" ? "make up the union" : "implement the interface"} instead.`, 26);
          else {
            var h = c.types.get(u).fields();
            for (var g in l[u] || {})
              h[g] || Gc(u + "." + g);
          }
        var v, b;
      }
    }(this.schema, this.resolvers), function(c, l) {
      if (process.env.NODE_ENV !== "production" && c.mutation) {
        var u = c.types.get(c.mutation).fields();
        for (var d in l)
          process.env.NODE_ENV !== "production" && (u[d] || cn(`Invalid optimistic mutation field: \`${d}\` is not a mutation field in the defined schema, but the \`optimistic\` option is referencing it.`, 24));
      }
    }(this.schema, this.optimisticMutations));
  }
  __init() {
    this.keyOfField = uo;
  }
  keyOfEntity(e) {
    if (Cl.current && e === Cl.current.parent)
      return Cl.current.parentKey;
    if (e == null || typeof e == "string")
      return e || null;
    if (!e.__typename)
      return null;
    if (this.rootNames[e.__typename])
      return e.__typename;
    var n;
    return this.keys[e.__typename] ? n = this.keys[e.__typename](e) : e.id != null ? n = `${e.id}` : e._id != null && (n = `${e._id}`), n ? `${e.__typename}:${n}` : null;
  }
  resolve(e, n, r) {
    var i = uo(n, r), o = this.keyOfEntity(e);
    if (!o)
      return null;
    var a = xa(o, i);
    return a !== void 0 ? a : Ra(o, i) || null;
  }
  __init2() {
    this.resolveFieldByKey = this.resolve;
  }
  invalidate(e, n, r) {
    var i = this.keyOfEntity(e);
    Gi(i, process.env.NODE_ENV !== "production" ? "Can't generate a key for invalidate(...).\nYou have to pass an id or _id field or create a custom `keys` field for `" + (typeof e == "object" ? e.__typename : e + "`.") : "", 19), ((o, a, s) => {
      for (var c = a ? [{
        fieldKey: uo(a, s)
      }] : B0(o), l = 0, u = c.length; l < u; l++) {
        var { fieldKey: d } = c[l];
        Ra(o, d) !== void 0 ? nc(o, d, void 0) : tc(o, d, void 0);
      }
    })(i, n, r);
  }
  inspectFields(e) {
    var n = this.keyOfEntity(e);
    return n ? B0(n) : [];
  }
  updateQuery(e, n) {
    var r = Rh(e.query, e.variables);
    r.query = Cs(r.query);
    var i = n(this.readQuery(r));
    i !== null && pg(this, r, i);
  }
  readQuery(e) {
    var n = Rh(e.query, e.variables);
    return n.query = Cs(n.query), c_(this, n).data;
  }
  readFragment(e, n, r, i) {
    return YO(this, Cs(e), n, r, i);
  }
  writeFragment(e, n, r, i) {
    ((o, a, s, c, l) => {
      var u = Gu(a), d;
      if (l) {
        if (!(d = u[l]))
          return process.env.NODE_ENV !== "production" && cn(`writeFragment(...) was called with a fragment name that does not exist.
You provided ` + l + " but could only find " + Object.keys(u).join(", ") + ".", 11), null;
      } else if (!(d = u[Object.keys(u)[0]]))
        return process.env.NODE_ENV !== "production" && cn(`writeFragment(...) was called with an empty fragment.
You have to call it with at least one fragment in your GraphQL document.`, 11), null;
      var f = K2(d), h = {
        __typename: f,
        ...s
      }, g = o.keyOfEntity(h);
      if (!g)
        return process.env.NODE_ENV !== "production" ? cn("Can't generate a key for writeFragment(...) data.\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + f + "`.", 12) : void 0;
      process.env.NODE_ENV !== "production" && Ic(f, d);
      var v = Qu(o, c || {}, u, f, g, void 0);
      gg(v, g, hr(d), h), process.env.NODE_ENV !== "production" && Cc();
    })(this, Cs(e), n, r, i);
  }
  link(e, n, r, i) {
    var o = i !== void 0 ? r : null, a = i !== void 0 ? i : r, s = Ph(this, e);
    typeof s == "string" && nc(s, uo(n, o), Ph(this, a));
  }
};
var j0 = (t, e, n, r, i) => {
  Aa("read", t.data, i);
  var o = c_(t, e, n, r);
  return Oa(), o;
}, c_ = (t, e, n, r) => {
  var i = ru(e.query), o = t.rootFields[i.operation], a = hr(i), s = Qu(t, Y2(i, e.variables), Gu(e.query), o, o, !1, r);
  process.env.NODE_ENV !== "production" && Ic(o, i), n || (n = Va());
  var c = o !== s.store.rootFields.query ? l_(s, o, a, n) : Na(s, o, a, n);
  return process.env.NODE_ENV !== "production" && Cc(), {
    dependencies: hg(),
    partial: s.partial || !c,
    data: c || null
  };
}, l_ = (t, e, n, r) => {
  if (typeof (t.store.rootNames[e] ? e : r.__typename) != "string")
    return r;
  for (var i = Ju(e, e, n, t), o, a = !1, s = Va(r); o = i(); ) {
    var c = ug(o), l = r[c];
    t.__internal.path.push(c);
    var u = void 0;
    o.selectionSet && l !== null ? u = u_(t, hr(o), Il(l)) : u = l, a = a || u !== l, u !== void 0 && (s[c] = u), t.__internal.path.pop();
  }
  return a ? s : r;
}, u_ = (t, e, n) => {
  if (Array.isArray(n)) {
    for (var r = new Array(n.length), i = !1, o = 0, a = n.length; o < a; o++)
      t.__internal.path.push(o), r[o] = u_(t, e, n[o]), i = i || r[o] !== n[o], t.__internal.path.pop();
    return i ? r : n;
  } else if (n === null)
    return null;
  var s = t.store.keyOfEntity(n);
  return s !== null ? Na(t, s, e, n) || null : l_(t, n.__typename, e, n);
}, YO = (t, e, n, r, i) => {
  var o = Gu(e), a;
  if (i) {
    if (!(a = o[i]))
      return process.env.NODE_ENV !== "production" && cn(`readFragment(...) was called with a fragment name that does not exist.
You provided ` + i + " but could only find " + Object.keys(o).join(", ") + ".", 6), null;
  } else if (!(a = o[Object.keys(o)[0]]))
    return process.env.NODE_ENV !== "production" && cn(`readFragment(...) was called with an empty fragment.
You have to call it with at least one fragment in your GraphQL document.`, 6), null;
  var s = K2(a);
  typeof n != "string" && !n.__typename && (n.__typename = s);
  var c = t.keyOfEntity(n);
  if (!c)
    return process.env.NODE_ENV !== "production" && cn("Can't generate a key for readFragment(...).\nYou have to pass an `id` or `_id` field or create a custom `keys` config for `" + s + "`.", 7), null;
  process.env.NODE_ENV !== "production" && Ic(s, a);
  var l = Qu(t, r || {}, o, s, c), u = Na(l, c, hr(a), Va()) || null;
  return process.env.NODE_ENV !== "production" && Cc(), u;
}, Na = (t, e, n, r, i) => {
  var { store: o } = t, a = e === o.rootFields.query, s = i && o.keyOfEntity(i) || e;
  process.env.NODE_ENV !== "production" && !a && t.store.rootNames[s] && cn("Invalid root traversal: A selection was being read on `" + s + "` which is an uncached root type.\nThe `" + t.store.rootFields.mutation + "` and `" + t.store.rootFields.subscription + "` types are special Operation Root Types and cannot be read back from the cache.", 25);
  var c = a ? e : xa(s, "__typename") || i && i.__typename;
  if (typeof c == "string") {
    if (i && c !== i.__typename) {
      process.env.NODE_ENV !== "production" && cn("Invalid resolver data: The resolver at `" + s + "` returned an invalid typename that could not be reconciled with the cache.", 8);
      return;
    }
    for (var l = o.resolvers[c], u = Ju(c, s, n, t), d = !1, f = !1, h = c !== r.__typename, g, v = Va(r); (g = u()) !== void 0; ) {
      var b = gr(g), m = dg(g, t.variables), y = ug(g), p = uo(b, m), w = ka(s, p), _ = xa(s, p), E = i ? i[b] : void 0;
      process.env.NODE_ENV !== "production" && o.schema && c && X2(o.schema, c, b), t.__internal.path.push(y);
      var S = void 0;
      if (b === "__typename")
        S = c;
      else if (E !== void 0 && g.selectionSet === void 0)
        S = E;
      else if (BO() === "read" && l && l[b]) {
        if (Mh(t, v, c, s, w, b), _ !== void 0 && (v[y] = _), S = l[b](v, m || {}, o, t), g.selectionSet && (S = Fh(t, c, b, w, hr(g), v[y] !== void 0 ? v[y] : r[y], S, Xd(r))), o.schema && S === null && !L0(o.schema, c, b))
          return;
      } else if (!g.selectionSet)
        S = _;
      else if (E !== void 0)
        S = Fh(t, c, b, w, hr(g), v[y] !== void 0 ? v[y] : r[y], E, Xd(r));
      else {
        var T = Ra(s, p);
        T !== void 0 ? S = d_(t, T, c, b, hr(g), v[y] !== void 0 ? v[y] : r[y], Xd(r)) : typeof _ == "object" && _ !== null && (S = _);
      }
      if (S === void 0 && fo.current)
        d = !0;
      else if (S === void 0 && (o.schema && L0(o.schema, c, b) || Yu(t)))
        f = !0, S = null;
      else if (S === void 0) {
        t.__internal.path.pop();
        return;
      } else
        d = d || b !== "__typename";
      t.__internal.path.pop(), h = h || S !== r[y], S !== void 0 && (v[y] = S);
    }
    return t.partial = t.partial || f, a && f && !d ? void 0 : h ? v : r;
  }
}, Fh = (t, e, n, r, i, o, a, s) => {
  if (Array.isArray(a)) {
    for (var { store: c } = t, l = c.schema ? Z2(c.schema, e, n) : !1, u = new Array(a.length), d = !Array.isArray(o) || a.length !== o.length, f = 0, h = a.length; f < h; f++) {
      t.__internal.path.push(f);
      var g = Fh(t, e, n, ka(r, `${f}`), i, o != null ? o[f] : void 0, a[f], s);
      if (t.__internal.path.pop(), g === void 0 && !l)
        return;
      t.partial = t.partial || g === void 0 && l, u[f] = g ?? null, d = d || u[f] !== o[f];
    }
    return d ? u : o;
  } else {
    if (a == null)
      return a;
    if (s && o === null)
      return null;
    if (QO(a)) {
      var v = o || Va();
      return typeof a == "string" ? Na(t, a, i, v) : Na(t, r, i, v, a);
    } else {
      process.env.NODE_ENV !== "production" && cn("Invalid resolver value: The field at `" + r + "` is a scalar (number, boolean, etc), but the GraphQL query expects a selection set for this field.", 9);
      return;
    }
  }
}, d_ = (t, e, n, r, i, o, a) => {
  if (Array.isArray(e)) {
    for (var { store: s } = t, c = s.schema ? Z2(s.schema, n, r) : !1, l = new Array(e.length), u = !Array.isArray(o) || l.length !== o.length, d = 0, f = e.length; d < f; d++) {
      t.__internal.path.push(d);
      var h = d_(t, e[d], n, r, i, o != null ? o[d] : void 0, a);
      if (t.__internal.path.pop(), h === void 0 && !c)
        return;
      t.partial = t.partial || h === void 0 && c, l[d] = h || null, u = u || l[d] !== o[d];
    }
    return u ? l : o;
  } else if (e === null || o === null && a)
    return null;
  return Na(t, e, i, o || Va());
}, QO = (t) => typeof t == "string" || typeof t == "object" && typeof t.__typename == "string", V0 = (t, e) => ko(t.kind, t, {
  ...t.context,
  meta: {
    ...t.context.meta,
    cacheOutcome: e
  }
}), $0 = (t, e) => ko(t.kind, t, {
  ...t.context,
  requestPolicy: e
}), JO = (t) => ({ forward: e, client: n, dispatchDebug: r }) => {
  var i = new GO(t);
  t && t.storage && t.storage.readData().then((_) => {
    ((E, S, T) => {
      Aa("write", E, null);
      for (var x in T) {
        var A = T[x];
        if (A !== void 0) {
          var { entityKey: N, fieldKey: F } = t_(x);
          A[0] === ":" ? Ra(N, F) === void 0 && nc(N, F, JSON.parse(A.slice(1))) : xa(N, F) === void 0 && tc(N, F, JSON.parse(A));
        }
      }
      Oa(), E.storage = S;
    })(i.data, t.storage, _);
  });
  var o = /* @__PURE__ */ new Map(), a = [], s = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Set(), h = /* @__PURE__ */ new Set(), g = (_) => {
    for (var E of _.values())
      if (l.has(E))
        return !0;
    return !1;
  }, v = (_, E) => {
    if (E)
      for (var S of E.values()) {
        var T = d.get(S);
        if (T)
          for (var x of T.values())
            _.add(x);
      }
  }, b = (_, E) => {
    for (var S of E.values())
      if (S !== _.key) {
        var T = s.get(S);
        if (T) {
          _.kind === "query" && h.add(S), s.delete(S);
          var x = "cache-first";
          u.has(S) && (u.delete(S), x = "cache-and-network"), n.reexecuteOperation($0(T, x));
        }
      }
    var A = f;
    _.kind === "query" && (f = h).add(_.key), (h = A).clear();
  }, m = (_) => {
    if (_.kind === "query")
      El(i.data, _.key);
    else if (_.kind === "teardown")
      s.delete(_.key), c.delete(_.key), f.delete(_.key), F0(i.data, _.key);
    else if (_.kind === "mutation" && _.context.requestPolicy !== "network-only") {
      var { dependencies: E } = ((x, A, N) => {
        process.env.NODE_ENV !== "production" && Gi(ru(A.query).operation === "mutation", process.env.NODE_ENV !== "production" ? `writeOptimistic(...) was called with an operation that is not a mutation.
This case is unsupported and should never occur.` : "", 10), Aa("write", x.data, N, !0);
        var F = pg(x, A, {}, void 0, !0);
        return Oa(), F;
      })(i, _, _.key);
      if (E.size) {
        for (var S of E.values())
          l.add(S);
        o.set(_.key, E);
        var T = /* @__PURE__ */ new Set();
        v(T, E), b(_, T);
      }
    }
    return ko(_.kind, {
      key: _.key,
      query: Cs(_.query),
      variables: _.variables ? DO(ru(_.query), _.variables) : _.variables
    }, _.context);
  }, y = (_, E) => {
    for (var S of E.values()) {
      var T = d.get(S);
      T || d.set(S, T = /* @__PURE__ */ new Set()), T.add(_.key);
    }
  }, p = (_) => {
    var E = j0(i, _, c.get(_.key)), S = E.data ? E.partial ? "partial" : "hit" : "miss";
    return c.set(_.key, E.data), s.set(_.key, _), y(_, E.dependencies), {
      outcome: S,
      operation: _,
      data: E.data,
      dependencies: E.dependencies
    };
  }, w = (_, E) => {
    var { error: S, extensions: T } = _, x = s.get(_.operation.key), A = x ? ko(x.kind, x, _.operation.context) : _.operation;
    if (A.kind === "mutation") {
      var N = o.get(A.key);
      v(E, N), o.delete(A.key);
    }
    (A.kind === "subscription" || _.hasNext) && El(i.data, A.key, !0);
    var F, D = _.data;
    if (D) {
      var L = KO(i, A, D, _.error, A.key).dependencies;
      v(E, L);
      var z = j0(i, A, A.kind === "query" && c.get(A.key) || D, _.error, A.key);
      D = z.data, A.kind === "query" && (v(E, F = z.dependencies), c.set(A.key, D));
    } else
      F0(i.data, A.key);
    return F && (s.set(A.key, A), y(_.operation, F)), {
      data: D,
      error: S,
      extensions: T,
      operation: A
    };
  };
  return (_) => {
    var E = Ui(_), S = Ui(Wo(p)(Qn((L) => L.kind === "query" && L.context.requestPolicy !== "network-only")(E))), T = Qn((L) => L.kind !== "query" || L.context.requestPolicy === "network-only")(E), x = Wo((L) => (process.env.NODE_ENV !== "production" && r({
      type: "cacheMiss",
      message: "The result could not be retrieved from the cache",
      operation: L.operation,
      source: "cacheExchange"
    }), V0(L.operation, "miss")))(Qn((L) => L.outcome === "miss" && L.operation.context.requestPolicy !== "cache-only" && !g(L.dependencies) && !f.has(L.operation.key))(S)), A = Wo((L) => {
      var { requestPolicy: z } = L.operation.context, ne = L.outcome === "partial" && z !== "cache-only", ae = z === "cache-and-network" || z === "cache-first" && ne && !f.has(L.operation.key), Re = {
        operation: V0(L.operation, L.outcome),
        data: L.data,
        error: L.error,
        extensions: L.extensions,
        stale: ae || ne
      };
      return ae && (g(L.dependencies) ? z === "cache-and-network" && u.add(L.operation.key) : n.reexecuteOperation($0(L.operation, "network-only"))), process.env.NODE_ENV !== "production" && r({
        type: "cacheHit",
        message: "A requested operation was found and returned from the cache.",
        operation: L.operation,
        data: {
          value: Re
        },
        source: "cacheExchange"
      }), Re;
    })(Qn((L) => L.outcome !== "miss" || L.operation.context.requestPolicy === "cache-only")(S)), N = Ui(e(Wo(m)(Xs([T, x])))), F = Wo((L) => {
      var z = /* @__PURE__ */ new Set(), ne = w(L, z);
      return b(L.operation, z), ne;
    })(Qn((L) => !o.has(L.operation.key))(N)), D = lg((L) => {
      if (a.push(L) < o.size)
        return aO;
      for (var z = 0; z < a.length; z++)
        El(i.data, a[z].operation.key);
      l.clear();
      for (var ne = [], ae = /* @__PURE__ */ new Set(), Re; Re = a.shift(); )
        ne.push(w(Re, ae));
      return b(L.operation, ae), L2(ne);
    })(Qn((L) => o.has(L.operation.key))(N));
    return Xs([F, D, A]);
  };
};
const pe = (t, e) => {
  const n = "Query";
  t.inspectFields(n).filter((r) => r.fieldName === e).forEach((r) => {
    t.invalidate(n, r.fieldKey);
  });
}, Yc = (t, e, n) => {
  const r = W3`
    query ($userId: ID!) {
      ${e}(userId: $userId) {
        id
      }
    }
  `;
  t.inspectFields("Query").filter((i) => i.fieldName === e).forEach((i) => {
    var o;
    t.updateQuery(
      {
        query: r,
        variables: { userId: (o = i.arguments) == null ? void 0 : o.userId }
      },
      (a) => (a[e] = a[e].filter(
        (s) => s.id !== n
      ), a)
    );
  });
}, ZO = ({
  schema: t,
  queries: e
}) => JO({
  // objects without an id (embedded objects) should explicitly return a null id
  keys: {
    Address: () => null,
    BreakdownSlice: () => null,
    checkIn: () => null,
    checkInPayload: () => null,
    CollegeCost: () => null,
    ComparisonBlock: () => null,
    ComparisonFeature: () => null,
    ComparisonPackage: () => null,
    DebtSummary: () => null,
    EmergencyFundProgress: () => null,
    EmergencyFundSummary: () => null,
    GoalProgress: () => null,
    HealthSummary: () => null,
    Link: () => null,
    MarkdownBlock: () => null,
    Money: () => null,
    PersonFactfind: () => null,
    ProductSummary: () => null,
    ProtectionScenario: () => null,
    ProtectionSummary: () => null,
    Provider: (n) => {
      var r, i;
      return ((r = n == null ? void 0 : n.id) == null ? void 0 : r.toString()) ?? ((i = n == null ? void 0 : n.name) == null ? void 0 : i.toString()) ?? null;
    },
    ResposiveImage: () => null,
    RetirementSummary: () => null,
    SavingsInvestingSummary: () => null,
    UrlBlock: () => null,
    WealthProjection: () => null,
    WealthAtDate: () => null,
    RecommendationCTA: () => null,
    Question: (n) => typeof (n == null ? void 0 : n.key) == "string" ? n.key : null,
    FieldInput: () => null,
    PensionAtDate: () => null,
    PensionCalculation: () => null,
    FieldOption: () => null,
    staleFields: () => null,
    PRSAFundRecommendation: () => null
  },
  schema: t,
  updates: {
    Mutation: {
      updatePerson(n, r, i, o) {
        var s, c;
        ((c = (s = r == null ? void 0 : r.input) == null ? void 0 : s.person) == null ? void 0 : c.id) || pe(i, "person"), pe(i, "plan"), pe(i, "persons");
      },
      signUp: (n, r, i, o) => {
        pe(i, "person"), pe(i, "user");
      },
      syncUser(n, r, i, o) {
        pe(i, "person"), pe(i, "user"), pe(i, "asset"), pe(i, "assets"), pe(i, "debt"), pe(i, "debts"), pe(i, "policy"), pe(i, "policies");
      },
      updateEmail(n, r, i, o) {
        pe(i, "user");
      },
      bookAppointment(n, r, i, o) {
        pe(i, "availableAppointmentDays"), pe(i, "availableAppointments"), pe(i, "scheduledAppointments"), pe(i, "plan");
      },
      updateAsset(n, r, i, o) {
        var s, c;
        ((c = (s = r == null ? void 0 : r.input) == null ? void 0 : s.asset) == null ? void 0 : c.id) || (pe(i, "asset"), pe(i, "assets")), pe(i, "plan"), pe(i, "planGraph");
      },
      deleteAsset(n, r, i, o) {
        var s;
        const a = (s = r == null ? void 0 : r.input) == null ? void 0 : s.assetId;
        Yc(i, "assets", a), pe(i, "plan"), pe(i, "planGraph");
      },
      updateAssets(n, r, i, o) {
        pe(i, "assets"), pe(i, "plan"), pe(i, "planGraph");
      },
      updateDebt(n, r, i, o) {
        var s, c;
        ((c = (s = r == null ? void 0 : r.input) == null ? void 0 : s.debt) == null ? void 0 : c.id) || (pe(i, "debt"), pe(i, "debts")), pe(i, "plan"), pe(i, "planGraph");
      },
      deleteDebt(n, r, i, o) {
        var s;
        const a = (s = r == null ? void 0 : r.input) == null ? void 0 : s.debtId;
        Yc(i, "debts", a), pe(i, "plan"), pe(i, "planGraph");
      },
      updateDebts(n, r, i, o) {
        pe(i, "debts"), pe(i, "plan"), pe(i, "planGraph");
      },
      updatePolicy(n, r, i, o) {
        var s, c;
        ((c = (s = r == null ? void 0 : r.input) == null ? void 0 : s.policy) == null ? void 0 : c.id) || (pe(i, "policy"), pe(i, "policies")), pe(i, "plan"), pe(i, "planGraph");
      },
      deletePolicy(n, r, i, o) {
        var s;
        const a = (s = r == null ? void 0 : r.input) == null ? void 0 : s.policyId;
        Yc(i, "policies", a), pe(i, "plan"), pe(i, "planGraph");
      },
      updatePolicies(n, r, i, o) {
        pe(i, "policies"), pe(i, "plan"), pe(i, "planGraph");
      },
      updateGoal(n, r, i, o) {
        var s;
        ((s = r == null ? void 0 : r.input) == null ? void 0 : s.goalId) || (pe(i, "goals"), pe(i, "CollegeCost")), pe(i, "plan"), pe(i, "planGraph");
      },
      deleteGoal(n, r, i, o) {
        var s;
        const a = (s = r == null ? void 0 : r.input) == null ? void 0 : s.goalId;
        Yc(i, "goals", a), pe(i, "plan"), pe(i, "planGraph");
      },
      updateGoals(n, r, i, o) {
        pe(i, "goals"), pe(i, "plan"), pe(i, "planGraph");
      },
      updateFactfind(n, r, i, o) {
        pe(i, "persons"), pe(i, "plan"), pe(i, "planGraph"), pe(i, "assets"), pe(i, "debts"), pe(i, "policies");
      },
      updateRisk(n, r, i, o) {
        pe(i, "plan"), pe(i, "planGraph");
      },
      setVulnerabilityReminder(n, r, i, o) {
        pe(i, "vulnerabilityReminder");
      },
      deleteVulnerabilityReminder(n, r, i, o) {
        pe(i, "vulnerabilityReminder");
      },
      createNewSurvey(n, r, i, o) {
        pe(i, "showSurvey");
      },
      declineSurvey(n, r, i, o) {
        pe(i, "showSurvey");
      },
      subscribeToTool(n, r, i, o) {
        pe(i, "tools");
      },
      updateCheckIn(n, r, i, o) {
        pe(i, "checkIn"), pe(i, "factfind");
      }
    }
  }
});
function Uh() {
  return (Uh = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }).apply(this, arguments);
}
var au = function(t) {
  return {
    type: "debug-event",
    source: "exchange",
    data: Uh(Uh({}, t), {
      source: "devtoolsExchange",
      timestamp: Date.now()
    })
  };
}, XO = function() {
  var t = Error.stackTraceLimit;
  Error.stackTraceLimit = 1 / 0;
  var e = new Error().stack || "";
  Error.stackTraceLimit = t;
  var n = /(useQuery|useMutation|useSubscription).*\n\s*at (\w+)/.exec(e);
  return n === null ? "Unknown" : n[2];
}, q0 = {
  source: "exchange",
  type: "connection-init",
  version: "2.0.3"
};
function ex(t) {
  return window.postMessage(JSON.parse(JSON.stringify(t)), window.location.origin);
}
var z0 = function(t) {
  var e = t.sendMessage, n = t.addMessageListener;
  function r(i) {
    return e({
      type: "debug-event",
      source: "exchange",
      data: i
    });
  }
  return function(i) {
    var o = i.client, a = i.forward;
    return n(function(s) {
      s.source !== "devtools" || !(s.type in K0) || K0[s.type]({
        client: o,
        sendMessage: e
      })(s);
    }), o.subscribeToDebugTarget && o.subscribeToDebugTarget(r), function(s) {
      return Ku(s, Oh(tx({
        client: o,
        sendMessage: e
      })), a, Oh(nx({
        client: o,
        sendMessage: e
      })));
    };
  };
}, tx = function(t) {
  var e = t.sendMessage;
  return function(n) {
    if (n.kind === "teardown") {
      var r = au({
        type: "teardown",
        message: "The operation has been torn down",
        operation: n,
        data: void 0
      });
      return e(r);
    }
    var i = au({
      type: "execution",
      message: "The client has received an execute command.",
      operation: n,
      data: {
        sourceComponent: XO()
      }
    });
    return e(i);
  };
}, nx = function(t) {
  var e = t.sendMessage;
  return function(n) {
    var r = n.operation, i = n.data, o = n.error;
    if (o) {
      var a = au({
        type: "error",
        message: "The operation has returned a new error.",
        operation: r,
        data: {
          value: o
        }
      });
      return e(a);
    }
    var s = au({
      type: "update",
      message: "The operation has returned a new response.",
      operation: r,
      data: {
        value: i
      }
    });
    e(s);
  };
}, K0 = {
  "execute-query": function(t) {
    var e = t.client;
    return function(n) {
      var r = /(^|\W)+mutation\W/.test(n.query), i = e.createRequestOperation(r ? "mutation" : "query", {
        key: (o = JSON.stringify(n.query), function(a, s) {
          a |= 0;
          for (var c = 0, l = 0 | s.length; c < l; c++)
            a = (a << 5) + a + s.charCodeAt(c);
          return a;
        }(5381, o) >>> 0),
        query: S6(n.query)
      }, {
        meta: {
          source: "Devtools"
        }
      }), o;
      Ku(e.executeRequestOperation(i), D2(1), U2);
    };
  },
  "connection-init": function(t) {
    var e = t.sendMessage;
    return function() {
      return e({
        type: "connection-acknowledge",
        source: "exchange",
        version: "2.0.3"
      });
    };
  }
};
function rx(t) {
  var e = t.forward;
  return function(n) {
    return Ku(n, e);
  };
}
var ix = function() {
  var t = typeof navigator < "u" && (navigator == null ? void 0 : navigator.product) === "ReactNative", e = !t && typeof window > "u";
  return process.env.NODE_ENV === "production" || e ? rx : z0(t ? function() {
    var n = [], r, i;
    function o() {
      r.send(JSON.stringify(q0));
    }
    function a() {
      i = i || setTimeout(l, 500);
    }
    function s() {
      i = i || setTimeout(l, 500);
    }
    function c(u) {
      try {
        if (!u.data)
          return;
        n.forEach(function(f) {
          return f(JSON.parse(u.data));
        });
      } catch (d) {
        console.warn(d);
      }
    }
    var l = function() {
      i = void 0, (r = new WebSocket("ws://localhost:7700")).onopen = o, r.onclose = a, r.onerror = s, r.onmessage = c;
    };
    return l(), {
      addMessageListener: function(u) {
        n = n.concat([u]);
      },
      sendMessage: function(u) {
        r.readyState === r.OPEN && r.send(JSON.stringify(u));
      }
    };
  }() : function() {
    var n = [];
    window.addEventListener("message", function(i) {
      var o = i.data;
      !i.isTrusted || !(o != null && o.source) || n.forEach(function(a) {
        return a(o);
      });
    });
    var r = ex;
    return r(q0), {
      addMessageListener: function(i) {
        return n = n.concat([i]);
      },
      sendMessage: r
    };
  }());
}();
const ox = (t) => ({ forward: e }) => (n) => {
  const r = Ku(
    n,
    Oh((o) => {
      var a, s, c;
      if (o.kind === "mutation") {
        const l = (s = (a = o == null ? void 0 : o.query) == null ? void 0 : a.definitions) == null ? void 0 : s.filter(
          (u) => u.kind === "OperationDefinition"
        );
        for (const u of l) {
          const d = (c = u == null ? void 0 : u.name) == null ? void 0 : c.value;
          d && t.track(`Mutation ${d}`);
        }
      }
    })
  );
  return e(r);
}, ax = (t) => G3({
  onResult: (e) => {
    var n, r;
    ((r = (n = e.error) == null ? void 0 : n.response) == null ? void 0 : r.status) === 503 ? t && t(!0) : t && t(!1);
  }
}), W0 = ({
  endpoint: t,
  getToken: e,
  refreshToken: n,
  schema: r,
  analytics: i,
  logOut: o,
  onDowntime: a,
  queries: s
}) => {
  if (!t)
    throw new Error("endpoint is required when creating a urql client");
  const c = ZO({ schema: r, queries: s }), l = NO({ getToken: e, refreshToken: n, logOut: o }), u = xO({
    initialDelayMs: 1e3,
    randomDelay: !0,
    maxDelayMs: 1e3 * 60 * 10,
    maxNumberAttempts: 40,
    retryIf: (g) => {
      var v;
      return ((v = g.response) == null ? void 0 : v.status) >= 500 ? !0 : !!g.networkError;
    }
  });
  let d = null;
  i && (d = ox(i));
  const f = ax(a), h = [
    ix,
    Q3,
    d,
    c,
    u,
    l,
    f,
    J3
  ].filter((g) => g != null);
  return Y3({
    url: t,
    exchanges: h
  });
};
function Oo(t) {
  return typeof t == "string";
}
function Hh(t) {
  return typeof t == "number";
}
function ha(t) {
  return typeof t == "function";
}
function Er(t) {
  return Object.prototype.toString.call(t).slice(8, -1).toLowerCase() === "object";
}
function sx(t) {
  var e, n, r, i = (r = (n = (e = t.userId) !== null && e !== void 0 ? e : t.anonymousId) !== null && n !== void 0 ? n : t.groupId) !== null && r !== void 0 ? r : t.previousId;
  return Oo(i);
}
var ls = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n, r) {
      var i = t.call(this, r) || this;
      return i.field = n, i;
    }
    return e;
  }(Error)
);
function jo(t) {
  var e, n = t && t.event && t.event.type, r = t.event;
  if (r === void 0)
    throw new ls("event", "Event is missing");
  if (!Oo(n))
    throw new ls("event", "Event is not a string");
  if (n === "track" && !Oo(r.event))
    throw new ls("event", "Event is not a string");
  var i = (e = r.properties) !== null && e !== void 0 ? e : r.traits;
  if (n !== "alias" && !Er(i))
    throw new ls("properties", "properties is not an object");
  if (!sx(r))
    throw new ls("userId", "Missing userId or anonymousId");
  return t;
}
var cx = {
  name: "Event Validation",
  type: "before",
  version: "1.0.0",
  isLoaded: function() {
    return !0;
  },
  load: function() {
    return Promise.resolve();
  },
  track: jo,
  identify: jo,
  page: jo,
  alias: jo,
  group: jo,
  screen: jo
};
function lx(t, e, n, r) {
  var i, o = [t, e, n, r], a = Er(t) ? t.event : t;
  if (!a || !Oo(a))
    throw new Error("Event missing");
  var s = Er(t) ? (i = t.properties) !== null && i !== void 0 ? i : {} : Er(e) ? e : {}, c = {};
  Er(e) && !ha(n) && (c = n ?? {}), Er(t) && !ha(e) && (c = e ?? {});
  var l = o.find(ha);
  return [a, s, c, l];
}
function G0(t, e, n, r, i) {
  var o, a, s = null, c = null, l = [t, e, n, r, i], u = l.filter(Oo);
  u[0] !== void 0 && u[1] !== void 0 && (s = u[0], c = u[1]), u.length === 1 && (s = null, c = u[0]);
  var d = l.find(ha), f = l.filter(function(v) {
    return c === null ? Er(v) : Er(v) || v === null;
  }), h = (o = f[0]) !== null && o !== void 0 ? o : {}, g = (a = f[1]) !== null && a !== void 0 ? a : {};
  return [
    s,
    c,
    h,
    g,
    d
  ];
}
var Y0 = function(t) {
  return function() {
    for (var e, n, r, i, o, a = [], s = 0; s < arguments.length; s++)
      a[s] = arguments[s];
    var c = null;
    c = (r = (e = a.find(Oo)) !== null && e !== void 0 ? e : (n = a.find(Hh)) === null || n === void 0 ? void 0 : n.toString()) !== null && r !== void 0 ? r : t.id();
    var l = a.filter(function(h) {
      return c === null ? Er(h) : Er(h) || h === null;
    }), u = (i = l[0]) !== null && i !== void 0 ? i : {}, d = (o = l[1]) !== null && o !== void 0 ? o : {}, f = a.find(ha);
    return [c, u, d, f];
  };
};
function ux(t, e, n, r) {
  Hh(t) && (t = t.toString()), Hh(e) && (e = e.toString());
  var i = [t, e, n, r], o = i.filter(Oo), a = o[0], s = a === void 0 ? t : a, c = o[1], l = c === void 0 ? null : c, u = i.filter(Er)[0], d = u === void 0 ? {} : u, f = i.find(ha);
  return [s, l, d, f];
}
function f_(t) {
  return Promise.resolve(t);
}
function dx(t, e) {
  return new Promise(function(n, r) {
    var i = setTimeout(function() {
      r(Error("Promise timed out"));
    }, e);
    t.then(function(o) {
      return clearTimeout(i), n(o);
    }).catch(r);
  });
}
function fx(t) {
  return new Promise(function(e) {
    return setTimeout(e, t);
  });
}
function hx(t, e, n, r) {
  var i = function() {
    try {
      return f_(e(t));
    } catch (o) {
      return Promise.reject(o);
    }
  };
  return fx(n).then(function() {
    return dx(i(), r ?? 1e3);
  }).catch(function(o) {
    t == null || t.log("warn", "Callback Error", { error: o }), t == null || t.stats.increment("callback_error");
  }).then(function() {
    return t;
  });
}
function mg() {
  return typeof window < "u";
}
function kW() {
  return !mg();
}
function h_() {
  return mg() ? window.navigator.onLine : !0;
}
function su() {
  return !h_();
}
function cu(t, e, n) {
  e.split && (e = e.split("."));
  for (var r = 0, i = e.length, o = t, a, s; r < i && (s = e[r++], !(s === "__proto__" || s === "constructor" || s === "prototype")); )
    o = o[s] = r === i ? n : typeof (a = o[s]) == typeof e ? a : e[r] * 0 !== 0 || ~("" + e[r]).indexOf(".") ? {} : [];
}
const AW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  dset: cu
}, Symbol.toStringTag, { value: "Module" }));
var px = (
  /** @class */
  function() {
    function t() {
      var e = this;
      this._logs = [], this.log = function(n, r, i) {
        var o = /* @__PURE__ */ new Date();
        e._logs.push({
          level: n,
          message: r,
          time: o,
          extras: i
        });
      };
    }
    return Object.defineProperty(t.prototype, "logs", {
      get: function() {
        return this._logs;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.flush = function() {
      if (this.logs.length > 1) {
        var e = this._logs.reduce(function(n, r) {
          var i, o, a, s = R(R({}, r), { json: JSON.stringify(r.extras, null, " "), extras: r.extras });
          delete s.time;
          var c = (a = (o = r.time) === null || o === void 0 ? void 0 : o.toISOString()) !== null && a !== void 0 ? a : "";
          return n[c] && (c = "".concat(c, "-").concat(Math.random())), R(R({}, n), (i = {}, i[c] = s, i));
        }, {});
        console.table ? console.table(e) : console.log(e);
      } else
        this.logs.forEach(function(n) {
          var r = n.level, i = n.message, o = n.extras;
          r === "info" || r === "debug" ? console.log(i, o ?? "") : console[r](i, o ?? "");
        });
      this._logs = [];
    }, t;
  }()
);
const gx = px;
var mx = function(t) {
  var e = {
    gauge: "g",
    counter: "c"
  };
  return e[t];
}, vx = (
  /** @class */
  function() {
    function t(e) {
      this.metrics = [], this.remoteMetrics = e;
    }
    return t.prototype.increment = function(e, n, r) {
      var i;
      n === void 0 && (n = 1), this.metrics.push({
        metric: e,
        value: n,
        tags: r ?? [],
        type: "counter",
        timestamp: Date.now()
      }), (i = this.remoteMetrics) === null || i === void 0 || i.increment(e, r ?? []);
    }, t.prototype.gauge = function(e, n, r) {
      this.metrics.push({
        metric: e,
        value: n,
        tags: r ?? [],
        type: "gauge",
        timestamp: Date.now()
      });
    }, t.prototype.flush = function() {
      var e = this.metrics.map(function(n) {
        return R(R({}, n), { tags: n.tags.join(",") });
      });
      console.table ? console.table(e) : console.log(e), this.metrics = [];
    }, t.prototype.serialize = function() {
      return this.metrics.map(function(e) {
        return {
          m: e.metric,
          v: e.value,
          t: e.tags,
          k: mx(e.type),
          e: e.timestamp
        };
      });
    }, t;
  }()
);
const yx = vx;
function $a(t, e) {
  return e = e || {}, new Promise(function(n, r) {
    var i = new XMLHttpRequest(), o = [], a = [], s = {}, c = function() {
      return { ok: (i.status / 100 | 0) == 2, statusText: i.statusText, status: i.status, url: i.responseURL, text: function() {
        return Promise.resolve(i.responseText);
      }, json: function() {
        return Promise.resolve(i.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([i.response]));
      }, clone: c, headers: { keys: function() {
        return o;
      }, entries: function() {
        return a;
      }, get: function(u) {
        return s[u.toLowerCase()];
      }, has: function(u) {
        return u.toLowerCase() in s;
      } } };
    };
    for (var l in i.open(e.method || "get", t, !0), i.onload = function() {
      i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(u, d, f) {
        o.push(d = d.toLowerCase()), a.push([d, f]), s[d] = s[d] ? s[d] + "," + f : f;
      }), n(c());
    }, i.onerror = r, i.withCredentials = e.credentials == "include", e.headers)
      i.setRequestHeader(l, e.headers[l]);
    i.send(e.body || null);
  });
}
var Ma = "1.42.3";
/*! js-cookie v3.0.1 | MIT */
function Qc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e];
    for (var r in n)
      t[r] = n[r];
  }
  return t;
}
var wx = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Bh(t, e) {
  function n(i, o, a) {
    if (!(typeof document > "u")) {
      a = Qc({}, e, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var s = "";
      for (var c in a)
        a[c] && (s += "; " + c, a[c] !== !0 && (s += "=" + a[c].split(";")[0]));
      return document.cookie = i + "=" + t.write(o, i) + s;
    }
  }
  function r(i) {
    if (!(typeof document > "u" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], a = {}, s = 0; s < o.length; s++) {
        var c = o[s].split("="), l = c.slice(1).join("=");
        try {
          var u = decodeURIComponent(c[0]);
          if (a[u] = t.read(l, u), i === u)
            break;
        } catch {
        }
      }
      return i ? a[i] : a;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(i, o) {
        n(
          i,
          "",
          Qc({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return Bh(this.converter, Qc({}, this.attributes, i));
      },
      withConverter: function(i) {
        return Bh(Qc({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var Gn = Bh(wx, { path: "/" });
function bx(t) {
  try {
    return decodeURIComponent(t.replace(/\+/g, " "));
  } catch {
    return t;
  }
}
function _x(t) {
  var e = t.hostname, n = e.split("."), r = n[n.length - 1], i = [];
  if (n.length === 4 && parseInt(r, 10) > 0 || n.length <= 1)
    return i;
  for (var o = n.length - 2; o >= 0; --o)
    i.push(n.slice(o).join("."));
  return i;
}
function Ex(t) {
  try {
    return new URL(t);
  } catch {
    return;
  }
}
function p_(t) {
  var e = Ex(t);
  if (e)
    for (var n = _x(e), r = 0; r < n.length; ++r) {
      var i = "__tld__", o = n[r], a = { domain: "." + o };
      try {
        if (Gn.set(i, "1", a), Gn.get(i))
          return Gn.remove(i, a), o;
      } catch {
        return;
      }
    }
}
var us;
function Cx() {
  if (us)
    return us;
  var t = p_(window.location.href);
  return us = {
    expires: 31536e6,
    secure: !1,
    path: "/"
  }, t && (us.domain = t), us;
}
var Ix = "npm";
function g_() {
  return Ix;
}
function Sx() {
  var t = Gn.get("_ga");
  if (t && t.startsWith("amp"))
    return t;
}
function Tx(t) {
  return t.startsWith("?") && (t = t.substring(1)), t = t.replace(/\?/g, "&"), t.split("&").reduce(function(e, n) {
    var r = n.split("="), i = r[0], o = r[1], a = o === void 0 ? "" : o;
    if (i.includes("utm_") && i.length > 4) {
      var s = i.substr(4);
      s === "campaign" && (s = "name"), e[s] = bx(a);
    }
    return e;
  }, {});
}
function kx(t) {
  var e = {
    btid: "dataxu",
    urid: "millennial-media"
  };
  t.startsWith("?") && (t = t.substring(1)), t = t.replace(/\?/g, "&");
  for (var n = t.split("&"), r = 0, i = n; r < i.length; r++) {
    var o = i[r], a = o.split("="), s = a[0], c = a[1];
    if (e[s])
      return {
        id: c,
        type: e[s]
      };
  }
}
function Ax(t, e, n) {
  var r = Gn.get("s:context.referrer"), i = kx(t);
  r = r ? JSON.parse(r) : void 0, i = i ?? r, i && (e && (e.referrer = R(R({}, e.referrer), i)), n || Gn.set("s:context.referrer", JSON.stringify(i), Cx()));
}
function Ox(t, e, n, r) {
  var i, o, a, s, c = t.user(), l = window.location.search;
  e.context = (o = (i = e.context) !== null && i !== void 0 ? i : e.options) !== null && o !== void 0 ? o : {};
  var u = e.context, d = e.anonymousId;
  delete e.options, e.writeKey = n == null ? void 0 : n.apiKey, u.userAgent = window.navigator.userAgent;
  var f = navigator.userLanguage || navigator.language;
  if (typeof u.locale > "u" && typeof f < "u" && (u.locale = f), !u.library) {
    var h = g_();
    h === "web" ? u.library = {
      name: "analytics.js",
      version: "next-".concat(Ma)
    } : u.library = {
      name: "analytics.js",
      version: "npm:next-".concat(Ma)
    };
  }
  l && !u.campaign && (u.campaign = Tx(l)), Ax(l, u, (a = t.options.disableClientPersistence) !== null && a !== void 0 ? a : !1), e.userId = e.userId || c.id(), e.anonymousId = c.anonymousId(d), e.sentAt = /* @__PURE__ */ new Date();
  var g = t.queue.failedInitializations || [];
  g.length > 0 && (e._metadata = { failedInitializations: g });
  var v = [], b = [];
  for (var m in r) {
    var y = r[m];
    m === "Segment.io" && v.push(m), y.bundlingStatus === "bundled" && v.push(m), y.bundlingStatus === "unbundled" && b.push(m);
  }
  for (var p = 0, w = (n == null ? void 0 : n.unbundledIntegrations) || []; p < w.length; p++) {
    var _ = w[p];
    b.includes(_) || b.push(_);
  }
  var E = (s = n == null ? void 0 : n.maybeBundledConfigIds) !== null && s !== void 0 ? s : {}, S = [];
  v.sort().forEach(function(x) {
    var A;
    ((A = E[x]) !== null && A !== void 0 ? A : []).forEach(function(N) {
      S.push(N);
    });
  }), (n == null ? void 0 : n.addBundledMetadata) !== !1 && (e._metadata = R(R({}, e._metadata), { bundled: v.sort(), unbundled: b.sort(), bundledIds: S }));
  var T = Sx();
  return T && (u.amp = { id: T }), e;
}
var xx = (
  /** @class */
  function() {
    function t(e) {
      var n = this, r, i, o, a;
      if (this.host = (r = e == null ? void 0 : e.host) !== null && r !== void 0 ? r : "api.segment.io/v1", this.sampleRate = (i = e == null ? void 0 : e.sampleRate) !== null && i !== void 0 ? i : 1, this.flushTimer = (o = e == null ? void 0 : e.flushTimer) !== null && o !== void 0 ? o : 30 * 1e3, this.maxQueueSize = (a = e == null ? void 0 : e.maxQueueSize) !== null && a !== void 0 ? a : 20, this.queue = [], this.sampleRate > 0) {
        var s = !1, c = function() {
          s || (s = !0, n.flush().catch(function(l) {
            console.error(l);
          }), s = !1, setTimeout(c, n.flushTimer));
        };
        c();
      }
    }
    return t.prototype.increment = function(e, n) {
      if (e.includes("analytics_js.") && n.length !== 0 && !(Math.random() > this.sampleRate) && !(this.queue.length >= this.maxQueueSize)) {
        var r = n.reduce(function(o, a) {
          var s = a.split(":"), c = s[0], l = s[1];
          return o[c] = l, o;
        }, {});
        r.library = "analytics.js";
        var i = g_();
        i === "web" ? r.library_version = "next-".concat(Ma) : r.library_version = "npm:next-".concat(Ma), this.queue.push({
          type: "Counter",
          metric: e,
          value: 1,
          tags: r
        }), e.includes("error") && this.flush().catch(function(o) {
          return console.error(o);
        });
      }
    }, t.prototype.flush = function() {
      return ke(this, void 0, void 0, function() {
        var e = this;
        return Ae(this, function(n) {
          switch (n.label) {
            case 0:
              return this.queue.length <= 0 ? [
                2
                /*return*/
              ] : [4, this.send().catch(function(r) {
                console.error(r), e.sampleRate = 0;
              })];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.send = function() {
      return ke(this, void 0, void 0, function() {
        var e, n, r;
        return Ae(this, function(i) {
          return e = { series: this.queue }, this.queue = [], n = { "Content-Type": "text/plain" }, r = "https://".concat(this.host, "/m"), [2, $a(r, {
            headers: n,
            body: JSON.stringify(e),
            method: "POST"
          })];
        });
      });
    }, t;
  }()
), rc = (
  /** @class */
  function() {
    function t(e) {
      var n, r, i;
      this.retry = (n = e.retry) !== null && n !== void 0 ? n : !0, this.type = (r = e.type) !== null && r !== void 0 ? r : "plugin Error", this.reason = (i = e.reason) !== null && i !== void 0 ? i : "";
    }
    return t;
  }()
), Q0, ui = (
  /** @class */
  function() {
    function t(e, n) {
      this.logger = new gx(), this.cancel = function(r) {
        throw r || new rc({ reason: "Context Cancel" });
      }, this._attempts = 0, this._event = e, this._id = n ?? Di(), this.stats = new yx(Q0);
    }
    return t.initMetrics = function(e) {
      Q0 = new xx(e);
    }, t.system = function() {
      return new t({ type: "track", event: "system" });
    }, t.prototype.isSame = function(e) {
      return e._id === this._id;
    }, t.prototype.log = function(e, n, r) {
      this.logger.log(e, n, r);
    }, Object.defineProperty(t.prototype, "id", {
      get: function() {
        return this._id;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "event", {
      get: function() {
        return this._event;
      },
      set: function(e) {
        this._event = e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attempts", {
      get: function() {
        return this._attempts;
      },
      set: function(e) {
        this._attempts = e;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updateEvent = function(e, n) {
      var r;
      if (e.split(".")[0] === "integrations") {
        var i = e.split(".")[1];
        if (((r = this._event.integrations) === null || r === void 0 ? void 0 : r[i]) === !1)
          return this._event;
      }
      return cu(this._event, e, n), this._event;
    }, t.prototype.failedDelivery = function() {
      return this._failedDelivery;
    }, t.prototype.setFailedDelivery = function(e) {
      this._failedDelivery = e;
    }, t.prototype.logs = function() {
      return this.logger.logs;
    }, t.prototype.flush = function() {
      this.logger.flush(), this.stats.flush();
    }, t.prototype.toJSON = function() {
      return {
        id: this._id,
        event: this._event,
        logs: this.logger.logs,
        metrics: this.stats.metrics
      };
    }, t;
  }()
), vg = (
  /** @class */
  function() {
    function t() {
      this.callbacks = {};
    }
    return t.prototype.on = function(e, n) {
      var r;
      return this.callbacks[e] = ln(ln([], (r = this.callbacks[e]) !== null && r !== void 0 ? r : [], !0), [n], !1), this;
    }, t.prototype.once = function(e, n) {
      var r = this, i = function() {
        for (var o = [], a = 0; a < arguments.length; a++)
          o[a] = arguments[a];
        r.off(e, i), n.apply(r, o);
      };
      return this.on(e, i), this;
    }, t.prototype.off = function(e, n) {
      var r, i = (r = this.callbacks[e]) !== null && r !== void 0 ? r : [], o = i.filter(function(a) {
        return a !== n;
      });
      return this.callbacks[e] = o, this;
    }, t.prototype.emit = function(e) {
      for (var n = this, r, i = [], o = 1; o < arguments.length; o++)
        i[o - 1] = arguments[o];
      var a = (r = this.callbacks[e]) !== null && r !== void 0 ? r : [];
      return a.forEach(function(s) {
        s.apply(n, i);
      }), this;
    }, t;
  }()
), jh = {}, Rx = {
  get exports() {
    return jh;
  },
  set exports(t) {
    jh = t;
  }
};
(function(t, e) {
  (function(n) {
    t.exports = n();
  })(function(n) {
    var r = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    function i(m, y) {
      var p = m[0], w = m[1], _ = m[2], E = m[3];
      p += (w & _ | ~w & E) + y[0] - 680876936 | 0, p = (p << 7 | p >>> 25) + w | 0, E += (p & w | ~p & _) + y[1] - 389564586 | 0, E = (E << 12 | E >>> 20) + p | 0, _ += (E & p | ~E & w) + y[2] + 606105819 | 0, _ = (_ << 17 | _ >>> 15) + E | 0, w += (_ & E | ~_ & p) + y[3] - 1044525330 | 0, w = (w << 22 | w >>> 10) + _ | 0, p += (w & _ | ~w & E) + y[4] - 176418897 | 0, p = (p << 7 | p >>> 25) + w | 0, E += (p & w | ~p & _) + y[5] + 1200080426 | 0, E = (E << 12 | E >>> 20) + p | 0, _ += (E & p | ~E & w) + y[6] - 1473231341 | 0, _ = (_ << 17 | _ >>> 15) + E | 0, w += (_ & E | ~_ & p) + y[7] - 45705983 | 0, w = (w << 22 | w >>> 10) + _ | 0, p += (w & _ | ~w & E) + y[8] + 1770035416 | 0, p = (p << 7 | p >>> 25) + w | 0, E += (p & w | ~p & _) + y[9] - 1958414417 | 0, E = (E << 12 | E >>> 20) + p | 0, _ += (E & p | ~E & w) + y[10] - 42063 | 0, _ = (_ << 17 | _ >>> 15) + E | 0, w += (_ & E | ~_ & p) + y[11] - 1990404162 | 0, w = (w << 22 | w >>> 10) + _ | 0, p += (w & _ | ~w & E) + y[12] + 1804603682 | 0, p = (p << 7 | p >>> 25) + w | 0, E += (p & w | ~p & _) + y[13] - 40341101 | 0, E = (E << 12 | E >>> 20) + p | 0, _ += (E & p | ~E & w) + y[14] - 1502002290 | 0, _ = (_ << 17 | _ >>> 15) + E | 0, w += (_ & E | ~_ & p) + y[15] + 1236535329 | 0, w = (w << 22 | w >>> 10) + _ | 0, p += (w & E | _ & ~E) + y[1] - 165796510 | 0, p = (p << 5 | p >>> 27) + w | 0, E += (p & _ | w & ~_) + y[6] - 1069501632 | 0, E = (E << 9 | E >>> 23) + p | 0, _ += (E & w | p & ~w) + y[11] + 643717713 | 0, _ = (_ << 14 | _ >>> 18) + E | 0, w += (_ & p | E & ~p) + y[0] - 373897302 | 0, w = (w << 20 | w >>> 12) + _ | 0, p += (w & E | _ & ~E) + y[5] - 701558691 | 0, p = (p << 5 | p >>> 27) + w | 0, E += (p & _ | w & ~_) + y[10] + 38016083 | 0, E = (E << 9 | E >>> 23) + p | 0, _ += (E & w | p & ~w) + y[15] - 660478335 | 0, _ = (_ << 14 | _ >>> 18) + E | 0, w += (_ & p | E & ~p) + y[4] - 405537848 | 0, w = (w << 20 | w >>> 12) + _ | 0, p += (w & E | _ & ~E) + y[9] + 568446438 | 0, p = (p << 5 | p >>> 27) + w | 0, E += (p & _ | w & ~_) + y[14] - 1019803690 | 0, E = (E << 9 | E >>> 23) + p | 0, _ += (E & w | p & ~w) + y[3] - 187363961 | 0, _ = (_ << 14 | _ >>> 18) + E | 0, w += (_ & p | E & ~p) + y[8] + 1163531501 | 0, w = (w << 20 | w >>> 12) + _ | 0, p += (w & E | _ & ~E) + y[13] - 1444681467 | 0, p = (p << 5 | p >>> 27) + w | 0, E += (p & _ | w & ~_) + y[2] - 51403784 | 0, E = (E << 9 | E >>> 23) + p | 0, _ += (E & w | p & ~w) + y[7] + 1735328473 | 0, _ = (_ << 14 | _ >>> 18) + E | 0, w += (_ & p | E & ~p) + y[12] - 1926607734 | 0, w = (w << 20 | w >>> 12) + _ | 0, p += (w ^ _ ^ E) + y[5] - 378558 | 0, p = (p << 4 | p >>> 28) + w | 0, E += (p ^ w ^ _) + y[8] - 2022574463 | 0, E = (E << 11 | E >>> 21) + p | 0, _ += (E ^ p ^ w) + y[11] + 1839030562 | 0, _ = (_ << 16 | _ >>> 16) + E | 0, w += (_ ^ E ^ p) + y[14] - 35309556 | 0, w = (w << 23 | w >>> 9) + _ | 0, p += (w ^ _ ^ E) + y[1] - 1530992060 | 0, p = (p << 4 | p >>> 28) + w | 0, E += (p ^ w ^ _) + y[4] + 1272893353 | 0, E = (E << 11 | E >>> 21) + p | 0, _ += (E ^ p ^ w) + y[7] - 155497632 | 0, _ = (_ << 16 | _ >>> 16) + E | 0, w += (_ ^ E ^ p) + y[10] - 1094730640 | 0, w = (w << 23 | w >>> 9) + _ | 0, p += (w ^ _ ^ E) + y[13] + 681279174 | 0, p = (p << 4 | p >>> 28) + w | 0, E += (p ^ w ^ _) + y[0] - 358537222 | 0, E = (E << 11 | E >>> 21) + p | 0, _ += (E ^ p ^ w) + y[3] - 722521979 | 0, _ = (_ << 16 | _ >>> 16) + E | 0, w += (_ ^ E ^ p) + y[6] + 76029189 | 0, w = (w << 23 | w >>> 9) + _ | 0, p += (w ^ _ ^ E) + y[9] - 640364487 | 0, p = (p << 4 | p >>> 28) + w | 0, E += (p ^ w ^ _) + y[12] - 421815835 | 0, E = (E << 11 | E >>> 21) + p | 0, _ += (E ^ p ^ w) + y[15] + 530742520 | 0, _ = (_ << 16 | _ >>> 16) + E | 0, w += (_ ^ E ^ p) + y[2] - 995338651 | 0, w = (w << 23 | w >>> 9) + _ | 0, p += (_ ^ (w | ~E)) + y[0] - 198630844 | 0, p = (p << 6 | p >>> 26) + w | 0, E += (w ^ (p | ~_)) + y[7] + 1126891415 | 0, E = (E << 10 | E >>> 22) + p | 0, _ += (p ^ (E | ~w)) + y[14] - 1416354905 | 0, _ = (_ << 15 | _ >>> 17) + E | 0, w += (E ^ (_ | ~p)) + y[5] - 57434055 | 0, w = (w << 21 | w >>> 11) + _ | 0, p += (_ ^ (w | ~E)) + y[12] + 1700485571 | 0, p = (p << 6 | p >>> 26) + w | 0, E += (w ^ (p | ~_)) + y[3] - 1894986606 | 0, E = (E << 10 | E >>> 22) + p | 0, _ += (p ^ (E | ~w)) + y[10] - 1051523 | 0, _ = (_ << 15 | _ >>> 17) + E | 0, w += (E ^ (_ | ~p)) + y[1] - 2054922799 | 0, w = (w << 21 | w >>> 11) + _ | 0, p += (_ ^ (w | ~E)) + y[8] + 1873313359 | 0, p = (p << 6 | p >>> 26) + w | 0, E += (w ^ (p | ~_)) + y[15] - 30611744 | 0, E = (E << 10 | E >>> 22) + p | 0, _ += (p ^ (E | ~w)) + y[6] - 1560198380 | 0, _ = (_ << 15 | _ >>> 17) + E | 0, w += (E ^ (_ | ~p)) + y[13] + 1309151649 | 0, w = (w << 21 | w >>> 11) + _ | 0, p += (_ ^ (w | ~E)) + y[4] - 145523070 | 0, p = (p << 6 | p >>> 26) + w | 0, E += (w ^ (p | ~_)) + y[11] - 1120210379 | 0, E = (E << 10 | E >>> 22) + p | 0, _ += (p ^ (E | ~w)) + y[2] + 718787259 | 0, _ = (_ << 15 | _ >>> 17) + E | 0, w += (E ^ (_ | ~p)) + y[9] - 343485551 | 0, w = (w << 21 | w >>> 11) + _ | 0, m[0] = p + m[0] | 0, m[1] = w + m[1] | 0, m[2] = _ + m[2] | 0, m[3] = E + m[3] | 0;
    }
    function o(m) {
      var y = [], p;
      for (p = 0; p < 64; p += 4)
        y[p >> 2] = m.charCodeAt(p) + (m.charCodeAt(p + 1) << 8) + (m.charCodeAt(p + 2) << 16) + (m.charCodeAt(p + 3) << 24);
      return y;
    }
    function a(m) {
      var y = [], p;
      for (p = 0; p < 64; p += 4)
        y[p >> 2] = m[p] + (m[p + 1] << 8) + (m[p + 2] << 16) + (m[p + 3] << 24);
      return y;
    }
    function s(m) {
      var y = m.length, p = [1732584193, -271733879, -1732584194, 271733878], w, _, E, S, T, x;
      for (w = 64; w <= y; w += 64)
        i(p, o(m.substring(w - 64, w)));
      for (m = m.substring(w - 64), _ = m.length, E = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], w = 0; w < _; w += 1)
        E[w >> 2] |= m.charCodeAt(w) << (w % 4 << 3);
      if (E[w >> 2] |= 128 << (w % 4 << 3), w > 55)
        for (i(p, E), w = 0; w < 16; w += 1)
          E[w] = 0;
      return S = y * 8, S = S.toString(16).match(/(.*?)(.{0,8})$/), T = parseInt(S[2], 16), x = parseInt(S[1], 16) || 0, E[14] = T, E[15] = x, i(p, E), p;
    }
    function c(m) {
      var y = m.length, p = [1732584193, -271733879, -1732584194, 271733878], w, _, E, S, T, x;
      for (w = 64; w <= y; w += 64)
        i(p, a(m.subarray(w - 64, w)));
      for (m = w - 64 < y ? m.subarray(w - 64) : new Uint8Array(0), _ = m.length, E = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], w = 0; w < _; w += 1)
        E[w >> 2] |= m[w] << (w % 4 << 3);
      if (E[w >> 2] |= 128 << (w % 4 << 3), w > 55)
        for (i(p, E), w = 0; w < 16; w += 1)
          E[w] = 0;
      return S = y * 8, S = S.toString(16).match(/(.*?)(.{0,8})$/), T = parseInt(S[2], 16), x = parseInt(S[1], 16) || 0, E[14] = T, E[15] = x, i(p, E), p;
    }
    function l(m) {
      var y = "", p;
      for (p = 0; p < 4; p += 1)
        y += r[m >> p * 8 + 4 & 15] + r[m >> p * 8 & 15];
      return y;
    }
    function u(m) {
      var y;
      for (y = 0; y < m.length; y += 1)
        m[y] = l(m[y]);
      return m.join("");
    }
    u(s("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && function() {
      function m(y, p) {
        return y = y | 0 || 0, y < 0 ? Math.max(y + p, 0) : Math.min(y, p);
      }
      ArrayBuffer.prototype.slice = function(y, p) {
        var w = this.byteLength, _ = m(y, w), E = w, S, T, x, A;
        return p !== n && (E = m(p, w)), _ > E ? new ArrayBuffer(0) : (S = E - _, T = new ArrayBuffer(S), x = new Uint8Array(T), A = new Uint8Array(this, _, S), x.set(A), T);
      };
    }();
    function d(m) {
      return /[\u0080-\uFFFF]/.test(m) && (m = unescape(encodeURIComponent(m))), m;
    }
    function f(m, y) {
      var p = m.length, w = new ArrayBuffer(p), _ = new Uint8Array(w), E;
      for (E = 0; E < p; E += 1)
        _[E] = m.charCodeAt(E);
      return y ? _ : w;
    }
    function h(m) {
      return String.fromCharCode.apply(null, new Uint8Array(m));
    }
    function g(m, y, p) {
      var w = new Uint8Array(m.byteLength + y.byteLength);
      return w.set(new Uint8Array(m)), w.set(new Uint8Array(y), m.byteLength), p ? w : w.buffer;
    }
    function v(m) {
      var y = [], p = m.length, w;
      for (w = 0; w < p - 1; w += 2)
        y.push(parseInt(m.substr(w, 2), 16));
      return String.fromCharCode.apply(String, y);
    }
    function b() {
      this.reset();
    }
    return b.prototype.append = function(m) {
      return this.appendBinary(d(m)), this;
    }, b.prototype.appendBinary = function(m) {
      this._buff += m, this._length += m.length;
      var y = this._buff.length, p;
      for (p = 64; p <= y; p += 64)
        i(this._hash, o(this._buff.substring(p - 64, p)));
      return this._buff = this._buff.substring(p - 64), this;
    }, b.prototype.end = function(m) {
      var y = this._buff, p = y.length, w, _ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], E;
      for (w = 0; w < p; w += 1)
        _[w >> 2] |= y.charCodeAt(w) << (w % 4 << 3);
      return this._finish(_, p), E = u(this._hash), m && (E = v(E)), this.reset(), E;
    }, b.prototype.reset = function() {
      return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, b.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    }, b.prototype.setState = function(m) {
      return this._buff = m.buff, this._length = m.length, this._hash = m.hash, this;
    }, b.prototype.destroy = function() {
      delete this._hash, delete this._buff, delete this._length;
    }, b.prototype._finish = function(m, y) {
      var p = y, w, _, E;
      if (m[p >> 2] |= 128 << (p % 4 << 3), p > 55)
        for (i(this._hash, m), p = 0; p < 16; p += 1)
          m[p] = 0;
      w = this._length * 8, w = w.toString(16).match(/(.*?)(.{0,8})$/), _ = parseInt(w[2], 16), E = parseInt(w[1], 16) || 0, m[14] = _, m[15] = E, i(this._hash, m);
    }, b.hash = function(m, y) {
      return b.hashBinary(d(m), y);
    }, b.hashBinary = function(m, y) {
      var p = s(m), w = u(p);
      return y ? v(w) : w;
    }, b.ArrayBuffer = function() {
      this.reset();
    }, b.ArrayBuffer.prototype.append = function(m) {
      var y = g(this._buff.buffer, m, !0), p = y.length, w;
      for (this._length += m.byteLength, w = 64; w <= p; w += 64)
        i(this._hash, a(y.subarray(w - 64, w)));
      return this._buff = w - 64 < p ? new Uint8Array(y.buffer.slice(w - 64)) : new Uint8Array(0), this;
    }, b.ArrayBuffer.prototype.end = function(m) {
      var y = this._buff, p = y.length, w = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], _, E;
      for (_ = 0; _ < p; _ += 1)
        w[_ >> 2] |= y[_] << (_ % 4 << 3);
      return this._finish(w, p), E = u(this._hash), m && (E = v(E)), this.reset(), E;
    }, b.ArrayBuffer.prototype.reset = function() {
      return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, b.ArrayBuffer.prototype.getState = function() {
      var m = b.prototype.getState.call(this);
      return m.buff = h(m.buff), m;
    }, b.ArrayBuffer.prototype.setState = function(m) {
      return m.buff = f(m.buff, !0), b.prototype.setState.call(this, m);
    }, b.ArrayBuffer.prototype.destroy = b.prototype.destroy, b.ArrayBuffer.prototype._finish = b.prototype._finish, b.ArrayBuffer.hash = function(m, y) {
      var p = c(new Uint8Array(m)), w = u(p);
      return y ? v(w) : w;
    }, b;
  });
})(Rx);
const Nx = jh;
var Mx = (
  /** @class */
  function() {
    function t(e) {
      this.user = e;
    }
    return t.prototype.track = function(e, n, r, i) {
      return this.normalize(R(R({}, this.baseEvent()), { event: e, type: "track", properties: n, options: R({}, r), integrations: R({}, i) }));
    }, t.prototype.page = function(e, n, r, i, o) {
      var a, s = {
        type: "page",
        properties: R({}, r),
        options: R({}, i),
        integrations: R({}, o)
      };
      return e !== null && (s.category = e, s.properties = (a = s.properties) !== null && a !== void 0 ? a : {}, s.properties.category = e), n !== null && (s.name = n), this.normalize(R(R({}, this.baseEvent()), s));
    }, t.prototype.screen = function(e, n, r, i, o) {
      var a = {
        type: "screen",
        properties: R({}, r),
        options: R({}, i),
        integrations: R({}, o)
      };
      return e !== null && (a.category = e), n !== null && (a.name = n), this.normalize(R(R({}, this.baseEvent()), a));
    }, t.prototype.identify = function(e, n, r, i) {
      return this.normalize(R(R({}, this.baseEvent()), { type: "identify", userId: e, traits: n, options: R({}, r), integrations: R({}, i) }));
    }, t.prototype.group = function(e, n, r, i) {
      return this.normalize(R(R({}, this.baseEvent()), { type: "group", traits: n, options: R({}, r), integrations: R({}, i), groupId: e }));
    }, t.prototype.alias = function(e, n, r, i) {
      var o = {
        userId: e,
        type: "alias",
        options: R({}, r),
        integrations: R({}, i)
      };
      return n !== null && (o.previousId = n), e === void 0 ? this.normalize(R(R({}, o), this.baseEvent())) : this.normalize(R(R({}, this.baseEvent()), o));
    }, t.prototype.baseEvent = function() {
      var e = {
        integrations: {},
        options: {}
      }, n = this.user;
      return n.id() && (e.userId = n.id()), n.anonymousId() && (e.anonymousId = n.anonymousId()), e;
    }, t.prototype.context = function(e) {
      var n, r, i, o = ["integrations", "anonymousId", "timestamp", "userId"], a = (n = e.options) !== null && n !== void 0 ? n : {};
      delete a.integrations;
      var s = Object.keys(a), c = (i = (r = e.options) === null || r === void 0 ? void 0 : r.context) !== null && i !== void 0 ? i : {}, l = {};
      return s.forEach(function(u) {
        u !== "context" && (o.includes(u) ? cu(l, u, a[u]) : cu(c, u, a[u]));
      }), [c, l];
    }, t.prototype.normalize = function(e) {
      var n, r, i = Object.keys((n = e.integrations) !== null && n !== void 0 ? n : {}).reduce(function(h, g) {
        var v, b;
        return R(R({}, h), (v = {}, v[g] = !!(!((b = e.integrations) === null || b === void 0) && b[g]), v));
      }, {}), o = R(R({}, i), (r = e.options) === null || r === void 0 ? void 0 : r.integrations), a = this.context(e), s = a[0], c = a[1];
      e.options;
      var l = jr(e, ["options"]), u = R(R(R({ timestamp: /* @__PURE__ */ new Date() }, l), { context: s, integrations: o }), c), d = "ajs-next-" + Nx.hash(JSON.stringify(u) + Di()), f = R(R({}, u), { messageId: d });
      return f;
    }, t;
  }()
);
function Px(t, e) {
  var n = {};
  return t.forEach(function(r) {
    var i, o = void 0;
    if (typeof e == "string") {
      var a = r[e];
      o = typeof a != "string" ? JSON.stringify(a) : a;
    } else
      e instanceof Function && (o = e(r));
    o !== void 0 && (n[o] = ln(ln([], (i = n[o]) !== null && i !== void 0 ? i : [], !0), [r], !1));
  }), n;
}
function Dx(t) {
  var e = Math.random() + 1, n = t.minTimeout, r = n === void 0 ? 500 : n, i = t.factor, o = i === void 0 ? 2 : i, a = t.attempt, s = t.maxTimeout, c = s === void 0 ? 1 / 0 : s;
  return Math.min(e * r * Math.pow(o, a), c);
}
var m_ = "onRemoveFromFuture", yg = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n, r, i) {
      var o = t.call(this) || this;
      return o.future = [], o.maxAttempts = n, o.queue = r, o.seen = i ?? {}, o;
    }
    return e.prototype.push = function() {
      for (var n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var o = r.map(function(a) {
        var s = n.updateAttempts(a);
        return s > n.maxAttempts || n.includes(a) ? !1 : (n.queue.push(a), !0);
      });
      return this.queue = this.queue.sort(function(a, s) {
        return n.getAttempts(a) - n.getAttempts(s);
      }), o;
    }, e.prototype.pushWithBackoff = function(n) {
      var r = this;
      if (this.getAttempts(n) === 0)
        return this.push(n)[0];
      var i = this.updateAttempts(n);
      if (i > this.maxAttempts || this.includes(n))
        return !1;
      var o = Dx({ attempt: i - 1 });
      return setTimeout(function() {
        r.queue.push(n), r.future = r.future.filter(function(a) {
          return a.id !== n.id;
        }), r.emit(m_);
      }, o), this.future.push(n), !0;
    }, e.prototype.getAttempts = function(n) {
      var r;
      return (r = this.seen[n.id]) !== null && r !== void 0 ? r : 0;
    }, e.prototype.updateAttempts = function(n) {
      return this.seen[n.id] = this.getAttempts(n) + 1, this.getAttempts(n);
    }, e.prototype.includes = function(n) {
      return this.queue.includes(n) || this.future.includes(n) || !!this.queue.find(function(r) {
        return r.id === n.id;
      }) || !!this.future.find(function(r) {
        return r.id === n.id;
      });
    }, e.prototype.pop = function() {
      return this.queue.shift();
    }, Object.defineProperty(e.prototype, "length", {
      get: function() {
        return this.queue.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "todo", {
      get: function() {
        return this.queue.length + this.future.length;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }(vg)
), Hr = {
  getItem: function() {
  },
  setItem: function() {
  },
  removeItem: function() {
  }
};
try {
  Hr = mg() && window.localStorage ? window.localStorage : Hr;
} catch (t) {
  console.warn("Unable to access localStorage", t);
}
function v_(t) {
  var e = Hr.getItem(t);
  return (e ? JSON.parse(e) : []).map(function(n) {
    return new ui(n.event, n.id);
  });
}
function Lx(t, e) {
  var n = v_(t), r = ln(ln([], e, !0), n, !0), i = r.reduce(function(o, a) {
    var s;
    return R(R({}, o), (s = {}, s[a.id] = a, s));
  }, {});
  Hr.setItem(t, JSON.stringify(Object.values(i)));
}
function y_(t) {
  var e = Hr.getItem(t);
  return e ? JSON.parse(e) : {};
}
function Fx(t, e) {
  var n = y_(t);
  Hr.setItem(t, JSON.stringify(R(R({}, n), e)));
}
function J0(t) {
  Hr.removeItem(t);
}
var Ux = function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function Vh(t, e, n) {
  n === void 0 && (n = 0);
  var r = 50, i = "persisted-queue:v1:".concat(t, ":lock"), o = function(l) {
    return (/* @__PURE__ */ new Date()).getTime() > l;
  }, a = Hr.getItem(i), s = a ? JSON.parse(a) : null, c = s === null || o(s);
  if (c) {
    Hr.setItem(i, JSON.stringify(Ux() + r)), e(), Hr.removeItem(i);
    return;
  }
  !c && n < 3 ? setTimeout(function() {
    Vh(t, e, n + 1);
  }, r) : console.error("Unable to retrieve lock");
}
var wg = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n, r) {
      var i = t.call(this, n, []) || this, o = "persisted-queue:v1:".concat(r, ":items"), a = "persisted-queue:v1:".concat(r, ":seen"), s = [], c = {};
      return Vh(r, function() {
        try {
          s = v_(o), c = y_(a), J0(o), J0(a), i.queue = ln(ln([], s, !0), i.queue, !0), i.seen = R(R({}, c), i.seen);
        } catch (l) {
          console.error(l);
        }
      }), window.addEventListener("beforeunload", function() {
        if (i.todo > 0) {
          var l = ln(ln([], i.queue, !0), i.future, !0);
          try {
            Vh(r, function() {
              Lx(o, l), Fx(a, i.seen);
            });
          } catch (u) {
            console.error(u);
          }
        }
      }), i;
    }
    return e;
  }(yg)
), w_ = function(t) {
  return typeof t == "object" && t !== null && "then" in t && typeof t.then == "function";
}, Hx = function() {
  var t, e, n = 0;
  return {
    done: function() {
      return t;
    },
    run: function(r) {
      var i = r();
      return w_(i) && (++n === 1 && (t = new Promise(function(o) {
        return e = o;
      })), i.finally(function() {
        return --n === 0 && e();
      })), i;
    }
  };
};
function Bx(t) {
  return ke(this, void 0, void 0, function() {
    var e;
    return Ae(this, function(n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 2, , 3]), [4, t()];
        case 1:
          return [2, n.sent()];
        case 2:
          return e = n.sent(), [2, Promise.reject(e)];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Ps(t, e) {
  t.log("debug", "plugin", { plugin: e.name });
  var n = (/* @__PURE__ */ new Date()).getTime(), r = e[t.event.type];
  if (r === void 0)
    return Promise.resolve(t);
  var i = Bx(function() {
    return r.apply(e, [t]);
  }).then(function(o) {
    var a = (/* @__PURE__ */ new Date()).getTime() - n;
    return o.stats.gauge("plugin_time", a, ["plugin:".concat(e.name)]), o;
  }).catch(function(o) {
    if (o instanceof rc && o.type === "middleware_cancellation")
      throw o;
    return o instanceof rc ? (t.log("warn", o.type, {
      plugin: e.name,
      error: o
    }), o) : (t.log("error", "plugin Error", {
      plugin: e.name,
      error: o
    }), t.stats.increment("plugin_error", 1, ["plugin:".concat(e.name)]), o);
  });
  return i;
}
function jx(t, e) {
  return Ps(t, e).then(function(n) {
    if (n instanceof ui)
      return n;
    t.log("debug", "Context canceled"), t.stats.increment("context_canceled"), t.cancel(n);
  });
}
var b_ = function() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : null;
}, ef, Z0, Vx = b_(), oa = (ef = (Z0 = Vx).__SEGMENT_INSPECTOR__) !== null && ef !== void 0 ? ef : Z0.__SEGMENT_INSPECTOR__ = {}, $x = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n) {
      var r = t.call(this) || this;
      return r.criticalTasks = Hx(), r.plugins = [], r.failedInitializations = [], r.flushing = !1, r.queue = n ?? new wg(4, "event-queue"), r.queue.on(m_, function() {
        r.scheduleFlush(0);
      }), r;
    }
    return e.prototype.register = function(n, r, i) {
      return ke(this, void 0, void 0, function() {
        var o = this;
        return Ae(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, Promise.resolve(r.load(n, i)).then(function() {
                o.plugins.push(r);
              }).catch(function(s) {
                if (r.type === "destination") {
                  o.failedInitializations.push(r.name), console.warn(r.name, s), n.log("warn", "Failed to load destination", {
                    plugin: r.name,
                    error: s
                  });
                  return;
                }
                throw s;
              })];
            case 1:
              return a.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.deregister = function(n, r, i) {
      return ke(this, void 0, void 0, function() {
        var o;
        return Ae(this, function(a) {
          switch (a.label) {
            case 0:
              return a.trys.push([0, 3, , 4]), r.unload ? [4, Promise.resolve(r.unload(n, i))] : [3, 2];
            case 1:
              a.sent(), a.label = 2;
            case 2:
              return this.plugins = this.plugins.filter(function(s) {
                return s.name !== r.name;
              }), [3, 4];
            case 3:
              return o = a.sent(), n.log("warn", "Failed to unload destination", {
                plugin: r.name,
                error: o
              }), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.dispatch = function(n) {
      return ke(this, void 0, void 0, function() {
        var r;
        return Ae(this, function(i) {
          return n.log("debug", "Dispatching"), n.stats.increment("message_dispatched"), this.queue.push(n), r = this.subscribeToDelivery(n), this.scheduleFlush(0), [2, r];
        });
      });
    }, e.prototype.subscribeToDelivery = function(n) {
      return ke(this, void 0, void 0, function() {
        var r = this;
        return Ae(this, function(i) {
          return [2, new Promise(function(o) {
            var a = function(s, c) {
              s.isSame(n) && (r.off("flush", a), o(s));
            };
            r.on("flush", a);
          })];
        });
      });
    }, e.prototype.dispatchSingle = function(n) {
      return ke(this, void 0, void 0, function() {
        var r = this;
        return Ae(this, function(i) {
          return n.log("debug", "Dispatching"), n.stats.increment("message_dispatched"), this.queue.updateAttempts(n), n.attempts = 1, [2, this.deliver(n).catch(function(o) {
            if (o instanceof rc && o.retry === !1)
              return n.setFailedDelivery({ reason: o }), n;
            var a = r.enqueuRetry(o, n);
            return a ? r.subscribeToDelivery(n) : (n.setFailedDelivery({ reason: o }), n);
          })];
        });
      });
    }, e.prototype.isEmpty = function() {
      return this.queue.length === 0;
    }, e.prototype.scheduleFlush = function(n) {
      var r = this;
      n === void 0 && (n = 500), !this.flushing && (this.flushing = !0, setTimeout(function() {
        r.flush().then(function() {
          setTimeout(function() {
            r.flushing = !1, r.queue.length && r.scheduleFlush(0);
          }, 0);
        });
      }, n));
    }, e.prototype.deliver = function(n) {
      return ke(this, void 0, void 0, function() {
        var r, i, o;
        return Ae(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.criticalTasks.done()];
            case 1:
              a.sent(), r = Date.now(), a.label = 2;
            case 2:
              return a.trys.push([2, 4, , 5]), [4, this.flushOne(n)];
            case 3:
              return n = a.sent(), i = Date.now() - r, n.stats.gauge("delivered", i), n.log("debug", "Delivered", n.event), [2, n];
            case 4:
              throw o = a.sent(), n.log("error", "Failed to deliver", o), n.stats.increment("delivery_failed"), o;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.enqueuRetry = function(n, r) {
      var i = n instanceof rc && n.retry === !1, o = !i;
      if (o) {
        var a = this.queue.pushWithBackoff(r);
        return a;
      }
      return !1;
    }, e.prototype.flush = function() {
      return ke(this, void 0, void 0, function() {
        var n, r, i;
        return Ae(this, function(o) {
          switch (o.label) {
            case 0:
              if (this.queue.length === 0 || !h_())
                return [2, []];
              if (n = this.queue.pop(), !n)
                return [2, []];
              n.attempts = this.queue.getAttempts(n), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.deliver(n)];
            case 2:
              return n = o.sent(), this.emit("flush", n, !0), [3, 4];
            case 3:
              return r = o.sent(), i = this.enqueuRetry(r, n), i || (n.setFailedDelivery({ reason: r }), this.emit("flush", n, !1)), [2, []];
            case 4:
              return [2, [n]];
          }
        });
      });
    }, e.prototype.isReady = function() {
      return !0;
    }, e.prototype.availableExtensions = function(n) {
      var r = this.plugins.filter(function(h) {
        var g;
        return h.type !== "destination" && h.name !== "Segment.io" ? !0 : (g = n[h.name]) !== null && g !== void 0 ? g : (h.name === "Segment.io" ? !0 : n.All) !== !1;
      }), i = Px(r, "type"), o = i.before, a = o === void 0 ? [] : o, s = i.enrichment, c = s === void 0 ? [] : s, l = i.destination, u = l === void 0 ? [] : l, d = i.after, f = d === void 0 ? [] : d;
      return {
        before: a,
        enrichment: c,
        destinations: u,
        after: f
      };
    }, e.prototype.flushOne = function(n) {
      var r, i, o, a;
      return ke(this, void 0, void 0, function() {
        var s, c, l, u, d, f, b, h, g, v, b, m, y, p, w;
        return Ae(this, function(_) {
          switch (_.label) {
            case 0:
              if (!this.isReady())
                throw new Error("Not ready");
              s = this.availableExtensions((r = n.event.integrations) !== null && r !== void 0 ? r : {}), c = s.before, l = s.enrichment, u = 0, d = c, _.label = 1;
            case 1:
              return u < d.length ? (f = d[u], [4, jx(n, f)]) : [3, 4];
            case 2:
              b = _.sent(), b instanceof ui && (n = b), _.label = 3;
            case 3:
              return u++, [3, 1];
            case 4:
              h = 0, g = l, _.label = 5;
            case 5:
              return h < g.length ? (v = g[h], [4, Ps(n, v)]) : [3, 8];
            case 6:
              b = _.sent(), b instanceof ui && (n = b), _.label = 7;
            case 7:
              return h++, [3, 5];
            case 8:
              return (i = oa.enriched) === null || i === void 0 || i.call(oa, n), m = this.availableExtensions((o = n.event.integrations) !== null && o !== void 0 ? o : {}), y = m.destinations, p = m.after, [4, new Promise(function(E, S) {
                setTimeout(function() {
                  var T = y.map(function(x) {
                    return Ps(n, x);
                  });
                  Promise.all(T).then(E).catch(S);
                }, 0);
              })];
            case 9:
              return _.sent(), n.stats.increment("message_delivered"), (a = oa.delivered) === null || a === void 0 || a.call(oa, n, ["segment.io"]), w = p.map(function(E) {
                return Ps(n, E);
              }), [4, Promise.all(w)];
            case 10:
              return _.sent(), [2, n];
          }
        });
      });
    }, e;
  }(vg)
);
function bg(t) {
  for (var e = t.constructor.prototype, n = 0, r = Object.getOwnPropertyNames(e); n < r.length; n++) {
    var i = r[n];
    if (i !== "constructor") {
      var o = Object.getOwnPropertyDescriptor(t.constructor.prototype, i);
      o && typeof o.value == "function" && (t[i] = t[i].bind(t));
    }
  }
  return t;
}
var Vo = {
  persist: !0,
  cookie: {
    key: "ajs_user_id",
    oldKey: "ajs_user"
  },
  localStorage: {
    key: "ajs_user_traits"
  }
}, Zu = (
  /** @class */
  function() {
    function t() {
      this.cache = {};
    }
    return t.prototype.get = function(e) {
      return this.cache[e];
    }, t.prototype.set = function(e, n) {
      return this.cache[e] = n, n;
    }, t.prototype.remove = function(e) {
      delete this.cache[e];
    }, t;
  }()
), qx = 365, X0 = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n) {
      n === void 0 && (n = e.defaults);
      var r = t.call(this) || this;
      return r.options = R(R({}, e.defaults), n), r;
    }
    return e.available = function() {
      var n = window.navigator.cookieEnabled;
      return n || (Gn.set("ajs:cookies", "test"), n = document.cookie.includes("ajs:cookies"), Gn.remove("ajs:cookies")), n;
    }, Object.defineProperty(e, "defaults", {
      get: function() {
        return {
          maxage: qx,
          domain: p_(window.location.href),
          path: "/",
          sameSite: "Lax"
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.opts = function() {
      return {
        sameSite: this.options.sameSite,
        expires: this.options.maxage,
        domain: this.options.domain,
        path: this.options.path,
        secure: this.options.secure
      };
    }, e.prototype.get = function(n) {
      try {
        var r = Gn.get(n);
        if (!r)
          return null;
        try {
          return JSON.parse(r);
        } catch {
          return r;
        }
      } catch {
        return null;
      }
    }, e.prototype.set = function(n, r) {
      return typeof r == "string" ? Gn.set(n, r, this.opts()) : r === null ? Gn.remove(n, this.opts()) : Gn.set(n, JSON.stringify(r), this.opts()), r;
    }, e.prototype.remove = function(n) {
      return Gn.remove(n, this.opts());
    }, e;
  }(Zu)
), tf = (
  /** @class */
  function(t) {
    an(e, t);
    function e() {
      var n = t !== null && t.apply(this, arguments) || this;
      return n.get = function(r) {
        return null;
      }, n.set = function(r, i) {
        return null;
      }, n.remove = function(r) {
      }, n;
    }
    return e;
  }(Zu)
), ey = (
  /** @class */
  function(t) {
    an(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.available = function() {
      var n = "test";
      try {
        return localStorage.setItem(n, n), localStorage.removeItem(n), !0;
      } catch {
        return !1;
      }
    }, e.prototype.get = function(n) {
      var r = localStorage.getItem(n);
      if (r)
        try {
          return JSON.parse(r);
        } catch {
          return JSON.parse(JSON.stringify(r));
        }
      return null;
    }, e.prototype.set = function(n, r) {
      try {
        localStorage.setItem(n, JSON.stringify(r));
      } catch {
        console.warn("Unable to set ".concat(n, " in localStorage, storage may be full."));
      }
      return r;
    }, e.prototype.remove = function(n) {
      return localStorage.removeItem(n);
    }, e;
  }(Zu)
), __ = (
  /** @class */
  function() {
    function t(e, n) {
      e === void 0 && (e = Vo);
      var r = this, i, o, a, s;
      this.options = {}, this.id = function(d) {
        var f, h;
        if (r.options.disable)
          return null;
        var g = r.chainGet(r.idKey);
        if (d !== void 0) {
          r.trySet(r.idKey, d);
          var v = d !== g && g !== null && d !== null;
          v && r.anonymousId(null);
        }
        return (h = (f = r.chainGet(r.idKey)) !== null && f !== void 0 ? f : r.cookies.get(Vo.cookie.oldKey)) !== null && h !== void 0 ? h : null;
      }, this.anonymousId = function(d) {
        var f, h;
        if (r.options.disable)
          return null;
        if (d === void 0) {
          var g = (f = r.chainGet(r.anonKey)) !== null && f !== void 0 ? f : (h = r.legacySIO()) === null || h === void 0 ? void 0 : h[0];
          if (g)
            return g;
        }
        return d === null ? (r.trySet(r.anonKey, null), r.chainGet(r.anonKey)) : (r.trySet(r.anonKey, d ?? Di()), r.chainGet(r.anonKey));
      }, this.traits = function(d) {
        var f, h;
        if (!r.options.disable)
          return d === null && (d = {}), d && (r.mem.set(r.traitsKey, d ?? {}), r.localStorage.set(r.traitsKey, d ?? {})), (h = (f = r.localStorage.get(r.traitsKey)) !== null && f !== void 0 ? f : r.mem.get(r.traitsKey)) !== null && h !== void 0 ? h : {};
      }, this.options = e, this.cookieOptions = n, this.idKey = (o = (i = e.cookie) === null || i === void 0 ? void 0 : i.key) !== null && o !== void 0 ? o : Vo.cookie.key, this.traitsKey = (s = (a = e.localStorage) === null || a === void 0 ? void 0 : a.key) !== null && s !== void 0 ? s : Vo.localStorage.key, this.anonKey = "ajs_anonymous_id";
      var c = e.disable === !0, l = e.persist !== !1;
      this.localStorage = c || e.localStorageFallbackDisabled || !l || !ey.available() ? new tf() : new ey(), this.cookies = !c && l && X0.available() ? new X0(n) : new tf(), this.mem = c ? new tf() : new Zu();
      var u = this.cookies.get(Vo.cookie.oldKey);
      u && (u.id && this.id(u.id), u.traits && this.traits(u.traits)), bg(this);
    }
    return t.prototype.chainGet = function(e) {
      var n, r, i, o = (i = (r = (n = this.localStorage.get(e)) !== null && n !== void 0 ? n : this.cookies.get(e)) !== null && r !== void 0 ? r : this.mem.get(e)) !== null && i !== void 0 ? i : null;
      return this.trySet(e, typeof o == "number" ? o.toString() : o);
    }, t.prototype.trySet = function(e, n) {
      return this.localStorage.set(e, n), this.cookies.set(e, n), this.mem.set(e, n), n;
    }, t.prototype.chainClear = function(e) {
      this.localStorage.remove(e), this.cookies.remove(e), this.mem.remove(e);
    }, t.prototype.legacySIO = function() {
      var e = this.cookies.get("_sio");
      if (!e)
        return null;
      var n = e.split("----"), r = n[0], i = n[1];
      return [r, i];
    }, t.prototype.identify = function(e, n) {
      if (!this.options.disable) {
        n = n ?? {};
        var r = this.id();
        (r === null || r === e) && (n = R(R({}, this.traits()), n)), e && this.id(e), this.traits(n);
      }
    }, t.prototype.logout = function() {
      this.anonymousId(null), this.id(null), this.traits({});
    }, t.prototype.reset = function() {
      this.logout(), this.chainClear(this.idKey), this.chainClear(this.anonKey), this.chainClear(this.traitsKey);
    }, t.prototype.load = function() {
      return new t(this.options, this.cookieOptions);
    }, t.prototype.save = function() {
      return !0;
    }, t.defaults = Vo, t;
  }()
), zx = {
  persist: !0,
  cookie: {
    key: "ajs_group_id"
  },
  localStorage: {
    key: "ajs_group_properties"
  }
}, Kx = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n, r) {
      n === void 0 && (n = zx);
      var i = t.call(this, n, r) || this;
      return i.anonymousId = function(o) {
      }, bg(i), i;
    }
    return e;
  }(__)
), Ti = "This is being deprecated and will be not be available in future releases of Analytics JS", nf = b_(), rf = nf == null ? void 0 : nf.analytics;
function Wx(t, e) {
  t === void 0 && (t = !1), e === void 0 && (e = !1);
  var n = t ? 4 : 1, r = e ? new yg(n, []) : new wg(n, "event-queue");
  return new $x(r);
}
function Nr() {
  console.warn(Ti);
}
var Gx = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n, r, i, o, a) {
      var s = this, c, l, u;
      s = t.call(this) || this, s._debug = !1, s.initialized = !1, s.user = function() {
        return s._user;
      }, s.init = s.initialize.bind(s), s.log = Nr, s.addIntegrationMiddleware = Nr, s.listeners = Nr, s.addEventListener = Nr, s.removeAllListeners = Nr, s.removeListener = Nr, s.removeEventListener = Nr, s.hasListeners = Nr, s.add = Nr, s.addIntegration = Nr;
      var d = r == null ? void 0 : r.cookie, f = (c = r == null ? void 0 : r.disableClientPersistence) !== null && c !== void 0 ? c : !1;
      return s.settings = n, s.settings.timeout = (l = s.settings.timeout) !== null && l !== void 0 ? l : 300, s.queue = i ?? Wx(r == null ? void 0 : r.retryQueue, f), s._user = o ?? new __(f ? R(R({}, r == null ? void 0 : r.user), { persist: !1 }) : r == null ? void 0 : r.user, d).load(), s._group = a ?? new Kx(f ? R(R({}, r == null ? void 0 : r.group), { persist: !1 }) : r == null ? void 0 : r.group, d).load(), s.eventFactory = new Mx(s._user), s.integrations = (u = r == null ? void 0 : r.integrations) !== null && u !== void 0 ? u : {}, s.options = r ?? {}, bg(s), s;
    }
    return e.prototype.track = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u = this;
        return Ae(this, function(d) {
          return i = lx.apply(void 0, n), o = i[0], a = i[1], s = i[2], c = i[3], l = this.eventFactory.track(o, a, s, this.integrations), [2, this.dispatch(l, c).then(function(f) {
            return u.emit("track", o, f.event.properties, f.event.options), f;
          })];
        });
      });
    }, e.prototype.page = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u, d = this;
        return Ae(this, function(f) {
          return i = G0.apply(void 0, n), o = i[0], a = i[1], s = i[2], c = i[3], l = i[4], u = this.eventFactory.page(o, a, s, c, this.integrations), [2, this.dispatch(u, l).then(function(h) {
            return d.emit("page", o, a, h.event.properties, h.event.options), h;
          })];
        });
      });
    }, e.prototype.identify = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u = this;
        return Ae(this, function(d) {
          return i = Y0(this._user).apply(void 0, n), o = i[0], a = i[1], s = i[2], c = i[3], this._user.identify(o, a), l = this.eventFactory.identify(this._user.id(), this._user.traits(), s, this.integrations), [2, this.dispatch(l, c).then(function(f) {
            return u.emit("identify", f.event.userId, f.event.traits, f.event.options), f;
          })];
        });
      });
    }, e.prototype.group = function() {
      for (var n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      if (r.length === 0)
        return this._group;
      var o = Y0(this._group).apply(void 0, r), a = o[0], s = o[1], c = o[2], l = o[3];
      this._group.identify(a, s);
      var u = this._group.id(), d = this._group.traits(), f = this.eventFactory.group(u, d, c, this.integrations);
      return this.dispatch(f, l).then(function(h) {
        return n.emit("group", h.event.groupId, h.event.traits, h.event.options), h;
      });
    }, e.prototype.alias = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u = this;
        return Ae(this, function(d) {
          return i = ux.apply(void 0, n), o = i[0], a = i[1], s = i[2], c = i[3], l = this.eventFactory.alias(o, a, s, this.integrations), [2, this.dispatch(l, c).then(function(f) {
            return u.emit("alias", o, a, f.event.options), f;
          })];
        });
      });
    }, e.prototype.screen = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o, a, s, c, l, u, d = this;
        return Ae(this, function(f) {
          return i = G0.apply(void 0, n), o = i[0], a = i[1], s = i[2], c = i[3], l = i[4], u = this.eventFactory.screen(o, a, s, c, this.integrations), [2, this.dispatch(u, l).then(function(h) {
            return d.emit("screen", o, a, h.event.properties, h.event.options), h;
          })];
        });
      });
    }, e.prototype.trackClick = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o;
        return Ae(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-de9d661c.js"
              )];
            case 1:
              return i = a.sent(), [2, (o = i.link).call.apply(o, ln([this], n, !1))];
          }
        });
      });
    }, e.prototype.trackLink = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o;
        return Ae(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-de9d661c.js"
              )];
            case 1:
              return i = a.sent(), [2, (o = i.link).call.apply(o, ln([this], n, !1))];
          }
        });
      });
    }, e.prototype.trackSubmit = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o;
        return Ae(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-de9d661c.js"
              )];
            case 1:
              return i = a.sent(), [2, (o = i.form).call.apply(o, ln([this], n, !1))];
          }
        });
      });
    }, e.prototype.trackForm = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o;
        return Ae(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-de9d661c.js"
              )];
            case 1:
              return i = a.sent(), [2, (o = i.form).call.apply(o, ln([this], n, !1))];
          }
        });
      });
    }, e.prototype.register = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o, a = this;
        return Ae(this, function(s) {
          switch (s.label) {
            case 0:
              return i = ui.system(), o = n.map(function(c) {
                return a.queue.register(i, c, a);
              }), [4, Promise.all(o)];
            case 1:
              return s.sent(), [2, i];
          }
        });
      });
    }, e.prototype.deregister = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return ke(this, void 0, void 0, function() {
        var i, o, a = this;
        return Ae(this, function(s) {
          switch (s.label) {
            case 0:
              return i = ui.system(), o = n.map(function(c) {
                return ke(a, void 0, void 0, function() {
                  var l;
                  return Ae(this, function(u) {
                    return l = this.queue.plugins.find(function(d) {
                      return d.name === c;
                    }), l ? [2, this.queue.deregister(i, l, this)] : (i.log("warn", "plugin ".concat(c, " not found")), [
                      2
                      /*return*/
                    ]);
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return s.sent(), [2, i];
          }
        });
      });
    }, e.prototype.debug = function(n) {
      return n === !1 && localStorage.getItem("debug") && localStorage.removeItem("debug"), this._debug = n, this;
    }, e.prototype.reset = function() {
      this._user.reset();
    }, e.prototype.timeout = function(n) {
      this.settings.timeout = n;
    }, e.prototype.dispatch = function(n, r) {
      var i;
      return ke(this, void 0, void 0, function() {
        var o, a, s, c, l;
        return Ae(this, function(u) {
          switch (u.label) {
            case 0:
              return o = new ui(n), (i = oa.triggered) === null || i === void 0 || i.call(oa, o), su() && !this.options.retryQueue ? [2, o] : (a = Date.now(), this.queue.isEmpty() ? [4, this.queue.dispatchSingle(o)] : [3, 2]);
            case 1:
              return s = u.sent(), [3, 4];
            case 2:
              return [4, this.queue.dispatch(o)];
            case 3:
              s = u.sent(), u.label = 4;
            case 4:
              return c = Date.now() - a, l = this.settings.timeout, r ? [4, hx(s, r, Math.max((l ?? 300) - c, 0), l)] : [3, 6];
            case 5:
              s = u.sent(), u.label = 6;
            case 6:
              return this._debug && s.flush(), [2, s];
          }
        });
      });
    }, e.prototype.addSourceMiddleware = function(n) {
      return ke(this, void 0, void 0, function() {
        var r = this;
        return Ae(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, this.queue.criticalTasks.run(function() {
                return ke(r, void 0, void 0, function() {
                  var o, a, s;
                  return Ae(this, function(c) {
                    switch (c.label) {
                      case 0:
                        return [4, import(
                          /* webpackChunkName: "middleware" */
                          "./index-75336a1b.js"
                        )];
                      case 1:
                        return o = c.sent().sourceMiddlewarePlugin, a = {}, this.queue.plugins.forEach(function(l) {
                          if (l.type === "destination")
                            return a[l.name] = !0;
                        }), s = o(n, a), [4, this.register(s)];
                      case 2:
                        return c.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              })];
            case 1:
              return i.sent(), [2, this];
          }
        });
      });
    }, e.prototype.addDestinationMiddleware = function(n) {
      for (var r = [], i = 1; i < arguments.length; i++)
        r[i - 1] = arguments[i];
      var o = this.queue.plugins.filter(function(a) {
        return a.name.toLowerCase() === n.toLowerCase();
      });
      return o.forEach(function(a) {
        a.addMiddleware.apply(a, r);
      }), Promise.resolve(this);
    }, e.prototype.setAnonymousId = function(n) {
      return this._user.anonymousId(n);
    }, e.prototype.queryString = function(n) {
      return ke(this, void 0, void 0, function() {
        var r;
        return Ae(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "queryString" */
                "./index-5bdabf19.js"
              )];
            case 1:
              return r = i.sent().queryString, [2, r(this, n)];
          }
        });
      });
    }, e.prototype.use = function(n) {
      return n(this), this;
    }, e.prototype.ready = function(n) {
      return n === void 0 && (n = function(r) {
        return r;
      }), ke(this, void 0, void 0, function() {
        return Ae(this, function(r) {
          return [2, Promise.all(this.queue.plugins.map(function(i) {
            return i.ready ? i.ready() : Promise.resolve();
          })).then(function(i) {
            return n(i), i;
          })];
        });
      });
    }, e.prototype.noConflict = function() {
      return console.warn(Ti), window.analytics = rf ?? this, this;
    }, e.prototype.normalize = function(n) {
      return console.warn(Ti), this.eventFactory.normalize(n);
    }, Object.defineProperty(e.prototype, "failedInitializations", {
      get: function() {
        return console.warn(Ti), this.queue.failedInitializations;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "VERSION", {
      get: function() {
        return Ma;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.initialize = function(n, r) {
      return ke(this, void 0, void 0, function() {
        return Ae(this, function(i) {
          return console.warn(Ti), [2, Promise.resolve(this)];
        });
      });
    }, e.prototype.pageview = function(n) {
      return ke(this, void 0, void 0, function() {
        return Ae(this, function(r) {
          switch (r.label) {
            case 0:
              return console.warn(Ti), [4, this.page({ path: n })];
            case 1:
              return r.sent(), [2, this];
          }
        });
      });
    }, Object.defineProperty(e.prototype, "plugins", {
      get: function() {
        var n;
        return console.warn(Ti), (n = this._plugins) !== null && n !== void 0 ? n : {};
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "Integrations", {
      get: function() {
        console.warn(Ti);
        var n = this.queue.plugins.filter(function(r) {
          return r.type === "destination";
        }).reduce(function(r, i) {
          var o = "".concat(i.name.toLowerCase().replace(".", "").split(" ").join("-"), "Integration"), a = window[o];
          if (!a)
            return r;
          var s = a.Integration;
          return s ? (r[i.name] = s, r) : (r[i.name] = a, r);
        }, {});
        return n;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.push = function(n) {
      var r = this, i = n.shift();
      i && !r[i] || r[i].apply(this, n);
    }, e;
  }(vg)
);
function Yx() {
  return typeof process > "u" || !process.env ? {} : process.env;
}
var Qx = /(https:\/\/.*)\/analytics\.js\/v1\/(?:.*?)\/(?:platform|analytics.*)?/, Jx = function() {
  var t, e = Array.prototype.slice.call(document.querySelectorAll("script"));
  return e.forEach(function(n) {
    var r, i = (r = n.getAttribute("src")) !== null && r !== void 0 ? r : "", o = Qx.exec(i);
    o && o[1] && (t = o[1]);
  }), t;
}, Sl, Zx = function() {
  var t, e = Sl ?? ((t = window.analytics) === null || t === void 0 ? void 0 : t._cdn);
  return e;
}, Xx = function(t) {
  window.analytics && (window.analytics._cdn = t), Sl = t;
}, _g = function() {
  var t = Zx();
  if (t)
    return t;
  var e = Jx();
  return e || "https://cdn.segment.com";
}, OW = function() {
  var t = _g();
  return "".concat(t, "/next-integrations");
};
function e7(t, e) {
  var n, r = Object.entries((n = e.integrations) !== null && n !== void 0 ? n : {}).reduce(function(i, o) {
    var a, s, c = o[0], l = o[1];
    return typeof l == "object" ? R(R({}, i), (a = {}, a[c] = l, a)) : R(R({}, i), (s = {}, s[c] = {}, s));
  }, {});
  return Object.entries(t.integrations).reduce(function(i, o) {
    var a, s = o[0], c = o[1];
    return R(R({}, i), (a = {}, a[s] = R(R({}, c), r[s]), a));
  }, {});
}
function E_() {
  var t = document.getElementsByTagName("link"), e = "";
  return Array.prototype.slice.call(t).forEach(function(n) {
    n.getAttribute("rel") === "canonical" && (e = n.getAttribute("href"));
  }), e;
}
function t7() {
  var t = E_();
  if (!t)
    return window.location.pathname;
  var e = document.createElement("a");
  e.href = t;
  var n = e.pathname.startsWith("/") ? e.pathname : "/" + e.pathname;
  return n;
}
function n7(t) {
  t === void 0 && (t = "");
  var e = E_();
  if (e)
    return e.includes("?") ? e : "".concat(e).concat(t);
  var n = window.location.href, r = n.indexOf("#");
  return r === -1 ? n : n.slice(0, r);
}
function C_() {
  return {
    path: t7(),
    referrer: document.referrer,
    search: location.search,
    title: document.title,
    url: n7(location.search)
  };
}
function ds(t) {
  var e, n = t.event;
  n.context = n.context || {};
  var r = C_(), i = (e = n.properties) !== null && e !== void 0 ? e : {};
  return Object.keys(r).forEach(function(o) {
    i[o] && (r[o] = i[o]);
  }), n.context.page && (r = Object.assign({}, r, n.context.page)), n.context = Object.assign({}, n.context, {
    page: r
  }), t.event = n, t;
}
var r7 = {
  name: "Page Enrichment",
  version: "0.1.0",
  isLoaded: function() {
    return !0;
  },
  load: function() {
    return Promise.resolve();
  },
  type: "before",
  page: function(t) {
    return t.event.properties = Object.assign({}, C_(), t.event.properties), t.event.name && (t.event.properties.name = t.event.name), ds(t);
  },
  alias: ds,
  track: ds,
  identify: ds,
  group: ds
};
function I_(t) {
  var e = Array.prototype.slice.call(window.document.querySelectorAll("script"));
  return e.find(function(n) {
    return n.src === t;
  });
}
function of(t, e) {
  var n = I_(t);
  if (n !== void 0) {
    var r = n == null ? void 0 : n.getAttribute("status");
    if (r === "loaded")
      return Promise.resolve(n);
    if (r === "loading")
      return new Promise(function(i, o) {
        n.addEventListener("load", function() {
          return i(n);
        }), n.addEventListener("error", function(a) {
          return o(a);
        });
      });
  }
  return new Promise(function(i, o) {
    var a, s = window.document.createElement("script");
    s.type = "text/javascript", s.src = t, s.async = !0, s.setAttribute("status", "loading");
    for (var c = 0, l = Object.entries(e ?? {}); c < l.length; c++) {
      var u = l[c], d = u[0], f = u[1];
      s.setAttribute(d, f);
    }
    s.onload = function() {
      s.onerror = s.onload = null, s.setAttribute("status", "loaded"), i(s);
    }, s.onerror = function() {
      s.onerror = s.onload = null, s.setAttribute("status", "error"), o(new Error("Failed to load ".concat(t)));
    };
    var h = window.document.getElementsByTagName("script")[0];
    (a = h.parentElement) === null || a === void 0 || a.insertBefore(s, h);
  });
}
function xW(t) {
  var e = I_(t);
  return e !== void 0 && e.remove(), Promise.resolve();
}
function i7(t) {
  if (!Array.isArray(t))
    throw new Error("Not a valid list of plugins");
  var e = ["load", "isLoaded", "name", "version", "type"];
  return t.forEach(function(n) {
    e.forEach(function(r) {
      var i;
      if (n[r] === void 0)
        throw new Error("Plugin: ".concat((i = n.name) !== null && i !== void 0 ? i : "unknown", " missing required function ").concat(r));
    });
  }), !0;
}
function o7(t, e, n, r) {
  var i;
  return ke(this, void 0, void 0, function() {
    var o, a, s, c = this;
    return Ae(this, function(l) {
      switch (l.label) {
        case 0:
          return o = [], a = _g(), s = ((i = t.remotePlugins) !== null && i !== void 0 ? i : []).map(function(u) {
            return ke(c, void 0, void 0, function() {
              var d, f, h, g, v, b, m, y;
              return Ae(this, function(p) {
                switch (p.label) {
                  case 0:
                    if (e.All === !1 && !e[u.name] || e[u.name] === !1)
                      return [
                        2
                        /*return*/
                      ];
                    p.label = 1;
                  case 1:
                    if (p.trys.push([1, 12, , 13]), !r)
                      return [3, 7];
                    d = u.url.split("/"), f = d[d.length - 2], h = u.url.replace(f, btoa(f).replace(/=/g, "")), p.label = 2;
                  case 2:
                    return p.trys.push([2, 4, , 6]), [4, of(h.replace("https://cdn.segment.com", a))];
                  case 3:
                    return p.sent(), [3, 6];
                  case 4:
                    return p.sent(), [4, of(u.url.replace("https://cdn.segment.com", a))];
                  case 5:
                    return p.sent(), [3, 6];
                  case 6:
                    return [3, 9];
                  case 7:
                    return [4, of(u.url.replace("https://cdn.segment.com", a))];
                  case 8:
                    p.sent(), p.label = 9;
                  case 9:
                    return g = u.libraryName, typeof window[g] != "function" ? [3, 11] : (v = window[g], [4, f_(v(R(R({}, u.settings), n[u.name])))]);
                  case 10:
                    b = p.sent(), m = Array.isArray(b) ? b : [b], i7(m), o.push.apply(o, m), p.label = 11;
                  case 11:
                    return [3, 13];
                  case 12:
                    return y = p.sent(), console.warn("Failed to load Remote Plugin", y), [3, 13];
                  case 13:
                    return [
                      2
                      /*return*/
                    ];
                }
              });
            });
          }), [4, Promise.all(s)];
        case 1:
          return l.sent(), [2, o.filter(Boolean)];
      }
    });
  });
}
var ki = {}, Kr = {}, Eg = {}, Pa = {}, a7 = {
  get exports() {
    return Pa;
  },
  set exports(t) {
    Pa = t;
  }
};
(function(t) {
  t.exports = e(n), t.exports.find = t.exports, t.exports.replace = function(s, c, l, u) {
    return e(i).call(this, s, c, l, u), s;
  }, t.exports.del = function(s, c, l) {
    return e(r).call(this, s, c, null, l), s;
  };
  function e(s) {
    return function(c, l, u, d) {
      var f = d && a(d.normalizer) ? d.normalizer : o;
      l = f(l);
      for (var h, g = !1; !g; )
        v();
      function v() {
        for (h in c) {
          var b = f(h);
          if (l.indexOf(b) === 0) {
            var m = l.substr(b.length);
            if (m.charAt(0) === "." || m.length === 0) {
              l = m.substr(1);
              var y = c[h];
              if (y == null) {
                g = !0;
                return;
              }
              if (!l.length) {
                g = !0;
                return;
              }
              c = y;
              return;
            }
          }
        }
        h = void 0, g = !0;
      }
      if (h)
        return c == null ? c : s(c, h, u);
    };
  }
  function n(s, c) {
    if (s.hasOwnProperty(c))
      return s[c];
  }
  function r(s, c) {
    return s.hasOwnProperty(c) && delete s[c], s;
  }
  function i(s, c, l) {
    return s.hasOwnProperty(c) && (s[c] = l), s;
  }
  function o(s) {
    return s.replace(/[^a-zA-Z0-9\.]+/g, "").toLowerCase();
  }
  function a(s) {
    return typeof s == "function";
  }
})(a7);
var s7 = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Eg, "__esModule", { value: !0 });
var Ei = s7(Pa);
function $o(t, e) {
  return function() {
    var n = this.traits(), r = this.properties ? this.properties() : {};
    return Ei.default(n, "address." + t) || Ei.default(n, t) || (e ? Ei.default(n, "address." + e) : null) || (e ? Ei.default(n, e) : null) || Ei.default(r, "address." + t) || Ei.default(r, t) || (e ? Ei.default(r, "address." + e) : null) || (e ? Ei.default(r, e) : null);
  };
}
function c7(t) {
  t.zip = $o("postalCode", "zip"), t.country = $o("country"), t.street = $o("street"), t.state = $o("state"), t.city = $o("city"), t.region = $o("region");
}
Eg.default = c7;
var Xu = {};
Object.defineProperty(Xu, "__esModule", { value: !0 });
Xu.clone = void 0;
function $h(t) {
  if (typeof t != "object")
    return t;
  if (Object.prototype.toString.call(t) === "[object Object]") {
    var e = {};
    for (var n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = $h(t[n]));
    return e;
  } else
    return Array.isArray(t) ? t.map($h) : t;
}
Xu.clone = $h;
var Cg = {};
Object.defineProperty(Cg, "__esModule", { value: !0 });
var l7 = {
  Salesforce: !0
};
function u7(t) {
  return !l7[t];
}
Cg.default = u7;
var ed = {}, S_ = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
ed.parse = function(t) {
  var e = [1, 5, 6, 7, 11, 12], n = S_.exec(t), r = 0;
  if (!n)
    return new Date(t);
  for (var i = 0, o; o = e[i]; i++)
    n[o] = parseInt(n[o], 10) || 0;
  n[2] = parseInt(n[2], 10) || 1, n[3] = parseInt(n[3], 10) || 1, n[2]--, n[8] = n[8] ? (n[8] + "00").substring(0, 3) : 0, n[4] === " " ? r = (/* @__PURE__ */ new Date()).getTimezoneOffset() : n[9] !== "Z" && n[10] && (r = n[11] * 60 + n[12], n[10] === "+" && (r = 0 - r));
  var a = Date.UTC(n[1], n[2], n[3], n[5], n[6] + r, n[7], n[8]);
  return new Date(a);
};
ed.is = function(t, e) {
  return typeof t != "string" || e && /^\d{4}-\d{2}-\d{2}/.test(t) === !1 ? !1 : S_.test(t);
};
var Ig = {}, d7 = /\d{13}/;
Ig.is = function(t) {
  return d7.test(t);
};
Ig.parse = function(t) {
  return t = parseInt(t, 10), new Date(t);
};
var Sg = {}, f7 = /\d{10}/;
Sg.is = function(t) {
  return f7.test(t);
};
Sg.parse = function(t) {
  var e = parseInt(t, 10) * 1e3;
  return new Date(e);
};
var ty = ed, ny = Ig, ry = Sg, h7 = Object.prototype, T_ = h7.toString;
function p7(t) {
  return T_.call(t) === "[object Date]";
}
function g7(t) {
  return T_.call(t) === "[object Number]";
}
var Tg = function(e) {
  return p7(e) ? e : g7(e) ? new Date(m7(e)) : ty.is(e) ? ty.parse(e) : ny.is(e) ? ny.parse(e) : ry.is(e) ? ry.parse(e) : new Date(e);
};
function m7(t) {
  return t < 315576e5 ? t * 1e3 : t;
}
var iy = ed, v7 = kg;
function kg(t, e) {
  return e === void 0 && (e = !0), t && typeof t == "object" ? y7(t, e) : Array.isArray(t) ? w7(t, e) : iy.is(t, e) ? iy.parse(t) : t;
}
function y7(t, e) {
  return Object.keys(t).forEach(function(n) {
    t[n] = kg(t[n], e);
  }), t;
}
function w7(t, e) {
  return t.forEach(function(n, r) {
    t[r] = kg(n, e);
  }), t;
}
var Tc = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Kr, "__esModule", { value: !0 });
Kr.Facade = void 0;
var b7 = Tc(Eg), Da = Xu, _7 = Tc(Cg), E7 = Tc(Tg), qh = Tc(Pa), C7 = Tc(v7);
function nr(t, e) {
  e = e || {}, this.raw = Da.clone(t), "clone" in e || (e.clone = !0), e.clone && (t = Da.clone(t)), "traverse" in e || (e.traverse = !0), "timestamp" in t ? t.timestamp = E7.default(t.timestamp) : t.timestamp = /* @__PURE__ */ new Date(), e.traverse && C7.default(t), this.opts = e, this.obj = t;
}
Kr.Facade = nr;
var Yt = nr.prototype;
Yt.proxy = function(t) {
  var e = t.split(".");
  t = e.shift();
  var n = this[t] || this.obj[t];
  return n && (typeof n == "function" && (n = n.call(this) || {}), e.length === 0 ? this.opts.clone ? zh(n) : n : (n = qh.default(n, e.join(".")), this.opts.clone ? zh(n) : n));
};
Yt.field = function(t) {
  var e = this.obj[t];
  return this.opts.clone ? zh(e) : e;
};
nr.proxy = function(t) {
  return function() {
    return this.proxy(t);
  };
};
nr.field = function(t) {
  return function() {
    return this.field(t);
  };
};
nr.multi = function(t) {
  return function() {
    var e = this.proxy(t + "s");
    if (Array.isArray(e))
      return e;
    var n = this.proxy(t);
    return n && (n = [this.opts.clone ? Da.clone(n) : n]), n || [];
  };
};
nr.one = function(t) {
  return function() {
    var e = this.proxy(t);
    if (e)
      return e;
    var n = this.proxy(t + "s");
    if (Array.isArray(n))
      return n[0];
  };
};
Yt.json = function() {
  var t = this.opts.clone ? Da.clone(this.obj) : this.obj;
  return this.type && (t.type = this.type()), t;
};
Yt.rawEvent = function() {
  return this.raw;
};
Yt.options = function(t) {
  var e = this.obj.options || this.obj.context || {}, n = this.opts.clone ? Da.clone(e) : e;
  if (!t)
    return n;
  if (this.enabled(t)) {
    var r = this.integrations(), i = r[t] || qh.default(r, t);
    return typeof i != "object" && (i = qh.default(this.options(), t)), typeof i == "object" ? i : {};
  }
};
Yt.context = Yt.options;
Yt.enabled = function(t) {
  var e = this.proxy("options.providers.all");
  typeof e != "boolean" && (e = this.proxy("options.all")), typeof e != "boolean" && (e = this.proxy("integrations.all")), typeof e != "boolean" && (e = !0);
  var n = e && _7.default(t), r = this.integrations();
  if (r.providers && r.providers.hasOwnProperty(t) && (n = r.providers[t]), r.hasOwnProperty(t)) {
    var i = r[t];
    typeof i == "boolean" ? n = i : n = !0;
  }
  return !!n;
};
Yt.integrations = function() {
  return this.obj.integrations || this.proxy("options.providers") || this.options();
};
Yt.active = function() {
  var t = this.proxy("options.active");
  return t == null && (t = !0), t;
};
Yt.anonymousId = function() {
  return this.field("anonymousId") || this.field("sessionId");
};
Yt.sessionId = Yt.anonymousId;
Yt.groupId = nr.proxy("options.groupId");
Yt.traits = function(t) {
  var e = this.proxy("options.traits") || {}, n = this.userId();
  t = t || {}, n && (e.id = n);
  for (var r in t)
    if (Object.prototype.hasOwnProperty.call(t, r)) {
      var i = this[r] == null ? this.proxy("options.traits." + r) : this[r]();
      if (i == null)
        continue;
      e[t[r]] = i, delete e[r];
    }
  return e;
};
Yt.library = function() {
  var t = this.proxy("options.library");
  return t ? typeof t == "string" ? { name: t, version: null } : t : { name: "unknown", version: null };
};
Yt.device = function() {
  var t = this.proxy("context.device");
  (typeof t != "object" || t === null) && (t = {});
  var e = this.library().name;
  return t.type || (e.indexOf("ios") > -1 && (t.type = "ios"), e.indexOf("android") > -1 && (t.type = "android")), t;
};
Yt.userAgent = nr.proxy("context.userAgent");
Yt.timezone = nr.proxy("context.timezone");
Yt.timestamp = nr.field("timestamp");
Yt.channel = nr.field("channel");
Yt.ip = nr.proxy("context.ip");
Yt.userId = nr.field("userId");
b7.default(Yt);
function zh(t) {
  return Da.clone(t);
}
var td = {}, pi = {}, oy = {
  get exports() {
    return pi;
  },
  set exports(t) {
    pi = t;
  }
};
typeof Object.create == "function" ? oy.exports = function(e, n) {
  n && (e.super_ = n, e.prototype = Object.create(n.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : oy.exports = function(e, n) {
  if (n) {
    e.super_ = n;
    var r = function() {
    };
    r.prototype = n.prototype, e.prototype = new r(), e.prototype.constructor = e;
  }
};
var I7 = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(td, "__esModule", { value: !0 });
td.Alias = void 0;
var S7 = I7(pi), k_ = Kr;
function Ar(t, e) {
  k_.Facade.call(this, t, e);
}
td.Alias = Ar;
S7.default(Ar, k_.Facade);
Ar.prototype.action = function() {
  return "alias";
};
Ar.prototype.type = Ar.prototype.action;
Ar.prototype.previousId = function() {
  return this.field("previousId") || this.field("from");
};
Ar.prototype.from = Ar.prototype.previousId;
Ar.prototype.userId = function() {
  return this.field("userId") || this.field("to");
};
Ar.prototype.to = Ar.prototype.userId;
var nd = {}, qa = {};
Object.defineProperty(qa, "__esModule", { value: !0 });
var T7 = /.+\@.+\..+/;
function k7(t) {
  return T7.test(t);
}
qa.default = k7;
var Ag = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(nd, "__esModule", { value: !0 });
nd.Group = void 0;
var A7 = Ag(pi), O7 = Ag(qa), x7 = Ag(Tg), za = Kr;
function Og(t, e) {
  za.Facade.call(this, t, e);
}
nd.Group = Og;
A7.default(Og, za.Facade);
var Or = Og.prototype;
Or.action = function() {
  return "group";
};
Or.type = Or.action;
Or.groupId = za.Facade.field("groupId");
Or.created = function() {
  var t = this.proxy("traits.createdAt") || this.proxy("traits.created") || this.proxy("properties.createdAt") || this.proxy("properties.created");
  if (t)
    return x7.default(t);
};
Or.email = function() {
  var t = this.proxy("traits.email");
  if (t)
    return t;
  var e = this.groupId();
  if (O7.default(e))
    return e;
};
Or.traits = function(t) {
  var e = this.properties(), n = this.groupId();
  t = t || {}, n && (e.id = n);
  for (var r in t)
    if (Object.prototype.hasOwnProperty.call(t, r)) {
      var i = this[r] == null ? this.proxy("traits." + r) : this[r]();
      if (i == null)
        continue;
      e[t[r]] = i, delete e[r];
    }
  return e;
};
Or.name = za.Facade.proxy("traits.name");
Or.industry = za.Facade.proxy("traits.industry");
Or.employees = za.Facade.proxy("traits.employees");
Or.properties = function() {
  return this.field("traits") || this.field("properties") || {};
};
var kc = {}, rd = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(kc, "__esModule", { value: !0 });
kc.Identify = void 0;
var Wr = Kr, pa = rd(Pa), R7 = rd(pi), N7 = rd(qa), A_ = rd(Tg), yo = function(t) {
  return t.trim();
};
function xg(t, e) {
  Wr.Facade.call(this, t, e);
}
kc.Identify = xg;
R7.default(xg, Wr.Facade);
var Qt = xg.prototype;
Qt.action = function() {
  return "identify";
};
Qt.type = Qt.action;
Qt.traits = function(t) {
  var e = this.field("traits") || {}, n = this.userId();
  t = t || {}, n && (e.id = n);
  for (var r in t) {
    var i = this[r] == null ? this.proxy("traits." + r) : this[r]();
    i != null && (e[t[r]] = i, r !== t[r] && delete e[r]);
  }
  return e;
};
Qt.email = function() {
  var t = this.proxy("traits.email");
  if (t)
    return t;
  var e = this.userId();
  if (N7.default(e))
    return e;
};
Qt.created = function() {
  var t = this.proxy("traits.created") || this.proxy("traits.createdAt");
  if (t)
    return A_.default(t);
};
Qt.companyCreated = function() {
  var t = this.proxy("traits.company.created") || this.proxy("traits.company.createdAt");
  if (t)
    return A_.default(t);
};
Qt.companyName = function() {
  return this.proxy("traits.company.name");
};
Qt.name = function() {
  var t = this.proxy("traits.name");
  if (typeof t == "string")
    return yo(t);
  var e = this.firstName(), n = this.lastName();
  if (e && n)
    return yo(e + " " + n);
};
Qt.firstName = function() {
  var t = this.proxy("traits.firstName");
  if (typeof t == "string")
    return yo(t);
  var e = this.proxy("traits.name");
  if (typeof e == "string")
    return yo(e).split(" ")[0];
};
Qt.lastName = function() {
  var t = this.proxy("traits.lastName");
  if (typeof t == "string")
    return yo(t);
  var e = this.proxy("traits.name");
  if (typeof e == "string") {
    var n = yo(e).indexOf(" ");
    if (n !== -1)
      return yo(e.substr(n + 1));
  }
};
Qt.uid = function() {
  return this.userId() || this.username() || this.email();
};
Qt.description = function() {
  return this.proxy("traits.description") || this.proxy("traits.background");
};
Qt.age = function() {
  var t = this.birthday(), e = pa.default(this.traits(), "age");
  if (e != null)
    return e;
  if (t instanceof Date) {
    var n = /* @__PURE__ */ new Date();
    return n.getFullYear() - t.getFullYear();
  }
};
Qt.avatar = function() {
  var t = this.traits();
  return pa.default(t, "avatar") || pa.default(t, "photoUrl") || pa.default(t, "avatarUrl");
};
Qt.position = function() {
  var t = this.traits();
  return pa.default(t, "position") || pa.default(t, "jobTitle");
};
Qt.username = Wr.Facade.proxy("traits.username");
Qt.website = Wr.Facade.one("traits.website");
Qt.websites = Wr.Facade.multi("traits.website");
Qt.phone = Wr.Facade.one("traits.phone");
Qt.phones = Wr.Facade.multi("traits.phone");
Qt.address = Wr.Facade.proxy("traits.address");
Qt.gender = Wr.Facade.proxy("traits.gender");
Qt.birthday = Wr.Facade.proxy("traits.birthday");
var Ka = {}, Rg = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ka, "__esModule", { value: !0 });
Ka.Track = void 0;
var M7 = Rg(pi), _n = Kr, P7 = kc, D7 = Rg(qa), O_ = Rg(Pa);
function Ng(t, e) {
  _n.Facade.call(this, t, e);
}
Ka.Track = Ng;
M7.default(Ng, _n.Facade);
var Je = Ng.prototype;
Je.action = function() {
  return "track";
};
Je.type = Je.action;
Je.event = _n.Facade.field("event");
Je.value = _n.Facade.proxy("properties.value");
Je.category = _n.Facade.proxy("properties.category");
Je.id = _n.Facade.proxy("properties.id");
Je.productId = function() {
  return this.proxy("properties.product_id") || this.proxy("properties.productId");
};
Je.promotionId = function() {
  return this.proxy("properties.promotion_id") || this.proxy("properties.promotionId");
};
Je.cartId = function() {
  return this.proxy("properties.cart_id") || this.proxy("properties.cartId");
};
Je.checkoutId = function() {
  return this.proxy("properties.checkout_id") || this.proxy("properties.checkoutId");
};
Je.paymentId = function() {
  return this.proxy("properties.payment_id") || this.proxy("properties.paymentId");
};
Je.couponId = function() {
  return this.proxy("properties.coupon_id") || this.proxy("properties.couponId");
};
Je.wishlistId = function() {
  return this.proxy("properties.wishlist_id") || this.proxy("properties.wishlistId");
};
Je.reviewId = function() {
  return this.proxy("properties.review_id") || this.proxy("properties.reviewId");
};
Je.orderId = function() {
  return this.proxy("properties.id") || this.proxy("properties.order_id") || this.proxy("properties.orderId");
};
Je.sku = _n.Facade.proxy("properties.sku");
Je.tax = _n.Facade.proxy("properties.tax");
Je.name = _n.Facade.proxy("properties.name");
Je.price = _n.Facade.proxy("properties.price");
Je.total = _n.Facade.proxy("properties.total");
Je.repeat = _n.Facade.proxy("properties.repeat");
Je.coupon = _n.Facade.proxy("properties.coupon");
Je.shipping = _n.Facade.proxy("properties.shipping");
Je.discount = _n.Facade.proxy("properties.discount");
Je.shippingMethod = function() {
  return this.proxy("properties.shipping_method") || this.proxy("properties.shippingMethod");
};
Je.paymentMethod = function() {
  return this.proxy("properties.payment_method") || this.proxy("properties.paymentMethod");
};
Je.description = _n.Facade.proxy("properties.description");
Je.plan = _n.Facade.proxy("properties.plan");
Je.subtotal = function() {
  var t = O_.default(this.properties(), "subtotal"), e = this.total() || this.revenue();
  if (t)
    return t;
  if (!e)
    return 0;
  if (this.total()) {
    var n = this.tax();
    n && (e -= n), n = this.shipping(), n && (e -= n), n = this.discount(), n && (e += n);
  }
  return e;
};
Je.products = function() {
  var t = this.properties(), e = O_.default(t, "products");
  return Array.isArray(e) ? e.filter(function(n) {
    return n !== null;
  }) : [];
};
Je.quantity = function() {
  var t = this.obj.properties || {};
  return t.quantity || 1;
};
Je.currency = function() {
  var t = this.obj.properties || {};
  return t.currency || "USD";
};
Je.referrer = function() {
  return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
};
Je.query = _n.Facade.proxy("options.query");
Je.properties = function(t) {
  var e = this.field("properties") || {};
  t = t || {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      var r = this[n] == null ? this.proxy("properties." + n) : this[n]();
      if (r == null)
        continue;
      e[t[n]] = r, delete e[n];
    }
  return e;
};
Je.username = function() {
  return this.proxy("traits.username") || this.proxy("properties.username") || this.userId() || this.sessionId();
};
Je.email = function() {
  var t = this.proxy("traits.email") || this.proxy("properties.email") || this.proxy("options.traits.email");
  if (t)
    return t;
  var e = this.userId();
  if (D7.default(e))
    return e;
};
Je.revenue = function() {
  var t = this.proxy("properties.revenue"), e = this.event(), n = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
  return !t && e && e.match(n) && (t = this.proxy("properties.total")), L7(t);
};
Je.cents = function() {
  var t = this.revenue();
  return typeof t != "number" ? this.value() || 0 : t * 100;
};
Je.identify = function() {
  var t = this.json();
  return t.traits = this.traits(), new P7.Identify(t, this.opts);
};
function L7(t) {
  if (t) {
    if (typeof t == "number")
      return t;
    if (typeof t == "string" && (t = t.replace(/\$/g, ""), t = parseFloat(t), !isNaN(t)))
      return t;
  }
}
var Ac = {}, x_ = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ac, "__esModule", { value: !0 });
Ac.Page = void 0;
var F7 = x_(pi), Lo = Kr, U7 = Ka, H7 = x_(qa);
function Mg(t, e) {
  Lo.Facade.call(this, t, e);
}
Ac.Page = Mg;
F7.default(Mg, Lo.Facade);
var $n = Mg.prototype;
$n.action = function() {
  return "page";
};
$n.type = $n.action;
$n.category = Lo.Facade.field("category");
$n.name = Lo.Facade.field("name");
$n.title = Lo.Facade.proxy("properties.title");
$n.path = Lo.Facade.proxy("properties.path");
$n.url = Lo.Facade.proxy("properties.url");
$n.referrer = function() {
  return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
};
$n.properties = function(t) {
  var e = this.field("properties") || {}, n = this.category(), r = this.name();
  t = t || {}, n && (e.category = n), r && (e.name = r);
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      var o = this[i] == null ? this.proxy("properties." + i) : this[i]();
      if (o == null)
        continue;
      e[t[i]] = o, i !== t[i] && delete e[i];
    }
  return e;
};
$n.email = function() {
  var t = this.proxy("context.traits.email") || this.proxy("properties.email");
  if (t)
    return t;
  var e = this.userId();
  if (H7.default(e))
    return e;
};
$n.fullName = function() {
  var t = this.category(), e = this.name();
  return e && t ? t + " " + e : e;
};
$n.event = function(t) {
  return t ? "Viewed " + t + " Page" : "Loaded a Page";
};
$n.track = function(t) {
  var e = this.json();
  return e.event = this.event(t), e.timestamp = this.timestamp(), e.properties = this.properties(), new U7.Track(e, this.opts);
};
var id = {}, B7 = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(id, "__esModule", { value: !0 });
id.Screen = void 0;
var j7 = B7(pi), R_ = Ac, V7 = Ka;
function xo(t, e) {
  R_.Page.call(this, t, e);
}
id.Screen = xo;
j7.default(xo, R_.Page);
xo.prototype.action = function() {
  return "screen";
};
xo.prototype.type = xo.prototype.action;
xo.prototype.event = function(t) {
  return t ? "Viewed " + t + " Screen" : "Loaded a Screen";
};
xo.prototype.track = function(t) {
  var e = this.json();
  return e.event = this.event(t), e.timestamp = this.timestamp(), e.properties = this.properties(), new V7.Track(e, this.opts);
};
var od = {}, $7 = Gt && Gt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(od, "__esModule", { value: !0 });
od.Delete = void 0;
var q7 = $7(pi), N_ = Kr;
function Pg(t, e) {
  N_.Facade.call(this, t, e);
}
od.Delete = Pg;
q7.default(Pg, N_.Facade);
Pg.prototype.type = function() {
  return "delete";
};
(function(t) {
  var e = Gt && Gt.__assign || function() {
    return e = Object.assign || function(u) {
      for (var d, f = 1, h = arguments.length; f < h; f++) {
        d = arguments[f];
        for (var g in d)
          Object.prototype.hasOwnProperty.call(d, g) && (u[g] = d[g]);
      }
      return u;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.Delete = t.Screen = t.Page = t.Track = t.Identify = t.Group = t.Alias = t.Facade = void 0;
  var n = Kr;
  Object.defineProperty(t, "Facade", { enumerable: !0, get: function() {
    return n.Facade;
  } });
  var r = td;
  Object.defineProperty(t, "Alias", { enumerable: !0, get: function() {
    return r.Alias;
  } });
  var i = nd;
  Object.defineProperty(t, "Group", { enumerable: !0, get: function() {
    return i.Group;
  } });
  var o = kc;
  Object.defineProperty(t, "Identify", { enumerable: !0, get: function() {
    return o.Identify;
  } });
  var a = Ka;
  Object.defineProperty(t, "Track", { enumerable: !0, get: function() {
    return a.Track;
  } });
  var s = Ac;
  Object.defineProperty(t, "Page", { enumerable: !0, get: function() {
    return s.Page;
  } });
  var c = id;
  Object.defineProperty(t, "Screen", { enumerable: !0, get: function() {
    return c.Screen;
  } });
  var l = od;
  Object.defineProperty(t, "Delete", { enumerable: !0, get: function() {
    return l.Delete;
  } }), t.default = e(e({}, n.Facade), {
    Alias: r.Alias,
    Group: i.Group,
    Identify: o.Identify,
    Track: a.Track,
    Page: s.Page,
    Screen: c.Screen,
    Delete: l.Delete
  });
})(ki);
function z7(t, e) {
  var n = new ki.Facade(t, e);
  return t.type === "track" && (n = new ki.Track(t, e)), t.type === "identify" && (n = new ki.Identify(t, e)), t.type === "page" && (n = new ki.Page(t, e)), t.type === "alias" && (n = new ki.Alias(t, e)), t.type === "group" && (n = new ki.Group(t, e)), t.type === "screen" && (n = new ki.Screen(t, e)), Object.defineProperty(n, "obj", {
    value: t,
    writable: !0
  }), n;
}
var M_ = $a;
typeof window < "u" && (M_ = window.fetch || $a);
var K7 = 500;
function P_(t) {
  var e = encodeURI(JSON.stringify(t)).split(/%..|./).length - 1;
  return e / 1024;
}
function W7(t) {
  return P_(t) >= K7 - 50;
}
function G7(t) {
  var e = [], n = 0;
  return t.forEach(function(r) {
    var i = P_(e[n]);
    i >= 64 && n++, e[n] ? e[n].push(r) : e[n] = [r];
  }), e;
}
function Y7(t, e) {
  var n, r, i = [], o = !1, a = (n = e == null ? void 0 : e.size) !== null && n !== void 0 ? n : 10, s = (r = e == null ? void 0 : e.timeout) !== null && r !== void 0 ? r : 5e3;
  function c(h) {
    var g;
    if (h.length !== 0) {
      var v = (g = h[0]) === null || g === void 0 ? void 0 : g.writeKey;
      return M_("https://".concat(t, "/b"), {
        keepalive: o,
        headers: {
          "Content-Type": "text/plain"
        },
        method: "post",
        body: JSON.stringify({ batch: h, writeKey: v })
      });
    }
  }
  function l() {
    return ke(this, void 0, void 0, function() {
      var h;
      return Ae(this, function(g) {
        return i.length ? (h = i, i = [], [2, c(h)]) : [
          2
          /*return*/
        ];
      });
    });
  }
  var u;
  function d() {
    u || (u = setTimeout(function() {
      u = void 0, l().catch(console.error);
    }, s));
  }
  window.addEventListener("beforeunload", function() {
    if (o = !0, i.length) {
      var h = G7(i).map(c);
      Promise.all(h).catch(console.error);
    }
  });
  function f(h, g) {
    return ke(this, void 0, void 0, function() {
      var v;
      return Ae(this, function(b) {
        return i.push(g), v = i.length >= a || W7(i), [2, v || o ? l() : d()];
      });
    });
  }
  return {
    dispatch: f
  };
}
var D_ = $a;
typeof window < "u" && (D_ = window.fetch || $a);
function Q7() {
  function t(e, n) {
    return D_(e, {
      headers: { "Content-Type": "text/plain" },
      method: "post",
      body: JSON.stringify(n)
    });
  }
  return {
    dispatch: t
  };
}
var J7 = function(t, e) {
  return ke(void 0, void 0, void 0, function() {
    var n;
    return Ae(this, function(r) {
      return n = function(i) {
        return ke(void 0, void 0, void 0, function() {
          var o;
          return Ae(this, function(a) {
            switch (a.label) {
              case 0:
                return t(i) ? (o = n, [4, e()]) : [3, 2];
              case 1:
                return [2, o.apply(void 0, [a.sent()])];
              case 2:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, [2, n(void 0)];
    });
  });
};
function Z7(t, e) {
  return ke(this, void 0, void 0, function() {
    var n, r = this;
    return Ae(this, function(i) {
      switch (i.label) {
        case 0:
          return n = [], su() ? [2, e] : [
            4,
            J7(function() {
              return e.length > 0 && !su();
            }, function() {
              return ke(r, void 0, void 0, function() {
                var o, a, s;
                return Ae(this, function(c) {
                  switch (c.label) {
                    case 0:
                      return o = e.pop(), o ? [4, Ps(o, t)] : [
                        2
                        /*return*/
                      ];
                    case 1:
                      return a = c.sent(), s = a instanceof ui, s || n.push(o), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            })
            // re-add failed tasks
          ];
        case 1:
          return i.sent(), n.map(function(o) {
            return e.pushWithBackoff(o);
          }), [2, e];
      }
    });
  });
}
function Jc(t, e, n, r) {
  var i = this;
  t || setTimeout(function() {
    return ke(i, void 0, void 0, function() {
      var o, a;
      return Ae(this, function(s) {
        switch (s.label) {
          case 0:
            return o = !0, [4, Z7(n, e)];
          case 1:
            return a = s.sent(), o = !1, e.todo > 0 && r(o, a, n, r), [
              2
              /*return*/
            ];
        }
      });
    });
  }, Math.random() * 5e3);
}
function X7(t, e) {
  var n, r, i, o, a = t.user();
  return e.previousId = (i = (r = (n = e.previousId) !== null && n !== void 0 ? n : e.from) !== null && r !== void 0 ? r : a.id()) !== null && i !== void 0 ? i : a.anonymousId(), e.userId = (o = e.userId) !== null && o !== void 0 ? o : e.to, delete e.from, delete e.to, e;
}
function eR(t, e, n) {
  var r, i, o, a, s = t.options.disableClientPersistence ? new yg(t.queue.queue.maxAttempts, []) : new wg(t.queue.queue.maxAttempts, "dest-Segment.io"), c = !1, l = (r = e == null ? void 0 : e.apiHost) !== null && r !== void 0 ? r : "api.segment.io/v1", u = (i = e == null ? void 0 : e.protocol) !== null && i !== void 0 ? i : "https", d = "".concat(u, "://").concat(l), f = ((o = e == null ? void 0 : e.deliveryStrategy) === null || o === void 0 ? void 0 : o.strategy) === "batching" ? Y7(l, (a = e == null ? void 0 : e.deliveryStrategy) === null || a === void 0 ? void 0 : a.config) : Q7();
  function h(v) {
    return ke(this, void 0, void 0, function() {
      var b, m;
      return Ae(this, function(y) {
        return su() ? (s.push(v), Jc(c, s, g, Jc), [2, v]) : (b = v.event.type.charAt(0), m = z7(v.event).json(), v.event.type === "track" && delete m.traits, v.event.type === "alias" && (m = X7(t, m)), [2, f.dispatch("".concat(d, "/").concat(b), Ox(t, m, e, n)).then(function() {
          return v;
        }).catch(function(p) {
          return (p.type === "error" || p.message === "Failed to fetch") && (s.push(v), Jc(c, s, g, Jc)), v;
        })]);
      });
    });
  }
  var g = {
    name: "Segment.io",
    type: "after",
    version: "0.1.0",
    isLoaded: function() {
      return !0;
    },
    load: function() {
      return Promise.resolve();
    },
    track: h,
    identify: h,
    page: h,
    alias: h,
    group: h
  };
  return g;
}
var L_ = function(t, e, n) {
  n.getCalls(t).forEach(function(r) {
    Dg(e, r).catch(console.error);
  });
}, tR = function(t, e) {
  return ke(void 0, void 0, void 0, function() {
    var n, r, i;
    return Ae(this, function(o) {
      switch (o.label) {
        case 0:
          n = 0, r = e.getCalls("addSourceMiddleware"), o.label = 1;
        case 1:
          return n < r.length ? (i = r[n], [4, Dg(t, i).catch(console.error)]) : [3, 4];
        case 2:
          o.sent(), o.label = 3;
        case 3:
          return n++, [3, 1];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, nR = L_.bind(globalThis, "on"), rR = L_.bind(globalThis, "setAnonymousId"), iR = function(t, e) {
  e.toArray().forEach(function(n) {
    setTimeout(function() {
      Dg(t, n).catch(console.error);
    }, 0);
  });
}, oR = (
  /** @class */
  function() {
    function t() {
      this._value = {};
    }
    return t.prototype.toArray = function() {
      var e;
      return (e = []).concat.apply(e, Object.values(this._value));
    }, t.prototype.getCalls = function(e) {
      var n;
      return (n = this._value[e]) !== null && n !== void 0 ? n : [];
    }, t.prototype.push = function() {
      for (var e = this, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return n.forEach(function(i) {
        e._value[i.method] ? e._value[i.method].push(i) : e._value[i.method] = [i];
      }), this;
    }, t.prototype.clear = function() {
      return this._value = {}, this;
    }, t;
  }()
);
function Dg(t, e) {
  return ke(this, void 0, void 0, function() {
    var n, r;
    return Ae(this, function(i) {
      switch (i.label) {
        case 0:
          return i.trys.push([0, 3, , 4]), e.called ? [2, void 0] : (e.called = !0, n = t[e.method].apply(t, e.args), w_(n) ? [4, n] : [3, 2]);
        case 1:
          i.sent(), i.label = 2;
        case 2:
          return e.resolve(n), [3, 4];
        case 3:
          return r = i.sent(), e.reject(r), [3, 4];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
var aR = (
  /** @class */
  function() {
    function t(e) {
      var n = this;
      this._preInitBuffer = new oR(), this.trackSubmit = this._createMethod("trackSubmit"), this.trackClick = this._createMethod("trackClick"), this.trackLink = this._createMethod("trackLink"), this.pageView = this._createMethod("pageview"), this.identify = this._createMethod("identify"), this.reset = this._createMethod("reset"), this.group = this._createMethod("group"), this.track = this._createMethod("track"), this.ready = this._createMethod("ready"), this.alias = this._createMethod("alias"), this.debug = this._createChainableMethod("debug"), this.page = this._createMethod("page"), this.once = this._createChainableMethod("once"), this.off = this._createChainableMethod("off"), this.on = this._createChainableMethod("on"), this.addSourceMiddleware = this._createMethod("addSourceMiddleware"), this.setAnonymousId = this._createMethod("setAnonymousId"), this.addDestinationMiddleware = this._createMethod("addDestinationMiddleware"), this.screen = this._createMethod("screen"), this.register = this._createMethod("register"), this.deregister = this._createMethod("deregister"), this.user = this._createMethod("user"), this.VERSION = Ma, this._promise = e(this._preInitBuffer), this._promise.then(function(r) {
        var i = r[0], o = r[1];
        n.instance = i, n.ctx = o;
      }).catch(function() {
      });
    }
    return t.prototype.then = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return (e = this._promise).then.apply(e, n);
    }, t.prototype.catch = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return (e = this._promise).catch.apply(e, n);
    }, t.prototype.finally = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return (e = this._promise).finally.apply(e, n);
    }, t.prototype._createMethod = function(e) {
      var n = this;
      return function() {
        for (var r, i = [], o = 0; o < arguments.length; o++)
          i[o] = arguments[o];
        if (n.instance) {
          var a = (r = n.instance)[e].apply(r, i);
          return Promise.resolve(a);
        }
        return new Promise(function(s, c) {
          n._preInitBuffer.push({
            method: e,
            args: i,
            resolve: s,
            reject: c,
            called: !1
          });
        });
      };
    }, t.prototype._createChainableMethod = function(e) {
      var n = this;
      return function() {
        for (var r, i = [], o = 0; o < arguments.length; o++)
          i[o] = arguments[o];
        return n.instance ? ((r = n.instance)[e].apply(r, i), n) : (n._preInitBuffer.push({
          method: e,
          args: i,
          resolve: function() {
          },
          reject: console.error,
          called: !1
        }), n);
      };
    }, t;
  }()
);
function sR(t) {
  var e = t[0], n = t.slice(1);
  return {
    method: e,
    resolve: function() {
    },
    reject: console.error,
    args: n,
    called: !1
  };
}
var cR = function(t) {
  return t.map(sR);
}, Kh = function() {
  var t = window.analytics;
  if (!Array.isArray(t))
    return [];
  var e = t.splice(0, t.length);
  return cR(e);
};
function lR(t, e) {
  var n = e ?? _g();
  return $a("".concat(n, "/v1/projects/").concat(t, "/settings")).then(function(r) {
    return r.json();
  }).catch(function(r) {
    throw console.warn("Failed to load settings", r), r;
  });
}
function uR(t) {
  return Yx().NODE_ENV !== "test" && // just one integration means segmentio
  Object.keys(t.integrations).length > 1;
}
function dR(t, e) {
  e.push.apply(e, Kh()), rR(t, e), nR(t, e);
}
function fR(t, e) {
  return ke(this, void 0, void 0, function() {
    return Ae(this, function(n) {
      switch (n.label) {
        case 0:
          return e.push.apply(e, Kh()), [4, tR(t, e)];
        case 1:
          return n.sent(), e.push.apply(e, Kh()), iR(t, e), e.clear(), [
            2
            /*return*/
          ];
      }
    });
  });
}
function hR(t, e, n, r, i) {
  var o, a, s;
  return ke(this, void 0, void 0, function() {
    var c, l, u, d, f, h, g, v, b, m = this;
    return Ae(this, function(y) {
      switch (y.label) {
        case 0:
          return uR(t) ? [4, import(
            /* webpackChunkName: "ajs-destination" */
            "./index-c958fa8b.js"
          ).then(function(p) {
            return p.ajsDestinations(t, e.integrations, n);
          })] : [3, 2];
        case 1:
          return l = y.sent(), [3, 3];
        case 2:
          l = [], y.label = 3;
        case 3:
          return c = l, t.legacyVideoPluginsEnabled ? [4, import(
            /* webpackChunkName: "legacyVideos" */
            "./index-977689a9.js"
          ).then(function(p) {
            return p.loadLegacyVideoPlugins(e);
          })] : [3, 5];
        case 4:
          y.sent(), y.label = 5;
        case 5:
          return !((o = n.plan) === null || o === void 0) && o.track ? [4, import(
            /* webpackChunkName: "schemaFilter" */
            "./index-ef5ccf96.js"
          ).then(function(p) {
            var w;
            return p.schemaFilter((w = n.plan) === null || w === void 0 ? void 0 : w.track, t);
          })] : [3, 7];
        case 6:
          return d = y.sent(), [3, 8];
        case 7:
          d = void 0, y.label = 8;
        case 8:
          return u = d, f = e7(t, r), [4, o7(t, e.integrations, f, r.obfuscate).catch(function() {
            return [];
          })];
        case 9:
          return h = y.sent(), g = ln(ln(ln([
            cx,
            r7
          ], i, !0), c, !0), h, !0), u && g.push(u), v = ((a = n.integrations) === null || a === void 0 ? void 0 : a.All) === !1 && !n.integrations["Segment.io"] || n.integrations && n.integrations["Segment.io"] === !1, v || g.push(eR(e, f["Segment.io"], t.integrations)), [4, e.register.apply(e, g)];
        case 10:
          return b = y.sent(), Object.entries((s = t.enabledMiddleware) !== null && s !== void 0 ? s : {}).some(function(p) {
            var w = p[1];
            return w;
          }) ? [4, import(
            /* webpackChunkName: "remoteMiddleware" */
            "./index-41b06ef1.js"
          ).then(function(p) {
            var w = p.remoteMiddlewares;
            return ke(m, void 0, void 0, function() {
              var _, E;
              return Ae(this, function(S) {
                switch (S.label) {
                  case 0:
                    return [4, w(b, t, r.obfuscate)];
                  case 1:
                    return _ = S.sent(), E = _.map(function(T) {
                      return e.addSourceMiddleware(T);
                    }), [2, Promise.all(E)];
                }
              });
            });
          })] : [3, 12];
        case 11:
          y.sent(), y.label = 12;
        case 12:
          return [2, b];
      }
    });
  });
}
function pR(t, e, n) {
  var r, i, o, a, s, c;
  return e === void 0 && (e = {}), ke(this, void 0, void 0, function() {
    var l, u, d, f, h, g, v, b, m, y;
    return Ae(this, function(p) {
      switch (p.label) {
        case 0:
          return t.cdnURL && Xx(t.cdnURL), (r = t.cdnSettings) !== null && r !== void 0 ? (u = r, [3, 3]) : [3, 1];
        case 1:
          return [4, lR(t.writeKey, t.cdnURL)];
        case 2:
          u = p.sent(), p.label = 3;
        case 3:
          return l = u, d = (o = (i = l.integrations["Segment.io"]) === null || i === void 0 ? void 0 : i.retryQueue) !== null && o !== void 0 ? o : !0, f = R({ retryQueue: d }, e), h = new Gx(t, f), g = (a = t.plugins) !== null && a !== void 0 ? a : [], ui.initMetrics(l.metrics), dR(h, n), [4, hR(l, h, f, e, g)];
        case 4:
          return v = p.sent(), b = (s = window.location.search) !== null && s !== void 0 ? s : "", m = (c = window.location.hash) !== null && c !== void 0 ? c : "", y = b.length ? b : m.replace(/(?=#).*(?=\?)/, ""), y.includes("ajs_") ? [4, h.queryString(y).catch(console.error)] : [3, 6];
        case 5:
          p.sent(), p.label = 6;
        case 6:
          return h.initialized = !0, h.emit("initialize", t, e), e.initialPageview && h.page().catch(console.error), [4, fR(h, n)];
        case 7:
          return p.sent(), [2, [h, v]];
      }
    });
  });
}
var gR = (
  /** @class */
  function(t) {
    an(e, t);
    function e(n) {
      return t.call(this, n) || this;
    }
    return e.load = function(n, r) {
      return r === void 0 && (r = {}), new this(function(i) {
        return pR(n, r, i);
      });
    }, e.standalone = function(n, r) {
      return e.load({ writeKey: n }, r).then(function(i) {
        return i[0];
      });
    }, e;
  }(aR)
);
const Lg = Ct.createContext(
  void 0
), RW = ({
  children: t,
  writeKey: e
}) => {
  const n = Ct.useMemo(
    () => e ? gR.load({ writeKey: e }) : null,
    [e]
  ), { userId: r } = Ru();
  return Ee(() => {
    n && r && n.identify(r);
  }, [r, n]), /* @__PURE__ */ C(Lg.Provider, { value: n, children: t });
}, NW = () => {
  const t = Ct.useContext(Lg);
  if (!t)
    throw new Error("Context used outside of its Provider!");
  return t;
}, F_ = () => {
  const t = Ct.useContext(Lg);
  if (t)
    return t;
};
function mR(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var Oc = mR, vR = typeof Gt == "object" && Gt && Gt.Object === Object && Gt, U_ = vR, yR = U_, wR = typeof self == "object" && self && self.Object === Object && self, bR = yR || wR || Function("return this")(), Gr = bR, _R = Gr, ER = function() {
  return _R.Date.now();
}, CR = ER, IR = /\s/;
function SR(t) {
  for (var e = t.length; e-- && IR.test(t.charAt(e)); )
    ;
  return e;
}
var TR = SR, kR = TR, AR = /^\s+/;
function OR(t) {
  return t && t.slice(0, kR(t) + 1).replace(AR, "");
}
var xR = OR, RR = Gr, NR = RR.Symbol, Fg = NR, ay = Fg, H_ = Object.prototype, MR = H_.hasOwnProperty, PR = H_.toString, fs = ay ? ay.toStringTag : void 0;
function DR(t) {
  var e = MR.call(t, fs), n = t[fs];
  try {
    t[fs] = void 0;
    var r = !0;
  } catch {
  }
  var i = PR.call(t);
  return r && (e ? t[fs] = n : delete t[fs]), i;
}
var LR = DR, FR = Object.prototype, UR = FR.toString;
function HR(t) {
  return UR.call(t);
}
var BR = HR, sy = Fg, jR = LR, VR = BR, $R = "[object Null]", qR = "[object Undefined]", cy = sy ? sy.toStringTag : void 0;
function zR(t) {
  return t == null ? t === void 0 ? qR : $R : cy && cy in Object(t) ? jR(t) : VR(t);
}
var xc = zR;
function KR(t) {
  return t != null && typeof t == "object";
}
var Rc = KR, WR = xc, GR = Rc, YR = "[object Symbol]";
function QR(t) {
  return typeof t == "symbol" || GR(t) && WR(t) == YR;
}
var JR = QR, ZR = xR, ly = Oc, XR = JR, uy = 0 / 0, e8 = /^[-+]0x[0-9a-f]+$/i, t8 = /^0b[01]+$/i, n8 = /^0o[0-7]+$/i, r8 = parseInt;
function i8(t) {
  if (typeof t == "number")
    return t;
  if (XR(t))
    return uy;
  if (ly(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = ly(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = ZR(t);
  var n = t8.test(t);
  return n || n8.test(t) ? r8(t.slice(2), n ? 2 : 8) : e8.test(t) ? uy : +t;
}
var B_ = i8, o8 = Oc, af = CR, dy = B_, a8 = "Expected a function", s8 = Math.max, c8 = Math.min;
function l8(t, e, n) {
  var r, i, o, a, s, c, l = 0, u = !1, d = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(a8);
  e = dy(e) || 0, o8(n) && (u = !!n.leading, d = "maxWait" in n, o = d ? s8(dy(n.maxWait) || 0, e) : o, f = "trailing" in n ? !!n.trailing : f);
  function h(E) {
    var S = r, T = i;
    return r = i = void 0, l = E, a = t.apply(T, S), a;
  }
  function g(E) {
    return l = E, s = setTimeout(m, e), u ? h(E) : a;
  }
  function v(E) {
    var S = E - c, T = E - l, x = e - S;
    return d ? c8(x, o - T) : x;
  }
  function b(E) {
    var S = E - c, T = E - l;
    return c === void 0 || S >= e || S < 0 || d && T >= o;
  }
  function m() {
    var E = af();
    if (b(E))
      return y(E);
    s = setTimeout(m, v(E));
  }
  function y(E) {
    return s = void 0, f && r ? h(E) : (r = i = void 0, a);
  }
  function p() {
    s !== void 0 && clearTimeout(s), l = 0, r = c = i = s = void 0;
  }
  function w() {
    return s === void 0 ? a : y(af());
  }
  function _() {
    var E = af(), S = b(E);
    if (r = arguments, i = this, c = E, S) {
      if (s === void 0)
        return g(c);
      if (d)
        return clearTimeout(s), s = setTimeout(m, e), h(c);
    }
    return s === void 0 && (s = setTimeout(m, e)), a;
  }
  return _.cancel = p, _.flush = w, _;
}
var j_ = l8;
function MW(t, e) {
  const [n, r] = et(t), i = Tr(
    () => j_(r, e),
    [e]
  );
  return Ee(() => {
    i(t);
  }, [i, t]), n;
}
const bn = (t) => {
  const e = Me(Di()).current;
  return t ?? e;
}, PW = () => {
  const [t, e] = et(!1);
  return Ee(() => {
    var r;
    const n = () => {
      var i;
      e(
        (((i = window == null ? void 0 : window.visualViewport) == null ? void 0 : i.height) ?? 0) < (window == null ? void 0 : window.innerHeight)
      );
    };
    return (r = window.visualViewport) == null || r.addEventListener("resize", n), () => {
      var i;
      (i = window.visualViewport) == null || i.removeEventListener("resize", n);
    };
  }, []), t;
};
function DW([t, e], n = 5e3) {
  return Ee(() => {
    if (!t.fetching) {
      const r = setTimeout(
        () => e({ requestPolicy: "network-only" }),
        n
      );
      return () => clearTimeout(r);
    }
  }, [t.fetching, e, n]);
}
const fy = [
  "advisor",
  "teamName",
  "referrer",
  "userType",
  "userJourney",
  "sourceBranchName"
], LW = () => ({
  saveReferralDetails: (r) => {
    if (!(typeof window > "u"))
      try {
        Object.entries(r).forEach(([i, o]) => {
          o && window.localStorage.setItem(i, o);
        });
      } catch (i) {
        console.log(i);
      }
  },
  getReferralDetails: () => {
    let r = {
      advisor: null,
      teamName: null,
      referrer: null,
      userType: null,
      userJourney: null,
      sourceBranchName: null
    };
    if (typeof window < "u")
      try {
        fy.forEach((i) => {
          r[i] = window.localStorage.getItem(i);
        });
      } catch (i) {
        console.log(i);
      }
    return r;
  },
  clearReferralDetails: () => {
    typeof window > "u" || fy.forEach((r) => {
      window.localStorage.removeItem(r);
    });
  }
});
function FW() {
  const [t, e] = et({
    outerWidth: (window == null ? void 0 : window.outerWidth) ?? 0,
    outerHeight: window.outerHeight ?? 0,
    innerWidth: (window == null ? void 0 : window.innerWidth) ?? 0,
    innerHeight: window.innerHeight ?? 0
  }), n = Tr(
    () => j_(() => {
      e({
        outerWidth: window.outerWidth,
        outerHeight: window.outerHeight,
        innerWidth: window == null ? void 0 : window.innerWidth,
        innerHeight: window.innerHeight
      });
    }, 100),
    []
  );
  return Ee(() => (window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n)), [n]), t;
}
const u8 = () => null, d8 = () => Promise.resolve(), f8 = () => Promise.resolve(), UW = ({
  endpoint: t,
  schema: e,
  queries: n,
  children: r,
  onDowntime: i
}) => {
  const o = iI(), a = (o == null ? void 0 : o.loggedIn) ?? !1, s = (o == null ? void 0 : o.getToken) ?? u8, c = (o == null ? void 0 : o.refreshToken) ?? d8, l = (o == null ? void 0 : o.logOut) ?? f8, u = F_(), d = Me(
    W0({
      endpoint: t,
      getToken: s,
      refreshToken: c,
      logOut: l,
      schema: e,
      analytics: u,
      onDowntime: i,
      queries: n
    })
  );
  return Ee(() => {
    a || (d.current = W0({
      endpoint: t,
      getToken: s,
      refreshToken: c,
      logOut: l,
      schema: e,
      analytics: u,
      onDowntime: i,
      queries: n
    }));
  }, [
    u,
    t,
    s,
    a,
    c,
    e,
    i,
    l,
    n
  ]), /* @__PURE__ */ C(Z3, { value: d.current, children: r });
}, de = "inline-block";
var Wh = {}, h8 = {
  get exports() {
    return Wh;
  },
  set exports(t) {
    Wh = t;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var o = arguments[i];
        if (o) {
          var a = typeof o;
          if (a === "string" || a === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var s = n.apply(null, o);
              s && r.push(s);
            }
          } else if (a === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var c in o)
              e.call(o, c) && o[c] && r.push(c);
          }
        }
      }
      return r.join(" ");
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(h8);
const j = Wh, V_ = ({
  className: t,
  ...e
}) => /* @__PURE__ */ C(
  "svg",
  {
    "data-testid": "down caret",
    "aria-label": e["aria-label"] ?? "down caret",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: j(de, t),
    ...e,
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M3 6L8 11L13 6",
        stroke: "#4E4670",
        strokeWidth: "2",
        strokeLinecap: "round"
      }
    )
  }
), HW = ({
  className: t,
  title: e,
  bullets: n = [],
  bulletSections: r = []
}) => {
  const [i, o] = et(!1);
  return /* @__PURE__ */ K("div", { className: j("overflow-hidden", t), children: [
    /* @__PURE__ */ K(
      "section",
      {
        className: "flex justify-between items-center px-18 py-24 font-light cursor-pointer",
        onClick: () => o(!i),
        children: [
          /* @__PURE__ */ C("h1", { className: "text-t16 text-brand-primary font-semibold", children: e }),
          /* @__PURE__ */ C(
            V_,
            {
              className: `transition-all ease-in-out delay-150 w-16 ${i ? "rotate-180" : ""}`
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ K(
      "section",
      {
        className: j({
          "text-font-secondary px-18 pb-24 max-h-full transition-all delay-300 duration-1000 ease-in-out": i,
          "text-transparent p-0 max-h-[0em] border-b-0 transition-all delay-75 duration-1000 ease-in-out": !i
        }),
        "aria-hidden": !i,
        "data-testid": "bullet-section",
        children: [
          n.length > 0 && /* @__PURE__ */ C("ul", { className: "list-disc", "data-testid": "unordered-list", children: n.map((a, s) => /* @__PURE__ */ C("li", { className: "ml-18", children: a }, s)) }),
          r.length > 0 && /* @__PURE__ */ C(cc, { children: r.map((a, s) => {
            const { title: c, bullets: l } = a;
            return /* @__PURE__ */ K("div", { children: [
              /* @__PURE__ */ C("h1", { className: "text-t16 text-brand-primary font-semibold", children: c }),
              /* @__PURE__ */ C(
                "ul",
                {
                  className: "list-disc mb-12 sm:18",
                  "data-testid": "unordered-list",
                  children: l.map((u, d) => /* @__PURE__ */ C("li", { className: "ml-18", children: u }, d))
                }
              )
            ] }, s);
          }) })
        ]
      }
    ),
    /* @__PURE__ */ C(
      "div",
      {
        className: j("border-b border-accordion-divider", {
          "mt-32 sm:mt-0": i,
          "overflow-y-hidden": !i
        })
      }
    )
  ] });
}, BW = ({
  className: t,
  ...e
}) => /* @__PURE__ */ C(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "close icon",
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    className: j(de, t),
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M9.92 17.92 2 10l7.92-7.92 1.41 1.42L5.83 9H20v2H5.83l5.51 5.5-1.42 1.42ZM2 10V0H0v20h2V10Z",
        fill: "currentColor"
      }
    )
  }
), p8 = ({
  className: t,
  ...e
}) => /* @__PURE__ */ C(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "open icon",
    width: 15,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 18",
    ...e,
    className: j(de, t),
    children: /* @__PURE__ */ C(
      "path",
      {
        fill: "#5261AC",
        d: "M14.752 16.747 25.588 3.745A2.168 2.168 0 0 0 22.257.97l-9.17 11.004L3.917.97a2.168 2.168 0 0 0-3.33 2.776l10.835 13.002a2.17 2.17 0 0 0 3.33 0Z"
      }
    )
  }
), jW = ({
  className: t,
  ...e
}) => /* @__PURE__ */ C(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "arrow up icon",
    width: 17,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    className: j(de, t),
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M7.743.876a1 1 0 0 1 1.514 0l7.315 8.47A1 1 0 0 1 15.815 11h-.607a1 1 0 0 1-.736-.323L9.268 5.025a1 1 0 0 0-1.5.033l-4.714 5.587A1 1 0 0 1 2.29 11H1.185a1 1 0 0 1-.757-1.654L7.743.876Z",
        fill: "#5261AC"
      }
    )
  }
), VW = ({
  className: t,
  ...e
}) => /* @__PURE__ */ C(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "open icon",
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    className: j(de, t),
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "M10.08 2.08 18 10l-7.92 7.92-1.41-1.42 5.5-5.5H0V9h14.17L8.66 3.5l1.42-1.42ZM18 10v10h2V0h-2v10Z",
        fill: "currentColor"
      }
    )
  }
), $W = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "",
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      className: j(de, n),
      children: [
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ K("mask", { id: s, children: [
          /* @__PURE__ */ C("rect", { fill: "#FFF", width: "100%", height: "100%" }),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M12.122 8.355a.5.5 0 0 0 0-.708L8.94 4.465a.5.5 0 1 0-.707.708L11.06 8 8.233 10.83a.5.5 0 1 0 .707.707l3.182-3.182ZM4.239 8.5h7.53v-1h-7.53v1Z",
              fill: "#000"
            }
          )
        ] }) }),
        /* @__PURE__ */ C("rect", { width: 16, height: 16, rx: 8, fill: a, mask: `url(#${s})` })
      ]
    }
  );
}, Te = (t) => {
  const e = {
    xsm: { width: 12, height: 12 },
    sm: { width: 16, height: 16 },
    md: { width: 24, height: 24 },
    lg: { width: 32, height: 32 },
    xl: { width: 48, height: 48 },
    xxl: { width: 88, height: 88 },
    xxxl: { width: 93, height: 93 }
  };
  return t ? e[t] : e.md;
}, Ue = (t) => t ? {
  primary: "#3B3160",
  secondary: "#615A80",
  grey: "#615A80",
  icon: "#E1E5FF",
  green: "#55CBB7",
  white: "#FFFFFF"
}[t] : "currentColor", qW = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      width: i,
      height: o,
      "aria-hidden": !0,
      viewBox: "0 0 16 16",
      className: j(de, n),
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M15.71 8.472a1.005 1.005 0 0 0 0-1.422L9.313.652a1.005 1.005 0 1 0-1.421 1.422l5.687 5.687-5.687 5.688a1.005 1.005 0 1 0 1.421 1.422l6.399-6.399ZM0 8.767h15V6.756H0v2.01Z",
          fill: a
        }
      )
    }
  );
}, zW = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 36 36",
      "data-testid": "asset icon",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            stroke: a,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 3,
            d: "M7.783 32.722h26.25M22.84 9.373l10.8 6.912a.832.832 0 0 1 .393.7v1.247a.823.823 0 0 1-.256.594.894.894 0 0 1-.619.246H7.783"
          }
        ),
        /* @__PURE__ */ C(
          "rect",
          {
            width: 9.844,
            height: 14.7,
            x: 1.527,
            y: 15.069,
            stroke: a,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            rx: 1.515,
            transform: "rotate(-90 1.527 15.069)"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            stroke: a,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m6.607 5.422.438-2.813c.067-.427.307-.811.67-1.068a1.75 1.75 0 0 1 1.26-.301l9.87 1.418a1.71 1.71 0 0 1 1.114.643c.268.348.38.783.313 1.21l-.771 4.944a1.685 1.685 0 0 1-1.2 1.322 1.78 1.78 0 0 1-1.767-.447"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            stroke: a,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 3.8,
            d: "M8.877 9.622c.302 0 .547.235.547.525 0 .29-.245.525-.547.525a.536.536 0 0 1-.546-.525c0-.29.244-.525.546-.525"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            stroke: a,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 3,
            d: "M30.752 32.722v-13.65M24.19 32.722v-13.65M17.627 32.722v-13.65M11.065 32.722v-13.65"
          }
        )
      ]
    }
  );
}, g8 = ({ size: t, className: e, ...n }) => {
  const { width: r, height: i } = Te(t);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      width: r,
      height: i,
      viewBox: "0 0 42 44",
      fill: "currentColor",
      className: e,
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ C("path", { d: "M37.1235 35.395C39.2777 32.8031 40.7759 29.7306 41.4915 26.4372C42.2071 23.1439 42.1189 19.7267 41.2345 16.4746C40.3501 13.2225 38.6954 10.2313 36.4105 7.75398C34.1255 5.27666 31.2775 3.3861 28.1074 2.24224C24.9373 1.09839 21.5383 0.734886 18.1979 1.18249C14.8576 1.63009 11.6742 2.87562 8.91708 4.81372C6.15993 6.75183 3.91012 9.32548 2.35799 12.317C0.805856 15.3085 -0.00294389 18.6298 8.05147e-06 22C0.00114081 26.8992 1.72763 31.6416 4.87651 35.395L4.84651 35.4205C4.95151 35.5465 5.07151 35.6545 5.17951 35.779C5.31451 35.9335 5.46001 36.079 5.59951 36.229C6.01951 36.685 6.45151 37.123 6.90451 37.534C7.04251 37.66 7.18501 37.777 7.32451 37.897C7.80451 38.311 8.29801 38.704 8.80951 39.07C8.87551 39.115 8.93551 39.1735 9.00151 39.22V39.202C12.5147 41.6742 16.7057 43.001 21.0015 43.001C25.2974 43.001 29.4884 41.6742 33.0015 39.202V39.22C33.0675 39.1735 33.126 39.115 33.1935 39.07C33.7035 38.7025 34.1985 38.311 34.6785 37.897C34.818 37.777 34.9605 37.6585 35.0985 37.534C35.5515 37.1215 35.9835 36.685 36.4035 36.229C36.543 36.079 36.687 35.9335 36.8235 35.779C36.93 35.6545 37.0515 35.5465 37.1565 35.419L37.1235 35.395ZM21 9.99997C22.335 9.99997 23.6401 10.3958 24.7501 11.1375C25.8601 11.8792 26.7253 12.9335 27.2362 14.1669C27.7471 15.4003 27.8808 16.7575 27.6203 18.0668C27.3599 19.3762 26.717 20.5789 25.773 21.5229C24.829 22.4669 23.6262 23.1098 22.3169 23.3703C21.0075 23.6307 19.6503 23.497 18.4169 22.9862C17.1835 22.4753 16.1293 21.6101 15.3876 20.5001C14.6459 19.39 14.25 18.085 14.25 16.75C14.25 14.9598 14.9612 13.2429 16.227 11.977C17.4929 10.7111 19.2098 9.99997 21 9.99997ZM9.01051 35.395C9.03653 33.4254 9.83693 31.5453 11.2385 30.1614C12.6402 28.7774 14.5303 28.001 16.5 28H25.5C27.4697 28.001 29.3599 28.7774 30.7615 30.1614C32.1631 31.5453 32.9635 33.4254 32.9895 35.395C29.6998 38.3595 25.4284 40.0001 21 40.0001C16.5716 40.0001 12.3002 38.3595 9.01051 35.395Z" })
    }
  );
}, KW = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      "data-testid": "back arrow circle icon",
      viewBox: "0 0 59 59",
      width: i,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: j(de, n),
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: 29.672, cy: 29.406, r: 24.672, fill: a }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M28.464 18.035c.226-.233.532-.364.852-.364.32 0 .625.131.851.364.226.233.353.549.353.878 0 .329-.127.645-.353.878l-3.514 3.622h6.07c.85-.01 1.693.154 2.48.482a6.41 6.41 0 0 1 2.109 1.43 6.636 6.636 0 0 1 1.41 2.157 6.799 6.799 0 0 1 .001 5.101 6.636 6.636 0 0 1-1.41 2.157 6.41 6.41 0 0 1-2.109 1.43 6.257 6.257 0 0 1-2.48.483h-11.24a1.172 1.172 0 0 1-.88-.347 1.275 1.275 0 0 1 0-1.786 1.172 1.172 0 0 1 .879-.348h11.241a3.955 3.955 0 0 0 2.84-1.212 4.204 4.204 0 0 0 1.175-2.926c0-.544-.103-1.082-.305-1.584a4.149 4.149 0 0 0-.87-1.343 3.955 3.955 0 0 0-2.84-1.212h-5.15l2.593 2.673c.226.233.353.549.353.878 0 .33-.127.645-.353.878a1.187 1.187 0 0 1-.851.363c-.32 0-.626-.13-.852-.363l-4.996-5.15a1.429 1.429 0 0 1-.4-.995c0-.373.144-.73.4-.994l4.996-5.15Z",
            fill: "#5463D6"
          }
        ),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 29.493,
            cy: 29.238,
            r: 28.071,
            stroke: "#BEC7FF",
            strokeWidth: 1.863
          }
        )
      ]
    }
  );
}, WW = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "back arrow icon",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          fill: a,
          d: "M7.77 2.9a.674.674 0 0 1 .484-.207c.182 0 .356.075.484.207a.716.716 0 0 1 0 .997L6.742 5.954h3.448c.482-.005.96.088 1.408.274a3.64 3.64 0 0 1 1.197.812c.344.35.616.766.802 1.225a3.86 3.86 0 0 1 0 2.897 3.768 3.768 0 0 1-.801 1.225c-.343.35-.75.626-1.197.813-.448.186-.926.28-1.409.274H3.806a.666.666 0 0 1-.5-.197.705.705 0 0 1-.208-.508.723.723 0 0 1 .209-.507.681.681 0 0 1 .499-.197h6.384c.605 0 1.185-.248 1.613-.689a2.413 2.413 0 0 0 .494-2.561 2.356 2.356 0 0 0-.494-.763 2.246 2.246 0 0 0-1.613-.688H7.265l1.473 1.518a.716.716 0 0 1 0 .997.674.674 0 0 1-.484.207.674.674 0 0 1-.483-.207L4.933 6.955a.812.812 0 0 1-.227-.565c0-.212.082-.416.227-.565L7.771 2.9Z"
        }
      )
    }
  );
}, GW = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      width: i,
      height: o,
      viewBox: "0 0 94 94",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "book adviser call icon",
      className: j(de, n),
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: 46.922, cy: 46.905, r: 39.737, fill: a }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "m47.569 65.35.017.013a7.875 7.875 0 0 0 9.8-1.076l1.1-1.101a2.625 2.625 0 0 0 0-3.714l-4.642-4.639a2.625 2.625 0 0 0-3.714 0 2.625 2.625 0 0 1-3.711 0l-7.424-7.425a2.625 2.625 0 0 1 0-3.712 2.625 2.625 0 0 0 0-3.713l-4.64-4.64a2.625 2.625 0 0 0-3.712 0l-1.103 1.101a7.875 7.875 0 0 0-1.075 9.8l.011.017a71.06 71.06 0 0 0 19.093 19.09ZM57.422 45.593a9.188 9.188 0 1 0 0-18.375 9.188 9.188 0 0 0 0 18.375Z",
            fill: "#5463D6",
            fillOpacity: 0.2,
            stroke: "#5463D6",
            strokeWidth: 3,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M57.422 32.468v3.937h3.937",
            fill: "#5463D6",
            fillOpacity: 0.2
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M57.422 32.468v3.937h3.937",
            stroke: "#5463D6",
            strokeWidth: 3,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 46.711,
            cy: 46.866,
            r: 45.211,
            stroke: "#E1E5FF",
            strokeWidth: 3
          }
        )
      ]
    }
  );
}, YW = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "book icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M12.667 2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a.666.666 0 0 0 .667-.667V2.667A.667.667 0 0 0 12.667 2Zm-8 10.667a.667.667 0 0 1 0-1.334H12v1.334H4.667Z",
          fill: a
        }
      )
    }
  );
}, QW = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "book outline icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M3 2v-.615h-.615V2H3Zm0 12h-.615v.615H3V14Zm10.154 0v.615h.615V14h-.615ZM12.077 2.77l-.394.472c.012.01.024.02.036.028l.358-.5ZM2.385 2v12h1.23V2h-1.23ZM3 14.615h10.154v-1.23H3v1.23ZM13.77 14V4.615h-1.231V14h1.23Zm-.616-9.385h.615v-.032l-.003-.057a2.925 2.925 0 0 0-.169-.758 3.19 3.19 0 0 0-1.162-1.5l-.716 1.002c.421.3.623.653.723.924a1.688 1.688 0 0 1 .097.43v-.008h.615Zm-.683-2.319A4.002 4.002 0 0 0 10.88 1.5a4.036 4.036 0 0 0-.777-.114h-.025L10.076 2v.615h-.004.002a2.809 2.809 0 0 1 .507.078c.322.08.73.24 1.101.549l.788-.946Zm-2.394-.911H3v1.23h7.077v-1.23Z",
            fill: a
          }
        ),
        /* @__PURE__ */ C("path", { stroke: a, strokeWidth: 1.231, d: "M4.846 5.692h5.539" })
      ]
    }
  );
}, JW = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "currentColor",
      stroke: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "calendar icon",
      ...r,
      children: /* @__PURE__ */ C("path", { d: "M.5 14.5c0 .8.7 1.5 1.6 1.5h11.8c.9 0 1.6-.7 1.6-1.5V6H.5v8.5zm10.7-6.1c0-.2.2-.4.4-.4H13c.2 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-1.3c-.2 0-.4-.2-.4-.4V8.4zm0 4c0-.2.2-.4.4-.4H13c.2 0 .4.2.4.4v1.2c0 .2-.2.4-.4.4h-1.3c-.2 0-.4-.2-.4-.4v-1.2zm-4.3-4c0-.2.2-.4.4-.4h1.3c.2 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4H7.3c-.2 0-.4-.2-.4-.4V8.4zm0 4c0-.2.2-.4.4-.4h1.3c.2 0 .4.2.4.4v1.2c0 .2-.2.4-.4.4H7.3c-.2 0-.4-.2-.4-.4v-1.2zm-4.3-4c0-.2.2-.4.4-.4h1.3c.2 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4H3c-.2 0-.4-.2-.4-.4V8.4zm0 4c0-.2.2-.4.4-.4h1.3c.2 0 .4.2.4.4v1.2c0 .2-.2.4-.4.4H3c-.2 0-.4-.2-.4-.4v-1.2zM13.9 2h-1.6V.5c0-.3-.3-.5-.5-.5h-1.1c-.3 0-.5.2-.5.5V2H5.9V.5c0-.3-.3-.5-.6-.5H4.2c-.2 0-.5.2-.5.5V2H2.1C1.2 2 .5 2.7.5 3.5V5h15V3.5c0-.8-.7-1.5-1.6-1.5z" })
    }
  );
}, ZW = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => /* @__PURE__ */ K(
  "svg",
  {
    "aria-hidden": !0,
    className: j(de, n),
    viewBox: "0 0 17 17",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "calendar outline icon",
    ...r,
    children: [
      /* @__PURE__ */ C("path", { d: "M13.3 2.766H3.966c-.736 0-1.333.597-1.333 1.333v9.333c0 .737.597 1.334 1.333 1.334H13.3c.737 0 1.334-.597 1.334-1.334V4.1c0-.736-.597-1.333-1.333-1.333z" }),
      /* @__PURE__ */ C("path", { d: "M11.3 1.432V4.1M5.966 1.432V4.1", strokeLinecap: "round" }),
      /* @__PURE__ */ C("path", { d: "M2.633 6.766h12" })
    ]
  }
), XW = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      width: i,
      height: o,
      "data-testid": "chart circle icon",
      "aria-hidden": !0,
      className: j(de, n),
      viewBox: "0 0 82 82",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: "41.4706", cy: "41.2089", r: "34.2636", fill: a }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M32.6635 56.9615V46.9674H38.7961V56.9615H32.6635ZM43.5571 56.961V24.5715H49.6902V56.961H43.5571ZM54.5065 56.961V34.6708H60.6391V56.961H54.5065ZM21.7141 56.961V34.6708H27.8472V56.961H21.7141Z",
            fill: "#CBD1F9",
            stroke: "#717FE2",
            strokeWidth: "2.35"
          }
        ),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: "41.2227",
            cy: "40.9609",
            r: "38.984",
            stroke: "#E1E5FF",
            strokeWidth: "2.58678"
          }
        )
      ]
    }
  );
}, eG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "data-testid": "wallet icon",
      "aria-hidden": !0,
      width: i,
      height: o,
      className: j(de, n),
      viewBox: "0 0 81 82",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: "40.676", cy: "41.2101", r: "34.2385", fill: a }),
        /* @__PURE__ */ C(
          "path",
          {
            opacity: "0.2",
            d: "M56.7267 33.6689V53.5657C56.7267 53.9426 56.5769 54.3041 56.3104 54.5706C56.0439 54.8371 55.6824 54.9869 55.3055 54.9869H26.8815C26.1276 54.9869 25.4046 54.6874 24.8716 54.1544C24.3385 53.6213 24.0391 52.8983 24.0391 52.1445V29.4053C24.0391 30.1591 24.3385 30.8821 24.8716 31.4152C25.4046 31.9482 26.1276 32.2477 26.8815 32.2477H55.3055C55.6824 32.2477 56.0439 32.3974 56.3104 32.6639C56.5769 32.9305 56.7267 33.2919 56.7267 33.6689Z",
            fill: "#717FE2"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M55.3048 30.8225H26.8808C26.5039 30.8225 26.1424 30.6728 25.8758 30.4062C25.6093 30.1397 25.4596 29.7782 25.4596 29.4013C25.4596 29.0244 25.6093 28.6629 25.8758 28.3964C26.1424 28.1298 26.5039 27.9801 26.8808 27.9801H51.0412C51.4181 27.9801 51.7796 27.8304 52.0461 27.5638C52.3127 27.2973 52.4624 26.9358 52.4624 26.5589C52.4624 26.182 52.3127 25.8205 52.0461 25.554C51.7796 25.2874 51.4181 25.1377 51.0412 25.1377H26.8808C25.75 25.1377 24.6655 25.5869 23.866 26.3865C23.0664 27.1861 22.6172 28.2705 22.6172 29.4013V52.1405C22.6172 53.2713 23.0664 54.3557 23.866 55.1553C24.6655 55.9549 25.75 56.4041 26.8808 56.4041H55.3048C56.0586 56.4041 56.7816 56.1046 57.3147 55.5716C57.8477 55.0385 58.1472 54.3156 58.1472 53.5617V33.6649C58.1472 32.911 57.8477 32.1881 57.3147 31.655C56.7816 31.122 56.0586 30.8225 55.3048 30.8225ZM55.3048 53.5617H26.8808C26.5039 53.5617 26.1424 53.412 25.8758 53.1454C25.6093 52.8789 25.4596 52.5174 25.4596 52.1405V33.4215C25.9159 33.5833 26.3966 33.6656 26.8808 33.6649H55.3048V53.5617ZM46.7776 42.9027C46.7776 42.4811 46.9026 42.0689 47.1369 41.7183C47.3711 41.3678 47.704 41.0945 48.0936 40.9332C48.4831 40.7718 48.9118 40.7296 49.3253 40.8119C49.7388 40.8941 50.1187 41.0972 50.4168 41.3953C50.7149 41.6934 50.918 42.0733 51.0002 42.4868C51.0825 42.9003 51.0403 43.329 50.8789 43.7185C50.7176 44.108 50.4443 44.441 50.0938 44.6752C49.7432 44.9095 49.331 45.0345 48.9094 45.0345C48.344 45.0345 47.8018 44.8099 47.402 44.4101C47.0022 44.0103 46.7776 43.4681 46.7776 42.9027Z",
            fill: "#717FE2"
          }
        ),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: "40.4275",
            cy: "40.9617",
            r: "38.9554",
            stroke: "#E1E5FF",
            strokeWidth: "2.58488"
          }
        )
      ]
    }
  );
}, tG = ({ size: t, className: e, ...n }) => {
  const { width: r, height: i } = Te(t);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-label": "chat icon",
      className: j(de, e),
      width: r,
      height: i,
      viewBox: "0 0 33 33",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: [
        /* @__PURE__ */ K("g", { clipPath: "url(#clip0_13173_15181)", children: [
          /* @__PURE__ */ C(
            "path",
            {
              d: "M28.8421 25.1068C30.7481 23.4081 31.8273 21.1439 31.8273 18.7942C31.8273 16.2971 30.6584 13.9618 28.5357 12.218C26.4697 10.5214 23.7352 9.58691 20.8354 9.58691C17.9356 9.58691 15.2011 10.5214 13.1354 12.2181C11.0127 13.9618 9.84375 16.2971 9.84375 18.7942C9.84375 21.2913 11.0127 23.6267 13.1354 25.3705C15.2011 27.0672 17.9356 28.0016 20.8354 28.0016C21.2218 28.0016 21.6106 27.9845 21.9961 27.9506L22.6547 28.5215C24.9237 30.4877 27.8254 31.5701 30.8278 31.5702H31.827V29.4433L31.5344 29.1507C30.3799 27.9928 29.465 26.6186 28.8421 25.1068ZM23.9636 27.0112L22.642 25.8657L22.2014 25.9197C21.7481 25.9752 21.292 26.003 20.8354 26.003C15.8767 26.003 11.8422 22.7691 11.8422 18.7942C11.8422 14.8193 15.8767 11.5854 20.8354 11.5854C25.7941 11.5854 29.8286 14.8192 29.8286 18.7942C29.8286 20.7746 28.8406 22.6234 27.0465 24.0001L26.471 24.4417L26.7366 25.1934C27.2808 26.7284 28.0807 28.1604 29.1024 29.4287C27.1996 29.1111 25.4214 28.2745 23.9636 27.0112Z",
              fill: "#717fe3",
              stroke: "#717fe3",
              strokeWidth: "1.19909"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M4.61103 20.4207C5.54639 19.2367 6.2808 17.907 6.78487 16.4848L7.04842 15.7369L6.47342 15.2956C4.78171 13.9975 3.85004 12.2552 3.85004 10.3896C3.85004 6.641 7.66021 3.59125 12.3436 3.59125C15.789 3.59125 18.7616 5.24187 20.0925 7.60695C20.3396 7.59496 20.5878 7.58821 20.8371 7.58821C21.3379 7.58821 21.834 7.61251 22.3256 7.6611C21.8113 6.32867 20.9181 5.11235 19.6901 4.10374C17.719 2.48453 15.1102 1.59277 12.3436 1.59277C9.57694 1.59277 6.96817 2.48453 4.99692 4.10374C2.96859 5.76991 1.85156 8.00227 1.85156 10.3896C1.85156 12.6254 2.87279 14.7797 4.67754 16.4003C4.08857 17.8176 3.22799 19.106 2.14428 20.1929L1.85156 20.4856V22.5768H2.8508C4.69859 22.5766 6.52096 22.1463 8.17369 21.32C7.99246 20.6331 7.88628 19.9285 7.857 19.2187C6.85387 19.8067 5.75513 20.2135 4.61103 20.4207Z",
              fill: "#717fe3",
              stroke: "#717fe3",
              strokeWidth: "1.19909"
            }
          )
        ] }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_13173_15181", children: /* @__PURE__ */ C(
          "rect",
          {
            width: "31.9757",
            height: "31.9757",
            fill: "white",
            transform: "translate(0.851562 0.592773)"
          }
        ) }) })
      ]
    }
  );
}, nG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "book outline icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 24 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M2.95413 20.2692L6.56397 19.0654L7.19578 19.3813C8.64723 20.1053 10.2609 20.4912 11.9531 20.4912C17.6052 20.4912 22.1987 16.0412 22.1987 11.0995C22.1987 6.15769 17.6052 1.70771 11.9531 1.70771C6.301 1.70771 1.70759 6.15769 1.70759 11.0995C1.70759 12.9436 2.37355 14.8152 3.59789 16.4152L4.18701 17.1836L2.95242 20.2675L2.95413 20.2692ZM1.74686 22.472C1.59234 22.5238 1.42622 22.5302 1.26814 22.4906C1.11006 22.451 0.966612 22.367 0.854746 22.2485C0.74288 22.13 0.667268 21.9819 0.636841 21.8218C0.606414 21.6617 0.622443 21.4963 0.683036 21.345L2.24036 17.4517C0.819643 15.5904 0 13.3637 0 11.0995C0 5.4405 5.12277 0.00012207 11.9531 0.00012207C18.7835 0.00012207 23.9062 5.4405 23.9062 11.0995C23.9062 16.7584 18.7835 22.1988 11.9531 22.1988C10.0375 22.2042 8.14709 21.7621 6.43249 20.9078L1.74686 22.4703V22.472Z",
            fill: a
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            stroke: a,
            strokeWidth: 1.231,
            d: "M7.68387 12.8073H16.2218C16.791 12.8073 17.0756 13.0919 17.0756 13.6611C17.0756 14.2303 16.791 14.5149 16.2218 14.5149H7.68387C7.11468 14.5149 6.83008 14.2303 6.83008 13.6611C6.83008 13.0919 7.11468 12.8073 7.68387 12.8073ZM8.53767 7.68457H15.368C15.9372 7.68457 16.2218 7.96917 16.2218 8.53836C16.2218 9.10756 15.9372 9.39216 15.368 9.39216H8.53767C7.96847 9.39216 7.68387 9.10756 7.68387 8.53836C7.68387 7.96917 7.96847 7.68457 8.53767 7.68457Z",
            fill: "white"
          }
        )
      ]
    }
  );
}, rG = ({ size: t, className: e, ...n }) => {
  const { width: r, height: i } = Te(t);
  return /* @__PURE__ */ C(
    "svg",
    {
      width: r,
      height: i,
      "data-testid": "checklist icon",
      "aria-hidden": !0,
      className: j(de, e),
      viewBox: "0 0 38 29",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M6.68244 28.5695L0.09375 21.9809L2.69211 19.3825L6.63604 23.3264L14.5239 15.4386L17.1223 18.0833L6.68244 28.5695ZM6.68244 13.7218L0.09375 7.13311L2.69211 4.53475L6.63604 8.47869L14.5239 0.59082L17.1223 3.23558L6.68244 13.7218ZM20.5094 24.8576V21.1457H37.2131V24.8576H20.5094ZM20.5094 10.0099V6.29792H37.2131V10.0099H20.5094Z",
          fill: "#717fe3"
        }
      )
    }
  );
}, iG = ({
  className: t,
  ...e
}) => /* @__PURE__ */ K(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "add icon",
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: j(de, t),
    ...e,
    children: [
      /* @__PURE__ */ C("rect", { width: 24.914, height: 24.159, rx: 12.079, fill: "#5261AC" }),
      /* @__PURE__ */ C(
        "path",
        {
          stroke: "#fff",
          strokeWidth: 1.887,
          strokeLinecap: "round",
          d: "M8.871 11.892h7.173M12.646 8.494v7.173"
        }
      )
    ]
  }
), oG = ({
  className: t,
  ...e
}) => /* @__PURE__ */ K(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "progress bar",
    className: j(de, t),
    width: 68,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M34.134 8.079a25.915 25.915 0 0 0-14.79 4.507l2.483 3.61a21.51 21.51 0 0 1 12.276-3.741l.03-4.376ZM18.538 13.16a25.764 25.764 0 0 0-7.94 9.64l3.97 1.873a21.384 21.384 0 0 1 6.59-8.001l-2.62-3.513Z",
          fill: "#F1F3FD"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M10.18 23.727A25.649 25.649 0 0 0 9.112 40.92 25.746 25.746 0 0 0 19.17 54.935l2.513-3.589a21.369 21.369 0 0 1-8.348-11.632 21.288 21.288 0 0 1 .886-14.271l-4.041-1.716Z",
          fill: "#EBEDF7"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M57.285 44.892a25.755 25.755 0 0 1-6.691 8.625 25.877 25.877 0 0 1-9.675 5.094l-1.184-4.214a21.478 21.478 0 0 0 8.03-4.228 21.377 21.377 0 0 0 5.554-7.159l3.966 1.882Z",
          fill: "#99A2CD"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M40.09 58.827a25.943 25.943 0 0 1-20.145-3.374l2.381-3.677a21.534 21.534 0 0 0 16.72 2.8l1.044 4.251Z",
          fill: "#C1C7E1"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M59.25 28.547a25.648 25.648 0 0 1-1.446 15.187L53.75 42.05a21.29 21.29 0 0 0 1.2-12.605l4.3-.896Z",
          fill: "#717FB8"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M34.834 8.093a25.905 25.905 0 0 1 15.305 5.659 25.734 25.734 0 0 1 8.847 13.667l-4.256 1.089a21.358 21.358 0 0 0-7.342-11.344 21.5 21.5 0 0 0-12.704-4.697l.15-4.374Z",
          fill: "#5261AC"
        }
      )
    ]
  }
), aG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "collapsible arrow icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M7.9465 13.28L2.6665 7.99998L7.9465 2.71998L8.8865 3.66665L5.21984 7.33331L14.6665 7.33331L14.6665 8.66665L5.21984 8.66665L8.89317 12.3333L7.9465 13.28ZM2.6665 7.99998L2.6665 1.33331L1.33317 1.33331L1.33317 14.6666L2.6665 14.6666L2.6665 7.99998Z",
          fill: a
        }
      )
    }
  );
}, sG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      viewBox: "0 0 32 33",
      width: i,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("g", { clipPath: `url(#${a})`, children: /* @__PURE__ */ C(
          "path",
          {
            d: "M18.242 6.337a5.232 5.232 0 0 0-4.48 0L.764 12.494a1.334 1.334 0 0 0-.762 1.275v8.07a1.334 1.334 0 1 0 2.666 0v-5.99l2.667 1.323v7.333a1.334 1.334 0 0 0 .392.944l.067.064.16.147c.836.744 1.739 1.41 2.698 1.986 1.782 1.072 4.355 2.192 7.35 2.192 2.994 0 5.568-1.12 7.352-2.192a17.98 17.98 0 0 0 2.698-1.986l.16-.147.062-.064h.005a1.332 1.332 0 0 0 .39-.947V17.17l4.591-2.277a1.333 1.333 0 0 0-.02-2.4L18.241 6.334v.003Zm.085 14.973 5.675-2.816v5.419a15.31 15.31 0 0 1-2.019 1.448c-1.547.928-3.643 1.81-5.981 1.81-2.339 0-4.432-.88-5.982-1.81a15.31 15.31 0 0 1-2.018-1.448v-5.419l5.674 2.816a5.241 5.241 0 0 0 4.651 0ZM17.1 8.748l10.512 4.978-10.472 5.195a2.564 2.564 0 0 1-2.277 0L4.391 13.726l10.512-4.978a2.565 2.565 0 0 1 2.197 0ZM5.732 25.454l-.002-.002.002.002Z",
            fill: "currentColor"
          }
        ) }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: a, children: /* @__PURE__ */ C("path", { fill: "#fff", transform: "translate(0 .5)", d: "M0 0h32v32H0z" }) }) })
      ]
    }
  );
}, cG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "cross icon",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M3.88 10.548a1.111 1.111 0 1 0 1.572 1.571l-1.571-1.571Zm8.239-5.096a1.111 1.111 0 1 0-1.572-1.571l1.572 1.571ZM5.452 12.12l6.667-6.667-1.572-1.571-6.666 6.667 1.571 1.571Z",
            fill: a
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M5.452 3.881a1.111 1.111 0 0 0-1.57 1.571l1.57-1.571Zm5.096 8.238a1.111 1.111 0 0 0 1.571-1.571l-1.571 1.571ZM3.88 5.452l6.667 6.667 1.571-1.571L5.452 3.88l-1.57 1.571Z",
            fill: a
          }
        )
      ]
    }
  );
}, lG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      xmlns: "http://www.w3.org/2000/svg",
      width: i,
      height: o,
      fill: "none",
      viewBox: "0 0 36 36",
      "data-testid": "debt icon",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          fill: a,
          d: "M15.726 3.934c.34-.35.801-.547 1.282-.547.48 0 .942.197 1.282.547.34.35.53.826.53 1.322 0 .495-.19.97-.53 1.32L13 12.029h9.136a9.416 9.416 0 0 1 3.733.726 9.648 9.648 0 0 1 3.173 2.152 9.986 9.986 0 0 1 2.124 3.246 10.23 10.23 0 0 1 0 7.678 9.986 9.986 0 0 1-2.122 3.247 9.647 9.647 0 0 1-3.173 2.152 9.414 9.414 0 0 1-3.733.727H5.22a1.762 1.762 0 0 1-.713-.123 1.807 1.807 0 0 1-.61-.4 1.872 1.872 0 0 1-.41-.614 1.918 1.918 0 0 1 .41-2.074c.176-.175.383-.31.61-.4.228-.09.47-.132.713-.123h16.92c1.602 0 3.139-.657 4.272-1.825a6.327 6.327 0 0 0 1.77-4.404c0-.818-.156-1.628-.46-2.383a6.246 6.246 0 0 0-1.31-2.021 5.953 5.953 0 0 0-4.273-1.824h-7.752l3.904 4.023c.34.35.53.825.53 1.32 0 .496-.19.972-.53 1.322-.34.35-.802.547-1.282.547-.481 0-.942-.197-1.282-.547l-7.52-7.75a2.151 2.151 0 0 1-.601-1.498c0-.561.216-1.1.602-1.497l7.52-7.75Z"
        }
      )
    }
  );
}, uG = ({
  className: t,
  ...e
}) => /* @__PURE__ */ C(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "missing square icon",
    className: t,
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C(
      "rect",
      {
        x: "0.340608",
        y: "0.340608",
        width: "49.1673",
        height: "49.1673",
        rx: "7.83398",
        stroke: "black",
        strokeWidth: "0.681215",
        strokeDasharray: "6.81 6.81"
      }
    )
  }
), dG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "down arrow icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ K("mask", { id: s, children: [
          /* @__PURE__ */ C("rect", { fill: "#FFF", width: "100%", height: "100%" }),
          /* @__PURE__ */ C("path", { d: "M8.167 10.762 5.63 6.369h5.073l-2.536 4.393Z", fill: "#000" })
        ] }) }),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 8.167,
            cy: 7.833,
            r: 6.833,
            fill: a,
            mask: `url(#${s})`
          }
        )
      ]
    }
  );
}, fG = ({ className: t, ...e }) => /* @__PURE__ */ K(
  "svg",
  {
    "aria-hidden": !e["aria-label"],
    width: 13,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    className: j(de, t),
    children: [
      /* @__PURE__ */ C("circle", { cx: 2.5, cy: 2.5, r: 2.5, fill: "#EEE" }),
      /* @__PURE__ */ C("circle", { cx: 2.5, cy: 12.5, r: 2.5, fill: "#EEE" }),
      /* @__PURE__ */ C("circle", { cx: 2.5, cy: 22.5, r: 2.5, fill: "#EEE" }),
      /* @__PURE__ */ C("circle", { cx: 10.5, cy: 2.5, r: 2.5, fill: "#EEE" }),
      /* @__PURE__ */ C("circle", { cx: 10.5, cy: 12.5, r: 2.5, fill: "#EEE" }),
      /* @__PURE__ */ C("circle", { cx: 10.5, cy: 22.5, r: 2.5, fill: "#EEE" })
    ]
  }
), hG = ({
  className: t,
  ...e
}) => /* @__PURE__ */ C(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "down arrow",
    width: 14,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: j(de, t),
    ...e,
    children: /* @__PURE__ */ C("path", { d: "M7 12 .072 0h13.856L7 12Z", fill: "#5261AC" })
  }
), pG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "eye icon",
      width: i,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 52 52",
      ...r,
      className: j(de, n),
      children: /* @__PURE__ */ C(
        "path",
        {
          stroke: a,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 4,
          d: "M2.872 24.031c10.51 18.52 35.746 18.52 46.256 0M26 38v6M36 36l2 6M44 31.2l4 4.8M16 36l-2 6M8 31.2 4 36"
        }
      )
    }
  );
}, gG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "eye icon open",
      width: i,
      height: o,
      viewBox: "0 0 52 52",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: j(de, n),
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            stroke: a,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 4,
            d: "M2.872 23.969c10.51-18.52 35.746-18.52 46.256 0M2.872 24.031c10.51 18.52 35.746 18.52 46.256 0"
          }
        ),
        /* @__PURE__ */ C("circle", { cx: 26, cy: 24, r: 8, stroke: a, strokeWidth: 4 })
      ]
    }
  );
}, mG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("g", { clipPath: `url(#${s})`, children: /* @__PURE__ */ C(
          "path",
          {
            d: "M9.12 2.919a2.616 2.616 0 0 0-2.24 0L.383 5.997a.667.667 0 0 0-.381.638v4.034a.667.667 0 1 0 1.333 0V7.675l1.334.66v3.667a.667.667 0 0 0 .196.473l.033.032.08.073c.418.372.87.705 1.35.993.89.536 2.177 1.096 3.674 1.096 1.497 0 2.784-.56 3.676-1.096.48-.288.931-.62 1.35-.993l.08-.073.03-.032h.003a.667.667 0 0 0 .194-.474V8.335l2.296-1.14a.666.666 0 0 0-.01-1.2l-6.5-3.078v.002Zm.044 7.486L12 8.997v2.71c-.316.268-.654.51-1.01.723-.773.465-1.82.906-2.99.906-1.17 0-2.216-.44-2.99-.905A7.654 7.654 0 0 1 4 11.707v-2.71l2.837 1.408a2.621 2.621 0 0 0 2.326 0ZM8.55 4.124l5.256 2.49L8.57 9.21a1.283 1.283 0 0 1-1.138 0L2.196 6.613l5.256-2.49a1.283 1.283 0 0 1 1.098 0Zm-5.684 8.353-.001-.001.001.001Z",
            fill: a
          }
        ) }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: s, children: /* @__PURE__ */ C("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
      ]
    }
  );
}, vG = ({ size: t, variant: e, className: n, ...r }) => /* @__PURE__ */ K(
  "svg",
  {
    "aria-hidden": !0,
    className: j(de, n),
    width: 38,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "graph icon",
    ...r,
    children: [
      /* @__PURE__ */ C(
        "rect",
        {
          x: 5.516,
          y: 9.246,
          width: 23.231,
          height: 23.231,
          rx: 11.616,
          transform: "rotate(.054 5.516 9.246)",
          fill: "#EBDAF1",
          stroke: "#5261AC",
          strokeWidth: 1.4
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "m1.503 28.46 11.498-9 4.89 2.736L32.972 6.969m0 0L23.5 6.96m9.473.009-.008 9.473",
          stroke: "#5261AC",
          strokeWidth: 1.4,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), yG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M6 2H3.333A1.333 1.333 0 0 0 2 3.333V6a1.333 1.333 0 0 0 1.333 1.333H6A1.333 1.333 0 0 0 7.333 6V3.333A1.333 1.333 0 0 0 6 2Zm6.667 0H10a1.333 1.333 0 0 0-1.333 1.333V6A1.333 1.333 0 0 0 10 7.333h2.667A1.333 1.333 0 0 0 14 6V3.333A1.334 1.334 0 0 0 12.667 2ZM6 8.667H3.333A1.333 1.333 0 0 0 2 10v2.667A1.333 1.333 0 0 0 3.333 14H6a1.334 1.334 0 0 0 1.333-1.333V10A1.333 1.333 0 0 0 6 8.667Zm6.667 0H10A1.333 1.333 0 0 0 8.667 10v2.667A1.333 1.333 0 0 0 10 14h2.667A1.334 1.334 0 0 0 14 12.667V10a1.334 1.334 0 0 0-1.333-1.333Z",
          fill: a
        }
      )
    }
  );
}, wG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 59 59",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: 29.692, cy: 29.406, r: 24.672, fill: a }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M29.597 22.099s1.36-3.703 5.86-3.703 9.255 4.645 4.98 12.794c-3.618 6.896-9.63 9.364-10.81 9.798h-.002c-1.18-.434-7.255-2.902-10.873-9.798-4.275-8.15.415-12.794 4.914-12.794 4.5 0 5.926 3.703 5.926 3.703",
            stroke: "#5463D6",
            strokeWidth: 1.863,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M18.223 29.817c-1.312-1.968-.79-3.26-.223-3.813-.21.091-.453-.025-.52-.831-.117-1.413.743-1.579.743-3.065 0-1.487.836-1.858 1.486-2.88.65-1.022.743-.65 4.18-.65s2.88.464 3.901 1.672c.818.966 1.517 1.64 1.765 1.858.155-.248.539-.966.836-1.858.371-1.115 1.022-1.022 5.016-1.672 3.994-.65 4.83 1.3 6.223 5.016 1.393 3.715-1.58 8.917-4.273 12.354-2.155 2.75-4.86 4.118-5.944 4.458-.403.155-1.895.167-4.645-1.021-3.436-1.487-6.687-6.781-8.545-9.568Z",
            fill: "#5463D6",
            fillOpacity: 0.2
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M29.577 22.066s1.361-3.703 5.86-3.703c4.5 0 9.255 4.644 4.98 12.794-3.618 6.895-9.63 9.363-10.81 9.798h-.002c-1.18-.435-7.255-2.903-10.872-9.798-4.276-8.15.414-12.794 4.913-12.794 4.5 0 5.926 3.703 5.926 3.703",
            stroke: "#5463D6",
            strokeOpacity: 0.2,
            strokeWidth: 2.229,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M17.996 28.925h4.573l1.927 3.48 3.2-6.956 3.778 7.834 3.616-7.265 1.51 3.161H41",
            stroke: "#5463D6",
            strokeWidth: 1.863,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 29.512,
            cy: 29.238,
            r: 28.071,
            stroke: "#BEC7FF",
            strokeWidth: 1.863
          }
        )
      ]
    }
  );
}, bG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "health icon",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M7.99344 3.88169C7.99344 3.88169 8.80746 1.66699 11.4987 1.66699C14.1898 1.66699 17.034 4.44499 14.4767 9.31954C12.3131 13.4437 8.71721 14.9199 8.01149 15.1797H8.01014C7.30443 14.9199 3.67079 13.4437 1.50717 9.31954C-1.05015 4.44499 1.75499 1.66699 4.44617 1.66699C7.13733 1.66699 7.99044 3.88169 7.99044 3.88169",
            stroke: a,
            strokeWidth: "0.750014",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M1.06641 7.98471H3.80164L4.95383 10.0661L6.86843 5.90527L9.12812 10.591L11.2909 6.24553L12.194 8.13647H14.826",
            stroke: a,
            strokeWidth: "0.750014",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}, _G = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "home icon",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M5.67835 12.5886H3.77104C3.24435 12.5886 2.81738 12.1617 2.81738 11.635V6.8667",
            stroke: "currentColor",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M0.911011 5.91309L6.49371 1.18932C6.8493 0.888391 7.37025 0.888391 7.72583 1.18932L12.3536 5.10503",
            stroke: "currentColor",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M10.4478 1.14478H12.3551V3.05209",
            stroke: "currentColor",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M10.3777 11.7463C10.446 11.8144 10.4664 11.917 10.4295 12.0061C10.3927 12.0952 10.3057 12.1534 10.2092 12.1534C10.1128 12.1534 10.0258 12.0952 9.98895 12.0061C9.95207 11.917 9.97252 11.8144 10.0408 11.7463C10.0854 11.7015 10.146 11.6763 10.2092 11.6763C10.2725 11.6763 10.3331 11.7015 10.3777 11.7463",
            stroke: "currentColor",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.5687 10.9771L14.9128 8.63304C15.3166 8.22924 15.3166 7.57456 14.9128 7.17077C14.509 6.76697 13.8543 6.76697 13.4505 7.17077L11.1083 9.51485C9.97045 9.06925 8.67603 9.48262 8.00703 10.5052C7.33803 11.5279 7.4778 12.8795 8.34189 13.7436C9.20598 14.6076 10.5576 14.7474 11.5802 14.0784C12.6028 13.4094 13.0162 12.115 12.5706 10.9771H12.5687Z",
            stroke: "currentColor",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}, EG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "house icon",
      ...r,
      children: [
        /* @__PURE__ */ C("path", { d: "M6.667 9.333h2.666V14H6.666V9.333Z", fill: a }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "m13.613 6.787-5.14-5.254a.667.667 0 0 0-.946 0l-5.14 5.26A1.334 1.334 0 0 0 2 7.747v5.587a1.334 1.334 0 0 0 1.26 1.333h2.073v-6A.667.667 0 0 1 6 8h4a.667.667 0 0 1 .667.667v6h2.073A1.334 1.334 0 0 0 14 13.334V7.747a1.38 1.38 0 0 0-.387-.96Z",
            fill: a
          }
        )
      ]
    }
  );
}, CG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "house outline icon",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M7.132 1.866a1.333 1.333 0 0 1 1.736 0l4.224 3.62 1.658 1.327a.666.666 0 1 1-.833 1.041l-.583-.467v5.28A1.333 1.333 0 0 1 12 14H4a1.333 1.333 0 0 1-1.333-1.333v-5.28l-.583.466a.667.667 0 1 1-.834-1.041l1.658-1.327 4.224-3.62v.001ZM4 6.306v6.36h2V10a1.333 1.333 0 0 1 1.334-1.333h1.333A1.333 1.333 0 0 1 10 10v2.667h2v-6.36L8 2.878 4 6.307Zm4.667 6.36V10H7.334v2.667h1.333Z",
          fill: a
        }
      )
    }
  );
}, IG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M15.655 8.34 14.56 3.143c-.212-1.134-1.026-1.81-2.179-1.81H3.62c-.575 0-1.06.16-1.44.476-.38.317-.63.764-.74 1.332L.345 8.339a.57.57 0 0 0-.01.113v3.834a2.19 2.19 0 0 0 2.19 2.19h10.952a2.19 2.19 0 0 0 2.19-2.19V8.452a.571.571 0 0 0-.01-.113ZM2.512 3.362v-.01c.122-.63.473-.924 1.106-.924h8.763c.637 0 .988.293 1.105.921l.002.014.922 4.376a.135.135 0 0 1-.028.115.136.136 0 0 1-.107.05h-4.084a.545.545 0 0 0-.548.542 1.643 1.643 0 1 1-3.286 0 .545.545 0 0 0-.547-.542H1.725a.137.137 0 0 1-.134-.165l.921-4.377Z",
          fill: a
        }
      )
    }
  );
}, m8 = ({ className: t, ...e }) => /* @__PURE__ */ K(
  "svg",
  {
    "aria-hidden": !0,
    className: j(de, t),
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          stroke: "#5261AC",
          strokeWidth: 1.414,
          d: "M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          stroke: "#5261AC",
          strokeLinecap: "square",
          strokeWidth: 1.414,
          d: "M9 12.358v-4.5"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          stroke: "#5261AC",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.414,
          d: "M9 5.608h.008"
        }
      )
    ]
  }
), SG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      xmlns: "http://www.w3.org/2000/svg",
      width: i,
      height: o,
      viewBox: "0 0 14 14",
      "data-testid": "link icon",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M6.94967 8.94843C6.79694 9.01137 6.6755 9.13246 6.61212 9.28501C6.54874 9.43756 6.54863 9.60905 6.6118 9.76168C6.70813 9.99426 6.65484 10.262 6.47678 10.4399L4.71712 12.2002C4.23116 12.686 3.44342 12.686 2.95746 12.2002L1.6371 10.8804C1.40361 10.6471 1.27243 10.3304 1.27243 10.0003C1.27243 9.67017 1.40361 9.35356 1.6371 9.12017L3.39925 7.36051C3.57837 7.18418 3.84513 7.13112 4.07809 7.22549C4.3958 7.35659 4.75962 7.20532 4.89072 6.88762C5.02182 6.56992 4.87055 6.20609 4.55285 6.07499C3.85479 5.79257 3.05565 5.952 2.51942 6.48068L0.757272 8.24034C-0.21271 9.21318 -0.21271 10.7874 0.757272 11.7603L2.07764 13.08C3.04955 14.0516 4.62503 14.0516 5.59695 13.08L7.35723 11.3204C7.89017 10.7859 8.0499 9.98354 7.7623 9.28568C7.63099 8.96819 7.2672 8.81722 6.94967 8.94843Z",
            fill: a
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M4.05718 9.77967C4.30168 10.0189 4.6925 10.0189 4.93701 9.77967L9.77731 4.93999C10.0131 4.69584 10.0097 4.30776 9.76973 4.06774C9.52972 3.82773 9.14163 3.82436 8.89748 4.06016L4.05718 8.89984C3.81427 9.14282 3.81427 9.53669 4.05718 9.77967Z",
            fill: a
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M12.637 2.52019L11.3173 1.20045C10.3445 0.230466 8.7702 0.230466 7.79736 1.20045L6.03708 2.9601C5.50409 3.49433 5.34434 4.29651 5.63201 4.99416C5.71693 5.19968 5.90504 5.34428 6.12548 5.3735C6.34592 5.40271 6.56521 5.31211 6.70073 5.13581C6.83625 4.95951 6.86743 4.7243 6.78251 4.51878C6.68729 4.2869 6.74052 4.02053 6.91753 3.84304L8.67719 2.08339C8.91058 1.8499 9.22719 1.71872 9.55733 1.71872C9.88746 1.71872 10.2041 1.8499 10.4375 2.08339L11.7572 3.40313C11.9907 3.63652 12.1219 3.95313 12.1219 4.28327C12.1219 4.61341 11.9907 4.93001 11.7572 5.16341L9.99506 6.91996C9.81578 7.09599 9.54921 7.14901 9.31621 7.05498C8.99851 6.92353 8.63441 7.07452 8.50296 7.39222C8.37152 7.70993 8.52251 8.07403 8.84021 8.20548C9.53837 8.48997 10.3389 8.3306 10.8749 7.80041L12.6345 6.04075C13.6053 5.06838 13.6064 3.49393 12.637 2.52019Z",
            fill: a
          }
        )
      ]
    }
  );
}, TG = ({ className: t, ...e }) => /* @__PURE__ */ C(
  "svg",
  {
    "aria-hidden": !0,
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    className: j(de, t),
    children: /* @__PURE__ */ C(
      "path",
      {
        stroke: "#55CBB7",
        strokeWidth: 1.791,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 10.75h14.5v10.875H5zM7.719 10.75V8.031A4.531 4.531 0 0 1 12.25 3.5v0a4.531 4.531 0 0 1 4.531 4.531v2.719"
      }
    )
  }
), kG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 31 31",
      fill: "currentColor",
      stroke: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "more advice icon",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M3.82118 30.9899H27.1788C28.0638 30.9899 28.9125 30.6384 29.5383 30.0126C30.1641 29.3868 30.5156 28.5381 30.5156 27.6531V4.29548C30.5156 3.41051 30.1641 2.56178 29.5383 1.93601C28.9125 1.31023 28.0638 0.958679 27.1788 0.958679H3.82118C2.9362 0.958679 2.08747 1.31023 1.4617 1.93601C0.83593 2.56178 0.484375 3.41051 0.484375 4.29548V27.6531C0.484375 28.5381 0.83593 29.3868 1.4617 30.0126C2.08747 30.6384 2.9362 30.9899 3.82118 30.9899ZM7.15799 14.3059H13.8316V7.63229H17.1684V14.3059H23.842V17.6427H17.1684V24.3163H13.8316V17.6427H7.15799V14.3059Z",
          fill: "currentColor"
        }
      )
    }
  );
}, AG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      width: i,
      height: o,
      viewBox: "0 0 59 59",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": !0,
      className: j(de, n),
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: 29.682, cy: 29.406, r: 24.672, fill: a }),
        /* @__PURE__ */ K("g", { clipPath: "url(#a)", children: [
          /* @__PURE__ */ C(
            "path",
            {
              d: "M36.518 18.023c3.43 1.256 4.488 7.118 3.14 11.874H18.687c-.784-4.56.52-9.654 3.738-10.717 2.013-.665 4.362.383 6.347 2.273 2.276-2.659 5.303-4.325 7.746-3.43Z",
              fill: "#5463D6",
              fillOpacity: 0.2
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M25.46 29.897h7.645m-4.333-8.444c2.276-2.659 5.303-4.325 7.746-3.43 3.43 1.256 4.488 7.118 3.14 11.874h-6.553m-4.333-8.444c-1.985-1.89-4.334-2.938-6.347-2.273-3.219 1.063-4.522 6.156-3.738 10.717h14.418m-4.333-8.444c1.666 1.586 3.076 3.764 3.82 6.019.28.854.448 1.664.513 2.425",
              stroke: "#5463D6",
              strokeWidth: 1.863,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M41.7 29.869c0 5.904-5.62 10.69-12.554 10.69s-12.554-4.786-12.554-10.69H41.7Z",
              fill: "#5463D6",
              fillOpacity: 0.2,
              stroke: "#5463D6",
              strokeWidth: 1.863,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M17.729 33.108h4.922M32.717 34.148h7.556M28.622 36.88h-4.034",
              stroke: "#5463D6",
              strokeWidth: 1.746,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 29.503,
            cy: 29.238,
            r: 28.071,
            stroke: "#BEC7FF",
            strokeWidth: 1.863
          }
        ),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "a", children: /* @__PURE__ */ C(
          "path",
          {
            fill: "#fff",
            transform: "translate(15.748 16.093)",
            d: "M0 0h26.974v26.974H0z"
          }
        ) }) })
      ]
    }
  );
}, OG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      fill: "none",
      viewBox: "0 0 36 36",
      "data-testid": "nest icon",
      ...r,
      children: [
        /* @__PURE__ */ K(
          "g",
          {
            stroke: a,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2.6,
            clipPath: "url(#a)",
            children: [
              /* @__PURE__ */ C("path", { d: "M13.55 18.014h8.259m-4.681-9.12c2.458-2.873 5.729-4.672 8.366-3.706 3.706 1.357 4.849 7.69 3.393 12.826h-7.078m-4.681-9.12c-2.145-2.042-4.681-3.175-6.856-2.456-3.477 1.148-4.885 6.65-4.038 11.576H21.81m-4.681-9.12c1.8 1.712 3.323 4.065 4.125 6.5.305.923.485 1.798.556 2.62" }),
              /* @__PURE__ */ C("path", { d: "M31.091 17.983c0 6.378-6.071 11.549-13.56 11.549-7.49 0-13.561-5.17-13.561-11.549H31.09ZM5.199 21.483h5.317M21.39 22.606h8.162M16.967 25.557h-4.359" })
            ]
          }
        ),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "a", children: /* @__PURE__ */ C("path", { fill: "#fff", d: "M.128.172h35v35h-35z" }) }) })
      ]
    }
  );
}, xG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "notification icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ K("mask", { id: s, children: [
          /* @__PURE__ */ C("rect", { fill: "#000", width: "100%", height: "100%" }),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M14.0055 11.9317V12.6135H1.73279V11.9317L3.09642 10.5681V6.47718C3.09642 4.36354 4.48051 2.50218 6.50551 1.90218V1.70446C6.50551 1.3428 6.64918 0.995951 6.90491 0.74022C7.16064 0.484489 7.50749 0.34082 7.86915 0.34082C8.23081 0.34082 8.57765 0.484489 8.83338 0.74022C9.08911 0.995951 9.23278 1.3428 9.23278 1.70446V1.90218C11.2578 2.50218 12.6419 4.36354 12.6419 6.47718V10.5681L14.0055 11.9317ZM9.23278 13.2954C9.23278 13.657 9.08911 14.0039 8.83338 14.2596C8.57765 14.5153 8.23081 14.659 7.86915 14.659C7.50749 14.659 7.16064 14.5153 6.90491 14.2596C6.64918 14.0039 6.50551 13.657 6.50551 13.2954M13.1532 1.15218L12.1851 2.12036C12.7617 2.68997 13.2196 3.36838 13.5321 4.11627C13.8446 4.86415 14.0055 5.66663 14.0055 6.47718H15.3691C15.3691 4.47945 14.5782 2.55673 13.1532 1.15218M0.369154 6.47718H1.73279C1.73279 4.84082 2.38733 3.27264 3.55324 2.12036L2.58506 1.15218C1.88134 1.84871 1.32306 2.67814 0.942659 3.59228C0.562255 4.50642 0.36731 5.48705 0.369154 6.47718V6.47718Z",
              fill: "#fff"
            }
          )
        ] }) }),
        /* @__PURE__ */ C("rect", { width: 16, height: 16, rx: 8, fill: a, mask: `url(#${s})` })
      ]
    }
  );
}, RG = ({ size: t, className: e, ...n }) => {
  const { width: r, height: i } = Te(t);
  return /* @__PURE__ */ C(
    "svg",
    {
      width: r,
      height: i,
      "data-testid": "book icon",
      "aria-hidden": !0,
      className: j(de, e),
      viewBox: "0 0 35 31",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.873 29.9357C15.4014 29.6448 14.9125 29.3828 14.409 29.1514C13.151 28.5696 11.4724 28.0221 9.65832 28.0221C7.46319 28.0221 5.47402 28.8253 4.20053 29.5015C3.79861 29.712 3.35061 29.819 2.89696 29.8131C2.44331 29.8071 1.9983 29.6882 1.60208 29.4672C1.18595 29.2428 0.837903 28.9106 0.594496 28.5053C0.351088 28.1 0.221296 27.6367 0.21875 27.1639V5.71038C0.21875 4.64457 0.725054 3.54271 1.75997 2.91455C3.08838 2.1079 6.07815 0.561523 9.65832 0.561523C12.3718 0.561523 15.056 1.43683 17.3816 2.80986C19.7072 1.43683 22.3914 0.561523 25.1049 0.561523C28.6851 0.561523 31.6748 2.10618 33.0032 2.91455C34.0382 3.54271 34.5445 4.64457 34.5445 5.71038V27.1639C34.5445 28.2504 33.894 29.0622 33.1611 29.4672C32.7647 29.6885 32.3194 29.8075 31.8654 29.8135C31.4114 29.8195 30.9631 29.7123 30.561 29.5015C29.2892 28.8253 27.3 28.0221 25.1049 28.0221C23.2908 28.0221 21.6122 28.5713 20.3542 29.1514C19.8507 29.3828 19.3618 29.6448 18.8902 29.9357C18.4028 30.2395 17.9909 30.5965 17.3833 30.5965C16.7723 30.5965 16.3621 30.2395 15.873 29.9357ZM3.65132 25.9522V5.78246C4.80638 5.09595 7.08389 3.99409 9.65832 3.99409C11.7694 3.99409 13.8598 4.7115 15.6653 5.78246V25.9522C14.1464 25.2726 12.0388 24.5895 9.65832 24.5895C7.28813 24.5895 5.18053 25.2675 3.65132 25.9522ZM19.0979 25.9522C20.6168 25.2726 22.7244 24.5895 25.1049 24.5895C27.4751 24.5895 29.5827 25.2675 31.1119 25.9522V5.78246C29.9568 5.09595 27.6793 3.99409 25.1049 3.99409C22.9939 3.99409 20.9034 4.7115 19.0979 5.78246V25.9522Z",
          fill: "#717fe3"
        }
      )
    }
  );
}, NG = ({
  className: t,
  ...e
}) => /* @__PURE__ */ K(
  "svg",
  {
    "aria-hidden": !0,
    width: 92,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: j(de, t),
    ...e,
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M32.906 9.75a11.008 11.008 0 0 0-10.968 10.969c0 1.95.553 3.76 1.447 5.333-4.39 2.57-7.826 6.216-9.674 10.51h-.305a1.192 1.192 0 0 1-1.219-1.218c0-.43.22-.77.534-.99l-2.82-3.96a6.033 6.033 0 0 0-2.588 4.95c0 2.998 2.237 5.455 5.104 5.942-.125.853-.23 1.704-.23 2.589 0 6.074 3.228 11.34 7.922 15.234-.59 2.438-.295 5.036 1.6 6.933a7.466 7.466 0 0 0 10.512 0l.914-.914c1.904.35 3.818.684 5.865.684s3.96-.333 5.865-.684l.914.914a7.466 7.466 0 0 0 10.513 0c1.855-1.858 2.132-4.38 1.599-6.782a22.444 22.444 0 0 0 4.95-5.635h5.409v-19.5h-5.56a21.834 21.834 0 0 0-3.125-3.96l1.373-7.543V19.5H58.5s-5.855.098-10.818 3.81a38.048 38.048 0 0 0-3.96-.917 9.466 9.466 0 0 0 .153-1.674c0-6.028-4.94-10.969-10.969-10.969Zm0 4.875A6.065 6.065 0 0 1 39 20.719c0 .419-.076.819-.154 1.218-3.931.02-7.644.78-11.041 2.058a5.898 5.898 0 0 1-.992-3.276 6.065 6.065 0 0 1 6.093-6.094Zm22.547 10.208c.04-.01.04.008.076 0l-.914 5.558-.227 1.297 1.065.914a16.957 16.957 0 0 1 3.961 5.028L60.1 39h3.276v9.75h-3.276l-.685 1.372c-1.19 2.35-3.066 4.417-5.484 6.167l-1.753 1.297 1.068 1.982c.58.98.475 2.189-.383 3.047a2.48 2.48 0 0 1-3.578 0l-1.753-1.756-.99-.911-1.296.305c-1.98.455-4.083.684-6.245.684a27.91 27.91 0 0 1-6.247-.684l-1.292-.305-.992.914-1.753 1.75a2.478 2.478 0 0 1-3.58 0 2.45 2.45 0 0 1-.38-3.047l1.067-1.98-1.753-1.293c-4.41-3.203-7.008-7.571-7.008-12.417 0-9.121 9.531-17.063 21.938-17.063 2.998 0 5.855.449 8.456 1.295l1.294.458 1.068-.914c1.74-1.553 3.892-2.389 5.635-2.818ZM53.625 39a2.445 2.445 0 0 0-2.438 2.438 2.445 2.445 0 0 0 2.438 2.437 2.445 2.445 0 0 0 2.438-2.438A2.445 2.445 0 0 0 53.624 39Z",
          fill: "#55CBB7"
        }
      ),
      /* @__PURE__ */ C("circle", { cx: 78, cy: 14, r: 14, fill: "#5261AC" }),
      /* @__PURE__ */ C(
        "path",
        {
          d: "m84.23 9.52-8.266 8.576-3.745-3.074",
          stroke: "#fff",
          strokeWidth: 3.36,
          strokeLinecap: "round"
        }
      )
    ]
  }
), MG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      width: i,
      height: o,
      fill: "none",
      viewBox: "0 0 59 58",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      className: j(de, n),
      children: [
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 29,
            cy: 29.5,
            r: 28.094,
            stroke: "#EFEFEF",
            strokeWidth: 1.813
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M26.168 15.906a5.116 5.116 0 0 0-5.098 5.098 5 5 0 0 0 .673 2.479c-2.04 1.194-3.637 2.888-4.496 4.884h-.142a.553.553 0 0 1-.566-.566c0-.2.102-.358.248-.46l-1.31-1.841a2.804 2.804 0 0 0-1.204 2.3c0 1.394 1.04 2.536 2.372 2.763a8.283 8.283 0 0 0-.106 1.203c0 2.823 1.5 5.27 3.682 7.08-.274 1.133-.137 2.34.743 3.221a3.47 3.47 0 0 0 4.886 0l.424-.424c.885.163 1.774.318 2.726.318s1.84-.155 2.726-.318l.424.424a3.47 3.47 0 0 0 4.886 0c.862-.863.991-2.035.743-3.151a10.428 10.428 0 0 0 2.301-2.62h2.514v-9.062H40.01a10.143 10.143 0 0 0-1.453-1.84l.638-3.505v-1.451h-1.133s-2.72.045-5.027 1.77a17.69 17.69 0 0 0-1.84-.426 4.4 4.4 0 0 0 .07-.778c0-2.802-2.296-5.098-5.097-5.098Zm0 2.266A2.819 2.819 0 0 1 29 21.004c0 .195-.035.38-.071.566-1.828.01-3.553.363-5.132.956-.3-.45-.461-.98-.461-1.522a2.819 2.819 0 0 1 2.832-2.832Zm10.479 4.744c.018-.004.018.003.035 0l-.425 2.583-.106.603.495.424a7.88 7.88 0 0 1 1.841 2.337l.319.637h1.522v4.531h-1.522l-.319.638c-.553 1.092-1.425 2.053-2.549 2.866l-.814.603.496.92c.27.456.221 1.018-.178 1.417a1.153 1.153 0 0 1-1.663 0l-.814-.816-.46-.424-.603.142c-.92.212-1.897.318-2.902.318-.977.004-1.95-.103-2.903-.318l-.6-.142-.462.425-.814.814a1.155 1.155 0 0 1-1.664 0 1.139 1.139 0 0 1-.177-1.416l.496-.92-.815-.602c-2.049-1.488-3.256-3.518-3.256-5.77 0-4.24 4.429-7.93 10.195-7.93 1.393 0 2.721.208 3.93.602l.601.212.496-.424c.81-.722 1.81-1.11 2.62-1.31Zm-.85 6.584c-.623 0-1.133.51-1.133 1.133s.51 1.133 1.133 1.133 1.133-.51 1.133-1.133-.51-1.133-1.133-1.133Z",
            fill: a
          }
        )
      ]
    }
  );
}, PG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "piggy bank outline icon",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M6.75 2A2.258 2.258 0 0 0 4.5 4.25c0 .4.114.771.297 1.094-.9.527-1.605 1.275-1.984 2.156H2.75a.244.244 0 0 1-.25-.25c0-.088.045-.158.11-.203l-.579-.813A1.238 1.238 0 0 0 1.5 7.25c0 .615.459 1.119 1.047 1.219-.026.175-.047.35-.047.531 0 1.246.662 2.326 1.625 3.125-.121.5-.06 1.033.328 1.422a1.531 1.531 0 0 0 2.156 0l.188-.188c.39.072.783.141 1.203.141.42 0 .813-.069 1.203-.14l.188.187a1.531 1.531 0 0 0 2.156 0c.38-.381.438-.899.328-1.391A4.603 4.603 0 0 0 12.89 11H14V7h-1.14a4.478 4.478 0 0 0-.641-.813l.281-1.546V4H12s-1.201.02-2.219.782a7.805 7.805 0 0 0-.813-.189c.02-.11.032-.226.032-.343A2.258 2.258 0 0 0 6.75 2Zm0 1C7.445 3 8 3.555 8 4.25c0 .086-.016.168-.032.25a6.514 6.514 0 0 0-2.264.422A1.244 1.244 0 0 1 6.75 3Zm4.625 2.094c.008-.002.008.002.015 0l-.187 1.14-.046.266.218.188c.334.289.61.639.813 1.031l.14.281H13v2h-.672l-.14.281c-.245.482-.63.906-1.126 1.265l-.359.267.219.406a.503.503 0 0 1-.079.625.508.508 0 0 1-.733 0l-.36-.36-.203-.187-.266.063c-.406.093-.838.14-1.281.14a5.725 5.725 0 0 1-1.282-.14l-.264-.063-.204.188-.36.359a.509.509 0 0 1-.734 0 .503.503 0 0 1-.078-.625l.219-.406-.36-.266C4.034 10.89 3.5 9.994 3.5 9c0-1.871 1.955-3.5 4.5-3.5.615 0 1.201.092 1.735.266l.265.093.219-.187c.357-.318.799-.49 1.156-.578ZM11 8c-.275 0-.5.225-.5.5s.225.5.5.5.5-.225.5-.5-.225-.5-.5-.5Z",
          fill: a
        }
      )
    }
  );
}, DG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 39 49",
      fill: "none",
      "data-testid": "pin home icon",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M37.1262 19.1851C37.1262 21.6051 36.2748 24.5785 34.8585 27.7341C33.45 30.8723 31.5193 34.111 29.4459 37.0372C27.3714 39.9647 25.1736 42.552 23.2443 44.3953C22.2781 45.3184 21.3996 46.0354 20.6544 46.5148C19.8727 47.0177 19.3722 47.1704 19.1279 47.1704C18.8837 47.1704 18.3832 47.0177 17.6015 46.5148C16.8563 46.0354 15.9777 45.3184 15.0115 44.3953C13.0823 42.552 10.8845 39.9647 8.81001 37.0372C6.73653 34.111 4.80582 30.8723 3.39735 27.7341C1.9811 24.5785 1.12964 21.6051 1.12964 19.1851C1.12964 9.23711 9.1884 1.17383 19.1279 1.17383C29.0675 1.17383 37.1262 9.23711 37.1262 19.1851Z",
            fill: a,
            stroke: `url(#${s})`,
            strokeWidth: "2.00343"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M16.8107 25.7783H14.9034C14.3767 25.7783 13.9497 25.3511 13.9497 24.824V20.0525",
            stroke: "white",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M12.0425 19.0984L17.6252 14.3714C17.9808 14.0702 18.5017 14.0702 18.8573 14.3714L23.4851 18.2897",
            stroke: "white",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M21.5791 14.3267H23.4864V16.2353",
            stroke: "white",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M21.509 24.9355C21.5772 25.0037 21.5976 25.1064 21.5608 25.1956C21.5239 25.2847 21.4369 25.3429 21.3405 25.3429C21.244 25.3429 21.1571 25.2847 21.1202 25.1956C21.0833 25.1064 21.1037 25.0037 21.172 24.9355C21.2166 24.8907 21.2772 24.8655 21.3405 24.8655C21.4037 24.8655 21.4643 24.8907 21.509 24.9355",
            stroke: "white",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M23.7002 24.1657L26.0442 21.82C26.448 21.416 26.448 20.7608 26.0442 20.3568C25.6404 19.9527 24.9858 19.9527 24.582 20.3568L22.2398 22.7025C21.1019 22.2566 19.8075 22.6702 19.1385 23.6935C18.4695 24.7168 18.6093 26.0694 19.4734 26.9341C20.3374 27.7987 21.6891 27.9386 22.7117 27.2691C23.7343 26.5997 24.1477 25.3044 23.7021 24.1657H23.7002Z",
            stroke: "white",
            strokeWidth: "1.52729",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ K(
          "radialGradient",
          {
            id: s,
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(19.1279 19.1851) rotate(90) scale(19.013 19)",
            children: [
              /* @__PURE__ */ C("stop", { offset: "0.838542", stopColor: "white" }),
              /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#ECEFFF" })
            ]
          }
        ) })
      ]
    }
  );
}, LG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 39 49",
      fill: "none",
      "data-testid": "pin wedding icon",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            fill: a,
            stroke: `url(#${s})`,
            strokeWidth: 2.016,
            d: "M37.12 19.185c0 2.419-.851 5.391-2.267 8.546-1.409 3.138-3.34 6.377-5.412 9.302-2.075 2.928-4.272 5.515-6.201 7.358-.966.923-1.844 1.64-2.59 2.118-.78.503-1.28.655-1.522.655s-.742-.152-1.523-.655c-.745-.479-1.623-1.195-2.589-2.118-1.929-1.843-4.126-4.43-6.2-7.358-2.074-2.925-4.004-6.164-5.413-9.302-1.416-3.155-2.267-6.127-2.267-8.546 0-9.944 8.056-18.005 17.992-18.005 9.936 0 17.992 8.06 17.992 18.005Z"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fill: "#fff",
            d: "m18.863 17.668-2.497-3.5.999-1.499h2.997l1 1.5-2.499 3.5Zm2.186-2-.75 1.063a3.685 3.685 0 0 1 2.311 3.437 3.75 3.75 0 0 1-3.747 3.749 3.745 3.745 0 0 1-3.746-3.75c0-1.562.936-2.874 2.31-3.436l-.75-1.062a4.94 4.94 0 0 0-2.81 4.499 5 5 0 0 0 4.996 4.999 4.994 4.994 0 0 0 4.996-5c0-1.999-1.124-3.686-2.81-4.498Z"
          }
        ),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ K(
          "radialGradient",
          {
            id: s,
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(0 19.013 -19 0 19.128 19.185)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ C("stop", { offset: 0.839, stopColor: "#fff" }),
              /* @__PURE__ */ C("stop", { offset: 1, stopColor: "#ECEFFF" })
            ]
          }
        ) })
      ]
    }
  );
}, FG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 39 49",
      fill: "none",
      "data-testid": "pin child education icon",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            fill: a,
            stroke: `url(#${s})`,
            strokeWidth: 2.016,
            d: "M37.12 19.185c0 2.419-.851 5.391-2.267 8.546-1.409 3.138-3.34 6.377-5.412 9.302-2.075 2.928-4.272 5.515-6.201 7.358-.966.923-1.844 1.64-2.59 2.118-.78.503-1.28.655-1.522.655s-.742-.152-1.523-.655c-.745-.479-1.623-1.195-2.589-2.118-1.929-1.843-4.126-4.43-6.2-7.358-2.074-2.925-4.004-6.164-5.413-9.302-1.416-3.155-2.267-6.127-2.267-8.546 0-9.944 8.056-18.005 17.992-18.005 9.936 0 17.992 8.06 17.992 18.005Z"
          }
        ),
        /* @__PURE__ */ C("g", { clipPath: "url(#b)", children: /* @__PURE__ */ C(
          "path",
          {
            fill: "#fff",
            d: "M20.53 12.906a2.448 2.448 0 0 0-2.098 0l-6.087 2.886a.625.625 0 0 0-.357.597v3.783a.625.625 0 0 0 1.249 0v-2.808l1.249.62v3.437a.627.627 0 0 0 .183.442l.032.03.075.069c.391.349.814.66 1.264.931.834.502 2.039 1.027 3.442 1.027 1.402 0 2.607-.525 3.443-1.027a8.42 8.42 0 0 0 1.264-.931l.075-.069.028-.03h.003a.625.625 0 0 0 .182-.443v-3.437l2.15-1.067a.625.625 0 0 0-.01-1.125l-6.086-2.886v.001Zm.04 7.018 2.658-1.32v2.54a7.17 7.17 0 0 1-.945.678c-.725.435-1.706.849-2.801.849-1.096 0-2.076-.413-2.802-.849a7.17 7.17 0 0 1-.945-.679v-2.54l2.657 1.32c.687.34 1.492.34 2.179 0Zm-.574-5.888 4.923 2.333-4.904 2.435a1.201 1.201 0 0 1-1.067 0l-4.904-2.435 4.923-2.333a1.202 1.202 0 0 1 1.03 0Zm-5.324 7.83-.001-.002.001.002Z"
          }
        ) }),
        /* @__PURE__ */ K("defs", { children: [
          /* @__PURE__ */ K(
            "radialGradient",
            {
              id: s,
              cx: 0,
              cy: 0,
              r: 1,
              gradientTransform: "matrix(0 19.013 -19 0 19.128 19.185)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ C("stop", { offset: 0.839, stopColor: "#fff" }),
                /* @__PURE__ */ C("stop", { offset: 1, stopColor: "#ECEFFF" })
              ]
            }
          ),
          /* @__PURE__ */ C("clipPath", { id: "b", children: /* @__PURE__ */ C("path", { fill: "#fff", d: "M11.987 10.17h14.987v14.998H11.987z" }) })
        ] })
      ]
    }
  );
}, UG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 39 49",
      fill: "none",
      "data-testid": "pin piggy bank icon",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            fill: a,
            stroke: `url(#${s})`,
            strokeWidth: 2.016,
            d: "M37.12 19.185c0 2.419-.851 5.391-2.267 8.546-1.409 3.138-3.34 6.377-5.412 9.302-2.075 2.928-4.272 5.515-6.201 7.358-.966.923-1.844 1.64-2.59 2.118-.78.503-1.28.655-1.522.655s-.742-.152-1.523-.655c-.745-.479-1.623-1.195-2.589-2.118-1.929-1.843-4.126-4.43-6.2-7.358-2.074-2.925-4.004-6.164-5.413-9.302-1.416-3.155-2.267-6.127-2.267-8.546 0-9.944 8.056-18.005 17.992-18.005 9.936 0 17.992 8.06 17.992 18.005Z"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 1.134,
            d: "M21.003 14.48c-2.063-.689-7.5.375-7.5 4.315 0 1.876.937 2.814 1.687 3.19 0 0-.562 1.313.563 1.876s2.062-.75 2.062-.75.657.187 1.313.187c.656 0 1.312-.188 1.312-.188s.563 1.314 1.875.75c.938-.562.563-1.688.563-1.688s1.125-.563 1.312-1.5c1.313 0 1.313-.376 1.313-.751v-2.064c0-.669 0-.938-1.125-.938-.188-.563-.75-1.126-.938-1.314 0-.938 0-1.313.188-2.251-1.125 0-2.625 1.125-2.625 1.125Zm-4.688.492c-.75-.375-.937-3.12 1.313-3.307 2.437 0 2.195 2.622 1.938 2.62-1.125.007-2.313.312-3.25.687Z"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            stroke: "#fff",
            strokeWidth: 1.134,
            d: "M13.69 17.857c-.687-.063-1.874-.563-1.124-1.689"
          }
        ),
        /* @__PURE__ */ C("circle", { cx: 22.69, cy: 18.232, r: 0.563, fill: "#fff" }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ K(
          "radialGradient",
          {
            id: s,
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(0 19.013 -19 0 19.128 19.185)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ C("stop", { offset: 0.839, stopColor: "#fff" }),
              /* @__PURE__ */ C("stop", { offset: 1, stopColor: "#ECEFFF" })
            ]
          }
        ) })
      ]
    }
  );
}, HG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn(), c = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 39 49",
      fill: "none",
      "data-testid": "pin retirement icon",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            fill: a,
            stroke: `url(#${s})`,
            strokeWidth: 2.016,
            d: "M37.12 19.185c0 2.419-.851 5.391-2.267 8.546-1.409 3.138-3.34 6.377-5.412 9.302-2.075 2.928-4.272 5.515-6.201 7.358-.966.923-1.844 1.64-2.59 2.118-.78.503-1.28.655-1.522.655s-.742-.152-1.523-.655c-.745-.479-1.623-1.195-2.589-2.118-1.929-1.843-4.126-4.43-6.2-7.358-2.074-2.925-4.004-6.164-5.413-9.302-1.416-3.155-2.267-6.127-2.267-8.546 0-9.944 8.056-18.005 17.992-18.005 9.936 0 17.992 8.06 17.992 18.005Z"
          }
        ),
        /* @__PURE__ */ K("g", { clipPath: `url(#${c})`, transform: "translate(10,12) scale(0.5)", children: [
          /* @__PURE__ */ C(
            "path",
            {
              d: "M13.5503 18.0137H21.8086M17.128 8.89341C19.5862 6.02105 22.8566 4.22163 25.4945 5.18778C29.1999 6.54489 30.3427 12.8772 28.8866 18.0137H21.8086M17.128 8.89341C14.9832 6.85172 12.4465 5.71908 10.2716 6.4377C6.79487 7.58643 5.3869 13.0876 6.23409 18.0137C7.04735 18.0137 18.8418 18.0137 21.8086 18.0137M17.128 8.89341C18.9273 10.6062 20.4507 12.9587 21.2535 15.3948C21.5575 16.3175 21.7383 17.1918 21.8086 18.0137",
              stroke: "white",
              strokeWidth: "2.6",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M31.0915 17.9834C31.0915 24.3615 25.02 29.5319 17.5306 29.5319C10.0411 29.5319 3.96973 24.3615 3.96973 17.9834H31.0915Z",
              stroke: "white",
              strokeWidth: "2.6",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M5.19873 21.4827H10.516",
              stroke: "white",
              strokeWidth: "2.6",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M21.3896 22.606H29.5516",
              stroke: "white",
              strokeWidth: "2.6",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M16.9666 25.5571H12.6084",
              stroke: "white",
              strokeWidth: "2.6",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }
          )
        ] }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: c, children: /* @__PURE__ */ C(
          "rect",
          {
            width: "35",
            height: "35",
            fill: "white",
            transform: "translate(0.12793 0.172119)"
          }
        ) }) }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ K(
          "radialGradient",
          {
            id: s,
            cx: 0,
            cy: 0,
            r: 1,
            gradientTransform: "matrix(0 19.013 -19 0 19.128 19.185)",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ C("stop", { offset: 0.839, stopColor: "#fff" }),
              /* @__PURE__ */ C("stop", { offset: 1, stopColor: "#ECEFFF" })
            ]
          }
        ) })
      ]
    }
  );
}, BG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("g", { clipPath: `url(#${s})`, children: /* @__PURE__ */ C(
          "path",
          {
            opacity: 1.1,
            d: "M6.328 9.651c0-.39.05-.743.15-1.058.114-.328.297-.63.549-.907a5.23 5.23 0 0 1 1.02-.87c.404-.277.713-.516.927-.718.214-.202.365-.397.453-.586a1.54 1.54 0 0 0 .133-.623.845.845 0 0 0-.416-.756c-.265-.19-.624-.284-1.077-.284-.504 0-1.021.082-1.55.246a9.447 9.447 0 0 0-1.645.699l-1.134-2.25a8.905 8.905 0 0 1 2.098-.887 8.515 8.515 0 0 1 2.457-.34c1.349 0 2.394.314 3.138.944.756.618 1.134 1.418 1.134 2.4 0 .505-.082.952-.246 1.343-.151.39-.39.756-.718 1.096-.315.327-.731.668-1.248 1.02a13.23 13.23 0 0 0-.869.643c-.202.176-.34.347-.416.51a1.44 1.44 0 0 0-.113.605v.51H6.328v-.737Zm-.34 3.931c0-.617.17-1.045.51-1.285.34-.252.762-.378 1.266-.378.466 0 .87.126 1.21.378.353.24.529.668.529 1.285 0 .58-.176 1.002-.53 1.267-.34.264-.743.397-1.209.397-.504 0-.926-.133-1.266-.397-.34-.265-.51-.687-.51-1.267Z",
            fill: a
          }
        ) }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: s, children: /* @__PURE__ */ C("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
      ]
    }
  );
}, jG = ({
  className: t,
  ...e
}) => /* @__PURE__ */ K(
  "svg",
  {
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: j(de, t),
    ...e,
    children: [
      /* @__PURE__ */ C(
        "circle",
        {
          cx: 12.25,
          cy: 11.75,
          r: 8.5,
          stroke: "#5261AC",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M10 8h3a2 2 0 0 1 2 2v.25A1.75 1.75 0 0 1 13.25 12a1.75 1.75 0 0 0-1.75 1.75v.5",
          stroke: "#5261AC",
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ C("circle", { cx: 11.5, cy: 16, r: 1, fill: "#5261AC" })
    ]
  }
), VG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M8 6.667 5.333 2.933l1.067-1.6h3.2l1.066 1.6L8 6.667Zm2.333-2.134-.8 1.134C11 6.267 12 7.667 12 9.333a4 4 0 1 1-8 0c0-1.666 1-3.066 2.466-3.666l-.8-1.134a5.27 5.27 0 0 0-3 4.8 5.333 5.333 0 1 0 10.667 0 5.27 5.27 0 0 0-3-4.8Z",
          fill: a
        }
      )
    }
  );
}, $G = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      width: i,
      height: o,
      "aria-hidden": !0,
      className: j(de, n),
      viewBox: "0 0 59 59",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: 29.676, cy: 29.406, r: 24.672, fill: a }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M35.427 36.646V27.78a5.7 5.7 0 0 0-5.703-5.702 5.7 5.7 0 0 0-5.703 5.702v8.862h-3.183v3.204H36.12",
            fill: "#5463D6",
            fillOpacity: 0.2
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M35.427 36.646V27.78a5.7 5.7 0 0 0-5.703-5.702 5.7 5.7 0 0 0-5.703 5.702v8.862h-3.183v3.204H36.12",
            stroke: "#5463D6",
            strokeWidth: 1.863,
            strokeMiterlimit: 10
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M27.25 27.786a2.477 2.477 0 0 1 2.478-2.478M29.729 14.99v3.2M16.934 27.787h3.2M39.328 27.787h3.2M36.52 20.99l2.262-2.258M22.934 20.99l-2.262-2.258M38.588 40.575v-3.913h-14.56",
            stroke: "#5463D6",
            strokeWidth: 1.863,
            strokeMiterlimit: 10
          }
        ),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 29.497,
            cy: 29.238,
            r: 28.071,
            stroke: "#BEC7FF",
            strokeWidth: 1.863
          }
        )
      ]
    }
  );
}, qG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e), s = bn();
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 36 36",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "siren icon",
      fill: "none",
      ...r,
      children: [
        /* @__PURE__ */ K("g", { clipPath: `url(#${s})`, children: [
          /* @__PURE__ */ C(
            "path",
            {
              fill: "#fff",
              d: "M24.581 28.45V17.67a6.932 6.932 0 0 0-6.934-6.934 6.932 6.932 0 0 0-6.934 6.934v10.775h-3.87v3.081h18.581"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              stroke: a,
              strokeLinecap: "round",
              strokeMiterlimit: 10,
              strokeWidth: 2.6,
              d: "M24.581 28.45V17.67a6.932 6.932 0 0 0-6.934-6.934 6.932 6.932 0 0 0-6.934 6.934v10.775h-3.87v3.081h18.581"
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              stroke: a,
              strokeLinecap: "round",
              strokeMiterlimit: 10,
              strokeWidth: 2.6,
              d: "M14.639 17.676a3.012 3.012 0 0 1 3.013-3.013M17.652 3.453v2.554M3.41 17.676h2.575M29.324 17.676h2.523M25.909 9.413l1.927-1.95M9.39 9.413 7.42 7.1M28.423 31.526V28.47H10.718"
            }
          )
        ] }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: s, children: /* @__PURE__ */ C("path", { fill: "#fff", d: "M.128.172h35v35h-35z" }) }) })
      ]
    }
  );
}, zG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      "data-testid": "sprout icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M12.666 6a2 2 0 0 0-1.88 1.333H2a.667.667 0 1 0 0 1.334h8.786A2 2 0 1 0 12.666 6ZM2 4.667h.786a2 2 0 0 0 3.76 0H14a.667.667 0 1 0 0-1.334H6.546a2 2 0 0 0-3.76 0H2a.667.667 0 1 0 0 1.334Zm12 6.666H9.213a2 2 0 0 0-3.76 0H2a.667.667 0 1 0 0 1.334h3.453a2 2 0 0 0 3.76 0H14a.666.666 0 1 0 0-1.334Z",
          fill: a
        }
      )
    }
  );
}, KG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      "data-testid": "sprout icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 10 10",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("g", { clipPath: "url(#clip0_7520_184038)", children: /* @__PURE__ */ C(
          "path",
          {
            d: "M1.44238 2.33135H0.317383C0.317383 4.50752 2.08047 6.26885 4.25488 6.26885V8.51885C4.25488 8.84404 4.50801 9.09717 4.80156 9.09717C5.09512 9.09717 5.37988 8.84404 5.37988 8.53467V6.28467C5.37988 4.11025 3.6168 2.33135 1.44238 2.33135ZM8.19238 1.22217C6.71143 1.22217 5.42559 2.03955 4.75059 3.24893C5.23838 3.77838 5.59873 4.42455 5.7877 5.13857C7.77051 4.93291 9.31738 3.25947 9.31738 1.22217H8.19238Z",
            fill: a
          }
        ) }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_7520_184038", children: /* @__PURE__ */ C(
          "rect",
          {
            width: "9",
            height: "9",
            fill: "white",
            transform: "translate(0.317383 0.659668)"
          }
        ) }) })
      ]
    }
  );
}, WG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      width: i,
      height: o,
      viewBox: "0 0 59 59",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": !0,
      className: j(de, n),
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: 29.688, cy: 29.406, r: 24.672, fill: a }),
        /* @__PURE__ */ K("g", { clipPath: "url(#a)", children: [
          /* @__PURE__ */ C(
            "path",
            {
              d: "M28.997 34.537C17.827 36.263 16.86 24.312 16.86 24.312c7.652-1.182 11.624 3.382 12.267 7.426",
              fill: "#5463D6",
              fillOpacity: 0.2
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M28.997 34.537C17.827 36.263 16.86 24.312 16.86 24.312c7.652-1.182 11.624 3.382 12.267 7.426",
              stroke: "#5463D6",
              strokeWidth: 1.863
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M29.144 40.484V29.278S27.967 17.63 41.254 17.63c0 0 1.328 13.063-11.808 13.063",
              fill: "#5463D6",
              fillOpacity: 0.2
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M29.144 40.484V29.278S27.967 17.63 41.254 17.63c0 0 1.328 13.063-11.808 13.063",
              stroke: "#5463D6",
              strokeWidth: 1.863
            }
          ),
          /* @__PURE__ */ C(
            "path",
            {
              d: "M40.825 18.055 29.666 30.367M16.861 24.312l12.16 9.452",
              stroke: "#5463D6",
              strokeWidth: 1.751
            }
          )
        ] }),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 29.509,
            cy: 29.238,
            r: 28.071,
            stroke: "#BEC7FF",
            strokeWidth: 1.863
          }
        ),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "a", children: /* @__PURE__ */ C(
          "path",
          {
            fill: "#fff",
            transform: "translate(15.734 15.939)",
            d: "M0 0h27.06v27.06H0z"
          }
        ) }) })
      ]
    }
  );
}, GG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      "data-testid": "sprout icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M7.842 10.997C1.237 12.017.667 4.951.667 4.951c4.524-.699 6.873 2 7.252 4.39",
            stroke: a,
            strokeWidth: 0.75
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M7.929 14.513V7.887S7.233 1 15.089 1c0 0 .786 7.724-6.982 7.724M14.835 1.251l-6.598 7.28M.667 4.951l7.19 5.589",
            stroke: a,
            strokeWidth: 0.75
          }
        )
      ]
    }
  );
}, YG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-label": r["aria-label"] ?? "survey icon",
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "M11.333 1.333v1.334h2.005c.365 0 .662.296.662.662v10.675a.663.663 0 0 1-.662.662H2.662A.663.663 0 0 1 2 14.004V3.33c0-.366.297-.662.662-.662h2.005V1.333h6.666ZM4.667 4H3.333v9.333h9.334V4h-1.334v1.333H4.667V4ZM6 10.666V12H4.667v-1.334H6Zm0-2V10H4.667V8.667H6Zm0-2V8H4.667V6.667H6Zm4-4H6V4h4V2.667Z",
          fill: a
        }
      )
    }
  );
}, QG = ({ size: t, variant: e, className: n, ...r }) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: /* @__PURE__ */ C(
        "path",
        {
          d: "m6.666 10.333-.661.75a1 1 0 0 0 1.369-.043l-.708-.707Zm6.04-4.626a1 1 0 0 0-1.413-1.414l1.414 1.414ZM4.81 7.361a1 1 0 0 0-1.324 1.5l1.324-1.5Zm2.564 3.68 5.333-5.334-1.414-1.414-5.334 5.333 1.415 1.414Zm-.046-1.457L4.81 7.36l-1.324 1.5 2.519 2.222 1.323-1.5Z",
          fill: a
        }
      )
    }
  );
}, JG = ({
  className: t,
  ...e
}) => /* @__PURE__ */ C(Nc, { variant: "floating", children: /* @__PURE__ */ C(
  "svg",
  {
    "aria-label": e["aria-label"] ?? "ticked box icon",
    width: 49,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: j(de, t),
    ...e,
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "m20.009 31-1.985 2.25a3 3 0 0 0 4.106-.129L20.009 31ZM38.13 17.121a3 3 0 1 0-4.243-4.242l4.243 4.242Zm-23.692 4.963a3 3 0 0 0-3.97 4.499l3.97-4.5ZM22.13 33.12l16-16-4.243-4.242-16 16 4.243 4.242Zm-.136-4.37-7.556-6.667-3.97 4.499 7.556 6.666 3.97-4.499Z",
        fill: "#5261AC"
      }
    )
  }
) }), ZG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      viewBox: "0 0 59 59",
      width: i,
      height: o,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C("circle", { cx: 29.666, cy: 29.406, r: 24.672, fill: a }),
        /* @__PURE__ */ K(
          "g",
          {
            clipPath: "url(#a)",
            stroke: "#5463D6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
              /* @__PURE__ */ C(
                "path",
                {
                  d: "M30.66 29.606v8.643a2.822 2.822 0 0 1-2.815 2.814 2.822 2.822 0 0 1-2.814-2.814",
                  strokeWidth: 2.328
                }
              ),
              /* @__PURE__ */ C(
                "path",
                {
                  d: "M19.858 29.591c2.176 0 4.079.959 5.149 2.394 1.07-1.435 2.973-2.394 5.15-2.394 2.175 0 4.248.907 5.319 2.342 1.07-1.435 2.803-2.342 4.979-2.342a7.036 7.036 0 0 1 2.666.52c-.494-6.48-6.102-11.593-12.965-11.593-6.864 0-12.474 5.116-12.965 11.598a7.023 7.023 0 0 1 2.667-.525Z",
                  fill: "#5463D6",
                  fillOpacity: 0.2,
                  strokeWidth: 1.863
                }
              ),
              /* @__PURE__ */ C(
                "path",
                {
                  d: "M30.091 16.753v1.553a.478.478 0 0 1-.154.35c-.849.796-4.93 5.056-4.93 13.328M30.373 18.518s5.102 4.014 5.102 13.247",
                  strokeWidth: 2.328
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ C(
          "circle",
          {
            cx: 29.487,
            cy: 29.238,
            r: 28.071,
            stroke: "#BEC7FF",
            strokeWidth: 1.863
          }
        ),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "a", children: /* @__PURE__ */ C(
          "path",
          {
            fill: "#fff",
            transform: "translate(15.393 14.955)",
            d: "M0 0h28.784v28.784H0z"
          }
        ) }) })
      ]
    }
  );
}, XG = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t), a = Ue(e);
  return /* @__PURE__ */ K(
    "svg",
    {
      "aria-hidden": !0,
      className: j(de, n),
      width: i,
      height: o,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-testid": "umbrella icon",
      strokeWidth: 0.75,
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M8.486 8.144v4.804a1.569 1.569 0 0 1-1.564 1.564 1.569 1.569 0 0 1-1.565-1.564",
            stroke: a,
            fill: "none",
            strokeWidth: "inherit",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M2.482 8.136c1.21 0 2.268.533 2.862 1.33.595-.797 1.653-1.33 2.863-1.33s2.362.504 2.957 1.301c.595-.797 1.558-1.3 2.767-1.3.508-.002 1.012.096 1.482.288-.274-3.602-3.392-6.445-7.206-6.445C4.39 1.98 1.273 4.824 1 8.428c.47-.193.974-.292 1.482-.292Z",
            stroke: a,
            strokeWidth: "inherit",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M8.17 1v.863a.265.265 0 0 1-.085.194c-.472.443-2.74 2.81-2.74 7.41M8.327 1.98s2.836 2.232 2.836 7.364",
            stroke: a,
            strokeWidth: "inherit",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
}, eY = ({ size: t, className: e, ...n }) => {
  const { width: r, height: i } = Te(t);
  return /* @__PURE__ */ C(
    "svg",
    {
      "aria-label": "video icon",
      className: j(de, e),
      width: r,
      height: i,
      viewBox: "0 0 34 31",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...n,
      children: /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M30.4342 0.350586C31.2746 0.35032 32.0839 0.667689 32.7001 1.23907C33.3163 1.81046 33.6937 2.59362 33.7567 3.43158L33.765 3.68139V26.997C33.7653 27.8373 33.4479 28.6467 32.8766 29.2628C32.3052 29.879 31.522 30.2564 30.684 30.3195L30.4342 30.3278H3.78783C2.94751 30.3281 2.13814 30.0107 1.52197 29.4393C0.905808 28.8679 0.528383 28.0848 0.465359 27.2468L0.457031 26.997V3.68139C0.456765 2.84106 0.774134 2.0317 1.34552 1.41553C1.9169 0.799363 2.70007 0.421937 3.53802 0.358913L3.78783 0.350586H30.4342ZM30.4342 3.68139H3.78783V26.997H30.4342V3.68139ZM14.3465 8.07471L15.2091 8.45776L15.7721 8.72422L16.4166 9.04065L17.1327 9.4037L17.9154 9.82005L18.7598 10.2864L19.2028 10.5395L20.0655 11.0475L20.8549 11.5337L21.571 11.9884L22.2038 12.4097L23.0032 12.9593L23.6094 13.3973L23.7676 13.5139C24.0247 13.7052 24.2334 13.9538 24.3772 14.2401C24.521 14.5264 24.5959 14.8423 24.5959 15.1627C24.5959 15.483 24.521 15.7989 24.3772 16.0852C24.2334 16.3715 24.0247 16.6202 23.7676 16.8114L23.2297 17.2028L22.4969 17.7157L21.9041 18.1137L21.2296 18.5517L20.4751 19.0231L19.6441 19.5227L18.7548 20.0373L17.9071 20.5069L17.1227 20.9233L16.4066 21.2897L15.7637 21.6028L14.7278 22.0824L14.3448 22.2489C14.0507 22.3757 13.7311 22.4319 13.4115 22.4132C13.0918 22.3945 12.7809 22.3013 12.5036 22.1412C12.2264 21.981 11.9903 21.7583 11.8144 21.4907C11.6385 21.2232 11.5275 20.9182 11.4903 20.6002L11.3937 19.6592L11.3404 19.0364L11.2705 17.9306L11.2322 17.0845L11.2072 16.1602C11.2042 15.997 11.202 15.8338 11.2005 15.6706L11.1972 15.1627C11.1972 14.8179 11.2005 14.4848 11.2072 14.1634L11.2322 13.2391L11.2705 12.3948L11.3154 11.6337L11.3654 10.9658L11.4903 9.72679C11.5273 9.40839 11.6381 9.10304 11.814 8.8351C11.99 8.56716 12.2261 8.34404 12.5035 8.18355C12.781 8.02306 13.0921 7.92964 13.4121 7.91074C13.7321 7.89184 14.052 7.948 14.3465 8.07471ZM15.364 12.2399L14.6379 11.8768L14.5896 12.6879L14.553 13.6055L14.5313 14.6214L14.528 15.1627L14.5313 15.7039L14.553 16.7181L14.5696 17.1894L14.6129 18.0555L14.6379 18.4468L15.3607 18.0838L16.1717 17.6574L17.0627 17.1678L17.5357 16.898L18.4533 16.3551L19.2761 15.8455L20.0022 15.3792L20.3286 15.1627L19.6508 14.713L18.8747 14.2234C18.4331 13.95 17.9873 13.6835 17.5374 13.424L17.0661 13.1558L16.1767 12.6662L15.364 12.2399Z",
          fill: "#717fe3"
        }
      )
    }
  );
}, tY = ({
  name: t,
  getInitials: e = !1,
  namePosition: n = "none",
  showBorder: r = !0,
  size: i = "md",
  variant: o = "filled",
  colorType: a = "pink"
}) => {
  const { width: s, height: c } = Te(i ?? "lg"), l = e ? v8(t ?? "") : "", { avatarClasses: u, initialsClasses: d } = _8(
    a,
    i,
    o,
    r
  ), f = y8(n);
  return /* @__PURE__ */ K(
    "section",
    {
      className: `flex ${f} gap-4 items-center justify-center`,
      children: [
        /* @__PURE__ */ C(
          "div",
          {
            className: `rounded-full flex aspect-square items-center justify-center ${u}`,
            style: { width: s, height: c },
            children: o === "icon" ? /* @__PURE__ */ C(
              "div",
              {
                className: `w-full h-full flex items-center justify-center rounded-full ${u}`,
                children: /* @__PURE__ */ C(g8, { size: i })
              }
            ) : /* @__PURE__ */ C("div", { className: d, children: l })
          }
        ),
        n !== "none" && /* @__PURE__ */ C("p", { children: t })
      ]
    }
  );
}, v8 = (t) => t.match(/[A-Z]/g) || [], y8 = (t) => {
  switch (t) {
    case "top":
      return "flex-col-reverse";
    case "left":
      return "flex-row-reverse";
    case "right":
      return "flex-row";
    default:
      return "flex-col";
  }
}, w8 = (t) => {
  let e, n, r;
  switch (t) {
    case "gray":
      e = "bg-gray-500", n = "ring-gray-900", r = "text-gray-100";
      break;
    case "red":
      e = "bg-red-500", n = "ring-red-900", r = "text-red-100";
      break;
    case "blue":
      e = "bg-blue-500", n = "ring-blue-600", r = "text-blue-100";
      break;
    case "green":
      e = "bg-green-500", n = "ring-green-700", r = "text-green-100";
      break;
    case "yellow":
      e = "bg-yellow-300", n = "ring-yellow-500", r = "text-yellow-800";
      break;
    case "orange":
      e = "bg-orange-500", n = "ring-orange-700", r = "text-orange-900";
      break;
    case "purple":
      e = "bg-purple-500", n = "ring-purple-700", r = "text-purple-200";
      break;
    case "pink":
      e = "bg-pink-500", n = "ring-pink-700", r = "text-pink-200";
      break;
    case "irish-life":
      e = "bg-brand-primary", n = "ring-icon-icon-selected", r = "text-white";
      break;
    case "sandbox":
      e = "bg-brand-primary", n = "ring-icon-icon-selected", r = "text-white";
      break;
    default:
      e = "bg-transparent", n = "ring-transparent", r = "text-white";
  }
  return { backgroundColor: e, ringColor: n, textColor: r };
}, b8 = (t) => {
  let e, n;
  switch (t) {
    case "xsm":
      e = "ring-1", n = "text-[0.3rem]";
      break;
    case "sm":
      e = "ring-1", n = "text-[0.5rem]";
      break;
    case "md":
      e = "ring-2", n = "text-base";
      break;
    case "lg":
      e = "ring-2", n = "text-lg";
      break;
    case "xl":
      e = "ring-2", n = "text-xl";
      break;
    case "xxl":
      e = "ring-2", n = "text-3xl";
      break;
    case "xxxl":
      e = "ring-4", n = "text-4xl";
      break;
    default:
      e = "ring-2", n = "text-xs";
  }
  return { ringWidth: e, textSize: n };
}, _8 = (t, e, n, r) => {
  let { backgroundColor: i, ringColor: o, textColor: a } = w8(t), { ringWidth: s, textSize: c } = b8(e), l;
  switch (n) {
    case "icon":
      o = "ring-transparent", s = "ring-0", l = `${i} ${o} ${a}`;
      break;
    case "ghost":
      i = "bg-transparent", a = "text".concat(o.slice(o.indexOf("-"))), l = `${i} ${o}`;
      break;
    default:
      l = `${i} ${o}`;
  }
  l = `${l} ${r ? s : "ring-0"} ring-inset`;
  let u = `${a} ${c} font-semibold`;
  return { avatarClasses: l, initialsClasses: u };
}, nY = xu(
  ({ size: t, variant: e, className: n, children: r, iconRight: i, iconLeft: o, ...a }, s) => {
    const c = bn(), l = a.id ?? c, u = $_({
      size: t,
      variant: e,
      className: n,
      icons: !!(o || i)
    });
    return /* @__PURE__ */ K(
      "button",
      {
        ref: s,
        ...a,
        type: a.type ?? "button",
        id: l,
        className: u,
        children: [
          o,
          r,
          i
        ]
      }
    );
  }
), $_ = ({
  size: t = "md",
  variant: e,
  className: n,
  icons: r
}) => {
  const o = ((a) => {
    switch (a) {
      case "ghost":
        return "h-fit min-h-60 min-w-180 text-button-ghost-txt bg-button-ghost-background border border-button-ghost-border hover:text-button-ghost-txt-hover hover:bg-button-ghost-background-hover disabled:text-button-ghost-txt-disabled disabled:bg-button-ghost-background-disabled disabled:border-button-ghost-border-disabled font-semibold";
      case "primary":
        return "h-fit min-h-60 min-w-180 text-button-primary-txt bg-button-primary-background hover:text-button-primary-txt-hover hover:bg-button-primary-background-hover disabled:text-button-primary-txt-disabled disabled:bg-button-primary-background-disabled font-semibold";
      case "secondary":
        return "h-fit min-h-60 min-w-180 text-button-secondary-txt bg-button-secondary-background border-0 hover:text-button-secondary-txt-hover hover:bg-button-secondary-background-hover disabled:text-button-secondary-txt-disabled disabled:bg-button-secondary-background-disabled font-semibold";
      default:
        return "rounded-none px-0 text-left text-font-links hover:text-font-links-hovered disabled:text-button-primary-txt-disabled";
    }
  })(e ?? "primary");
  return j(
    "text-center flex items-center justify-center rounded-full px-24 py-8 h-fit w-fit",
    {
      "text-t16": t === "sm",
      "text-t21": t === "md",
      "text-t27": t === "lg",
      "flex justify-between items-center gap-x-8": r
    },
    o,
    n
  );
}, E8 = (t) => new Promise((e) => {
  setTimeout(e, t);
}), q_ = (t) => {
  var e;
  return t.getAttribute("href") ?? t.getAttributeNS("http://www.w3.org/1999/xlink", "href") ?? t.getAttribute("xlink:href") ?? ((e = t.getElementsByTagName("a")[0]) == null ? void 0 : e.getAttribute("href"));
};
function C8(t) {
  return !!(t.ctrlKey || t.shiftKey || t.metaKey || t.button && t.button === 1);
}
function I8(t) {
  const e = q_(t);
  return !!(t.target === "_blank" && e);
}
const S8 = ({ children: t, ...e }) => {
  const n = F_();
  return /* @__PURE__ */ C("a", { ...e, onClick: async (i) => {
    if (n) {
      const o = i.currentTarget, a = q_(o);
      C8(i) || I8(o) ? n.track("OPEN_EXTERNAL_LINK", { to: a }) : (i.preventDefault(), await Promise.race([
        n.track("OPEN_EXTERNAL_LINK", { to: a }),
        E8(500)
      ]), a && (window.location.href = a));
    }
  }, children: t });
}, rY = ({
  to: t,
  className: e,
  disabled: n,
  children: r,
  rightIcon: i,
  variant: o,
  size: a,
  onClick: s,
  ...c
}) => {
  const l = typeof document < "u";
  let u = !1;
  l && (u = new URL(document.baseURI).origin === new URL(t.toString(), document.baseURI).origin);
  const d = $_({
    size: a,
    variant: o,
    className: e,
    icons: !!i
  }), f = /* @__PURE__ */ K(
    "button",
    {
      "aria-disabled": n,
      className: d,
      disabled: n,
      children: [
        r,
        i && /* @__PURE__ */ C("span", { className: "shrink-0", children: i })
      ]
    }
  );
  return n ? (c["aria-disabled"] = !0, /* @__PURE__ */ C("span", { ...c, children: f })) : u ? /* @__PURE__ */ C(xw, { ...c, onClick: s, to: t, children: f }) : /* @__PURE__ */ C(S8, { ...c, href: t.toString(), children: f });
}, Nc = xu(
  ({
    children: t,
    className: e,
    testId: n,
    onClick: r,
    id: i,
    variant: o = "floating",
    style: a,
    ariaLabel: s
  }, c) => {
    const l = e == null ? void 0 : e.includes("bg-");
    return /* @__PURE__ */ C(
      "div",
      {
        id: i,
        "data-testid": n,
        "aria-label": s,
        ref: c,
        className: j(
          { "rounded-lg shadow-primary": o === "floating" },
          e,
          // default setting for bg
          { "bg-white": !l }
        ),
        onClick: r,
        style: a,
        children: t
      }
    );
  }
), T8 = (t) => /* @__PURE__ */ C(
  "svg",
  {
    width: 20,
    height: 16,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "m2 9.713 6 5L19.68 2.097",
        stroke: "currentColor",
        strokeWidth: 4,
        strokeLinecap: "round"
      }
    )
  }
), iY = ({
  children: t,
  onChange: e,
  checked: n,
  onBlur: r,
  className: i,
  label: o,
  variant: a,
  value: s,
  error: c,
  onSubmit: l,
  ...u
}) => {
  const { "aria-label": d } = u;
  return /* @__PURE__ */ K(cc, { children: [
    /* @__PURE__ */ K(
      "label",
      {
        "aria-label": d ?? "checkbox",
        className: j(
          "relative cursor-pointer flex flex-row items-start justify-start",
          i
        ),
        children: [
          /* @__PURE__ */ C(
            "input",
            {
              type: "checkbox",
              className: "peer sr-only appearance-none",
              onChange: (f) => {
                e && e(f), l && l(f), r && r();
              }
            }
          ),
          /* @__PURE__ */ C(
            "div",
            {
              className: j(
                "bg-checkbox-background-unchecked rounded-full border-2 border-input-border",
                "w-24 h-24 p-2 flex flex-shrink-0 justify-center items-center focus-within:border-blue-500 mr-12",
                {
                  "rounded-md": a === "square",
                  "rounded-full": a === "round"
                }
              ),
              children: /* @__PURE__ */ C(
                T8,
                {
                  className: j("text-checkbox-tick opacity-0", {
                    "opacity-100": n
                  })
                }
              )
            }
          ),
          t && /* @__PURE__ */ C("div", { children: t }),
          o && /* @__PURE__ */ C("p", { className: "text-font-primary", children: o })
        ]
      }
    ),
    c && /* @__PURE__ */ C("p", { className: "text-action-error text-t16 mt-12", children: c })
  ] });
};
function jn(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(e.indexOf(i) >= 0) && (n[i] = t[i]);
  return n;
}
function Ne() {
  return Ne = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Ne.apply(this, arguments);
}
function hy(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Gh(t, e) {
  return Gh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Gh(t, e);
}
function k8(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Gh(t, e);
}
var P = {}, py = {
  get exports() {
    return P;
  },
  set exports(t) {
    P = t;
  }
}, lu = {}, A8 = {
  get exports() {
    return lu;
  },
  set exports(t) {
    lu = t;
  }
}, wt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gy;
function O8() {
  if (gy)
    return wt;
  gy = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, g = t ? Symbol.for("react.lazy") : 60116, v = t ? Symbol.for("react.block") : 60121, b = t ? Symbol.for("react.fundamental") : 60117, m = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
  function p(_) {
    if (typeof _ == "object" && _ !== null) {
      var E = _.$$typeof;
      switch (E) {
        case e:
          switch (_ = _.type, _) {
            case c:
            case l:
            case r:
            case o:
            case i:
            case d:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case s:
                case u:
                case g:
                case h:
                case a:
                  return _;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function w(_) {
    return p(_) === l;
  }
  return wt.AsyncMode = c, wt.ConcurrentMode = l, wt.ContextConsumer = s, wt.ContextProvider = a, wt.Element = e, wt.ForwardRef = u, wt.Fragment = r, wt.Lazy = g, wt.Memo = h, wt.Portal = n, wt.Profiler = o, wt.StrictMode = i, wt.Suspense = d, wt.isAsyncMode = function(_) {
    return w(_) || p(_) === c;
  }, wt.isConcurrentMode = w, wt.isContextConsumer = function(_) {
    return p(_) === s;
  }, wt.isContextProvider = function(_) {
    return p(_) === a;
  }, wt.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === e;
  }, wt.isForwardRef = function(_) {
    return p(_) === u;
  }, wt.isFragment = function(_) {
    return p(_) === r;
  }, wt.isLazy = function(_) {
    return p(_) === g;
  }, wt.isMemo = function(_) {
    return p(_) === h;
  }, wt.isPortal = function(_) {
    return p(_) === n;
  }, wt.isProfiler = function(_) {
    return p(_) === o;
  }, wt.isStrictMode = function(_) {
    return p(_) === i;
  }, wt.isSuspense = function(_) {
    return p(_) === d;
  }, wt.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === r || _ === l || _ === o || _ === i || _ === d || _ === f || typeof _ == "object" && _ !== null && (_.$$typeof === g || _.$$typeof === h || _.$$typeof === a || _.$$typeof === s || _.$$typeof === u || _.$$typeof === b || _.$$typeof === m || _.$$typeof === y || _.$$typeof === v);
  }, wt.typeOf = p, wt;
}
var bt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var my;
function x8() {
  return my || (my = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, s = t ? Symbol.for("react.context") : 60110, c = t ? Symbol.for("react.async_mode") : 60111, l = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, g = t ? Symbol.for("react.lazy") : 60116, v = t ? Symbol.for("react.block") : 60121, b = t ? Symbol.for("react.fundamental") : 60117, m = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
    function p(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === r || V === l || V === o || V === i || V === d || V === f || typeof V == "object" && V !== null && (V.$$typeof === g || V.$$typeof === h || V.$$typeof === a || V.$$typeof === s || V.$$typeof === u || V.$$typeof === b || V.$$typeof === m || V.$$typeof === y || V.$$typeof === v);
    }
    function w(V) {
      if (typeof V == "object" && V !== null) {
        var Pe = V.$$typeof;
        switch (Pe) {
          case e:
            var X = V.type;
            switch (X) {
              case c:
              case l:
              case r:
              case o:
              case i:
              case d:
                return X;
              default:
                var it = X && X.$$typeof;
                switch (it) {
                  case s:
                  case u:
                  case g:
                  case h:
                  case a:
                    return it;
                  default:
                    return Pe;
                }
            }
          case n:
            return Pe;
        }
      }
    }
    var _ = c, E = l, S = s, T = a, x = e, A = u, N = r, F = g, D = h, L = n, z = o, ne = i, ae = d, Re = !1;
    function fe(V) {
      return Re || (Re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(V) || w(V) === c;
    }
    function I(V) {
      return w(V) === l;
    }
    function J(V) {
      return w(V) === s;
    }
    function me(V) {
      return w(V) === a;
    }
    function O(V) {
      return typeof V == "object" && V !== null && V.$$typeof === e;
    }
    function ue(V) {
      return w(V) === u;
    }
    function Ce(V) {
      return w(V) === r;
    }
    function Z(V) {
      return w(V) === g;
    }
    function he(V) {
      return w(V) === h;
    }
    function Q(V) {
      return w(V) === n;
    }
    function $(V) {
      return w(V) === o;
    }
    function q(V) {
      return w(V) === i;
    }
    function H(V) {
      return w(V) === d;
    }
    bt.AsyncMode = _, bt.ConcurrentMode = E, bt.ContextConsumer = S, bt.ContextProvider = T, bt.Element = x, bt.ForwardRef = A, bt.Fragment = N, bt.Lazy = F, bt.Memo = D, bt.Portal = L, bt.Profiler = z, bt.StrictMode = ne, bt.Suspense = ae, bt.isAsyncMode = fe, bt.isConcurrentMode = I, bt.isContextConsumer = J, bt.isContextProvider = me, bt.isElement = O, bt.isForwardRef = ue, bt.isFragment = Ce, bt.isLazy = Z, bt.isMemo = he, bt.isPortal = Q, bt.isProfiler = $, bt.isStrictMode = q, bt.isSuspense = H, bt.isValidElementType = p, bt.typeOf = w;
  }()), bt;
}
var vy;
function z_() {
  return vy || (vy = 1, function(t) {
    process.env.NODE_ENV === "production" ? t.exports = O8() : t.exports = x8();
  }(A8)), lu;
}
var sf, yy;
function Ug() {
  if (yy)
    return sf;
  yy = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return sf = t, sf;
}
var cf, wy;
function K_() {
  return wy || (wy = 1, cf = Function.call.bind(Object.prototype.hasOwnProperty)), cf;
}
var lf, by;
function R8() {
  if (by)
    return lf;
  by = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = Ug(), n = {}, r = K_();
    t = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in o)
        if (r(o, u)) {
          var d;
          try {
            if (typeof o[u] != "function") {
              var f = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = o[u](a, u, c, s, null, e);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && t(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = l ? l() : "";
            t(
              "Failed " + s + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, lf = i, lf;
}
var uf, _y;
function N8() {
  if (_y)
    return uf;
  _y = 1;
  var t = z_(), e = kp(), n = Ug(), r = K_(), i = R8(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return uf = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(I) {
      var J = I && (l && I[l] || I[u]);
      if (typeof J == "function")
        return J;
    }
    var f = "<<anonymous>>", h = {
      array: m("array"),
      bigint: m("bigint"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: y(),
      arrayOf: p,
      element: w(),
      elementType: _(),
      instanceOf: E,
      node: A(),
      objectOf: T,
      oneOf: S,
      oneOfType: x,
      shape: F,
      exact: D
    };
    function g(I, J) {
      return I === J ? I !== 0 || 1 / I === 1 / J : I !== I && J !== J;
    }
    function v(I, J) {
      this.message = I, this.data = J && typeof J == "object" ? J : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function b(I) {
      if (process.env.NODE_ENV !== "production")
        var J = {}, me = 0;
      function O(Ce, Z, he, Q, $, q, H) {
        if (Q = Q || f, q = q || he, H !== n) {
          if (c) {
            var V = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw V.name = "Invariant Violation", V;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Pe = Q + ":" + he;
            !J[Pe] && // Avoid spamming the console because they are often not actionable except for lib authors
            me < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + q + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), J[Pe] = !0, me++);
          }
        }
        return Z[he] == null ? Ce ? Z[he] === null ? new v("The " + $ + " `" + q + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new v("The " + $ + " `" + q + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : I(Z, he, Q, $, q);
      }
      var ue = O.bind(null, !1);
      return ue.isRequired = O.bind(null, !0), ue;
    }
    function m(I) {
      function J(me, O, ue, Ce, Z, he) {
        var Q = me[O], $ = ne(Q);
        if ($ !== I) {
          var q = ae(Q);
          return new v(
            "Invalid " + Ce + " `" + Z + "` of type " + ("`" + q + "` supplied to `" + ue + "`, expected ") + ("`" + I + "`."),
            { expectedType: I }
          );
        }
        return null;
      }
      return b(J);
    }
    function y() {
      return b(a);
    }
    function p(I) {
      function J(me, O, ue, Ce, Z) {
        if (typeof I != "function")
          return new v("Property `" + Z + "` of component `" + ue + "` has invalid PropType notation inside arrayOf.");
        var he = me[O];
        if (!Array.isArray(he)) {
          var Q = ne(he);
          return new v("Invalid " + Ce + " `" + Z + "` of type " + ("`" + Q + "` supplied to `" + ue + "`, expected an array."));
        }
        for (var $ = 0; $ < he.length; $++) {
          var q = I(he, $, ue, Ce, Z + "[" + $ + "]", n);
          if (q instanceof Error)
            return q;
        }
        return null;
      }
      return b(J);
    }
    function w() {
      function I(J, me, O, ue, Ce) {
        var Z = J[me];
        if (!s(Z)) {
          var he = ne(Z);
          return new v("Invalid " + ue + " `" + Ce + "` of type " + ("`" + he + "` supplied to `" + O + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(I);
    }
    function _() {
      function I(J, me, O, ue, Ce) {
        var Z = J[me];
        if (!t.isValidElementType(Z)) {
          var he = ne(Z);
          return new v("Invalid " + ue + " `" + Ce + "` of type " + ("`" + he + "` supplied to `" + O + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(I);
    }
    function E(I) {
      function J(me, O, ue, Ce, Z) {
        if (!(me[O] instanceof I)) {
          var he = I.name || f, Q = fe(me[O]);
          return new v("Invalid " + Ce + " `" + Z + "` of type " + ("`" + Q + "` supplied to `" + ue + "`, expected ") + ("instance of `" + he + "`."));
        }
        return null;
      }
      return b(J);
    }
    function S(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function J(me, O, ue, Ce, Z) {
        for (var he = me[O], Q = 0; Q < I.length; Q++)
          if (g(he, I[Q]))
            return null;
        var $ = JSON.stringify(I, function(H, V) {
          var Pe = ae(V);
          return Pe === "symbol" ? String(V) : V;
        });
        return new v("Invalid " + Ce + " `" + Z + "` of value `" + String(he) + "` " + ("supplied to `" + ue + "`, expected one of " + $ + "."));
      }
      return b(J);
    }
    function T(I) {
      function J(me, O, ue, Ce, Z) {
        if (typeof I != "function")
          return new v("Property `" + Z + "` of component `" + ue + "` has invalid PropType notation inside objectOf.");
        var he = me[O], Q = ne(he);
        if (Q !== "object")
          return new v("Invalid " + Ce + " `" + Z + "` of type " + ("`" + Q + "` supplied to `" + ue + "`, expected an object."));
        for (var $ in he)
          if (r(he, $)) {
            var q = I(he, $, ue, Ce, Z + "." + $, n);
            if (q instanceof Error)
              return q;
          }
        return null;
      }
      return b(J);
    }
    function x(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var J = 0; J < I.length; J++) {
        var me = I[J];
        if (typeof me != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Re(me) + " at index " + J + "."
          ), a;
      }
      function O(ue, Ce, Z, he, Q) {
        for (var $ = [], q = 0; q < I.length; q++) {
          var H = I[q], V = H(ue, Ce, Z, he, Q, n);
          if (V == null)
            return null;
          V.data && r(V.data, "expectedType") && $.push(V.data.expectedType);
        }
        var Pe = $.length > 0 ? ", expected one of type [" + $.join(", ") + "]" : "";
        return new v("Invalid " + he + " `" + Q + "` supplied to " + ("`" + Z + "`" + Pe + "."));
      }
      return b(O);
    }
    function A() {
      function I(J, me, O, ue, Ce) {
        return L(J[me]) ? null : new v("Invalid " + ue + " `" + Ce + "` supplied to " + ("`" + O + "`, expected a ReactNode."));
      }
      return b(I);
    }
    function N(I, J, me, O, ue) {
      return new v(
        (I || "React class") + ": " + J + " type `" + me + "." + O + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ue + "`."
      );
    }
    function F(I) {
      function J(me, O, ue, Ce, Z) {
        var he = me[O], Q = ne(he);
        if (Q !== "object")
          return new v("Invalid " + Ce + " `" + Z + "` of type `" + Q + "` " + ("supplied to `" + ue + "`, expected `object`."));
        for (var $ in I) {
          var q = I[$];
          if (typeof q != "function")
            return N(ue, Ce, Z, $, ae(q));
          var H = q(he, $, ue, Ce, Z + "." + $, n);
          if (H)
            return H;
        }
        return null;
      }
      return b(J);
    }
    function D(I) {
      function J(me, O, ue, Ce, Z) {
        var he = me[O], Q = ne(he);
        if (Q !== "object")
          return new v("Invalid " + Ce + " `" + Z + "` of type `" + Q + "` " + ("supplied to `" + ue + "`, expected `object`."));
        var $ = e({}, me[O], I);
        for (var q in $) {
          var H = I[q];
          if (r(I, q) && typeof H != "function")
            return N(ue, Ce, Z, q, ae(H));
          if (!H)
            return new v(
              "Invalid " + Ce + " `" + Z + "` key `" + q + "` supplied to `" + ue + "`.\nBad object: " + JSON.stringify(me[O], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(I), null, "  ")
            );
          var V = H(he, q, ue, Ce, Z + "." + q, n);
          if (V)
            return V;
        }
        return null;
      }
      return b(J);
    }
    function L(I) {
      switch (typeof I) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !I;
        case "object":
          if (Array.isArray(I))
            return I.every(L);
          if (I === null || s(I))
            return !0;
          var J = d(I);
          if (J) {
            var me = J.call(I), O;
            if (J !== I.entries) {
              for (; !(O = me.next()).done; )
                if (!L(O.value))
                  return !1;
            } else
              for (; !(O = me.next()).done; ) {
                var ue = O.value;
                if (ue && !L(ue[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function z(I, J) {
      return I === "symbol" ? !0 : J ? J["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && J instanceof Symbol : !1;
    }
    function ne(I) {
      var J = typeof I;
      return Array.isArray(I) ? "array" : I instanceof RegExp ? "object" : z(J, I) ? "symbol" : J;
    }
    function ae(I) {
      if (typeof I > "u" || I === null)
        return "" + I;
      var J = ne(I);
      if (J === "object") {
        if (I instanceof Date)
          return "date";
        if (I instanceof RegExp)
          return "regexp";
      }
      return J;
    }
    function Re(I) {
      var J = ae(I);
      switch (J) {
        case "array":
        case "object":
          return "an " + J;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + J;
        default:
          return J;
      }
    }
    function fe(I) {
      return !I.constructor || !I.constructor.name ? f : I.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, uf;
}
var df, Ey;
function M8() {
  if (Ey)
    return df;
  Ey = 1;
  var t = Ug();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, df = function() {
    function r(a, s, c, l, u, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return o.PropTypes = o, o;
  }, df;
}
if (process.env.NODE_ENV !== "production") {
  var P8 = z_(), D8 = !0;
  py.exports = N8()(P8.isElement, D8);
} else
  py.exports = M8()();
var uu = {}, L8 = {
  get exports() {
    return uu;
  },
  set exports(t) {
    uu = t;
  }
}, Ot = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cy;
function F8() {
  if (Cy)
    return Ot;
  Cy = 1;
  var t = 60103, e = 60106, n = 60107, r = 60108, i = 60114, o = 60109, a = 60110, s = 60112, c = 60113, l = 60120, u = 60115, d = 60116, f = 60121, h = 60122, g = 60117, v = 60129, b = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var m = Symbol.for;
    t = m("react.element"), e = m("react.portal"), n = m("react.fragment"), r = m("react.strict_mode"), i = m("react.profiler"), o = m("react.provider"), a = m("react.context"), s = m("react.forward_ref"), c = m("react.suspense"), l = m("react.suspense_list"), u = m("react.memo"), d = m("react.lazy"), f = m("react.block"), h = m("react.server.block"), g = m("react.fundamental"), v = m("react.debug_trace_mode"), b = m("react.legacy_hidden");
  }
  function y(D) {
    if (typeof D == "object" && D !== null) {
      var L = D.$$typeof;
      switch (L) {
        case t:
          switch (D = D.type, D) {
            case n:
            case i:
            case r:
            case c:
            case l:
              return D;
            default:
              switch (D = D && D.$$typeof, D) {
                case a:
                case s:
                case d:
                case u:
                case o:
                  return D;
                default:
                  return L;
              }
          }
        case e:
          return L;
      }
    }
  }
  var p = o, w = t, _ = s, E = n, S = d, T = u, x = e, A = i, N = r, F = c;
  return Ot.ContextConsumer = a, Ot.ContextProvider = p, Ot.Element = w, Ot.ForwardRef = _, Ot.Fragment = E, Ot.Lazy = S, Ot.Memo = T, Ot.Portal = x, Ot.Profiler = A, Ot.StrictMode = N, Ot.Suspense = F, Ot.isAsyncMode = function() {
    return !1;
  }, Ot.isConcurrentMode = function() {
    return !1;
  }, Ot.isContextConsumer = function(D) {
    return y(D) === a;
  }, Ot.isContextProvider = function(D) {
    return y(D) === o;
  }, Ot.isElement = function(D) {
    return typeof D == "object" && D !== null && D.$$typeof === t;
  }, Ot.isForwardRef = function(D) {
    return y(D) === s;
  }, Ot.isFragment = function(D) {
    return y(D) === n;
  }, Ot.isLazy = function(D) {
    return y(D) === d;
  }, Ot.isMemo = function(D) {
    return y(D) === u;
  }, Ot.isPortal = function(D) {
    return y(D) === e;
  }, Ot.isProfiler = function(D) {
    return y(D) === i;
  }, Ot.isStrictMode = function(D) {
    return y(D) === r;
  }, Ot.isSuspense = function(D) {
    return y(D) === c;
  }, Ot.isValidElementType = function(D) {
    return typeof D == "string" || typeof D == "function" || D === n || D === i || D === v || D === r || D === c || D === l || D === b || typeof D == "object" && D !== null && (D.$$typeof === d || D.$$typeof === u || D.$$typeof === o || D.$$typeof === a || D.$$typeof === s || D.$$typeof === g || D.$$typeof === f || D[0] === h);
  }, Ot.typeOf = y, Ot;
}
var xt = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Iy;
function U8() {
  return Iy || (Iy = 1, process.env.NODE_ENV !== "production" && function() {
    var t = 60103, e = 60106, n = 60107, r = 60108, i = 60114, o = 60109, a = 60110, s = 60112, c = 60113, l = 60120, u = 60115, d = 60116, f = 60121, h = 60122, g = 60117, v = 60129, b = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var m = Symbol.for;
      t = m("react.element"), e = m("react.portal"), n = m("react.fragment"), r = m("react.strict_mode"), i = m("react.profiler"), o = m("react.provider"), a = m("react.context"), s = m("react.forward_ref"), c = m("react.suspense"), l = m("react.suspense_list"), u = m("react.memo"), d = m("react.lazy"), f = m("react.block"), h = m("react.server.block"), g = m("react.fundamental"), m("react.scope"), m("react.opaque.id"), v = m("react.debug_trace_mode"), m("react.offscreen"), b = m("react.legacy_hidden");
    }
    var y = !1;
    function p(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === n || H === i || H === v || H === r || H === c || H === l || H === b || y || typeof H == "object" && H !== null && (H.$$typeof === d || H.$$typeof === u || H.$$typeof === o || H.$$typeof === a || H.$$typeof === s || H.$$typeof === g || H.$$typeof === f || H[0] === h));
    }
    function w(H) {
      if (typeof H == "object" && H !== null) {
        var V = H.$$typeof;
        switch (V) {
          case t:
            var Pe = H.type;
            switch (Pe) {
              case n:
              case i:
              case r:
              case c:
              case l:
                return Pe;
              default:
                var X = Pe && Pe.$$typeof;
                switch (X) {
                  case a:
                  case s:
                  case d:
                  case u:
                  case o:
                    return X;
                  default:
                    return V;
                }
            }
          case e:
            return V;
        }
      }
    }
    var _ = a, E = o, S = t, T = s, x = n, A = d, N = u, F = e, D = i, L = r, z = c, ne = !1, ae = !1;
    function Re(H) {
      return ne || (ne = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function fe(H) {
      return ae || (ae = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function I(H) {
      return w(H) === a;
    }
    function J(H) {
      return w(H) === o;
    }
    function me(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function O(H) {
      return w(H) === s;
    }
    function ue(H) {
      return w(H) === n;
    }
    function Ce(H) {
      return w(H) === d;
    }
    function Z(H) {
      return w(H) === u;
    }
    function he(H) {
      return w(H) === e;
    }
    function Q(H) {
      return w(H) === i;
    }
    function $(H) {
      return w(H) === r;
    }
    function q(H) {
      return w(H) === c;
    }
    xt.ContextConsumer = _, xt.ContextProvider = E, xt.Element = S, xt.ForwardRef = T, xt.Fragment = x, xt.Lazy = A, xt.Memo = N, xt.Portal = F, xt.Profiler = D, xt.StrictMode = L, xt.Suspense = z, xt.isAsyncMode = Re, xt.isConcurrentMode = fe, xt.isContextConsumer = I, xt.isContextProvider = J, xt.isElement = me, xt.isForwardRef = O, xt.isFragment = ue, xt.isLazy = Ce, xt.isMemo = Z, xt.isPortal = he, xt.isProfiler = Q, xt.isStrictMode = $, xt.isSuspense = q, xt.isValidElementType = p, xt.typeOf = w;
  }()), xt;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = F8() : t.exports = U8();
})(L8);
function Sy(t) {
  return typeof t == "object" && t != null && t.nodeType === 1;
}
function Ty(t, e) {
  return (!e || t !== "hidden") && t !== "visible" && t !== "clip";
}
function ff(t, e) {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    var n = getComputedStyle(t, null);
    return Ty(n.overflowY, e) || Ty(n.overflowX, e) || function(r) {
      var i = function(o) {
        if (!o.ownerDocument || !o.ownerDocument.defaultView)
          return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    }(t);
  }
  return !1;
}
function Zc(t, e, n, r, i, o, a, s) {
  return o < t && a > e || o > t && a < e ? 0 : o <= t && s <= n || a >= e && s >= n ? o - t - r : a > e && s < n || o < t && s > n ? a - e + i : 0;
}
var H8 = function(t, e) {
  var n = window, r = e.scrollMode, i = e.block, o = e.inline, a = e.boundary, s = e.skipOverflowHiddenElements, c = typeof a == "function" ? a : function(X) {
    return X !== a;
  };
  if (!Sy(t))
    throw new TypeError("Invalid target");
  for (var l, u, d = document.scrollingElement || document.documentElement, f = [], h = t; Sy(h) && c(h); ) {
    if ((h = (u = (l = h).parentElement) == null ? l.getRootNode().host || null : u) === d) {
      f.push(h);
      break;
    }
    h != null && h === document.body && ff(h) && !ff(document.documentElement) || h != null && ff(h, s) && f.push(h);
  }
  for (var g = n.visualViewport ? n.visualViewport.width : innerWidth, v = n.visualViewport ? n.visualViewport.height : innerHeight, b = window.scrollX || pageXOffset, m = window.scrollY || pageYOffset, y = t.getBoundingClientRect(), p = y.height, w = y.width, _ = y.top, E = y.right, S = y.bottom, T = y.left, x = i === "start" || i === "nearest" ? _ : i === "end" ? S : _ + p / 2, A = o === "center" ? T + w / 2 : o === "end" ? E : T, N = [], F = 0; F < f.length; F++) {
    var D = f[F], L = D.getBoundingClientRect(), z = L.height, ne = L.width, ae = L.top, Re = L.right, fe = L.bottom, I = L.left;
    if (r === "if-needed" && _ >= 0 && T >= 0 && S <= v && E <= g && _ >= ae && S <= fe && T >= I && E <= Re)
      return N;
    var J = getComputedStyle(D), me = parseInt(J.borderLeftWidth, 10), O = parseInt(J.borderTopWidth, 10), ue = parseInt(J.borderRightWidth, 10), Ce = parseInt(J.borderBottomWidth, 10), Z = 0, he = 0, Q = "offsetWidth" in D ? D.offsetWidth - D.clientWidth - me - ue : 0, $ = "offsetHeight" in D ? D.offsetHeight - D.clientHeight - O - Ce : 0, q = "offsetWidth" in D ? D.offsetWidth === 0 ? 0 : ne / D.offsetWidth : 0, H = "offsetHeight" in D ? D.offsetHeight === 0 ? 0 : z / D.offsetHeight : 0;
    if (d === D)
      Z = i === "start" ? x : i === "end" ? x - v : i === "nearest" ? Zc(m, m + v, v, O, Ce, m + x, m + x + p, p) : x - v / 2, he = o === "start" ? A : o === "center" ? A - g / 2 : o === "end" ? A - g : Zc(b, b + g, g, me, ue, b + A, b + A + w, w), Z = Math.max(0, Z + m), he = Math.max(0, he + b);
    else {
      Z = i === "start" ? x - ae - O : i === "end" ? x - fe + Ce + $ : i === "nearest" ? Zc(ae, fe, z, O, Ce + $, x, x + p, p) : x - (ae + z / 2) + $ / 2, he = o === "start" ? A - I - me : o === "center" ? A - (I + ne / 2) + Q / 2 : o === "end" ? A - Re + ue + Q : Zc(I, Re, ne, me, ue + Q, A, A + w, w);
      var V = D.scrollLeft, Pe = D.scrollTop;
      x += Pe - (Z = Math.max(0, Math.min(Pe + Z / H, D.scrollHeight - z / H + $))), A += V - (he = Math.max(0, Math.min(V + he / q, D.scrollWidth - ne / q + Q)));
    }
    N.push({ el: D, top: Z, left: he });
  }
  return N;
}, B8 = 0;
function ky(t) {
  return typeof t == "function" ? t : Yn;
}
function Yn() {
}
function W_(t, e) {
  if (t) {
    var n = H8(t, {
      boundary: e,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var i = r.el, o = r.top, a = r.left;
      i.scrollTop = o, i.scrollLeft = a;
    });
  }
}
function Ay(t, e, n) {
  var r = t === e || e instanceof n.Node && t.contains && t.contains(e);
  return r;
}
function ad(t, e) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function i() {
    for (var o = arguments.length, a = new Array(o), s = 0; s < o; s++)
      a[s] = arguments[s];
    r(), n = setTimeout(function() {
      n = null, t.apply(void 0, a);
    }, e);
  }
  return i.cancel = r, i;
}
function Wt() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      o[a - 1] = arguments[a];
    return e.some(function(s) {
      return s && s.apply(void 0, [r].concat(o)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Dr() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    e.forEach(function(i) {
      typeof i == "function" ? i(r) : i && (i.current = r);
    });
  };
}
function G_() {
  return String(B8++);
}
function Y_(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Oy(t, e) {
  return t = Array.isArray(t) ? (
    /* istanbul ignore next (preact) */
    t[0]
  ) : t, !t && e ? e : t;
}
function Q_(t) {
  return typeof t.type == "string";
}
function J_(t) {
  return t.props;
}
function j8(t, e) {
  console.error('The property "' + e + '" is required in "' + t + '"');
}
var V8 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Xc(t) {
  t === void 0 && (t = {});
  var e = {};
  return V8.forEach(function(n) {
    t.hasOwnProperty(n) && (e[n] = t[n]);
  }), e;
}
function ic(t, e) {
  return Object.keys(t).reduce(function(n, r) {
    return n[r] = du(e, r) ? e[r] : t[r], n;
  }, {});
}
function du(t, e) {
  return t[e] !== void 0;
}
function oc(t) {
  var e = t.key, n = t.keyCode;
  return n >= 37 && n <= 40 && e.indexOf("Arrow") !== 0 ? "Arrow" + e : e;
}
function $8(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Hi(t, e, n, r, i) {
  if (i === void 0 && (i = !0), n === 0)
    return -1;
  var o = n - 1;
  (typeof e != "number" || e < 0 || e >= n) && (e = t > 0 ? -1 : o + 1);
  var a = e + t;
  a < 0 ? a = i ? o : 0 : a > o && (a = i ? 0 : o);
  var s = gi(t, a, n, r, i);
  return s === -1 ? e >= n ? -1 : e : s;
}
function gi(t, e, n, r, i) {
  var o = r(e);
  if (!o || !o.hasAttribute("disabled"))
    return e;
  if (t > 0) {
    for (var a = e + 1; a < n; a++)
      if (!r(a).hasAttribute("disabled"))
        return a;
  } else
    for (var s = e - 1; s >= 0; s--)
      if (!r(s).hasAttribute("disabled"))
        return s;
  return i ? t > 0 ? gi(1, 0, n, r, !1) : gi(-1, n - 1, n, r, !1) : -1;
}
function fu(t, e, n, r) {
  return r === void 0 && (r = !0), e.some(function(i) {
    return i && (Ay(i, t, n) || r && Ay(i, n.document.activeElement, n));
  });
}
var Hg = Yn;
process.env.NODE_ENV !== "production" && (Hg = function(e, n, r) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(o) {
    n[o] !== void 0 && r[o] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + o + '" to be uncontrolled. ' + i) : n[o] === void 0 && r[o] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + o + '" to be controlled. ' + i);
  });
});
var q8 = ad(function(t) {
  X_(t).textContent = "";
}, 500);
function Z_(t, e) {
  var n = X_(e);
  t && (n.textContent = t, q8(e));
}
function X_(t) {
  t === void 0 && (t = document);
  var e = t.getElementById("a11y-status-message");
  return e || (e = t.createElement("div"), e.setAttribute("id", "a11y-status-message"), e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-relevant", "additions text"), Object.assign(e.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(e), e);
}
var eE = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, tE = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, nE = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Tl = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, kl = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, rE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, iE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, oE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, aE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, sE = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, cE = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, lE = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, uE = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, Yh = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, dE = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, fE = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, hE = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, z8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: eE,
  mouseUp: tE,
  itemMouseEnter: nE,
  keyDownArrowUp: Tl,
  keyDownArrowDown: kl,
  keyDownEscape: rE,
  keyDownEnter: iE,
  keyDownHome: oE,
  keyDownEnd: aE,
  clickItem: sE,
  blurInput: cE,
  changeInput: lE,
  keyDownSpaceButton: uE,
  clickButton: Yh,
  blurButton: dE,
  controlledPropUpdatedSelectedItem: fE,
  touchEnd: hE
}), K8 = ["refKey", "ref"], W8 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], G8 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], Y8 = ["refKey", "ref"], Q8 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], J8 = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(e) {
    k8(n, e);
    function n(i) {
      var o;
      o = e.call(this, i) || this, o.id = o.props.id || "downshift-" + G_(), o.menuId = o.props.menuId || o.id + "-menu", o.labelId = o.props.labelId || o.id + "-label", o.inputId = o.props.inputId || o.id + "-input", o.getItemId = o.props.getItemId || function(y) {
        return o.id + "-item-" + y;
      }, o.input = null, o.items = [], o.itemCount = null, o.previousResultCount = 0, o.timeoutIds = [], o.internalSetTimeout = function(y, p) {
        var w = setTimeout(function() {
          o.timeoutIds = o.timeoutIds.filter(function(_) {
            return _ !== w;
          }), y();
        }, p);
        o.timeoutIds.push(w);
      }, o.setItemCount = function(y) {
        o.itemCount = y;
      }, o.unsetItemCount = function() {
        o.itemCount = null;
      }, o.setHighlightedIndex = function(y, p) {
        y === void 0 && (y = o.props.defaultHighlightedIndex), p === void 0 && (p = {}), p = Xc(p), o.internalSetState(Ne({
          highlightedIndex: y
        }, p));
      }, o.clearSelection = function(y) {
        o.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: o.props.defaultHighlightedIndex,
          isOpen: o.props.defaultIsOpen
        }, y);
      }, o.selectItem = function(y, p, w) {
        p = Xc(p), o.internalSetState(Ne({
          isOpen: o.props.defaultIsOpen,
          highlightedIndex: o.props.defaultHighlightedIndex,
          selectedItem: y,
          inputValue: o.props.itemToString(y)
        }, p), w);
      }, o.selectItemAtIndex = function(y, p, w) {
        var _ = o.items[y];
        _ != null && o.selectItem(_, p, w);
      }, o.selectHighlightedItem = function(y, p) {
        return o.selectItemAtIndex(o.getState().highlightedIndex, y, p);
      }, o.internalSetState = function(y, p) {
        var w, _, E = {}, S = typeof y == "function";
        return !S && y.hasOwnProperty("inputValue") && o.props.onInputValueChange(y.inputValue, Ne({}, o.getStateAndHelpers(), y)), o.setState(function(T) {
          T = o.getState(T);
          var x = S ? y(T) : y;
          x = o.props.stateReducer(T, x), w = x.hasOwnProperty("selectedItem");
          var A = {};
          return w && x.selectedItem !== T.selectedItem && (_ = x.selectedItem), x.type = x.type || eE, Object.keys(x).forEach(function(N) {
            T[N] !== x[N] && (E[N] = x[N]), N !== "type" && (x[N], du(o.props, N) || (A[N] = x[N]));
          }), S && x.hasOwnProperty("inputValue") && o.props.onInputValueChange(x.inputValue, Ne({}, o.getStateAndHelpers(), x)), A;
        }, function() {
          ky(p)();
          var T = Object.keys(E).length > 1;
          T && o.props.onStateChange(E, o.getStateAndHelpers()), w && o.props.onSelect(y.selectedItem, o.getStateAndHelpers()), _ !== void 0 && o.props.onChange(_, o.getStateAndHelpers()), o.props.onUserAction(E, o.getStateAndHelpers());
        });
      }, o.rootRef = function(y) {
        return o._rootNode = y;
      }, o.getRootProps = function(y, p) {
        var w, _ = y === void 0 ? {} : y, E = _.refKey, S = E === void 0 ? "ref" : E, T = _.ref, x = jn(_, K8), A = p === void 0 ? {} : p, N = A.suppressRefError, F = N === void 0 ? !1 : N;
        o.getRootProps.called = !0, o.getRootProps.refKey = S, o.getRootProps.suppressRefError = F;
        var D = o.getState(), L = D.isOpen;
        return Ne((w = {}, w[S] = Dr(T, o.rootRef), w.role = "combobox", w["aria-expanded"] = L, w["aria-haspopup"] = "listbox", w["aria-owns"] = L ? o.menuId : null, w["aria-labelledby"] = o.labelId, w), x);
      }, o.keyDownHandlers = {
        ArrowDown: function(p) {
          var w = this;
          if (p.preventDefault(), this.getState().isOpen) {
            var _ = p.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(_, {
              type: kl
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: kl
            }, function() {
              var E = w.getItemCount();
              if (E > 0) {
                var S = w.getState(), T = S.highlightedIndex, x = Hi(1, T, E, function(A) {
                  return w.getItemNodeFromIndex(A);
                });
                w.setHighlightedIndex(x, {
                  type: kl
                });
              }
            });
        },
        ArrowUp: function(p) {
          var w = this;
          if (p.preventDefault(), this.getState().isOpen) {
            var _ = p.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(_, {
              type: Tl
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Tl
            }, function() {
              var E = w.getItemCount();
              if (E > 0) {
                var S = w.getState(), T = S.highlightedIndex, x = Hi(-1, T, E, function(A) {
                  return w.getItemNodeFromIndex(A);
                });
                w.setHighlightedIndex(x, {
                  type: Tl
                });
              }
            });
        },
        Enter: function(p) {
          if (p.which !== 229) {
            var w = this.getState(), _ = w.isOpen, E = w.highlightedIndex;
            if (_ && E != null) {
              p.preventDefault();
              var S = this.items[E], T = this.getItemNodeFromIndex(E);
              if (S == null || T && T.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: iE
              });
            }
          }
        },
        Escape: function(p) {
          p.preventDefault(), this.reset(Ne({
            type: rE
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, o.buttonKeyDownHandlers = Ne({}, o.keyDownHandlers, {
        " ": function(p) {
          p.preventDefault(), this.toggleMenu({
            type: uE
          });
        }
      }), o.inputKeyDownHandlers = Ne({}, o.keyDownHandlers, {
        Home: function(p) {
          var w = this, _ = this.getState(), E = _.isOpen;
          if (E) {
            p.preventDefault();
            var S = this.getItemCount();
            if (!(S <= 0 || !E)) {
              var T = gi(1, 0, S, function(x) {
                return w.getItemNodeFromIndex(x);
              }, !1);
              this.setHighlightedIndex(T, {
                type: oE
              });
            }
          }
        },
        End: function(p) {
          var w = this, _ = this.getState(), E = _.isOpen;
          if (E) {
            p.preventDefault();
            var S = this.getItemCount();
            if (!(S <= 0 || !E)) {
              var T = gi(-1, S - 1, S, function(x) {
                return w.getItemNodeFromIndex(x);
              }, !1);
              this.setHighlightedIndex(T, {
                type: aE
              });
            }
          }
        }
      }), o.getToggleButtonProps = function(y) {
        var p = y === void 0 ? {} : y, w = p.onClick;
        p.onPress;
        var _ = p.onKeyDown, E = p.onKeyUp, S = p.onBlur, T = jn(p, W8), x = o.getState(), A = x.isOpen, N = {
          onClick: Wt(w, o.buttonHandleClick),
          onKeyDown: Wt(_, o.buttonHandleKeyDown),
          onKeyUp: Wt(E, o.buttonHandleKeyUp),
          onBlur: Wt(S, o.buttonHandleBlur)
        }, F = T.disabled ? {} : N;
        return Ne({
          type: "button",
          role: "button",
          "aria-label": A ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, F, T);
      }, o.buttonHandleKeyUp = function(y) {
        y.preventDefault();
      }, o.buttonHandleKeyDown = function(y) {
        var p = oc(y);
        o.buttonKeyDownHandlers[p] && o.buttonKeyDownHandlers[p].call(hy(o), y);
      }, o.buttonHandleClick = function(y) {
        y.preventDefault(), o.props.environment.document.activeElement === o.props.environment.document.body && y.target.focus(), process.env.NODE_ENV === "test" ? o.toggleMenu({
          type: Yh
        }) : o.internalSetTimeout(function() {
          return o.toggleMenu({
            type: Yh
          });
        });
      }, o.buttonHandleBlur = function(y) {
        var p = y.target;
        o.internalSetTimeout(function() {
          !o.isMouseDown && (o.props.environment.document.activeElement == null || o.props.environment.document.activeElement.id !== o.inputId) && o.props.environment.document.activeElement !== p && o.reset({
            type: dE
          });
        });
      }, o.getLabelProps = function(y) {
        return Ne({
          htmlFor: o.inputId,
          id: o.labelId
        }, y);
      }, o.getInputProps = function(y) {
        var p = y === void 0 ? {} : y, w = p.onKeyDown, _ = p.onBlur, E = p.onChange, S = p.onInput;
        p.onChangeText;
        var T = jn(p, G8), x, A = {};
        x = "onChange";
        var N = o.getState(), F = N.inputValue, D = N.isOpen, L = N.highlightedIndex;
        if (!T.disabled) {
          var z;
          A = (z = {}, z[x] = Wt(E, S, o.inputHandleChange), z.onKeyDown = Wt(w, o.inputHandleKeyDown), z.onBlur = Wt(_, o.inputHandleBlur), z);
        }
        return Ne({
          "aria-autocomplete": "list",
          "aria-activedescendant": D && typeof L == "number" && L >= 0 ? o.getItemId(L) : null,
          "aria-controls": D ? o.menuId : null,
          "aria-labelledby": o.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: F,
          id: o.inputId
        }, A, T);
      }, o.inputHandleKeyDown = function(y) {
        var p = oc(y);
        p && o.inputKeyDownHandlers[p] && o.inputKeyDownHandlers[p].call(hy(o), y);
      }, o.inputHandleChange = function(y) {
        o.internalSetState({
          type: lE,
          isOpen: !0,
          inputValue: y.target.value,
          highlightedIndex: o.props.defaultHighlightedIndex
        });
      }, o.inputHandleBlur = function() {
        o.internalSetTimeout(function() {
          var y = o.props.environment.document && !!o.props.environment.document.activeElement && !!o.props.environment.document.activeElement.dataset && o.props.environment.document.activeElement.dataset.toggle && o._rootNode && o._rootNode.contains(o.props.environment.document.activeElement);
          !o.isMouseDown && !y && o.reset({
            type: cE
          });
        });
      }, o.menuRef = function(y) {
        o._menuNode = y;
      }, o.getMenuProps = function(y, p) {
        var w, _ = y === void 0 ? {} : y, E = _.refKey, S = E === void 0 ? "ref" : E, T = _.ref, x = jn(_, Y8), A = p === void 0 ? {} : p, N = A.suppressRefError, F = N === void 0 ? !1 : N;
        return o.getMenuProps.called = !0, o.getMenuProps.refKey = S, o.getMenuProps.suppressRefError = F, Ne((w = {}, w[S] = Dr(T, o.menuRef), w.role = "listbox", w["aria-labelledby"] = x && x["aria-label"] ? null : o.labelId, w.id = o.menuId, w), x);
      }, o.getItemProps = function(y) {
        var p, w = y === void 0 ? {} : y, _ = w.onMouseMove, E = w.onMouseDown, S = w.onClick;
        w.onPress;
        var T = w.index, x = w.item, A = x === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : j8("getItemProps", "item") : x, N = jn(w, Q8);
        T === void 0 ? (o.items.push(A), T = o.items.indexOf(A)) : o.items[T] = A;
        var F = "onClick", D = S, L = (p = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: Wt(_, function() {
            T !== o.getState().highlightedIndex && (o.setHighlightedIndex(T, {
              type: nE
            }), o.avoidScrolling = !0, o.internalSetTimeout(function() {
              return o.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: Wt(E, function(ne) {
            ne.preventDefault();
          })
        }, p[F] = Wt(D, function() {
          o.selectItemAtIndex(T, {
            type: sE
          });
        }), p), z = N.disabled ? {
          onMouseDown: L.onMouseDown
        } : L;
        return Ne({
          id: o.getItemId(T),
          role: "option",
          "aria-selected": o.getState().highlightedIndex === T
        }, z, N);
      }, o.clearItems = function() {
        o.items = [];
      }, o.reset = function(y, p) {
        y === void 0 && (y = {}), y = Xc(y), o.internalSetState(function(w) {
          var _ = w.selectedItem;
          return Ne({
            isOpen: o.props.defaultIsOpen,
            highlightedIndex: o.props.defaultHighlightedIndex,
            inputValue: o.props.itemToString(_)
          }, y);
        }, p);
      }, o.toggleMenu = function(y, p) {
        y === void 0 && (y = {}), y = Xc(y), o.internalSetState(function(w) {
          var _ = w.isOpen;
          return Ne({
            isOpen: !_
          }, _ && {
            highlightedIndex: o.props.defaultHighlightedIndex
          }, y);
        }, function() {
          var w = o.getState(), _ = w.isOpen, E = w.highlightedIndex;
          _ && o.getItemCount() > 0 && typeof E == "number" && o.setHighlightedIndex(E, y), ky(p)();
        });
      }, o.openMenu = function(y) {
        o.internalSetState({
          isOpen: !0
        }, y);
      }, o.closeMenu = function(y) {
        o.internalSetState({
          isOpen: !1
        }, y);
      }, o.updateStatus = ad(function() {
        var y = o.getState(), p = o.items[y.highlightedIndex], w = o.getItemCount(), _ = o.props.getA11yStatusMessage(Ne({
          itemToString: o.props.itemToString,
          previousResultCount: o.previousResultCount,
          resultCount: w,
          highlightedItem: p
        }, y));
        o.previousResultCount = w, Z_(_, o.props.environment.document);
      }, 200);
      var a = o.props, s = a.defaultHighlightedIndex, c = a.initialHighlightedIndex, l = c === void 0 ? s : c, u = a.defaultIsOpen, d = a.initialIsOpen, f = d === void 0 ? u : d, h = a.initialInputValue, g = h === void 0 ? "" : h, v = a.initialSelectedItem, b = v === void 0 ? null : v, m = o.getState({
        highlightedIndex: l,
        isOpen: f,
        inputValue: g,
        selectedItem: b
      });
      return m.selectedItem != null && o.props.initialInputValue === void 0 && (m.inputValue = o.props.itemToString(m.selectedItem)), o.state = m, o;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(o) {
        clearTimeout(o);
      }), this.timeoutIds = [];
    }, r.getState = function(o) {
      return o === void 0 && (o = this.state), ic(o, this.props);
    }, r.getItemCount = function() {
      var o = this.items.length;
      return this.itemCount != null ? o = this.itemCount : this.props.itemCount !== void 0 && (o = this.props.itemCount), o;
    }, r.getItemNodeFromIndex = function(o) {
      return this.props.environment.document.getElementById(this.getItemId(o));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var o = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(o, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(o, a) {
      var s = this, c = this.getItemCount(), l = this.getState(), u = l.highlightedIndex;
      if (c > 0) {
        var d = Hi(o, u, c, function(f) {
          return s.getItemNodeFromIndex(f);
        });
        this.setHighlightedIndex(d, a);
      }
    }, r.getStateAndHelpers = function() {
      var o = this.getState(), a = o.highlightedIndex, s = o.inputValue, c = o.selectedItem, l = o.isOpen, u = this.props.itemToString, d = this.id, f = this.getRootProps, h = this.getToggleButtonProps, g = this.getLabelProps, v = this.getMenuProps, b = this.getInputProps, m = this.getItemProps, y = this.openMenu, p = this.closeMenu, w = this.toggleMenu, _ = this.selectItem, E = this.selectItemAtIndex, S = this.selectHighlightedItem, T = this.setHighlightedIndex, x = this.clearSelection, A = this.clearItems, N = this.reset, F = this.setItemCount, D = this.unsetItemCount, L = this.internalSetState;
      return {
        // prop getters
        getRootProps: f,
        getToggleButtonProps: h,
        getLabelProps: g,
        getMenuProps: v,
        getInputProps: b,
        getItemProps: m,
        // actions
        reset: N,
        openMenu: y,
        closeMenu: p,
        toggleMenu: w,
        selectItem: _,
        selectItemAtIndex: E,
        selectHighlightedItem: S,
        setHighlightedIndex: T,
        clearSelection: x,
        clearItems: A,
        setItemCount: F,
        unsetItemCount: D,
        setState: L,
        // props
        itemToString: u,
        // derived
        id: d,
        // state
        highlightedIndex: a,
        inputValue: s,
        isOpen: l,
        selectedItem: c
      };
    }, r.componentDidMount = function() {
      var o = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && xy(this._menuNode, this.getMenuProps);
      {
        var a = function() {
          o.isMouseDown = !0;
        }, s = function(h) {
          o.isMouseDown = !1;
          var g = fu(h.target, [o._rootNode, o._menuNode], o.props.environment);
          !g && o.getState().isOpen && o.reset({
            type: tE
          }, function() {
            return o.props.onOuterClick(o.getStateAndHelpers());
          });
        }, c = function() {
          o.isTouchMove = !1;
        }, l = function() {
          o.isTouchMove = !0;
        }, u = function(h) {
          var g = fu(h.target, [o._rootNode, o._menuNode], o.props.environment, !1);
          !o.isTouchMove && !g && o.getState().isOpen && o.reset({
            type: hE
          }, function() {
            return o.props.onOuterClick(o.getStateAndHelpers());
          });
        }, d = this.props.environment;
        d.addEventListener("mousedown", a), d.addEventListener("mouseup", s), d.addEventListener("touchstart", c), d.addEventListener("touchmove", l), d.addEventListener("touchend", u), this.cleanup = function() {
          o.internalClearTimeouts(), o.updateStatus.cancel(), d.removeEventListener("mousedown", a), d.removeEventListener("mouseup", s), d.removeEventListener("touchstart", c), d.removeEventListener("touchmove", l), d.removeEventListener("touchend", u);
        };
      }
    }, r.shouldScroll = function(o, a) {
      var s = this.props.highlightedIndex === void 0 ? this.getState() : this.props, c = s.highlightedIndex, l = a.highlightedIndex === void 0 ? o : a, u = l.highlightedIndex, d = c && this.getState().isOpen && !o.isOpen, f = c !== u;
      return d || f;
    }, r.componentDidUpdate = function(o, a) {
      process.env.NODE_ENV !== "production" && (Hg(this.state, o, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && xy(this._menuNode, this.getMenuProps)), du(this.props, "selectedItem") && this.props.selectedItemChanged(o.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: fE,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(a, o) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var o = Oy(this.props.children, Yn);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var a = Oy(o(this.getStateAndHelpers()));
      if (!a)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && Z8(a, this.getRootProps), a;
      if (Q_(a))
        return /* @__PURE__ */ Ow(a, this.getRootProps(J_(a)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(V3);
  return t.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: Y_,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && $8(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: Yn,
    onInputValueChange: Yn,
    onUserAction: Yn,
    onChange: Yn,
    onSelect: Yn,
    onOuterClick: Yn,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: W_
  }, t.stateChangeTypes = z8, t;
}();
process.env.NODE_ENV !== "production" && (J8.propTypes = {
  children: P.func,
  defaultHighlightedIndex: P.number,
  defaultIsOpen: P.bool,
  initialHighlightedIndex: P.number,
  initialSelectedItem: P.any,
  initialInputValue: P.string,
  initialIsOpen: P.bool,
  getA11yStatusMessage: P.func,
  itemToString: P.func,
  onChange: P.func,
  onSelect: P.func,
  onStateChange: P.func,
  onInputValueChange: P.func,
  onUserAction: P.func,
  onOuterClick: P.func,
  selectedItemChanged: P.func,
  stateReducer: P.func,
  itemCount: P.number,
  id: P.string,
  environment: P.shape({
    addEventListener: P.func,
    removeEventListener: P.func,
    document: P.shape({
      getElementById: P.func,
      activeElement: P.any,
      body: P.any
    })
  }),
  suppressRefError: P.bool,
  scrollIntoView: P.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: P.any,
  isOpen: P.bool,
  inputValue: P.string,
  highlightedIndex: P.number,
  labelId: P.string,
  inputId: P.string,
  menuId: P.string,
  getItemId: P.func
  /* eslint-enable react/no-unused-prop-types */
});
function xy(t, e) {
  var n = e.refKey;
  t || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function Z8(t, e) {
  var n = e.refKey, r = n !== "ref", i = !Q_(t);
  i && !r && !uu.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !uu.isForwardRef(t) && !J_(t)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var X8 = ["isInitialMount", "highlightedIndex", "items", "environment"], pE = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function eN(t, e, n) {
  var r = t.props, i = t.type, o = {};
  Object.keys(e).forEach(function(a) {
    tN(a, t, e, n), n[a] !== e[a] && (o[a] = n[a]);
  }), r.onStateChange && Object.keys(o).length && r.onStateChange(Ne({
    type: i
  }, o));
}
function tN(t, e, n, r) {
  var i = e.props, o = e.type, a = "on" + Bg(t) + "Change";
  i[a] && r[t] !== void 0 && r[t] !== n[t] && i[a](Ne({
    type: o
  }, r));
}
function nN(t, e) {
  return e.changes;
}
function rN(t) {
  var e = t.selectedItem, n = t.itemToString;
  return e ? n(e) + " has been selected." : "";
}
var iN = ad(function(t, e) {
  Z_(t(), e);
}, 200), oN = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Tp : Ee;
function gE(t) {
  var e = t.id, n = e === void 0 ? "downshift-" + G_() : e, r = t.labelId, i = t.menuId, o = t.getItemId, a = t.toggleButtonId, s = t.inputId, c = Me({
    labelId: r || n + "-label",
    menuId: i || n + "-menu",
    getItemId: o || function(l) {
      return n + "-item-" + l;
    },
    toggleButtonId: a || n + "-toggle-button",
    inputId: s || n + "-input"
  });
  return c.current;
}
function mE(t, e, n) {
  return t !== void 0 ? t : n.length === 0 ? -1 : n.indexOf(e);
}
function aN(t) {
  return t ? String(t) : "";
}
function Ry(t) {
  return /^\S{1}$/.test(t);
}
function Bg(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function jg(t) {
  var e = Me(t);
  return e.current = t, e;
}
function vE(t, e, n) {
  var r = Me(), i = Me(), o = Qe(function(f, h) {
    i.current = h, f = ic(f, h.props);
    var g = t(f, h), v = h.props.stateReducer(f, Ne({}, h, {
      changes: g
    }));
    return v;
  }, [t]), a = $3(o, e), s = a[0], c = a[1], l = jg(n), u = Qe(function(f) {
    return c(Ne({
      props: l.current
    }, f));
  }, [l]), d = i.current;
  return Ee(function() {
    d && r.current && r.current !== s && eN(d, ic(r.current, d.props), s), r.current = s;
  }, [s, n, d]), [s, u];
}
function sN(t, e, n) {
  var r = vE(t, e, n), i = r[0], o = r[1];
  return [ic(i, n), o];
}
var Ds = {
  itemToString: aN,
  stateReducer: nN,
  getA11ySelectionMessage: rN,
  scrollIntoView: W_,
  circularNavigation: !1,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function Vn(t, e, n) {
  n === void 0 && (n = pE);
  var r = "default" + Bg(e);
  return r in t ? t[r] : n[e];
}
function el(t, e, n) {
  if (n === void 0 && (n = pE), e in t)
    return t[e];
  var r = "initial" + Bg(e);
  return r in t ? t[r] : Vn(t, e, n);
}
function yE(t) {
  var e = el(t, "selectedItem"), n = el(t, "isOpen"), r = el(t, "highlightedIndex"), i = el(t, "inputValue");
  return {
    highlightedIndex: r < 0 && e && n ? t.items.indexOf(e) : r,
    isOpen: n,
    selectedItem: e,
    inputValue: i
  };
}
function La(t, e, n, r) {
  var i = t.items, o = t.initialHighlightedIndex, a = t.defaultHighlightedIndex, s = e.selectedItem, c = e.highlightedIndex;
  return i.length === 0 ? -1 : o !== void 0 && c === o ? o : a !== void 0 ? a : s ? n === 0 ? i.indexOf(s) : Hi(n, i.indexOf(s), i.length, r, !1) : n === 0 ? -1 : n < 0 ? i.length - 1 : 0;
}
function wE(t, e, n, r) {
  var i = Me({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return Ee(function() {
    var o = function() {
      i.current.isMouseDown = !0;
    }, a = function(d) {
      i.current.isMouseDown = !1, t && !fu(d.target, e.map(function(f) {
        return f.current;
      }), n) && r();
    }, s = function() {
      i.current.isTouchMove = !1;
    }, c = function() {
      i.current.isTouchMove = !0;
    }, l = function(d) {
      t && !i.current.isTouchMove && !fu(d.target, e.map(function(f) {
        return f.current;
      }), n, !1) && r();
    };
    return n.addEventListener("mousedown", o), n.addEventListener("mouseup", a), n.addEventListener("touchstart", s), n.addEventListener("touchmove", c), n.addEventListener("touchend", l), function() {
      n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", a), n.removeEventListener("touchstart", s), n.removeEventListener("touchmove", c), n.removeEventListener("touchend", l);
    };
  }, [t, n]), i;
}
var Vg = function() {
  return Yn;
};
process.env.NODE_ENV !== "production" && (Vg = function() {
  for (var e = Me(!0), n = arguments.length, r = new Array(n), i = 0; i < n; i++)
    r[i] = arguments[i];
  var o = Me(r.reduce(function(s, c) {
    return s[c] = {}, s;
  }, {}));
  Ee(function() {
    Object.keys(o.current).forEach(function(s) {
      var c = o.current[s];
      if (e.current && !Object.keys(c).length) {
        console.error("downshift: You forgot to call the " + s + " getter function on your component / element.");
        return;
      }
      var l = c.suppressRefError, u = c.refKey, d = c.elementRef;
      (!d || !d.current) && !l && console.error('downshift: The ref prop "' + u + '" from ' + s + " was not applied correctly on your element.");
    }), e.current = !1;
  });
  var a = Qe(function(s, c, l, u) {
    o.current[s] = {
      suppressRefError: c,
      refKey: l,
      elementRef: u
    };
  }, []);
  return a;
});
function hu(t, e, n) {
  var r = n.isInitialMount, i = n.highlightedIndex, o = n.items, a = n.environment, s = jn(n, X8);
  Ee(function() {
    r || iN(function() {
      return t(Ne({
        highlightedIndex: i,
        highlightedItem: o[i],
        resultCount: o.length
      }, s));
    }, a.document);
  }, e);
}
function bE(t) {
  var e = t.highlightedIndex, n = t.isOpen, r = t.itemRefs, i = t.getItemNodeFromIndex, o = t.menuElement, a = t.scrollIntoView, s = Me(!0);
  return oN(function() {
    e < 0 || !n || !Object.keys(r.current).length || (s.current === !1 ? s.current = !0 : a(i(e), o));
  }, [e]), s;
}
var $g = Yn;
process.env.NODE_ENV !== "production" && ($g = function(e) {
  var n = e.isInitialMount, r = e.props, i = e.state, o = Me(r);
  Ee(function() {
    n || (Hg(i, o.current, r), o.current = r);
  }, [i, r, n]);
});
function _E(t, e, n) {
  var r = e.type, i = e.props, o;
  switch (r) {
    case n.ItemMouseMove:
      o = {
        highlightedIndex: e.index
      };
      break;
    case n.MenuMouseLeave:
      o = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      o = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : La(i, t, 0)
      };
      break;
    case n.FunctionOpenMenu:
      o = {
        isOpen: !0,
        highlightedIndex: La(i, t, 0)
      };
      break;
    case n.FunctionCloseMenu:
      o = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      o = {
        highlightedIndex: e.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      o = {
        inputValue: e.inputValue
      };
      break;
    case n.FunctionReset:
      o = {
        highlightedIndex: Vn(i, "highlightedIndex"),
        isOpen: Vn(i, "isOpen"),
        selectedItem: Vn(i, "selectedItem"),
        inputValue: Vn(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return Ne({}, t, o);
}
function Ny(t) {
  for (var e = t.keysSoFar, n = t.highlightedIndex, r = t.items, i = t.itemToString, o = t.getItemNodeFromIndex, a = e.toLowerCase(), s = 0; s < r.length; s++) {
    var c = (s + n + 1) % r.length, l = r[c];
    if (l !== void 0 && i(l).toLowerCase().startsWith(a)) {
      var u = o(c);
      if (!(u != null && u.hasAttribute("disabled")))
        return c;
    }
  }
  return n;
}
var cN = {
  items: P.array.isRequired,
  itemToString: P.func,
  getA11yStatusMessage: P.func,
  getA11ySelectionMessage: P.func,
  circularNavigation: P.bool,
  highlightedIndex: P.number,
  defaultHighlightedIndex: P.number,
  initialHighlightedIndex: P.number,
  isOpen: P.bool,
  defaultIsOpen: P.bool,
  initialIsOpen: P.bool,
  selectedItem: P.any,
  initialSelectedItem: P.any,
  defaultSelectedItem: P.any,
  id: P.string,
  labelId: P.string,
  menuId: P.string,
  getItemId: P.func,
  toggleButtonId: P.string,
  stateReducer: P.func,
  onSelectedItemChange: P.func,
  onHighlightedIndexChange: P.func,
  onStateChange: P.func,
  onIsOpenChange: P.func,
  environment: P.shape({
    addEventListener: P.func,
    removeEventListener: P.func,
    document: P.shape({
      getElementById: P.func,
      activeElement: P.any,
      body: P.any
    })
  })
};
function lN(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select." : "" : "No results are available." : "";
}
var uN = R(R({}, Ds), { getA11yStatusMessage: lN }), EE = Yn;
process.env.NODE_ENV !== "production" && (EE = function(t, e) {
  P.checkPropTypes(cN, t, "prop", e.name);
});
var qg = process.env.NODE_ENV !== "production" ? "__menu_keydown_arrow_down__" : 0, zg = process.env.NODE_ENV !== "production" ? "__menu_keydown_arrow_up__" : 1, Kg = process.env.NODE_ENV !== "production" ? "__menu_keydown_escape__" : 2, Wg = process.env.NODE_ENV !== "production" ? "__menu_keydown_home__" : 3, Gg = process.env.NODE_ENV !== "production" ? "__menu_keydown_end__" : 4, Yg = process.env.NODE_ENV !== "production" ? "__menu_keydown_enter__" : 5, Qg = process.env.NODE_ENV !== "production" ? "__menu_keydown_space_button__" : 6, Jg = process.env.NODE_ENV !== "production" ? "__menu_keydown_character__" : 7, pu = process.env.NODE_ENV !== "production" ? "__menu_blur__" : 8, CE = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 9, IE = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 10, Zg = process.env.NODE_ENV !== "production" ? "__item_click__" : 11, SE = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 12, Xg = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 13, em = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 14, tm = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 15, TE = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 16, kE = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 17, AE = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 18, OE = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 19, nm = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 20, Qh = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 21, xE = process.env.NODE_ENV !== "production" ? "__function_reset__" : 22, RE = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MenuKeyDownArrowDown: qg,
  MenuKeyDownArrowUp: zg,
  MenuKeyDownEscape: Kg,
  MenuKeyDownHome: Wg,
  MenuKeyDownEnd: Gg,
  MenuKeyDownEnter: Yg,
  MenuKeyDownSpaceButton: Qg,
  MenuKeyDownCharacter: Jg,
  MenuBlur: pu,
  MenuMouseLeave: CE,
  ItemMouseMove: IE,
  ItemClick: Zg,
  ToggleButtonClick: SE,
  ToggleButtonKeyDownArrowDown: Xg,
  ToggleButtonKeyDownArrowUp: em,
  ToggleButtonKeyDownCharacter: tm,
  FunctionToggleMenu: TE,
  FunctionOpenMenu: kE,
  FunctionCloseMenu: AE,
  FunctionSetHighlightedIndex: OE,
  FunctionSelectItem: nm,
  FunctionSetInputValue: Qh,
  FunctionReset: xE
});
function dN(t, e) {
  var n = e.type, r = e.props, i = e.shiftKey, o;
  switch (n) {
    case Zg:
      o = {
        isOpen: Vn(r, "isOpen"),
        highlightedIndex: Vn(r, "highlightedIndex"),
        selectedItem: r.items[e.index]
      };
      break;
    case tm:
      {
        var a = e.key, s = "" + t.inputValue + a, c = Ny({
          keysSoFar: s,
          highlightedIndex: t.selectedItem ? r.items.indexOf(t.selectedItem) : -1,
          items: r.items,
          itemToString: r.itemToString,
          getItemNodeFromIndex: e.getItemNodeFromIndex
        });
        o = Ne({
          inputValue: s
        }, c >= 0 && {
          selectedItem: r.items[c]
        });
      }
      break;
    case Xg:
      o = {
        highlightedIndex: La(r, t, 1, e.getItemNodeFromIndex),
        isOpen: !0
      };
      break;
    case em:
      o = {
        highlightedIndex: La(r, t, -1, e.getItemNodeFromIndex),
        isOpen: !0
      };
      break;
    case Yg:
    case Qg:
      o = Ne({
        isOpen: Vn(r, "isOpen"),
        highlightedIndex: Vn(r, "highlightedIndex")
      }, t.highlightedIndex >= 0 && {
        selectedItem: r.items[t.highlightedIndex]
      });
      break;
    case Wg:
      o = {
        highlightedIndex: gi(1, 0, r.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case Gg:
      o = {
        highlightedIndex: gi(-1, r.items.length - 1, r.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case Kg:
      o = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case pu:
      o = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case Jg:
      {
        var l = e.key, u = "" + t.inputValue + l, d = Ny({
          keysSoFar: u,
          highlightedIndex: t.highlightedIndex,
          items: r.items,
          itemToString: r.itemToString,
          getItemNodeFromIndex: e.getItemNodeFromIndex
        });
        o = Ne({
          inputValue: u
        }, d >= 0 && {
          highlightedIndex: d
        });
      }
      break;
    case qg:
      o = {
        highlightedIndex: Hi(i ? 5 : 1, t.highlightedIndex, r.items.length, e.getItemNodeFromIndex, r.circularNavigation)
      };
      break;
    case zg:
      o = {
        highlightedIndex: Hi(i ? -5 : -1, t.highlightedIndex, r.items.length, e.getItemNodeFromIndex, r.circularNavigation)
      };
      break;
    case nm:
      o = {
        selectedItem: e.selectedItem
      };
      break;
    default:
      return _E(t, e, RE);
  }
  return Ne({}, t, o);
}
var fN = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"], hN = ["onClick", "onKeyDown", "refKey", "ref"], pN = ["item", "index", "onMouseMove", "onClick", "refKey", "ref"];
rm.stateChangeTypes = RE;
function rm(t) {
  t === void 0 && (t = {}), EE(t, rm);
  var e = Ne({}, uN, t), n = e.items, r = e.scrollIntoView, i = e.environment, o = e.initialIsOpen, a = e.defaultIsOpen, s = e.itemToString, c = e.getA11ySelectionMessage, l = e.getA11yStatusMessage, u = yE(e), d = sN(dN, u, e), f = d[0], h = d[1], g = f.isOpen, v = f.highlightedIndex, b = f.selectedItem, m = f.inputValue, y = Me(null), p = Me(null), w = Me({}), _ = Me(!0), E = Me(null), S = gE(e), T = Me(), x = Me(!0), A = jg({
    state: f,
    props: e
  }), N = Qe(function(Q) {
    return w.current[S.getItemId(Q)];
  }, [S]);
  hu(l, [g, v, m, n], Ne({
    isInitialMount: x.current,
    previousResultCount: T.current,
    items: n,
    environment: i,
    itemToString: s
  }, f)), hu(c, [b], Ne({
    isInitialMount: x.current,
    previousResultCount: T.current,
    items: n,
    environment: i,
    itemToString: s
  }, f));
  var F = bE({
    menuElement: p.current,
    highlightedIndex: v,
    isOpen: g,
    itemRefs: w,
    scrollIntoView: r,
    getItemNodeFromIndex: N
  });
  Ee(function() {
    return E.current = ad(function(Q) {
      Q({
        type: Qh,
        inputValue: ""
      });
    }, 500), function() {
      E.current.cancel();
    };
  }, []), Ee(function() {
    m && E.current(h);
  }, [h, m]), $g({
    isInitialMount: x.current,
    props: e,
    state: f
  }), Ee(function() {
    if (x.current) {
      (o || a || g) && p.current && p.current.focus();
      return;
    }
    if (g) {
      p.current && p.current.focus();
      return;
    }
    i.document.activeElement === p.current && y.current && (_.current = !1, y.current.focus());
  }, [g]), Ee(function() {
    x.current || (T.current = n.length);
  });
  var D = wE(g, [p, y], i, function() {
    h({
      type: pu
    });
  }), L = Vg("getMenuProps", "getToggleButtonProps");
  Ee(function() {
    x.current = !1;
  }, []), Ee(function() {
    g || (w.current = {});
  }, [g]);
  var z = Tr(function() {
    return {
      ArrowDown: function($) {
        $.preventDefault(), h({
          type: Xg,
          getItemNodeFromIndex: N,
          shiftKey: $.shiftKey
        });
      },
      ArrowUp: function($) {
        $.preventDefault(), h({
          type: em,
          getItemNodeFromIndex: N,
          shiftKey: $.shiftKey
        });
      }
    };
  }, [h, N]), ne = Tr(function() {
    return {
      ArrowDown: function($) {
        $.preventDefault(), h({
          type: qg,
          getItemNodeFromIndex: N,
          shiftKey: $.shiftKey
        });
      },
      ArrowUp: function($) {
        $.preventDefault(), h({
          type: zg,
          getItemNodeFromIndex: N,
          shiftKey: $.shiftKey
        });
      },
      Home: function($) {
        $.preventDefault(), h({
          type: Wg,
          getItemNodeFromIndex: N
        });
      },
      End: function($) {
        $.preventDefault(), h({
          type: Gg,
          getItemNodeFromIndex: N
        });
      },
      Escape: function() {
        h({
          type: Kg
        });
      },
      Enter: function($) {
        $.preventDefault(), h({
          type: Yg
        });
      },
      " ": function($) {
        $.preventDefault(), h({
          type: Qg
        });
      }
    };
  }, [h, N]), ae = Qe(function() {
    h({
      type: TE
    });
  }, [h]), Re = Qe(function() {
    h({
      type: AE
    });
  }, [h]), fe = Qe(function() {
    h({
      type: kE
    });
  }, [h]), I = Qe(function(Q) {
    h({
      type: OE,
      highlightedIndex: Q
    });
  }, [h]), J = Qe(function(Q) {
    h({
      type: nm,
      selectedItem: Q
    });
  }, [h]), me = Qe(function() {
    h({
      type: xE
    });
  }, [h]), O = Qe(function(Q) {
    h({
      type: Qh,
      inputValue: Q
    });
  }, [h]), ue = Qe(function(Q) {
    return Ne({
      id: S.labelId,
      htmlFor: S.toggleButtonId
    }, Q);
  }, [S]), Ce = Qe(function(Q, $) {
    var q, H = Q === void 0 ? {} : Q, V = H.onMouseLeave, Pe = H.refKey, X = Pe === void 0 ? "ref" : Pe, it = H.onKeyDown, ht = H.onBlur, Ze = H.ref, pt = jn(H, fN), Nt = $ === void 0 ? {} : $, ut = Nt.suppressRefError, We = ut === void 0 ? !1 : ut, en = A.current.state, Jt = function(U) {
      var Y = oc(U);
      Y && ne[Y] ? ne[Y](U) : Ry(Y) && h({
        type: Jg,
        key: Y,
        getItemNodeFromIndex: N
      });
    }, gt = function() {
      if (_.current === !1) {
        _.current = !0;
        return;
      }
      var U = !D.current.isMouseDown;
      U && h({
        type: pu
      });
    }, Zt = function() {
      h({
        type: CE
      });
    };
    return L("getMenuProps", We, X, p), Ne((q = {}, q[X] = Dr(Ze, function(Tt) {
      p.current = Tt;
    }), q.id = S.menuId, q.role = "listbox", q["aria-labelledby"] = S.labelId, q.tabIndex = -1, q), en.isOpen && en.highlightedIndex > -1 && {
      "aria-activedescendant": S.getItemId(en.highlightedIndex)
    }, {
      onMouseLeave: Wt(V, Zt),
      onKeyDown: Wt(it, Jt),
      onBlur: Wt(ht, gt)
    }, pt);
  }, [h, A, ne, D, L, S, N]), Z = Qe(function(Q, $) {
    var q, H = Q === void 0 ? {} : Q, V = H.onClick, Pe = H.onKeyDown, X = H.refKey, it = X === void 0 ? "ref" : X, ht = H.ref, Ze = jn(H, hN), pt = $ === void 0 ? {} : $, Nt = pt.suppressRefError, ut = Nt === void 0 ? !1 : Nt, We = function() {
      h({
        type: SE
      });
    }, en = function(Zt) {
      var Tt = oc(Zt);
      Tt && z[Tt] ? z[Tt](Zt) : Ry(Tt) && h({
        type: tm,
        key: Tt,
        getItemNodeFromIndex: N
      });
    }, Jt = Ne((q = {}, q[it] = Dr(ht, function(gt) {
      y.current = gt;
    }), q.id = S.toggleButtonId, q["aria-haspopup"] = "listbox", q["aria-expanded"] = A.current.state.isOpen, q["aria-labelledby"] = S.labelId + " " + S.toggleButtonId, q), Ze);
    return Ze.disabled || (Jt.onClick = Wt(V, We), Jt.onKeyDown = Wt(Pe, en)), L("getToggleButtonProps", ut, it, y), Jt;
  }, [h, A, z, L, S, N]), he = Qe(function(Q) {
    var $, q = Q === void 0 ? {} : Q, H = q.item, V = q.index, Pe = q.onMouseMove, X = q.onClick, it = q.refKey, ht = it === void 0 ? "ref" : it, Ze = q.ref, pt = jn(q, pN), Nt = A.current, ut = Nt.state, We = Nt.props, en = function() {
      V !== ut.highlightedIndex && (F.current = !1, h({
        type: IE,
        index: V
      }));
    }, Jt = function() {
      h({
        type: Zg,
        index: V
      });
    }, gt = mE(V, H, We.items);
    if (gt < 0)
      throw new Error("Pass either item or item index in getItemProps!");
    var Zt = Ne(($ = {
      role: "option",
      "aria-selected": "" + (gt === ut.highlightedIndex),
      id: S.getItemId(gt)
    }, $[ht] = Dr(Ze, function(Tt) {
      Tt && (w.current[S.getItemId(gt)] = Tt);
    }), $), pt);
    return pt.disabled || (Zt.onMouseMove = Wt(Pe, en), Zt.onClick = Wt(X, Jt)), Zt;
  }, [h, A, F, S]);
  return {
    // prop getters.
    getToggleButtonProps: Z,
    getLabelProps: ue,
    getMenuProps: Ce,
    getItemProps: he,
    // actions.
    toggleMenu: ae,
    openMenu: fe,
    closeMenu: Re,
    setHighlightedIndex: I,
    selectItem: J,
    reset: me,
    setInputValue: O,
    // state.
    highlightedIndex: v,
    isOpen: g,
    selectedItem: b,
    inputValue: m
  };
}
var im = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, om = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, am = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, sm = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, cm = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, lm = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 5, um = process.env.NODE_ENV !== "production" ? "__input_change__" : 6, gu = process.env.NODE_ENV !== "production" ? "__input_blur__" : 7, NE = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 8, ME = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 9, dm = process.env.NODE_ENV !== "production" ? "__item_click__" : 10, PE = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 11, DE = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 12, LE = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 13, FE = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 14, UE = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 15, fm = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 16, HE = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 17, BE = process.env.NODE_ENV !== "production" ? "__function_reset__" : 18, hm = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 19, jE = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: im,
  InputKeyDownArrowUp: om,
  InputKeyDownEscape: am,
  InputKeyDownHome: sm,
  InputKeyDownEnd: cm,
  InputKeyDownEnter: lm,
  InputChange: um,
  InputBlur: gu,
  MenuMouseLeave: NE,
  ItemMouseMove: ME,
  ItemClick: dm,
  ToggleButtonClick: PE,
  FunctionToggleMenu: DE,
  FunctionOpenMenu: LE,
  FunctionCloseMenu: FE,
  FunctionSetHighlightedIndex: UE,
  FunctionSelectItem: fm,
  FunctionSetInputValue: HE,
  FunctionReset: BE,
  ControlledPropUpdatedSelectedItem: hm
});
function gN(t) {
  var e = yE(t), n = e.selectedItem, r = e.inputValue;
  return r === "" && n && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (r = t.itemToString(n)), Ne({}, e, {
    inputValue: r
  });
}
var mN = {
  items: P.array.isRequired,
  itemToString: P.func,
  getA11yStatusMessage: P.func,
  getA11ySelectionMessage: P.func,
  circularNavigation: P.bool,
  highlightedIndex: P.number,
  defaultHighlightedIndex: P.number,
  initialHighlightedIndex: P.number,
  isOpen: P.bool,
  defaultIsOpen: P.bool,
  initialIsOpen: P.bool,
  selectedItem: P.any,
  initialSelectedItem: P.any,
  defaultSelectedItem: P.any,
  inputValue: P.string,
  defaultInputValue: P.string,
  initialInputValue: P.string,
  id: P.string,
  labelId: P.string,
  menuId: P.string,
  getItemId: P.func,
  inputId: P.string,
  toggleButtonId: P.string,
  stateReducer: P.func,
  onSelectedItemChange: P.func,
  onHighlightedIndexChange: P.func,
  onStateChange: P.func,
  onIsOpenChange: P.func,
  onInputValueChange: P.func,
  environment: P.shape({
    addEventListener: P.func,
    removeEventListener: P.func,
    document: P.shape({
      getElementById: P.func,
      activeElement: P.any,
      body: P.any
    })
  })
};
function vN(t, e, n) {
  var r = Me(), i = vE(t, e, n), o = i[0], a = i[1];
  return Ee(function() {
    du(n, "selectedItem") && (r.current !== n.selectedItem && a({
      type: hm,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = o.selectedItem === r.current ? n.selectedItem : o.selectedItem);
  }), [ic(o, n), a];
}
var VE = Yn;
process.env.NODE_ENV !== "production" && (VE = function(e, n) {
  P.checkPropTypes(mN, e, "prop", n.name);
});
var yN = Ne({}, Ds, {
  getA11yStatusMessage: Y_,
  circularNavigation: !0
});
function wN(t, e) {
  var n = e.type, r = e.props, i = e.shiftKey, o;
  switch (n) {
    case dm:
      o = {
        isOpen: Vn(r, "isOpen"),
        highlightedIndex: Vn(r, "highlightedIndex"),
        selectedItem: r.items[e.index],
        inputValue: r.itemToString(r.items[e.index])
      };
      break;
    case im:
      t.isOpen ? o = {
        highlightedIndex: Hi(i ? 5 : 1, t.highlightedIndex, r.items.length, e.getItemNodeFromIndex, r.circularNavigation)
      } : o = {
        highlightedIndex: La(r, t, 1, e.getItemNodeFromIndex),
        isOpen: r.items.length >= 0
      };
      break;
    case om:
      t.isOpen ? o = {
        highlightedIndex: Hi(i ? -5 : -1, t.highlightedIndex, r.items.length, e.getItemNodeFromIndex, r.circularNavigation)
      } : o = {
        highlightedIndex: La(r, t, -1, e.getItemNodeFromIndex),
        isOpen: r.items.length >= 0
      };
      break;
    case lm:
      o = Ne({}, t.isOpen && t.highlightedIndex >= 0 && {
        selectedItem: r.items[t.highlightedIndex],
        isOpen: Vn(r, "isOpen"),
        highlightedIndex: Vn(r, "highlightedIndex"),
        inputValue: r.itemToString(r.items[t.highlightedIndex])
      });
      break;
    case am:
      o = Ne({
        isOpen: !1,
        highlightedIndex: -1
      }, !t.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case sm:
      o = {
        highlightedIndex: gi(1, 0, r.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case cm:
      o = {
        highlightedIndex: gi(-1, r.items.length - 1, r.items.length, e.getItemNodeFromIndex, !1)
      };
      break;
    case gu:
      o = Ne({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && e.selectItem && {
        selectedItem: r.items[t.highlightedIndex],
        inputValue: r.itemToString(r.items[t.highlightedIndex])
      });
      break;
    case um:
      o = {
        isOpen: !0,
        highlightedIndex: Vn(r, "highlightedIndex"),
        inputValue: e.inputValue
      };
      break;
    case fm:
      o = {
        selectedItem: e.selectedItem,
        inputValue: r.itemToString(e.selectedItem)
      };
      break;
    case hm:
      o = {
        inputValue: e.inputValue
      };
      break;
    default:
      return _E(t, e, jE);
  }
  return Ne({}, t, o);
}
var bN = ["onMouseLeave", "refKey", "ref"], _N = ["item", "index", "refKey", "ref", "onMouseMove", "onClick", "onPress"], EN = ["onClick", "onPress", "refKey", "ref"], CN = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"], IN = ["refKey", "ref"];
pm.stateChangeTypes = jE;
function pm(t) {
  t === void 0 && (t = {}), VE(t, pm);
  var e = Ne({}, yN, t), n = e.initialIsOpen, r = e.defaultIsOpen, i = e.items, o = e.scrollIntoView, a = e.environment, s = e.getA11yStatusMessage, c = e.getA11ySelectionMessage, l = e.itemToString, u = gN(e), d = vN(wN, u, e), f = d[0], h = d[1], g = f.isOpen, v = f.highlightedIndex, b = f.selectedItem, m = f.inputValue, y = Me(null), p = Me({}), w = Me(null), _ = Me(null), E = Me(null), S = Me(!0), T = gE(e), x = Me(), A = jg({
    state: f,
    props: e
  }), N = Qe(function($) {
    return p.current[T.getItemId($)];
  }, [T]);
  hu(s, [g, v, m, i], Ne({
    isInitialMount: S.current,
    previousResultCount: x.current,
    items: i,
    environment: a,
    itemToString: l
  }, f)), hu(c, [b], Ne({
    isInitialMount: S.current,
    previousResultCount: x.current,
    items: i,
    environment: a,
    itemToString: l
  }, f));
  var F = bE({
    menuElement: y.current,
    highlightedIndex: v,
    isOpen: g,
    itemRefs: p,
    scrollIntoView: o,
    getItemNodeFromIndex: N
  });
  $g({
    isInitialMount: S.current,
    props: e,
    state: f
  }), Ee(function() {
    var $ = n || r || g;
    $ && w.current && w.current.focus();
  }, []), Ee(function() {
    S.current || (x.current = i.length);
  });
  var D = wE(g, [E, y, _], a, function() {
    h({
      type: gu,
      selectItem: !1
    });
  }), L = Vg("getInputProps", "getComboboxProps", "getMenuProps");
  Ee(function() {
    S.current = !1;
  }, []), Ee(function() {
    g || (p.current = {});
  }, [g]);
  var z = Tr(function() {
    return {
      ArrowDown: function(q) {
        q.preventDefault(), h({
          type: im,
          shiftKey: q.shiftKey,
          getItemNodeFromIndex: N
        });
      },
      ArrowUp: function(q) {
        q.preventDefault(), h({
          type: om,
          shiftKey: q.shiftKey,
          getItemNodeFromIndex: N
        });
      },
      Home: function(q) {
        A.current.state.isOpen && (q.preventDefault(), h({
          type: sm,
          getItemNodeFromIndex: N
        }));
      },
      End: function(q) {
        A.current.state.isOpen && (q.preventDefault(), h({
          type: cm,
          getItemNodeFromIndex: N
        }));
      },
      Escape: function() {
        var q = A.current.state;
        (q.isOpen || q.inputValue || q.selectedItem || q.highlightedIndex > -1) && h({
          type: am
        });
      },
      Enter: function(q) {
        var H = A.current.state;
        !H.isOpen || H.highlightedIndex < 0 || q.which === 229 || (q.preventDefault(), h({
          type: lm,
          getItemNodeFromIndex: N
        }));
      }
    };
  }, [h, A, N]), ne = Qe(function($) {
    return Ne({
      id: T.labelId,
      htmlFor: T.inputId
    }, $);
  }, [T]), ae = Qe(function($, q) {
    var H, V = $ === void 0 ? {} : $, Pe = V.onMouseLeave, X = V.refKey, it = X === void 0 ? "ref" : X, ht = V.ref, Ze = jn(V, bN), pt = q === void 0 ? {} : q, Nt = pt.suppressRefError, ut = Nt === void 0 ? !1 : Nt;
    return L("getMenuProps", ut, it, y), Ne((H = {}, H[it] = Dr(ht, function(We) {
      y.current = We;
    }), H.id = T.menuId, H.role = "listbox", H["aria-labelledby"] = T.labelId, H.onMouseLeave = Wt(Pe, function() {
      h({
        type: NE
      });
    }), H), Ze);
  }, [h, L, T]), Re = Qe(function($) {
    var q, H, V = $ === void 0 ? {} : $, Pe = V.item, X = V.index, it = V.refKey, ht = it === void 0 ? "ref" : it, Ze = V.ref, pt = V.onMouseMove, Nt = V.onClick;
    V.onPress;
    var ut = jn(V, _N), We = A.current, en = We.props, Jt = We.state, gt = mE(X, Pe, en.items);
    if (gt < 0)
      throw new Error("Pass either item or item index in getItemProps!");
    var Zt = "onClick", Tt = Nt, U = function() {
      X !== Jt.highlightedIndex && (F.current = !1, h({
        type: ME,
        index: X
      }));
    }, Y = function() {
      h({
        type: dm,
        index: X
      }), w.current && w.current.focus();
    };
    return Ne((q = {}, q[ht] = Dr(Ze, function(we) {
      we && (p.current[T.getItemId(gt)] = we);
    }), q.role = "option", q["aria-selected"] = "" + (gt === Jt.highlightedIndex), q.id = T.getItemId(gt), q), !ut.disabled && (H = {
      onMouseMove: Wt(pt, U)
    }, H[Zt] = Wt(Tt, Y), H), ut);
  }, [h, A, F, T]), fe = Qe(function($) {
    var q, H = $ === void 0 ? {} : $, V = H.onClick;
    H.onPress;
    var Pe = H.refKey, X = Pe === void 0 ? "ref" : Pe, it = H.ref, ht = jn(H, EN), Ze = function() {
      h({
        type: PE
      }), !A.current.state.isOpen && w.current && w.current.focus();
    };
    return Ne((q = {}, q[X] = Dr(it, function(pt) {
      _.current = pt;
    }), q.id = T.toggleButtonId, q.tabIndex = -1, q), !ht.disabled && Ne({}, {
      onClick: Wt(V, Ze)
    }), ht);
  }, [h, A, T]), I = Qe(function($, q) {
    var H, V = $ === void 0 ? {} : $, Pe = V.onKeyDown, X = V.onChange, it = V.onInput, ht = V.onBlur;
    V.onChangeText;
    var Ze = V.refKey, pt = Ze === void 0 ? "ref" : Ze, Nt = V.ref, ut = jn(V, CN), We = q === void 0 ? {} : q, en = We.suppressRefError, Jt = en === void 0 ? !1 : en;
    L("getInputProps", Jt, pt, w);
    var gt = A.current.state, Zt = function(kt) {
      var tn = oc(kt);
      tn && z[tn] && z[tn](kt);
    }, Tt = function(kt) {
      h({
        type: um,
        inputValue: kt.target.value
      });
    }, U = function() {
      gt.isOpen && !D.current.isMouseDown && h({
        type: gu,
        selectItem: !0
      });
    }, Y = "onChange", we = {};
    if (!ut.disabled) {
      var qe;
      we = (qe = {}, qe[Y] = Wt(X, it, Tt), qe.onKeyDown = Wt(Pe, Zt), qe.onBlur = Wt(ht, U), qe);
    }
    return Ne((H = {}, H[pt] = Dr(Nt, function(Ye) {
      w.current = Ye;
    }), H.id = T.inputId, H["aria-autocomplete"] = "list", H["aria-controls"] = T.menuId, H), gt.isOpen && gt.highlightedIndex > -1 && {
      "aria-activedescendant": T.getItemId(gt.highlightedIndex)
    }, {
      "aria-labelledby": T.labelId,
      // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
      // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
      autoComplete: "off",
      value: gt.inputValue
    }, we, ut);
  }, [h, z, A, D, L, T]), J = Qe(function($, q) {
    var H, V = $ === void 0 ? {} : $, Pe = V.refKey, X = Pe === void 0 ? "ref" : Pe, it = V.ref, ht = jn(V, IN), Ze = q === void 0 ? {} : q, pt = Ze.suppressRefError, Nt = pt === void 0 ? !1 : pt;
    return L("getComboboxProps", Nt, X, E), Ne((H = {}, H[X] = Dr(it, function(ut) {
      E.current = ut;
    }), H.role = "combobox", H["aria-haspopup"] = "listbox", H["aria-owns"] = T.menuId, H["aria-expanded"] = A.current.state.isOpen, H), ht);
  }, [A, L, T]), me = Qe(function() {
    h({
      type: DE
    });
  }, [h]), O = Qe(function() {
    h({
      type: FE
    });
  }, [h]), ue = Qe(function() {
    h({
      type: LE
    });
  }, [h]), Ce = Qe(function($) {
    h({
      type: UE,
      highlightedIndex: $
    });
  }, [h]), Z = Qe(function($) {
    h({
      type: fm,
      selectedItem: $
    });
  }, [h]), he = Qe(function($) {
    h({
      type: HE,
      inputValue: $
    });
  }, [h]), Q = Qe(function() {
    h({
      type: BE
    });
  }, [h]);
  return {
    // prop getters.
    getItemProps: Re,
    getLabelProps: ne,
    getMenuProps: ae,
    getInputProps: I,
    getComboboxProps: J,
    getToggleButtonProps: fe,
    // actions.
    toggleMenu: me,
    openMenu: ue,
    closeMenu: O,
    setHighlightedIndex: Ce,
    setInputValue: he,
    selectItem: Z,
    reset: Q,
    // state.
    highlightedIndex: v,
    isOpen: g,
    selectedItem: b,
    inputValue: m
  };
}
function SN(t) {
  var e = t.removedSelectedItem, n = t.itemToString;
  return n(e) + " has been removed.";
}
P.array, P.array, P.array, P.func, P.func, P.func, P.number, P.number, P.number, P.func, P.func, P.string, P.string, P.shape({
  addEventListener: P.func,
  removeEventListener: P.func,
  document: P.shape({
    getElementById: P.func,
    activeElement: P.any,
    body: P.any
  })
});
Ds.itemToString, Ds.stateReducer, Ds.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function mi(t) {
  return Array.isArray ? Array.isArray(t) : zE(t) === "[object Array]";
}
const TN = 1 / 0;
function kN(t) {
  if (typeof t == "string")
    return t;
  let e = t + "";
  return e == "0" && 1 / t == -TN ? "-0" : e;
}
function AN(t) {
  return t == null ? "" : kN(t);
}
function di(t) {
  return typeof t == "string";
}
function $E(t) {
  return typeof t == "number";
}
function ON(t) {
  return t === !0 || t === !1 || xN(t) && zE(t) == "[object Boolean]";
}
function qE(t) {
  return typeof t == "object";
}
function xN(t) {
  return qE(t) && t !== null;
}
function Jn(t) {
  return t != null;
}
function hf(t) {
  return !t.trim().length;
}
function zE(t) {
  return t == null ? t === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(t);
}
const RN = "Incorrect 'index' type", NN = (t) => `Invalid value for key ${t}`, MN = (t) => `Pattern length exceeds max of ${t}.`, PN = (t) => `Missing ${t} property in key`, DN = (t) => `Property 'weight' in key '${t}' must be a positive integer`, My = Object.prototype.hasOwnProperty;
class LN {
  constructor(e) {
    this._keys = [], this._keyMap = {};
    let n = 0;
    e.forEach((r) => {
      let i = KE(r);
      n += i.weight, this._keys.push(i), this._keyMap[i.id] = i, n += i.weight;
    }), this._keys.forEach((r) => {
      r.weight /= n;
    });
  }
  get(e) {
    return this._keyMap[e];
  }
  keys() {
    return this._keys;
  }
  toJSON() {
    return JSON.stringify(this._keys);
  }
}
function KE(t) {
  let e = null, n = null, r = null, i = 1;
  if (di(t) || mi(t))
    r = t, e = Py(t), n = Jh(t);
  else {
    if (!My.call(t, "name"))
      throw new Error(PN("name"));
    const o = t.name;
    if (r = o, My.call(t, "weight") && (i = t.weight, i <= 0))
      throw new Error(DN(o));
    e = Py(o), n = Jh(o);
  }
  return { path: e, id: n, weight: i, src: r };
}
function Py(t) {
  return mi(t) ? t : t.split(".");
}
function Jh(t) {
  return mi(t) ? t.join(".") : t;
}
function FN(t, e) {
  let n = [], r = !1;
  const i = (o, a, s) => {
    if (Jn(o))
      if (!a[s])
        n.push(o);
      else {
        let c = a[s];
        const l = o[c];
        if (!Jn(l))
          return;
        if (s === a.length - 1 && (di(l) || $E(l) || ON(l)))
          n.push(AN(l));
        else if (mi(l)) {
          r = !0;
          for (let u = 0, d = l.length; u < d; u += 1)
            i(l[u], a, s + 1);
        } else
          a.length && i(l, a, s + 1);
      }
  };
  return i(t, di(e) ? e.split(".") : e, 0), r ? n : n[0];
}
const UN = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: !1,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: !1,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
}, HN = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: !1,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: !1,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: !0,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (t, e) => t.score === e.score ? t.idx < e.idx ? -1 : 1 : t.score < e.score ? -1 : 1
}, BN = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
}, jN = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: !1,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: FN,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: !1,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: !1,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};
var $e = {
  ...HN,
  ...UN,
  ...BN,
  ...jN
};
const VN = /[^ ]+/g;
function $N(t = 1, e = 3) {
  const n = /* @__PURE__ */ new Map(), r = Math.pow(10, e);
  return {
    get(i) {
      const o = i.match(VN).length;
      if (n.has(o))
        return n.get(o);
      const a = 1 / Math.pow(o, 0.5 * t), s = parseFloat(Math.round(a * r) / r);
      return n.set(o, s), s;
    },
    clear() {
      n.clear();
    }
  };
}
class gm {
  constructor({
    getFn: e = $e.getFn,
    fieldNormWeight: n = $e.fieldNormWeight
  } = {}) {
    this.norm = $N(n, 3), this.getFn = e, this.isCreated = !1, this.setIndexRecords();
  }
  setSources(e = []) {
    this.docs = e;
  }
  setIndexRecords(e = []) {
    this.records = e;
  }
  setKeys(e = []) {
    this.keys = e, this._keysMap = {}, e.forEach((n, r) => {
      this._keysMap[n.id] = r;
    });
  }
  create() {
    this.isCreated || !this.docs.length || (this.isCreated = !0, di(this.docs[0]) ? this.docs.forEach((e, n) => {
      this._addString(e, n);
    }) : this.docs.forEach((e, n) => {
      this._addObject(e, n);
    }), this.norm.clear());
  }
  // Adds a doc to the end of the index
  add(e) {
    const n = this.size();
    di(e) ? this._addString(e, n) : this._addObject(e, n);
  }
  // Removes the doc at the specified index of the index
  removeAt(e) {
    this.records.splice(e, 1);
    for (let n = e, r = this.size(); n < r; n += 1)
      this.records[n].i -= 1;
  }
  getValueForItemAtKeyId(e, n) {
    return e[this._keysMap[n]];
  }
  size() {
    return this.records.length;
  }
  _addString(e, n) {
    if (!Jn(e) || hf(e))
      return;
    let r = {
      v: e,
      i: n,
      n: this.norm.get(e)
    };
    this.records.push(r);
  }
  _addObject(e, n) {
    let r = { i: n, $: {} };
    this.keys.forEach((i, o) => {
      let a = this.getFn(e, i.path);
      if (Jn(a)) {
        if (mi(a)) {
          let s = [];
          const c = [{ nestedArrIndex: -1, value: a }];
          for (; c.length; ) {
            const { nestedArrIndex: l, value: u } = c.pop();
            if (Jn(u))
              if (di(u) && !hf(u)) {
                let d = {
                  v: u,
                  i: l,
                  n: this.norm.get(u)
                };
                s.push(d);
              } else
                mi(u) && u.forEach((d, f) => {
                  c.push({
                    nestedArrIndex: f,
                    value: d
                  });
                });
          }
          r.$[o] = s;
        } else if (!hf(a)) {
          let s = {
            v: a,
            n: this.norm.get(a)
          };
          r.$[o] = s;
        }
      }
    }), this.records.push(r);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    };
  }
}
function WE(t, e, { getFn: n = $e.getFn, fieldNormWeight: r = $e.fieldNormWeight } = {}) {
  const i = new gm({ getFn: n, fieldNormWeight: r });
  return i.setKeys(t.map(KE)), i.setSources(e), i.create(), i;
}
function qN(t, { getFn: e = $e.getFn, fieldNormWeight: n = $e.fieldNormWeight } = {}) {
  const { keys: r, records: i } = t, o = new gm({ getFn: e, fieldNormWeight: n });
  return o.setKeys(r), o.setIndexRecords(i), o;
}
function tl(t, {
  errors: e = 0,
  currentLocation: n = 0,
  expectedLocation: r = 0,
  distance: i = $e.distance,
  ignoreLocation: o = $e.ignoreLocation
} = {}) {
  const a = e / t.length;
  if (o)
    return a;
  const s = Math.abs(r - n);
  return i ? a + s / i : s ? 1 : a;
}
function zN(t = [], e = $e.minMatchCharLength) {
  let n = [], r = -1, i = -1, o = 0;
  for (let a = t.length; o < a; o += 1) {
    let s = t[o];
    s && r === -1 ? r = o : !s && r !== -1 && (i = o - 1, i - r + 1 >= e && n.push([r, i]), r = -1);
  }
  return t[o - 1] && o - r >= e && n.push([r, o - 1]), n;
}
const oo = 32;
function KN(t, e, n, {
  location: r = $e.location,
  distance: i = $e.distance,
  threshold: o = $e.threshold,
  findAllMatches: a = $e.findAllMatches,
  minMatchCharLength: s = $e.minMatchCharLength,
  includeMatches: c = $e.includeMatches,
  ignoreLocation: l = $e.ignoreLocation
} = {}) {
  if (e.length > oo)
    throw new Error(MN(oo));
  const u = e.length, d = t.length, f = Math.max(0, Math.min(r, d));
  let h = o, g = f;
  const v = s > 1 || c, b = v ? Array(d) : [];
  let m;
  for (; (m = t.indexOf(e, g)) > -1; ) {
    let S = tl(e, {
      currentLocation: m,
      expectedLocation: f,
      distance: i,
      ignoreLocation: l
    });
    if (h = Math.min(S, h), g = m + u, v) {
      let T = 0;
      for (; T < u; )
        b[m + T] = 1, T += 1;
    }
  }
  g = -1;
  let y = [], p = 1, w = u + d;
  const _ = 1 << u - 1;
  for (let S = 0; S < u; S += 1) {
    let T = 0, x = w;
    for (; T < x; )
      tl(e, {
        errors: S,
        currentLocation: f + x,
        expectedLocation: f,
        distance: i,
        ignoreLocation: l
      }) <= h ? T = x : w = x, x = Math.floor((w - T) / 2 + T);
    w = x;
    let A = Math.max(1, f - x + 1), N = a ? d : Math.min(f + x, d) + u, F = Array(N + 2);
    F[N + 1] = (1 << S) - 1;
    for (let L = N; L >= A; L -= 1) {
      let z = L - 1, ne = n[t.charAt(z)];
      if (v && (b[z] = +!!ne), F[L] = (F[L + 1] << 1 | 1) & ne, S && (F[L] |= (y[L + 1] | y[L]) << 1 | 1 | y[L + 1]), F[L] & _ && (p = tl(e, {
        errors: S,
        currentLocation: z,
        expectedLocation: f,
        distance: i,
        ignoreLocation: l
      }), p <= h)) {
        if (h = p, g = z, g <= f)
          break;
        A = Math.max(1, 2 * f - g);
      }
    }
    if (tl(e, {
      errors: S + 1,
      currentLocation: f,
      expectedLocation: f,
      distance: i,
      ignoreLocation: l
    }) > h)
      break;
    y = F;
  }
  const E = {
    isMatch: g >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(1e-3, p)
  };
  if (v) {
    const S = zN(b, s);
    S.length ? c && (E.indices = S) : E.isMatch = !1;
  }
  return E;
}
function WN(t) {
  let e = {};
  for (let n = 0, r = t.length; n < r; n += 1) {
    const i = t.charAt(n);
    e[i] = (e[i] || 0) | 1 << r - n - 1;
  }
  return e;
}
class GE {
  constructor(e, {
    location: n = $e.location,
    threshold: r = $e.threshold,
    distance: i = $e.distance,
    includeMatches: o = $e.includeMatches,
    findAllMatches: a = $e.findAllMatches,
    minMatchCharLength: s = $e.minMatchCharLength,
    isCaseSensitive: c = $e.isCaseSensitive,
    ignoreLocation: l = $e.ignoreLocation
  } = {}) {
    if (this.options = {
      location: n,
      threshold: r,
      distance: i,
      includeMatches: o,
      findAllMatches: a,
      minMatchCharLength: s,
      isCaseSensitive: c,
      ignoreLocation: l
    }, this.pattern = c ? e : e.toLowerCase(), this.chunks = [], !this.pattern.length)
      return;
    const u = (f, h) => {
      this.chunks.push({
        pattern: f,
        alphabet: WN(f),
        startIndex: h
      });
    }, d = this.pattern.length;
    if (d > oo) {
      let f = 0;
      const h = d % oo, g = d - h;
      for (; f < g; )
        u(this.pattern.substr(f, oo), f), f += oo;
      if (h) {
        const v = d - oo;
        u(this.pattern.substr(v), v);
      }
    } else
      u(this.pattern, 0);
  }
  searchIn(e) {
    const { isCaseSensitive: n, includeMatches: r } = this.options;
    if (n || (e = e.toLowerCase()), this.pattern === e) {
      let g = {
        isMatch: !0,
        score: 0
      };
      return r && (g.indices = [[0, e.length - 1]]), g;
    }
    const {
      location: i,
      distance: o,
      threshold: a,
      findAllMatches: s,
      minMatchCharLength: c,
      ignoreLocation: l
    } = this.options;
    let u = [], d = 0, f = !1;
    this.chunks.forEach(({ pattern: g, alphabet: v, startIndex: b }) => {
      const { isMatch: m, score: y, indices: p } = KN(e, g, v, {
        location: i + b,
        distance: o,
        threshold: a,
        findAllMatches: s,
        minMatchCharLength: c,
        includeMatches: r,
        ignoreLocation: l
      });
      m && (f = !0), d += y, m && p && (u = [...u, ...p]);
    });
    let h = {
      isMatch: f,
      score: f ? d / this.chunks.length : 1
    };
    return f && r && (h.indices = u), h;
  }
}
class Yi {
  constructor(e) {
    this.pattern = e;
  }
  static isMultiMatch(e) {
    return Dy(e, this.multiRegex);
  }
  static isSingleMatch(e) {
    return Dy(e, this.singleRegex);
  }
  search() {
  }
}
function Dy(t, e) {
  const n = t.match(e);
  return n ? n[1] : null;
}
class GN extends Yi {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "exact";
  }
  static get multiRegex() {
    return /^="(.*)"$/;
  }
  static get singleRegex() {
    return /^=(.*)$/;
  }
  search(e) {
    const n = e === this.pattern;
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class YN extends Yi {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "inverse-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"$/;
  }
  static get singleRegex() {
    return /^!(.*)$/;
  }
  search(e) {
    const r = e.indexOf(this.pattern) === -1;
    return {
      isMatch: r,
      score: r ? 0 : 1,
      indices: [0, e.length - 1]
    };
  }
}
class QN extends Yi {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "prefix-exact";
  }
  static get multiRegex() {
    return /^\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^\^(.*)$/;
  }
  search(e) {
    const n = e.startsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    };
  }
}
class JN extends Yi {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "inverse-prefix-exact";
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/;
  }
  static get singleRegex() {
    return /^!\^(.*)$/;
  }
  search(e) {
    const n = !e.startsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, e.length - 1]
    };
  }
}
class ZN extends Yi {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "suffix-exact";
  }
  static get multiRegex() {
    return /^"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^(.*)\$$/;
  }
  search(e) {
    const n = e.endsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [e.length - this.pattern.length, e.length - 1]
    };
  }
}
class XN extends Yi {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "inverse-suffix-exact";
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/;
  }
  static get singleRegex() {
    return /^!(.*)\$$/;
  }
  search(e) {
    const n = !e.endsWith(this.pattern);
    return {
      isMatch: n,
      score: n ? 0 : 1,
      indices: [0, e.length - 1]
    };
  }
}
class YE extends Yi {
  constructor(e, {
    location: n = $e.location,
    threshold: r = $e.threshold,
    distance: i = $e.distance,
    includeMatches: o = $e.includeMatches,
    findAllMatches: a = $e.findAllMatches,
    minMatchCharLength: s = $e.minMatchCharLength,
    isCaseSensitive: c = $e.isCaseSensitive,
    ignoreLocation: l = $e.ignoreLocation
  } = {}) {
    super(e), this._bitapSearch = new GE(e, {
      location: n,
      threshold: r,
      distance: i,
      includeMatches: o,
      findAllMatches: a,
      minMatchCharLength: s,
      isCaseSensitive: c,
      ignoreLocation: l
    });
  }
  static get type() {
    return "fuzzy";
  }
  static get multiRegex() {
    return /^"(.*)"$/;
  }
  static get singleRegex() {
    return /^(.*)$/;
  }
  search(e) {
    return this._bitapSearch.searchIn(e);
  }
}
class QE extends Yi {
  constructor(e) {
    super(e);
  }
  static get type() {
    return "include";
  }
  static get multiRegex() {
    return /^'"(.*)"$/;
  }
  static get singleRegex() {
    return /^'(.*)$/;
  }
  search(e) {
    let n = 0, r;
    const i = [], o = this.pattern.length;
    for (; (r = e.indexOf(this.pattern, n)) > -1; )
      n = r + o, i.push([r, n - 1]);
    const a = !!i.length;
    return {
      isMatch: a,
      score: a ? 0 : 1,
      indices: i
    };
  }
}
const Zh = [
  GN,
  QE,
  QN,
  JN,
  XN,
  ZN,
  YN,
  YE
], Ly = Zh.length, e9 = / +(?=([^\"]*\"[^\"]*\")*[^\"]*$)/, t9 = "|";
function n9(t, e = {}) {
  return t.split(t9).map((n) => {
    let r = n.trim().split(e9).filter((o) => o && !!o.trim()), i = [];
    for (let o = 0, a = r.length; o < a; o += 1) {
      const s = r[o];
      let c = !1, l = -1;
      for (; !c && ++l < Ly; ) {
        const u = Zh[l];
        let d = u.isMultiMatch(s);
        d && (i.push(new u(d, e)), c = !0);
      }
      if (!c)
        for (l = -1; ++l < Ly; ) {
          const u = Zh[l];
          let d = u.isSingleMatch(s);
          if (d) {
            i.push(new u(d, e));
            break;
          }
        }
    }
    return i;
  });
}
const r9 = /* @__PURE__ */ new Set([YE.type, QE.type]);
class i9 {
  constructor(e, {
    isCaseSensitive: n = $e.isCaseSensitive,
    includeMatches: r = $e.includeMatches,
    minMatchCharLength: i = $e.minMatchCharLength,
    ignoreLocation: o = $e.ignoreLocation,
    findAllMatches: a = $e.findAllMatches,
    location: s = $e.location,
    threshold: c = $e.threshold,
    distance: l = $e.distance
  } = {}) {
    this.query = null, this.options = {
      isCaseSensitive: n,
      includeMatches: r,
      minMatchCharLength: i,
      findAllMatches: a,
      ignoreLocation: o,
      location: s,
      threshold: c,
      distance: l
    }, this.pattern = n ? e : e.toLowerCase(), this.query = n9(this.pattern, this.options);
  }
  static condition(e, n) {
    return n.useExtendedSearch;
  }
  searchIn(e) {
    const n = this.query;
    if (!n)
      return {
        isMatch: !1,
        score: 1
      };
    const { includeMatches: r, isCaseSensitive: i } = this.options;
    e = i ? e : e.toLowerCase();
    let o = 0, a = [], s = 0;
    for (let c = 0, l = n.length; c < l; c += 1) {
      const u = n[c];
      a.length = 0, o = 0;
      for (let d = 0, f = u.length; d < f; d += 1) {
        const h = u[d], { isMatch: g, indices: v, score: b } = h.search(e);
        if (g) {
          if (o += 1, s += b, r) {
            const m = h.constructor.type;
            r9.has(m) ? a = [...a, ...v] : a.push(v);
          }
        } else {
          s = 0, o = 0, a.length = 0;
          break;
        }
      }
      if (o) {
        let d = {
          isMatch: !0,
          score: s / o
        };
        return r && (d.indices = a), d;
      }
    }
    return {
      isMatch: !1,
      score: 1
    };
  }
}
const Xh = [];
function o9(...t) {
  Xh.push(...t);
}
function ep(t, e) {
  for (let n = 0, r = Xh.length; n < r; n += 1) {
    let i = Xh[n];
    if (i.condition(t, e))
      return new i(t, e);
  }
  return new GE(t, e);
}
const mu = {
  AND: "$and",
  OR: "$or"
}, tp = {
  PATH: "$path",
  PATTERN: "$val"
}, np = (t) => !!(t[mu.AND] || t[mu.OR]), a9 = (t) => !!t[tp.PATH], s9 = (t) => !mi(t) && qE(t) && !np(t), Fy = (t) => ({
  [mu.AND]: Object.keys(t).map((e) => ({
    [e]: t[e]
  }))
});
function JE(t, e, { auto: n = !0 } = {}) {
  const r = (i) => {
    let o = Object.keys(i);
    const a = a9(i);
    if (!a && o.length > 1 && !np(i))
      return r(Fy(i));
    if (s9(i)) {
      const c = a ? i[tp.PATH] : o[0], l = a ? i[tp.PATTERN] : i[c];
      if (!di(l))
        throw new Error(NN(c));
      const u = {
        keyId: Jh(c),
        pattern: l
      };
      return n && (u.searcher = ep(l, e)), u;
    }
    let s = {
      children: [],
      operator: o[0]
    };
    return o.forEach((c) => {
      const l = i[c];
      mi(l) && l.forEach((u) => {
        s.children.push(r(u));
      });
    }), s;
  };
  return np(t) || (t = Fy(t)), r(t);
}
function c9(t, { ignoreFieldNorm: e = $e.ignoreFieldNorm }) {
  t.forEach((n) => {
    let r = 1;
    n.matches.forEach(({ key: i, norm: o, score: a }) => {
      const s = i ? i.weight : null;
      r *= Math.pow(
        a === 0 && s ? Number.EPSILON : a,
        (s || 1) * (e ? 1 : o)
      );
    }), n.score = r;
  });
}
function l9(t, e) {
  const n = t.matches;
  e.matches = [], Jn(n) && n.forEach((r) => {
    if (!Jn(r.indices) || !r.indices.length)
      return;
    const { indices: i, value: o } = r;
    let a = {
      indices: i,
      value: o
    };
    r.key && (a.key = r.key.src), r.idx > -1 && (a.refIndex = r.idx), e.matches.push(a);
  });
}
function u9(t, e) {
  e.score = t.score;
}
function d9(t, e, {
  includeMatches: n = $e.includeMatches,
  includeScore: r = $e.includeScore
} = {}) {
  const i = [];
  return n && i.push(l9), r && i.push(u9), t.map((o) => {
    const { idx: a } = o, s = {
      item: e[a],
      refIndex: a
    };
    return i.length && i.forEach((c) => {
      c(o, s);
    }), s;
  });
}
class Wa {
  constructor(e, n = {}, r) {
    this.options = { ...$e, ...n }, this.options.useExtendedSearch, this._keyStore = new LN(this.options.keys), this.setCollection(e, r);
  }
  setCollection(e, n) {
    if (this._docs = e, n && !(n instanceof gm))
      throw new Error(RN);
    this._myIndex = n || WE(this.options.keys, this._docs, {
      getFn: this.options.getFn,
      fieldNormWeight: this.options.fieldNormWeight
    });
  }
  add(e) {
    Jn(e) && (this._docs.push(e), this._myIndex.add(e));
  }
  remove(e = () => !1) {
    const n = [];
    for (let r = 0, i = this._docs.length; r < i; r += 1) {
      const o = this._docs[r];
      e(o, r) && (this.removeAt(r), r -= 1, i -= 1, n.push(o));
    }
    return n;
  }
  removeAt(e) {
    this._docs.splice(e, 1), this._myIndex.removeAt(e);
  }
  getIndex() {
    return this._myIndex;
  }
  search(e, { limit: n = -1 } = {}) {
    const {
      includeMatches: r,
      includeScore: i,
      shouldSort: o,
      sortFn: a,
      ignoreFieldNorm: s
    } = this.options;
    let c = di(e) ? di(this._docs[0]) ? this._searchStringList(e) : this._searchObjectList(e) : this._searchLogical(e);
    return c9(c, { ignoreFieldNorm: s }), o && c.sort(a), $E(n) && n > -1 && (c = c.slice(0, n)), d9(c, this._docs, {
      includeMatches: r,
      includeScore: i
    });
  }
  _searchStringList(e) {
    const n = ep(e, this.options), { records: r } = this._myIndex, i = [];
    return r.forEach(({ v: o, i: a, n: s }) => {
      if (!Jn(o))
        return;
      const { isMatch: c, score: l, indices: u } = n.searchIn(o);
      c && i.push({
        item: o,
        idx: a,
        matches: [{ score: l, value: o, norm: s, indices: u }]
      });
    }), i;
  }
  _searchLogical(e) {
    const n = JE(e, this.options), r = (s, c, l) => {
      if (!s.children) {
        const { keyId: d, searcher: f } = s, h = this._findMatches({
          key: this._keyStore.get(d),
          value: this._myIndex.getValueForItemAtKeyId(c, d),
          searcher: f
        });
        return h && h.length ? [
          {
            idx: l,
            item: c,
            matches: h
          }
        ] : [];
      }
      const u = [];
      for (let d = 0, f = s.children.length; d < f; d += 1) {
        const h = s.children[d], g = r(h, c, l);
        if (g.length)
          u.push(...g);
        else if (s.operator === mu.AND)
          return [];
      }
      return u;
    }, i = this._myIndex.records, o = {}, a = [];
    return i.forEach(({ $: s, i: c }) => {
      if (Jn(s)) {
        let l = r(n, s, c);
        l.length && (o[c] || (o[c] = { idx: c, item: s, matches: [] }, a.push(o[c])), l.forEach(({ matches: u }) => {
          o[c].matches.push(...u);
        }));
      }
    }), a;
  }
  _searchObjectList(e) {
    const n = ep(e, this.options), { keys: r, records: i } = this._myIndex, o = [];
    return i.forEach(({ $: a, i: s }) => {
      if (!Jn(a))
        return;
      let c = [];
      r.forEach((l, u) => {
        c.push(
          ...this._findMatches({
            key: l,
            value: a[u],
            searcher: n
          })
        );
      }), c.length && o.push({
        idx: s,
        item: a,
        matches: c
      });
    }), o;
  }
  _findMatches({ key: e, value: n, searcher: r }) {
    if (!Jn(n))
      return [];
    let i = [];
    if (mi(n))
      n.forEach(({ v: o, i: a, n: s }) => {
        if (!Jn(o))
          return;
        const { isMatch: c, score: l, indices: u } = r.searchIn(o);
        c && i.push({
          score: l,
          key: e,
          value: o,
          idx: a,
          norm: s,
          indices: u
        });
      });
    else {
      const { v: o, n: a } = n, { isMatch: s, score: c, indices: l } = r.searchIn(o);
      s && i.push({ score: c, key: e, value: o, norm: a, indices: l });
    }
    return i;
  }
}
Wa.version = "6.5.3";
Wa.createIndex = WE;
Wa.parseIndex = qN;
Wa.config = $e;
Wa.parseQuery = JE;
o9(i9);
const ZE = xu(
  ({
    label: t,
    children: e,
    error: n,
    helperText: r,
    invalid: i,
    className: o,
    variant: a = "border",
    align: s = "left",
    iconLeft: c,
    iconLeftStatus: l = "decorative",
    iconRight: u,
    iconRightStatus: d = "action",
    isObfuscated: f = !1,
    onSubmit: h,
    onKeyUp: g,
    ...v
  }, b) => {
    const m = bn(), y = v.id ?? m, p = f9(a ?? "", s), w = h9(a ?? "", i ?? !1);
    return /* @__PURE__ */ K(
      "div",
      {
        className: j("text-t16 text-input-txt font-normal", o),
        children: [
          t && /* @__PURE__ */ K("div", { className: "pb-8", children: [
            /* @__PURE__ */ C("label", { htmlFor: y, className: "text-input-label font-semibold", children: t }),
            r && /* @__PURE__ */ C("p", { className: "text-font-secondary", children: r })
          ] }),
          /* @__PURE__ */ K("div", { className: "relative flex items-center placeholder:text-input-place focus-within:font-medium focus-within:text-input-txt-focus", children: [
            c && /* @__PURE__ */ C(
              "div",
              {
                className: j("absolute left-12 cursor-pointer", {
                  "text-input-txt-disabled cursor-auto": v.disabled,
                  "pointer-events-none cursor-auto": l === "decorative"
                }),
                children: c
              }
            ),
            /* @__PURE__ */ C("div", { className: "w-full", children: /* @__PURE__ */ C(
              "input",
              {
                ref: b,
                type: f ? "password" : "text",
                className: j(p, w, {
                  "pl-48": c,
                  "pl-18": !c,
                  "pr-48": u,
                  "pr-18": !u
                }),
                id: y,
                onKeyUp: (_) => {
                  _.key === "Enter" && h && h(), g && g(_);
                },
                ...v,
                children: e
              }
            ) }),
            u && /* @__PURE__ */ C(
              "div",
              {
                className: j("absolute right-12", {
                  "text-input-txt-disabled": v.disabled,
                  "pointer-events-none": d === "decorative" || v.disabled
                }),
                children: u
              }
            )
          ] }),
          n && /* @__PURE__ */ C("p", { className: "text-action-error text-t16 mt-4", children: n })
        ]
      }
    );
  }
), f9 = (t, e) => {
  const n = j(
    "h-full min-h-48 px-18 w-full text-t16",
    "placeholder:text-input-place bg-input-background",
    `text-${e}`,
    "disabled:text-input-txt-disabled disabled:placeholder:text-input-place-disabled disabled:bg-input-background-disabled disabled:outline-input-border-disabled disabled:cursor-not-allowed",
    "invalid:outline-input-border-error invalid:outline-2 invalid:outline-offset-[-2px]",
    "hover:outline-input-border-hover hover:outline-2 hover:outline-offset-[-2px]"
  );
  switch (t) {
    case "plain":
      return j(
        n,
        "border-transparent outline outline-1 outline-transparent outline-offset-[-1px]"
      );
    case "border":
    default:
      return j(
        n,
        "border-1 border-solid border-transparent rounded outline outline-1 outline-input-border outline-offset-[-1px]"
      );
  }
}, h9 = (t, e) => {
  switch (t) {
    case "plain":
    default:
      return j({
        "outline-input-border-error outline-2 outline-offset-[-2px] focus:outline-input-border-error focus:invalid:outline-input-border-error ": e,
        "outline-input-border outline-1 outline-offset-[-1px] focus:outline-input-border-focus focus:outline-2 outline-offset-[-1px] focus:outline-offset-[-2px]": !e
      });
  }
};
function oY({
  value: t,
  onChange: e,
  onSubmit: n,
  items: r,
  itemToString: i = Np,
  itemToKey: o = Kw,
  searchKeys: a = ["label"],
  placeholder: s,
  label: c,
  error: l,
  className: u,
  disabled: d
}) {
  const [f, h] = et(null), g = Tr(
    () => new Wa(r, {
      keys: a,
      getFn: i
    }),
    [i, r, a]
  ), v = Tr(
    () => {
      var x;
      return f ? (x = g.search(f)) == null ? void 0 : x.map((A) => A.item) : r;
    },
    [f, r, g]
  ), {
    isOpen: b,
    getLabelProps: m,
    getMenuProps: y,
    getInputProps: p,
    getComboboxProps: w,
    highlightedIndex: _,
    getItemProps: E
  } = pm({
    defaultSelectedItem: t,
    items: v,
    itemToString: i,
    onInputValueChange: ({ inputValue: x }) => {
      h(x);
    },
    onSelectedItemChange: ({ selectedItem: x }) => {
      e && e(x), n && n();
    }
  }), S = p(), T = `${S.id}-errormessage`;
  return /* @__PURE__ */ K("div", { role: "group", className: j("relative", u), children: [
    c && /* @__PURE__ */ C(
      "label",
      {
        className: "text-input-label text-t16 font-semibold",
        ...m(),
        children: c
      }
    ),
    /* @__PURE__ */ K("div", { className: "mt-4", "aria-label": c, ...w(), children: [
      /* @__PURE__ */ C(
        ZE,
        {
          disabled: d,
          ...S,
          onSubmit: n,
          placeholder: s,
          "aria-errormessage": T
        }
      ),
      /* @__PURE__ */ C(
        Nc,
        {
          className: j(
            "absolute mt-1 z-30 min-w-full overflow-hidden bg-white",
            {
              hidden: !b || d
            }
          ),
          children: /* @__PURE__ */ C(
            "ul",
            {
              ...y(),
              className: "max-h-320 overflow-y-auto focus-visible:outline-none",
              children: b && v.map((x, A) => /* @__PURE__ */ C(
                "li",
                {
                  className: j("p-16 text-font-primary", {
                    "bg-menu-active/50": _ === A
                  }),
                  ...E({ item: x, index: A }),
                  children: i(x)
                },
                o(x)
              ))
            }
          )
        }
      ),
      l && /* @__PURE__ */ C("span", { id: T, className: "text-action-error text-t16", children: l })
    ] })
  ] });
}
function vu(t) {
  "@babel/helpers - typeof";
  return vu = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vu(t);
}
function xr(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function Lt(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function Pt(t) {
  Lt(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || vu(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Uy(t, e) {
  Lt(2, arguments);
  var n = Pt(t), r = xr(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var i = n.getDate(), o = new Date(n.getTime());
  o.setMonth(n.getMonth() + r + 1, 0);
  var a = o.getDate();
  return i >= a ? o : (n.setFullYear(o.getFullYear(), o.getMonth(), i), n);
}
function XE(t, e) {
  Lt(2, arguments);
  var n = Pt(t).getTime(), r = xr(e);
  return new Date(n + r);
}
var p9 = 36e5;
function g9(t, e) {
  Lt(2, arguments);
  var n = xr(e);
  return XE(t, n * p9);
}
var m9 = {};
function Ga() {
  return m9;
}
function v9(t, e) {
  var n, r, i, o, a, s, c, l;
  Lt(1, arguments);
  var u = Ga(), d = xr((n = (r = (i = (o = e == null ? void 0 : e.weekStartsOn) !== null && o !== void 0 ? o : e == null || (a = e.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Pt(t), h = f.getDay(), g = (h < d ? 7 : 0) + h - d;
  return f.setDate(f.getDate() - g), f.setHours(0, 0, 0, 0), f;
}
function y9(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function ga(t) {
  Lt(1, arguments);
  var e = Pt(t);
  return e.setHours(0, 0, 0, 0), e;
}
function w9(t) {
  return Lt(1, arguments), t instanceof Date || vu(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function b9(t) {
  if (Lt(1, arguments), !w9(t) && typeof t != "number")
    return !1;
  var e = Pt(t);
  return !isNaN(Number(e));
}
function _9(t) {
  Lt(1, arguments);
  var e = Pt(t);
  return e.setHours(23, 59, 59, 999), e;
}
function Hy(t) {
  Lt(1, arguments);
  var e = Pt(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function eC(t, e) {
  var n;
  Lt(1, arguments);
  var r = t || {}, i = Pt(r.start), o = Pt(r.end), a = o.getTime();
  if (!(i.getTime() <= a))
    throw new RangeError("Invalid interval");
  var s = [], c = i;
  c.setHours(0, 0, 0, 0);
  var l = Number((n = e == null ? void 0 : e.step) !== null && n !== void 0 ? n : 1);
  if (l < 1 || isNaN(l))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; c.getTime() <= a; )
    s.push(Pt(c)), c.setDate(c.getDate() + l), c.setHours(0, 0, 0, 0);
  return s;
}
function E9(t, e) {
  var n;
  Lt(1, arguments);
  var r = t || {}, i = Pt(r.start), o = Pt(r.end), a = i.getTime(), s = o.getTime();
  if (!(a <= s))
    throw new RangeError("Invalid interval");
  var c = [], l = i;
  l.setMinutes(0, 0, 0);
  var u = Number((n = e == null ? void 0 : e.step) !== null && n !== void 0 ? n : 1);
  if (u < 1 || isNaN(u))
    throw new RangeError("`options.step` must be a number greater than 1");
  for (; l.getTime() <= s; )
    c.push(Pt(l)), l = g9(l, u);
  return c;
}
function By(t) {
  Lt(1, arguments);
  var e = Pt(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function C9(t, e) {
  var n, r, i, o, a, s, c, l;
  Lt(1, arguments);
  var u = Ga(), d = xr((n = (r = (i = (o = e == null ? void 0 : e.weekStartsOn) !== null && o !== void 0 ? o : e == null || (a = e.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Pt(t), h = f.getDay(), g = (h < d ? -7 : 0) + 6 - (h - d);
  return f.setDate(f.getDate() + g), f.setHours(23, 59, 59, 999), f;
}
function I9(t, e) {
  Lt(2, arguments);
  var n = xr(e);
  return XE(t, -n);
}
var S9 = 864e5;
function T9(t) {
  Lt(1, arguments);
  var e = Pt(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), i = n - r;
  return Math.floor(i / S9) + 1;
}
function yu(t) {
  Lt(1, arguments);
  var e = 1, n = Pt(t), r = n.getUTCDay(), i = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function tC(t) {
  Lt(1, arguments);
  var e = Pt(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = yu(r), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var a = yu(o);
  return e.getTime() >= i.getTime() ? n + 1 : e.getTime() >= a.getTime() ? n : n - 1;
}
function k9(t) {
  Lt(1, arguments);
  var e = tC(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = yu(n);
  return r;
}
var A9 = 6048e5;
function O9(t) {
  Lt(1, arguments);
  var e = Pt(t), n = yu(e).getTime() - k9(e).getTime();
  return Math.round(n / A9) + 1;
}
function wu(t, e) {
  var n, r, i, o, a, s, c, l;
  Lt(1, arguments);
  var u = Ga(), d = xr((n = (r = (i = (o = e == null ? void 0 : e.weekStartsOn) !== null && o !== void 0 ? o : e == null || (a = e.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : u.weekStartsOn) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Pt(t), h = f.getUTCDay(), g = (h < d ? 7 : 0) + h - d;
  return f.setUTCDate(f.getUTCDate() - g), f.setUTCHours(0, 0, 0, 0), f;
}
function nC(t, e) {
  var n, r, i, o, a, s, c, l;
  Lt(1, arguments);
  var u = Pt(t), d = u.getUTCFullYear(), f = Ga(), h = xr((n = (r = (i = (o = e == null ? void 0 : e.firstWeekContainsDate) !== null && o !== void 0 ? o : e == null || (a = e.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = f.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(d + 1, 0, h), g.setUTCHours(0, 0, 0, 0);
  var v = wu(g, e), b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(d, 0, h), b.setUTCHours(0, 0, 0, 0);
  var m = wu(b, e);
  return u.getTime() >= v.getTime() ? d + 1 : u.getTime() >= m.getTime() ? d : d - 1;
}
function x9(t, e) {
  var n, r, i, o, a, s, c, l;
  Lt(1, arguments);
  var u = Ga(), d = xr((n = (r = (i = (o = e == null ? void 0 : e.firstWeekContainsDate) !== null && o !== void 0 ? o : e == null || (a = e.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (c = u.locale) === null || c === void 0 || (l = c.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = nC(t, e), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, d), h.setUTCHours(0, 0, 0, 0);
  var g = wu(h, e);
  return g;
}
var R9 = 6048e5;
function N9(t, e) {
  Lt(1, arguments);
  var n = Pt(t), r = wu(n, e).getTime() - x9(n, e).getTime();
  return Math.round(r / R9) + 1;
}
function at(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var M9 = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return at(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : at(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return at(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return at(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return at(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return at(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return at(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, i = e.getUTCMilliseconds(), o = Math.floor(i * Math.pow(10, r - 3));
    return at(o, n.length);
  }
};
const Ci = M9;
var qo = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, P9 = {
  // Era
  G: function(e, n, r) {
    var i = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var i = e.getUTCFullYear(), o = i > 0 ? i : 1 - i;
      return r.ordinalNumber(o, {
        unit: "year"
      });
    }
    return Ci.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, i) {
    var o = nC(e, i), a = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var s = a % 100;
      return at(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(a, {
      unit: "year"
    }) : at(a, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = tC(e);
    return at(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return at(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return at(i, 2);
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var i = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return at(i, 2);
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var i = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Ci.M(e, n);
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var i = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return at(i + 1, 2);
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, i) {
    var o = N9(e, i);
    return n === "wo" ? r.ordinalNumber(o, {
      unit: "week"
    }) : at(o, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var i = O9(e);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : at(i, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : Ci.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var i = T9(e);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : at(i, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var i = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, i) {
    var o = e.getUTCDay(), a = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(a);
      case "ee":
        return at(a, 2);
      case "eo":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, i) {
    var o = e.getUTCDay(), a = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(a);
      case "cc":
        return at(a, n.length);
      case "co":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var i = e.getUTCDay(), o = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return at(o, n.length);
      case "io":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var i = e.getUTCHours(), o = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var i = e.getUTCHours(), o;
    switch (i === 12 ? o = qo.noon : i === 0 ? o = qo.midnight : o = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var i = e.getUTCHours(), o;
    switch (i >= 17 ? o = qo.evening : i >= 12 ? o = qo.afternoon : i >= 4 ? o = qo.morning : o = qo.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var i = e.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Ci.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : Ci.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var i = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : at(i, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var i = e.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : at(i, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : Ci.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : Ci.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Ci.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, i) {
    var o = i._originalDate || e, a = o.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      case "X":
        return Vy(a);
      case "XXXX":
      case "XX":
        return no(a);
      case "XXXXX":
      case "XXX":
      default:
        return no(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, i) {
    var o = i._originalDate || e, a = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return Vy(a);
      case "xxxx":
      case "xx":
        return no(a);
      case "xxxxx":
      case "xxx":
      default:
        return no(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, i) {
    var o = i._originalDate || e, a = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + jy(a, ":");
      case "OOOO":
      default:
        return "GMT" + no(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, i) {
    var o = i._originalDate || e, a = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + jy(a, ":");
      case "zzzz":
      default:
        return "GMT" + no(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, i) {
    var o = i._originalDate || e, a = Math.floor(o.getTime() / 1e3);
    return at(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, i) {
    var o = i._originalDate || e, a = o.getTime();
    return at(a, n.length);
  }
};
function jy(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), i = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(i);
  var a = e || "";
  return n + String(i) + a + at(o, 2);
}
function Vy(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + at(Math.abs(t) / 60, 2);
  }
  return no(t, e);
}
function no(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", i = Math.abs(t), o = at(Math.floor(i / 60), 2), a = at(i % 60, 2);
  return r + o + n + a;
}
const D9 = P9;
var $y = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, rC = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, L9 = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], i = r[1], o = r[2];
  if (!o)
    return $y(e, n);
  var a;
  switch (i) {
    case "P":
      a = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = n.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", $y(i, n)).replace("{{time}}", rC(o, n));
}, F9 = {
  p: rC,
  P: L9
};
const U9 = F9;
var H9 = ["D", "DD"], B9 = ["YY", "YYYY"];
function j9(t) {
  return H9.indexOf(t) !== -1;
}
function V9(t) {
  return B9.indexOf(t) !== -1;
}
function qy(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var $9 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, q9 = function(e, n, r) {
  var i, o = $9[e];
  return typeof o == "string" ? i = o : n === 1 ? i = o.one : i = o.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
const z9 = q9;
function pf(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var K9 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, W9 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, G9 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Y9 = {
  date: pf({
    formats: K9,
    defaultWidth: "full"
  }),
  time: pf({
    formats: W9,
    defaultWidth: "full"
  }),
  dateTime: pf({
    formats: G9,
    defaultWidth: "full"
  })
};
const Q9 = Y9;
var J9 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Z9 = function(e, n, r, i) {
  return J9[e];
};
const X9 = Z9;
function hs(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && t.formattingValues) {
      var o = t.defaultFormattingWidth || t.defaultWidth, a = n != null && n.width ? String(n.width) : o;
      i = t.formattingValues[a] || t.formattingValues[o];
    } else {
      var s = t.defaultWidth, c = n != null && n.width ? String(n.width) : t.defaultWidth;
      i = t.values[c] || t.values[s];
    }
    var l = t.argumentCallback ? t.argumentCallback(e) : e;
    return i[l];
  };
}
var eM = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, tM = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, nM = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, rM = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, iM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, oM = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, aM = function(e, n) {
  var r = Number(e), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, sM = {
  ordinalNumber: aM,
  era: hs({
    values: eM,
    defaultWidth: "wide"
  }),
  quarter: hs({
    values: tM,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: hs({
    values: nM,
    defaultWidth: "wide"
  }),
  day: hs({
    values: rM,
    defaultWidth: "wide"
  }),
  dayPeriod: hs({
    values: iM,
    defaultWidth: "wide",
    formattingValues: oM,
    defaultFormattingWidth: "wide"
  })
};
const cM = sM;
function ps(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], o = e.match(i);
    if (!o)
      return null;
    var a = o[0], s = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], c = Array.isArray(s) ? uM(s, function(d) {
      return d.test(a);
    }) : lM(s, function(d) {
      return d.test(a);
    }), l;
    l = t.valueCallback ? t.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
    var u = e.slice(a.length);
    return {
      value: l,
      rest: u
    };
  };
}
function lM(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function uM(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function dM(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r)
      return null;
    var i = r[0], o = e.match(t.parsePattern);
    if (!o)
      return null;
    var a = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = e.slice(i.length);
    return {
      value: a,
      rest: s
    };
  };
}
var fM = /^(\d+)(th|st|nd|rd)?/i, hM = /\d+/i, pM = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, gM = {
  any: [/^b/i, /^(a|c)/i]
}, mM = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, vM = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, yM = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, wM = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, bM = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, _M = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, EM = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, CM = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, IM = {
  ordinalNumber: dM({
    matchPattern: fM,
    parsePattern: hM,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: ps({
    matchPatterns: pM,
    defaultMatchWidth: "wide",
    parsePatterns: gM,
    defaultParseWidth: "any"
  }),
  quarter: ps({
    matchPatterns: mM,
    defaultMatchWidth: "wide",
    parsePatterns: vM,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: ps({
    matchPatterns: yM,
    defaultMatchWidth: "wide",
    parsePatterns: wM,
    defaultParseWidth: "any"
  }),
  day: ps({
    matchPatterns: bM,
    defaultMatchWidth: "wide",
    parsePatterns: _M,
    defaultParseWidth: "any"
  }),
  dayPeriod: ps({
    matchPatterns: EM,
    defaultMatchWidth: "any",
    parsePatterns: CM,
    defaultParseWidth: "any"
  })
};
const SM = IM;
var TM = {
  code: "en-US",
  formatDistance: z9,
  formatLong: Q9,
  formatRelative: X9,
  localize: cM,
  match: SM,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const kM = TM;
var AM = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, OM = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, xM = /^'([^]*?)'?$/, RM = /''/g, NM = /[a-zA-Z]/;
function mm(t, e, n) {
  var r, i, o, a, s, c, l, u, d, f, h, g, v, b, m, y, p, w;
  Lt(2, arguments);
  var _ = String(e), E = Ga(), S = (r = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : E.locale) !== null && r !== void 0 ? r : kM, T = xr((o = (a = (s = (c = n == null ? void 0 : n.firstWeekContainsDate) !== null && c !== void 0 ? c : n == null || (l = n.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : E.firstWeekContainsDate) !== null && a !== void 0 ? a : (d = E.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(T >= 1 && T <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var x = xr((h = (g = (v = (b = n == null ? void 0 : n.weekStartsOn) !== null && b !== void 0 ? b : n == null || (m = n.locale) === null || m === void 0 || (y = m.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && v !== void 0 ? v : E.weekStartsOn) !== null && g !== void 0 ? g : (p = E.locale) === null || p === void 0 || (w = p.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(x >= 0 && x <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!S.localize)
    throw new RangeError("locale must contain localize property");
  if (!S.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var A = Pt(t);
  if (!b9(A))
    throw new RangeError("Invalid time value");
  var N = y9(A), F = I9(A, N), D = {
    firstWeekContainsDate: T,
    weekStartsOn: x,
    locale: S,
    _originalDate: A
  }, L = _.match(OM).map(function(z) {
    var ne = z[0];
    if (ne === "p" || ne === "P") {
      var ae = U9[ne];
      return ae(z, S.formatLong);
    }
    return z;
  }).join("").match(AM).map(function(z) {
    if (z === "''")
      return "'";
    var ne = z[0];
    if (ne === "'")
      return MM(z);
    var ae = D9[ne];
    if (ae)
      return !(n != null && n.useAdditionalWeekYearTokens) && V9(z) && qy(z, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && j9(z) && qy(z, e, String(t)), ae(F, z, S.localize, D);
    if (ne.match(NM))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + ne + "`");
    return z;
  }).join("");
  return L;
}
function MM(t) {
  var e = t.match(xM);
  return e ? e[1].replace(RM, "'") : t;
}
function iC(t, e) {
  var n, r;
  Lt(1, arguments);
  var i = Pt(t);
  if (isNaN(i.getTime()))
    throw new RangeError("Invalid time value");
  var o = String((n = e == null ? void 0 : e.format) !== null && n !== void 0 ? n : "extended"), a = String((r = e == null ? void 0 : e.representation) !== null && r !== void 0 ? r : "complete");
  if (o !== "extended" && o !== "basic")
    throw new RangeError("format must be 'extended' or 'basic'");
  if (a !== "date" && a !== "time" && a !== "complete")
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  var s = "", c = "", l = o === "extended" ? "-" : "", u = o === "extended" ? ":" : "";
  if (a !== "time") {
    var d = at(i.getDate(), 2), f = at(i.getMonth() + 1, 2), h = at(i.getFullYear(), 4);
    s = "".concat(h).concat(l).concat(f).concat(l).concat(d);
  }
  if (a !== "date") {
    var g = i.getTimezoneOffset();
    if (g !== 0) {
      var v = Math.abs(g), b = at(Math.floor(v / 60), 2), m = at(v % 60, 2), y = g < 0 ? "+" : "-";
      c = "".concat(y).concat(b, ":").concat(m);
    } else
      c = "Z";
    var p = at(i.getHours(), 2), w = at(i.getMinutes(), 2), _ = at(i.getSeconds(), 2), E = s === "" ? "" : "T", S = [p, w, _].join(u);
    s = "".concat(s).concat(E).concat(S).concat(c);
  }
  return s;
}
function oC(t, e) {
  Lt(2, arguments);
  var n = Pt(t).getTime(), r = Pt(e.start).getTime(), i = Pt(e.end).getTime();
  if (!(r <= i))
    throw new RangeError("Invalid interval");
  return n >= r && n <= i;
}
const zy = (t) => /* @__PURE__ */ C(
  "svg",
  {
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: /* @__PURE__ */ C(
      "path",
      {
        d: "m16 4-8 8 8 8",
        stroke: "#0C1E68",
        strokeWidth: 3,
        strokeLinecap: "round"
      }
    )
  }
);
function PM(t, e, n) {
  var r = -1, i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), n = n > i ? i : n, n < 0 && (n += i), i = e > n ? 0 : n - e >>> 0, e >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = t[r + e];
  return o;
}
var DM = PM;
function LM(t, e) {
  return t === e || t !== t && e !== e;
}
var vm = LM, FM = xc, UM = Oc, HM = "[object AsyncFunction]", BM = "[object Function]", jM = "[object GeneratorFunction]", VM = "[object Proxy]";
function $M(t) {
  if (!UM(t))
    return !1;
  var e = FM(t);
  return e == BM || e == jM || e == HM || e == VM;
}
var aC = $M, qM = 9007199254740991;
function zM(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= qM;
}
var sC = zM, KM = aC, WM = sC;
function GM(t) {
  return t != null && WM(t.length) && !KM(t);
}
var cC = GM, YM = 9007199254740991, QM = /^(?:0|[1-9]\d*)$/;
function JM(t, e) {
  var n = typeof t;
  return e = e ?? YM, !!e && (n == "number" || n != "symbol" && QM.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
var lC = JM, ZM = vm, XM = cC, eP = lC, tP = Oc;
function nP(t, e, n) {
  if (!tP(n))
    return !1;
  var r = typeof e;
  return (r == "number" ? XM(n) && eP(e, n.length) : r == "string" && e in n) ? ZM(n[e], t) : !1;
}
var rP = nP, iP = B_, Ky = 1 / 0, oP = 17976931348623157e292;
function aP(t) {
  if (!t)
    return t === 0 ? t : 0;
  if (t = iP(t), t === Ky || t === -Ky) {
    var e = t < 0 ? -1 : 1;
    return e * oP;
  }
  return t === t ? t : 0;
}
var sP = aP, cP = sP;
function lP(t) {
  var e = cP(t), n = e % 1;
  return e === e ? n ? e - n : e : 0;
}
var uP = lP, dP = DM, fP = rP, hP = uP, pP = Math.ceil, gP = Math.max;
function mP(t, e, n) {
  (n ? fP(t, e, n) : e === void 0) ? e = 1 : e = gP(hP(e), 0);
  var r = t == null ? 0 : t.length;
  if (!r || e < 1)
    return [];
  for (var i = 0, o = 0, a = Array(pP(r / e)); i < r; )
    a[o++] = dP(t, i, i += e);
  return a;
}
var vP = mP;
function yP() {
  this.__data__ = [], this.size = 0;
}
var wP = yP, bP = vm;
function _P(t, e) {
  for (var n = t.length; n--; )
    if (bP(t[n][0], e))
      return n;
  return -1;
}
var sd = _P, EP = sd, CP = Array.prototype, IP = CP.splice;
function SP(t) {
  var e = this.__data__, n = EP(e, t);
  if (n < 0)
    return !1;
  var r = e.length - 1;
  return n == r ? e.pop() : IP.call(e, n, 1), --this.size, !0;
}
var TP = SP, kP = sd;
function AP(t) {
  var e = this.__data__, n = kP(e, t);
  return n < 0 ? void 0 : e[n][1];
}
var OP = AP, xP = sd;
function RP(t) {
  return xP(this.__data__, t) > -1;
}
var NP = RP, MP = sd;
function PP(t, e) {
  var n = this.__data__, r = MP(n, t);
  return r < 0 ? (++this.size, n.push([t, e])) : n[r][1] = e, this;
}
var DP = PP, LP = wP, FP = TP, UP = OP, HP = NP, BP = DP;
function Ya(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Ya.prototype.clear = LP;
Ya.prototype.delete = FP;
Ya.prototype.get = UP;
Ya.prototype.has = HP;
Ya.prototype.set = BP;
var cd = Ya, jP = cd;
function VP() {
  this.__data__ = new jP(), this.size = 0;
}
var $P = VP;
function qP(t) {
  var e = this.__data__, n = e.delete(t);
  return this.size = e.size, n;
}
var zP = qP;
function KP(t) {
  return this.__data__.get(t);
}
var WP = KP;
function GP(t) {
  return this.__data__.has(t);
}
var YP = GP, QP = Gr, JP = QP["__core-js_shared__"], ZP = JP, gf = ZP, Wy = function() {
  var t = /[^.]+$/.exec(gf && gf.keys && gf.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function XP(t) {
  return !!Wy && Wy in t;
}
var eD = XP, tD = Function.prototype, nD = tD.toString;
function rD(t) {
  if (t != null) {
    try {
      return nD.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var uC = rD, iD = aC, oD = eD, aD = Oc, sD = uC, cD = /[\\^$.*+?()[\]{}|]/g, lD = /^\[object .+?Constructor\]$/, uD = Function.prototype, dD = Object.prototype, fD = uD.toString, hD = dD.hasOwnProperty, pD = RegExp(
  "^" + fD.call(hD).replace(cD, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function gD(t) {
  if (!aD(t) || oD(t))
    return !1;
  var e = iD(t) ? pD : lD;
  return e.test(sD(t));
}
var mD = gD;
function vD(t, e) {
  return t == null ? void 0 : t[e];
}
var yD = vD, wD = mD, bD = yD;
function _D(t, e) {
  var n = bD(t, e);
  return wD(n) ? n : void 0;
}
var Qa = _D, ED = Qa, CD = Gr, ID = ED(CD, "Map"), ym = ID, SD = Qa, TD = SD(Object, "create"), ld = TD, Gy = ld;
function kD() {
  this.__data__ = Gy ? Gy(null) : {}, this.size = 0;
}
var AD = kD;
function OD(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var xD = OD, RD = ld, ND = "__lodash_hash_undefined__", MD = Object.prototype, PD = MD.hasOwnProperty;
function DD(t) {
  var e = this.__data__;
  if (RD) {
    var n = e[t];
    return n === ND ? void 0 : n;
  }
  return PD.call(e, t) ? e[t] : void 0;
}
var LD = DD, FD = ld, UD = Object.prototype, HD = UD.hasOwnProperty;
function BD(t) {
  var e = this.__data__;
  return FD ? e[t] !== void 0 : HD.call(e, t);
}
var jD = BD, VD = ld, $D = "__lodash_hash_undefined__";
function qD(t, e) {
  var n = this.__data__;
  return this.size += this.has(t) ? 0 : 1, n[t] = VD && e === void 0 ? $D : e, this;
}
var zD = qD, KD = AD, WD = xD, GD = LD, YD = jD, QD = zD;
function Ja(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Ja.prototype.clear = KD;
Ja.prototype.delete = WD;
Ja.prototype.get = GD;
Ja.prototype.has = YD;
Ja.prototype.set = QD;
var JD = Ja, Yy = JD, ZD = cd, XD = ym;
function eL() {
  this.size = 0, this.__data__ = {
    hash: new Yy(),
    map: new (XD || ZD)(),
    string: new Yy()
  };
}
var tL = eL;
function nL(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
var rL = nL, iL = rL;
function oL(t, e) {
  var n = t.__data__;
  return iL(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
}
var ud = oL, aL = ud;
function sL(t) {
  var e = aL(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
var cL = sL, lL = ud;
function uL(t) {
  return lL(this, t).get(t);
}
var dL = uL, fL = ud;
function hL(t) {
  return fL(this, t).has(t);
}
var pL = hL, gL = ud;
function mL(t, e) {
  var n = gL(this, t), r = n.size;
  return n.set(t, e), this.size += n.size == r ? 0 : 1, this;
}
var vL = mL, yL = tL, wL = cL, bL = dL, _L = pL, EL = vL;
function Za(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.clear(); ++e < n; ) {
    var r = t[e];
    this.set(r[0], r[1]);
  }
}
Za.prototype.clear = yL;
Za.prototype.delete = wL;
Za.prototype.get = bL;
Za.prototype.has = _L;
Za.prototype.set = EL;
var dC = Za, CL = cd, IL = ym, SL = dC, TL = 200;
function kL(t, e) {
  var n = this.__data__;
  if (n instanceof CL) {
    var r = n.__data__;
    if (!IL || r.length < TL - 1)
      return r.push([t, e]), this.size = ++n.size, this;
    n = this.__data__ = new SL(r);
  }
  return n.set(t, e), this.size = n.size, this;
}
var AL = kL, OL = cd, xL = $P, RL = zP, NL = WP, ML = YP, PL = AL;
function Xa(t) {
  var e = this.__data__ = new OL(t);
  this.size = e.size;
}
Xa.prototype.clear = xL;
Xa.prototype.delete = RL;
Xa.prototype.get = NL;
Xa.prototype.has = ML;
Xa.prototype.set = PL;
var DL = Xa, LL = "__lodash_hash_undefined__";
function FL(t) {
  return this.__data__.set(t, LL), this;
}
var UL = FL;
function HL(t) {
  return this.__data__.has(t);
}
var BL = HL, jL = dC, VL = UL, $L = BL;
function bu(t) {
  var e = -1, n = t == null ? 0 : t.length;
  for (this.__data__ = new jL(); ++e < n; )
    this.add(t[e]);
}
bu.prototype.add = bu.prototype.push = VL;
bu.prototype.has = $L;
var qL = bu;
function zL(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length; ++n < r; )
    if (e(t[n], n, t))
      return !0;
  return !1;
}
var KL = zL;
function WL(t, e) {
  return t.has(e);
}
var GL = WL, YL = qL, QL = KL, JL = GL, ZL = 1, XL = 2;
function eF(t, e, n, r, i, o) {
  var a = n & ZL, s = t.length, c = e.length;
  if (s != c && !(a && c > s))
    return !1;
  var l = o.get(t), u = o.get(e);
  if (l && u)
    return l == e && u == t;
  var d = -1, f = !0, h = n & XL ? new YL() : void 0;
  for (o.set(t, e), o.set(e, t); ++d < s; ) {
    var g = t[d], v = e[d];
    if (r)
      var b = a ? r(v, g, d, e, t, o) : r(g, v, d, t, e, o);
    if (b !== void 0) {
      if (b)
        continue;
      f = !1;
      break;
    }
    if (h) {
      if (!QL(e, function(m, y) {
        if (!JL(h, y) && (g === m || i(g, m, n, r, o)))
          return h.push(y);
      })) {
        f = !1;
        break;
      }
    } else if (!(g === v || i(g, v, n, r, o))) {
      f = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), f;
}
var fC = eF, tF = Gr, nF = tF.Uint8Array, rF = nF;
function iF(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r, i) {
    n[++e] = [i, r];
  }), n;
}
var oF = iF;
function aF(t) {
  var e = -1, n = Array(t.size);
  return t.forEach(function(r) {
    n[++e] = r;
  }), n;
}
var sF = aF, Qy = Fg, Jy = rF, cF = vm, lF = fC, uF = oF, dF = sF, fF = 1, hF = 2, pF = "[object Boolean]", gF = "[object Date]", mF = "[object Error]", vF = "[object Map]", yF = "[object Number]", wF = "[object RegExp]", bF = "[object Set]", _F = "[object String]", EF = "[object Symbol]", CF = "[object ArrayBuffer]", IF = "[object DataView]", Zy = Qy ? Qy.prototype : void 0, mf = Zy ? Zy.valueOf : void 0;
function SF(t, e, n, r, i, o, a) {
  switch (n) {
    case IF:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case CF:
      return !(t.byteLength != e.byteLength || !o(new Jy(t), new Jy(e)));
    case pF:
    case gF:
    case yF:
      return cF(+t, +e);
    case mF:
      return t.name == e.name && t.message == e.message;
    case wF:
    case _F:
      return t == e + "";
    case vF:
      var s = uF;
    case bF:
      var c = r & fF;
      if (s || (s = dF), t.size != e.size && !c)
        return !1;
      var l = a.get(t);
      if (l)
        return l == e;
      r |= hF, a.set(t, e);
      var u = lF(s(t), s(e), r, i, o, a);
      return a.delete(t), u;
    case EF:
      if (mf)
        return mf.call(t) == mf.call(e);
  }
  return !1;
}
var TF = SF;
function kF(t, e) {
  for (var n = -1, r = e.length, i = t.length; ++n < r; )
    t[i + n] = e[n];
  return t;
}
var AF = kF, OF = Array.isArray, wm = OF, xF = AF, RF = wm;
function NF(t, e, n) {
  var r = e(t);
  return RF(t) ? r : xF(r, n(t));
}
var MF = NF;
function PF(t, e) {
  for (var n = -1, r = t == null ? 0 : t.length, i = 0, o = []; ++n < r; ) {
    var a = t[n];
    e(a, n, t) && (o[i++] = a);
  }
  return o;
}
var DF = PF;
function LF() {
  return [];
}
var FF = LF, UF = DF, HF = FF, BF = Object.prototype, jF = BF.propertyIsEnumerable, Xy = Object.getOwnPropertySymbols, VF = Xy ? function(t) {
  return t == null ? [] : (t = Object(t), UF(Xy(t), function(e) {
    return jF.call(t, e);
  }));
} : HF, $F = VF;
function qF(t, e) {
  for (var n = -1, r = Array(t); ++n < t; )
    r[n] = e(n);
  return r;
}
var zF = qF, KF = xc, WF = Rc, GF = "[object Arguments]";
function YF(t) {
  return WF(t) && KF(t) == GF;
}
var QF = YF, e1 = QF, JF = Rc, hC = Object.prototype, ZF = hC.hasOwnProperty, XF = hC.propertyIsEnumerable, eU = e1(function() {
  return arguments;
}()) ? e1 : function(t) {
  return JF(t) && ZF.call(t, "callee") && !XF.call(t, "callee");
}, tU = eU, ac = {}, nU = {
  get exports() {
    return ac;
  },
  set exports(t) {
    ac = t;
  }
};
function rU() {
  return !1;
}
var iU = rU;
(function(t, e) {
  var n = Gr, r = iU, i = e && !e.nodeType && e, o = i && !0 && t && !t.nodeType && t, a = o && o.exports === i, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, l = c || r;
  t.exports = l;
})(nU, ac);
var oU = xc, aU = sC, sU = Rc, cU = "[object Arguments]", lU = "[object Array]", uU = "[object Boolean]", dU = "[object Date]", fU = "[object Error]", hU = "[object Function]", pU = "[object Map]", gU = "[object Number]", mU = "[object Object]", vU = "[object RegExp]", yU = "[object Set]", wU = "[object String]", bU = "[object WeakMap]", _U = "[object ArrayBuffer]", EU = "[object DataView]", CU = "[object Float32Array]", IU = "[object Float64Array]", SU = "[object Int8Array]", TU = "[object Int16Array]", kU = "[object Int32Array]", AU = "[object Uint8Array]", OU = "[object Uint8ClampedArray]", xU = "[object Uint16Array]", RU = "[object Uint32Array]", Vt = {};
Vt[CU] = Vt[IU] = Vt[SU] = Vt[TU] = Vt[kU] = Vt[AU] = Vt[OU] = Vt[xU] = Vt[RU] = !0;
Vt[cU] = Vt[lU] = Vt[_U] = Vt[uU] = Vt[EU] = Vt[dU] = Vt[fU] = Vt[hU] = Vt[pU] = Vt[gU] = Vt[mU] = Vt[vU] = Vt[yU] = Vt[wU] = Vt[bU] = !1;
function NU(t) {
  return sU(t) && aU(t.length) && !!Vt[oU(t)];
}
var MU = NU;
function PU(t) {
  return function(e) {
    return t(e);
  };
}
var DU = PU, _u = {}, LU = {
  get exports() {
    return _u;
  },
  set exports(t) {
    _u = t;
  }
};
(function(t, e) {
  var n = U_, r = e && !e.nodeType && e, i = r && !0 && t && !t.nodeType && t, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  t.exports = s;
})(LU, _u);
var FU = MU, UU = DU, t1 = _u, n1 = t1 && t1.isTypedArray, HU = n1 ? UU(n1) : FU, pC = HU, BU = zF, jU = tU, VU = wm, $U = ac, qU = lC, zU = pC, KU = Object.prototype, WU = KU.hasOwnProperty;
function GU(t, e) {
  var n = VU(t), r = !n && jU(t), i = !n && !r && $U(t), o = !n && !r && !i && zU(t), a = n || r || i || o, s = a ? BU(t.length, String) : [], c = s.length;
  for (var l in t)
    (e || WU.call(t, l)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    qU(l, c))) && s.push(l);
  return s;
}
var YU = GU, QU = Object.prototype;
function JU(t) {
  var e = t && t.constructor, n = typeof e == "function" && e.prototype || QU;
  return t === n;
}
var ZU = JU;
function XU(t, e) {
  return function(n) {
    return t(e(n));
  };
}
var eH = XU, tH = eH, nH = tH(Object.keys, Object), rH = nH, iH = ZU, oH = rH, aH = Object.prototype, sH = aH.hasOwnProperty;
function cH(t) {
  if (!iH(t))
    return oH(t);
  var e = [];
  for (var n in Object(t))
    sH.call(t, n) && n != "constructor" && e.push(n);
  return e;
}
var lH = cH, uH = YU, dH = lH, fH = cC;
function hH(t) {
  return fH(t) ? uH(t) : dH(t);
}
var pH = hH, gH = MF, mH = $F, vH = pH;
function yH(t) {
  return gH(t, vH, mH);
}
var wH = yH, r1 = wH, bH = 1, _H = Object.prototype, EH = _H.hasOwnProperty;
function CH(t, e, n, r, i, o) {
  var a = n & bH, s = r1(t), c = s.length, l = r1(e), u = l.length;
  if (c != u && !a)
    return !1;
  for (var d = c; d--; ) {
    var f = s[d];
    if (!(a ? f in e : EH.call(e, f)))
      return !1;
  }
  var h = o.get(t), g = o.get(e);
  if (h && g)
    return h == e && g == t;
  var v = !0;
  o.set(t, e), o.set(e, t);
  for (var b = a; ++d < c; ) {
    f = s[d];
    var m = t[f], y = e[f];
    if (r)
      var p = a ? r(y, m, f, e, t, o) : r(m, y, f, t, e, o);
    if (!(p === void 0 ? m === y || i(m, y, n, r, o) : p)) {
      v = !1;
      break;
    }
    b || (b = f == "constructor");
  }
  if (v && !b) {
    var w = t.constructor, _ = e.constructor;
    w != _ && "constructor" in t && "constructor" in e && !(typeof w == "function" && w instanceof w && typeof _ == "function" && _ instanceof _) && (v = !1);
  }
  return o.delete(t), o.delete(e), v;
}
var IH = CH, SH = Qa, TH = Gr, kH = SH(TH, "DataView"), AH = kH, OH = Qa, xH = Gr, RH = OH(xH, "Promise"), NH = RH, MH = Qa, PH = Gr, DH = MH(PH, "Set"), LH = DH, FH = Qa, UH = Gr, HH = FH(UH, "WeakMap"), BH = HH, rp = AH, ip = ym, op = NH, ap = LH, sp = BH, gC = xc, es = uC, i1 = "[object Map]", jH = "[object Object]", o1 = "[object Promise]", a1 = "[object Set]", s1 = "[object WeakMap]", c1 = "[object DataView]", VH = es(rp), $H = es(ip), qH = es(op), zH = es(ap), KH = es(sp), ro = gC;
(rp && ro(new rp(new ArrayBuffer(1))) != c1 || ip && ro(new ip()) != i1 || op && ro(op.resolve()) != o1 || ap && ro(new ap()) != a1 || sp && ro(new sp()) != s1) && (ro = function(t) {
  var e = gC(t), n = e == jH ? t.constructor : void 0, r = n ? es(n) : "";
  if (r)
    switch (r) {
      case VH:
        return c1;
      case $H:
        return i1;
      case qH:
        return o1;
      case zH:
        return a1;
      case KH:
        return s1;
    }
  return e;
});
var WH = ro, vf = DL, GH = fC, YH = TF, QH = IH, l1 = WH, u1 = wm, d1 = ac, JH = pC, ZH = 1, f1 = "[object Arguments]", h1 = "[object Array]", nl = "[object Object]", XH = Object.prototype, p1 = XH.hasOwnProperty;
function eB(t, e, n, r, i, o) {
  var a = u1(t), s = u1(e), c = a ? h1 : l1(t), l = s ? h1 : l1(e);
  c = c == f1 ? nl : c, l = l == f1 ? nl : l;
  var u = c == nl, d = l == nl, f = c == l;
  if (f && d1(t)) {
    if (!d1(e))
      return !1;
    a = !0, u = !1;
  }
  if (f && !u)
    return o || (o = new vf()), a || JH(t) ? GH(t, e, n, r, i, o) : YH(t, e, c, n, r, i, o);
  if (!(n & ZH)) {
    var h = u && p1.call(t, "__wrapped__"), g = d && p1.call(e, "__wrapped__");
    if (h || g) {
      var v = h ? t.value() : t, b = g ? e.value() : e;
      return o || (o = new vf()), i(v, b, n, r, o);
    }
  }
  return f ? (o || (o = new vf()), QH(t, e, n, r, i, o)) : !1;
}
var tB = eB, nB = tB, g1 = Rc;
function mC(t, e, n, r, i) {
  return t === e ? !0 : t == null || e == null || !g1(t) && !g1(e) ? t !== t && e !== e : nB(t, e, n, r, mC, i);
}
var rB = mC, iB = rB;
function oB(t, e) {
  return iB(t, e);
}
var cp = oB;
const aB = (t) => (t + 6) % 7, m1 = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], sB = ({
  days: t,
  className: e,
  onChange: n,
  value: r,
  start: i,
  end: o,
  loading: a,
  label: s
}) => {
  const c = t.map((m) => ga(m)), l = 4, u = ga(i), d = ga(o), f = u ? v9(u, { weekStartsOn: 1 }) : null, h = C9(d, { weekStartsOn: 1 }), v = (f && h ? eC({ start: f, end: h }) : []).filter(
    (m) => aB(m.getDay()) <= l
  ), b = vP(v, l + 1);
  return /* @__PURE__ */ C("fieldset", { "aria-label": "day options", className: e, children: /* @__PURE__ */ K("table", { className: "border-spacing-16 border-separate", children: [
    /* @__PURE__ */ C("thead", { children: /* @__PURE__ */ C("tr", { className: "text-font-secondary-grey uppercase text-t12 font-bold", children: Array(l + 1).fill(null).map((m, y) => /* @__PURE__ */ C("th", { children: m1[y] }, m1[y])) }) }),
    /* @__PURE__ */ C("tbody", { className: "text-center text-t16 text-font-primary", children: b.map((m, y) => /* @__PURE__ */ C("tr", { children: m.map((p) => {
      const w = iC(p);
      if (!oC(p, { start: i, end: o }))
        return /* @__PURE__ */ C("td", {}, w);
      const _ = mm(p, "d"), E = c.findIndex((T) => cp(p, T)) > -1, S = cp(p, r);
      return /* @__PURE__ */ C("td", { children: /* @__PURE__ */ C(
        "button",
        {
          disabled: !E || a,
          className: j(
            "bg-picker text-brand-900 font-semibold w-32 h-32 flex items-center justify-center rounded",
            {
              "animate-pulse": a,
              "text-radio-disabled bg-picker-unavailable": !E,
              " hover:bg-picker-selected hover:text-white": E,
              "text-white bg-picker-selected": S && E
            }
          ),
          onClick: () => n(p),
          children: _
        }
      ) }, w);
    }) }, y)) })
  ] }) });
}, cB = ({
  className: t,
  size: e = "md",
  alignHorizontal: n = "center",
  alignVertical: r = "center"
}) => (
  // This will position the spinner relative to it's parent container.
  /* @__PURE__ */ C(
    "div",
    {
      className: j(
        "flex",
        { "justify-start": n === "left" },
        { "justify-center": n === "center" },
        { "justify-end": n === "right" },
        { "items-start": r === "top" },
        { "items-center": r === "center" },
        { "items-end": r === "bottom" }
      ),
      children: /* @__PURE__ */ K(
        "div",
        {
          role: "status",
          className: j(
            "text-state-empty",
            { "w-24": e === "sm" },
            { "w-48": e === "md" },
            { "w-60": e === "lg" },
            t
          ),
          children: [
            /* @__PURE__ */ K(
              "svg",
              {
                "aria-hidden": "true",
                className: "mr-2 animate-spin",
                viewBox: "0 0 100 101",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                  /* @__PURE__ */ C(
                    "path",
                    {
                      d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                      fill: "currentColor"
                    }
                  ),
                  /* @__PURE__ */ C(
                    "path",
                    {
                      className: "fill-brand-primary",
                      d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                      fill: "currentFill"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ C("span", { className: "sr-only", children: "Loading..." })
          ]
        }
      )
    }
  )
), lB = ({
  times: t,
  className: e,
  onChange: n,
  value: r,
  loading: i,
  label: o
}) => /* @__PURE__ */ K("div", { className: j("text-font-primary", e), children: [
  o && /* @__PURE__ */ C("h1", { className: "text-font-primary font-normal text-t21 sm:text-t27 mb-40", children: o }),
  /* @__PURE__ */ C("div", { className: "flex flex-wrap gap-8 sm:gap-16 pb-8", children: i ? /* @__PURE__ */ C(cB, {}) : t.map((a) => {
    const s = iC(a), c = mm(a, "hh:mmaa"), l = cp(a, r);
    return /* @__PURE__ */ C(
      "button",
      {
        onClick: () => n(a),
        className: j(
          "rounded bg-picker text-brand-900 font-semibold  text-t16 p-16",
          {
            "animate-pulse": i,
            "text-white bg-picker-selected": l
          }
        ),
        children: c
      },
      s
    );
  }) })
] }), uB = ({ start: t, end: e, value: n, onChange: r }) => /* @__PURE__ */ C(
  sB,
  {
    value: n,
    onChange: r,
    days: eC({
      start: t,
      end: e
    }),
    start: t,
    end: e
  }
), dB = ({
  start: t,
  end: e,
  value: n,
  onChange: r
}) => /* @__PURE__ */ C(
  lB,
  {
    value: n,
    onChange: r,
    times: E9({
      start: t,
      end: e
    })
  }
), aY = (t) => {
  const {
    className: e,
    startDate: n = /* @__PURE__ */ new Date(),
    value: r,
    onChange: i,
    dateLabel: o,
    renderDays: a = uB,
    renderTimes: s = dB
  } = t, [c, l] = et(
    new Date(
      (By(n).getTime() + Hy(n).getTime()) / 2
    )
  ), u = By(c), d = Hy(c), [f, h] = et(
    r ? ga(r) : null
  ), [g, v] = et(
    r ? ga(r) : null
  ), b = () => {
    l((p) => Uy(p, 1));
  }, m = () => {
    l((p) => Uy(p, -1));
  }, y = (p) => {
    v(p), p && i(p);
  };
  return /* @__PURE__ */ K("section", { className: j(e), children: [
    /* @__PURE__ */ K("div", { className: "w-full max-w-340", children: [
      o && /* @__PURE__ */ C("h1", { className: "text-font-primary font-normal text-t21 sm:text-t27 mb-40", children: o }),
      /* @__PURE__ */ K("div", { children: [
        /* @__PURE__ */ K("div", { className: "font-semibold flex self-stretch", children: [
          /* @__PURE__ */ C(
            "button",
            {
              onClick: m,
              "aria-label": "previous month",
              className: "p-8",
              children: /* @__PURE__ */ C(zy, {})
            }
          ),
          /* @__PURE__ */ C("div", { className: "flex-1 text-t21 text-font-primary flex items-center justify-center", children: mm(c, "MMMM yyyy") }),
          /* @__PURE__ */ C(
            "button",
            {
              onClick: b,
              "aria-label": "next month",
              className: "p-8",
              children: /* @__PURE__ */ C(zy, { className: "rotate-180" })
            }
          )
        ] }),
        a({
          start: u,
          end: d,
          value: f,
          onChange: h
        })
      ] })
    ] }),
    f && oC(f, {
      start: u,
      end: d
    }) && s({
      start: ga(f),
      end: _9(f),
      value: g,
      onChange: y
    })
  ] });
}, sY = ({
  size: t,
  variant: e,
  className: n,
  ...r
}) => {
  const { width: i, height: o } = Te(t);
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: i,
      height: o,
      viewBox: "0 0 192.756 192.756",
      ...r,
      children: /* @__PURE__ */ K("g", { fillRule: "evenodd", clipRule: "evenodd", children: [
        /* @__PURE__ */ C("path", { fill: "#fff", d: "M0 0h192.756v192.756H0V0z" }),
        /* @__PURE__ */ C("path", { d: "M91.182 79.879h9.115s9.025-.182 8.934 8.021c-.09 6.108-8.75 7.019-8.75 7.019h-9.298v-15.04h-.001zm27.269 29.445c.256 1.193 1.119 2.508 3.998 2.643 3.828.09 6.016-1.369 6.016-1.369v2.826s-4.193 1.004-6.199 1.004c-2.096 0-8.295-.457-8.295-6.199 0-4.648 5.105-6.107 8.021-6.107 5.105.182 7.566 2.006 7.475 7.201 0 .075-8.399.019-11.016.001zm.012-2.281h6.994s0-2.643-3.373-2.643c-2.537 0-3.367 1.368-3.621 2.643zm22.125-2.854c1.012-1.098 2.711-1.977 5.561-1.977 5.652 0 6.564 4.74 6.473 6.016s-.547 6.107-7.109 6.107c-2.479 0-3.996-.846-4.924-1.896v1.531h-4.467V97.562h4.467v6.627h-.001zm3.83 7.594c2.643-.092 3.828-2.369 3.828-3.463s-.639-3.373-4.012-3.373c-2.617 0-3.414 1.977-3.646 2.943v1.189c.23.985 1.031 2.704 3.83 2.704zm38.559-.455l.09 2.553s-2.096.455-3.463.455-4.924-.82-4.924-4.285v-5.287h-3.736v-2.369h3.736v-2.826h4.559v2.826h3.738v2.369h-3.738v4.559s0 2.279 1.824 2.279c1.822 0 1.914-.274 1.914-.274zM169.121 82.34h5.287v12.67h4.465V82.34h5.379v-2.644h-15.131v2.644zm-1.824.638l.547-2.644s-2.279-1.002-6.289-1.002c-3.92 0-10.209 2.188-10.209 8.113 0 5.834 6.654 7.839 10.756 7.839s5.469-.638 5.469-.638l-.455-2.917s-1.824.547-4.924.547c-3.008-.091-6.105-2.461-6.105-5.104.09-2.37 2.824-5.014 6.381-5.014 2.733 0 4.829.82 4.829.82zm-40.291-3.19s7.475-.364 7.475 4.011c0 3.738-4.283 4.011-4.283 4.011s1.184.182 1.732 1.002c.455.729 3.463 6.199 3.463 6.199h-4.559s-.729-.912-1.094-1.549c-.273-.638-1.094-2.006-1.094-2.006s-.637-2.279-2.826-2.279c-.055 0-.945-.034-1.641-.06v5.894h-4.375V79.788h7.202zm-2.826 6.837h2.371s3.281-.183 3.463-2.188c.092-1.914-3.189-2.188-3.189-2.188h-2.645v4.376zm18.322 2.37h7.293v-2.826h-7.293v-3.464h7.932v-2.917h-12.396v15.223h12.488v-2.735h-8.023v-3.281h-.001zm17.775 11.667h4.467v-3.1h-4.467v3.1zm0 13.309h4.467v-11.576h-4.467v11.576zm-48.675-18.96h4.375V79.788h-4.375v15.223zm-20.42 3.829h9.115s9.025-.184 8.934 8.021c-.09 6.107-8.75 7.02-8.75 7.02h-9.298V98.84h-.001zm4.467 12.215h2.917s6.016-.365 6.016-5.014-6.381-5.105-6.381-5.105h-2.552v10.119zm0-18.961h2.917s6.016-.456 6.016-5.014c0-4.74-6.381-5.104-6.381-5.104h-2.552v10.118zM50.253 88.941v30.5s-17.685-3.191-17.685-15.314c.001-9.669 13.092-13.931 17.685-15.186zm0-.569c-10.629-.769-34.73 4.213-34.73 15.116 0 7.109 12.762 17.502 33.545 17.775.82 0 24.429-.912 24.065-26.253-.306-21.284-16.236-25.012-21.33-25.661v-1.297c20.308 1.289 36.28 13.502 36.28 28.325 0 15.679-17.867 28.44-39.835 28.44S8.504 112.055 8.504 96.377s17.775-28.44 39.744-28.44c.673 0 1.342.012 2.006.036v20.399h-.001z" })
      ] })
    }
  );
};
function cY({
  value: t,
  onChange: e,
  onOpen: n,
  onClose: r,
  onSubmit: i,
  items: o,
  label: a,
  error: s,
  placeholder: c,
  tooltip: l,
  itemToString: u = Np,
  itemToKey: d = Kw,
  itemDisabled: f = cS,
  onBlur: h,
  className: g,
  variant: v = "default",
  icon: b,
  leftIcon: m,
  disabled: y,
  "aria-label": p
}) {
  const {
    isOpen: w,
    selectedItem: _,
    getToggleButtonProps: E,
    getLabelProps: S,
    getMenuProps: T,
    highlightedIndex: x,
    getItemProps: A
  } = rm({
    selectedItem: t,
    items: o,
    onIsOpenChange: ({ isOpen: N }) => {
      N && n && n(), !N && r && r();
    },
    onSelectedItemChange: ({ selectedItem: N }) => {
      e && e(N ?? null), i && i(), h && h();
    }
  });
  return /* @__PURE__ */ K("div", { role: "group", className: j("relative", g), children: [
    a && /* @__PURE__ */ C("div", { className: "text-t16 pb-8", children: /* @__PURE__ */ K(
      "div",
      {
        className: j(
          "text-input-label flex items-start font-semibold",
          { "justify-between w-full": l }
        ),
        ...S(),
        children: [
          a,
          l && /* @__PURE__ */ C(B3, { children: l })
        ]
      }
    ) }),
    /* @__PURE__ */ K(
      "button",
      {
        "aria-label": p,
        disabled: y,
        type: "button",
        className: j(
          "w-full flex items-center justify-between border-1 border-solid border-transparent rounded text-font-primary",
          {
            "bg-input-background outline outline-1 outline-input-border outline-offset-[-1px] min-h-48 py-12 px-18": v === "default",
            "bg-input-dropdown-background outline-none font-semibold px-16 py-8": v === "small",
            "rounded-b-none": w
          }
        ),
        ...E(),
        children: [
          m && /* @__PURE__ */ C("div", { className: "flex mr-12", children: m }),
          /* @__PURE__ */ C(
            "div",
            {
              className: j(
                "text-ellipsis whitespace-nowrap overflow-hidden",
                {
                  "text-t16 mr-16": v === "default",
                  "text-t11 mr-8": v === "small"
                }
              ),
              children: _ ? u(_) : c ?? ""
            }
          ),
          b || /* @__PURE__ */ C(
            V_,
            {
              className: j("shrink-0", {
                "w-8": v === "small",
                "w-16": v === "default"
              })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ C(
      Nc,
      {
        className: j(
          "absolute z-30 min-w-full overflow-hidden rounded rounded-t-none",
          {
            "bg-white": v === "default",
            "bg-input-dropdown-background text-font-primary font-semibold text-t11 mt-8": v === "small",
            hidden: !w || y
          }
        ),
        children: /* @__PURE__ */ C(
          "ul",
          {
            ...T(),
            className: "max-h-320 overflow-y-auto focus-visible:outline-none",
            children: w && !y && o.map((N, F) => /* @__PURE__ */ C(
              "li",
              {
                className: j("cursor-pointer text-font-primary", {
                  "bg-menu-active/50": x === F && v === "default",
                  "bg-input-dropdown-background/50": x === F && v === "small",
                  "p-16": v === "default",
                  "p-8": v === "small"
                }),
                ...A({ item: N, index: F, disabled: f(N) }),
                children: u(N)
              },
              d(N)
            ))
          }
        )
      }
    ),
    s && /* @__PURE__ */ C("span", { className: "text-action-error text-t16", children: s })
  ] });
}
const lY = ({ to: t, className: e, title: n }) => /* @__PURE__ */ K(
  Rw,
  {
    to: t,
    className: j(
      "flex-1 flex items-center justify-center bg-empty-add-card-background text-empty-add-card-text text-t16 font-semibold rounded-lg py-16 m-b-24 hover:text-font-links-hovered h-80 sm:mt-0",
      e
    ),
    role: "link",
    children: [
      n,
      /* @__PURE__ */ C("div", { className: "w-24 h-24 sm:w-28 sm:h-28 flex items-center justify-center shrink-0 pl-18", children: /* @__PURE__ */ C("div", { className: "w-24 h-24 sm:w-28 sm:h-28 flex items-center justify-center shrink-0", children: /* @__PURE__ */ C("div", { className: "bg-action-primary rounded-md flex items-center justify-center w-full h-full", children: /* @__PURE__ */ C("p", { className: "text-white font-bold text-t20", children: "+" }) }) }) })
    ]
  }
), uY = ({
  onChange: t,
  onBlur: e,
  value: n,
  error: r,
  className: i,
  label: o,
  tooltip: a
}) => /* @__PURE__ */ K("fieldset", { className: i, children: [
  (o || a) && /* @__PURE__ */ K("legend", { className: "flex items-center w-full mb-16", children: [
    o && /* @__PURE__ */ C("span", { className: "text-input-label font-semibold", children: o }),
    a && /* @__PURE__ */ C(B3, { className: "inline-block", "aria-label": a, children: a })
  ] }),
  /* @__PURE__ */ C(
    hB,
    {
      className: "flex gap-24",
      value: n === null ? void 0 : n,
      onBlur: e,
      options: [
        { label: "Yes", value: !0 },
        { label: "No", value: !1 }
      ],
      onChange: (s) => {
        t(s === void 0 ? null : s);
      },
      variant: "wrapped"
    }
  ),
  r && /* @__PURE__ */ C("p", { className: "text-action-error mt-12", children: r })
] }), dY = (t) => /* @__PURE__ */ C("svg", { width: 120, height: 39, viewBox: "0 0 120 39", fill: "#fff", ...t, children: /* @__PURE__ */ C("path", { d: "M33.376 13.078v17.53h-3.21V13.731l3.21-.654ZM37.082 22.025c0-1.717-.025-2.285-.104-3.429l2.793-.654.105 2.418h.103c.627-1.795 2.114-2.705 3.472-2.705a3.4 3.4 0 0 1 .757.078v3.017a4.442 4.442 0 0 0-.94-.104 2.83 2.83 0 0 0-2.87 2.419c-.065.325-.1.656-.105.988v6.554h-3.21v-8.582ZM49.684 14.404a1.796 1.796 0 0 1-1.072 1.702 1.804 1.804 0 0 1-2.492-1.274 1.795 1.795 0 0 1 .756-1.863c.298-.2.648-.307 1.007-.307a1.704 1.704 0 0 1 1.677 1.054c.089.219.131.453.124.688Zm-3.42 16.203V18.596l3.238-.655v12.666h-3.237ZM52.245 27.668c1 .56 2.118.871 3.263.91 1.41 0 2.036-.572 2.036-1.404 0-.858-.522-1.3-2.088-1.847-2.48-.858-3.523-2.21-3.498-3.693 0-2.236 1.853-3.979 4.803-3.979a7.492 7.492 0 0 1 3.367.754l-.626 2.263a5.729 5.729 0 0 0-2.69-.728c-1.148 0-1.774.546-1.774 1.326 0 .806.6 1.197 2.219 1.768 2.297.833 3.367 2.004 3.393 3.876 0 2.288-1.801 3.953-5.168 3.953a8.227 8.227 0 0 1-3.863-.884l.627-2.315ZM62.52 12.796l3.237-.654v7.542h.052a4.308 4.308 0 0 1 1.593-1.457 4.365 4.365 0 0 1 2.192-.571c2.166 0 4.436 1.43 4.436 5.487v7.464h-3.21v-7.1c0-1.846-.678-3.225-2.453-3.225a2.62 2.62 0 0 0-2.48 1.794c-.1.31-.145.637-.13.963v7.568H62.52v-17.81ZM81.895 13.732l3.21-.654v14.85h7.23v2.68h-10.44V13.731ZM97.668 14.404a1.796 1.796 0 0 1-1.073 1.702 1.804 1.804 0 0 1-2.492-1.274 1.795 1.795 0 0 1 .757-1.863c.297-.2.648-.307 1.007-.307a1.704 1.704 0 0 1 1.676 1.054c.09.219.131.453.125.688Zm-3.42 16.203V18.596l3.237-.655v12.666h-3.237ZM101.295 30.607V20.334h-1.722V17.94h1.722v-.546c0-1.638.444-3.277 1.54-4.317a4.87 4.87 0 0 1 3.315-1.223c.7-.012 1.397.094 2.062.312l-.235 2.471a3.752 3.752 0 0 0-1.357-.234c-1.592 0-2.141 1.327-2.141 2.887v.65h2.793v2.393h-2.766v10.273h-3.211ZM111.24 25.171c.078 2.29 1.879 3.277 3.914 3.277a9.579 9.579 0 0 0 3.524-.572l.47 2.21a12.007 12.007 0 0 1-4.437.78c-4.124 0-6.551-2.522-6.551-6.397 0-3.51 2.14-6.814 6.212-6.814 4.123 0 5.481 3.381 5.481 6.164.004.453-.031.905-.105 1.352h-8.508Zm5.585-2.236c.026-1.17-.496-3.095-2.636-3.095-1.984 0-2.819 1.794-2.949 3.095h5.585ZM23.91 35.766l-.171-1.543.172-1.887-.524-.415c-.358.209-.723.396-.826.453-.22.132-2.166 1.347-2.166 1.347l-1.5-.419-.807-.218-.068-.572s-.172-3.785-.153-3.92c.019-.135-.537-4.023-.537-4.023l-.31-2.092.251-2.7.546-3.574c-.032-.098.016-1.444.016-1.444s-.048-2.179-.043-2.272c.005-.094.128-1.314.128-1.314l.594-1.562.133-.61a.163.163 0 0 0-.034-.082 1.324 1.324 0 0 0-1.168-.23c-.323.08-.619.245-.856.478a15.06 15.06 0 0 0-.318 1.634l-.159 2.028-.288 2.348s-.122.718-.147.81c-.068.243-.42.118-.42.118a4.171 4.171 0 0 1-.062-.68c.02-.209.149-1.308.149-1.308a.37.37 0 0 0 .005-.07 6.676 6.676 0 0 0-.17-1.035.76.76 0 0 0-.726-.46 3.104 3.104 0 0 0-.936.077.926.926 0 0 0-.58.432 1.354 1.354 0 0 0-.152.64s.12 1.366.186 1.585l.237.766s.032.504-.42.24a.607.607 0 0 1-.05-.045l-.488-.966-.028-.077-.022-.086-.207-1.296-.015-.113.007-1.095c.035-.131.324-1.6.707-2.193l.443-.602a19.34 19.34 0 0 0 1.318-1.618.954.954 0 0 0 .107-.198c.114-.341 1.599-1.156 2.205-1.611a5.037 5.037 0 0 1 1.343-.795c.268-.076.73-.246.904-.316.186-.06.366-.14.535-.24.021-.044-.164-.102-.164-.102l-1.167-.147s-.452-.076-.527-.208a6.77 6.77 0 0 0-.929-.624 1.867 1.867 0 0 0-1.152.027 10.87 10.87 0 0 0-1.162.416c-.33.217-.672.416-1.023.599-.077.029-.15.067-.217.113l-.158-.198s.247-.43.298-.53c.049-.1.474-1.066.474-1.066.167-.398.3-.81.397-1.23.174-.72-.567-1.535-1.131-1.88-.563-.346-2.462-.176-2.871-.118-.408.057-2.075.342-2.216.4-.145.057-2.115.654-2.22.684-.06.017-.51.177-.93.335 0 0-1.66.847-2.059 1.145a12.251 12.251 0 0 1-2.14 1.39L0 4.295l.25.248s.796.149 1.343.248a7.869 7.869 0 0 0 2.095-.067c.416-.131.807-.33 1.158-.589.136-.092.282-.17.435-.23.021-.008.076-.036.104-.046a4.744 4.744 0 0 1 1.082-.165c.035.003.07.008.104.016.077.011.574.213.66.505.065.406.006.823-.169 1.196a3.372 3.372 0 0 1-1.114.933c-.208.085-.69.27-1.102.44-.715.21-1.449.353-2.19.427h-.69l-.171.686c-.048.402-.019.81.086 1.2.186.468.448.903.774 1.287.193.162.436.253.689.257l.774-.943.728-.681.388-.248s.143-.093.184-.122c.333-.188.689-.331 1.06-.426.132-.029.538-.177.721-.213.05-.004.1 0 .148.011 0 0 .724.21.724.78a2.451 2.451 0 0 1-.239 1.025l-.039.081-.103.117-.822.598-.126.075c-.25.124-.513.223-.783.294-.763.195-1.826 1.195-1.826 1.195-.647.496-1.245 1.638-1.494 1.886-.249.248-.199.446-.199.446.788-.28 1.592-.516 2.406-.707l2.563-.54s1.242-.238 1.598-.529c.353-.252.73-.469 1.124-.648l.046 2.476.025.164.48 1.747s1.15 3.086 1.094 3.862c-.057.78-.238 3.873-.238 3.873s-.684 3.477-.695 3.866c-.008.387-.137 2.217-.137 2.217l-.033.891-.001 1.49c-.33.17-.677.306-1.035.406-.927.34-1.815.777-2.65 1.304-.318.27-.839.393-.801.543.064.178.14.35.229.518 0 0-.323.461-.082.648.21.164 2.381 1.231 2.909 1.484a.59.59 0 0 0 .145.047l2.21.546.26.026s.197.006.296-.005c.425-.051 1.543-.182 2.298-.26.246-.023.45-.042.583-.05.073-.005.134-.023.151-.02.153.043 3.1-1.07 3.595-1.221a5.893 5.893 0 0 0 1.293-.76l1.8.521.177.073s.723.335 1.337.676c.252-.114.487-.264.696-.445l-.172-.943Zm-9.459-3.264-1.67-.103.145-3.033s.44-2.67.44-2.84c0-.146.215-1.292.278-1.6a.194.194 0 0 1 .037-.08l.067-.063.287-.18.27-.107.078-.01.068.004c.114.013.225.042.33.086.148.08.353.832.353.832l.307 2.067.167 2.5.153 2.611-1.31-.084Z" }) }), fY = ({
  to: t,
  end: e,
  children: n,
  className: r,
  isPill: i,
  ...o
}) => /* @__PURE__ */ C(
  xw,
  {
    to: t,
    end: e,
    "aria-label": o["aria-label"],
    className: ({ isActive: a }) => j(
      "flex flex-col items-center lg:px-12 lg:py-6 text-center justify-center",
      "lg:border-l-4 lg:border-r-4 lg:border-r-transparent",
      "gap-y-4 lg:gap-y-8 text-t11 lg:text-t14",
      {
        "[&_svg]:text-menu-active font-bold border-menu-active": a,
        "border-transparent font-normal": !a,
        "bg-menu-background lg:bg-transparent text-white px-8 sm:px-14": a && i,
        "rounded-sm sm:rounded-lg lg:rounded-none text-t16 sm:text-t21 py-6 sm:py-12 lg:p-0": i
      },
      r
    ),
    children: n
  }
), hY = ({
  onChange: t,
  onBlur: e,
  onKeyUp: n,
  children: r,
  className: i,
  helperText: o,
  error: a,
  min: s,
  max: c,
  decimals: l = !0,
  value: u,
  ...d
}) => /* @__PURE__ */ K("div", { className: j("w-full", i), children: [
  /* @__PURE__ */ C(
    ZE,
    {
      ...d,
      value: u ?? "",
      helperText: o,
      onChange: (f) => {
        if (f.target.value.length > 9 || c && Number(f.target.value) > c || (s || s === 0) && Number(f.target.value) < s)
          return !1;
        if (f.target.value === "")
          t && t(null);
        else {
          let h = Number(f.target.value);
          l || (h = Math.trunc(h)), t && t(h);
        }
      },
      type: "number",
      onKeyUp: (f) => {
        n && n(f);
      },
      onWheel: (f) => {
        f.currentTarget.blur();
      },
      children: r
    }
  ),
  a && /* @__PURE__ */ C("p", { className: "text-action-error text-t16 mt-8", children: a })
] }), fB = ({
  className: t,
  label: e,
  onChange: n,
  value: r,
  disabled: i = !1,
  checked: o,
  children: a,
  ...s
}) => {
  const c = bn();
  return /* @__PURE__ */ C("div", { className: "flex justify-center relative", children: /* @__PURE__ */ K("div", { className: j("flex items-center ", t), children: [
    /* @__PURE__ */ C(
      "input",
      {
        ...s,
        className: j(
          "appearance-none mr-4 h-24 w-24 rounded-full border-2 border-solid border-radio-empty-border bg-radio-empty-fill hover:cursor-pointer hover:disabled:pointer-events-none focus:border-radio-focus before:pointer-events-none before:absolute before:h-8 before:w-8 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:content-[''] after:absolute after:z-[1] after:block after:h-8 after:w-8 after:rounded-full after:content-[''] checked:hover:cursor-pointer checked:border-none checked:after:absolute checked:after:origin-center checked:after:content-[''] checked:after:h-[24px] checked:after:w-[24px] checked:after:rounded-full checked:after:border-radio-selected-border checked:after:bg-radio-selected-fill checked:after:border checked:after:border-solid checked:after:border-[8px] focus:checked:after:ring-2 focus:checked:after:ring-blue-300 focus:checked:after:ring-offset hover:checked:after:border-radio-hoverdisabled:bg-radio-empty-fill disabled:border-radio-disabled"
        ),
        type: "radio",
        id: c,
        checked: o,
        disabled: i,
        onChange: (l) => {
          const u = l.currentTarget.value;
          l.currentTarget.focus(), n(typeof r == "boolean" ? u === "true" : u);
        },
        value: typeof r == "boolean" ? r.toString() : r
      }
    ),
    /* @__PURE__ */ C(
      "label",
      {
        className: j(
          "max-w-[80%] mt-px inline-block pl-4 text-font-secondary hover:cursor-pointer ",
          { "text-radio-disabled hover:cursor-default ": i }
        ),
        htmlFor: c,
        children: e ?? a
      }
    )
  ] }) });
};
function hB({
  value: t,
  onChange: e,
  onBlur: n,
  label: r,
  options: i,
  className: o,
  "aria-labelledby": a,
  "aria-label": s,
  variant: c = "auto",
  disabled: l,
  error: u,
  onSubmit: d
}) {
  const f = (b) => () => {
    e && e(b), d && d();
  }, g = ((b) => {
    switch (b) {
      case "auto":
        return i.length > 4 ? "wrapped" : "stacked";
      case "auto-end":
        return i.length > 4 ? "wrapped-end" : "stacked-end";
      default:
        return b;
    }
  })(c);
  return /* @__PURE__ */ K(
    "div",
    {
      role: "radiogroup",
      "aria-labelledby": a,
      "aria-label": s,
      className: j(
        "flex gap-12 w-full",
        ((b) => {
          switch (b) {
            case "stacked":
              return "flex-col";
            case "wrapped":
              return "flex-wrap";
            case "stacked-end":
              return "flex-col items-end";
            case "stacked-full":
              return "flex-col items-stretch";
            case "wrapped-end":
              return "flex-wrap justify-end";
          }
        })(g),
        o
      ),
      children: [
        r && /* @__PURE__ */ C("legend", { className: "mb-4", children: r }),
        i.map((b) => {
          const m = t === b.value;
          return /* @__PURE__ */ C(
            fB,
            {
              disabled: l,
              role: "radio",
              "aria-checked": m,
              onChange: f(b.value),
              onBlur: n,
              value: b.value,
              checked: m,
              className: `text-t16 h-fit ${g.includes("full") ? "w-full" : "w-fit"} ${g.includes("stacked") ? "flex-1" : ""}`,
              children: /* @__PURE__ */ C("p", { children: b.label })
            },
            String(b.value)
          );
        }),
        u && /* @__PURE__ */ C("p", { className: "text-action-error text-t16 mt-12", children: u })
      ]
    }
  );
}
const pB = ({ children: t, className: e }) => /* @__PURE__ */ C("div", { className: e, children: /* @__PURE__ */ C(
  "div",
  {
    className: j(
      "rounded-full ring ring-recommendation-icon-roundel ring-offset-2 sm:ring-offset-4",
      "m-4 sm:m-8 h-48 sm:h-80 w-48 sm:w-80 bg-recommendation-icon-roundel",
      "flex items-center justify-center"
    ),
    children: t
  }
) }), gB = ({ count: t }) => /* @__PURE__ */ K(
  "div",
  {
    className: j(
      "rounded-full py-4 sm:py-8 px-8 sm:px-12 inline-block",
      "font-bold text-t10 sm:text-t12 tracking-wider",
      {
        "text-todos-multiple bg-todos-multiple/[.1]": t > 0,
        "text-todos-none-label bg-todos-none": t <= 0
      }
    ),
    children: [
      t,
      " ",
      t === 1 ? "THING" : "THINGS",
      " TO DO"
    ]
  }
), pY = ({
  to: t,
  icon: e,
  thingsToDo: n,
  title: r,
  className: i
}) => /* @__PURE__ */ C(Rw, { to: t, className: i, children: /* @__PURE__ */ K(Nc, { className: "pl-18 sm:pl-34 pr-34 flex items-center", children: [
  /* @__PURE__ */ C(pB, { className: "my-12 sm:my-18", children: e }),
  /* @__PURE__ */ K("div", { className: "ml-12 sm:ml-28 my-16 sm:my-32 flex-1", children: [
    /* @__PURE__ */ C("h3", { className: "text-t16 sm:text-t25 font-semibold text-font-primary mb-6 sm:mb-12", children: r }),
    /* @__PURE__ */ C(gB, { count: n })
  ] }),
  /* @__PURE__ */ C(p8, { className: "-rotate-90 sm:scale-150" })
] }) }), v1 = ["http", "https", "mailto", "tel"];
function mB(t) {
  const e = (t || "").trim(), n = e.charAt(0);
  if (n === "#" || n === "/")
    return e;
  const r = e.indexOf(":");
  if (r === -1)
    return e;
  let i = -1;
  for (; ++i < v1.length; ) {
    const o = v1[i];
    if (r === o.length && e.slice(0, o.length).toLowerCase() === o)
      return e;
  }
  return i = e.indexOf("?"), i !== -1 && r > i || (i = e.indexOf("#"), i !== -1 && r > i) ? e : "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var vB = function(e) {
  return e != null && e.constructor != null && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
};
const vC = vB;
function Ls(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? y1(t.position) : "start" in t || "end" in t ? y1(t) : "line" in t || "column" in t ? lp(t) : "";
}
function lp(t) {
  return w1(t && t.line) + ":" + w1(t && t.column);
}
function y1(t) {
  return lp(t && t.start) + "-" + lp(t && t.end);
}
function w1(t) {
  return t && typeof t == "number" ? t : 1;
}
class vr extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(e, n, r) {
    const i = [null, null];
    let o = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const a = r.indexOf(":");
      a === -1 ? i[1] = r : (i[0] = r.slice(0, a), i[1] = r.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (o = n.position) : "start" in n || "end" in n ? o = n : ("line" in n || "column" in n) && (o.start = n)), this.name = Ls(n) || "1:1", this.message = typeof e == "object" ? e.message : e, this.stack = "", typeof e == "object" && e.stack && (this.stack = e.stack), this.reason = this.message, this.fatal, this.line = o.start.line, this.column = o.start.column, this.position = o, this.source = i[0], this.ruleId = i[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
vr.prototype.file = "";
vr.prototype.name = "";
vr.prototype.reason = "";
vr.prototype.message = "";
vr.prototype.stack = "";
vr.prototype.fatal = null;
vr.prototype.column = null;
vr.prototype.line = null;
vr.prototype.source = null;
vr.prototype.ruleId = null;
vr.prototype.position = null;
const Mr = { basename: yB, dirname: wB, extname: bB, join: _B, sep: "/" };
function yB(t, e) {
  if (e !== void 0 && typeof e != "string")
    throw new TypeError('"ext" argument must be a string');
  Mc(t);
  let n = 0, r = -1, i = t.length, o;
  if (e === void 0 || e.length === 0 || e.length > t.length) {
    for (; i--; )
      if (t.charCodeAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : t.slice(n, r);
  }
  if (e === t)
    return "";
  let a = -1, s = e.length - 1;
  for (; i--; )
    if (t.charCodeAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (o = !0, a = i + 1), s > -1 && (t.charCodeAt(i) === e.charCodeAt(s--) ? s < 0 && (r = i) : (s = -1, r = a));
  return n === r ? r = a : r < 0 && (r = t.length), t.slice(n, r);
}
function wB(t) {
  if (Mc(t), t.length === 0)
    return ".";
  let e = -1, n = t.length, r;
  for (; --n; )
    if (t.charCodeAt(n) === 47) {
      if (r) {
        e = n;
        break;
      }
    } else
      r || (r = !0);
  return e < 0 ? t.charCodeAt(0) === 47 ? "/" : "." : e === 1 && t.charCodeAt(0) === 47 ? "//" : t.slice(0, e);
}
function bB(t) {
  Mc(t);
  let e = t.length, n = -1, r = 0, i = -1, o = 0, a;
  for (; e--; ) {
    const s = t.charCodeAt(e);
    if (s === 47) {
      if (a) {
        r = e + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = e + 1), s === 46 ? i < 0 ? i = e : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : t.slice(i, n);
}
function _B(...t) {
  let e = -1, n;
  for (; ++e < t.length; )
    Mc(t[e]), t[e] && (n = n === void 0 ? t[e] : n + "/" + t[e]);
  return n === void 0 ? "." : EB(n);
}
function EB(t) {
  Mc(t);
  const e = t.charCodeAt(0) === 47;
  let n = CB(t, !e);
  return n.length === 0 && !e && (n = "."), n.length > 0 && t.charCodeAt(t.length - 1) === 47 && (n += "/"), e ? "/" + n : n;
}
function CB(t, e) {
  let n = "", r = 0, i = -1, o = 0, a = -1, s, c;
  for (; ++a <= t.length; ) {
    if (a < t.length)
      s = t.charCodeAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === a - 1 || o === 1))
        if (i !== a - 1 && o === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (c = n.lastIndexOf("/"), c !== n.length - 1) {
                c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = a, o = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = a, o = 0;
              continue;
            }
          }
          e && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + t.slice(i + 1, a) : n = t.slice(i + 1, a), r = a - i - 1;
      i = a, o = 0;
    } else
      s === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function Mc(t) {
  if (typeof t != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(t)
    );
}
const IB = { cwd: SB };
function SB() {
  return "/";
}
function up(t) {
  return t !== null && typeof t == "object" && // @ts-expect-error: indexable.
  t.href && // @ts-expect-error: indexable.
  t.origin;
}
function TB(t) {
  if (typeof t == "string")
    t = new URL(t);
  else if (!up(t)) {
    const e = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + t + "`"
    );
    throw e.code = "ERR_INVALID_ARG_TYPE", e;
  }
  if (t.protocol !== "file:") {
    const e = new TypeError("The URL must be of scheme file");
    throw e.code = "ERR_INVALID_URL_SCHEME", e;
  }
  return kB(t);
}
function kB(t) {
  if (t.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const e = t.pathname;
  let n = -1;
  for (; ++n < e.length; )
    if (e.charCodeAt(n) === 37 && e.charCodeAt(n + 1) === 50) {
      const r = e.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(e);
}
const yf = ["history", "path", "basename", "stem", "extname", "dirname"];
class yC {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(e) {
    let n;
    e ? typeof e == "string" || AB(e) ? n = { value: e } : up(e) ? n = { path: e } : n = e : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = IB.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < yf.length; ) {
      const o = yf[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      yf.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(e) {
    up(e) && (e = TB(e)), bf(e, "path"), this.path !== e && this.history.push(e);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? Mr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(e) {
    b1(this.basename, "dirname"), this.path = Mr.join(e || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? Mr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(e) {
    bf(e, "basename"), wf(e, "basename"), this.path = Mr.join(this.dirname || "", e);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? Mr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(e) {
    if (wf(e, "extname"), b1(this.dirname, "extname"), e) {
      if (e.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (e.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Mr.join(this.dirname, this.stem + (e || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? Mr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(e) {
    bf(e, "stem"), wf(e, "stem"), this.path = Mr.join(this.dirname || "", e + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(e) {
    return (this.value || "").toString(e || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(e, n, r) {
    const i = new vr(e, n, r);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(e, n, r) {
    const i = this.message(e, n, r);
    return i.fatal = null, i;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(e, n, r) {
    const i = this.message(e, n, r);
    throw i.fatal = !0, i;
  }
}
function wf(t, e) {
  if (t && t.includes(Mr.sep))
    throw new Error(
      "`" + e + "` cannot be a path: did not expect `" + Mr.sep + "`"
    );
}
function bf(t, e) {
  if (!t)
    throw new Error("`" + e + "` cannot be empty");
}
function b1(t, e) {
  if (!t)
    throw new Error("Setting `" + e + "` requires `path` to be set too");
}
function AB(t) {
  return vC(t);
}
function _1(t) {
  if (t)
    throw t;
}
var Al = Object.prototype.hasOwnProperty, wC = Object.prototype.toString, E1 = Object.defineProperty, C1 = Object.getOwnPropertyDescriptor, I1 = function(e) {
  return typeof Array.isArray == "function" ? Array.isArray(e) : wC.call(e) === "[object Array]";
}, S1 = function(e) {
  if (!e || wC.call(e) !== "[object Object]")
    return !1;
  var n = Al.call(e, "constructor"), r = e.constructor && e.constructor.prototype && Al.call(e.constructor.prototype, "isPrototypeOf");
  if (e.constructor && !n && !r)
    return !1;
  var i;
  for (i in e)
    ;
  return typeof i > "u" || Al.call(e, i);
}, T1 = function(e, n) {
  E1 && n.name === "__proto__" ? E1(e, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : e[n.name] = n.newValue;
}, k1 = function(e, n) {
  if (n === "__proto__")
    if (Al.call(e, n)) {
      if (C1)
        return C1(e, n).value;
    } else
      return;
  return e[n];
}, A1 = function t() {
  var e, n, r, i, o, a, s = arguments[0], c = 1, l = arguments.length, u = !1;
  for (typeof s == "boolean" && (u = s, s = arguments[1] || {}, c = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); c < l; ++c)
    if (e = arguments[c], e != null)
      for (n in e)
        r = k1(s, n), i = k1(e, n), s !== i && (u && i && (S1(i) || (o = I1(i))) ? (o ? (o = !1, a = r && I1(r) ? r : []) : a = r && S1(r) ? r : {}, T1(s, { name: n, newValue: t(u, a, i) })) : typeof i < "u" && T1(s, { name: n, newValue: i }));
  return s;
};
function dp(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
function OB() {
  const t = [], e = { run: n, use: r };
  return e;
  function n(...i) {
    let o = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...i);
    function s(c, ...l) {
      const u = t[++o];
      let d = -1;
      if (c) {
        a(c);
        return;
      }
      for (; ++d < i.length; )
        (l[d] === null || l[d] === void 0) && (l[d] = i[d]);
      i = l, u ? xB(u, s)(...l) : a(null, ...l);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return t.push(i), e;
  }
}
function xB(t, e) {
  let n;
  return r;
  function r(...a) {
    const s = t.length > a.length;
    let c;
    s && a.push(i);
    try {
      c = t.apply(this, a);
    } catch (l) {
      const u = (
        /** @type {Error} */
        l
      );
      if (s && n)
        throw u;
      return i(u);
    }
    s || (c instanceof Promise ? c.then(o, i) : c instanceof Error ? i(c) : o(c));
  }
  function i(a, ...s) {
    n || (n = !0, e(a, ...s));
  }
  function o(a) {
    i(null, a);
  }
}
const RB = _C().freeze(), bC = {}.hasOwnProperty;
function _C() {
  const t = OB(), e = [];
  let n = {}, r, i = -1;
  return o.data = a, o.Parser = void 0, o.Compiler = void 0, o.freeze = s, o.attachers = e, o.use = c, o.parse = l, o.stringify = u, o.run = d, o.runSync = f, o.process = h, o.processSync = g, o;
  function o() {
    const v = _C();
    let b = -1;
    for (; ++b < e.length; )
      v.use(...e[b]);
    return v.data(A1(!0, {}, n)), v;
  }
  function a(v, b) {
    return typeof v == "string" ? arguments.length === 2 ? (Cf("data", r), n[v] = b, o) : bC.call(n, v) && n[v] || null : v ? (Cf("data", r), n = v, o) : n;
  }
  function s() {
    if (r)
      return o;
    for (; ++i < e.length; ) {
      const [v, ...b] = e[i];
      if (b[0] === !1)
        continue;
      b[0] === !0 && (b[0] = void 0);
      const m = v.call(o, ...b);
      typeof m == "function" && t.use(m);
    }
    return r = !0, i = Number.POSITIVE_INFINITY, o;
  }
  function c(v, ...b) {
    let m;
    if (Cf("use", r), v != null)
      if (typeof v == "function")
        _(v, ...b);
      else if (typeof v == "object")
        Array.isArray(v) ? w(v) : p(v);
      else
        throw new TypeError("Expected usable value, not `" + v + "`");
    return m && (n.settings = Object.assign(n.settings || {}, m)), o;
    function y(E) {
      if (typeof E == "function")
        _(E);
      else if (typeof E == "object")
        if (Array.isArray(E)) {
          const [S, ...T] = E;
          _(S, ...T);
        } else
          p(E);
      else
        throw new TypeError("Expected usable value, not `" + E + "`");
    }
    function p(E) {
      w(E.plugins), E.settings && (m = Object.assign(m || {}, E.settings));
    }
    function w(E) {
      let S = -1;
      if (E != null)
        if (Array.isArray(E))
          for (; ++S < E.length; ) {
            const T = E[S];
            y(T);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + E + "`");
    }
    function _(E, S) {
      let T = -1, x;
      for (; ++T < e.length; )
        if (e[T][0] === E) {
          x = e[T];
          break;
        }
      x ? (dp(x[1]) && dp(S) && (S = A1(!0, x[1], S)), x[1] = S) : e.push([...arguments]);
    }
  }
  function l(v) {
    o.freeze();
    const b = gs(v), m = o.Parser;
    return _f("parse", m), O1(m, "parse") ? new m(String(b), b).parse() : m(String(b), b);
  }
  function u(v, b) {
    o.freeze();
    const m = gs(b), y = o.Compiler;
    return Ef("stringify", y), x1(v), O1(y, "compile") ? new y(v, m).compile() : y(v, m);
  }
  function d(v, b, m) {
    if (x1(v), o.freeze(), !m && typeof b == "function" && (m = b, b = void 0), !m)
      return new Promise(y);
    y(null, m);
    function y(p, w) {
      t.run(v, gs(b), _);
      function _(E, S, T) {
        S = S || v, E ? w(E) : p ? p(S) : m(null, S, T);
      }
    }
  }
  function f(v, b) {
    let m, y;
    return o.run(v, b, p), R1("runSync", "run", y), m;
    function p(w, _) {
      _1(w), m = _, y = !0;
    }
  }
  function h(v, b) {
    if (o.freeze(), _f("process", o.Parser), Ef("process", o.Compiler), !b)
      return new Promise(m);
    m(null, b);
    function m(y, p) {
      const w = gs(v);
      o.run(o.parse(w), w, (E, S, T) => {
        if (E || !S || !T)
          _(E);
        else {
          const x = o.stringify(S, T);
          x == null || (PB(x) ? T.value = x : T.result = x), _(E, T);
        }
      });
      function _(E, S) {
        E || !S ? p(E) : y ? y(S) : b(null, S);
      }
    }
  }
  function g(v) {
    let b;
    o.freeze(), _f("processSync", o.Parser), Ef("processSync", o.Compiler);
    const m = gs(v);
    return o.process(m, y), R1("processSync", "process", b), m;
    function y(p) {
      b = !0, _1(p);
    }
  }
}
function O1(t, e) {
  return typeof t == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  t.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (NB(t.prototype) || e in t.prototype);
}
function NB(t) {
  let e;
  for (e in t)
    if (bC.call(t, e))
      return !0;
  return !1;
}
function _f(t, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + t + "` without `Parser`");
}
function Ef(t, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + t + "` without `Compiler`");
}
function Cf(t, e) {
  if (e)
    throw new Error(
      "Cannot call `" + t + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function x1(t) {
  if (!dp(t) || typeof t.type != "string")
    throw new TypeError("Expected node, got `" + t + "`");
}
function R1(t, e, n) {
  if (!n)
    throw new Error(
      "`" + t + "` finished async. Use `" + e + "` instead"
    );
}
function gs(t) {
  return MB(t) ? t : new yC(t);
}
function MB(t) {
  return !!(t && typeof t == "object" && "message" in t && "messages" in t);
}
function PB(t) {
  return typeof t == "string" || vC(t);
}
const DB = {};
function LB(t, e) {
  const n = e || DB, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return EC(t, r, i);
}
function EC(t, e, n) {
  if (FB(t)) {
    if ("value" in t)
      return t.type === "html" && !n ? "" : t.value;
    if (e && "alt" in t && t.alt)
      return t.alt;
    if ("children" in t)
      return N1(t.children, e, n);
  }
  return Array.isArray(t) ? N1(t, e, n) : "";
}
function N1(t, e, n) {
  const r = [];
  let i = -1;
  for (; ++i < t.length; )
    r[i] = EC(t[i], e, n);
  return r.join("");
}
function FB(t) {
  return !!(t && typeof t == "object");
}
function er(t, e, n, r) {
  const i = t.length;
  let o = 0, a;
  if (e < 0 ? e = -e > i ? 0 : i + e : e = e > i ? i : e, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(e, n), t.splice(...a);
  else
    for (n && t.splice(e, n); o < r.length; )
      a = r.slice(o, o + 1e4), a.unshift(e, 0), t.splice(...a), o += 1e4, e += 1e4;
}
function lr(t, e) {
  return t.length > 0 ? (er(t, t.length, 0, e), t) : e;
}
const M1 = {}.hasOwnProperty;
function CC(t) {
  const e = {};
  let n = -1;
  for (; ++n < t.length; )
    UB(e, t[n]);
  return e;
}
function UB(t, e) {
  let n;
  for (n in e) {
    const i = (M1.call(t, n) ? t[n] : void 0) || (t[n] = {}), o = e[n];
    let a;
    if (o)
      for (a in o) {
        M1.call(i, a) || (i[a] = []);
        const s = o[a];
        HB(
          // @ts-expect-error Looks like a list.
          i[a],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function HB(t, e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; )
    (e[n].add === "after" ? t : r).push(e[n]);
  er(t, 0, 0, r);
}
const BB = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Dn = Qi(/[A-Za-z]/), Mn = Qi(/[\dA-Za-z]/), jB = Qi(/[#-'*+\--9=?A-Z^-~]/);
function Eu(t) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    t !== null && (t < 32 || t === 127)
  );
}
const fp = Qi(/\d/), VB = Qi(/[\dA-Fa-f]/), $B = Qi(/[!-/:-@[-`{-~]/);
function xe(t) {
  return t !== null && t < -2;
}
function Dt(t) {
  return t !== null && (t < 0 || t === 32);
}
function ct(t) {
  return t === -2 || t === -1 || t === 32;
}
const dd = Qi(BB), Ro = Qi(/\s/);
function Qi(t) {
  return e;
  function e(n) {
    return n !== null && t.test(String.fromCharCode(n));
  }
}
function dt(t, e, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return a;
  function a(c) {
    return ct(c) ? (t.enter(n), s(c)) : e(c);
  }
  function s(c) {
    return ct(c) && o++ < i ? (t.consume(c), s) : (t.exit(n), e(c));
  }
}
const qB = {
  tokenize: zB
};
function zB(t) {
  const e = t.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return e;
  function r(s) {
    if (s === null) {
      t.consume(s);
      return;
    }
    return t.enter("lineEnding"), t.consume(s), t.exit("lineEnding"), dt(t, e, "linePrefix");
  }
  function i(s) {
    return t.enter("paragraph"), o(s);
  }
  function o(s) {
    const c = t.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, a(s);
  }
  function a(s) {
    if (s === null) {
      t.exit("chunkText"), t.exit("paragraph"), t.consume(s);
      return;
    }
    return xe(s) ? (t.consume(s), t.exit("chunkText"), o) : (t.consume(s), a);
  }
}
const KB = {
  tokenize: WB
}, P1 = {
  tokenize: GB
};
function WB(t) {
  const e = this, n = [];
  let r = 0, i, o, a;
  return s;
  function s(p) {
    if (r < n.length) {
      const w = n[r];
      return e.containerState = w[1], t.attempt(
        w[0].continuation,
        c,
        l
      )(p);
    }
    return l(p);
  }
  function c(p) {
    if (r++, e.containerState._closeFlow) {
      e.containerState._closeFlow = void 0, i && y();
      const w = e.events.length;
      let _ = w, E;
      for (; _--; )
        if (e.events[_][0] === "exit" && e.events[_][1].type === "chunkFlow") {
          E = e.events[_][1].end;
          break;
        }
      m(r);
      let S = w;
      for (; S < e.events.length; )
        e.events[S][1].end = Object.assign({}, E), S++;
      return er(
        e.events,
        _ + 1,
        0,
        e.events.slice(w)
      ), e.events.length = S, l(p);
    }
    return s(p);
  }
  function l(p) {
    if (r === n.length) {
      if (!i)
        return f(p);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return g(p);
      e.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return e.containerState = {}, t.check(
      P1,
      u,
      d
    )(p);
  }
  function u(p) {
    return i && y(), m(r), f(p);
  }
  function d(p) {
    return e.parser.lazy[e.now().line] = r !== n.length, a = e.now().offset, g(p);
  }
  function f(p) {
    return e.containerState = {}, t.attempt(
      P1,
      h,
      g
    )(p);
  }
  function h(p) {
    return r++, n.push([e.currentConstruct, e.containerState]), f(p);
  }
  function g(p) {
    if (p === null) {
      i && y(), m(0), t.consume(p);
      return;
    }
    return i = i || e.parser.flow(e.now()), t.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), v(p);
  }
  function v(p) {
    if (p === null) {
      b(t.exit("chunkFlow"), !0), m(0), t.consume(p);
      return;
    }
    return xe(p) ? (t.consume(p), b(t.exit("chunkFlow")), r = 0, e.interrupt = void 0, s) : (t.consume(p), v);
  }
  function b(p, w) {
    const _ = e.sliceStream(p);
    if (w && _.push(null), p.previous = o, o && (o.next = p), o = p, i.defineSkip(p.start), i.write(_), e.parser.lazy[p.start.line]) {
      let E = i.events.length;
      for (; E--; )
        if (
          // The token starts before the line ending…
          i.events[E][1].start.offset < a && // …and either is not ended yet…
          (!i.events[E][1].end || // …or ends after it.
          i.events[E][1].end.offset > a)
        )
          return;
      const S = e.events.length;
      let T = S, x, A;
      for (; T--; )
        if (e.events[T][0] === "exit" && e.events[T][1].type === "chunkFlow") {
          if (x) {
            A = e.events[T][1].end;
            break;
          }
          x = !0;
        }
      for (m(r), E = S; E < e.events.length; )
        e.events[E][1].end = Object.assign({}, A), E++;
      er(
        e.events,
        T + 1,
        0,
        e.events.slice(S)
      ), e.events.length = E;
    }
  }
  function m(p) {
    let w = n.length;
    for (; w-- > p; ) {
      const _ = n[w];
      e.containerState = _[1], _[0].exit.call(e, t);
    }
    n.length = p;
  }
  function y() {
    i.write([null]), o = void 0, i = void 0, e.containerState._closeFlow = void 0;
  }
}
function GB(t, e, n) {
  return dt(
    t,
    t.attempt(this.parser.constructs.document, e, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Cu(t) {
  if (t === null || Dt(t) || Ro(t))
    return 1;
  if (dd(t))
    return 2;
}
function fd(t, e, n) {
  const r = [];
  let i = -1;
  for (; ++i < t.length; ) {
    const o = t[i].resolveAll;
    o && !r.includes(o) && (e = o(e, n), r.push(o));
  }
  return e;
}
const hp = {
  name: "attention",
  tokenize: QB,
  resolveAll: YB
};
function YB(t, e) {
  let n = -1, r, i, o, a, s, c, l, u;
  for (; ++n < t.length; )
    if (t[n][0] === "enter" && t[n][1].type === "attentionSequence" && t[n][1]._close) {
      for (r = n; r--; )
        if (t[r][0] === "exit" && t[r][1].type === "attentionSequence" && t[r][1]._open && // If the markers are the same:
        e.sliceSerialize(t[r][1]).charCodeAt(0) === e.sliceSerialize(t[n][1]).charCodeAt(0)) {
          if ((t[r][1]._close || t[n][1]._open) && (t[n][1].end.offset - t[n][1].start.offset) % 3 && !((t[r][1].end.offset - t[r][1].start.offset + t[n][1].end.offset - t[n][1].start.offset) % 3))
            continue;
          c = t[r][1].end.offset - t[r][1].start.offset > 1 && t[n][1].end.offset - t[n][1].start.offset > 1 ? 2 : 1;
          const d = Object.assign({}, t[r][1].end), f = Object.assign({}, t[n][1].start);
          D1(d, -c), D1(f, c), a = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: d,
            end: Object.assign({}, t[r][1].end)
          }, s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, t[n][1].start),
            end: f
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, t[r][1].end),
            end: Object.assign({}, t[n][1].start)
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, s.end)
          }, t[r][1].end = Object.assign({}, a.start), t[n][1].start = Object.assign({}, s.end), l = [], t[r][1].end.offset - t[r][1].start.offset && (l = lr(l, [
            ["enter", t[r][1], e],
            ["exit", t[r][1], e]
          ])), l = lr(l, [
            ["enter", i, e],
            ["enter", a, e],
            ["exit", a, e],
            ["enter", o, e]
          ]), l = lr(
            l,
            fd(
              e.parser.constructs.insideSpan.null,
              t.slice(r + 1, n),
              e
            )
          ), l = lr(l, [
            ["exit", o, e],
            ["enter", s, e],
            ["exit", s, e],
            ["exit", i, e]
          ]), t[n][1].end.offset - t[n][1].start.offset ? (u = 2, l = lr(l, [
            ["enter", t[n][1], e],
            ["exit", t[n][1], e]
          ])) : u = 0, er(t, r - 1, n - r + 3, l), n = r + l.length - u - 2;
          break;
        }
    }
  for (n = -1; ++n < t.length; )
    t[n][1].type === "attentionSequence" && (t[n][1].type = "data");
  return t;
}
function QB(t, e) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Cu(r);
  let o;
  return a;
  function a(c) {
    return o = c, t.enter("attentionSequence"), s(c);
  }
  function s(c) {
    if (c === o)
      return t.consume(c), s;
    const l = t.exit("attentionSequence"), u = Cu(c), d = !u || u === 2 && i || n.includes(c), f = !i || i === 2 && u || n.includes(r);
    return l._open = !!(o === 42 ? d : d && (i || !f)), l._close = !!(o === 42 ? f : f && (u || !d)), e(c);
  }
}
function D1(t, e) {
  t.column += e, t.offset += e, t._bufferIndex += e;
}
const JB = {
  name: "autolink",
  tokenize: ZB
};
function ZB(t, e, n) {
  let r = 0;
  return i;
  function i(h) {
    return t.enter("autolink"), t.enter("autolinkMarker"), t.consume(h), t.exit("autolinkMarker"), t.enter("autolinkProtocol"), o;
  }
  function o(h) {
    return Dn(h) ? (t.consume(h), a) : l(h);
  }
  function a(h) {
    return h === 43 || h === 45 || h === 46 || Mn(h) ? (r = 1, s(h)) : l(h);
  }
  function s(h) {
    return h === 58 ? (t.consume(h), r = 0, c) : (h === 43 || h === 45 || h === 46 || Mn(h)) && r++ < 32 ? (t.consume(h), s) : (r = 0, l(h));
  }
  function c(h) {
    return h === 62 ? (t.exit("autolinkProtocol"), t.enter("autolinkMarker"), t.consume(h), t.exit("autolinkMarker"), t.exit("autolink"), e) : h === null || h === 32 || h === 60 || Eu(h) ? n(h) : (t.consume(h), c);
  }
  function l(h) {
    return h === 64 ? (t.consume(h), u) : jB(h) ? (t.consume(h), l) : n(h);
  }
  function u(h) {
    return Mn(h) ? d(h) : n(h);
  }
  function d(h) {
    return h === 46 ? (t.consume(h), r = 0, u) : h === 62 ? (t.exit("autolinkProtocol").type = "autolinkEmail", t.enter("autolinkMarker"), t.consume(h), t.exit("autolinkMarker"), t.exit("autolink"), e) : f(h);
  }
  function f(h) {
    if ((h === 45 || Mn(h)) && r++ < 63) {
      const g = h === 45 ? f : d;
      return t.consume(h), g;
    }
    return n(h);
  }
}
const Pc = {
  tokenize: XB,
  partial: !0
};
function XB(t, e, n) {
  return r;
  function r(o) {
    return ct(o) ? dt(t, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || xe(o) ? e(o) : n(o);
  }
}
const IC = {
  name: "blockQuote",
  tokenize: ej,
  continuation: {
    tokenize: tj
  },
  exit: nj
};
function ej(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    if (a === 62) {
      const s = r.containerState;
      return s.open || (t.enter("blockQuote", {
        _container: !0
      }), s.open = !0), t.enter("blockQuotePrefix"), t.enter("blockQuoteMarker"), t.consume(a), t.exit("blockQuoteMarker"), o;
    }
    return n(a);
  }
  function o(a) {
    return ct(a) ? (t.enter("blockQuotePrefixWhitespace"), t.consume(a), t.exit("blockQuotePrefixWhitespace"), t.exit("blockQuotePrefix"), e) : (t.exit("blockQuotePrefix"), e(a));
  }
}
function tj(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return ct(a) ? dt(
      t,
      o,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(a) : o(a);
  }
  function o(a) {
    return t.attempt(IC, e, n)(a);
  }
}
function nj(t) {
  t.exit("blockQuote");
}
const SC = {
  name: "characterEscape",
  tokenize: rj
};
function rj(t, e, n) {
  return r;
  function r(o) {
    return t.enter("characterEscape"), t.enter("escapeMarker"), t.consume(o), t.exit("escapeMarker"), i;
  }
  function i(o) {
    return $B(o) ? (t.enter("characterEscapeValue"), t.consume(o), t.exit("characterEscapeValue"), t.exit("characterEscape"), e) : n(o);
  }
}
const L1 = document.createElement("i");
function bm(t) {
  const e = "&" + t + ";";
  L1.innerHTML = e;
  const n = L1.textContent;
  return n.charCodeAt(n.length - 1) === 59 && t !== "semi" || n === e ? !1 : n;
}
const TC = {
  name: "characterReference",
  tokenize: ij
};
function ij(t, e, n) {
  const r = this;
  let i = 0, o, a;
  return s;
  function s(d) {
    return t.enter("characterReference"), t.enter("characterReferenceMarker"), t.consume(d), t.exit("characterReferenceMarker"), c;
  }
  function c(d) {
    return d === 35 ? (t.enter("characterReferenceMarkerNumeric"), t.consume(d), t.exit("characterReferenceMarkerNumeric"), l) : (t.enter("characterReferenceValue"), o = 31, a = Mn, u(d));
  }
  function l(d) {
    return d === 88 || d === 120 ? (t.enter("characterReferenceMarkerHexadecimal"), t.consume(d), t.exit("characterReferenceMarkerHexadecimal"), t.enter("characterReferenceValue"), o = 6, a = VB, u) : (t.enter("characterReferenceValue"), o = 7, a = fp, u(d));
  }
  function u(d) {
    if (d === 59 && i) {
      const f = t.exit("characterReferenceValue");
      return a === Mn && !bm(r.sliceSerialize(f)) ? n(d) : (t.enter("characterReferenceMarker"), t.consume(d), t.exit("characterReferenceMarker"), t.exit("characterReference"), e);
    }
    return a(d) && i++ < o ? (t.consume(d), u) : n(d);
  }
}
const F1 = {
  tokenize: aj,
  partial: !0
}, U1 = {
  name: "codeFenced",
  tokenize: oj,
  concrete: !0
};
function oj(t, e, n) {
  const r = this, i = {
    tokenize: _,
    partial: !0
  };
  let o = 0, a = 0, s;
  return c;
  function c(E) {
    return l(E);
  }
  function l(E) {
    const S = r.events[r.events.length - 1];
    return o = S && S[1].type === "linePrefix" ? S[2].sliceSerialize(S[1], !0).length : 0, s = E, t.enter("codeFenced"), t.enter("codeFencedFence"), t.enter("codeFencedFenceSequence"), u(E);
  }
  function u(E) {
    return E === s ? (a++, t.consume(E), u) : a < 3 ? n(E) : (t.exit("codeFencedFenceSequence"), ct(E) ? dt(t, d, "whitespace")(E) : d(E));
  }
  function d(E) {
    return E === null || xe(E) ? (t.exit("codeFencedFence"), r.interrupt ? e(E) : t.check(F1, v, w)(E)) : (t.enter("codeFencedFenceInfo"), t.enter("chunkString", {
      contentType: "string"
    }), f(E));
  }
  function f(E) {
    return E === null || xe(E) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), d(E)) : ct(E) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), dt(t, h, "whitespace")(E)) : E === 96 && E === s ? n(E) : (t.consume(E), f);
  }
  function h(E) {
    return E === null || xe(E) ? d(E) : (t.enter("codeFencedFenceMeta"), t.enter("chunkString", {
      contentType: "string"
    }), g(E));
  }
  function g(E) {
    return E === null || xe(E) ? (t.exit("chunkString"), t.exit("codeFencedFenceMeta"), d(E)) : E === 96 && E === s ? n(E) : (t.consume(E), g);
  }
  function v(E) {
    return t.attempt(i, w, b)(E);
  }
  function b(E) {
    return t.enter("lineEnding"), t.consume(E), t.exit("lineEnding"), m;
  }
  function m(E) {
    return o > 0 && ct(E) ? dt(
      t,
      y,
      "linePrefix",
      o + 1
    )(E) : y(E);
  }
  function y(E) {
    return E === null || xe(E) ? t.check(F1, v, w)(E) : (t.enter("codeFlowValue"), p(E));
  }
  function p(E) {
    return E === null || xe(E) ? (t.exit("codeFlowValue"), y(E)) : (t.consume(E), p);
  }
  function w(E) {
    return t.exit("codeFenced"), e(E);
  }
  function _(E, S, T) {
    let x = 0;
    return A;
    function A(z) {
      return E.enter("lineEnding"), E.consume(z), E.exit("lineEnding"), N;
    }
    function N(z) {
      return E.enter("codeFencedFence"), ct(z) ? dt(
        E,
        F,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(z) : F(z);
    }
    function F(z) {
      return z === s ? (E.enter("codeFencedFenceSequence"), D(z)) : T(z);
    }
    function D(z) {
      return z === s ? (x++, E.consume(z), D) : x >= a ? (E.exit("codeFencedFenceSequence"), ct(z) ? dt(E, L, "whitespace")(z) : L(z)) : T(z);
    }
    function L(z) {
      return z === null || xe(z) ? (E.exit("codeFencedFence"), S(z)) : T(z);
    }
  }
}
function aj(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return a === null ? n(a) : (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), o);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : e(a);
  }
}
const If = {
  name: "codeIndented",
  tokenize: cj
}, sj = {
  tokenize: lj,
  partial: !0
};
function cj(t, e, n) {
  const r = this;
  return i;
  function i(l) {
    return t.enter("codeIndented"), dt(t, o, "linePrefix", 4 + 1)(l);
  }
  function o(l) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? a(l) : n(l);
  }
  function a(l) {
    return l === null ? c(l) : xe(l) ? t.attempt(sj, a, c)(l) : (t.enter("codeFlowValue"), s(l));
  }
  function s(l) {
    return l === null || xe(l) ? (t.exit("codeFlowValue"), a(l)) : (t.consume(l), s);
  }
  function c(l) {
    return t.exit("codeIndented"), e(l);
  }
}
function lj(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : xe(a) ? (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), i) : dt(t, o, "linePrefix", 4 + 1)(a);
  }
  function o(a) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(a) : xe(a) ? i(a) : n(a);
  }
}
const uj = {
  name: "codeText",
  tokenize: hj,
  resolve: dj,
  previous: fj
};
function dj(t) {
  let e = t.length - 4, n = 3, r, i;
  if ((t[n][1].type === "lineEnding" || t[n][1].type === "space") && (t[e][1].type === "lineEnding" || t[e][1].type === "space")) {
    for (r = n; ++r < e; )
      if (t[r][1].type === "codeTextData") {
        t[n][1].type = "codeTextPadding", t[e][1].type = "codeTextPadding", n += 2, e -= 2;
        break;
      }
  }
  for (r = n - 1, e++; ++r <= e; )
    i === void 0 ? r !== e && t[r][1].type !== "lineEnding" && (i = r) : (r === e || t[r][1].type === "lineEnding") && (t[i][1].type = "codeTextData", r !== i + 2 && (t[i][1].end = t[r - 1][1].end, t.splice(i + 2, r - i - 2), e -= r - i - 2, r = i + 2), i = void 0);
  return t;
}
function fj(t) {
  return t !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function hj(t, e, n) {
  let r = 0, i, o;
  return a;
  function a(d) {
    return t.enter("codeText"), t.enter("codeTextSequence"), s(d);
  }
  function s(d) {
    return d === 96 ? (t.consume(d), r++, s) : (t.exit("codeTextSequence"), c(d));
  }
  function c(d) {
    return d === null ? n(d) : d === 32 ? (t.enter("space"), t.consume(d), t.exit("space"), c) : d === 96 ? (o = t.enter("codeTextSequence"), i = 0, u(d)) : xe(d) ? (t.enter("lineEnding"), t.consume(d), t.exit("lineEnding"), c) : (t.enter("codeTextData"), l(d));
  }
  function l(d) {
    return d === null || d === 32 || d === 96 || xe(d) ? (t.exit("codeTextData"), c(d)) : (t.consume(d), l);
  }
  function u(d) {
    return d === 96 ? (t.consume(d), i++, u) : i === r ? (t.exit("codeTextSequence"), t.exit("codeText"), e(d)) : (o.type = "codeTextData", l(d));
  }
}
function kC(t) {
  const e = {};
  let n = -1, r, i, o, a, s, c, l;
  for (; ++n < t.length; ) {
    for (; n in e; )
      n = e[n];
    if (r = t[n], n && r[1].type === "chunkFlow" && t[n - 1][1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(e, pj(t, n)), n = e[n], l = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (a = t[o], a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (t[i][1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, t[i][1].start), s = t.slice(i, n), s.unshift(r), er(t, i, n - i + 1, s));
    }
  }
  return !l;
}
function pj(t, e) {
  const n = t[e][1], r = t[e][2];
  let i = e - 1;
  const o = [], a = n._tokenizer || r.parser[n.contentType](n.start), s = a.events, c = [], l = {};
  let u, d, f = -1, h = n, g = 0, v = 0;
  const b = [v];
  for (; h; ) {
    for (; t[++i][1] !== h; )
      ;
    o.push(i), h._tokenizer || (u = r.sliceStream(h), h.next || u.push(null), d && a.defineSkip(h.start), h._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(u), h._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), d = h, h = h.next;
  }
  for (h = n; ++f < s.length; )
    // Find a void token that includes a break.
    s[f][0] === "exit" && s[f - 1][0] === "enter" && s[f][1].type === s[f - 1][1].type && s[f][1].start.line !== s[f][1].end.line && (v = f + 1, b.push(v), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (a.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : b.pop(), f = b.length; f--; ) {
    const m = s.slice(b[f], b[f + 1]), y = o.pop();
    c.unshift([y, y + m.length - 1]), er(t, y, 2, m);
  }
  for (f = -1; ++f < c.length; )
    l[g + c[f][0]] = g + c[f][1], g += c[f][1] - c[f][0] - 1;
  return l;
}
const gj = {
  tokenize: yj,
  resolve: vj
}, mj = {
  tokenize: wj,
  partial: !0
};
function vj(t) {
  return kC(t), t;
}
function yj(t, e) {
  let n;
  return r;
  function r(s) {
    return t.enter("content"), n = t.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? o(s) : xe(s) ? t.check(
      mj,
      a,
      o
    )(s) : (t.consume(s), i);
  }
  function o(s) {
    return t.exit("chunkContent"), t.exit("content"), e(s);
  }
  function a(s) {
    return t.consume(s), t.exit("chunkContent"), n.next = t.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function wj(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return t.exit("chunkContent"), t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), dt(t, o, "linePrefix");
  }
  function o(a) {
    if (a === null || xe(a))
      return n(a);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(a) : t.interrupt(r.parser.constructs.flow, n, e)(a);
  }
}
function AC(t, e, n, r, i, o, a, s, c) {
  const l = c || Number.POSITIVE_INFINITY;
  let u = 0;
  return d;
  function d(m) {
    return m === 60 ? (t.enter(r), t.enter(i), t.enter(o), t.consume(m), t.exit(o), f) : m === null || m === 32 || m === 41 || Eu(m) ? n(m) : (t.enter(r), t.enter(a), t.enter(s), t.enter("chunkString", {
      contentType: "string"
    }), v(m));
  }
  function f(m) {
    return m === 62 ? (t.enter(o), t.consume(m), t.exit(o), t.exit(i), t.exit(r), e) : (t.enter(s), t.enter("chunkString", {
      contentType: "string"
    }), h(m));
  }
  function h(m) {
    return m === 62 ? (t.exit("chunkString"), t.exit(s), f(m)) : m === null || m === 60 || xe(m) ? n(m) : (t.consume(m), m === 92 ? g : h);
  }
  function g(m) {
    return m === 60 || m === 62 || m === 92 ? (t.consume(m), h) : h(m);
  }
  function v(m) {
    return !u && (m === null || m === 41 || Dt(m)) ? (t.exit("chunkString"), t.exit(s), t.exit(a), t.exit(r), e(m)) : u < l && m === 40 ? (t.consume(m), u++, v) : m === 41 ? (t.consume(m), u--, v) : m === null || m === 32 || m === 40 || Eu(m) ? n(m) : (t.consume(m), m === 92 ? b : v);
  }
  function b(m) {
    return m === 40 || m === 41 || m === 92 ? (t.consume(m), v) : v(m);
  }
}
function OC(t, e, n, r, i, o) {
  const a = this;
  let s = 0, c;
  return l;
  function l(h) {
    return t.enter(r), t.enter(i), t.consume(h), t.exit(i), t.enter(o), u;
  }
  function u(h) {
    return s > 999 || h === null || h === 91 || h === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !s && "_hiddenFootnoteSupport" in a.parser.constructs ? n(h) : h === 93 ? (t.exit(o), t.enter(i), t.consume(h), t.exit(i), t.exit(r), e) : xe(h) ? (t.enter("lineEnding"), t.consume(h), t.exit("lineEnding"), u) : (t.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === null || h === 91 || h === 93 || xe(h) || s++ > 999 ? (t.exit("chunkString"), u(h)) : (t.consume(h), c || (c = !ct(h)), h === 92 ? f : d);
  }
  function f(h) {
    return h === 91 || h === 92 || h === 93 ? (t.consume(h), s++, d) : d(h);
  }
}
function xC(t, e, n, r, i, o) {
  let a;
  return s;
  function s(f) {
    return f === 34 || f === 39 || f === 40 ? (t.enter(r), t.enter(i), t.consume(f), t.exit(i), a = f === 40 ? 41 : f, c) : n(f);
  }
  function c(f) {
    return f === a ? (t.enter(i), t.consume(f), t.exit(i), t.exit(r), e) : (t.enter(o), l(f));
  }
  function l(f) {
    return f === a ? (t.exit(o), c(a)) : f === null ? n(f) : xe(f) ? (t.enter("lineEnding"), t.consume(f), t.exit("lineEnding"), dt(t, l, "linePrefix")) : (t.enter("chunkString", {
      contentType: "string"
    }), u(f));
  }
  function u(f) {
    return f === a || f === null || xe(f) ? (t.exit("chunkString"), l(f)) : (t.consume(f), f === 92 ? d : u);
  }
  function d(f) {
    return f === a || f === 92 ? (t.consume(f), u) : u(f);
  }
}
function Fs(t, e) {
  let n;
  return r;
  function r(i) {
    return xe(i) ? (t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), n = !0, r) : ct(i) ? dt(
      t,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : e(i);
  }
}
function Sr(t) {
  return t.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const bj = {
  name: "definition",
  tokenize: Ej
}, _j = {
  tokenize: Cj,
  partial: !0
};
function Ej(t, e, n) {
  const r = this;
  let i;
  return o;
  function o(h) {
    return t.enter("definition"), a(h);
  }
  function a(h) {
    return OC.call(
      r,
      t,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function s(h) {
    return i = Sr(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), h === 58 ? (t.enter("definitionMarker"), t.consume(h), t.exit("definitionMarker"), c) : n(h);
  }
  function c(h) {
    return Dt(h) ? Fs(t, l)(h) : l(h);
  }
  function l(h) {
    return AC(
      t,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function u(h) {
    return t.attempt(_j, d, d)(h);
  }
  function d(h) {
    return ct(h) ? dt(t, f, "whitespace")(h) : f(h);
  }
  function f(h) {
    return h === null || xe(h) ? (t.exit("definition"), r.parser.defined.push(i), e(h)) : n(h);
  }
}
function Cj(t, e, n) {
  return r;
  function r(s) {
    return Dt(s) ? Fs(t, i)(s) : n(s);
  }
  function i(s) {
    return xC(
      t,
      o,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(s);
  }
  function o(s) {
    return ct(s) ? dt(t, a, "whitespace")(s) : a(s);
  }
  function a(s) {
    return s === null || xe(s) ? e(s) : n(s);
  }
}
const Ij = {
  name: "hardBreakEscape",
  tokenize: Sj
};
function Sj(t, e, n) {
  return r;
  function r(o) {
    return t.enter("hardBreakEscape"), t.consume(o), i;
  }
  function i(o) {
    return xe(o) ? (t.exit("hardBreakEscape"), e(o)) : n(o);
  }
}
const Tj = {
  name: "headingAtx",
  tokenize: Aj,
  resolve: kj
};
function kj(t, e) {
  let n = t.length - 2, r = 3, i, o;
  return t[r][1].type === "whitespace" && (r += 2), n - 2 > r && t[n][1].type === "whitespace" && (n -= 2), t[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && t[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: t[r][1].start,
    end: t[n][1].end
  }, o = {
    type: "chunkText",
    start: t[r][1].start,
    end: t[n][1].end,
    contentType: "text"
  }, er(t, r, n - r + 1, [
    ["enter", i, e],
    ["enter", o, e],
    ["exit", o, e],
    ["exit", i, e]
  ])), t;
}
function Aj(t, e, n) {
  let r = 0;
  return i;
  function i(u) {
    return t.enter("atxHeading"), o(u);
  }
  function o(u) {
    return t.enter("atxHeadingSequence"), a(u);
  }
  function a(u) {
    return u === 35 && r++ < 6 ? (t.consume(u), a) : u === null || Dt(u) ? (t.exit("atxHeadingSequence"), s(u)) : n(u);
  }
  function s(u) {
    return u === 35 ? (t.enter("atxHeadingSequence"), c(u)) : u === null || xe(u) ? (t.exit("atxHeading"), e(u)) : ct(u) ? dt(t, s, "whitespace")(u) : (t.enter("atxHeadingText"), l(u));
  }
  function c(u) {
    return u === 35 ? (t.consume(u), c) : (t.exit("atxHeadingSequence"), s(u));
  }
  function l(u) {
    return u === null || u === 35 || Dt(u) ? (t.exit("atxHeadingText"), s(u)) : (t.consume(u), l);
  }
}
const Oj = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], H1 = ["pre", "script", "style", "textarea"], xj = {
  name: "htmlFlow",
  tokenize: Pj,
  resolveTo: Mj,
  concrete: !0
}, Rj = {
  tokenize: Lj,
  partial: !0
}, Nj = {
  tokenize: Dj,
  partial: !0
};
function Mj(t) {
  let e = t.length;
  for (; e-- && !(t[e][0] === "enter" && t[e][1].type === "htmlFlow"); )
    ;
  return e > 1 && t[e - 2][1].type === "linePrefix" && (t[e][1].start = t[e - 2][1].start, t[e + 1][1].start = t[e - 2][1].start, t.splice(e - 2, 2)), t;
}
function Pj(t, e, n) {
  const r = this;
  let i, o, a, s, c;
  return l;
  function l(O) {
    return u(O);
  }
  function u(O) {
    return t.enter("htmlFlow"), t.enter("htmlFlowData"), t.consume(O), d;
  }
  function d(O) {
    return O === 33 ? (t.consume(O), f) : O === 47 ? (t.consume(O), o = !0, v) : O === 63 ? (t.consume(O), i = 3, r.interrupt ? e : I) : Dn(O) ? (t.consume(O), a = String.fromCharCode(O), b) : n(O);
  }
  function f(O) {
    return O === 45 ? (t.consume(O), i = 2, h) : O === 91 ? (t.consume(O), i = 5, s = 0, g) : Dn(O) ? (t.consume(O), i = 4, r.interrupt ? e : I) : n(O);
  }
  function h(O) {
    return O === 45 ? (t.consume(O), r.interrupt ? e : I) : n(O);
  }
  function g(O) {
    const ue = "CDATA[";
    return O === ue.charCodeAt(s++) ? (t.consume(O), s === ue.length ? r.interrupt ? e : F : g) : n(O);
  }
  function v(O) {
    return Dn(O) ? (t.consume(O), a = String.fromCharCode(O), b) : n(O);
  }
  function b(O) {
    if (O === null || O === 47 || O === 62 || Dt(O)) {
      const ue = O === 47, Ce = a.toLowerCase();
      return !ue && !o && H1.includes(Ce) ? (i = 1, r.interrupt ? e(O) : F(O)) : Oj.includes(a.toLowerCase()) ? (i = 6, ue ? (t.consume(O), m) : r.interrupt ? e(O) : F(O)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(O) : o ? y(O) : p(O));
    }
    return O === 45 || Mn(O) ? (t.consume(O), a += String.fromCharCode(O), b) : n(O);
  }
  function m(O) {
    return O === 62 ? (t.consume(O), r.interrupt ? e : F) : n(O);
  }
  function y(O) {
    return ct(O) ? (t.consume(O), y) : A(O);
  }
  function p(O) {
    return O === 47 ? (t.consume(O), A) : O === 58 || O === 95 || Dn(O) ? (t.consume(O), w) : ct(O) ? (t.consume(O), p) : A(O);
  }
  function w(O) {
    return O === 45 || O === 46 || O === 58 || O === 95 || Mn(O) ? (t.consume(O), w) : _(O);
  }
  function _(O) {
    return O === 61 ? (t.consume(O), E) : ct(O) ? (t.consume(O), _) : p(O);
  }
  function E(O) {
    return O === null || O === 60 || O === 61 || O === 62 || O === 96 ? n(O) : O === 34 || O === 39 ? (t.consume(O), c = O, S) : ct(O) ? (t.consume(O), E) : T(O);
  }
  function S(O) {
    return O === c ? (t.consume(O), c = null, x) : O === null || xe(O) ? n(O) : (t.consume(O), S);
  }
  function T(O) {
    return O === null || O === 34 || O === 39 || O === 47 || O === 60 || O === 61 || O === 62 || O === 96 || Dt(O) ? _(O) : (t.consume(O), T);
  }
  function x(O) {
    return O === 47 || O === 62 || ct(O) ? p(O) : n(O);
  }
  function A(O) {
    return O === 62 ? (t.consume(O), N) : n(O);
  }
  function N(O) {
    return O === null || xe(O) ? F(O) : ct(O) ? (t.consume(O), N) : n(O);
  }
  function F(O) {
    return O === 45 && i === 2 ? (t.consume(O), ne) : O === 60 && i === 1 ? (t.consume(O), ae) : O === 62 && i === 4 ? (t.consume(O), J) : O === 63 && i === 3 ? (t.consume(O), I) : O === 93 && i === 5 ? (t.consume(O), fe) : xe(O) && (i === 6 || i === 7) ? (t.exit("htmlFlowData"), t.check(
      Rj,
      me,
      D
    )(O)) : O === null || xe(O) ? (t.exit("htmlFlowData"), D(O)) : (t.consume(O), F);
  }
  function D(O) {
    return t.check(
      Nj,
      L,
      me
    )(O);
  }
  function L(O) {
    return t.enter("lineEnding"), t.consume(O), t.exit("lineEnding"), z;
  }
  function z(O) {
    return O === null || xe(O) ? D(O) : (t.enter("htmlFlowData"), F(O));
  }
  function ne(O) {
    return O === 45 ? (t.consume(O), I) : F(O);
  }
  function ae(O) {
    return O === 47 ? (t.consume(O), a = "", Re) : F(O);
  }
  function Re(O) {
    if (O === 62) {
      const ue = a.toLowerCase();
      return H1.includes(ue) ? (t.consume(O), J) : F(O);
    }
    return Dn(O) && a.length < 8 ? (t.consume(O), a += String.fromCharCode(O), Re) : F(O);
  }
  function fe(O) {
    return O === 93 ? (t.consume(O), I) : F(O);
  }
  function I(O) {
    return O === 62 ? (t.consume(O), J) : O === 45 && i === 2 ? (t.consume(O), I) : F(O);
  }
  function J(O) {
    return O === null || xe(O) ? (t.exit("htmlFlowData"), me(O)) : (t.consume(O), J);
  }
  function me(O) {
    return t.exit("htmlFlow"), e(O);
  }
}
function Dj(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return xe(a) ? (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), o) : n(a);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : e(a);
  }
}
function Lj(t, e, n) {
  return r;
  function r(i) {
    return t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), t.attempt(Pc, e, n);
  }
}
const Fj = {
  name: "htmlText",
  tokenize: Uj
};
function Uj(t, e, n) {
  const r = this;
  let i, o, a;
  return s;
  function s(I) {
    return t.enter("htmlText"), t.enter("htmlTextData"), t.consume(I), c;
  }
  function c(I) {
    return I === 33 ? (t.consume(I), l) : I === 47 ? (t.consume(I), _) : I === 63 ? (t.consume(I), p) : Dn(I) ? (t.consume(I), T) : n(I);
  }
  function l(I) {
    return I === 45 ? (t.consume(I), u) : I === 91 ? (t.consume(I), o = 0, g) : Dn(I) ? (t.consume(I), y) : n(I);
  }
  function u(I) {
    return I === 45 ? (t.consume(I), h) : n(I);
  }
  function d(I) {
    return I === null ? n(I) : I === 45 ? (t.consume(I), f) : xe(I) ? (a = d, ae(I)) : (t.consume(I), d);
  }
  function f(I) {
    return I === 45 ? (t.consume(I), h) : d(I);
  }
  function h(I) {
    return I === 62 ? ne(I) : I === 45 ? f(I) : d(I);
  }
  function g(I) {
    const J = "CDATA[";
    return I === J.charCodeAt(o++) ? (t.consume(I), o === J.length ? v : g) : n(I);
  }
  function v(I) {
    return I === null ? n(I) : I === 93 ? (t.consume(I), b) : xe(I) ? (a = v, ae(I)) : (t.consume(I), v);
  }
  function b(I) {
    return I === 93 ? (t.consume(I), m) : v(I);
  }
  function m(I) {
    return I === 62 ? ne(I) : I === 93 ? (t.consume(I), m) : v(I);
  }
  function y(I) {
    return I === null || I === 62 ? ne(I) : xe(I) ? (a = y, ae(I)) : (t.consume(I), y);
  }
  function p(I) {
    return I === null ? n(I) : I === 63 ? (t.consume(I), w) : xe(I) ? (a = p, ae(I)) : (t.consume(I), p);
  }
  function w(I) {
    return I === 62 ? ne(I) : p(I);
  }
  function _(I) {
    return Dn(I) ? (t.consume(I), E) : n(I);
  }
  function E(I) {
    return I === 45 || Mn(I) ? (t.consume(I), E) : S(I);
  }
  function S(I) {
    return xe(I) ? (a = S, ae(I)) : ct(I) ? (t.consume(I), S) : ne(I);
  }
  function T(I) {
    return I === 45 || Mn(I) ? (t.consume(I), T) : I === 47 || I === 62 || Dt(I) ? x(I) : n(I);
  }
  function x(I) {
    return I === 47 ? (t.consume(I), ne) : I === 58 || I === 95 || Dn(I) ? (t.consume(I), A) : xe(I) ? (a = x, ae(I)) : ct(I) ? (t.consume(I), x) : ne(I);
  }
  function A(I) {
    return I === 45 || I === 46 || I === 58 || I === 95 || Mn(I) ? (t.consume(I), A) : N(I);
  }
  function N(I) {
    return I === 61 ? (t.consume(I), F) : xe(I) ? (a = N, ae(I)) : ct(I) ? (t.consume(I), N) : x(I);
  }
  function F(I) {
    return I === null || I === 60 || I === 61 || I === 62 || I === 96 ? n(I) : I === 34 || I === 39 ? (t.consume(I), i = I, D) : xe(I) ? (a = F, ae(I)) : ct(I) ? (t.consume(I), F) : (t.consume(I), L);
  }
  function D(I) {
    return I === i ? (t.consume(I), i = void 0, z) : I === null ? n(I) : xe(I) ? (a = D, ae(I)) : (t.consume(I), D);
  }
  function L(I) {
    return I === null || I === 34 || I === 39 || I === 60 || I === 61 || I === 96 ? n(I) : I === 47 || I === 62 || Dt(I) ? x(I) : (t.consume(I), L);
  }
  function z(I) {
    return I === 47 || I === 62 || Dt(I) ? x(I) : n(I);
  }
  function ne(I) {
    return I === 62 ? (t.consume(I), t.exit("htmlTextData"), t.exit("htmlText"), e) : n(I);
  }
  function ae(I) {
    return t.exit("htmlTextData"), t.enter("lineEnding"), t.consume(I), t.exit("lineEnding"), Re;
  }
  function Re(I) {
    return ct(I) ? dt(
      t,
      fe,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(I) : fe(I);
  }
  function fe(I) {
    return t.enter("htmlTextData"), a(I);
  }
}
const _m = {
  name: "labelEnd",
  tokenize: qj,
  resolveTo: $j,
  resolveAll: Vj
}, Hj = {
  tokenize: zj
}, Bj = {
  tokenize: Kj
}, jj = {
  tokenize: Wj
};
function Vj(t) {
  let e = -1;
  for (; ++e < t.length; ) {
    const n = t[e][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (t.splice(e + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", e++);
  }
  return t;
}
function $j(t, e) {
  let n = t.length, r = 0, i, o, a, s;
  for (; n--; )
    if (i = t[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      t[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (t[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (a = n);
  const c = {
    type: t[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, t[o][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  }, l = {
    type: "label",
    start: Object.assign({}, t[o][1].start),
    end: Object.assign({}, t[a][1].end)
  }, u = {
    type: "labelText",
    start: Object.assign({}, t[o + r + 2][1].end),
    end: Object.assign({}, t[a - 2][1].start)
  };
  return s = [
    ["enter", c, e],
    ["enter", l, e]
  ], s = lr(s, t.slice(o + 1, o + r + 3)), s = lr(s, [["enter", u, e]]), s = lr(
    s,
    fd(
      e.parser.constructs.insideSpan.null,
      t.slice(o + r + 4, a - 3),
      e
    )
  ), s = lr(s, [
    ["exit", u, e],
    t[a - 2],
    t[a - 1],
    ["exit", l, e]
  ]), s = lr(s, t.slice(a + 1)), s = lr(s, [["exit", c, e]]), er(t, o, t.length, s), t;
}
function qj(t, e, n) {
  const r = this;
  let i = r.events.length, o, a;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return s;
  function s(f) {
    return o ? o._inactive ? d(f) : (a = r.parser.defined.includes(
      Sr(
        r.sliceSerialize({
          start: o.end,
          end: r.now()
        })
      )
    ), t.enter("labelEnd"), t.enter("labelMarker"), t.consume(f), t.exit("labelMarker"), t.exit("labelEnd"), c) : n(f);
  }
  function c(f) {
    return f === 40 ? t.attempt(
      Hj,
      u,
      a ? u : d
    )(f) : f === 91 ? t.attempt(
      Bj,
      u,
      a ? l : d
    )(f) : a ? u(f) : d(f);
  }
  function l(f) {
    return t.attempt(
      jj,
      u,
      d
    )(f);
  }
  function u(f) {
    return e(f);
  }
  function d(f) {
    return o._balanced = !0, n(f);
  }
}
function zj(t, e, n) {
  return r;
  function r(d) {
    return t.enter("resource"), t.enter("resourceMarker"), t.consume(d), t.exit("resourceMarker"), i;
  }
  function i(d) {
    return Dt(d) ? Fs(t, o)(d) : o(d);
  }
  function o(d) {
    return d === 41 ? u(d) : AC(
      t,
      a,
      s,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(d);
  }
  function a(d) {
    return Dt(d) ? Fs(t, c)(d) : u(d);
  }
  function s(d) {
    return n(d);
  }
  function c(d) {
    return d === 34 || d === 39 || d === 40 ? xC(
      t,
      l,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(d) : u(d);
  }
  function l(d) {
    return Dt(d) ? Fs(t, u)(d) : u(d);
  }
  function u(d) {
    return d === 41 ? (t.enter("resourceMarker"), t.consume(d), t.exit("resourceMarker"), t.exit("resource"), e) : n(d);
  }
}
function Kj(t, e, n) {
  const r = this;
  return i;
  function i(s) {
    return OC.call(
      r,
      t,
      o,
      a,
      "reference",
      "referenceMarker",
      "referenceString"
    )(s);
  }
  function o(s) {
    return r.parser.defined.includes(
      Sr(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? e(s) : n(s);
  }
  function a(s) {
    return n(s);
  }
}
function Wj(t, e, n) {
  return r;
  function r(o) {
    return t.enter("reference"), t.enter("referenceMarker"), t.consume(o), t.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (t.enter("referenceMarker"), t.consume(o), t.exit("referenceMarker"), t.exit("reference"), e) : n(o);
  }
}
const Gj = {
  name: "labelStartImage",
  tokenize: Yj,
  resolveAll: _m.resolveAll
};
function Yj(t, e, n) {
  const r = this;
  return i;
  function i(s) {
    return t.enter("labelImage"), t.enter("labelImageMarker"), t.consume(s), t.exit("labelImageMarker"), o;
  }
  function o(s) {
    return s === 91 ? (t.enter("labelMarker"), t.consume(s), t.exit("labelMarker"), t.exit("labelImage"), a) : n(s);
  }
  function a(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : e(s);
  }
}
const Qj = {
  name: "labelStartLink",
  tokenize: Jj,
  resolveAll: _m.resolveAll
};
function Jj(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return t.enter("labelLink"), t.enter("labelMarker"), t.consume(a), t.exit("labelMarker"), t.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : e(a);
  }
}
const Sf = {
  name: "lineEnding",
  tokenize: Zj
};
function Zj(t, e) {
  return n;
  function n(r) {
    return t.enter("lineEnding"), t.consume(r), t.exit("lineEnding"), dt(t, e, "linePrefix");
  }
}
const Ol = {
  name: "thematicBreak",
  tokenize: Xj
};
function Xj(t, e, n) {
  let r = 0, i;
  return o;
  function o(l) {
    return t.enter("thematicBreak"), a(l);
  }
  function a(l) {
    return i = l, s(l);
  }
  function s(l) {
    return l === i ? (t.enter("thematicBreakSequence"), c(l)) : r >= 3 && (l === null || xe(l)) ? (t.exit("thematicBreak"), e(l)) : n(l);
  }
  function c(l) {
    return l === i ? (t.consume(l), r++, c) : (t.exit("thematicBreakSequence"), ct(l) ? dt(t, s, "whitespace")(l) : s(l));
  }
}
const Un = {
  name: "list",
  tokenize: nV,
  continuation: {
    tokenize: rV
  },
  exit: oV
}, eV = {
  tokenize: aV,
  partial: !0
}, tV = {
  tokenize: iV,
  partial: !0
};
function nV(t, e, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return s;
  function s(h) {
    const g = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : fp(h)) {
      if (r.containerState.type || (r.containerState.type = g, t.enter(g, {
        _container: !0
      })), g === "listUnordered")
        return t.enter("listItemPrefix"), h === 42 || h === 45 ? t.check(Ol, n, l)(h) : l(h);
      if (!r.interrupt || h === 49)
        return t.enter("listItemPrefix"), t.enter("listItemValue"), c(h);
    }
    return n(h);
  }
  function c(h) {
    return fp(h) && ++a < 10 ? (t.consume(h), c) : (!r.interrupt || a < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (t.exit("listItemValue"), l(h)) : n(h);
  }
  function l(h) {
    return t.enter("listItemMarker"), t.consume(h), t.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, t.check(
      Pc,
      // Can’t be empty when interrupting.
      r.interrupt ? n : u,
      t.attempt(
        eV,
        f,
        d
      )
    );
  }
  function u(h) {
    return r.containerState.initialBlankLine = !0, o++, f(h);
  }
  function d(h) {
    return ct(h) ? (t.enter("listItemPrefixWhitespace"), t.consume(h), t.exit("listItemPrefixWhitespace"), f) : n(h);
  }
  function f(h) {
    return r.containerState.size = o + r.sliceSerialize(t.exit("listItemPrefix"), !0).length, e(h);
  }
}
function rV(t, e, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, t.check(Pc, i, o);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, dt(
      t,
      e,
      "listItemIndent",
      r.containerState.size + 1
    )(s);
  }
  function o(s) {
    return r.containerState.furtherBlankLines || !ct(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, t.attempt(tV, e, a)(s));
  }
  function a(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, dt(
      t,
      t.attempt(Un, e, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function iV(t, e, n) {
  const r = this;
  return dt(
    t,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? e(o) : n(o);
  }
}
function oV(t) {
  t.exit(this.containerState.type);
}
function aV(t, e, n) {
  const r = this;
  return dt(
    t,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return !ct(o) && a && a[1].type === "listItemPrefixWhitespace" ? e(o) : n(o);
  }
}
const B1 = {
  name: "setextUnderline",
  tokenize: cV,
  resolveTo: sV
};
function sV(t, e) {
  let n = t.length, r, i, o;
  for (; n--; )
    if (t[n][0] === "enter") {
      if (t[n][1].type === "content") {
        r = n;
        break;
      }
      t[n][1].type === "paragraph" && (i = n);
    } else
      t[n][1].type === "content" && t.splice(n, 1), !o && t[n][1].type === "definition" && (o = n);
  const a = {
    type: "setextHeading",
    start: Object.assign({}, t[i][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  };
  return t[i][1].type = "setextHeadingText", o ? (t.splice(i, 0, ["enter", a, e]), t.splice(o + 1, 0, ["exit", t[r][1], e]), t[r][1].end = Object.assign({}, t[o][1].end)) : t[r][1] = a, t.push(["exit", a, e]), t;
}
function cV(t, e, n) {
  const r = this;
  let i;
  return o;
  function o(l) {
    let u = r.events.length, d;
    for (; u--; )
      if (r.events[u][1].type !== "lineEnding" && r.events[u][1].type !== "linePrefix" && r.events[u][1].type !== "content") {
        d = r.events[u][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || d) ? (t.enter("setextHeadingLine"), i = l, a(l)) : n(l);
  }
  function a(l) {
    return t.enter("setextHeadingLineSequence"), s(l);
  }
  function s(l) {
    return l === i ? (t.consume(l), s) : (t.exit("setextHeadingLineSequence"), ct(l) ? dt(t, c, "lineSuffix")(l) : c(l));
  }
  function c(l) {
    return l === null || xe(l) ? (t.exit("setextHeadingLine"), e(l)) : n(l);
  }
}
const lV = {
  tokenize: uV
};
function uV(t) {
  const e = this, n = t.attempt(
    // Try to parse a blank line.
    Pc,
    r,
    // Try to parse initial flow (essentially, only code).
    t.attempt(
      this.parser.constructs.flowInitial,
      i,
      dt(
        t,
        t.attempt(
          this.parser.constructs.flow,
          i,
          t.attempt(gj, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      t.consume(o);
      return;
    }
    return t.enter("lineEndingBlank"), t.consume(o), t.exit("lineEndingBlank"), e.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      t.consume(o);
      return;
    }
    return t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), e.currentConstruct = void 0, n;
  }
}
const dV = {
  resolveAll: NC()
}, fV = RC("string"), hV = RC("text");
function RC(t) {
  return {
    tokenize: e,
    resolveAll: NC(
      t === "text" ? pV : void 0
    )
  };
  function e(n) {
    const r = this, i = this.parser.constructs[t], o = n.attempt(i, a, s);
    return a;
    function a(u) {
      return l(u) ? o(u) : s(u);
    }
    function s(u) {
      if (u === null) {
        n.consume(u);
        return;
      }
      return n.enter("data"), n.consume(u), c;
    }
    function c(u) {
      return l(u) ? (n.exit("data"), o(u)) : (n.consume(u), c);
    }
    function l(u) {
      if (u === null)
        return !0;
      const d = i[u];
      let f = -1;
      if (d)
        for (; ++f < d.length; ) {
          const h = d[f];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function NC(t) {
  return e;
  function e(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return t ? t(n, r) : n;
  }
}
function pV(t, e) {
  let n = 0;
  for (; ++n <= t.length; )
    if ((n === t.length || t[n][1].type === "lineEnding") && t[n - 1][1].type === "data") {
      const r = t[n - 1][1], i = e.sliceStream(r);
      let o = i.length, a = -1, s = 0, c;
      for (; o--; ) {
        const l = i[o];
        if (typeof l == "string") {
          for (a = l.length; l.charCodeAt(a - 1) === 32; )
            s++, a--;
          if (a)
            break;
          a = -1;
        } else if (l === -2)
          c = !0, s++;
        else if (l !== -1) {
          o++;
          break;
        }
      }
      if (s) {
        const l = {
          type: n === t.length || c || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + o,
            _bufferIndex: o ? a : r.start._bufferIndex + a
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, l.start), r.start.offset === r.end.offset ? Object.assign(r, l) : (t.splice(
          n,
          0,
          ["enter", l, e],
          ["exit", l, e]
        ), n += 2);
      }
      n++;
    }
  return t;
}
function gV(t, e, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let a = [], s = [];
  const c = {
    consume: y,
    enter: p,
    exit: w,
    attempt: S(_),
    check: S(E),
    interrupt: S(E, {
      interrupt: !0
    })
  }, l = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: t,
    sliceStream: h,
    sliceSerialize: f,
    now: g,
    defineSkip: v,
    write: d
  };
  let u = e.tokenize.call(l, c);
  return e.resolveAll && o.push(e), l;
  function d(N) {
    return a = lr(a, N), b(), a[a.length - 1] !== null ? [] : (T(e, 0), l.events = fd(o, l.events, l), l.events);
  }
  function f(N, F) {
    return vV(h(N), F);
  }
  function h(N) {
    return mV(a, N);
  }
  function g() {
    const { line: N, column: F, offset: D, _index: L, _bufferIndex: z } = r;
    return {
      line: N,
      column: F,
      offset: D,
      _index: L,
      _bufferIndex: z
    };
  }
  function v(N) {
    i[N.line] = N.column, A();
  }
  function b() {
    let N;
    for (; r._index < a.length; ) {
      const F = a[r._index];
      if (typeof F == "string")
        for (N = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === N && r._bufferIndex < F.length; )
          m(F.charCodeAt(r._bufferIndex));
      else
        m(F);
    }
  }
  function m(N) {
    u = u(N);
  }
  function y(N) {
    xe(N) ? (r.line++, r.column = 1, r.offset += N === -3 ? 2 : 1, A()) : N !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === a[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = N;
  }
  function p(N, F) {
    const D = F || {};
    return D.type = N, D.start = g(), l.events.push(["enter", D, l]), s.push(D), D;
  }
  function w(N) {
    const F = s.pop();
    return F.end = g(), l.events.push(["exit", F, l]), F;
  }
  function _(N, F) {
    T(N, F.from);
  }
  function E(N, F) {
    F.restore();
  }
  function S(N, F) {
    return D;
    function D(L, z, ne) {
      let ae, Re, fe, I;
      return Array.isArray(L) ? me(L) : "tokenize" in L ? (
        // @ts-expect-error Looks like a construct.
        me([L])
      ) : J(L);
      function J(Z) {
        return he;
        function he(Q) {
          const $ = Q !== null && Z[Q], q = Q !== null && Z.null, H = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray($) ? $ : $ ? [$] : [],
            ...Array.isArray(q) ? q : q ? [q] : []
          ];
          return me(H)(Q);
        }
      }
      function me(Z) {
        return ae = Z, Re = 0, Z.length === 0 ? ne : O(Z[Re]);
      }
      function O(Z) {
        return he;
        function he(Q) {
          return I = x(), fe = Z, Z.partial || (l.currentConstruct = Z), Z.name && l.parser.constructs.disable.null.includes(Z.name) ? Ce() : Z.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            F ? Object.assign(Object.create(l), F) : l,
            c,
            ue,
            Ce
          )(Q);
        }
      }
      function ue(Z) {
        return N(fe, I), z;
      }
      function Ce(Z) {
        return I.restore(), ++Re < ae.length ? O(ae[Re]) : ne;
      }
    }
  }
  function T(N, F) {
    N.resolveAll && !o.includes(N) && o.push(N), N.resolve && er(
      l.events,
      F,
      l.events.length - F,
      N.resolve(l.events.slice(F), l)
    ), N.resolveTo && (l.events = N.resolveTo(l.events, l));
  }
  function x() {
    const N = g(), F = l.previous, D = l.currentConstruct, L = l.events.length, z = Array.from(s);
    return {
      restore: ne,
      from: L
    };
    function ne() {
      r = N, l.previous = F, l.currentConstruct = D, l.events.length = L, s = z, A();
    }
  }
  function A() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function mV(t, e) {
  const n = e.start._index, r = e.start._bufferIndex, i = e.end._index, o = e.end._bufferIndex;
  let a;
  if (n === i)
    a = [t[n].slice(r, o)];
  else {
    if (a = t.slice(n, i), r > -1) {
      const s = a[0];
      typeof s == "string" ? a[0] = s.slice(r) : a.shift();
    }
    o > 0 && a.push(t[i].slice(0, o));
  }
  return a;
}
function vV(t, e) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < t.length; ) {
    const o = t[n];
    let a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = e ? " " : "	";
          break;
        }
        case -1: {
          if (!e && i)
            continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, r.push(a);
  }
  return r.join("");
}
const yV = {
  [42]: Un,
  [43]: Un,
  [45]: Un,
  [48]: Un,
  [49]: Un,
  [50]: Un,
  [51]: Un,
  [52]: Un,
  [53]: Un,
  [54]: Un,
  [55]: Un,
  [56]: Un,
  [57]: Un,
  [62]: IC
}, wV = {
  [91]: bj
}, bV = {
  [-2]: If,
  [-1]: If,
  [32]: If
}, _V = {
  [35]: Tj,
  [42]: Ol,
  [45]: [B1, Ol],
  [60]: xj,
  [61]: B1,
  [95]: Ol,
  [96]: U1,
  [126]: U1
}, EV = {
  [38]: TC,
  [92]: SC
}, CV = {
  [-5]: Sf,
  [-4]: Sf,
  [-3]: Sf,
  [33]: Gj,
  [38]: TC,
  [42]: hp,
  [60]: [JB, Fj],
  [91]: Qj,
  [92]: [Ij, SC],
  [93]: _m,
  [95]: hp,
  [96]: uj
}, IV = {
  null: [hp, dV]
}, SV = {
  null: [42, 95]
}, TV = {
  null: []
}, kV = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: SV,
  contentInitial: wV,
  disable: TV,
  document: yV,
  flow: _V,
  flowInitial: bV,
  insideSpan: IV,
  string: EV,
  text: CV
}, Symbol.toStringTag, { value: "Module" }));
function AV(t) {
  const n = (
    /** @type {FullNormalizedExtension} */
    CC([kV, ...(t || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(qB),
    document: i(KB),
    flow: i(lV),
    string: i(fV),
    text: i(hV)
  };
  return r;
  function i(o) {
    return a;
    function a(s) {
      return gV(r, o, s);
    }
  }
}
const j1 = /[\0\t\n\r]/g;
function OV() {
  let t = 1, e = "", n = !0, r;
  return i;
  function i(o, a, s) {
    const c = [];
    let l, u, d, f, h;
    for (o = e + o.toString(a), d = 0, e = "", n && (o.charCodeAt(0) === 65279 && d++, n = void 0); d < o.length; ) {
      if (j1.lastIndex = d, l = j1.exec(o), f = l && l.index !== void 0 ? l.index : o.length, h = o.charCodeAt(f), !l) {
        e = o.slice(d);
        break;
      }
      if (h === 10 && d === f && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), d < f && (c.push(o.slice(d, f)), t += f - d), h) {
          case 0: {
            c.push(65533), t++;
            break;
          }
          case 9: {
            for (u = Math.ceil(t / 4) * 4, c.push(-2); t++ < u; )
              c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), t = 1;
            break;
          }
          default:
            r = !0, t = 1;
        }
      d = f + 1;
    }
    return s && (r && c.push(-5), e && c.push(e), c.push(null)), c;
  }
}
function xV(t) {
  for (; !kC(t); )
    ;
  return t;
}
function MC(t, e) {
  const n = Number.parseInt(t, e);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "�" : String.fromCharCode(n)
  );
}
const RV = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function PC(t) {
  return t.replace(RV, NV);
}
function NV(t, e, n) {
  if (e)
    return e;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return MC(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return bm(n) || t;
}
const DC = {}.hasOwnProperty, MV = (
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */
  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function(t, e, n) {
    return typeof e != "string" && (n = e, e = void 0), PV(n)(
      xV(
        AV(n).document().write(OV()(t, e, !0))
      )
    );
  }
);
function PV(t) {
  const e = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: s(ut),
      autolinkProtocol: N,
      autolinkEmail: N,
      atxHeading: s(ht),
      blockQuote: s(H),
      characterEscape: N,
      characterReference: N,
      codeFenced: s(V),
      codeFencedFenceInfo: c,
      codeFencedFenceMeta: c,
      codeIndented: s(V, c),
      codeText: s(Pe, c),
      codeTextData: N,
      data: N,
      codeFlowValue: N,
      definition: s(X),
      definitionDestinationString: c,
      definitionLabelString: c,
      definitionTitleString: c,
      emphasis: s(it),
      hardBreakEscape: s(Ze),
      hardBreakTrailing: s(Ze),
      htmlFlow: s(pt, c),
      htmlFlowData: N,
      htmlText: s(pt, c),
      htmlTextData: N,
      image: s(Nt),
      label: c,
      link: s(ut),
      listItem: s(en),
      listItemValue: g,
      listOrdered: s(We, h),
      listUnordered: s(We),
      paragraph: s(Jt),
      reference: Ce,
      referenceString: c,
      resourceDestinationString: c,
      resourceTitleString: c,
      setextHeading: s(ht),
      strong: s(gt),
      thematicBreak: s(Tt)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: S,
      autolink: u(),
      autolinkEmail: q,
      autolinkProtocol: $,
      blockQuote: u(),
      characterEscapeValue: F,
      characterReferenceMarkerHexadecimal: he,
      characterReferenceMarkerNumeric: he,
      characterReferenceValue: Q,
      codeFenced: u(y),
      codeFencedFence: m,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: b,
      codeFlowValue: F,
      codeIndented: u(p),
      codeText: u(ae),
      codeTextData: F,
      data: F,
      definition: u(),
      definitionDestinationString: E,
      definitionLabelString: w,
      definitionTitleString: _,
      emphasis: u(),
      hardBreakEscape: u(L),
      hardBreakTrailing: u(L),
      htmlFlow: u(z),
      htmlFlowData: F,
      htmlText: u(ne),
      htmlTextData: F,
      image: u(fe),
      label: J,
      labelText: I,
      lineEnding: D,
      link: u(Re),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Z,
      resourceDestinationString: me,
      resourceTitleString: O,
      resource: ue,
      setextHeading: u(A),
      setextHeadingLineSequence: x,
      setextHeadingText: T,
      strong: u(),
      thematicBreak: u()
    }
  };
  LC(e, (t || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(U) {
    let Y = {
      type: "root",
      children: []
    };
    const we = {
      stack: [Y],
      tokenStack: [],
      config: e,
      enter: l,
      exit: d,
      buffer: c,
      resume: f,
      setData: o,
      getData: a
    }, qe = [];
    let Ye = -1;
    for (; ++Ye < U.length; )
      if (U[Ye][1].type === "listOrdered" || U[Ye][1].type === "listUnordered")
        if (U[Ye][0] === "enter")
          qe.push(Ye);
        else {
          const kt = qe.pop();
          Ye = i(U, kt, Ye);
        }
    for (Ye = -1; ++Ye < U.length; ) {
      const kt = e[U[Ye][0]];
      DC.call(kt, U[Ye][1].type) && kt[U[Ye][1].type].call(
        Object.assign(
          {
            sliceSerialize: U[Ye][2].sliceSerialize
          },
          we
        ),
        U[Ye][1]
      );
    }
    if (we.tokenStack.length > 0) {
      const kt = we.tokenStack[we.tokenStack.length - 1];
      (kt[1] || V1).call(we, void 0, kt[0]);
    }
    for (Y.position = {
      start: Ii(
        U.length > 0 ? U[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: Ii(
        U.length > 0 ? U[U.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, Ye = -1; ++Ye < e.transforms.length; )
      Y = e.transforms[Ye](Y) || Y;
    return Y;
  }
  function i(U, Y, we) {
    let qe = Y - 1, Ye = -1, kt = !1, tn, vn, jt, Xt;
    for (; ++qe <= we; ) {
      const vt = U[qe];
      if (vt[1].type === "listUnordered" || vt[1].type === "listOrdered" || vt[1].type === "blockQuote" ? (vt[0] === "enter" ? Ye++ : Ye--, Xt = void 0) : vt[1].type === "lineEndingBlank" ? vt[0] === "enter" && (tn && !Xt && !Ye && !jt && (jt = qe), Xt = void 0) : vt[1].type === "linePrefix" || vt[1].type === "listItemValue" || vt[1].type === "listItemMarker" || vt[1].type === "listItemPrefix" || vt[1].type === "listItemPrefixWhitespace" || (Xt = void 0), !Ye && vt[0] === "enter" && vt[1].type === "listItemPrefix" || Ye === -1 && vt[0] === "exit" && (vt[1].type === "listUnordered" || vt[1].type === "listOrdered")) {
        if (tn) {
          let zn = qe;
          for (vn = void 0; zn--; ) {
            const gn = U[zn];
            if (gn[1].type === "lineEnding" || gn[1].type === "lineEndingBlank") {
              if (gn[0] === "exit")
                continue;
              vn && (U[vn][1].type = "lineEndingBlank", kt = !0), gn[1].type = "lineEnding", vn = zn;
            } else if (!(gn[1].type === "linePrefix" || gn[1].type === "blockQuotePrefix" || gn[1].type === "blockQuotePrefixWhitespace" || gn[1].type === "blockQuoteMarker" || gn[1].type === "listItemIndent"))
              break;
          }
          jt && (!vn || jt < vn) && (tn._spread = !0), tn.end = Object.assign(
            {},
            vn ? U[vn][1].start : vt[1].end
          ), U.splice(vn || qe, 0, ["exit", tn, vt[2]]), qe++, we++;
        }
        vt[1].type === "listItemPrefix" && (tn = {
          type: "listItem",
          _spread: !1,
          start: Object.assign({}, vt[1].start),
          // @ts-expect-error: we’ll add `end` in a second.
          end: void 0
        }, U.splice(qe, 0, ["enter", tn, vt[2]]), qe++, we++, jt = void 0, Xt = !0);
      }
    }
    return U[Y][1]._spread = kt, we;
  }
  function o(U, Y) {
    n[U] = Y;
  }
  function a(U) {
    return n[U];
  }
  function s(U, Y) {
    return we;
    function we(qe) {
      l.call(this, U(qe), qe), Y && Y.call(this, qe);
    }
  }
  function c() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(U, Y, we) {
    return this.stack[this.stack.length - 1].children.push(U), this.stack.push(U), this.tokenStack.push([Y, we]), U.position = {
      start: Ii(Y.start)
    }, U;
  }
  function u(U) {
    return Y;
    function Y(we) {
      U && U.call(this, we), d.call(this, we);
    }
  }
  function d(U, Y) {
    const we = this.stack.pop(), qe = this.tokenStack.pop();
    if (qe)
      qe[0].type !== U.type && (Y ? Y.call(this, U, qe[0]) : (qe[1] || V1).call(this, U, qe[0]));
    else
      throw new Error(
        "Cannot close `" + U.type + "` (" + Ls({
          start: U.start,
          end: U.end
        }) + "): it’s not open"
      );
    return we.position.end = Ii(U.end), we;
  }
  function f() {
    return LB(this.stack.pop());
  }
  function h() {
    o("expectingFirstListItemValue", !0);
  }
  function g(U) {
    if (a("expectingFirstListItemValue")) {
      const Y = this.stack[this.stack.length - 2];
      Y.start = Number.parseInt(this.sliceSerialize(U), 10), o("expectingFirstListItemValue");
    }
  }
  function v() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.lang = U;
  }
  function b() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.meta = U;
  }
  function m() {
    a("flowCodeInside") || (this.buffer(), o("flowCodeInside", !0));
  }
  function y() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = U.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), o("flowCodeInside");
  }
  function p() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = U.replace(/(\r?\n|\r)$/g, "");
  }
  function w(U) {
    const Y = this.resume(), we = this.stack[this.stack.length - 1];
    we.label = Y, we.identifier = Sr(
      this.sliceSerialize(U)
    ).toLowerCase();
  }
  function _() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.title = U;
  }
  function E() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.url = U;
  }
  function S(U) {
    const Y = this.stack[this.stack.length - 1];
    if (!Y.depth) {
      const we = this.sliceSerialize(U).length;
      Y.depth = we;
    }
  }
  function T() {
    o("setextHeadingSlurpLineEnding", !0);
  }
  function x(U) {
    const Y = this.stack[this.stack.length - 1];
    Y.depth = this.sliceSerialize(U).charCodeAt(0) === 61 ? 1 : 2;
  }
  function A() {
    o("setextHeadingSlurpLineEnding");
  }
  function N(U) {
    const Y = this.stack[this.stack.length - 1];
    let we = Y.children[Y.children.length - 1];
    (!we || we.type !== "text") && (we = Zt(), we.position = {
      start: Ii(U.start)
    }, Y.children.push(we)), this.stack.push(we);
  }
  function F(U) {
    const Y = this.stack.pop();
    Y.value += this.sliceSerialize(U), Y.position.end = Ii(U.end);
  }
  function D(U) {
    const Y = this.stack[this.stack.length - 1];
    if (a("atHardBreak")) {
      const we = Y.children[Y.children.length - 1];
      we.position.end = Ii(U.end), o("atHardBreak");
      return;
    }
    !a("setextHeadingSlurpLineEnding") && e.canContainEols.includes(Y.type) && (N.call(this, U), F.call(this, U));
  }
  function L() {
    o("atHardBreak", !0);
  }
  function z() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = U;
  }
  function ne() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = U;
  }
  function ae() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.value = U;
  }
  function Re() {
    const U = this.stack[this.stack.length - 1];
    if (a("inReference")) {
      const Y = a("referenceType") || "shortcut";
      U.type += "Reference", U.referenceType = Y, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    o("referenceType");
  }
  function fe() {
    const U = this.stack[this.stack.length - 1];
    if (a("inReference")) {
      const Y = a("referenceType") || "shortcut";
      U.type += "Reference", U.referenceType = Y, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    o("referenceType");
  }
  function I(U) {
    const Y = this.sliceSerialize(U), we = this.stack[this.stack.length - 2];
    we.label = PC(Y), we.identifier = Sr(Y).toLowerCase();
  }
  function J() {
    const U = this.stack[this.stack.length - 1], Y = this.resume(), we = this.stack[this.stack.length - 1];
    if (o("inReference", !0), we.type === "link") {
      const qe = U.children;
      we.children = qe;
    } else
      we.alt = Y;
  }
  function me() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.url = U;
  }
  function O() {
    const U = this.resume(), Y = this.stack[this.stack.length - 1];
    Y.title = U;
  }
  function ue() {
    o("inReference");
  }
  function Ce() {
    o("referenceType", "collapsed");
  }
  function Z(U) {
    const Y = this.resume(), we = this.stack[this.stack.length - 1];
    we.label = Y, we.identifier = Sr(
      this.sliceSerialize(U)
    ).toLowerCase(), o("referenceType", "full");
  }
  function he(U) {
    o("characterReferenceType", U.type);
  }
  function Q(U) {
    const Y = this.sliceSerialize(U), we = a("characterReferenceType");
    let qe;
    we ? (qe = MC(
      Y,
      we === "characterReferenceMarkerNumeric" ? 10 : 16
    ), o("characterReferenceType")) : qe = bm(Y);
    const Ye = this.stack.pop();
    Ye.value += qe, Ye.position.end = Ii(U.end);
  }
  function $(U) {
    F.call(this, U);
    const Y = this.stack[this.stack.length - 1];
    Y.url = this.sliceSerialize(U);
  }
  function q(U) {
    F.call(this, U);
    const Y = this.stack[this.stack.length - 1];
    Y.url = "mailto:" + this.sliceSerialize(U);
  }
  function H() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function V() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Pe() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function X() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function it() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ht() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function Ze() {
    return {
      type: "break"
    };
  }
  function pt() {
    return {
      type: "html",
      value: ""
    };
  }
  function Nt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function ut() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function We(U) {
    return {
      type: "list",
      ordered: U.type === "listOrdered",
      start: null,
      spread: U._spread,
      children: []
    };
  }
  function en(U) {
    return {
      type: "listItem",
      spread: U._spread,
      checked: null,
      children: []
    };
  }
  function Jt() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function gt() {
    return {
      type: "strong",
      children: []
    };
  }
  function Zt() {
    return {
      type: "text",
      value: ""
    };
  }
  function Tt() {
    return {
      type: "thematicBreak"
    };
  }
}
function Ii(t) {
  return {
    line: t.line,
    column: t.column,
    offset: t.offset
  };
}
function LC(t, e) {
  let n = -1;
  for (; ++n < e.length; ) {
    const r = e[n];
    Array.isArray(r) ? LC(t, r) : DV(t, r);
  }
}
function DV(t, e) {
  let n;
  for (n in e)
    if (DC.call(e, n)) {
      if (n === "canContainEols") {
        const r = e[n];
        r && t[n].push(...r);
      } else if (n === "transforms") {
        const r = e[n];
        r && t[n].push(...r);
      } else if (n === "enter" || n === "exit") {
        const r = e[n];
        r && Object.assign(t[n], r);
      }
    }
}
function V1(t, e) {
  throw t ? new Error(
    "Cannot close `" + t.type + "` (" + Ls({
      start: t.start,
      end: t.end
    }) + "): a different token (`" + e.type + "`, " + Ls({
      start: e.start,
      end: e.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + e.type + "`, " + Ls({
      start: e.start,
      end: e.end
    }) + ") is still open"
  );
}
function LV(t) {
  Object.assign(this, { Parser: (n) => {
    const r = (
      /** @type {Options} */
      this.data("settings")
    );
    return MV(
      n,
      Object.assign({}, r, t, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
function FV(t, e) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: t.wrap(t.all(e), !0)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function UV(t, e) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return t.patch(e, n), [t.applyData(e, n), { type: "text", value: `
` }];
}
function HV(t, e) {
  const n = e.value ? e.value + `
` : "", r = e.lang ? e.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null, i = {};
  r && (i.className = ["language-" + r]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: n }]
  };
  return e.meta && (o.data = { meta: e.meta }), t.patch(e, o), o = t.applyData(e, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, t.patch(e, o), o;
}
function BV(t, e) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function jV(t, e) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function ts(t) {
  const e = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < t.length; ) {
    const o = t.charCodeAt(n);
    let a = "";
    if (o === 37 && Mn(t.charCodeAt(n + 1)) && Mn(t.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (a = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const s = t.charCodeAt(n + 1);
      o < 56320 && s > 56319 && s < 57344 ? (a = String.fromCharCode(o, s), i = 1) : a = "�";
    } else
      a = String.fromCharCode(o);
    a && (e.push(t.slice(r, n), encodeURIComponent(a)), r = n + i + 1, a = ""), i && (n += i, i = 0);
  }
  return e.join("") + t.slice(r);
}
function FC(t, e) {
  const n = String(e.identifier).toUpperCase(), r = ts(n.toLowerCase()), i = t.footnoteOrder.indexOf(n);
  let o;
  i === -1 ? (t.footnoteOrder.push(n), t.footnoteCounts[n] = 1, o = t.footnoteOrder.length) : (t.footnoteCounts[n]++, o = i + 1);
  const a = t.footnoteCounts[n], s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t.clobberPrefix + "fn-" + r,
      id: t.clobberPrefix + "fnref-" + r + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  t.patch(e, s);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return t.patch(e, c), t.applyData(e, c);
}
function VV(t, e) {
  const n = t.footnoteById;
  let r = 1;
  for (; r in n; )
    r++;
  const i = String(r);
  return n[i] = {
    type: "footnoteDefinition",
    identifier: i,
    children: [{ type: "paragraph", children: e.children }],
    position: e.position
  }, FC(t, {
    type: "footnoteReference",
    identifier: i,
    position: e.position
  });
}
function $V(t, e) {
  const n = {
    type: "element",
    tagName: "h" + e.depth,
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function qV(t, e) {
  if (t.dangerous) {
    const n = { type: "raw", value: e.value };
    return t.patch(e, n), t.applyData(e, n);
  }
  return null;
}
function UC(t, e) {
  const n = e.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (e.label || e.identifier) + "]"), e.type === "imageReference")
    return { type: "text", value: "![" + e.alt + r };
  const i = t.all(e), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const a = i[i.length - 1];
  return a && a.type === "text" ? a.value += r : i.push({ type: "text", value: r }), i;
}
function zV(t, e) {
  const n = t.definition(e.identifier);
  if (!n)
    return UC(t, e);
  const r = { src: ts(n.url || ""), alt: e.alt };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return t.patch(e, i), t.applyData(e, i);
}
function KV(t, e) {
  const n = { src: ts(e.url) };
  e.alt !== null && e.alt !== void 0 && (n.alt = e.alt), e.title !== null && e.title !== void 0 && (n.title = e.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return t.patch(e, r), t.applyData(e, r);
}
function WV(t, e) {
  const n = { type: "text", value: e.value.replace(/\r?\n|\r/g, " ") };
  t.patch(e, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return t.patch(e, r), t.applyData(e, r);
}
function GV(t, e) {
  const n = t.definition(e.identifier);
  if (!n)
    return UC(t, e);
  const r = { href: ts(n.url || "") };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: t.all(e)
  };
  return t.patch(e, i), t.applyData(e, i);
}
function YV(t, e) {
  const n = { href: ts(e.url) };
  e.title !== null && e.title !== void 0 && (n.title = e.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function QV(t, e, n) {
  const r = t.all(e), i = n ? JV(n) : HC(e), o = {}, a = [];
  if (typeof e.checked == "boolean") {
    const u = r[0];
    let d;
    u && u.type === "element" && u.tagName === "p" ? d = u : (d = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(d)), d.children.length > 0 && d.children.unshift({ type: "text", value: " " }), d.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: e.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const u = r[s];
    (i || s !== 0 || u.type !== "element" || u.tagName !== "p") && a.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !i ? a.push(...u.children) : a.push(u);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && a.push({ type: "text", value: `
` });
  const l = { type: "element", tagName: "li", properties: o, children: a };
  return t.patch(e, l), t.applyData(e, l);
}
function JV(t) {
  let e = !1;
  if (t.type === "list") {
    e = t.spread || !1;
    const n = t.children;
    let r = -1;
    for (; !e && ++r < n.length; )
      e = HC(n[r]);
  }
  return e;
}
function HC(t) {
  const e = t.spread;
  return e ?? t.children.length > 1;
}
function ZV(t, e) {
  const n = {}, r = t.all(e);
  let i = -1;
  for (typeof e.start == "number" && e.start !== 1 && (n.start = e.start); ++i < r.length; ) {
    const a = r[i];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: e.ordered ? "ol" : "ul",
    properties: n,
    children: t.wrap(r, !0)
  };
  return t.patch(e, o), t.applyData(e, o);
}
function XV(t, e) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function e$(t, e) {
  const n = { type: "root", children: t.wrap(t.all(e)) };
  return t.patch(e, n), t.applyData(e, n);
}
function t$(t, e) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
const Em = BC("start"), Cm = BC("end");
function n$(t) {
  return { start: Em(t), end: Cm(t) };
}
function BC(t) {
  return e;
  function e(n) {
    const r = n && n.position && n.position[t] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
function r$(t, e) {
  const n = t.all(e), r = n.shift(), i = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: t.wrap([r], !0)
    };
    t.patch(e.children[0], a), i.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: t.wrap(n, !0)
    }, s = Em(e.children[1]), c = Cm(e.children[e.children.length - 1]);
    s.line && c.line && (a.position = { start: s, end: c }), i.push(a);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: t.wrap(i, !0)
  };
  return t.patch(e, o), t.applyData(e, o);
}
function i$(t, e, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(e) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, s = a ? a.length : e.children.length;
  let c = -1;
  const l = [];
  for (; ++c < s; ) {
    const d = e.children[c], f = {}, h = a ? a[c] : void 0;
    h && (f.align = h);
    let g = { type: "element", tagName: o, properties: f, children: [] };
    d && (g.children = t.all(d), t.patch(d, g), g = t.applyData(e, g)), l.push(g);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: t.wrap(l, !0)
  };
  return t.patch(e, u), t.applyData(e, u);
}
function o$(t, e) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
const $1 = 9, q1 = 32;
function a$(t) {
  const e = String(t), n = /\r?\n|\r/g;
  let r = n.exec(e), i = 0;
  const o = [];
  for (; r; )
    o.push(
      z1(e.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(e);
  return o.push(z1(e.slice(i), i > 0, !1)), o.join("");
}
function z1(t, e, n) {
  let r = 0, i = t.length;
  if (e) {
    let o = t.codePointAt(r);
    for (; o === $1 || o === q1; )
      r++, o = t.codePointAt(r);
  }
  if (n) {
    let o = t.codePointAt(i - 1);
    for (; o === $1 || o === q1; )
      i--, o = t.codePointAt(i - 1);
  }
  return i > r ? t.slice(r, i) : "";
}
function s$(t, e) {
  const n = { type: "text", value: a$(String(e.value)) };
  return t.patch(e, n), t.applyData(e, n);
}
function c$(t, e) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return t.patch(e, n), t.applyData(e, n);
}
const l$ = {
  blockquote: FV,
  break: UV,
  code: HV,
  delete: BV,
  emphasis: jV,
  footnoteReference: FC,
  footnote: VV,
  heading: $V,
  html: qV,
  imageReference: zV,
  image: KV,
  inlineCode: WV,
  linkReference: GV,
  link: YV,
  listItem: QV,
  list: ZV,
  paragraph: XV,
  root: e$,
  strong: t$,
  table: r$,
  tableCell: o$,
  tableRow: i$,
  text: s$,
  thematicBreak: c$,
  toml: rl,
  yaml: rl,
  definition: rl,
  footnoteDefinition: rl
};
function rl() {
  return null;
}
const Im = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(t) {
    if (t == null)
      return h$;
    if (typeof t == "string")
      return f$(t);
    if (typeof t == "object")
      return Array.isArray(t) ? u$(t) : d$(t);
    if (typeof t == "function")
      return hd(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function u$(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e[n] = Im(t[n]);
  return hd(r);
  function r(...i) {
    let o = -1;
    for (; ++o < e.length; )
      if (e[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function d$(t) {
  return hd(e);
  function e(n) {
    let r;
    for (r in t)
      if (n[r] !== t[r])
        return !1;
    return !0;
  }
}
function f$(t) {
  return hd(e);
  function e(n) {
    return n && n.type === t;
  }
}
function hd(t) {
  return e;
  function e(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && t.call(this, n, ...r));
  }
}
function h$() {
  return !0;
}
const p$ = !0, K1 = !1, g$ = "skip", jC = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(t, e, n, r) {
    typeof e == "function" && typeof n != "function" && (r = n, n = e, e = null);
    const i = Im(e), o = r ? -1 : 1;
    a(t, void 0, [])();
    function a(s, c, l) {
      const u = s && typeof s == "object" ? s : {};
      if (typeof u.type == "string") {
        const f = (
          // `hast`
          typeof u.tagName == "string" ? u.tagName : (
            // `xast`
            typeof u.name == "string" ? u.name : void 0
          )
        );
        Object.defineProperty(d, "name", {
          value: "node (" + (s.type + (f ? "<" + f + ">" : "")) + ")"
        });
      }
      return d;
      function d() {
        let f = [], h, g, v;
        if ((!e || i(s, c, l[l.length - 1] || null)) && (f = m$(n(s, l)), f[0] === K1))
          return f;
        if (s.children && f[0] !== g$)
          for (g = (r ? s.children.length : -1) + o, v = l.concat(s); g > -1 && g < s.children.length; ) {
            if (h = a(s.children[g], g, v)(), h[0] === K1)
              return h;
            g = typeof h[1] == "number" ? h[1] : g + o;
          }
        return f;
      }
    }
  }
);
function m$(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [p$, t] : [t];
}
const Sm = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(t, e, n, r) {
    typeof e == "function" && typeof n != "function" && (r = n, n = e, e = null), jC(t, e, i, r);
    function i(o, a) {
      const s = a[a.length - 1];
      return n(
        o,
        s ? s.children.indexOf(o) : null,
        s
      );
    }
  }
);
function v$(t) {
  return !t || !t.position || !t.position.start || !t.position.start.line || !t.position.start.column || !t.position.end || !t.position.end.line || !t.position.end.column;
}
const W1 = {}.hasOwnProperty;
function y$(t) {
  const e = /* @__PURE__ */ Object.create(null);
  if (!t || !t.type)
    throw new Error("mdast-util-definitions expected node");
  return Sm(t, "definition", (r) => {
    const i = G1(r.identifier);
    i && !W1.call(e, i) && (e[i] = r);
  }), n;
  function n(r) {
    const i = G1(r);
    return i && W1.call(e, i) ? e[i] : null;
  }
}
function G1(t) {
  return String(t || "").toUpperCase();
}
const Iu = {}.hasOwnProperty;
function w$(t, e) {
  const n = e || {}, r = n.allowDangerousHtml || !1, i = {};
  return a.dangerous = r, a.clobberPrefix = n.clobberPrefix === void 0 || n.clobberPrefix === null ? "user-content-" : n.clobberPrefix, a.footnoteLabel = n.footnoteLabel || "Footnotes", a.footnoteLabelTagName = n.footnoteLabelTagName || "h2", a.footnoteLabelProperties = n.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a.footnoteBackLabel = n.footnoteBackLabel || "Back to content", a.unknownHandler = n.unknownHandler, a.passThrough = n.passThrough, a.handlers = { ...l$, ...n.handlers }, a.definition = y$(t), a.footnoteById = i, a.footnoteOrder = [], a.footnoteCounts = {}, a.patch = b$, a.applyData = _$, a.one = s, a.all = c, a.wrap = C$, a.augment = o, Sm(t, "footnoteDefinition", (l) => {
    const u = String(l.identifier).toUpperCase();
    Iu.call(i, u) || (i[u] = l);
  }), a;
  function o(l, u) {
    if (l && "data" in l && l.data) {
      const d = l.data;
      d.hName && (u.type !== "element" && (u = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), u.tagName = d.hName), u.type === "element" && d.hProperties && (u.properties = { ...u.properties, ...d.hProperties }), "children" in u && u.children && d.hChildren && (u.children = d.hChildren);
    }
    if (l) {
      const d = "type" in l ? l : { position: l };
      v$(d) || (u.position = { start: Em(d), end: Cm(d) });
    }
    return u;
  }
  function a(l, u, d, f) {
    return Array.isArray(d) && (f = d, d = {}), o(l, {
      type: "element",
      tagName: u,
      properties: d || {},
      children: f || []
    });
  }
  function s(l, u) {
    return VC(a, l, u);
  }
  function c(l) {
    return Tm(a, l);
  }
}
function b$(t, e) {
  t.position && (e.position = n$(t));
}
function _$(t, e) {
  let n = e;
  if (t && t.data) {
    const r = t.data.hName, i = t.data.hChildren, o = t.data.hProperties;
    typeof r == "string" && (n.type === "element" ? n.tagName = r : n = {
      type: "element",
      tagName: r,
      properties: {},
      children: []
    }), n.type === "element" && o && (n.properties = { ...n.properties, ...o }), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function VC(t, e, n) {
  const r = e && e.type;
  if (!r)
    throw new Error("Expected node, got `" + e + "`");
  return Iu.call(t.handlers, r) ? t.handlers[r](t, e, n) : t.passThrough && t.passThrough.includes(r) ? "children" in e ? { ...e, children: Tm(t, e) } : e : t.unknownHandler ? t.unknownHandler(t, e, n) : E$(t, e);
}
function Tm(t, e) {
  const n = [];
  if ("children" in e) {
    const r = e.children;
    let i = -1;
    for (; ++i < r.length; ) {
      const o = VC(t, r[i], e);
      if (o) {
        if (i && r[i - 1].type === "break" && (!Array.isArray(o) && o.type === "text" && (o.value = o.value.replace(/^\s+/, "")), !Array.isArray(o) && o.type === "element")) {
          const a = o.children[0];
          a && a.type === "text" && (a.value = a.value.replace(/^\s+/, ""));
        }
        Array.isArray(o) ? n.push(...o) : n.push(o);
      }
    }
  }
  return n;
}
function E$(t, e) {
  const n = e.data || {}, r = "value" in e && !(Iu.call(n, "hProperties") || Iu.call(n, "hChildren")) ? { type: "text", value: e.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: Tm(t, e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function C$(t, e) {
  const n = [];
  let r = -1;
  for (e && n.push({ type: "text", value: `
` }); ++r < t.length; )
    r && n.push({ type: "text", value: `
` }), n.push(t[r]);
  return e && t.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function I$(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.footnoteOrder.length; ) {
    const r = t.footnoteById[t.footnoteOrder[n]];
    if (!r)
      continue;
    const i = t.all(r), o = String(r.identifier).toUpperCase(), a = ts(o.toLowerCase());
    let s = 0;
    const c = [];
    for (; ++s <= t.footnoteCounts[o]; ) {
      const d = {
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t.clobberPrefix + "fnref-" + a + (s > 1 ? "-" + s : ""),
          dataFootnoteBackref: !0,
          className: ["data-footnote-backref"],
          ariaLabel: t.footnoteBackLabel
        },
        children: [{ type: "text", value: "↩" }]
      };
      s > 1 && d.children.push({
        type: "element",
        tagName: "sup",
        children: [{ type: "text", value: String(s) }]
      }), c.length > 0 && c.push({ type: "text", value: " " }), c.push(d);
    }
    const l = i[i.length - 1];
    if (l && l.type === "element" && l.tagName === "p") {
      const d = l.children[l.children.length - 1];
      d && d.type === "text" ? d.value += " " : l.children.push({ type: "text", value: " " }), l.children.push(...c);
    } else
      i.push(...c);
    const u = {
      type: "element",
      tagName: "li",
      properties: { id: t.clobberPrefix + "fn-" + a },
      children: t.wrap(i, !0)
    };
    t.patch(r, u), e.push(u);
  }
  if (e.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: t.footnoteLabelTagName,
          properties: {
            // To do: use structured clone.
            ...JSON.parse(JSON.stringify(t.footnoteLabelProperties)),
            id: "footnote-label"
          },
          children: [{ type: "text", value: t.footnoteLabel }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: t.wrap(e, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function $C(t, e) {
  const n = w$(t, e), r = n.one(t, null), i = I$(n);
  return i && r.children.push({ type: "text", value: `
` }, i), Array.isArray(r) ? { type: "root", children: r } : r;
}
const S$ = (
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  function(t, e) {
    return t && "run" in t ? k$(t, e) : A$(t || e);
  }
), T$ = S$;
function k$(t, e) {
  return (n, r, i) => {
    t.run($C(n, e), r, (o) => {
      i(o);
    });
  };
}
function A$(t) {
  return (e) => $C(e, t);
}
class Dc {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(e, n, r) {
    this.property = e, this.normal = n, r && (this.space = r);
  }
}
Dc.prototype.property = {};
Dc.prototype.normal = {};
Dc.prototype.space = null;
function qC(t, e) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < t.length; )
    Object.assign(n, t[i].property), Object.assign(r, t[i].normal);
  return new Dc(n, r, e);
}
function pp(t) {
  return t.toLowerCase();
}
class yr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(e, n) {
    this.property = e, this.attribute = n;
  }
}
yr.prototype.space = null;
yr.prototype.boolean = !1;
yr.prototype.booleanish = !1;
yr.prototype.overloadedBoolean = !1;
yr.prototype.number = !1;
yr.prototype.commaSeparated = !1;
yr.prototype.spaceSeparated = !1;
yr.prototype.commaOrSpaceSeparated = !1;
yr.prototype.mustUseProperty = !1;
yr.prototype.defined = !1;
let O$ = 0;
const Xe = Fo(), fn = Fo(), zC = Fo(), te = Fo(), $t = Fo(), ma = Fo(), Kn = Fo();
function Fo() {
  return 2 ** ++O$;
}
const gp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Xe,
  booleanish: fn,
  commaOrSpaceSeparated: Kn,
  commaSeparated: ma,
  number: te,
  overloadedBoolean: zC,
  spaceSeparated: $t
}, Symbol.toStringTag, { value: "Module" })), Tf = Object.keys(gp);
class km extends yr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(e, n, r, i) {
    let o = -1;
    if (super(e, n), Y1(this, "space", i), typeof r == "number")
      for (; ++o < Tf.length; ) {
        const a = Tf[o];
        Y1(this, Tf[o], (r & gp[a]) === gp[a]);
      }
  }
}
km.prototype.defined = !0;
function Y1(t, e, n) {
  n && (t[e] = n);
}
const x$ = {}.hasOwnProperty;
function ns(t) {
  const e = {}, n = {};
  let r;
  for (r in t.properties)
    if (x$.call(t.properties, r)) {
      const i = t.properties[r], o = new km(
        r,
        t.transform(t.attributes || {}, r),
        i,
        t.space
      );
      t.mustUseProperty && t.mustUseProperty.includes(r) && (o.mustUseProperty = !0), e[r] = o, n[pp(r)] = r, n[pp(o.attribute)] = r;
    }
  return new Dc(e, n, t.space);
}
const KC = ns({
  space: "xlink",
  transform(t, e) {
    return "xlink:" + e.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), WC = ns({
  space: "xml",
  transform(t, e) {
    return "xml:" + e.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function GC(t, e) {
  return e in t ? t[e] : e;
}
function YC(t, e) {
  return GC(t, e.toLowerCase());
}
const QC = ns({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: YC,
  properties: { xmlns: null, xmlnsXLink: null }
}), JC = ns({
  transform(t, e) {
    return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: fn,
    ariaAutoComplete: null,
    ariaBusy: fn,
    ariaChecked: fn,
    ariaColCount: te,
    ariaColIndex: te,
    ariaColSpan: te,
    ariaControls: $t,
    ariaCurrent: null,
    ariaDescribedBy: $t,
    ariaDetails: null,
    ariaDisabled: fn,
    ariaDropEffect: $t,
    ariaErrorMessage: null,
    ariaExpanded: fn,
    ariaFlowTo: $t,
    ariaGrabbed: fn,
    ariaHasPopup: null,
    ariaHidden: fn,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: $t,
    ariaLevel: te,
    ariaLive: null,
    ariaModal: fn,
    ariaMultiLine: fn,
    ariaMultiSelectable: fn,
    ariaOrientation: null,
    ariaOwns: $t,
    ariaPlaceholder: null,
    ariaPosInSet: te,
    ariaPressed: fn,
    ariaReadOnly: fn,
    ariaRelevant: null,
    ariaRequired: fn,
    ariaRoleDescription: $t,
    ariaRowCount: te,
    ariaRowIndex: te,
    ariaRowSpan: te,
    ariaSelected: fn,
    ariaSetSize: te,
    ariaSort: null,
    ariaValueMax: te,
    ariaValueMin: te,
    ariaValueNow: te,
    ariaValueText: null,
    role: null
  }
}), R$ = ns({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: YC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ma,
    acceptCharset: $t,
    accessKey: $t,
    action: null,
    allow: null,
    allowFullScreen: Xe,
    allowPaymentRequest: Xe,
    allowUserMedia: Xe,
    alt: null,
    as: null,
    async: Xe,
    autoCapitalize: null,
    autoComplete: $t,
    autoFocus: Xe,
    autoPlay: Xe,
    capture: Xe,
    charSet: null,
    checked: Xe,
    cite: null,
    className: $t,
    cols: te,
    colSpan: null,
    content: null,
    contentEditable: fn,
    controls: Xe,
    controlsList: $t,
    coords: te | ma,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Xe,
    defer: Xe,
    dir: null,
    dirName: null,
    disabled: Xe,
    download: zC,
    draggable: fn,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Xe,
    formTarget: null,
    headers: $t,
    height: te,
    hidden: Xe,
    high: te,
    href: null,
    hrefLang: null,
    htmlFor: $t,
    httpEquiv: $t,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Xe,
    itemId: null,
    itemProp: $t,
    itemRef: $t,
    itemScope: Xe,
    itemType: $t,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Xe,
    low: te,
    manifest: null,
    max: null,
    maxLength: te,
    media: null,
    method: null,
    min: null,
    minLength: te,
    multiple: Xe,
    muted: Xe,
    name: null,
    nonce: null,
    noModule: Xe,
    noValidate: Xe,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Xe,
    optimum: te,
    pattern: null,
    ping: $t,
    placeholder: null,
    playsInline: Xe,
    poster: null,
    preload: null,
    readOnly: Xe,
    referrerPolicy: null,
    rel: $t,
    required: Xe,
    reversed: Xe,
    rows: te,
    rowSpan: te,
    sandbox: $t,
    scope: null,
    scoped: Xe,
    seamless: Xe,
    selected: Xe,
    shape: null,
    size: te,
    sizes: null,
    slot: null,
    span: te,
    spellCheck: fn,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: te,
    step: null,
    style: null,
    tabIndex: te,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Xe,
    useMap: null,
    value: fn,
    width: te,
    wrap: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: $t,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: te,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: te,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Xe,
    // Lists. Use CSS to reduce space between items instead
    declare: Xe,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: te,
    // `<img>` and `<object>`
    leftMargin: te,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: te,
    // `<body>`
    marginWidth: te,
    // `<body>`
    noResize: Xe,
    // `<frame>`
    noHref: Xe,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Xe,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Xe,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: te,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: fn,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: te,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: te,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Xe,
    disableRemotePlayback: Xe,
    prefix: null,
    property: null,
    results: te,
    security: null,
    unselectable: null
  }
}), N$ = ns({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: GC,
  properties: {
    about: Kn,
    accentHeight: te,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: te,
    amplitude: te,
    arabicForm: null,
    ascent: te,
    attributeName: null,
    attributeType: null,
    azimuth: te,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: te,
    by: null,
    calcMode: null,
    capHeight: te,
    className: $t,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: te,
    diffuseConstant: te,
    direction: null,
    display: null,
    dur: null,
    divisor: te,
    dominantBaseline: null,
    download: Xe,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: te,
    enableBackground: null,
    end: null,
    event: null,
    exponent: te,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: te,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ma,
    g2: ma,
    glyphName: ma,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: te,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: te,
    horizOriginX: te,
    horizOriginY: te,
    id: null,
    ideographic: te,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: te,
    k: te,
    k1: te,
    k2: te,
    k3: te,
    k4: te,
    kernelMatrix: Kn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: te,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: te,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: te,
    overlineThickness: te,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: te,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: $t,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: te,
    pointsAtY: te,
    pointsAtZ: te,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Kn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Kn,
    rev: Kn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Kn,
    requiredFeatures: Kn,
    requiredFonts: Kn,
    requiredFormats: Kn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: te,
    specularExponent: te,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: te,
    strikethroughThickness: te,
    string: null,
    stroke: null,
    strokeDashArray: Kn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: te,
    strokeOpacity: te,
    strokeWidth: null,
    style: null,
    surfaceScale: te,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Kn,
    tabIndex: te,
    tableValues: null,
    target: null,
    targetX: te,
    targetY: te,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Kn,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: te,
    underlineThickness: te,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: te,
    values: null,
    vAlphabetic: te,
    vMathematical: te,
    vectorEffect: null,
    vHanging: te,
    vIdeographic: te,
    version: null,
    vertAdvY: te,
    vertOriginX: te,
    vertOriginY: te,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: te,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), M$ = /^data[-\w.:]+$/i, Q1 = /-[a-z]/g, P$ = /[A-Z]/g;
function D$(t, e) {
  const n = pp(e);
  let r = e, i = yr;
  if (n in t.normal)
    return t.property[t.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && M$.test(e)) {
    if (e.charAt(4) === "-") {
      const o = e.slice(5).replace(Q1, F$);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = e.slice(4);
      if (!Q1.test(o)) {
        let a = o.replace(P$, L$);
        a.charAt(0) !== "-" && (a = "-" + a), e = "data" + a;
      }
    }
    i = km;
  }
  return new i(r, e);
}
function L$(t) {
  return "-" + t.toLowerCase();
}
function F$(t) {
  return t.charAt(1).toUpperCase();
}
const J1 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, U$ = qC([WC, KC, QC, JC, R$], "html"), H$ = qC([WC, KC, QC, JC, N$], "svg");
function B$(t) {
  if (t.allowedElements && t.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (t.allowedElements || t.disallowedElements || t.allowElement)
    return (e) => {
      Sm(e, "element", (n, r, i) => {
        const o = (
          /** @type {Element|Root} */
          i
        );
        let a;
        if (t.allowedElements ? a = !t.allowedElements.includes(n.tagName) : t.disallowedElements && (a = t.disallowedElements.includes(n.tagName)), !a && t.allowElement && typeof r == "number" && (a = !t.allowElement(n, r, o)), a && typeof r == "number")
          return t.unwrapDisallowed && n.children ? o.children.splice(r, 1, ...n.children) : o.children.splice(r, 1), r;
      });
    };
}
var mp = {}, j$ = {
  get exports() {
    return mp;
  },
  set exports(t) {
    mp = t;
  }
}, _t = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z1;
function V$() {
  if (Z1)
    return _t;
  Z1 = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function v(b) {
    if (typeof b == "object" && b !== null) {
      var m = b.$$typeof;
      switch (m) {
        case t:
          switch (b = b.type, b) {
            case n:
            case i:
            case r:
            case l:
            case u:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case a:
                case c:
                case f:
                case d:
                case o:
                  return b;
                default:
                  return m;
              }
          }
        case e:
          return m;
      }
    }
  }
  return _t.ContextConsumer = a, _t.ContextProvider = o, _t.Element = t, _t.ForwardRef = c, _t.Fragment = n, _t.Lazy = f, _t.Memo = d, _t.Portal = e, _t.Profiler = i, _t.StrictMode = r, _t.Suspense = l, _t.SuspenseList = u, _t.isAsyncMode = function() {
    return !1;
  }, _t.isConcurrentMode = function() {
    return !1;
  }, _t.isContextConsumer = function(b) {
    return v(b) === a;
  }, _t.isContextProvider = function(b) {
    return v(b) === o;
  }, _t.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, _t.isForwardRef = function(b) {
    return v(b) === c;
  }, _t.isFragment = function(b) {
    return v(b) === n;
  }, _t.isLazy = function(b) {
    return v(b) === f;
  }, _t.isMemo = function(b) {
    return v(b) === d;
  }, _t.isPortal = function(b) {
    return v(b) === e;
  }, _t.isProfiler = function(b) {
    return v(b) === i;
  }, _t.isStrictMode = function(b) {
    return v(b) === r;
  }, _t.isSuspense = function(b) {
    return v(b) === l;
  }, _t.isSuspenseList = function(b) {
    return v(b) === u;
  }, _t.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === i || b === r || b === l || b === u || b === h || typeof b == "object" && b !== null && (b.$$typeof === f || b.$$typeof === d || b.$$typeof === o || b.$$typeof === a || b.$$typeof === c || b.$$typeof === g || b.getModuleId !== void 0);
  }, _t.typeOf = v, _t;
}
var Et = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var X1;
function $$() {
  return X1 || (X1 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), g = !1, v = !1, b = !1, m = !1, y = !1, p;
    p = Symbol.for("react.module.reference");
    function w(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === n || X === i || y || X === r || X === l || X === u || m || X === h || g || v || b || typeof X == "object" && X !== null && (X.$$typeof === f || X.$$typeof === d || X.$$typeof === o || X.$$typeof === a || X.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === p || X.getModuleId !== void 0));
    }
    function _(X) {
      if (typeof X == "object" && X !== null) {
        var it = X.$$typeof;
        switch (it) {
          case t:
            var ht = X.type;
            switch (ht) {
              case n:
              case i:
              case r:
              case l:
              case u:
                return ht;
              default:
                var Ze = ht && ht.$$typeof;
                switch (Ze) {
                  case s:
                  case a:
                  case c:
                  case f:
                  case d:
                  case o:
                    return Ze;
                  default:
                    return it;
                }
            }
          case e:
            return it;
        }
      }
    }
    var E = a, S = o, T = t, x = c, A = n, N = f, F = d, D = e, L = i, z = r, ne = l, ae = u, Re = !1, fe = !1;
    function I(X) {
      return Re || (Re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function J(X) {
      return fe || (fe = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function me(X) {
      return _(X) === a;
    }
    function O(X) {
      return _(X) === o;
    }
    function ue(X) {
      return typeof X == "object" && X !== null && X.$$typeof === t;
    }
    function Ce(X) {
      return _(X) === c;
    }
    function Z(X) {
      return _(X) === n;
    }
    function he(X) {
      return _(X) === f;
    }
    function Q(X) {
      return _(X) === d;
    }
    function $(X) {
      return _(X) === e;
    }
    function q(X) {
      return _(X) === i;
    }
    function H(X) {
      return _(X) === r;
    }
    function V(X) {
      return _(X) === l;
    }
    function Pe(X) {
      return _(X) === u;
    }
    Et.ContextConsumer = E, Et.ContextProvider = S, Et.Element = T, Et.ForwardRef = x, Et.Fragment = A, Et.Lazy = N, Et.Memo = F, Et.Portal = D, Et.Profiler = L, Et.StrictMode = z, Et.Suspense = ne, Et.SuspenseList = ae, Et.isAsyncMode = I, Et.isConcurrentMode = J, Et.isContextConsumer = me, Et.isContextProvider = O, Et.isElement = ue, Et.isForwardRef = Ce, Et.isFragment = Z, Et.isLazy = he, Et.isMemo = Q, Et.isPortal = $, Et.isProfiler = q, Et.isStrictMode = H, Et.isSuspense = V, Et.isSuspenseList = Pe, Et.isValidElementType = w, Et.typeOf = _;
  }()), Et;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = V$() : t.exports = $$();
})(j$);
const q$ = /* @__PURE__ */ X3(mp);
function z$(t) {
  const e = (
    // @ts-expect-error looks like a node.
    t && typeof t == "object" && t.type === "text" ? (
      // @ts-expect-error looks like a text.
      t.value || ""
    ) : t
  );
  return typeof e == "string" && e.replace(/[ \t\n\f\r]/g, "") === "";
}
function K$(t) {
  return t.join(" ").trim();
}
function W$(t, e) {
  const n = e || {};
  return (t[t.length - 1] === "" ? [...t, ""] : t).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
var Su = {}, G$ = {
  get exports() {
    return Su;
  },
  set exports(t) {
    Su = t;
  }
}, ew = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Y$ = /\n/g, Q$ = /^\s*/, J$ = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Z$ = /^:\s*/, X$ = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, eq = /^[;\s]*/, tq = /^\s+|\s+$/g, nq = `
`, tw = "/", nw = "*", ao = "", rq = "comment", iq = "declaration", oq = function(t, e) {
  if (typeof t != "string")
    throw new TypeError("First argument must be a string");
  if (!t)
    return [];
  e = e || {};
  var n = 1, r = 1;
  function i(g) {
    var v = g.match(Y$);
    v && (n += v.length);
    var b = g.lastIndexOf(nq);
    r = ~b ? g.length - b : r + g.length;
  }
  function o() {
    var g = { line: n, column: r };
    return function(v) {
      return v.position = new a(g), l(), v;
    };
  }
  function a(g) {
    this.start = g, this.end = { line: n, column: r }, this.source = e.source;
  }
  a.prototype.content = t;
  function s(g) {
    var v = new Error(
      e.source + ":" + n + ":" + r + ": " + g
    );
    if (v.reason = g, v.filename = e.source, v.line = n, v.column = r, v.source = t, !e.silent)
      throw v;
  }
  function c(g) {
    var v = g.exec(t);
    if (v) {
      var b = v[0];
      return i(b), t = t.slice(b.length), v;
    }
  }
  function l() {
    c(Q$);
  }
  function u(g) {
    var v;
    for (g = g || []; v = d(); )
      v !== !1 && g.push(v);
    return g;
  }
  function d() {
    var g = o();
    if (!(tw != t.charAt(0) || nw != t.charAt(1))) {
      for (var v = 2; ao != t.charAt(v) && (nw != t.charAt(v) || tw != t.charAt(v + 1)); )
        ++v;
      if (v += 2, ao === t.charAt(v - 1))
        return s("End of comment missing");
      var b = t.slice(2, v - 2);
      return r += 2, i(b), t = t.slice(v), r += 2, g({
        type: rq,
        comment: b
      });
    }
  }
  function f() {
    var g = o(), v = c(J$);
    if (v) {
      if (d(), !c(Z$))
        return s("property missing ':'");
      var b = c(X$), m = g({
        type: iq,
        property: rw(v[0].replace(ew, ao)),
        value: b ? rw(b[0].replace(ew, ao)) : ao
      });
      return c(eq), m;
    }
  }
  function h() {
    var g = [];
    u(g);
    for (var v; v = f(); )
      v !== !1 && (g.push(v), u(g));
    return g;
  }
  return l(), h();
};
function rw(t) {
  return t ? t.replace(tq, ao) : ao;
}
var aq = oq;
function ZC(t, e) {
  var n = null;
  if (!t || typeof t != "string")
    return n;
  for (var r, i = aq(t), o = typeof e == "function", a, s, c = 0, l = i.length; c < l; c++)
    r = i[c], a = r.property, s = r.value, o ? e(a, s, r) : s && (n || (n = {}), n[a] = s);
  return n;
}
G$.exports = ZC;
Su.default = ZC;
const sq = Su, vp = {}.hasOwnProperty, cq = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function XC(t, e) {
  const n = [];
  let r = -1, i;
  for (; ++r < e.children.length; )
    i = e.children[r], i.type === "element" ? n.push(lq(t, i, r, e)) : i.type === "text" ? (e.type !== "element" || !cq.has(e.tagName) || !z$(i)) && n.push(i.value) : i.type === "raw" && !t.options.skipHtml && n.push(i.value);
  return n;
}
function lq(t, e, n, r) {
  const i = t.options, o = i.transformLinkUri === void 0 ? mB : i.transformLinkUri, a = t.schema, s = e.tagName, c = {};
  let l = a, u;
  if (a.space === "html" && s === "svg" && (l = H$, t.schema = l), e.properties)
    for (u in e.properties)
      vp.call(e.properties, u) && dq(c, u, e.properties[u], t);
  (s === "ol" || s === "ul") && t.listDepth++;
  const d = XC(t, e);
  (s === "ol" || s === "ul") && t.listDepth--, t.schema = a;
  const f = e.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  }, h = i.components && vp.call(i.components, s) ? i.components[s] : s, g = typeof h == "string" || h === Ct.Fragment;
  if (!q$.isValidElementType(h))
    throw new TypeError(
      `Component for name \`${s}\` not defined or is not renderable`
    );
  if (c.key = n, s === "a" && i.linkTarget && (c.target = typeof i.linkTarget == "function" ? i.linkTarget(
    String(c.href || ""),
    e.children,
    typeof c.title == "string" ? c.title : null
  ) : i.linkTarget), s === "a" && o && (c.href = o(
    String(c.href || ""),
    e.children,
    typeof c.title == "string" ? c.title : null
  )), !g && s === "code" && r.type === "element" && r.tagName !== "pre" && (c.inline = !0), !g && (s === "h1" || s === "h2" || s === "h3" || s === "h4" || s === "h5" || s === "h6") && (c.level = Number.parseInt(s.charAt(1), 10)), s === "img" && i.transformImageUri && (c.src = i.transformImageUri(
    String(c.src || ""),
    String(c.alt || ""),
    typeof c.title == "string" ? c.title : null
  )), !g && s === "li" && r.type === "element") {
    const v = uq(e);
    c.checked = v && v.properties ? !!v.properties.checked : null, c.index = kf(r, e), c.ordered = r.tagName === "ol";
  }
  return !g && (s === "ol" || s === "ul") && (c.ordered = s === "ol", c.depth = t.listDepth), (s === "td" || s === "th") && (c.align && (c.style || (c.style = {}), c.style.textAlign = c.align, delete c.align), g || (c.isHeader = s === "th")), !g && s === "tr" && r.type === "element" && (c.isHeader = r.tagName === "thead"), i.sourcePos && (c["data-sourcepos"] = pq(f)), !g && i.rawSourcePos && (c.sourcePosition = e.position), !g && i.includeElementIndex && (c.index = kf(r, e), c.siblingCount = kf(r)), g || (c.node = e), d.length > 0 ? Ct.createElement(h, c, d) : Ct.createElement(h, c);
}
function uq(t) {
  let e = -1;
  for (; ++e < t.children.length; ) {
    const n = t.children[e];
    if (n.type === "element" && n.tagName === "input")
      return n;
  }
  return null;
}
function kf(t, e) {
  let n = -1, r = 0;
  for (; ++n < t.children.length && t.children[n] !== e; )
    t.children[n].type === "element" && r++;
  return r;
}
function dq(t, e, n, r) {
  const i = D$(r.schema, e);
  let o = n;
  o == null || o !== o || (Array.isArray(o) && (o = i.commaSeparated ? W$(o) : K$(o)), i.property === "style" && typeof o == "string" && (o = fq(o)), i.space && i.property ? t[vp.call(J1, i.property) ? J1[i.property] : i.property] = o : i.attribute && (t[i.attribute] = o));
}
function fq(t) {
  const e = {};
  try {
    sq(t, n);
  } catch {
  }
  return e;
  function n(r, i) {
    const o = r.slice(0, 4) === "-ms-" ? `ms-${r.slice(4)}` : r;
    e[o.replace(/-([a-z])/g, hq)] = i;
  }
}
function hq(t, e) {
  return e.toUpperCase();
}
function pq(t) {
  return [
    t.start.line,
    ":",
    t.start.column,
    "-",
    t.end.line,
    ":",
    t.end.column
  ].map(String).join("");
}
const iw = {}.hasOwnProperty, gq = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", il = {
  plugins: { to: "remarkPlugins", id: "change-plugins-to-remarkplugins" },
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function e3(t) {
  for (const o in il)
    if (iw.call(il, o) && iw.call(t, o)) {
      const a = il[o];
      console.warn(
        `[react-markdown] Warning: please ${a.to ? `use \`${a.to}\` instead of` : "remove"} \`${o}\` (see <${gq}#${a.id}> for more info)`
      ), delete il[o];
    }
  const e = RB().use(LV).use(t.remarkPlugins || []).use(T$, {
    ...t.remarkRehypeOptions,
    allowDangerousHtml: !0
  }).use(t.rehypePlugins || []).use(B$, t), n = new yC();
  typeof t.children == "string" ? n.value = t.children : t.children !== void 0 && t.children !== null && console.warn(
    `[react-markdown] Warning: please pass a string as \`children\` (not: \`${t.children}\`)`
  );
  const r = e.runSync(e.parse(n), n);
  if (r.type !== "root")
    throw new TypeError("Expected a `root` node");
  let i = Ct.createElement(
    Ct.Fragment,
    {},
    XC({ options: t, schema: U$, listDepth: 0 }, r)
  );
  return t.className && (i = Ct.createElement("div", { className: t.className }, i)), i;
}
e3.propTypes = {
  // Core options:
  children: P.string,
  // Layout options:
  className: P.string,
  // Filter options:
  allowElement: P.func,
  allowedElements: P.arrayOf(P.string),
  disallowedElements: P.arrayOf(P.string),
  unwrapDisallowed: P.bool,
  // Plugin options:
  remarkPlugins: P.arrayOf(
    P.oneOfType([
      P.object,
      P.func,
      P.arrayOf(
        P.oneOfType([
          P.bool,
          P.string,
          P.object,
          P.func,
          P.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            P.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: P.arrayOf(
    P.oneOfType([
      P.object,
      P.func,
      P.arrayOf(
        P.oneOfType([
          P.bool,
          P.string,
          P.object,
          P.func,
          P.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            P.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: P.bool,
  rawSourcePos: P.bool,
  skipHtml: P.bool,
  includeElementIndex: P.bool,
  transformLinkUri: P.oneOfType([P.func, P.bool]),
  linkTarget: P.oneOfType([P.func, P.string]),
  transformImageUri: P.func,
  components: P.object
};
const mq = {
  tokenize: Eq,
  partial: !0
}, t3 = {
  tokenize: Cq,
  partial: !0
}, n3 = {
  tokenize: Iq,
  partial: !0
}, r3 = {
  tokenize: Sq,
  partial: !0
}, vq = {
  tokenize: Tq,
  partial: !0
}, i3 = {
  tokenize: bq,
  previous: a3
}, o3 = {
  tokenize: _q,
  previous: s3
}, wi = {
  tokenize: wq,
  previous: c3
}, Yr = {}, yq = {
  text: Yr
};
let Zi = 48;
for (; Zi < 123; )
  Yr[Zi] = wi, Zi++, Zi === 58 ? Zi = 65 : Zi === 91 && (Zi = 97);
Yr[43] = wi;
Yr[45] = wi;
Yr[46] = wi;
Yr[95] = wi;
Yr[72] = [wi, o3];
Yr[104] = [wi, o3];
Yr[87] = [wi, i3];
Yr[119] = [wi, i3];
function wq(t, e, n) {
  const r = this;
  let i, o;
  return a;
  function a(d) {
    return !yp(d) || !c3.call(r, r.previous) || Am(r.events) ? n(d) : (t.enter("literalAutolink"), t.enter("literalAutolinkEmail"), s(d));
  }
  function s(d) {
    return yp(d) ? (t.consume(d), s) : d === 64 ? (t.consume(d), c) : n(d);
  }
  function c(d) {
    return d === 46 ? t.check(
      vq,
      u,
      l
    )(d) : d === 45 || d === 95 || Mn(d) ? (o = !0, t.consume(d), c) : u(d);
  }
  function l(d) {
    return t.consume(d), i = !0, c;
  }
  function u(d) {
    return o && i && Dn(r.previous) ? (t.exit("literalAutolinkEmail"), t.exit("literalAutolink"), e(d)) : n(d);
  }
}
function bq(t, e, n) {
  const r = this;
  return i;
  function i(a) {
    return a !== 87 && a !== 119 || !a3.call(r, r.previous) || Am(r.events) ? n(a) : (t.enter("literalAutolink"), t.enter("literalAutolinkWww"), t.check(
      mq,
      t.attempt(t3, t.attempt(n3, o), n),
      n
    )(a));
  }
  function o(a) {
    return t.exit("literalAutolinkWww"), t.exit("literalAutolink"), e(a);
  }
}
function _q(t, e, n) {
  const r = this;
  let i = "", o = !1;
  return a;
  function a(d) {
    return (d === 72 || d === 104) && s3.call(r, r.previous) && !Am(r.events) ? (t.enter("literalAutolink"), t.enter("literalAutolinkHttp"), i += String.fromCodePoint(d), t.consume(d), s) : n(d);
  }
  function s(d) {
    if (Dn(d) && i.length < 5)
      return i += String.fromCodePoint(d), t.consume(d), s;
    if (d === 58) {
      const f = i.toLowerCase();
      if (f === "http" || f === "https")
        return t.consume(d), c;
    }
    return n(d);
  }
  function c(d) {
    return d === 47 ? (t.consume(d), o ? l : (o = !0, c)) : n(d);
  }
  function l(d) {
    return d === null || Eu(d) || Dt(d) || Ro(d) || dd(d) ? n(d) : t.attempt(t3, t.attempt(n3, u), n)(d);
  }
  function u(d) {
    return t.exit("literalAutolinkHttp"), t.exit("literalAutolink"), e(d);
  }
}
function Eq(t, e, n) {
  let r = 0;
  return i;
  function i(a) {
    return (a === 87 || a === 119) && r < 3 ? (r++, t.consume(a), i) : a === 46 && r === 3 ? (t.consume(a), o) : n(a);
  }
  function o(a) {
    return a === null ? n(a) : e(a);
  }
}
function Cq(t, e, n) {
  let r, i, o;
  return a;
  function a(l) {
    return l === 46 || l === 95 ? t.check(r3, c, s)(l) : l === null || Dt(l) || Ro(l) || l !== 45 && dd(l) ? c(l) : (o = !0, t.consume(l), a);
  }
  function s(l) {
    return l === 95 ? r = !0 : (i = r, r = void 0), t.consume(l), a;
  }
  function c(l) {
    return i || r || !o ? n(l) : e(l);
  }
}
function Iq(t, e) {
  let n = 0, r = 0;
  return i;
  function i(a) {
    return a === 40 ? (n++, t.consume(a), i) : a === 41 && r < n ? o(a) : a === 33 || a === 34 || a === 38 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 60 || a === 63 || a === 93 || a === 95 || a === 126 ? t.check(r3, e, o)(a) : a === null || Dt(a) || Ro(a) ? e(a) : (t.consume(a), i);
  }
  function o(a) {
    return a === 41 && r++, t.consume(a), i;
  }
}
function Sq(t, e, n) {
  return r;
  function r(s) {
    return s === 33 || s === 34 || s === 39 || s === 41 || s === 42 || s === 44 || s === 46 || s === 58 || s === 59 || s === 63 || s === 95 || s === 126 ? (t.consume(s), r) : s === 38 ? (t.consume(s), o) : s === 93 ? (t.consume(s), i) : (
      // `<` is an end.
      s === 60 || // So is whitespace.
      s === null || Dt(s) || Ro(s) ? e(s) : n(s)
    );
  }
  function i(s) {
    return s === null || s === 40 || s === 91 || Dt(s) || Ro(s) ? e(s) : r(s);
  }
  function o(s) {
    return Dn(s) ? a(s) : n(s);
  }
  function a(s) {
    return s === 59 ? (t.consume(s), r) : Dn(s) ? (t.consume(s), a) : n(s);
  }
}
function Tq(t, e, n) {
  return r;
  function r(o) {
    return t.consume(o), i;
  }
  function i(o) {
    return Mn(o) ? n(o) : e(o);
  }
}
function a3(t) {
  return t === null || t === 40 || t === 42 || t === 95 || t === 91 || t === 93 || t === 126 || Dt(t);
}
function s3(t) {
  return !Dn(t);
}
function c3(t) {
  return !(t === 47 || yp(t));
}
function yp(t) {
  return t === 43 || t === 45 || t === 46 || t === 95 || Mn(t);
}
function Am(t) {
  let e = t.length, n = !1;
  for (; e--; ) {
    const r = t[e][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return t.length > 0 && !n && (t[t.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const kq = {
  tokenize: Dq,
  partial: !0
};
function Aq() {
  return {
    document: {
      [91]: {
        tokenize: Nq,
        continuation: {
          tokenize: Mq
        },
        exit: Pq
      }
    },
    text: {
      [91]: {
        tokenize: Rq
      },
      [93]: {
        add: "after",
        tokenize: Oq,
        resolveTo: xq
      }
    }
  };
}
function Oq(t, e, n) {
  const r = this;
  let i = r.events.length;
  const o = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a;
  for (; i--; ) {
    const c = r.events[i][1];
    if (c.type === "labelImage") {
      a = c;
      break;
    }
    if (c.type === "gfmFootnoteCall" || c.type === "labelLink" || c.type === "label" || c.type === "image" || c.type === "link")
      break;
  }
  return s;
  function s(c) {
    if (!a || !a._balanced)
      return n(c);
    const l = Sr(
      r.sliceSerialize({
        start: a.end,
        end: r.now()
      })
    );
    return l.codePointAt(0) !== 94 || !o.includes(l.slice(1)) ? n(c) : (t.enter("gfmFootnoteCallLabelMarker"), t.consume(c), t.exit("gfmFootnoteCallLabelMarker"), e(c));
  }
}
function xq(t, e) {
  let n = t.length;
  for (; n--; )
    if (t[n][1].type === "labelImage" && t[n][0] === "enter") {
      t[n][1];
      break;
    }
  t[n + 1][1].type = "data", t[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, t[n + 3][1].start),
    end: Object.assign({}, t[t.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, t[n + 3][1].end),
    end: Object.assign({}, t[n + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const o = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, t[t.length - 1][1].start)
  }, a = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, o.start),
    end: Object.assign({}, o.end)
  }, s = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    t[n + 1],
    t[n + 2],
    ["enter", r, e],
    // The `[`
    t[n + 3],
    t[n + 4],
    // The `^`.
    ["enter", i, e],
    ["exit", i, e],
    // Everything in between.
    ["enter", o, e],
    ["enter", a, e],
    ["exit", a, e],
    ["exit", o, e],
    // The ending (`]`, properly parsed and labelled).
    t[t.length - 2],
    t[t.length - 1],
    ["exit", r, e]
  ];
  return t.splice(n, t.length - n + 1, ...s), t;
}
function Rq(t, e, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o = 0, a;
  return s;
  function s(d) {
    return t.enter("gfmFootnoteCall"), t.enter("gfmFootnoteCallLabelMarker"), t.consume(d), t.exit("gfmFootnoteCallLabelMarker"), c;
  }
  function c(d) {
    return d !== 94 ? n(d) : (t.enter("gfmFootnoteCallMarker"), t.consume(d), t.exit("gfmFootnoteCallMarker"), t.enter("gfmFootnoteCallString"), t.enter("chunkString").contentType = "string", l);
  }
  function l(d) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      d === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      d === null || d === 91 || Dt(d)
    )
      return n(d);
    if (d === 93) {
      t.exit("chunkString");
      const f = t.exit("gfmFootnoteCallString");
      return i.includes(Sr(r.sliceSerialize(f))) ? (t.enter("gfmFootnoteCallLabelMarker"), t.consume(d), t.exit("gfmFootnoteCallLabelMarker"), t.exit("gfmFootnoteCall"), e) : n(d);
    }
    return Dt(d) || (a = !0), o++, t.consume(d), d === 92 ? u : l;
  }
  function u(d) {
    return d === 91 || d === 92 || d === 93 ? (t.consume(d), o++, l) : l(d);
  }
}
function Nq(t, e, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o, a = 0, s;
  return c;
  function c(g) {
    return t.enter("gfmFootnoteDefinition")._container = !0, t.enter("gfmFootnoteDefinitionLabel"), t.enter("gfmFootnoteDefinitionLabelMarker"), t.consume(g), t.exit("gfmFootnoteDefinitionLabelMarker"), l;
  }
  function l(g) {
    return g === 94 ? (t.enter("gfmFootnoteDefinitionMarker"), t.consume(g), t.exit("gfmFootnoteDefinitionMarker"), t.enter("gfmFootnoteDefinitionLabelString"), t.enter("chunkString").contentType = "string", u) : n(g);
  }
  function u(g) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      g === 93 && !s || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      g === null || g === 91 || Dt(g)
    )
      return n(g);
    if (g === 93) {
      t.exit("chunkString");
      const v = t.exit("gfmFootnoteDefinitionLabelString");
      return o = Sr(r.sliceSerialize(v)), t.enter("gfmFootnoteDefinitionLabelMarker"), t.consume(g), t.exit("gfmFootnoteDefinitionLabelMarker"), t.exit("gfmFootnoteDefinitionLabel"), f;
    }
    return Dt(g) || (s = !0), a++, t.consume(g), g === 92 ? d : u;
  }
  function d(g) {
    return g === 91 || g === 92 || g === 93 ? (t.consume(g), a++, u) : u(g);
  }
  function f(g) {
    return g === 58 ? (t.enter("definitionMarker"), t.consume(g), t.exit("definitionMarker"), i.includes(o) || i.push(o), dt(
      t,
      h,
      "gfmFootnoteDefinitionWhitespace"
    )) : n(g);
  }
  function h(g) {
    return e(g);
  }
}
function Mq(t, e, n) {
  return t.check(Pc, e, t.attempt(kq, e, n));
}
function Pq(t) {
  t.exit("gfmFootnoteDefinition");
}
function Dq(t, e, n) {
  const r = this;
  return dt(
    t,
    i,
    "gfmFootnoteDefinitionIndent",
    4 + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "gfmFootnoteDefinitionIndent" && a[2].sliceSerialize(a[1], !0).length === 4 ? e(o) : n(o);
  }
}
function Lq(t) {
  let n = (t || {}).singleTilde;
  const r = {
    tokenize: o,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      [126]: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(a, s) {
    let c = -1;
    for (; ++c < a.length; )
      if (a[c][0] === "enter" && a[c][1].type === "strikethroughSequenceTemporary" && a[c][1]._close) {
        let l = c;
        for (; l--; )
          if (a[l][0] === "exit" && a[l][1].type === "strikethroughSequenceTemporary" && a[l][1]._open && // If the sizes are the same:
          a[c][1].end.offset - a[c][1].start.offset === a[l][1].end.offset - a[l][1].start.offset) {
            a[c][1].type = "strikethroughSequence", a[l][1].type = "strikethroughSequence";
            const u = {
              type: "strikethrough",
              start: Object.assign({}, a[l][1].start),
              end: Object.assign({}, a[c][1].end)
            }, d = {
              type: "strikethroughText",
              start: Object.assign({}, a[l][1].end),
              end: Object.assign({}, a[c][1].start)
            }, f = [
              ["enter", u, s],
              ["enter", a[l][1], s],
              ["exit", a[l][1], s],
              ["enter", d, s]
            ], h = s.parser.constructs.insideSpan.null;
            h && er(
              f,
              f.length,
              0,
              fd(h, a.slice(l + 1, c), s)
            ), er(f, f.length, 0, [
              ["exit", d, s],
              ["enter", a[c][1], s],
              ["exit", a[c][1], s],
              ["exit", u, s]
            ]), er(a, l - 1, c - l + 3, f), c = l + f.length - 2;
            break;
          }
      }
    for (c = -1; ++c < a.length; )
      a[c][1].type === "strikethroughSequenceTemporary" && (a[c][1].type = "data");
    return a;
  }
  function o(a, s, c) {
    const l = this.previous, u = this.events;
    let d = 0;
    return f;
    function f(g) {
      return l === 126 && u[u.length - 1][1].type !== "characterEscape" ? c(g) : (a.enter("strikethroughSequenceTemporary"), h(g));
    }
    function h(g) {
      const v = Cu(l);
      if (g === 126)
        return d > 1 ? c(g) : (a.consume(g), d++, h);
      if (d < 2 && !n)
        return c(g);
      const b = a.exit("strikethroughSequenceTemporary"), m = Cu(g);
      return b._open = !m || m === 2 && !!v, b._close = !v || v === 2 && !!m, s(g);
    }
  }
}
class Fq {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */
  add(e, n, r) {
    Uq(this, e, n, r);
  }
  // To do: not used here.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {void}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */
  consume(e) {
    if (this.map.sort((o, a) => o[0] - a[0]), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(e.slice(this.map[n][0] + this.map[n][1])), r.push(this.map[n][2]), e.length = this.map[n][0];
    r.push([...e]), e.length = 0;
    let i = r.pop();
    for (; i; )
      e.push(...i), i = r.pop();
    this.map.length = 0;
  }
}
function Uq(t, e, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < t.map.length; ) {
      if (t.map[i][0] === e) {
        t.map[i][1] += n, t.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    t.map.push([e, n, r]);
  }
}
function Hq(t, e) {
  let n = !1;
  const r = [];
  for (; e < t.length; ) {
    const i = t[e];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(
          t[e + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
        );
      else if (i[1].type === "tableContent") {
        if (t[e - 1][1].type === "tableDelimiterMarker") {
          const o = r.length - 1;
          r[o] = r[o] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else
      i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    e += 1;
  }
  return r;
}
const Bq = {
  flow: {
    null: {
      tokenize: jq,
      resolveAll: Vq
    }
  }
};
function jq(t, e, n) {
  const r = this;
  let i = 0, o = 0, a;
  return s;
  function s(A) {
    let N = r.events.length - 1;
    for (; N > -1; ) {
      const L = r.events[N][1].type;
      if (L === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      L === "linePrefix")
        N--;
      else
        break;
    }
    const F = N > -1 ? r.events[N][1].type : null, D = F === "tableHead" || F === "tableRow" ? E : c;
    return D === E && r.parser.lazy[r.now().line] ? n(A) : D(A);
  }
  function c(A) {
    return t.enter("tableHead"), t.enter("tableRow"), l(A);
  }
  function l(A) {
    return A === 124 || (a = !0, o += 1), u(A);
  }
  function u(A) {
    return A === null ? n(A) : xe(A) ? o > 1 ? (o = 0, r.interrupt = !0, t.exit("tableRow"), t.enter("lineEnding"), t.consume(A), t.exit("lineEnding"), h) : n(A) : ct(A) ? dt(t, u, "whitespace")(A) : (o += 1, a && (a = !1, i += 1), A === 124 ? (t.enter("tableCellDivider"), t.consume(A), t.exit("tableCellDivider"), a = !0, u) : (t.enter("data"), d(A)));
  }
  function d(A) {
    return A === null || A === 124 || Dt(A) ? (t.exit("data"), u(A)) : (t.consume(A), A === 92 ? f : d);
  }
  function f(A) {
    return A === 92 || A === 124 ? (t.consume(A), d) : d(A);
  }
  function h(A) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(A) : (t.enter("tableDelimiterRow"), a = !1, ct(A) ? dt(
      t,
      g,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(A) : g(A));
  }
  function g(A) {
    return A === 45 || A === 58 ? b(A) : A === 124 ? (a = !0, t.enter("tableCellDivider"), t.consume(A), t.exit("tableCellDivider"), v) : _(A);
  }
  function v(A) {
    return ct(A) ? dt(t, b, "whitespace")(A) : b(A);
  }
  function b(A) {
    return A === 58 ? (o += 1, a = !0, t.enter("tableDelimiterMarker"), t.consume(A), t.exit("tableDelimiterMarker"), m) : A === 45 ? (o += 1, m(A)) : A === null || xe(A) ? w(A) : _(A);
  }
  function m(A) {
    return A === 45 ? (t.enter("tableDelimiterFiller"), y(A)) : _(A);
  }
  function y(A) {
    return A === 45 ? (t.consume(A), y) : A === 58 ? (a = !0, t.exit("tableDelimiterFiller"), t.enter("tableDelimiterMarker"), t.consume(A), t.exit("tableDelimiterMarker"), p) : (t.exit("tableDelimiterFiller"), p(A));
  }
  function p(A) {
    return ct(A) ? dt(t, w, "whitespace")(A) : w(A);
  }
  function w(A) {
    return A === 124 ? g(A) : A === null || xe(A) ? !a || i !== o ? _(A) : (t.exit("tableDelimiterRow"), t.exit("tableHead"), e(A)) : _(A);
  }
  function _(A) {
    return n(A);
  }
  function E(A) {
    return t.enter("tableRow"), S(A);
  }
  function S(A) {
    return A === 124 ? (t.enter("tableCellDivider"), t.consume(A), t.exit("tableCellDivider"), S) : A === null || xe(A) ? (t.exit("tableRow"), e(A)) : ct(A) ? dt(t, S, "whitespace")(A) : (t.enter("data"), T(A));
  }
  function T(A) {
    return A === null || A === 124 || Dt(A) ? (t.exit("data"), S(A)) : (t.consume(A), A === 92 ? x : T);
  }
  function x(A) {
    return A === 92 || A === 124 ? (t.consume(A), T) : T(A);
  }
}
function Vq(t, e) {
  let n = -1, r = !0, i = 0, o = [0, 0, 0, 0], a = [0, 0, 0, 0], s = !1, c = 0, l, u, d;
  const f = new Fq();
  for (; ++n < t.length; ) {
    const h = t[n], g = h[1];
    h[0] === "enter" ? g.type === "tableHead" ? (s = !1, c !== 0 && (ow(f, e, c, l, u), u = void 0, c = 0), l = {
      type: "table",
      start: Object.assign({}, g.start),
      // Note: correct end is set later.
      end: Object.assign({}, g.end)
    }, f.add(n, 0, [["enter", l, e]])) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (r = !0, d = void 0, o = [0, 0, 0, 0], a = [0, n + 1, 0, 0], s && (s = !1, u = {
      type: "tableBody",
      start: Object.assign({}, g.start),
      // Note: correct end is set later.
      end: Object.assign({}, g.end)
    }, f.add(n, 0, [["enter", u, e]])), i = g.type === "tableDelimiterRow" ? 2 : u ? 3 : 1) : i && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") ? (r = !1, a[2] === 0 && (o[1] !== 0 && (a[0] = a[1], d = ol(
      f,
      e,
      o,
      i,
      void 0,
      d
    ), o = [0, 0, 0, 0]), a[2] = n)) : g.type === "tableCellDivider" && (r ? r = !1 : (o[1] !== 0 && (a[0] = a[1], d = ol(
      f,
      e,
      o,
      i,
      void 0,
      d
    )), o = a, a = [o[1], n, 0, 0])) : g.type === "tableHead" ? (s = !0, c = n) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (c = n, o[1] !== 0 ? (a[0] = a[1], d = ol(
      f,
      e,
      o,
      i,
      n,
      d
    )) : a[1] !== 0 && (d = ol(f, e, a, i, n, d)), i = 0) : i && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") && (a[3] = n);
  }
  for (c !== 0 && ow(f, e, c, l, u), f.consume(e.events), n = -1; ++n < e.events.length; ) {
    const h = e.events[n];
    h[0] === "enter" && h[1].type === "table" && (h[1]._align = Hq(e.events, n));
  }
  return t;
}
function ol(t, e, n, r, i, o) {
  const a = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", s = "tableContent";
  n[0] !== 0 && (o.end = Object.assign({}, Yo(e.events, n[0])), t.add(n[0], 0, [["exit", o, e]]));
  const c = Yo(e.events, n[1]);
  if (o = {
    type: a,
    start: Object.assign({}, c),
    // Note: correct end is set later.
    end: Object.assign({}, c)
  }, t.add(n[1], 0, [["enter", o, e]]), n[2] !== 0) {
    const l = Yo(e.events, n[2]), u = Yo(e.events, n[3]), d = {
      type: s,
      start: Object.assign({}, l),
      end: Object.assign({}, u)
    };
    if (t.add(n[2], 0, [["enter", d, e]]), r !== 2) {
      const f = e.events[n[2]], h = e.events[n[3]];
      if (f[1].end = Object.assign({}, h[1].end), f[1].type = "chunkText", f[1].contentType = "text", n[3] > n[2] + 1) {
        const g = n[2] + 1, v = n[3] - n[2] - 1;
        t.add(g, v, []);
      }
    }
    t.add(n[3] + 1, 0, [["exit", d, e]]);
  }
  return i !== void 0 && (o.end = Object.assign({}, Yo(e.events, i)), t.add(i, 0, [["exit", o, e]]), o = void 0), o;
}
function ow(t, e, n, r, i) {
  const o = [], a = Yo(e.events, n);
  i && (i.end = Object.assign({}, a), o.push(["exit", i, e])), r.end = Object.assign({}, a), o.push(["exit", r, e]), t.add(n + 1, 0, o);
}
function Yo(t, e) {
  const n = t[e], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const $q = {
  tokenize: zq
}, qq = {
  text: {
    [91]: $q
  }
};
function zq(t, e, n) {
  const r = this;
  return i;
  function i(c) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(c) : (t.enter("taskListCheck"), t.enter("taskListCheckMarker"), t.consume(c), t.exit("taskListCheckMarker"), o)
    );
  }
  function o(c) {
    return Dt(c) ? (t.enter("taskListCheckValueUnchecked"), t.consume(c), t.exit("taskListCheckValueUnchecked"), a) : c === 88 || c === 120 ? (t.enter("taskListCheckValueChecked"), t.consume(c), t.exit("taskListCheckValueChecked"), a) : n(c);
  }
  function a(c) {
    return c === 93 ? (t.enter("taskListCheckMarker"), t.consume(c), t.exit("taskListCheckMarker"), t.exit("taskListCheck"), s) : n(c);
  }
  function s(c) {
    return xe(c) ? e(c) : ct(c) ? t.check(
      {
        tokenize: Kq
      },
      e,
      n
    )(c) : n(c);
  }
}
function Kq(t, e, n) {
  return dt(t, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : e(i);
  }
}
function Wq(t) {
  return CC([
    yq,
    Aq(),
    Lq(t),
    Bq,
    qq
  ]);
}
function aw(t, e) {
  const n = String(t);
  if (typeof e != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(e);
  for (; i !== -1; )
    r++, i = n.indexOf(e, i + e.length);
  return r;
}
function Gq(t) {
  if (typeof t != "string")
    throw new TypeError("Expected a string");
  return t.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const Yq = {}.hasOwnProperty, Qq = (
  /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/
  /**
   * @template {Node} Tree
   * @param {Tree} tree
   * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
   * @param {Replace | Options | null | undefined} [replace]
   * @param {Options | null | undefined} [options]
   * @returns {Tree}
   */
  function(t, e, n, r) {
    let i, o;
    typeof e == "string" || e instanceof RegExp ? (o = [[e, n]], i = r) : (o = e, i = n), i || (i = {});
    const a = Im(i.ignore || []), s = Jq(o);
    let c = -1;
    for (; ++c < s.length; )
      jC(t, "text", l);
    return t;
    function l(d, f) {
      let h = -1, g;
      for (; ++h < f.length; ) {
        const v = f[h];
        if (a(
          v,
          // @ts-expect-error: TS doesn’t understand but it’s perfect.
          g ? g.children.indexOf(v) : void 0,
          g
        ))
          return;
        g = v;
      }
      if (g)
        return u(d, f);
    }
    function u(d, f) {
      const h = f[f.length - 1], g = s[c][0], v = s[c][1];
      let b = 0;
      const m = h.children.indexOf(d);
      let y = !1, p = [];
      g.lastIndex = 0;
      let w = g.exec(d.value);
      for (; w; ) {
        const _ = w.index, E = {
          index: w.index,
          input: w.input,
          // @ts-expect-error: stack is fine.
          stack: [...f, d]
        };
        let S = v(...w, E);
        if (typeof S == "string" && (S = S.length > 0 ? { type: "text", value: S } : void 0), S !== !1 && (b !== _ && p.push({
          type: "text",
          value: d.value.slice(b, _)
        }), Array.isArray(S) ? p.push(...S) : S && p.push(S), b = _ + w[0].length, y = !0), !g.global)
          break;
        w = g.exec(d.value);
      }
      return y ? (b < d.value.length && p.push({ type: "text", value: d.value.slice(b) }), h.children.splice(m, 1, ...p)) : p = [d], m + p.length;
    }
  }
);
function Jq(t) {
  const e = [];
  if (typeof t != "object")
    throw new TypeError("Expected array or object as schema");
  if (Array.isArray(t)) {
    let n = -1;
    for (; ++n < t.length; )
      e.push([
        sw(t[n][0]),
        cw(t[n][1])
      ]);
  } else {
    let n;
    for (n in t)
      Yq.call(t, n) && e.push([sw(n), cw(t[n])]);
  }
  return e;
}
function sw(t) {
  return typeof t == "string" ? new RegExp(Gq(t), "g") : t;
}
function cw(t) {
  return typeof t == "function" ? t : () => t;
}
const Af = "phrasing", Of = ["autolink", "link", "image", "label"], Zq = {
  transforms: [oz],
  enter: {
    literalAutolink: ez,
    literalAutolinkEmail: xf,
    literalAutolinkHttp: xf,
    literalAutolinkWww: xf
  },
  exit: {
    literalAutolink: iz,
    literalAutolinkEmail: rz,
    literalAutolinkHttp: tz,
    literalAutolinkWww: nz
  }
}, Xq = {
  unsafe: [
    {
      character: "@",
      before: "[+\\-.\\w]",
      after: "[\\-.\\w]",
      inConstruct: Af,
      notInConstruct: Of
    },
    {
      character: ".",
      before: "[Ww]",
      after: "[\\-.\\w]",
      inConstruct: Af,
      notInConstruct: Of
    },
    { character: ":", before: "[ps]", after: "\\/", inConstruct: Af, notInConstruct: Of }
  ]
};
function ez(t) {
  this.enter({ type: "link", title: null, url: "", children: [] }, t);
}
function xf(t) {
  this.config.enter.autolinkProtocol.call(this, t);
}
function tz(t) {
  this.config.exit.autolinkProtocol.call(this, t);
}
function nz(t) {
  this.config.exit.data.call(this, t);
  const e = (
    /** @type {Link} */
    this.stack[this.stack.length - 1]
  );
  e.url = "http://" + this.sliceSerialize(t);
}
function rz(t) {
  this.config.exit.autolinkEmail.call(this, t);
}
function iz(t) {
  this.exit(t);
}
function oz(t) {
  Qq(
    t,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, az],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, sz]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function az(t, e, n, r, i) {
  let o = "";
  if (!l3(i) || (/^w/i.test(e) && (n = e + n, e = "", o = "http://"), !cz(n)))
    return !1;
  const a = lz(n + r);
  if (!a[0])
    return !1;
  const s = {
    type: "link",
    title: null,
    url: o + e + a[0],
    children: [{ type: "text", value: e + a[0] }]
  };
  return a[1] ? [s, { type: "text", value: a[1] }] : s;
}
function sz(t, e, n, r) {
  return (
    // Not an expected previous character.
    !l3(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + e + "@" + n,
      children: [{ type: "text", value: e + "@" + n }]
    }
  );
}
function cz(t) {
  const e = t.split(".");
  return !(e.length < 2 || e[e.length - 1] && (/_/.test(e[e.length - 1]) || !/[a-zA-Z\d]/.test(e[e.length - 1])) || e[e.length - 2] && (/_/.test(e[e.length - 2]) || !/[a-zA-Z\d]/.test(e[e.length - 2])));
}
function lz(t) {
  const e = /[!"&'),.:;<>?\]}]+$/.exec(t);
  if (!e)
    return [t, void 0];
  t = t.slice(0, e.index);
  let n = e[0], r = n.indexOf(")");
  const i = aw(t, "(");
  let o = aw(t, ")");
  for (; r !== -1 && i > o; )
    t += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), o++;
  return [t, n];
}
function l3(t, e) {
  const n = t.input.charCodeAt(t.index - 1);
  return (t.index === 0 || Ro(n) || dd(n)) && (!e || n !== 47);
}
function u3(t) {
  return t.label || !t.identifier ? t.label || "" : PC(t.identifier);
}
function uz(t, e, n) {
  const r = e.indexStack, i = t.children || [], o = e.createTracker(n), a = [];
  let s = -1;
  for (r.push(-1); ++s < i.length; ) {
    const c = i[s];
    r[r.length - 1] = s, a.push(
      o.move(
        e.handle(c, t, e, {
          before: `
`,
          after: `
`,
          ...o.current()
        })
      )
    ), c.type !== "list" && (e.bulletLastUsed = void 0), s < i.length - 1 && a.push(
      o.move(dz(c, i[s + 1], t, e))
    );
  }
  return r.pop(), a.join("");
}
function dz(t, e, n, r) {
  let i = r.join.length;
  for (; i--; ) {
    const o = r.join[i](t, e, n, r);
    if (o === !0 || o === 1)
      break;
    if (typeof o == "number")
      return `
`.repeat(1 + o);
    if (o === !1)
      return `

<!---->

`;
  }
  return `

`;
}
const fz = /\r?\n|\r/g;
function hz(t, e) {
  const n = [];
  let r = 0, i = 0, o;
  for (; o = fz.exec(t); )
    a(t.slice(r, o.index)), n.push(o[0]), r = o.index + o[0].length, i++;
  return a(t.slice(r)), n.join("");
  function a(s) {
    n.push(e(s, i, !s));
  }
}
function d3(t) {
  if (!t._compiled) {
    const e = (t.atBreak ? "[\\r\\n][\\t ]*" : "") + (t.before ? "(?:" + t.before + ")" : "");
    t._compiled = new RegExp(
      (e ? "(" + e + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(t.character) ? "\\" : "") + t.character + (t.after ? "(?:" + t.after + ")" : ""),
      "g"
    );
  }
  return t._compiled;
}
function pz(t, e) {
  return lw(t, e.inConstruct, !0) && !lw(t, e.notInConstruct, !1);
}
function lw(t, e, n) {
  if (typeof e == "string" && (e = [e]), !e || e.length === 0)
    return n;
  let r = -1;
  for (; ++r < e.length; )
    if (t.includes(e[r]))
      return !0;
  return !1;
}
function f3(t, e, n) {
  const r = (n.before || "") + (e || "") + (n.after || ""), i = [], o = [], a = {};
  let s = -1;
  for (; ++s < t.unsafe.length; ) {
    const u = t.unsafe[s];
    if (!pz(t.stack, u))
      continue;
    const d = d3(u);
    let f;
    for (; f = d.exec(r); ) {
      const h = "before" in u || !!u.atBreak, g = "after" in u, v = f.index + (h ? f[1].length : 0);
      i.includes(v) ? (a[v].before && !h && (a[v].before = !1), a[v].after && !g && (a[v].after = !1)) : (i.push(v), a[v] = { before: h, after: g });
    }
  }
  i.sort(gz);
  let c = n.before ? n.before.length : 0;
  const l = r.length - (n.after ? n.after.length : 0);
  for (s = -1; ++s < i.length; ) {
    const u = i[s];
    u < c || u >= l || u + 1 < l && i[s + 1] === u + 1 && a[u].after && !a[u + 1].before && !a[u + 1].after || i[s - 1] === u - 1 && a[u].before && !a[u - 1].before && !a[u - 1].after || (c !== u && o.push(uw(r.slice(c, u), "\\")), c = u, /[!-/:-@[-`{-~]/.test(r.charAt(u)) && (!n.encode || !n.encode.includes(r.charAt(u))) ? o.push("\\") : (o.push(
      "&#x" + r.charCodeAt(u).toString(16).toUpperCase() + ";"
    ), c++));
  }
  return o.push(uw(r.slice(c, l), n.after)), o.join("");
}
function gz(t, e) {
  return t - e;
}
function uw(t, e) {
  const n = /\\(?=[!-/:-@[-`{-~])/g, r = [], i = [], o = t + e;
  let a = -1, s = 0, c;
  for (; c = n.exec(o); )
    r.push(c.index);
  for (; ++a < r.length; )
    s !== r[a] && i.push(t.slice(s, r[a])), i.push("\\"), s = r[a];
  return i.push(t.slice(s)), i.join("");
}
function pd(t) {
  const e = t || {}, n = e.now || {};
  let r = e.lineShift || 0, i = n.line || 1, o = n.column || 1;
  return { move: c, current: a, shift: s };
  function a() {
    return { now: { line: i, column: o }, lineShift: r };
  }
  function s(l) {
    r += l;
  }
  function c(l) {
    const u = l || "", d = u.split(/\r?\n|\r/g), f = d[d.length - 1];
    return i += d.length - 1, o = d.length === 1 ? o + f.length : 1 + f.length + r, u;
  }
}
h3.peek = Tz;
function mz() {
  return {
    enter: {
      gfmFootnoteDefinition: yz,
      gfmFootnoteDefinitionLabelString: wz,
      gfmFootnoteCall: Ez,
      gfmFootnoteCallString: Cz
    },
    exit: {
      gfmFootnoteDefinition: _z,
      gfmFootnoteDefinitionLabelString: bz,
      gfmFootnoteCall: Sz,
      gfmFootnoteCallString: Iz
    }
  };
}
function vz() {
  return {
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition: kz, footnoteReference: h3 }
  };
}
function yz(t) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    t
  );
}
function wz() {
  this.buffer();
}
function bz(t) {
  const e = this.resume(), n = (
    /** @type {FootnoteDefinition} */
    this.stack[this.stack.length - 1]
  );
  n.label = e, n.identifier = Sr(
    this.sliceSerialize(t)
  ).toLowerCase();
}
function _z(t) {
  this.exit(t);
}
function Ez(t) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, t);
}
function Cz() {
  this.buffer();
}
function Iz(t) {
  const e = this.resume(), n = (
    /** @type {FootnoteDefinition} */
    this.stack[this.stack.length - 1]
  );
  n.label = e, n.identifier = Sr(
    this.sliceSerialize(t)
  ).toLowerCase();
}
function Sz(t) {
  this.exit(t);
}
function h3(t, e, n, r) {
  const i = pd(r);
  let o = i.move("[^");
  const a = n.enter("footnoteReference"), s = n.enter("reference");
  return o += i.move(
    f3(n, u3(t), {
      ...i.current(),
      before: o,
      after: "]"
    })
  ), s(), a(), o += i.move("]"), o;
}
function Tz() {
  return "[";
}
function kz(t, e, n, r) {
  const i = pd(r);
  let o = i.move("[^");
  const a = n.enter("footnoteDefinition"), s = n.enter("label");
  return o += i.move(
    f3(n, u3(t), {
      ...i.current(),
      before: o,
      after: "]"
    })
  ), s(), o += i.move(
    "]:" + (t.children && t.children.length > 0 ? " " : "")
  ), i.shift(4), o += i.move(
    hz(uz(t, n, i.current()), Az)
  ), a(), o;
}
function Az(t, e, n) {
  return e === 0 ? t : (n ? "" : "    ") + t;
}
function p3(t, e, n) {
  const r = e.indexStack, i = t.children || [], o = [];
  let a = -1, s = n.before;
  r.push(-1);
  let c = e.createTracker(n);
  for (; ++a < i.length; ) {
    const l = i[a];
    let u;
    if (r[r.length - 1] = a, a + 1 < i.length) {
      let d = e.handle.handlers[i[a + 1].type];
      d && d.peek && (d = d.peek), u = d ? d(i[a + 1], t, e, {
        before: "",
        after: "",
        ...c.current()
      }).charAt(0) : "";
    } else
      u = n.after;
    o.length > 0 && (s === "\r" || s === `
`) && l.type === "html" && (o[o.length - 1] = o[o.length - 1].replace(
      /(\r?\n|\r)$/,
      " "
    ), s = " ", c = e.createTracker(n), c.move(o.join(""))), o.push(
      c.move(
        e.handle(l, t, e, {
          ...c.current(),
          before: s,
          after: u
        })
      )
    ), s = o[o.length - 1].slice(-1);
  }
  return r.pop(), o.join("");
}
const Oz = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
g3.peek = Pz;
const xz = {
  canContainEols: ["delete"],
  enter: { strikethrough: Nz },
  exit: { strikethrough: Mz }
}, Rz = {
  unsafe: [
    {
      character: "~",
      inConstruct: "phrasing",
      notInConstruct: Oz
    }
  ],
  handlers: { delete: g3 }
};
function Nz(t) {
  this.enter({ type: "delete", children: [] }, t);
}
function Mz(t) {
  this.exit(t);
}
function g3(t, e, n, r) {
  const i = pd(r), o = n.enter("strikethrough");
  let a = i.move("~~");
  return a += p3(t, n, {
    ...i.current(),
    before: a,
    after: "~"
  }), a += i.move("~~"), o(), a;
}
function Pz() {
  return "~";
}
m3.peek = Dz;
function m3(t, e, n) {
  let r = t.value || "", i = "`", o = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++o < n.unsafe.length; ) {
    const a = n.unsafe[o], s = d3(a);
    let c;
    if (a.atBreak)
      for (; c = s.exec(r); ) {
        let l = c.index;
        r.charCodeAt(l) === 10 && r.charCodeAt(l - 1) === 13 && l--, r = r.slice(0, l) + " " + r.slice(c.index + 1);
      }
  }
  return i + r + i;
}
function Dz() {
  return "`";
}
function Lz(t, e = {}) {
  const n = (e.align || []).concat(), r = e.stringLength || Uz, i = [], o = [], a = [], s = [];
  let c = 0, l = -1;
  for (; ++l < t.length; ) {
    const g = [], v = [];
    let b = -1;
    for (t[l].length > c && (c = t[l].length); ++b < t[l].length; ) {
      const m = Fz(t[l][b]);
      if (e.alignDelimiters !== !1) {
        const y = r(m);
        v[b] = y, (s[b] === void 0 || y > s[b]) && (s[b] = y);
      }
      g.push(m);
    }
    o[l] = g, a[l] = v;
  }
  let u = -1;
  if (typeof n == "object" && "length" in n)
    for (; ++u < c; )
      i[u] = dw(n[u]);
  else {
    const g = dw(n);
    for (; ++u < c; )
      i[u] = g;
  }
  u = -1;
  const d = [], f = [];
  for (; ++u < c; ) {
    const g = i[u];
    let v = "", b = "";
    g === 99 ? (v = ":", b = ":") : g === 108 ? v = ":" : g === 114 && (b = ":");
    let m = e.alignDelimiters === !1 ? 1 : Math.max(
      1,
      s[u] - v.length - b.length
    );
    const y = v + "-".repeat(m) + b;
    e.alignDelimiters !== !1 && (m = v.length + m + b.length, m > s[u] && (s[u] = m), f[u] = m), d[u] = y;
  }
  o.splice(1, 0, d), a.splice(1, 0, f), l = -1;
  const h = [];
  for (; ++l < o.length; ) {
    const g = o[l], v = a[l];
    u = -1;
    const b = [];
    for (; ++u < c; ) {
      const m = g[u] || "";
      let y = "", p = "";
      if (e.alignDelimiters !== !1) {
        const w = s[u] - (v[u] || 0), _ = i[u];
        _ === 114 ? y = " ".repeat(w) : _ === 99 ? w % 2 ? (y = " ".repeat(w / 2 + 0.5), p = " ".repeat(w / 2 - 0.5)) : (y = " ".repeat(w / 2), p = y) : p = " ".repeat(w);
      }
      e.delimiterStart !== !1 && !u && b.push("|"), e.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(e.alignDelimiters === !1 && m === "") && (e.delimiterStart !== !1 || u) && b.push(" "), e.alignDelimiters !== !1 && b.push(y), b.push(m), e.alignDelimiters !== !1 && b.push(p), e.padding !== !1 && b.push(" "), (e.delimiterEnd !== !1 || u !== c - 1) && b.push("|");
    }
    h.push(
      e.delimiterEnd === !1 ? b.join("").replace(/ +$/, "") : b.join("")
    );
  }
  return h.join(`
`);
}
function Fz(t) {
  return t == null ? "" : String(t);
}
function Uz(t) {
  return t.length;
}
function dw(t) {
  const e = typeof t == "string" ? t.codePointAt(0) : 0;
  return e === 67 || e === 99 ? 99 : e === 76 || e === 108 ? 108 : e === 82 || e === 114 ? 114 : 0;
}
const Hz = {
  enter: {
    table: Bz,
    tableData: fw,
    tableHeader: fw,
    tableRow: Vz
  },
  exit: {
    codeText: $z,
    table: jz,
    tableData: Rf,
    tableHeader: Rf,
    tableRow: Rf
  }
};
function Bz(t) {
  const e = t._align;
  this.enter(
    {
      type: "table",
      align: e.map((n) => n === "none" ? null : n),
      children: []
    },
    t
  ), this.setData("inTable", !0);
}
function jz(t) {
  this.exit(t), this.setData("inTable");
}
function Vz(t) {
  this.enter({ type: "tableRow", children: [] }, t);
}
function Rf(t) {
  this.exit(t);
}
function fw(t) {
  this.enter({ type: "tableCell", children: [] }, t);
}
function $z(t) {
  let e = this.resume();
  this.getData("inTable") && (e = e.replace(/\\([\\|])/g, qz));
  const n = (
    /** @type {InlineCode} */
    this.stack[this.stack.length - 1]
  );
  n.value = e, this.exit(t);
}
function qz(t, e) {
  return e === "|" ? e : t;
}
function zz(t) {
  const e = t || {}, n = e.tableCellPadding, r = e.tablePipeAlign, i = e.stringLength, o = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      table: a,
      tableRow: s,
      tableCell: c,
      inlineCode: f
    }
  };
  function a(h, g, v, b) {
    return l(
      u(h, v, b),
      h.align
    );
  }
  function s(h, g, v, b) {
    const m = d(h, v, b), y = l([m]);
    return y.slice(0, y.indexOf(`
`));
  }
  function c(h, g, v, b) {
    const m = v.enter("tableCell"), y = v.enter("phrasing"), p = p3(h, v, {
      ...b,
      before: o,
      after: o
    });
    return y(), m(), p;
  }
  function l(h, g) {
    return Lz(h, {
      align: g,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function u(h, g, v) {
    const b = h.children;
    let m = -1;
    const y = [], p = g.enter("table");
    for (; ++m < b.length; )
      y[m] = d(
        b[m],
        g,
        v
      );
    return p(), y;
  }
  function d(h, g, v) {
    const b = h.children;
    let m = -1;
    const y = [], p = g.enter("tableRow");
    for (; ++m < b.length; )
      y[m] = c(
        b[m],
        h,
        g,
        v
      );
    return p(), y;
  }
  function f(h, g, v) {
    let b = m3(h, g, v);
    return v.stack.includes("tableCell") && (b = b.replace(/\|/g, "\\$&")), b;
  }
}
function Kz(t) {
  const e = t.options.bullet || "*";
  if (e !== "*" && e !== "+" && e !== "-")
    throw new Error(
      "Cannot serialize items with `" + e + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return e;
}
function Wz(t) {
  const e = t.options.listItemIndent || "tab";
  if (e === 1 || e === "1")
    return "one";
  if (e !== "tab" && e !== "one" && e !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + e + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return e;
}
function Gz(t, e, n, r) {
  const i = Wz(n);
  let o = n.bulletCurrent || Kz(n);
  e && e.type === "list" && e.ordered && (o = (typeof e.start == "number" && e.start > -1 ? e.start : 1) + (n.options.incrementListMarker === !1 ? 0 : e.children.indexOf(t)) + o);
  let a = o.length + 1;
  (i === "tab" || i === "mixed" && (e && e.type === "list" && e.spread || t.spread)) && (a = Math.ceil(a / 4) * 4);
  const s = n.createTracker(r);
  s.move(o + " ".repeat(a - o.length)), s.shift(a);
  const c = n.enter("listItem"), l = n.indentLines(
    n.containerFlow(t, s.current()),
    u
  );
  return c(), l;
  function u(d, f, h) {
    return f ? (h ? "" : " ".repeat(a)) + d : (h ? o : o + " ".repeat(a - o.length)) + d;
  }
}
const Yz = {
  exit: {
    taskListCheckValueChecked: hw,
    taskListCheckValueUnchecked: hw,
    paragraph: Jz
  }
}, Qz = {
  unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
  handlers: { listItem: Zz }
};
function hw(t) {
  const e = (
    /** @type {ListItem} */
    this.stack[this.stack.length - 2]
  );
  e.checked = t.type === "taskListCheckValueChecked";
}
function Jz(t) {
  const e = (
    /** @type {Parents} */
    this.stack[this.stack.length - 2]
  );
  if (e && e.type === "listItem" && typeof e.checked == "boolean") {
    const n = (
      /** @type {Paragraph} */
      this.stack[this.stack.length - 1]
    ), r = n.children[0];
    if (r && r.type === "text") {
      const i = e.children;
      let o = -1, a;
      for (; ++o < i.length; ) {
        const s = i[o];
        if (s.type === "paragraph") {
          a = s;
          break;
        }
      }
      a === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(t);
}
function Zz(t, e, n, r) {
  const i = t.children[0], o = typeof t.checked == "boolean" && i && i.type === "paragraph", a = "[" + (t.checked ? "x" : " ") + "] ", s = pd(r);
  o && s.move(a);
  let c = Gz(t, e, n, {
    ...r,
    ...s.current()
  });
  return o && (c = c.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, l)), c;
  function l(u) {
    return u + a;
  }
}
function Xz() {
  return [
    Zq,
    mz(),
    xz,
    Hz,
    Yz
  ];
}
function eK(t) {
  return {
    extensions: [
      Xq,
      vz(),
      Rz,
      zz(t),
      Qz
    ]
  };
}
function tK(t = {}) {
  const e = this.data();
  n("micromarkExtensions", Wq(t)), n("fromMarkdownExtensions", Xz()), n("toMarkdownExtensions", eK(t));
  function n(r, i) {
    /** @type {unknown[]} */
    // Other extensions
    /* c8 ignore next 2 */
    (e[r] ? e[r] : e[r] = []).push(i);
  }
}
const gY = ({
  explanation: t,
  srcset: e,
  sizes: n,
  src: r,
  className: i
}) => /* @__PURE__ */ K(Nc, { className: j("flex flex-col sm:flex-row h-full", i), children: [
  /* @__PURE__ */ K("div", { className: "relative w-full sm:w-1/3 max-h-160 sm:max-h-full sm:order-last", children: [
    /* @__PURE__ */ C(
      "img",
      {
        srcSet: e ?? "",
        sizes: n ?? "",
        src: r ?? "",
        alt: "",
        className: "rounded-t-lg sm:rounded-r-lg sm:rounded-l-none max-h-160 sm:max-h-full w-full h-full object-cover object-right"
      }
    ),
    /* @__PURE__ */ C(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "none",
        style: { width: "33%", height: "100%" },
        className: "absolute top-0 -left-1 opacity-0 sm:opacity-100",
        children: /* @__PURE__ */ C("polygon", { stroke: "white", fill: "white", points: "0,0 100,0 0,100" })
      }
    )
  ] }),
  /* @__PURE__ */ C("div", { className: "w-full sm:w-2/3 py-20 px-18 sm:pl-32 sm:pr-4 overflow-auto overscroll-y-auto", children: /* @__PURE__ */ C("article", { className: "prose prose-headings:mt-12 prose-headings:mb-2 prose-headings:lg:my-12 prose-headings:text-font-primary prose-headings:font-semibold prose-headings:text-t18 prose-headings:sm:text-t21 prose-ul:text-font-secondary prose-ul:font-normal prose-ul:text-t16 prose-ul:sm:text-t18 prose-ul:pt-6 prose-ul:pb-12 prose-li:my-2 prose-p:my-2 prose-brand", children: /* @__PURE__ */ C(
    e3,
    {
      children: t ?? "",
      remarkPlugins: [tK]
    }
  ) }) })
] }), mY = ({
  children: t,
  height: e,
  showLines: n = !1,
  color: r = "bg-slate-300",
  fitContent: i,
  isLoaded: o = !1
}) => {
  const a = e || (i ? "fit-content" : "100%");
  return /* @__PURE__ */ K("section", { className: "w-full", children: [
    /* @__PURE__ */ K(
      "div",
      {
        "data-testid": "show-skeleton",
        className: `rounded ${r} animate-${o ? "none" : "pulse"}`,
        style: {
          display: o ? "hidden" : "inline-block",
          visibility: o ? "hidden" : "visible",
          height: a,
          width: i ? "fit-content" : "100%",
          minWidth: "10rem",
          minHeight: "3rem",
          overflow: "hidden",
          transition: "all 0.5s ease-in-out",
          opacity: o ? "0" : "100"
        },
        children: [
          n ? /* @__PURE__ */ K(
            "div",
            {
              "data-testid": "show-skeleton-lines",
              className: "flex space-x-12 p-18",
              children: [
                /* @__PURE__ */ C("div", { className: "bg-slate-200 rounded-full min-w-fit w-32 h-32" }),
                /* @__PURE__ */ K("div", { className: "flex flex-col flex-1 w-fit min-w-[10rem] space-y-12", children: [
                  /* @__PURE__ */ C("div", { className: "bg-slate-200 rounded-xl h-12 w-2/3 mb-12" }),
                  /* @__PURE__ */ K("div", { className: "flex space-x-12", children: [
                    /* @__PURE__ */ C("div", { className: "bg-slate-200 rounded w-1/4 h-8" }),
                    /* @__PURE__ */ C("div", { className: "bg-slate-200 rounded w-1/2 h-8" }),
                    /* @__PURE__ */ C("div", { className: "bg-slate-200 rounded w-1/4 h-8" })
                  ] }),
                  /* @__PURE__ */ K("div", { className: "flex space-x-12", children: [
                    /* @__PURE__ */ C("div", { className: "bg-slate-200 rounded w-1/3 h-8" }),
                    /* @__PURE__ */ C("div", { className: "bg-slate-200 rounded w-2/3 h-8" })
                  ] }),
                  /* @__PURE__ */ C("div", { className: "bg-slate-200 rounded h-8" })
                ] })
              ]
            }
          ) : /* @__PURE__ */ C("div", {}),
          /* @__PURE__ */ C("div", { className: "opacity-0", children: t })
        ]
      }
    ),
    /* @__PURE__ */ C(
      "div",
      {
        "data-testid": "show-children",
        style: {
          height: o ? "100%" : "0px",
          display: o ? "inline-block" : "hidden",
          visibility: o ? "visible" : "hidden",
          transition: "all 0.5s ease-in-out",
          opacity: o ? "100" : "0"
        },
        children: t
      }
    )
  ] });
};
const vY = ({
  min: t,
  max: e,
  value: n,
  onChange: r,
  className: i,
  disabled: o
}) => /* @__PURE__ */ C("div", { className: j("w-full", i), children: /* @__PURE__ */ C(
  "input",
  {
    type: "range",
    id: "slider",
    value: n == null ? void 0 : n.toString(),
    min: t ?? 0,
    max: e ?? 0,
    step: "1",
    className: "w-full appearance-none focus:outline-none",
    onChange: (a) => r(parseInt(a.target.value)),
    disabled: o
  }
) }), yY = ({
  disabled: t,
  checked: e,
  onChange: n,
  size: r,
  className: i,
  ...o
}) => {
  const a = r ?? "sm";
  return /* @__PURE__ */ C(
    "div",
    {
      className: j(
        "flex flex-row flex-nowrap items-center",
        i
      ),
      children: /* @__PURE__ */ K("label", { className: "relative inline-flex items-center cursor-pointer mx-8", children: [
        /* @__PURE__ */ C(
          "input",
          {
            type: "checkbox",
            role: "switch",
            value: "",
            className: "sr-only peer appearance-none outline-none",
            checked: e,
            onChange: n,
            disabled: t,
            ...o
          }
        ),
        /* @__PURE__ */ C(
          "span",
          {
            className: j(
              // Sizes
              {
                "w-34 h-20 after:w-16 after:h-16 after:absolute after:top-[2px] after:left-[2px] peer-checked:after:translate-x-[90%] ": a === "sm"
              },
              {
                "w-80 h-40 after:w-32 after:h-32 after:absolute after:top-[4px] after:left-[2px] peer-checked:after:translate-x-[130%]": a === "md"
              },
              // Borders & rings
              "border-none peer-focus-visible:ring rounded-full",
              // Colours: track
              "bg-switch-background-unchecked peer-checked:bg-switch-background-checked",
              // Colours: toggle
              "peer-checked:after:bg-switch-toggle-unchecked after:bg-switch-toggle-checked",
              // Toggle
              "duration-300 ease-in-out after:content-[''] after:border after:rounded-full after:transition-all",
              // Disabled
              "peer-disabled:bg-switch-disabled-background peer-disabled:cursor-not-allowed"
            )
          }
        )
      ] })
    }
  );
}, nK = ({
  title: t,
  selectedTab: e,
  setSelectedTab: n,
  index: r
}) => /* @__PURE__ */ C("li", { className: "text-font-primary", children: /* @__PURE__ */ K(
  "button",
  {
    className: j("text-t16 md:text-t18 flex flex-col pb-24", {
      "text-action-primary font-semibold": e === r
    }),
    onClick: () => n(r),
    children: [
      t,
      /* @__PURE__ */ C(
        "span",
        {
          "aria-hidden": !0,
          className: j(
            "h-4 w-full rounded-full content-[''] mt-2 inline-block",
            {
              "bg-action-primary": e === r
            }
          )
        }
      )
    ]
  }
) }), wY = ({ tabs: t, className: e }) => {
  const [n, r] = et(0);
  return (() => /* @__PURE__ */ K("div", { className: j("flex flex-col", e), children: [
    /* @__PURE__ */ C("ul", { className: "flex gap-x-20", id: "tab-group-list", role: "list", children: t.map((o, a) => /* @__PURE__ */ C(
      nK,
      {
        title: o.title,
        index: a,
        setSelectedTab: r,
        selectedTab: n
      },
      a
    )) }),
    t[n].tab
  ] }))();
}, bY = ({ children: t, className: e }) => /* @__PURE__ */ C(
  "div",
  {
    className: j(
      "sm:overflow-auto sm:overflow-hidden h-fit sm:max-h-[360px]",
      e
    ),
    children: t
  }
), _Y = ({
  className: t,
  label: e,
  isDisabled: n,
  error: r,
  ...i
}) => {
  var s;
  const o = bn(), a = i.id ?? o;
  return /* @__PURE__ */ K(
    "div",
    {
      className: j(
        "flex flex-col text-t16 text-font-primary",
        t
      ),
      children: [
        e && /* @__PURE__ */ C(
          "label",
          {
            htmlFor: a,
            className: "text-input-label text-t16 font-semibold mb-8",
            children: e
          }
        ),
        /* @__PURE__ */ K("div", { className: "relative", children: [
          /* @__PURE__ */ C(
            "textarea",
            {
              ...i,
              className: "min-h-200 w-full bg-background-primary rounded-lg border-input-border border resize-none p-24 pb-40",
              id: a
            }
          ),
          i.maxLength && /* @__PURE__ */ K("span", { className: "absolute bottom-12 right-12 text-t12 text-font-secondary bg-background-primary/80 rounded-md p-4", children: [
            (s = i.value) == null ? void 0 : s.toString().length,
            "/",
            i.maxLength
          ] })
        ] }),
        r && /* @__PURE__ */ C("p", { className: "text-action-error mt-12", children: r })
      ]
    }
  );
};
var wp = /* @__PURE__ */ ((t) => (t[t.Success = 0] = "Success", t[t.Error = 1] = "Error", t))(wp || {});
const v3 = Ha(
  void 0
), EY = ({ children: t }) => {
  const [e, n] = et([]), r = Qe(
    ({ duration: o = 5e3, icon: a = 0, message: s }) => new Promise((c) => {
      const l = Di(), u = () => {
        b(), c();
      };
      let d, f = o, h;
      const g = () => {
        d = (/* @__PURE__ */ new Date()).getTime(), h = window.setTimeout(u, f);
      }, v = () => {
        n((w) => w.filter((_) => _.id !== l)), clearTimeout(h), c();
      }, b = () => {
        n((w) => {
          const _ = w.findIndex((E) => E.id === l);
          if (_ > -1) {
            const E = { ...w[_], isExpired: !0 };
            return [
              ...w.slice(0, _),
              E,
              ...w.slice(_ + 1)
            ];
          }
          return w;
        }), clearTimeout(h);
      }, p = {
        duration: o,
        icon: a,
        message: s,
        expire: b,
        remove: v,
        pause: () => {
          window.clearTimeout(h);
          const w = (/* @__PURE__ */ new Date()).getTime() - d;
          f = f - w;
        },
        resume: () => {
          p.isExpired || g();
        },
        isExpired: !1,
        id: l
      };
      n((w) => [...w, p]), g();
    }),
    []
  ), i = Tr(
    () => ({
      toasts: e,
      addToast: r
    }),
    [e, r]
  );
  return /* @__PURE__ */ C(v3.Provider, { value: i, children: t });
}, rK = () => {
  const t = zi(v3);
  if (t === void 0)
    throw new Error("useToaster must be used within a ToasterContextProvider");
  return t;
}, iK = typeof window > "u" || typeof document > "u";
let gd = iK ? Ee : Tp;
function va(t) {
  let e = Me(t);
  return gd(() => {
    e.current = t;
  }, [t]), e;
}
function oK(t) {
  typeof queueMicrotask == "function" ? queueMicrotask(t) : Promise.resolve().then(t).catch((e) => setTimeout(() => {
    throw e;
  }));
}
function md() {
  let t = [], e = [], n = { enqueue(r) {
    e.push(r);
  }, addEventListener(r, i, o, a) {
    return r.addEventListener(i, o, a), n.add(() => r.removeEventListener(i, o, a));
  }, requestAnimationFrame(...r) {
    let i = requestAnimationFrame(...r);
    return n.add(() => cancelAnimationFrame(i));
  }, nextFrame(...r) {
    return n.requestAnimationFrame(() => n.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let i = setTimeout(...r);
    return n.add(() => clearTimeout(i));
  }, microTask(...r) {
    let i = { current: !0 };
    return oK(() => {
      i.current && r[0]();
    }), n.add(() => {
      i.current = !1;
    });
  }, add(r) {
    return t.push(r), () => {
      let i = t.indexOf(r);
      if (i >= 0) {
        let [o] = t.splice(i, 1);
        o();
      }
    };
  }, dispose() {
    for (let r of t.splice(0))
      r();
  }, async workQueue() {
    for (let r of e.splice(0))
      await r();
  } };
  return n;
}
function y3() {
  let [t] = et(md);
  return Ee(() => () => t.dispose(), [t]), t;
}
let ho = function(t) {
  let e = va(t);
  return Ct.useCallback((...n) => e.current(...n), [e]);
}, Nf = { serverHandoffComplete: !1 };
function w3() {
  let [t, e] = et(Nf.serverHandoffComplete);
  return Ee(() => {
    t !== !0 && e(!0);
  }, [t]), Ee(() => {
    Nf.serverHandoffComplete === !1 && (Nf.serverHandoffComplete = !0);
  }, []), t;
}
function dr(t, e, ...n) {
  if (t in e) {
    let i = e[t];
    return typeof i == "function" ? i(...n) : i;
  }
  let r = new Error(`Tried to handle "${t}" but there is no handler defined. Only defined handlers are: ${Object.keys(e).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, dr), r;
}
let aK = Symbol();
function b3(...t) {
  let e = Me(t);
  Ee(() => {
    e.current = t;
  }, [t]);
  let n = ho((r) => {
    for (let i of e.current)
      i != null && (typeof i == "function" ? i(r) : i.current = r);
  });
  return t.every((r) => r == null || (r == null ? void 0 : r[aK])) ? void 0 : n;
}
var _3 = ((t) => (t[t.None = 0] = "None", t[t.RenderStrategy = 1] = "RenderStrategy", t[t.Static = 2] = "Static", t))(_3 || {}), si = ((t) => (t[t.Unmount = 0] = "Unmount", t[t.Hidden = 1] = "Hidden", t))(si || {});
function E3({ ourProps: t, theirProps: e, slot: n, defaultTag: r, features: i, visible: o = !0, name: a }) {
  let s = C3(e, t);
  if (o)
    return al(s, n, r, a);
  let c = i ?? 0;
  if (c & 2) {
    let { static: l = !1, ...u } = s;
    if (l)
      return al(u, n, r, a);
  }
  if (c & 1) {
    let { unmount: l = !0, ...u } = s;
    return dr(l ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return al({ ...u, hidden: !0, style: { display: "none" } }, n, r, a);
    } });
  }
  return al(s, n, r, a);
}
function al(t, e = {}, n, r) {
  let { as: i = n, children: o, refName: a = "ref", ...s } = Mf(t, ["unmount", "static"]), c = t.ref !== void 0 ? { [a]: t.ref } : {}, l = typeof o == "function" ? o(e) : o;
  s.className && typeof s.className == "function" && (s.className = s.className(e));
  let u = {};
  if (e) {
    let d = !1, f = [];
    for (let [h, g] of Object.entries(e))
      typeof g == "boolean" && (d = !0), g === !0 && f.push(h);
    d && (u["data-headlessui-state"] = f.join(" "));
  }
  if (i === Ss && Object.keys(pw(s)).length > 0) {
    if (!q3(l) || Array.isArray(l) && l.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(s).map((d) => `  - ${d}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((d) => `  - ${d}`).join(`
`)].join(`
`));
    return Ow(l, Object.assign({}, C3(l.props, pw(Mf(s, ["ref"]))), u, c, sK(l.ref, c.ref)));
  }
  return z3(i, Object.assign({}, Mf(s, ["ref"]), i !== Ss && c, i !== Ss && u), l);
}
function sK(...t) {
  return { ref: t.every((e) => e == null) ? void 0 : (e) => {
    for (let n of t)
      n != null && (typeof n == "function" ? n(e) : n.current = e);
  } };
}
function C3(...t) {
  if (t.length === 0)
    return {};
  if (t.length === 1)
    return t[0];
  let e = {}, n = {};
  for (let r of t)
    for (let i in r)
      i.startsWith("on") && typeof r[i] == "function" ? (n[i] != null || (n[i] = []), n[i].push(r[i])) : e[i] = r[i];
  if (e.disabled || e["aria-disabled"])
    return Object.assign(e, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n)
    Object.assign(e, { [r](i, ...o) {
      let a = n[r];
      for (let s of a) {
        if ((i instanceof Event || (i == null ? void 0 : i.nativeEvent) instanceof Event) && i.defaultPrevented)
          return;
        s(i, ...o);
      }
    } });
  return e;
}
function Om(t) {
  var e;
  return Object.assign(xu(t), { displayName: (e = t.displayName) != null ? e : t.name });
}
function pw(t) {
  let e = Object.assign({}, t);
  for (let n in e)
    e[n] === void 0 && delete e[n];
  return e;
}
function Mf(t, e = []) {
  let n = Object.assign({}, t);
  for (let r of e)
    r in n && delete n[r];
  return n;
}
let xm = Ha(null);
xm.displayName = "OpenClosedContext";
var sc = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(sc || {});
function I3() {
  return zi(xm);
}
function cK({ value: t, children: e }) {
  return Ct.createElement(xm.Provider, { value: t }, e);
}
function S3() {
  let t = Me(!1);
  return gd(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
function lK(t) {
  let e = { called: !1 };
  return (...n) => {
    if (!e.called)
      return e.called = !0, t(...n);
  };
}
function Pf(t, ...e) {
  t && e.length > 0 && t.classList.add(...e);
}
function Df(t, ...e) {
  t && e.length > 0 && t.classList.remove(...e);
}
var bp = ((t) => (t.Ended = "ended", t.Cancelled = "cancelled", t))(bp || {});
function uK(t, e) {
  let n = md();
  if (!t)
    return n.dispose;
  let { transitionDuration: r, transitionDelay: i } = getComputedStyle(t), [o, a] = [r, i].map((s) => {
    let [c = 0] = s.split(",").filter(Boolean).map((l) => l.includes("ms") ? parseFloat(l) : parseFloat(l) * 1e3).sort((l, u) => u - l);
    return c;
  });
  if (o + a !== 0) {
    let s = [];
    s.push(n.addEventListener(t, "transitionrun", (c) => {
      c.target === c.currentTarget && (s.splice(0).forEach((l) => l()), s.push(n.addEventListener(t, "transitionend", (l) => {
        l.target === l.currentTarget && (e("ended"), s.splice(0).forEach((u) => u()));
      }), n.addEventListener(t, "transitioncancel", (l) => {
        l.target === l.currentTarget && (e("cancelled"), s.splice(0).forEach((u) => u()));
      })));
    }));
  } else
    e("ended");
  return n.add(() => e("cancelled")), n.dispose;
}
function dK(t, e, n, r) {
  let i = n ? "enter" : "leave", o = md(), a = r !== void 0 ? lK(r) : () => {
  };
  i === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
  let s = dr(i, { enter: () => e.enter, leave: () => e.leave }), c = dr(i, { enter: () => e.enterTo, leave: () => e.leaveTo }), l = dr(i, { enter: () => e.enterFrom, leave: () => e.leaveFrom });
  return Df(t, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), Pf(t, ...s, ...l), o.nextFrame(() => {
    Df(t, ...l), Pf(t, ...c), uK(t, (u) => (u === "ended" && (Df(t, ...s), Pf(t, ...e.entered)), a(u)));
  }), o.dispose;
}
function fK({ container: t, direction: e, classes: n, onStart: r, onStop: i }) {
  let o = S3(), a = y3(), s = va(e);
  gd(() => {
    let c = md();
    a.add(c.dispose);
    let l = t.current;
    if (l && s.current !== "idle" && o.current)
      return c.dispose(), r.current(s.current), c.add(dK(l, n.current, s.current === "enter", (u) => {
        c.dispose(), dr(u, { [bp.Ended]() {
          i.current(s.current);
        }, [bp.Cancelled]: () => {
        } });
      })), c.dispose;
  }, [e]);
}
function Xi(t = "") {
  return t.split(" ").filter((e) => e.trim().length > 1);
}
let vd = Ha(null);
vd.displayName = "TransitionContext";
var hK = ((t) => (t.Visible = "visible", t.Hidden = "hidden", t))(hK || {});
function pK() {
  let t = zi(vd);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function gK() {
  let t = zi(yd);
  if (t === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
let yd = Ha(null);
yd.displayName = "NestingContext";
function wd(t) {
  return "children" in t ? wd(t.children) : t.current.filter(({ el: e }) => e.current !== null).filter(({ state: e }) => e === "visible").length > 0;
}
function T3(t, e) {
  let n = va(t), r = Me([]), i = S3(), o = y3(), a = ho((h, g = si.Hidden) => {
    let v = r.current.findIndex(({ el: b }) => b === h);
    v !== -1 && (dr(g, { [si.Unmount]() {
      r.current.splice(v, 1);
    }, [si.Hidden]() {
      r.current[v].state = "hidden";
    } }), o.microTask(() => {
      var b;
      !wd(r) && i.current && ((b = n.current) == null || b.call(n));
    }));
  }), s = ho((h) => {
    let g = r.current.find(({ el: v }) => v === h);
    return g ? g.state !== "visible" && (g.state = "visible") : r.current.push({ el: h, state: "visible" }), () => a(h, si.Unmount);
  }), c = Me([]), l = Me(Promise.resolve()), u = Me({ enter: [], leave: [], idle: [] }), d = ho((h, g, v) => {
    c.current.splice(0), e && (e.chains.current[g] = e.chains.current[g].filter(([b]) => b !== h)), e == null || e.chains.current[g].push([h, new Promise((b) => {
      c.current.push(b);
    })]), e == null || e.chains.current[g].push([h, new Promise((b) => {
      Promise.all(u.current[g].map(([m, y]) => y)).then(() => b());
    })]), g === "enter" ? l.current = l.current.then(() => e == null ? void 0 : e.wait.current).then(() => v(g)) : v(g);
  }), f = ho((h, g, v) => {
    Promise.all(u.current[g].splice(0).map(([b, m]) => m)).then(() => {
      var b;
      (b = c.current.shift()) == null || b();
    }).then(() => v(g));
  });
  return Tr(() => ({ children: r, register: s, unregister: a, onStart: d, onStop: f, wait: l, chains: u }), [s, a, r, d, f, u, l]);
}
function mK() {
}
let vK = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function gw(t) {
  var e;
  let n = {};
  for (let r of vK)
    n[r] = (e = t[r]) != null ? e : mK;
  return n;
}
function yK(t) {
  let e = Me(gw(t));
  return Ee(() => {
    e.current = gw(t);
  }, [t]), e;
}
let wK = "div", k3 = _3.RenderStrategy, A3 = Om(function(t, e) {
  let { beforeEnter: n, afterEnter: r, beforeLeave: i, afterLeave: o, enter: a, enterFrom: s, enterTo: c, entered: l, leave: u, leaveFrom: d, leaveTo: f, ...h } = t, g = Me(null), v = b3(g, e), b = h.unmount ? si.Unmount : si.Hidden, { show: m, appear: y, initial: p } = pK(), [w, _] = et(m ? "visible" : "hidden"), E = gK(), { register: S, unregister: T } = E, x = Me(null);
  Ee(() => S(g), [S, g]), Ee(() => {
    if (b === si.Hidden && g.current) {
      if (m && w !== "visible") {
        _("visible");
        return;
      }
      return dr(w, { hidden: () => T(g), visible: () => S(g) });
    }
  }, [w, g, S, T, m, b]);
  let A = va({ enter: Xi(a), enterFrom: Xi(s), enterTo: Xi(c), entered: Xi(l), leave: Xi(u), leaveFrom: Xi(d), leaveTo: Xi(f) }), N = yK({ beforeEnter: n, afterEnter: r, beforeLeave: i, afterLeave: o }), F = w3();
  Ee(() => {
    if (F && w === "visible" && g.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [g, w, F]);
  let D = p && !y, L = (() => !F || D || x.current === m ? "idle" : m ? "enter" : "leave")(), z = ho((I) => dr(I, { enter: () => N.current.beforeEnter(), leave: () => N.current.beforeLeave(), idle: () => {
  } })), ne = ho((I) => dr(I, { enter: () => N.current.afterEnter(), leave: () => N.current.afterLeave(), idle: () => {
  } })), ae = T3(() => {
    _("hidden"), T(g);
  }, E);
  fK({ container: g, classes: A, direction: L, onStart: va((I) => {
    ae.onStart(g, I, z);
  }), onStop: va((I) => {
    ae.onStop(g, I, ne), I === "leave" && !wd(ae) && (_("hidden"), T(g));
  }) }), Ee(() => {
    !D || (b === si.Hidden ? x.current = null : x.current = m);
  }, [m, D, w]);
  let Re = h, fe = { ref: v };
  return Ct.createElement(yd.Provider, { value: ae }, Ct.createElement(cK, { value: dr(w, { visible: sc.Open, hidden: sc.Closed }) }, E3({ ourProps: fe, theirProps: Re, defaultTag: wK, features: k3, visible: w === "visible", name: "Transition.Child" })));
}), _p = Om(function(t, e) {
  let { show: n, appear: r = !1, unmount: i, ...o } = t, a = Me(null), s = b3(a, e);
  w3();
  let c = I3();
  if (n === void 0 && c !== null && (n = dr(c, { [sc.Open]: !0, [sc.Closed]: !1 })), ![!0, !1].includes(n))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [l, u] = et(n ? "visible" : "hidden"), d = T3(() => {
    u("hidden");
  }), [f, h] = et(!0), g = Me([n]);
  gd(() => {
    f !== !1 && g.current[g.current.length - 1] !== n && (g.current.push(n), h(!1));
  }, [g, n]);
  let v = Tr(() => ({ show: n, appear: r, initial: f }), [n, r, f]);
  Ee(() => {
    if (n)
      u("visible");
    else if (!wd(d))
      u("hidden");
    else {
      let m = a.current;
      if (!m)
        return;
      let y = m.getBoundingClientRect();
      y.x === 0 && y.y === 0 && y.width === 0 && y.height === 0 && u("hidden");
    }
  }, [n, d]);
  let b = { unmount: i };
  return Ct.createElement(yd.Provider, { value: d }, Ct.createElement(vd.Provider, { value: v }, E3({ ourProps: { ...b, as: Ss, children: Ct.createElement(A3, { ref: s, ...b, ...o }) }, theirProps: {}, defaultTag: Ss, features: k3, visible: l === "visible", name: "Transition" })));
}), bK = Om(function(t, e) {
  let n = zi(vd) !== null, r = I3() !== null;
  return Ct.createElement(Ct.Fragment, null, !n && r ? Ct.createElement(_p, { ref: e, ...t }) : Ct.createElement(A3, { ref: e, ...t }));
}), _K = Object.assign(_p, { Child: bK, Root: _p });
const EK = ({ icon: t }) => {
  switch (t) {
    case wp.Success:
      return /* @__PURE__ */ C(
        "svg",
        {
          width: 25,
          height: 25,
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ C(
            "path",
            {
              d: "m10.89 16-.992 1.125a1.5 1.5 0 0 0 2.053-.064L10.891 16Zm9.061-6.94a1.5 1.5 0 1 0-2.121-2.12l2.121 2.12ZM8.105 11.543a1.5 1.5 0 1 0-1.985 2.25l1.985-2.25Zm3.846 5.519 8-8-2.121-2.122-8 8 2.121 2.122Zm-.068-2.186-3.778-3.333-1.985 2.25 3.778 3.333 1.985-2.25Z",
              fill: "#55CBB7"
            }
          )
        }
      );
    case wp.Error:
      return /* @__PURE__ */ K(
        "svg",
        {
          "aria-hidden": !0,
          width: 25,
          height: 25,
          viewBox: "0 0 16 16",
          className: "text-action-error",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ C(
              "path",
              {
                fill: "currentColor",
                d: "M3.88 10.548a1.111 1.111 0 1 0 1.572 1.571l-1.571-1.571Zm8.239-5.096a1.111 1.111 0 1 0-1.572-1.571l1.572 1.571ZM5.452 12.12l6.667-6.667-1.572-1.571-6.666 6.667 1.571 1.571Z"
              }
            ),
            /* @__PURE__ */ C(
              "path",
              {
                fill: "currentColor",
                d: "M5.452 3.881a1.111 1.111 0 0 0-1.57 1.571l1.57-1.571Zm5.096 8.238a1.111 1.111 0 0 0 1.571-1.571l-1.571 1.571ZM3.88 5.452l6.667 6.667 1.571-1.571L5.452 3.88l-1.57 1.571Z"
              }
            )
          ]
        }
      );
    default:
      return null;
  }
}, CK = ({ toast: t }) => /* @__PURE__ */ K(
  _K,
  {
    className: "flex items-center justify-center rounded bg-white shadow-primary text-font-primary p-12",
    appear: !0,
    show: !t.isExpired,
    enter: "transition ease-in-out duration-300",
    enterFrom: "opacity-0 translate-y-24",
    enterTo: "opacity-100 translate-y-0",
    leave: "transition ease-in-out duration-500",
    leaveFrom: "opacity-100 translate-x-0",
    leaveTo: "opacity-0 translate-x-60",
    afterLeave: t.remove,
    onMouseEnter: t.pause,
    onMouseLeave: t.resume,
    onClick: t.expire,
    children: [
      /* @__PURE__ */ C("p", { className: "mr-4", children: t.message }),
      /* @__PURE__ */ C(EK, { icon: t.icon })
    ]
  }
), CY = ({ className: t }) => {
  const { toasts: e } = rK();
  return /* @__PURE__ */ C(cc, { children: e.map((n, r) => /* @__PURE__ */ C(
    "div",
    {
      className: j(
        "z-50 fixed top-24 right-18 sm:top-56 sm:right-60 transition duration-300",
        t
      ),
      style: { transform: `translateY(${(50 + 12) * r}px)` },
      children: /* @__PURE__ */ C(CK, { toast: n })
    },
    n.id
  )) });
}, Fa = Math.min, wo = Math.max, Tu = Math.round, sl = Math.floor, $i = (t) => ({
  x: t,
  y: t
}), IK = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, SK = {
  start: "end",
  end: "start"
};
function Ep(t, e, n) {
  return wo(t, Fa(e, n));
}
function Lc(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function No(t) {
  return t.split("-")[0];
}
function Fc(t) {
  return t.split("-")[1];
}
function O3(t) {
  return t === "x" ? "y" : "x";
}
function Rm(t) {
  return t === "y" ? "height" : "width";
}
function bd(t) {
  return ["top", "bottom"].includes(No(t)) ? "y" : "x";
}
function Nm(t) {
  return O3(bd(t));
}
function TK(t, e, n) {
  n === void 0 && (n = !1);
  const r = Fc(t), i = Nm(t), o = Rm(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (a = ku(a)), [a, ku(a)];
}
function kK(t) {
  const e = ku(t);
  return [Cp(t), e, Cp(e)];
}
function Cp(t) {
  return t.replace(/start|end/g, (e) => SK[e]);
}
function AK(t, e, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? i : r : e ? r : i;
    case "left":
    case "right":
      return e ? o : a;
    default:
      return [];
  }
}
function OK(t, e, n, r) {
  const i = Fc(t);
  let o = AK(No(t), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), e && (o = o.concat(o.map(Cp)))), o;
}
function ku(t) {
  return t.replace(/left|right|bottom|top/g, (e) => IK[e]);
}
function xK(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function x3(t) {
  return typeof t != "number" ? xK(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Au(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function mw(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const o = bd(e), a = Nm(e), s = Rm(a), c = No(e), l = o === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: u,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Fc(e)) {
    case "start":
      h[a] -= f * (n && l ? -1 : 1);
      break;
    case "end":
      h[a] += f * (n && l ? -1 : 1);
      break;
  }
  return h;
}
const RK = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let l = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: u,
    y: d
  } = mw(l, r, c), f = r, h = {}, g = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: b,
      fn: m
    } = s[v], {
      x: y,
      y: p,
      data: w,
      reset: _
    } = await m({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: l,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (u = y ?? u, d = p ?? d, h = {
      ...h,
      [b]: {
        ...h[b],
        ...w
      }
    }, _ && g <= 50) {
      g++, typeof _ == "object" && (_.placement && (f = _.placement), _.rects && (l = _.rects === !0 ? await a.getElementRects({
        reference: t,
        floating: e,
        strategy: i
      }) : _.rects), {
        x: u,
        y: d
      } = mw(l, f, c)), v = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function R3(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: c
  } = t, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = Lc(e, t), g = x3(h), b = s[f ? d === "floating" ? "reference" : "floating" : d], m = Au(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(b))) == null || n ? b : b.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), y = d === "floating" ? {
    ...a.floating,
    x: r,
    y: i
  } : a.reference, p = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), w = await (o.isElement == null ? void 0 : o.isElement(p)) ? await (o.getScale == null ? void 0 : o.getScale(p)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = Au(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: y,
    offsetParent: p,
    strategy: c
  }) : y);
  return {
    top: (m.top - _.top + g.top) / w.y,
    bottom: (_.bottom - m.bottom + g.bottom) / w.y,
    left: (m.left - _.left + g.left) / w.x,
    right: (_.right - m.right + g.right) / w.x
  };
}
const NK = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s
    } = e, {
      element: c,
      padding: l = 0
    } = Lc(t, e) || {};
    if (c == null)
      return {};
    const u = x3(l), d = {
      x: n,
      y: r
    }, f = Nm(i), h = Rm(f), g = await a.getDimensions(c), v = f === "y", b = v ? "top" : "left", m = v ? "bottom" : "right", y = v ? "clientHeight" : "clientWidth", p = o.reference[h] + o.reference[f] - d[f] - o.floating[h], w = d[f] - o.reference[f], _ = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let E = _ ? _[y] : 0;
    (!E || !await (a.isElement == null ? void 0 : a.isElement(_))) && (E = s.floating[y] || o.floating[h]);
    const S = p / 2 - w / 2, T = E / 2 - g[h] / 2 - 1, x = Fa(u[b], T), A = Fa(u[m], T), N = x, F = E - g[h] - A, D = E / 2 - g[h] / 2 + S, L = Ep(N, D, F), ne = Fc(i) != null && D != L && o.reference[h] / 2 - (D < N ? x : A) - g[h] / 2 < 0 ? D < N ? N - D : F - D : 0;
    return {
      [f]: d[f] - ne,
      data: {
        [f]: L,
        centerOffset: D - L + ne
      }
    };
  }
}), MK = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n;
      const {
        placement: r,
        middlewareData: i,
        rects: o,
        initialPlacement: a,
        platform: s,
        elements: c
      } = e, {
        mainAxis: l = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...v
      } = Lc(t, e), b = No(r), m = No(a) === a, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), p = d || (m || !g ? [ku(a)] : kK(a));
      !d && h !== "none" && p.push(...OK(a, g, h, y));
      const w = [a, ...p], _ = await R3(e, v), E = [];
      let S = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (l && E.push(_[b]), u) {
        const N = TK(r, o, y);
        E.push(_[N[0]], _[N[1]]);
      }
      if (S = [...S, {
        placement: r,
        overflows: E
      }], !E.every((N) => N <= 0)) {
        var T, x;
        const N = (((T = i.flip) == null ? void 0 : T.index) || 0) + 1, F = w[N];
        if (F)
          return {
            data: {
              index: N,
              overflows: S
            },
            reset: {
              placement: F
            }
          };
        let D = (x = S.filter((L) => L.overflows[0] <= 0).sort((L, z) => L.overflows[1] - z.overflows[1])[0]) == null ? void 0 : x.placement;
        if (!D)
          switch (f) {
            case "bestFit": {
              var A;
              const L = (A = S.map((z) => [z.placement, z.overflows.filter((ne) => ne > 0).reduce((ne, ae) => ne + ae, 0)]).sort((z, ne) => z[1] - ne[1])[0]) == null ? void 0 : A[0];
              L && (D = L);
              break;
            }
            case "initialPlacement":
              D = a;
              break;
          }
        if (r !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
async function PK(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = No(n), s = Fc(n), c = bd(n) === "y", l = ["left", "top"].includes(a) ? -1 : 1, u = o && c ? -1 : 1, d = Lc(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return s && typeof g == "number" && (h = s === "end" ? g * -1 : g), c ? {
    x: h * u,
    y: f * l
  } : {
    x: f * l,
    y: h * u
  };
}
const DK = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r
      } = e, i = await PK(e, t);
      return {
        x: n + i.x,
        y: r + i.y,
        data: i
      };
    }
  };
}, LK = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: m,
              y
            } = b;
            return {
              x: m,
              y
            };
          }
        },
        ...c
      } = Lc(t, e), l = {
        x: n,
        y: r
      }, u = await R3(e, c), d = bd(No(i)), f = O3(d);
      let h = l[f], g = l[d];
      if (o) {
        const b = f === "y" ? "top" : "left", m = f === "y" ? "bottom" : "right", y = h + u[b], p = h - u[m];
        h = Ep(y, h, p);
      }
      if (a) {
        const b = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", y = g + u[b], p = g - u[m];
        g = Ep(y, g, p);
      }
      const v = s.fn({
        ...e,
        [f]: h,
        [d]: g
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r
        }
      };
    }
  };
};
function qi(t) {
  return N3(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function tr(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function bi(t) {
  var e;
  return (e = (N3(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function N3(t) {
  return t instanceof Node || t instanceof tr(t).Node;
}
function vi(t) {
  return t instanceof Element || t instanceof tr(t).Element;
}
function $r(t) {
  return t instanceof HTMLElement || t instanceof tr(t).HTMLElement;
}
function vw(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof tr(t).ShadowRoot;
}
function Uc(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = mr(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(i);
}
function FK(t) {
  return ["table", "td", "th"].includes(qi(t));
}
function Mm(t) {
  const e = Pm(), n = mr(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function UK(t) {
  let e = Ua(t);
  for (; $r(e) && !_d(e); ) {
    if (Mm(e))
      return e;
    e = Ua(e);
  }
  return null;
}
function Pm() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function _d(t) {
  return ["html", "body", "#document"].includes(qi(t));
}
function mr(t) {
  return tr(t).getComputedStyle(t);
}
function Ed(t) {
  return vi(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function Ua(t) {
  if (qi(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    vw(t) && t.host || // Fallback.
    bi(t)
  );
  return vw(e) ? e.host : e;
}
function M3(t) {
  const e = Ua(t);
  return _d(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : $r(e) && Uc(e) ? e : M3(e);
}
function Ou(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = M3(t), i = r === ((n = t.ownerDocument) == null ? void 0 : n.body), o = tr(r);
  return i ? e.concat(o, o.visualViewport || [], Uc(r) ? r : []) : e.concat(r, Ou(r));
}
function P3(t) {
  const e = mr(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = $r(t), o = i ? t.offsetWidth : n, a = i ? t.offsetHeight : r, s = Tu(n) !== o || Tu(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function Dm(t) {
  return vi(t) ? t : t.contextElement;
}
function ya(t) {
  const e = Dm(t);
  if (!$r(e))
    return $i(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = P3(e);
  let a = (o ? Tu(n.width) : n.width) / r, s = (o ? Tu(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const HK = /* @__PURE__ */ $i(0);
function D3(t) {
  const e = tr(t);
  return !Pm() || !e.visualViewport ? HK : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function BK(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== tr(t) ? !1 : e;
}
function Mo(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), o = Dm(t);
  let a = $i(1);
  e && (r ? vi(r) && (a = ya(r)) : a = ya(t));
  const s = BK(o, n, r) ? D3(o) : $i(0);
  let c = (i.left + s.x) / a.x, l = (i.top + s.y) / a.y, u = i.width / a.x, d = i.height / a.y;
  if (o) {
    const f = tr(o), h = r && vi(r) ? tr(r) : r;
    let g = f.frameElement;
    for (; g && r && h !== f; ) {
      const v = ya(g), b = g.getBoundingClientRect(), m = mr(g), y = b.left + (g.clientLeft + parseFloat(m.paddingLeft)) * v.x, p = b.top + (g.clientTop + parseFloat(m.paddingTop)) * v.y;
      c *= v.x, l *= v.y, u *= v.x, d *= v.y, c += y, l += p, g = tr(g).frameElement;
    }
  }
  return Au({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
function jK(t) {
  let {
    rect: e,
    offsetParent: n,
    strategy: r
  } = t;
  const i = $r(n), o = bi(n);
  if (n === o)
    return e;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = $i(1);
  const c = $i(0);
  if ((i || !i && r !== "fixed") && ((qi(n) !== "body" || Uc(o)) && (a = Ed(n)), $r(n))) {
    const l = Mo(n);
    s = ya(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop;
  }
  return {
    width: e.width * s.x,
    height: e.height * s.y,
    x: e.x * s.x - a.scrollLeft * s.x + c.x,
    y: e.y * s.y - a.scrollTop * s.y + c.y
  };
}
function VK(t) {
  return Array.from(t.getClientRects());
}
function L3(t) {
  return Mo(bi(t)).left + Ed(t).scrollLeft;
}
function $K(t) {
  const e = bi(t), n = Ed(t), r = t.ownerDocument.body, i = wo(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = wo(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + L3(t);
  const s = -n.scrollTop;
  return mr(r).direction === "rtl" && (a += wo(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function qK(t, e) {
  const n = tr(t), r = bi(t), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, c = 0;
  if (i) {
    o = i.width, a = i.height;
    const l = Pm();
    (!l || l && e === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: c
  };
}
function zK(t, e) {
  const n = Mo(t, !0, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, o = $r(t) ? ya(t) : $i(1), a = t.clientWidth * o.x, s = t.clientHeight * o.y, c = i * o.x, l = r * o.y;
  return {
    width: a,
    height: s,
    x: c,
    y: l
  };
}
function yw(t, e, n) {
  let r;
  if (e === "viewport")
    r = qK(t, n);
  else if (e === "document")
    r = $K(bi(t));
  else if (vi(e))
    r = zK(e, n);
  else {
    const i = D3(t);
    r = {
      ...e,
      x: e.x - i.x,
      y: e.y - i.y
    };
  }
  return Au(r);
}
function F3(t, e) {
  const n = Ua(t);
  return n === e || !vi(n) || _d(n) ? !1 : mr(n).position === "fixed" || F3(n, e);
}
function KK(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = Ou(t).filter((s) => vi(s) && qi(s) !== "body"), i = null;
  const o = mr(t).position === "fixed";
  let a = o ? Ua(t) : t;
  for (; vi(a) && !_d(a); ) {
    const s = mr(a), c = Mm(a);
    !c && s.position === "fixed" && (i = null), (o ? !c && !i : !c && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Uc(a) && !c && F3(t, a)) ? r = r.filter((u) => u !== a) : i = s, a = Ua(a);
  }
  return e.set(t, r), r;
}
function WK(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const a = [...n === "clippingAncestors" ? KK(e, this._c) : [].concat(n), r], s = a[0], c = a.reduce((l, u) => {
    const d = yw(e, u, i);
    return l.top = wo(d.top, l.top), l.right = Fa(d.right, l.right), l.bottom = Fa(d.bottom, l.bottom), l.left = wo(d.left, l.left), l;
  }, yw(e, s, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function GK(t) {
  return P3(t);
}
function YK(t, e, n) {
  const r = $r(e), i = bi(e), o = n === "fixed", a = Mo(t, !0, o, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = $i(0);
  if (r || !r && !o)
    if ((qi(e) !== "body" || Uc(i)) && (s = Ed(e)), r) {
      const l = Mo(e, !0, o, e);
      c.x = l.x + e.clientLeft, c.y = l.y + e.clientTop;
    } else
      i && (c.x = L3(i));
  return {
    x: a.left + s.scrollLeft - c.x,
    y: a.top + s.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function ww(t, e) {
  return !$r(t) || mr(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function U3(t, e) {
  const n = tr(t);
  if (!$r(t))
    return n;
  let r = ww(t, e);
  for (; r && FK(r) && mr(r).position === "static"; )
    r = ww(r, e);
  return r && (qi(r) === "html" || qi(r) === "body" && mr(r).position === "static" && !Mm(r)) ? n : r || UK(t) || n;
}
const QK = async function(t) {
  let {
    reference: e,
    floating: n,
    strategy: r
  } = t;
  const i = this.getOffsetParent || U3, o = this.getDimensions;
  return {
    reference: YK(e, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await o(n)
    }
  };
};
function JK(t) {
  return mr(t).direction === "rtl";
}
const ZK = {
  convertOffsetParentRelativeRectToViewportRelativeRect: jK,
  getDocumentElement: bi,
  getClippingRect: WK,
  getOffsetParent: U3,
  getElementRects: QK,
  getClientRects: VK,
  getDimensions: GK,
  getScale: ya,
  isElement: vi,
  isRTL: JK
};
function XK(t, e) {
  let n = null, r;
  const i = bi(t);
  function o() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function a(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), o();
    const {
      left: l,
      top: u,
      width: d,
      height: f
    } = t.getBoundingClientRect();
    if (s || e(), !d || !f)
      return;
    const h = sl(u), g = sl(i.clientWidth - (l + d)), v = sl(i.clientHeight - (u + f)), b = sl(l), y = {
      rootMargin: -h + "px " + -g + "px " + -v + "px " + -b + "px",
      threshold: wo(0, Fa(1, c)) || 1
    };
    let p = !0;
    function w(_) {
      const E = _[0].intersectionRatio;
      if (E !== c) {
        if (!p)
          return a();
        E ? a(!1, E) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      p = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...y,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, y);
    }
    n.observe(t);
  }
  return a(!0), o;
}
function eW(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Dm(t), u = i || o ? [...l ? Ou(l) : [], ...Ou(e)] : [];
  u.forEach((m) => {
    i && m.addEventListener("scroll", n, {
      passive: !0
    }), o && m.addEventListener("resize", n);
  });
  const d = l && s ? XK(l, n) : null;
  let f = -1, h = null;
  a && (h = new ResizeObserver((m) => {
    let [y] = m;
    y && y.target === l && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(e);
    })), n();
  }), l && !c && h.observe(l), h.observe(e));
  let g, v = c ? Mo(t) : null;
  c && b();
  function b() {
    const m = Mo(t);
    v && (m.x !== v.x || m.y !== v.y || m.width !== v.width || m.height !== v.height) && n(), v = m, g = requestAnimationFrame(b);
  }
  return n(), () => {
    u.forEach((m) => {
      i && m.removeEventListener("scroll", n), o && m.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, c && cancelAnimationFrame(g);
  };
}
const bw = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: ZK,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return RK(t, e, {
    ...i,
    platform: o
  });
};
var Ip = {}, tW = {
  get exports() {
    return Ip;
  },
  set exports(t) {
    Ip = t;
  }
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function n() {
      for (var o = "", a = 0; a < arguments.length; a++) {
        var s = arguments[a];
        s && (o = i(o, r(s)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var a = "";
      for (var s in o)
        e.call(o, s) && o[s] && (a = i(a, s));
      return a;
    }
    function i(o, a) {
      return a ? o ? o + " " + a : o + a : o;
    }
    t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
  })();
})(tW);
const Sp = Ip;
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/
const nW = "react-tooltip-core-styles", rW = "react-tooltip-base-styles", _w = { core: !1, base: !1 };
function Ew({ css: t, id: e = rW, type: n = "base", ref: r }) {
  var i, o;
  if (!t || typeof document > "u" || _w[n] || n === "core" && typeof process < "u" && (!((i = process == null ? void 0 : process.env) === null || i === void 0) && i.REACT_TOOLTIP_DISABLE_CORE_STYLES) || n !== "base" && typeof process < "u" && (!((o = process == null ? void 0 : process.env) === null || o === void 0) && o.REACT_TOOLTIP_DISABLE_BASE_STYLES))
    return;
  n === "core" && (e = nW), r || (r = {});
  const { insertAt: a } = r;
  if (document.getElementById(e))
    return void console.warn(`[react-tooltip] Element with id '${e}' already exists. Call \`removeStyle()\` first`);
  const s = document.head || document.getElementsByTagName("head")[0], c = document.createElement("style");
  c.id = e, c.type = "text/css", a === "top" && s.firstChild ? s.insertBefore(c, s.firstChild) : s.appendChild(c), c.styleSheet ? c.styleSheet.cssText = t : c.appendChild(document.createTextNode(t)), _w[n] = !0;
}
const Cw = (t, e, n) => {
  let r = null;
  const i = function(...o) {
    const a = () => {
      r = null, n || t.apply(this, o);
    };
    n && !r && (t.apply(this, o), r = setTimeout(a, e)), n || (r && clearTimeout(r), r = setTimeout(a, e));
  };
  return i.cancel = () => {
    r && (clearTimeout(r), r = null);
  }, i;
}, iW = "DEFAULT_TOOLTIP_ID", oW = { anchorRefs: /* @__PURE__ */ new Set(), activeAnchor: { current: null }, attach: () => {
}, detach: () => {
}, setActiveAnchor: () => {
} }, aW = Ha({ getTooltipData: () => oW });
function H3(t = iW) {
  return zi(aW).getTooltipData(t);
}
const sW = typeof window < "u" ? Tp : Ee, cW = (t) => {
  if (!(t instanceof HTMLElement || t instanceof SVGElement))
    return !1;
  const e = getComputedStyle(t);
  return ["overflow", "overflow-x", "overflow-y"].some((n) => {
    const r = e.getPropertyValue(n);
    return r === "auto" || r === "scroll";
  });
}, Iw = (t) => {
  if (!t)
    return null;
  let e = t.parentElement;
  for (; e; ) {
    if (cW(e))
      return e;
    e = e.parentElement;
  }
  return document.scrollingElement || document.documentElement;
}, Sw = async ({ elementReference: t = null, tooltipReference: e = null, tooltipArrowReference: n = null, place: r = "top", offset: i = 10, strategy: o = "absolute", middlewares: a = [DK(Number(i)), MK({ fallbackAxisSideDirection: "start" }), LK({ padding: 5 })], border: s }) => {
  if (!t)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  if (e === null)
    return { tooltipStyles: {}, tooltipArrowStyles: {}, place: r };
  const c = a;
  return n ? (c.push(NK({ element: n, padding: 5 })), bw(t, e, { placement: r, strategy: o, middleware: c }).then(({ x: l, y: u, placement: d, middlewareData: f }) => {
    var h, g;
    const v = { left: `${l}px`, top: `${u}px`, border: s }, { x: b, y: m } = (h = f.arrow) !== null && h !== void 0 ? h : { x: 0, y: 0 }, y = (g = { top: "bottom", right: "left", bottom: "top", left: "right" }[d.split("-")[0]]) !== null && g !== void 0 ? g : "bottom", p = s && { borderBottom: s, borderRight: s };
    let w = 0;
    if (s) {
      const _ = `${s}`.match(/(\d+)px/);
      w = _ != null && _[1] ? Number(_[1]) : 1;
    }
    return { tooltipStyles: v, tooltipArrowStyles: { left: b != null ? `${b}px` : "", top: m != null ? `${m}px` : "", right: "", bottom: "", ...p, [y]: `-${4 + w}px` }, place: d };
  })) : bw(t, e, { placement: "bottom", strategy: o, middleware: c }).then(({ x: l, y: u, placement: d }) => ({ tooltipStyles: { left: `${l}px`, top: `${u}px` }, tooltipArrowStyles: {}, place: d }));
};
var zo = { tooltip: "core-styles-module_tooltip__3vRRp", fixed: "core-styles-module_fixed__pcSol", arrow: "core-styles-module_arrow__cvMwQ", noArrow: "core-styles-module_noArrow__xock6", clickable: "core-styles-module_clickable__ZuTTB", show: "core-styles-module_show__Nt9eE", closing: "core-styles-module_closing__sGnxF" }, Lf = { tooltip: "styles-module_tooltip__mnnfp", arrow: "styles-module_arrow__K0L3T", dark: "styles-module_dark__xNqje", light: "styles-module_light__Z6W-X", success: "styles-module_success__A2AKt", warning: "styles-module_warning__SCK0X", error: "styles-module_error__JvumD", info: "styles-module_info__BWdHW" };
const lW = ({ forwardRef: t, id: e, className: n, classNameArrow: r, variant: i = "dark", anchorId: o, anchorSelect: a, place: s = "top", offset: c = 10, events: l = ["hover"], openOnClick: u = !1, positionStrategy: d = "absolute", middlewares: f, wrapper: h, delayShow: g = 0, delayHide: v = 0, float: b = !1, hidden: m = !1, noArrow: y = !1, clickable: p = !1, closeOnEsc: w = !1, closeOnScroll: _ = !1, closeOnResize: E = !1, openEvents: S, closeEvents: T, globalCloseEvents: x, imperativeModeOnly: A, style: N, position: F, afterShow: D, afterHide: L, content: z, contentWrapperRef: ne, isOpen: ae, setIsOpen: Re, activeAnchor: fe, setActiveAnchor: I, border: J, opacity: me, arrowColor: O, role: ue = "tooltip" }) => {
  var Ce;
  const Z = Me(null), he = Me(null), Q = Me(null), $ = Me(null), q = Me(null), [H, V] = et(s), [Pe, X] = et({}), [it, ht] = et({}), [Ze, pt] = et(!1), [Nt, ut] = et(!1), [We, en] = et(null), Jt = Me(!1), gt = Me(null), { anchorRefs: Zt, setActiveAnchor: Tt } = H3(e), U = Me(!1), [Y, we] = et([]), qe = Me(!1), Ye = u || l.includes("click"), kt = Ye || (S == null ? void 0 : S.click) || (S == null ? void 0 : S.dblclick) || (S == null ? void 0 : S.mousedown), tn = S ? { ...S } : { mouseenter: !0, focus: !0, click: !1, dblclick: !1, mousedown: !1 };
  !S && Ye && Object.assign(tn, { mouseenter: !1, focus: !1, click: !0 });
  const vn = T ? { ...T } : { mouseleave: !0, blur: !0, click: !1, dblclick: !1, mouseup: !1 };
  !T && Ye && Object.assign(vn, { mouseleave: !1, blur: !1 });
  const jt = x ? { ...x } : { escape: w || !1, scroll: _ || !1, resize: E || !1, clickOutsideAnchor: kt || !1 };
  A && (Object.assign(tn, { mouseenter: !1, focus: !1, click: !1, dblclick: !1, mousedown: !1 }), Object.assign(vn, { mouseleave: !1, blur: !1, click: !1, dblclick: !1, mouseup: !1 }), Object.assign(jt, { escape: !1, scroll: !1, resize: !1, clickOutsideAnchor: !1 })), sW(() => (qe.current = !0, () => {
    qe.current = !1;
  }), []);
  const Xt = (k) => {
    qe.current && (k && ut(!0), setTimeout(() => {
      qe.current && (Re == null || Re(k), ae === void 0 && pt(k));
    }, 10));
  };
  Ee(() => {
    if (ae === void 0)
      return () => null;
    ae && ut(!0);
    const k = setTimeout(() => {
      pt(ae);
    }, 10);
    return () => {
      clearTimeout(k);
    };
  }, [ae]), Ee(() => {
    if (Ze !== Jt.current)
      if (q.current && clearTimeout(q.current), Jt.current = Ze, Ze)
        D == null || D();
      else {
        const k = ((B) => {
          const G = B.match(/^([\d.]+)(m?s?)$/);
          if (!G)
            return 0;
          const [, ve, Le] = G;
          return Le !== "s" && Le !== "ms" ? 0 : Number(ve) * (Le === "ms" ? 1 : 1e3);
        })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
        q.current = setTimeout(() => {
          ut(!1), en(null), L == null || L();
        }, k + 25);
      }
  }, [Ze]);
  const vt = (k = g) => {
    Q.current && clearTimeout(Q.current), Q.current = setTimeout(() => {
      Xt(!0);
    }, k);
  }, zn = (k = v) => {
    $.current && clearTimeout($.current), $.current = setTimeout(() => {
      U.current || Xt(!1);
    }, k);
  }, gn = (k) => {
    var B;
    if (!k)
      return;
    const G = (B = k.currentTarget) !== null && B !== void 0 ? B : k.target;
    if (!(G != null && G.isConnected))
      return I(null), void Tt({ current: null });
    g ? vt() : Xt(!0), I(G), Tt({ current: G }), $.current && clearTimeout($.current);
  }, Qr = () => {
    p ? zn(v || 100) : v ? zn() : Xt(!1), Q.current && clearTimeout(Q.current);
  }, Ji = ({ x: k, y: B }) => {
    var G;
    const ve = { getBoundingClientRect: () => ({ x: k, y: B, width: 0, height: 0, top: B, left: k, right: k, bottom: B }) };
    Sw({ place: (G = We == null ? void 0 : We.place) !== null && G !== void 0 ? G : s, offset: c, elementReference: ve, tooltipReference: Z.current, tooltipArrowReference: he.current, strategy: d, middlewares: f, border: J }).then((Le) => {
      Object.keys(Le.tooltipStyles).length && X(Le.tooltipStyles), Object.keys(Le.tooltipArrowStyles).length && ht(Le.tooltipArrowStyles), V(Le.place);
    });
  }, un = (k) => {
    if (!k)
      return;
    const B = k, G = { x: B.clientX, y: B.clientY };
    Ji(G), gt.current = G;
  }, kn = (k) => {
    var B;
    if (!Ze)
      return;
    const G = k.target;
    !((B = Z.current) === null || B === void 0) && B.contains(G) || [document.querySelector(`[id='${o}']`), ...Y].some((ve) => ve == null ? void 0 : ve.contains(G)) || (Xt(!1), Q.current && clearTimeout(Q.current));
  }, Oe = Cw(gn, 50, !0), ft = Cw(Qr, 50, !0), Fn = (k) => {
    ft.cancel(), Oe(k);
  }, Uo = () => {
    Oe.cancel(), ft();
  }, Jr = Qe(() => {
    var k, B;
    const G = (k = We == null ? void 0 : We.position) !== null && k !== void 0 ? k : F;
    G ? Ji(G) : b ? gt.current && Ji(gt.current) : fe != null && fe.isConnected && Sw({ place: (B = We == null ? void 0 : We.place) !== null && B !== void 0 ? B : s, offset: c, elementReference: fe, tooltipReference: Z.current, tooltipArrowReference: he.current, strategy: d, middlewares: f, border: J }).then((ve) => {
      qe.current && (Object.keys(ve.tooltipStyles).length && X(ve.tooltipStyles), Object.keys(ve.tooltipArrowStyles).length && ht(ve.tooltipArrowStyles), V(ve.place));
    });
  }, [Ze, fe, z, N, s, We == null ? void 0 : We.place, c, d, F, We == null ? void 0 : We.position, b]);
  Ee(() => {
    var k, B;
    const G = new Set(Zt);
    Y.forEach((Ut) => {
      G.add({ current: Ut });
    });
    const ve = document.querySelector(`[id='${o}']`);
    ve && G.add({ current: ve });
    const Le = () => {
      Xt(!1);
    }, ot = Iw(fe), Ge = Iw(Z.current);
    jt.scroll && (window.addEventListener("scroll", Le), ot == null || ot.addEventListener("scroll", Le), Ge == null || Ge.addEventListener("scroll", Le));
    let De = null;
    jt.resize ? window.addEventListener("resize", Le) : fe && Z.current && (De = eW(fe, Z.current, Jr, { ancestorResize: !0, elementResize: !0, layoutShift: !0 }));
    const At = (Ut) => {
      Ut.key === "Escape" && Xt(!1);
    };
    jt.escape && window.addEventListener("keydown", At), jt.clickOutsideAnchor && window.addEventListener("click", kn);
    const He = [], Ft = (Ut) => {
      Ze && (Ut == null ? void 0 : Ut.target) === fe || gn(Ut);
    }, wr = (Ut) => {
      Ze && (Ut == null ? void 0 : Ut.target) === fe && Qr();
    }, Xr = ["mouseenter", "mouseleave", "focus", "blur"], rs = ["click", "dblclick", "mousedown", "mouseup"];
    Object.entries(tn).forEach(([Ut, ei]) => {
      ei && (Xr.includes(Ut) ? He.push({ event: Ut, listener: Fn }) : rs.includes(Ut) && He.push({ event: Ut, listener: Ft }));
    }), Object.entries(vn).forEach(([Ut, ei]) => {
      ei && (Xr.includes(Ut) ? He.push({ event: Ut, listener: Uo }) : rs.includes(Ut) && He.push({ event: Ut, listener: wr }));
    }), b && He.push({ event: "pointermove", listener: un });
    const ir = () => {
      U.current = !0;
    }, Lm = () => {
      U.current = !1, Qr();
    };
    return p && !kt && ((k = Z.current) === null || k === void 0 || k.addEventListener("mouseenter", ir), (B = Z.current) === null || B === void 0 || B.addEventListener("mouseleave", Lm)), He.forEach(({ event: Ut, listener: ei }) => {
      G.forEach((Cd) => {
        var is;
        (is = Cd.current) === null || is === void 0 || is.addEventListener(Ut, ei);
      });
    }), () => {
      var Ut, ei;
      jt.scroll && (window.removeEventListener("scroll", Le), ot == null || ot.removeEventListener("scroll", Le), Ge == null || Ge.removeEventListener("scroll", Le)), jt.resize ? window.removeEventListener("resize", Le) : De == null || De(), jt.clickOutsideAnchor && window.removeEventListener("click", kn), jt.escape && window.removeEventListener("keydown", At), p && !kt && ((Ut = Z.current) === null || Ut === void 0 || Ut.removeEventListener("mouseenter", ir), (ei = Z.current) === null || ei === void 0 || ei.removeEventListener("mouseleave", Lm)), He.forEach(({ event: Cd, listener: is }) => {
        G.forEach((j3) => {
          var Id;
          (Id = j3.current) === null || Id === void 0 || Id.removeEventListener(Cd, is);
        });
      });
    };
  }, [fe, Jr, Nt, Zt, Y, S, T, x, Ye]), Ee(() => {
    var k, B;
    let G = (B = (k = We == null ? void 0 : We.anchorSelect) !== null && k !== void 0 ? k : a) !== null && B !== void 0 ? B : "";
    !G && e && (G = `[data-tooltip-id='${e}']`);
    const ve = new MutationObserver((Le) => {
      const ot = [], Ge = [];
      Le.forEach((De) => {
        if (De.type === "attributes" && De.attributeName === "data-tooltip-id" && De.target.getAttribute("data-tooltip-id") === e && ot.push(De.target), De.type === "childList") {
          if (fe) {
            const At = [...De.removedNodes].filter((He) => He.nodeType === 1);
            if (G)
              try {
                Ge.push(...At.filter((He) => He.matches(G))), Ge.push(...At.flatMap((He) => [...He.querySelectorAll(G)]));
              } catch {
              }
            At.some((He) => {
              var Ft;
              return !!(!((Ft = He == null ? void 0 : He.contains) === null || Ft === void 0) && Ft.call(He, fe)) && (ut(!1), Xt(!1), I(null), Q.current && clearTimeout(Q.current), $.current && clearTimeout($.current), !0);
            });
          }
          if (G)
            try {
              const At = [...De.addedNodes].filter((He) => He.nodeType === 1);
              ot.push(...At.filter((He) => He.matches(G))), ot.push(...At.flatMap((He) => [...He.querySelectorAll(G)]));
            } catch {
            }
        }
      }), (ot.length || Ge.length) && we((De) => [...De.filter((At) => !Ge.includes(At)), ...ot]);
    });
    return ve.observe(document.body, { childList: !0, subtree: !0, attributes: !0, attributeFilter: ["data-tooltip-id"] }), () => {
      ve.disconnect();
    };
  }, [e, a, We == null ? void 0 : We.anchorSelect, fe]), Ee(() => {
    Jr();
  }, [Jr]), Ee(() => {
    if (!(ne != null && ne.current))
      return () => null;
    const k = new ResizeObserver(() => {
      setTimeout(() => Jr());
    });
    return k.observe(ne.current), () => {
      k.disconnect();
    };
  }, [z, ne == null ? void 0 : ne.current]), Ee(() => {
    var k;
    const B = document.querySelector(`[id='${o}']`), G = [...Y, B];
    fe && G.includes(fe) || I((k = Y[0]) !== null && k !== void 0 ? k : B);
  }, [o, Y, fe]), Ee(() => () => {
    Q.current && clearTimeout(Q.current), $.current && clearTimeout($.current);
  }, []), Ee(() => {
    var k;
    let B = (k = We == null ? void 0 : We.anchorSelect) !== null && k !== void 0 ? k : a;
    if (!B && e && (B = `[data-tooltip-id='${e}']`), B)
      try {
        const G = Array.from(document.querySelectorAll(B));
        we(G);
      } catch {
        we([]);
      }
  }, [e, a, We == null ? void 0 : We.anchorSelect]);
  const rr = (Ce = We == null ? void 0 : We.content) !== null && Ce !== void 0 ? Ce : z, Zr = Ze && Object.keys(Pe).length > 0;
  return K3(t, () => ({ open: (k) => {
    if (k != null && k.anchorSelect)
      try {
        document.querySelector(k.anchorSelect);
      } catch {
        return void console.warn(`[react-tooltip] "${k.anchorSelect}" is not a valid CSS selector`);
      }
    en(k ?? null), k != null && k.delay ? vt(k.delay) : Xt(!0);
  }, close: (k) => {
    k != null && k.delay ? zn(k.delay) : Xt(!1);
  }, activeAnchor: fe, place: H, isOpen: !!(Nt && !m && rr && Zr) })), Nt && !m && rr ? Ct.createElement(h, { id: e, role: ue, className: Sp("react-tooltip", zo.tooltip, Lf.tooltip, Lf[i], n, `react-tooltip__place-${H}`, zo[Zr ? "show" : "closing"], Zr ? "react-tooltip__show" : "react-tooltip__closing", d === "fixed" && zo.fixed, p && zo.clickable), onTransitionEnd: (k) => {
    q.current && clearTimeout(q.current), Ze || k.propertyName !== "opacity" || (ut(!1), en(null), L == null || L());
  }, style: { ...N, ...Pe, opacity: me !== void 0 && Zr ? me : void 0 }, ref: Z }, rr, Ct.createElement(h, { className: Sp("react-tooltip-arrow", zo.arrow, Lf.arrow, r, y && zo.noArrow), style: { ...it, background: O ? `linear-gradient(to right bottom, transparent 50%, ${O} 50%)` : void 0 }, ref: he })) : null;
}, uW = ({ content: t }) => Ct.createElement("span", { dangerouslySetInnerHTML: { __html: t } }), Tw = (t, e) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(t, e), dW = Ct.forwardRef(({ id: t, anchorId: e, anchorSelect: n, content: r, html: i, render: o, className: a, classNameArrow: s, variant: c = "dark", place: l = "top", offset: u = 10, wrapper: d = "div", children: f = null, events: h = ["hover"], openOnClick: g = !1, positionStrategy: v = "absolute", middlewares: b, delayShow: m = 0, delayHide: y = 0, float: p = !1, hidden: w = !1, noArrow: _ = !1, clickable: E = !1, closeOnEsc: S = !1, closeOnScroll: T = !1, closeOnResize: x = !1, openEvents: A, closeEvents: N, globalCloseEvents: F, imperativeModeOnly: D = !1, style: L, position: z, isOpen: ne, disableStyleInjection: ae = !1, border: Re, opacity: fe, arrowColor: I, setIsOpen: J, afterShow: me, afterHide: O, role: ue = "tooltip" }, Ce) => {
  const [Z, he] = et(r), [Q, $] = et(i), [q, H] = et(l), [V, Pe] = et(c), [X, it] = et(u), [ht, Ze] = et(m), [pt, Nt] = et(y), [ut, We] = et(p), [en, Jt] = et(w), [gt, Zt] = et(d), [Tt, U] = et(h), [Y, we] = et(v), [qe, Ye] = et(null), [kt, tn] = et(null), vn = Me(ae), { anchorRefs: jt, activeAnchor: Xt } = H3(t), vt = (un) => un == null ? void 0 : un.getAttributeNames().reduce((kn, Oe) => {
    var ft;
    return Oe.startsWith("data-tooltip-") && (kn[Oe.replace(/^data-tooltip-/, "")] = (ft = un == null ? void 0 : un.getAttribute(Oe)) !== null && ft !== void 0 ? ft : null), kn;
  }, {}), zn = (un) => {
    const kn = { place: (Oe) => {
      var ft;
      H((ft = Oe) !== null && ft !== void 0 ? ft : l);
    }, content: (Oe) => {
      he(Oe ?? r);
    }, html: (Oe) => {
      $(Oe ?? i);
    }, variant: (Oe) => {
      var ft;
      Pe((ft = Oe) !== null && ft !== void 0 ? ft : c);
    }, offset: (Oe) => {
      it(Oe === null ? u : Number(Oe));
    }, wrapper: (Oe) => {
      var ft;
      Zt((ft = Oe) !== null && ft !== void 0 ? ft : d);
    }, events: (Oe) => {
      const ft = Oe == null ? void 0 : Oe.split(" ");
      U(ft ?? h);
    }, "position-strategy": (Oe) => {
      var ft;
      we((ft = Oe) !== null && ft !== void 0 ? ft : v);
    }, "delay-show": (Oe) => {
      Ze(Oe === null ? m : Number(Oe));
    }, "delay-hide": (Oe) => {
      Nt(Oe === null ? y : Number(Oe));
    }, float: (Oe) => {
      We(Oe === null ? p : Oe === "true");
    }, hidden: (Oe) => {
      Jt(Oe === null ? w : Oe === "true");
    }, "class-name": (Oe) => {
      Ye(Oe);
    } };
    Object.values(kn).forEach((Oe) => Oe(null)), Object.entries(un).forEach(([Oe, ft]) => {
      var Fn;
      (Fn = kn[Oe]) === null || Fn === void 0 || Fn.call(kn, ft);
    });
  };
  Ee(() => {
    he(r);
  }, [r]), Ee(() => {
    $(i);
  }, [i]), Ee(() => {
    H(l);
  }, [l]), Ee(() => {
    Pe(c);
  }, [c]), Ee(() => {
    it(u);
  }, [u]), Ee(() => {
    Ze(m);
  }, [m]), Ee(() => {
    Nt(y);
  }, [y]), Ee(() => {
    We(p);
  }, [p]), Ee(() => {
    Jt(w);
  }, [w]), Ee(() => {
    we(v);
  }, [v]), Ee(() => {
    vn.current !== ae && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
  }, [ae]), Ee(() => {
    typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: { disableCore: ae === "core", disableBase: ae } }));
  }, []), Ee(() => {
    var un;
    const kn = new Set(jt);
    let Oe = n;
    if (!Oe && t && (Oe = `[data-tooltip-id='${t}']`), Oe)
      try {
        document.querySelectorAll(Oe).forEach((rr) => {
          kn.add({ current: rr });
        });
      } catch {
        console.warn(`[react-tooltip] "${Oe}" is not a valid CSS selector`);
      }
    const ft = document.querySelector(`[id='${e}']`);
    if (ft && kn.add({ current: ft }), !kn.size)
      return () => null;
    const Fn = (un = kt ?? ft) !== null && un !== void 0 ? un : Xt.current, Uo = new MutationObserver((rr) => {
      rr.forEach((Zr) => {
        var k;
        if (!Fn || Zr.type !== "attributes" || !(!((k = Zr.attributeName) === null || k === void 0) && k.startsWith("data-tooltip-")))
          return;
        const B = vt(Fn);
        zn(B);
      });
    }), Jr = { attributes: !0, childList: !1, subtree: !1 };
    if (Fn) {
      const rr = vt(Fn);
      zn(rr), Uo.observe(Fn, Jr);
    }
    return () => {
      Uo.disconnect();
    };
  }, [jt, Xt, kt, e, n]), Ee(() => {
    L != null && L.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), Re && !Tw("border", `${Re}`) && console.warn(`[react-tooltip] "${Re}" is not a valid \`border\`.`), L != null && L.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), fe && !Tw("opacity", `${fe}`) && console.warn(`[react-tooltip] "${fe}" is not a valid \`opacity\`.`);
  }, []);
  let gn = f;
  const Qr = Me(null);
  if (o) {
    const un = o({ content: Z ?? null, activeAnchor: kt });
    gn = un ? Ct.createElement("div", { ref: Qr, className: "react-tooltip-content-wrapper" }, un) : null;
  } else
    Z && (gn = Z);
  Q && (gn = Ct.createElement(uW, { content: Q }));
  const Ji = { forwardRef: Ce, id: t, anchorId: e, anchorSelect: n, className: Sp(a, qe), classNameArrow: s, content: gn, contentWrapperRef: Qr, place: q, variant: V, offset: X, wrapper: gt, events: Tt, openOnClick: g, positionStrategy: Y, middlewares: b, delayShow: ht, delayHide: pt, float: ut, hidden: en, noArrow: _, clickable: E, closeOnEsc: S, closeOnScroll: T, closeOnResize: x, openEvents: A, closeEvents: N, globalCloseEvents: F, imperativeModeOnly: D, style: L, position: z, isOpen: ne, border: Re, opacity: fe, arrowColor: I, setIsOpen: J, afterShow: me, afterHide: O, activeAnchor: kt, setActiveAnchor: (un) => tn(un), role: ue };
  return Ct.createElement(lW, { ...Ji });
});
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", (t) => {
  t.detail.disableCore || Ew({ css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}", type: "core" }), t.detail.disableBase || Ew({ css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`, type: "base" });
});
const kw = {
  mobile: "425px",
  tablet: "1024px"
}, IY = {
  mobile: `(max-width: ${kw.mobile})`,
  tablet: `(max-width: ${kw.tablet})`
}, Aw = (t) => {
  const { innerWidth: e } = window;
  return {
    isPhone: e < 640,
    isTablet: e < 768,
    isDesktop: e > 768,
    isLessThanCustomWidth: t && e < t,
    isMoreThanCustomWidth: t && e > t
  };
}, fW = (t) => {
  const [e, n] = et(
    Aw(t)
  );
  return Ee(() => {
    const r = () => {
      n(Aw(t));
    };
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, [t]), e;
};
const B3 = ({
  children: t,
  className: e,
  variant: n = "default",
  place: r = "left",
  "aria-label": i
}) => {
  const o = bn(), { isPhone: a } = fW();
  return /* @__PURE__ */ K(
    "div",
    {
      id: "tooltip-icon",
      "data-tooltip-id": o,
      className: j("pl-8 w-fit", e),
      onClick: (s) => s.preventDefault(),
      "aria-label": `Tooltip details: ${i || ""}`,
      role: "tooltip",
      tabIndex: 0,
      children: [
        /* @__PURE__ */ C(m8, { "aria-hidden": !0, className: "h-20 w-20" }),
        /* @__PURE__ */ C(
          dW,
          {
            id: o,
            className: "z-[9999] max-w-[50vw] xl:max-w-[30vw]",
            noArrow: !0,
            openOnClick: !!a,
            place: r,
            "aria-hidden": !0,
            style: {
              backgroundColor: n === "component" ? "transparent" : "#5261AC",
              padding: n === "component" ? "0px" : "8px 16px",
              borderRadius: "9px 9px 9px 0px",
              color: "#fff",
              fontWeight: 400,
              fontSize: "12px",
              lineHeight: "14.4px"
            },
            children: /* @__PURE__ */ C("div", { children: t })
          }
        )
      ]
    }
  );
}, SY = ({
  className: t,
  children: e
}) => /* @__PURE__ */ C(
  "div",
  {
    className: j(
      "w-full px-indent-screen lg:px-indent-screen-lg",
      t
    ),
    children: e
  }
), TY = ({
  className: t,
  children: e
}) => /* @__PURE__ */ C(
  "div",
  {
    className: j(
      "py-48 w-full px-max-screen lg:px-max-screen-lg",
      t
    ),
    children: e
  }
), kY = ({
  className: t,
  children: e
}) => /* @__PURE__ */ C("div", { className: j("px-mid-screen lg:px-mid-screen-lg", t), children: e }), AY = ({
  className: t,
  children: e
}) => /* @__PURE__ */ C(
  "div",
  {
    className: j(
      "w-full px-small-screen lg:px-small-screen-lg",
      t
    ),
    children: e
  }
), OY = ({
  title: t,
  subtitle: e,
  className: n
}) => /* @__PURE__ */ K("div", { className: j("mb-14 sm:mb-20", n), children: [
  /* @__PURE__ */ C("h1", { className: "text-t21 sm:text-t27 lg:text-t32 text-font-primary font-semibold mb-13", children: t }),
  /* @__PURE__ */ C("h2", { className: "text-t15 sm:text-t16 lg:text-t18 text-font-secondary", children: e })
] });
export {
  BW as $,
  Ap as A,
  Bm as B,
  rc as C,
  wW as D,
  lS as E,
  EW as F,
  CW as G,
  TW as H,
  UW as I,
  HW as J,
  tY as K,
  nY as L,
  vW as M,
  $_ as N,
  rY as O,
  yg as P,
  Nc as Q,
  iY as R,
  oY as S,
  aY as T,
  IW as U,
  sB as V,
  lB as W,
  sY as X,
  cY as Y,
  lY as Z,
  ke as _,
  Ae as a,
  JG as a$,
  p8 as a0,
  jW as a1,
  VW as a2,
  $W as a3,
  qW as a4,
  zW as a5,
  g8 as a6,
  KW as a7,
  WW as a8,
  GW as a9,
  bG as aA,
  _G as aB,
  EG as aC,
  CG as aD,
  IG as aE,
  m8 as aF,
  SG as aG,
  TG as aH,
  kG as aI,
  AG as aJ,
  OG as aK,
  xG as aL,
  RG as aM,
  NG as aN,
  MG as aO,
  PG as aP,
  BG as aQ,
  jG as aR,
  VG as aS,
  $G as aT,
  qG as aU,
  zG as aV,
  KG as aW,
  WG as aX,
  GG as aY,
  YG as aZ,
  QG as a_,
  YW as aa,
  QW as ab,
  JW as ac,
  ZW as ad,
  XW as ae,
  eG as af,
  tG as ag,
  nG as ah,
  rG as ai,
  iG as aj,
  oG as ak,
  aG as al,
  sG as am,
  cG as an,
  lG as ao,
  uG as ap,
  dG as aq,
  fG as ar,
  V_ as as,
  hG as at,
  pG as au,
  gG as av,
  mG as aw,
  vG as ax,
  yG as ay,
  wG as az,
  OW as b,
  ZG as b0,
  XG as b1,
  eY as b2,
  DG as b3,
  LG as b4,
  FG as b5,
  UG as b6,
  HG as b7,
  de as b8,
  Te as b9,
  S8 as bA,
  SY as bB,
  TY as bC,
  kY as bD,
  AY as bE,
  OY as bF,
  Lg as bG,
  RW as bH,
  NW as bI,
  F_ as bJ,
  MW as bK,
  bn as bL,
  PW as bM,
  DW as bN,
  LW as bO,
  FW as bP,
  IY as bQ,
  fW as bR,
  Mu as bS,
  cS as bT,
  Kw as bU,
  Np as bV,
  yW as bW,
  Ue as ba,
  ZE as bb,
  uY as bc,
  dY as bd,
  fY as be,
  hY as bf,
  fB as bg,
  hB as bh,
  pY as bi,
  gY as bj,
  pB as bk,
  mY as bl,
  vY as bm,
  cB as bn,
  yY as bo,
  wY as bp,
  nK as bq,
  bY as br,
  _Y as bs,
  gB as bt,
  wp as bu,
  v3 as bv,
  EY as bw,
  rK as bx,
  CY as by,
  B3 as bz,
  Gt as c,
  AW as d,
  ln as e,
  f_ as f,
  mW as g,
  R as h,
  su as i,
  ki as j,
  kW as k,
  of as l,
  e7 as m,
  wg as n,
  Ps as o,
  J7 as p,
  h_ as q,
  ui as r,
  dx as s,
  z7 as t,
  xW as u,
  bx as v,
  X3 as w,
  rI as x,
  Ru as y,
  iI as z
};
//# sourceMappingURL=index-16eb2513.js.map
